// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"jKDqp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _app = require("./layout/App");
var _appDefault = parcelHelpers.interopDefault(_app);
const root = (0, _client.createRoot)(document.getElementById("App"));
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {}));

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-dom/client":"5ccwt","./layout/App":"bqjXi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gaGEj":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"kbpKW"}],"kbpKW":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"6uln9"}],"6uln9":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"8n7Eb"}],"8n7Eb":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.2.0";

},{}],"5ccwt":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"b8T3j"}],"b8T3j":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"bO0Ia"}],"bO0Ia":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var Mg = Uf(null), Ng = null, Og = null, Pg = null;
function Qg() {
    Pg = Og = Ng = null;
}
function Rg(a) {
    var b = Mg.current;
    E(Mg);
    a._currentValue = b;
}
function Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function Tg(a, b) {
    Ng = a;
    Pg = Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (Ug = !0), a.firstContext = null);
}
function Vg(a) {
    var b = a._currentValue;
    if (Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Og) {
            if (null === Ng) throw Error(p(308));
            Og = a;
            Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Og = Og.next = a;
    }
    return b;
}
var Wg = null;
function Xg(a) {
    null === Wg ? Wg = [
        a
    ] : Wg.push(a);
}
function Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return Zg(a, d);
}
function Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $g = !1;
function ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return Zg(a, c);
}
function eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function gh(a, b, c, d) {
    var e = a.updateQueue;
    $g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            $g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var jh = (new aa.Component).refs;
function kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = L(), d = lh(a), e = ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = dh(a, e, d);
        null !== b && (mh(b, a, d, c), eh(b, a, d));
    }
};
function oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function ph(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = Vg(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && nh.enqueueReplaceState(b, b.state, null);
}
function rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = jh;
    ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = Vg(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && nh.enqueueReplaceState(e, e.state, null), gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function uh(a) {
    var b = a._init;
    return b(a._payload);
}
function vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && uh(f) === b.type)) return d = e(b, c.props), d.ref = sh(a, b, c), d.return = a, d;
        d = yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = yh(b.type, b.key, b.props, null, a.mode, c), c.ref = sh(a, null, b), c.return = a, c;
                case wa:
                    return b = zh(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Ah(b, a.mode, c, null), b.return = a, b;
            th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = yh(f.type, f.key, f.props, null, a.mode, h), h.ref = sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Bh = vh(!0), Ch = vh(!1), Dh = {}, Eh = Uf(Dh), Fh = Uf(Dh), Gh = Uf(Dh);
function Hh(a) {
    if (a === Dh) throw Error(p(174));
    return a;
}
function Ih(a, b) {
    G(Gh, b);
    G(Fh, a);
    G(Eh, Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(Eh);
    G(Eh, b);
}
function Jh() {
    E(Eh);
    E(Fh);
    E(Gh);
}
function Kh(a) {
    Hh(Gh.current);
    var b = Hh(Eh.current);
    var c = lb(b, a.type);
    b !== c && (G(Fh, a), G(Eh, c));
}
function Lh(a) {
    Fh.current === a && (E(Eh), E(Fh));
}
var M = Uf(0);
function Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Nh = [];
function Oh() {
    for(var a = 0; a < Nh.length; a++)Nh[a]._workInProgressVersionPrimary = null;
    Nh.length = 0;
}
var Ph = ua.ReactCurrentDispatcher, Qh = ua.ReactCurrentBatchConfig, Rh = 0, N = null, O = null, P = null, Sh = !1, Th = !1, Uh = 0, Vh = 0;
function Q() {
    throw Error(p(321));
}
function Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Xh(a, b, c, d, e, f) {
    Rh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Ph.current = null === a || null === a.memoizedState ? Yh : Zh;
    a = c(d, e);
    if (Th) {
        f = 0;
        do {
            Th = !1;
            Uh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            Ph.current = $h;
            a = c(d, e);
        }while (Th);
    }
    Ph.current = ai;
    b = null !== O && null !== O.next;
    Rh = 0;
    P = O = N = null;
    Sh = !1;
    if (b) throw Error(p(300));
    return a;
}
function bi() {
    var a = 0 !== Uh;
    Uh = 0;
    return a;
}
function ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function di() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(p(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function fi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                N.lanes |= m;
                hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, N.lanes |= f, hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function gi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function hi() {}
function ii(a, b) {
    var c = N, d = di(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, Ug = !0);
    d = d.queue;
    ji(ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== P && P.memoizedState.tag & 1) {
        c.flags |= 2048;
        li(9, mi.bind(null, c, d, e, b), void 0, null);
        if (null === R) throw Error(p(349));
        0 !== (Rh & 30) || ni(c, b, e);
    }
    return e;
}
function ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    oi(b) && pi(a);
}
function ki(a, b, c) {
    return c(function() {
        oi(b) && pi(a);
    });
}
function oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function pi(a) {
    var b = Zg(a, 1);
    null !== b && mh(b, a, 1, -1);
}
function qi(a) {
    var b = ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ri.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function si() {
    return di().memoizedState;
}
function ti(a, b, c, d) {
    var e = ci();
    N.flags |= a;
    e.memoizedState = li(1 | b, c, void 0, void 0 === d ? null : d);
}
function ui(a, b, c, d) {
    var e = di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && Wh(d, g.deps)) {
            e.memoizedState = li(b, c, f, d);
            return;
        }
    }
    N.flags |= a;
    e.memoizedState = li(1 | b, c, f, d);
}
function vi(a, b) {
    return ti(8390656, 8, a, b);
}
function ji(a, b) {
    return ui(2048, 8, a, b);
}
function wi(a, b) {
    return ui(4, 2, a, b);
}
function xi(a, b) {
    return ui(4, 4, a, b);
}
function yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return ui(4, 4, yi.bind(null, b, a), c);
}
function Ai() {}
function Bi(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ci(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Di(a, b, c) {
    if (0 === (Rh & 21)) return a.baseState && (a.baseState = !1, Ug = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), N.lanes |= c, hh |= c, a.baseState = !0);
    return b;
}
function Ei(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Qh.transition;
    Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Qh.transition = d;
    }
}
function Fi() {
    return di().memoizedState;
}
function Gi(a, b, c) {
    var d = lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, c);
    else if (c = Yg(a, b, c, d), null !== c) {
        var e = L();
        mh(c, a, d, e);
        Ji(c, b, d);
    }
}
function ri(a, b, c) {
    var d = lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = Yg(a, b, e, d);
        null !== c && (e = L(), mh(c, a, d, e), Ji(c, b, d));
    }
}
function Hi(a) {
    var b = a.alternate;
    return a === N || null !== b && b === N;
}
function Ii(a, b) {
    Th = Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var ai = {
    readContext: Vg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useInsertionEffect: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useDeferredValue: Q,
    useTransition: Q,
    useMutableSource: Q,
    useSyncExternalStore: Q,
    useId: Q,
    unstable_isNewReconciler: !1
}, Yh = {
    readContext: Vg,
    useCallback: function(a, b) {
        ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: Vg,
    useEffect: vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ti(4194308, 4, yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = Gi.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: qi,
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        return ci().memoizedState = a;
    },
    useTransition: function() {
        var a = qi(!1), b = a[0];
        a = Ei.bind(null, a[1]);
        ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = N, e = ci();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === R) throw Error(p(349));
            0 !== (Rh & 30) || ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        vi(ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        li(9, mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = ci(), b = R.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Zh = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: fi,
    useRef: si,
    useState: function() {
        return fi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = fi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
}, $h = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: gi,
    useRef: si,
    useState: function() {
        return gi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return null === O ? b.memoizedState = a : Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = gi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
};
function Ki(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Ni = "function" === typeof WeakMap ? WeakMap : Map;
function Oi(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Pi || (Pi = !0, Qi = d);
        Mi(a, b);
    };
    return c;
}
function Ri(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Mi(a, b);
        "function" !== typeof d && (null === Si ? Si = new Set([
            this
        ]) : Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ui.bind(null, a, b, c), b.then(a, a));
}
function Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = ch(-1, 1), b.tag = 2, dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Xi = ua.ReactCurrentOwner, Ug = !1;
function Yi(a, b, c, d) {
    b.child = null === a ? Ch(b, null, c, d) : Bh(b, a.child, c, d);
}
function Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    Tg(b, e);
    d = Xh(a, b, c, d, f, e);
    c = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Yi(a, b, d, e);
    return b.child;
}
function aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, cj(a, b, f, d, e);
        a = yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return $i(a, b, e);
    }
    b.flags |= 1;
    a = wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (Ug = !0);
            else return b.lanes = a.lanes, $i(a, b, e);
        }
    }
    return dj(a, b, c, d, e);
}
function ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(fj, gj), gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(fj, gj), gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(fj, gj);
            gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(fj, gj), gj |= d;
    Yi(a, b, e, c);
    return b.child;
}
function hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function dj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    Tg(b, e);
    c = Xh(a, b, c, d, f, e);
    d = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Yi(a, b, c, e);
    return b.child;
}
function ij(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    Tg(b, e);
    if (null === b.stateNode) jj(a, b), ph(b, c, d), rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = Vg(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && qh(b, g, d, l);
        $g = !1;
        var r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || $g ? ("function" === typeof m && (kh(b, c, m, d), k = b.memoizedState), (h = $g || oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = Vg(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && qh(b, g, d, k);
        $g = !1;
        r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || $g ? ("function" === typeof y && (kh(b, c, y, d), n = b.memoizedState), (l = $g || oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return kj(a, b, c, d, f, e);
}
function kj(a, b, c, d, e, f) {
    hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), $i(a, b, f);
    d = b.stateNode;
    Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Bh(b, a.child, null, f), b.child = Bh(b, null, h, f)) : Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function lj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    Ih(a, b.containerInfo);
}
function mj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Yi(a, b, c, d);
    return b.child;
}
var nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function pj(a, b, c) {
    var d = b.pendingProps, e = M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(M, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = qj(g, d, 0, null), a = Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = oj(c), b.memoizedState = nj, a) : rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = wh(h, f) : (f = Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function rj(a, b) {
    b = qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function tj(a, b, c, d) {
    null !== d && Jg(d);
    Bh(b, a.child, null, c);
    a = rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Li(Error(p(422))), tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Bh(b, a.child, null, g);
        b.child.memoizedState = oj(g);
        b.memoizedState = nj;
        return f;
    }
    if (0 === (b.mode & 1)) return tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Li(f, d, void 0);
        return tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (Ug || h) {
        d = R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, Zg(a, e), mh(d, a, e, -1));
        }
        uj();
        d = Li(Error(p(421)));
        return tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    Sg(a.return, b, c);
}
function xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Yi(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && wj(a, c, b);
            else if (19 === a.tag) wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            xj(b, !0, c, null, f);
            break;
        case "together":
            xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function zj(a, b, c) {
    switch(b.tag){
        case 3:
            lj(b);
            Ig();
            break;
        case 5:
            Kh(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(M, M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return pj(a, b, c);
                G(M, M.current & 1);
                a = $i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(M, M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(M, M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, ej(a, b, c);
    }
    return $i(a, b, c);
}
var Aj, Bj, Cj, Dj;
Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Bj = function() {};
Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        Hh(Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Ej(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Fj(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            Jh();
            E(Wf);
            E(H);
            Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Gj(zg), zg = null));
            Bj(a, b);
            S(b);
            return null;
        case 5:
            Lh(b);
            var e = Hh(Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = Hh(Gh.current);
                Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Gj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (M.current & 1) ? 0 === T && (T = 3) : uj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return Jh(), Bj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return Rg(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(M);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Ej(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(M, M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Hj && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Hj && 1073741824 !== c && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = M.current, G(M, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (gj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Jj(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return Jh(), E(Wf), E(H), Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Lh(b), null;
        case 13:
            E(M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(M), null;
        case 4:
            return Jh(), null;
        case 10:
            return Rg(b.type._context), null;
        case 22:
        case 23:
            return Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Kj = !1, U = !1, Lj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Oj = !1;
function Pj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Oj;
    Oj = !1;
    return n;
}
function Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
function Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Xj(a, b, c), a = a.sibling; null !== a;)Xj(a, b, c), a = a.sibling;
}
var X = null, Yj = !1;
function Zj(a, b, c) {
    for(c = c.child; null !== c;)ak(a, b, c), c = c.sibling;
}
function ak(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Mj(c, b);
        case 6:
            var d = X, e = Yj;
            X = null;
            Zj(a, b, c);
            X = d;
            Yj = e;
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Yj;
            X = c.stateNode.containerInfo;
            Yj = !0;
            Zj(a, b, c);
            X = d;
            Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Nj(c, b, g) : 0 !== (f & 4) && Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Zj(a, b, c);
            break;
        case 1:
            if (!U && (Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Zj(a, b, c);
            break;
        case 21:
            Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Zj(a, b, c), U = d) : Zj(a, b, c);
            break;
        default:
            Zj(a, b, c);
    }
}
function bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Lj);
        b.forEach(function(b) {
            var d = ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Yj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            ak(f, g, e);
            X = null;
            Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)ek(b, a), b = b.sibling;
}
function ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            dk(b, a);
            fk(a);
            if (d & 4) {
                try {
                    Qj(3, a, a.return), Rj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Qj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            break;
        case 5:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            dk(b, a);
            fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            dk(b, a);
            fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            dk(b, a);
            fk(a);
            break;
        case 13:
            dk(b, a);
            fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (gk = B()));
            d & 4 && bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, dk(b, a), U = l) : dk(b, a);
            fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Qj(4, r, r.return);
                                break;
                            case 1:
                                Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            dk(b, a);
            fk(a);
            d & 4 && bk(a);
            break;
        case 21:
            break;
        default:
            dk(b, a), fk(a);
    }
}
function fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Vj(a);
                    Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Vj(a);
                    Wj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function ik(a, b, c) {
    V = a;
    jk(a, b, c);
}
function jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Kj;
                var l = U;
                Kj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? kk(e) : null !== k ? (k.return = g, V = k) : kk(e);
                for(; null !== f;)V = f, jk(f, b, c), f = f.sibling;
                V = e;
                Kj = h;
                U = l;
            }
            lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : lk(a, b, c);
    }
}
function lk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Sj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function hk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Rj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var mk = Math.ceil, nk = ua.ReactCurrentDispatcher, ok = ua.ReactCurrentOwner, pk = ua.ReactCurrentBatchConfig, K = 0, R = null, Y = null, Z = 0, gj = 0, fj = Uf(0), T = 0, qk = null, hh = 0, rk = 0, sk = 0, tk = null, uk = null, gk = 0, Hj = Infinity, vk = null, Pi = !1, Qi = null, Si = null, wk = !1, xk = null, yk = 0, zk = 0, Ak = null, Bk = -1, Ck = 0;
function L() {
    return 0 !== (K & 6) ? B() : -1 !== Bk ? Bk : Bk = B();
}
function lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Ck && (Ck = yc()), Ck;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function mh(a, b, c, d) {
    if (50 < zk) throw zk = 0, Ak = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== R) a === R && (0 === (K & 2) && (rk |= c), 4 === T && Dk(a, Z)), Ek(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Hj = B() + 500, fg && jg());
}
function Ek(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Fk.bind(null, a)) : hg(Fk.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Gk(c, Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Hk(a, b) {
    Bk = -1;
    Ck = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Ik() && a.callbackNode !== c) return null;
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Jk(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Kk();
        if (R !== a || Z !== b) vk = null, Hj = B() + 500, Lk(a, b);
        for(;;)try {
            Mk();
            break;
        } catch (h) {
            Nk(a, h);
        }
        Qg();
        nk.current = f;
        K = e;
        null !== Y ? b = 0 : (R = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Ok(a, e)));
        if (1 === b) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
        if (6 === b) Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Pk(e) && (b = Jk(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Ok(a, f))), 1 === b)) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Qk(a, uk, vk);
                    break;
                case 3:
                    Dk(a, d);
                    if ((d & 130023424) === d && (b = gk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), b);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 4:
                    Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), d);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 5:
                    Qk(a, uk, vk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Ek(a, B());
    return a.callbackNode === c ? Hk.bind(null, a) : null;
}
function Ok(a, b) {
    var c = tk;
    a.current.memoizedState.isDehydrated && (Lk(a, b).flags |= 256);
    a = Jk(a, b);
    2 !== a && (b = uk, uk = c, null !== b && Gj(b));
    return a;
}
function Gj(a) {
    null === uk ? uk = a : uk.push.apply(uk, a);
}
function Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Dk(a, b) {
    b &= ~sk;
    b &= ~rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Fk(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Ik();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Ek(a, B()), null;
    var c = Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Ok(a, d));
    }
    if (1 === c) throw c = qk, Lk(a, 0), Dk(a, b), Ek(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Qk(a, uk, vk);
    Ek(a, B());
    return null;
}
function Rk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Hj = B() + 500, fg && jg());
    }
}
function Sk(a) {
    null !== xk && 0 === xk.tag && 0 === (K & 6) && Ik();
    var b = K;
    K |= 1;
    var c = pk.transition, d = C;
    try {
        if (pk.transition = null, C = 1, a) return a();
    } finally{
        C = d, pk.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Ij() {
    gj = fj.current;
    E(fj);
}
function Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                Jh();
                E(Wf);
                E(H);
                Oh();
                break;
            case 5:
                Lh(d);
                break;
            case 4:
                Jh();
                break;
            case 13:
                E(M);
                break;
            case 19:
                E(M);
                break;
            case 10:
                Rg(d.type._context);
                break;
            case 22:
            case 23:
                Ij();
        }
        c = c.return;
    }
    R = a;
    Y = a = wh(a.current, null);
    Z = gj = b;
    T = 0;
    qk = null;
    sk = rk = hh = 0;
    uk = tk = null;
    if (null !== Wg) {
        for(b = 0; b < Wg.length; b++)if (c = Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        Wg = null;
    }
    return a;
}
function Nk(a, b) {
    do {
        var c = Y;
        try {
            Qg();
            Ph.current = ai;
            if (Sh) {
                for(var d = N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Sh = !1;
            }
            Rh = 0;
            P = O = N = null;
            Th = !1;
            Uh = 0;
            ok.current = null;
            if (null === c || null === c.return) {
                T = 1;
                qk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Wi(y, g, h, f, b);
                        y.mode & 1 && Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Ti(f, l, b);
                            uj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Wi(J, g, h, f, b);
                        Jg(Ki(k, h));
                        break a;
                    }
                }
                f = k = Ki(k, h);
                4 !== T && (T = 2);
                null === tk ? tk = [
                    f
                ] : tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Oi(f, k, b);
                            fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Si || !Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Ri(f, h, b);
                                fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Tk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Kk() {
    var a = nk.current;
    nk.current = ai;
    return null === a ? ai : a;
}
function uj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === R || 0 === (hh & 268435455) && 0 === (rk & 268435455) || Dk(R, Z);
}
function Jk(a, b) {
    var c = K;
    K |= 2;
    var d = Kk();
    if (R !== a || Z !== b) vk = null, Lk(a, b);
    for(;;)try {
        Uk();
        break;
    } catch (e) {
        Nk(a, e);
    }
    Qg();
    K = c;
    nk.current = d;
    if (null !== Y) throw Error(p(261));
    R = null;
    Z = 0;
    return T;
}
function Uk() {
    for(; null !== Y;)Vk(Y);
}
function Mk() {
    for(; null !== Y && !cc();)Vk(Y);
}
function Vk(a) {
    var b = Wk(a.alternate, a, gj);
    a.memoizedProps = a.pendingProps;
    null === b ? Tk(a) : Y = b;
    ok.current = null;
}
function Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Fj(c, b, gj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Qk(a, b, c) {
    var d = C, e = pk.transition;
    try {
        pk.transition = null, C = 1, Xk(a, b, c, d);
    } finally{
        pk.transition = e, C = d;
    }
    return null;
}
function Xk(a, b, c, d) {
    do Ik();
    while (null !== xk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === R && (Y = R = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || wk || (wk = !0, Gk(hc, function() {
        Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = pk.transition;
        pk.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        ok.current = null;
        Pj(a, c);
        ek(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        ik(c, a, e);
        dc();
        K = h;
        C = g;
        pk.transition = f;
    } else a.current = c;
    wk && (wk = !1, xk = a, yk = e);
    f = a.pendingLanes;
    0 === f && (Si = null);
    mc(c.stateNode, d);
    Ek(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Pi) throw Pi = !1, a = Qi, Qi = null, a;
    0 !== (yk & 1) && 0 !== a.tag && Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === Ak ? zk++ : (zk = 0, Ak = a) : zk = 0;
    jg();
    return null;
}
function Ik() {
    if (null !== xk) {
        var a = Dc(yk), b = pk.transition, c = C;
        try {
            pk.transition = null;
            C = 16 > a ? 16 : a;
            if (null === xk) var d = !1;
            else {
                a = xk;
                xk = null;
                yk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Tj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Rj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, pk.transition = b;
        }
    }
    return !1;
}
function Yk(a, b, c) {
    b = Ki(c, b);
    b = Oi(a, b, 1);
    a = dh(a, b, 1);
    b = L();
    null !== a && (Ac(a, 1, b), Ek(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Si || !Si.has(d))) {
                a = Ki(c, a);
                a = Ri(b, a, 1);
                b = dh(b, a, 1);
                a = L();
                null !== b && (Ac(b, 1, a), Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = L();
    a.pingedLanes |= a.suspendedLanes & c;
    R === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - gk ? Lk(a, 0) : sk |= c);
    Ek(a, b);
}
function Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = L();
    a = Zg(a, b);
    null !== a && (Ac(a, b, c), Ek(a, c));
}
function vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Zk(a, c);
}
function ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Zk(a, c);
}
var Wk;
Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return Ug = !1, zj(a, b, c);
            Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else Ug = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            jj(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            Tg(b, c);
            e = Xh(null, b, d, a, e, c);
            var f = bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, ah(b), e.updater = nh, b.stateNode = e, e._reactInternals = b, rh(b, d, a, c), b = kj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $k(d);
                a = Lg(d, a);
                switch(e){
                    case 0:
                        b = dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = aj(null, b, d, Lg(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), ij(a, b, d, e, c);
        case 3:
            a: {
                lj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                bh(a, b);
                gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ki(Error(p(423)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ki(Error(p(424)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = $i(a, b, c);
                        break a;
                    }
                    Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Kh(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), hj(a, b), Yi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return pj(a, b, c);
        case 4:
            return Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Bh(b, null, d, c) : Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), Zi(a, b, d, e, c);
        case 7:
            return Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = $i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, Tg(b, c), e = Vg(e), d = d(e), b.flags |= 1, Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Lg(d, b.pendingProps), e = Lg(d.type, e), aj(a, b, d, e, c);
        case 15:
            return cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), jj(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, Tg(b, c), ph(b, d, e), rh(b, d, e, c), kj(null, b, d, !0, a, c);
        case 19:
            return yj(a, b, c);
        case 22:
            return ej(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Gk(a, b) {
    return ac(a, b);
}
function al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new al(a, b, c, d);
}
function bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $k(a) {
    if ("function" === typeof a) return bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function wh(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Ah(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Ah(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function qj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function xh(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function zh(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function cl(a, b, c, d, e, f, g, h, k) {
    a = new bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    ah(f);
    return a;
}
function dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function el(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function fl(a, b, c, d, e, f, g, h, k) {
    a = cl(c, d, !0, a, e, f, g, h, k);
    a.context = el(null);
    c = a.current;
    d = L();
    e = lh(c);
    f = ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    dh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Ek(a, d);
    return a;
}
function gl(a, b, c, d) {
    var e = b.current, f = L(), g = lh(e);
    c = el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = dh(e, b, g);
    null !== a && (mh(a, e, g, f), eh(a, e, g));
    return g;
}
function hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function jl(a, b) {
    il(a, b);
    (a = a.alternate) && il(a, b);
}
function kl() {
    return null;
}
var ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ml(a) {
    this._internalRoot = a;
}
nl.prototype.render = ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    gl(a, b, null, null);
};
nl.prototype.unmount = ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Sk(function() {
            gl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function nl(a) {
    this._internalRoot = a;
}
nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function ql() {}
function rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = hl(g);
                f.call(a);
            };
        }
        var g = fl(b, d, a, 0, null, !1, !1, "", ql);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = hl(k);
            h.call(a);
        };
    }
    var k = cl(a, 0, !1, null, null, !1, !1, "", ql);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Sk(function() {
        gl(b, k, c, d);
    });
    return k;
}
function sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = hl(g);
                h.call(a);
            };
        }
        gl(b, g, a, e);
    } else g = rl(c, b, a, e, d);
    return hl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Ek(b, B()), 0 === (K & 6) && (Hj = B() + 500, jg()));
            }
            break;
        case 13:
            Sk(function() {
                var b = Zg(a, 1);
                if (null !== b) {
                    var c = L();
                    mh(b, a, 1, c);
                }
            }), jl(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = Zg(a, 134217728);
        if (null !== b) {
            var c = L();
            mh(b, a, 134217728, c);
        }
        jl(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = lh(a), c = Zg(a, b);
        if (null !== c) {
            var d = L();
            mh(c, a, b, d);
        }
        jl(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Rk;
Hb = Sk;
var tl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Rk
    ]
}, ul = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var vl = {
    bundleType: ul.bundleType,
    version: ul.version,
    rendererPackageName: ul.rendererPackageName,
    rendererConfig: ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: ul.findFiberByHostInstance || kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!wl.isDisabled && wl.supportsFiber) try {
        kc = wl.inject(vl), lc = wl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!ol(b)) throw Error(p(200));
    return dl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!ol(a)) throw Error(p(299));
    var c = !1, d = "", e = ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = cl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ml(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Sk(a);
};
exports.hydrate = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!ol(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new nl(b);
};
exports.render = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!pl(a)) throw Error(p(40));
    return a._reactRootContainer ? (Sk(function() {
        sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Rk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!pl(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return sl(a, b, c, !1, d);
};
exports.version = "18.2.0-next-9e3b772b8-20220608";

},{"5393afc8c463ef07":"6uln9","ece50e903283a22f":"jNZm8"}],"jNZm8":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"izQ2Z"}],"izQ2Z":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"bqjXi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _recoil = require("recoil");
var _client = require("@apollo/client");
var _utilities = require("@apollo/client/utilities");
var _context = require("@apollo/client/link/context");
var _subscriptions = require("@apollo/client/link/subscriptions");
var _graphqlWs = require("graphql-ws");
var _reactRouterDom = require("react-router-dom");
var _immer = require("immer");
var _auth = require("./Auth");
var _authDefault = parcelHelpers.interopDefault(_auth);
var _navbar = require("./Navbar");
var _navbarDefault = parcelHelpers.interopDefault(_navbar);
var _homePage = require("./HomePage");
var _homePageDefault = parcelHelpers.interopDefault(_homePage);
var _buildRouter = require("../build/BuildRouter");
var _buildRouterDefault = parcelHelpers.interopDefault(_buildRouter);
var _collectionsPage = require("../collections/CollectionsPage");
var _collectionsPageDefault = parcelHelpers.interopDefault(_collectionsPage);
var _collectionRouter = require("../collections/CollectionRouter");
var _collectionRouterDefault = parcelHelpers.interopDefault(_collectionRouter);
var _filesPage = require("../files/FilesPage");
var _filesPageDefault = parcelHelpers.interopDefault(_filesPage);
var _urlsRouter = require("../urls/UrlsRouter");
var _urlsRouterDefault = parcelHelpers.interopDefault(_urlsRouter);
var _usersPage = require("../users/UsersPage");
var _usersPageDefault = parcelHelpers.interopDefault(_usersPage);
var _accountPage = require("../users/AccountPage");
var _accountPageDefault = parcelHelpers.interopDefault(_accountPage);
var _logsPage = require("../logs/LogsPage");
var _logsPageDefault = parcelHelpers.interopDefault(_logsPage);
var _importPage = require("../import/ImportPage");
var _importPageDefault = parcelHelpers.interopDefault(_importPage);
var _errorBoundary = require("../utils/ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
(0, _immer.enableMapSet)();
function getApolloClient() {
    const GQL_URL = `${"http://cms.pp.content.catering"}${"/admin"}`;
    const WS_URL = `${"http://cms.pp.content.catering"}/subscriptions`.replace(/^http/, "ws");
    const httpLink = new (0, _client.HttpLink)({
        uri: GQL_URL
    });
    const wsLink = new (0, _subscriptions.GraphQLWsLink)((0, _graphqlWs.createClient)({
        url: WS_URL,
        connectionParams: {
            token: localStorage.getItem("token") || null
        }
    }));
    const link = (0, _client.split)(({ query })=>{
        const definition = (0, _utilities.getMainDefinition)(query);
        return definition.kind === "OperationDefinition" && definition.operation === "subscription";
    }, wsLink, httpLink);
    const authLink = (0, _context.setContext)((_, { headers })=>({
            headers: {
                ...headers,
                Authorization: `Bearer ${localStorage.getItem("token") || ""}`
            }
        }));
    return new (0, _client.ApolloClient)({
        link: authLink.concat(link),
        cache: new (0, _client.InMemoryCache)({
            dataIdFromObject (responseObject) {
                switch(responseObject.__typename){
                    // case 'Entry': return `Entry:${responseObject.collectionId || ''}:${responseObject.entryId}`
                    case "Build":
                        return `Build:${responseObject.buildId}`;
                    case "Collection":
                        return `Collection:${responseObject.collectionId}`;
                    default:
                        return (0, _client.defaultDataIdFromObject)(responseObject);
                }
            },
            typePolicies: {
                // Entry: { keyFields: ['entryId', 'collectionId'] },
                // Collection: { keyFields: ['collectionId'] },
                Build: {
                    merge: true
                }
            }
        }),
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "cache-and-network"
            }
        },
        connectToDevTools: false
    });
}
const apolloClient = getApolloClient();
function App() {
    (0, _react.useEffect)(()=>{
        const link = document.createElement("link");
        link.rel = "shortcut icon";
        link.href = `${"http://cms.pp.content.catering"}/favicon.png`;
        link.type = "image/png";
        document.head.appendChild(link);
        return ()=>document.head.removeChild(link);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _client.ApolloProvider), {
            client: apolloClient,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recoil.RecoilRoot), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _authDefault.default), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navbarDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            id: "Main",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundaryDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Routes), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            index: true,
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homePageDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            path: "/collection/:collectionId/*",
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectionRouterDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            path: "/build/*",
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildRouterDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            path: "/collections",
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectionsPageDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            path: "/files/*",
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filesPageDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            path: "/urls/*",
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _urlsRouterDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            path: "/import",
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importPageDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            path: "/logs",
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logsPageDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            path: "/users/*",
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersPageDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            path: "/account",
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountPageDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                            path: "*",
                                            element: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                        children: "404"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        children: "Page not found"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","recoil":"2QijJ","@apollo/client":"bWmmR","@apollo/client/utilities":"k55vB","@apollo/client/link/context":"c2s6j","@apollo/client/link/subscriptions":"9MM2L","graphql-ws":"bRngE","react-router-dom":"l6ORY","immer":"eUR2H","./Auth":"kfzWb","./Navbar":"flxrc","./HomePage":"eC2FZ","../build/BuildRouter":"20461","../collections/CollectionsPage":"evMyr","../collections/CollectionRouter":"fAN69","../files/FilesPage":"9w220","../urls/UrlsRouter":"3WtLX","../users/UsersPage":"8CXMj","../users/AccountPage":"c8WTJ","../logs/LogsPage":"f9n0G","../import/ImportPage":"4nNML","../utils/ErrorBoundary":"gTAYQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2QijJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultValue", ()=>Recoil_index_1);
parcelHelpers.export(exports, "RecoilEnv", ()=>Recoil_index_4);
parcelHelpers.export(exports, "RecoilLoadable", ()=>Recoil_index_3);
parcelHelpers.export(exports, "RecoilRoot", ()=>Recoil_index_5);
parcelHelpers.export(exports, "atom", ()=>Recoil_index_8);
parcelHelpers.export(exports, "atomFamily", ()=>Recoil_index_10);
parcelHelpers.export(exports, "constSelector", ()=>Recoil_index_12);
parcelHelpers.export(exports, "errorSelector", ()=>Recoil_index_13);
parcelHelpers.export(exports, "isRecoilValue", ()=>Recoil_index_2);
parcelHelpers.export(exports, "noWait", ()=>Recoil_index_15);
parcelHelpers.export(exports, "readOnlySelector", ()=>Recoil_index_14);
parcelHelpers.export(exports, "retentionZone", ()=>Recoil_index_38);
parcelHelpers.export(exports, "selector", ()=>Recoil_index_9);
parcelHelpers.export(exports, "selectorFamily", ()=>Recoil_index_11);
parcelHelpers.export(exports, "snapshot_UNSTABLE", ()=>Recoil_index_36);
parcelHelpers.export(exports, "useGetRecoilValueInfo_UNSTABLE", ()=>Recoil_index_26);
parcelHelpers.export(exports, "useGotoRecoilSnapshot", ()=>Recoil_index_33);
parcelHelpers.export(exports, "useRecoilBridgeAcrossReactRoots_UNSTABLE", ()=>Recoil_index_7);
parcelHelpers.export(exports, "useRecoilCallback", ()=>Recoil_index_31);
parcelHelpers.export(exports, "useRecoilRefresher_UNSTABLE", ()=>Recoil_index_27);
parcelHelpers.export(exports, "useRecoilSnapshot", ()=>Recoil_index_34);
parcelHelpers.export(exports, "useRecoilState", ()=>Recoil_index_22);
parcelHelpers.export(exports, "useRecoilStateLoadable", ()=>Recoil_index_23);
parcelHelpers.export(exports, "useRecoilState_TRANSITION_SUPPORT_UNSTABLE", ()=>Recoil_index_30);
parcelHelpers.export(exports, "useRecoilStoreID", ()=>Recoil_index_6);
parcelHelpers.export(exports, "useRecoilTransactionObserver_UNSTABLE", ()=>Recoil_index_35);
parcelHelpers.export(exports, "useRecoilTransaction_UNSTABLE", ()=>Recoil_index_32);
parcelHelpers.export(exports, "useRecoilValue", ()=>Recoil_index_20);
parcelHelpers.export(exports, "useRecoilValueLoadable", ()=>Recoil_index_21);
parcelHelpers.export(exports, "useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE", ()=>Recoil_index_28);
parcelHelpers.export(exports, "useRecoilValue_TRANSITION_SUPPORT_UNSTABLE", ()=>Recoil_index_29);
parcelHelpers.export(exports, "useResetRecoilState", ()=>Recoil_index_25);
parcelHelpers.export(exports, "useRetain", ()=>Recoil_index_37);
parcelHelpers.export(exports, "useSetRecoilState", ()=>Recoil_index_24);
parcelHelpers.export(exports, "waitForAll", ()=>Recoil_index_18);
parcelHelpers.export(exports, "waitForAllSettled", ()=>Recoil_index_19);
parcelHelpers.export(exports, "waitForAny", ()=>Recoil_index_17);
parcelHelpers.export(exports, "waitForNone", ()=>Recoil_index_16);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var process = require("86da38ec19b50b77");
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function err(message) {
    const error = new Error(message); // In V8, Error objects keep the closure scope chain alive until the
    // err.stack property is accessed.
    if (error.stack === undefined) // IE sets the stack only if error is thrown
    try {
        throw error;
    } catch (_) {} // eslint-disable-line fb-www/no-unused-catch-bindings, no-empty
    return error;
}
var err_1 = err;
// @oss-only
var Recoil_err = err_1;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ // Split declaration and implementation to allow this function to pretend to
// check for actual instance of Promise instead of something with a `then`
// method.
// eslint-disable-next-line no-redeclare
function isPromise(p) {
    return !!p && typeof p.then === "function";
}
var Recoil_isPromise = isPromise;
function nullthrows(x, message) {
    if (x != null) return x;
    throw Recoil_err(message !== null && message !== void 0 ? message : "Got unexpected null or undefined");
}
var Recoil_nullthrows = nullthrows;
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class BaseLoadable {
    getValue() {
        throw Recoil_err("BaseLoadable");
    }
    toPromise() {
        throw Recoil_err("BaseLoadable");
    }
    valueMaybe() {
        throw Recoil_err("BaseLoadable");
    }
    valueOrThrow() {
        // $FlowFixMe[prop-missing]
        throw Recoil_err(`Loadable expected value, but in "${this.state}" state`);
    }
    promiseMaybe() {
        throw Recoil_err("BaseLoadable");
    }
    promiseOrThrow() {
        // $FlowFixMe[prop-missing]
        throw Recoil_err(`Loadable expected promise, but in "${this.state}" state`);
    }
    errorMaybe() {
        throw Recoil_err("BaseLoadable");
    }
    errorOrThrow() {
        // $FlowFixMe[prop-missing]
        throw Recoil_err(`Loadable expected error, but in "${this.state}" state`);
    }
    is(other) {
        // $FlowFixMe[prop-missing]
        return other.state === this.state && other.contents === this.contents;
    }
    map(_map) {
        throw Recoil_err("BaseLoadable");
    }
}
class ValueLoadable extends BaseLoadable {
    constructor(value){
        super();
        _defineProperty(this, "state", "hasValue");
        _defineProperty(this, "contents", void 0);
        this.contents = value;
    }
    getValue() {
        return this.contents;
    }
    toPromise() {
        return Promise.resolve(this.contents);
    }
    valueMaybe() {
        return this.contents;
    }
    valueOrThrow() {
        return this.contents;
    }
    promiseMaybe() {
        return undefined;
    }
    errorMaybe() {
        return undefined;
    }
    map(map) {
        try {
            const next = map(this.contents);
            return Recoil_isPromise(next) ? loadableWithPromise(next) : isLoadable(next) ? next : loadableWithValue(next);
        } catch (e) {
            return Recoil_isPromise(e) ? // errors and subsequent retries will be handled in 'loading' case
            // $FlowFixMe[prop-missing]
            loadableWithPromise(e.next(()=>this.map(map))) : loadableWithError(e);
        }
    }
}
class ErrorLoadable extends BaseLoadable {
    constructor(error){
        super();
        _defineProperty(this, "state", "hasError");
        _defineProperty(this, "contents", void 0);
        this.contents = error;
    }
    getValue() {
        throw this.contents;
    }
    toPromise() {
        return Promise.reject(this.contents);
    }
    valueMaybe() {
        return undefined;
    }
    promiseMaybe() {
        return undefined;
    }
    errorMaybe() {
        return this.contents;
    }
    errorOrThrow() {
        return this.contents;
    }
    map(_map) {
        // $FlowIssue[incompatible-return]
        return this;
    }
}
class LoadingLoadable extends BaseLoadable {
    constructor(promise){
        super();
        _defineProperty(this, "state", "loading");
        _defineProperty(this, "contents", void 0);
        this.contents = promise;
    }
    getValue() {
        throw this.contents;
    }
    toPromise() {
        return this.contents;
    }
    valueMaybe() {
        return undefined;
    }
    promiseMaybe() {
        return this.contents;
    }
    promiseOrThrow() {
        return this.contents;
    }
    errorMaybe() {
        return undefined;
    }
    map(map) {
        return loadableWithPromise(this.contents.then((value)=>{
            const next = map(value);
            if (isLoadable(next)) {
                const nextLoadable = next;
                switch(nextLoadable.state){
                    case "hasValue":
                        return nextLoadable.contents;
                    case "hasError":
                        throw nextLoadable.contents;
                    case "loading":
                        return nextLoadable.contents;
                }
            } // $FlowIssue[incompatible-return]
            return next;
        }) // $FlowFixMe[incompatible-call]
        .catch((e)=>{
            if (Recoil_isPromise(e)) // we were "suspended," try again
            return e.then(()=>this.map(map).contents);
            throw e;
        }));
    }
}
function loadableWithValue(value) {
    return Object.freeze(new ValueLoadable(value));
}
function loadableWithError(error) {
    return Object.freeze(new ErrorLoadable(error));
}
function loadableWithPromise(promise) {
    return Object.freeze(new LoadingLoadable(promise));
}
function loadableLoading() {
    return Object.freeze(new LoadingLoadable(new Promise(()=>{})));
}
function loadableAllArray(inputs) {
    return inputs.every((i)=>i.state === "hasValue") ? loadableWithValue(inputs.map((i)=>i.contents)) : inputs.some((i)=>i.state === "hasError") ? loadableWithError(Recoil_nullthrows(inputs.find((i)=>i.state === "hasError"), "Invalid loadable passed to loadableAll").contents) : loadableWithPromise(Promise.all(inputs.map((i)=>i.contents)));
}
function loadableAll(inputs) {
    const unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map((key)=>inputs[key]);
    const normalizedInputs = unwrapedInputs.map((x)=>isLoadable(x) ? x : Recoil_isPromise(x) ? loadableWithPromise(x) : loadableWithValue(x));
    const output = loadableAllArray(normalizedInputs);
    return Array.isArray(inputs) ? output : // $FlowIssue[incompatible-call]
    output.map((outputs)=>Object.getOwnPropertyNames(inputs).reduce((out, key, idx)=>({
                ...out,
                [key]: outputs[idx]
            }), {}));
}
function isLoadable(x) {
    return x instanceof BaseLoadable;
}
const LoadableStaticInterface = {
    of: (value)=>Recoil_isPromise(value) ? loadableWithPromise(value) : isLoadable(value) ? value : loadableWithValue(value),
    error: (error)=>loadableWithError(error),
    // $FlowIssue[incompatible-return]
    loading: ()=>loadableLoading(),
    // $FlowIssue[unclear-type]
    all: loadableAll,
    isLoadable
};
var Recoil_Loadable = {
    loadableWithValue,
    loadableWithError,
    loadableWithPromise,
    loadableLoading,
    loadableAll,
    isLoadable,
    RecoilLoadable: LoadableStaticInterface
};
var Recoil_Loadable_1 = Recoil_Loadable.loadableWithValue;
var Recoil_Loadable_2 = Recoil_Loadable.loadableWithError;
var Recoil_Loadable_3 = Recoil_Loadable.loadableWithPromise;
var Recoil_Loadable_4 = Recoil_Loadable.loadableLoading;
var Recoil_Loadable_5 = Recoil_Loadable.loadableAll;
var Recoil_Loadable_6 = Recoil_Loadable.isLoadable;
var Recoil_Loadable_7 = Recoil_Loadable.RecoilLoadable;
var Recoil_Loadable$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    loadableWithValue: Recoil_Loadable_1,
    loadableWithError: Recoil_Loadable_2,
    loadableWithPromise: Recoil_Loadable_3,
    loadableLoading: Recoil_Loadable_4,
    loadableAll: Recoil_Loadable_5,
    isLoadable: Recoil_Loadable_6,
    RecoilLoadable: Recoil_Loadable_7
});
const env = {
    RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true,
    // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
    RECOIL_GKS_ENABLED: new Set([
        "recoil_hamt_2020",
        "recoil_sync_external_store",
        "recoil_suppress_rerender_in_callback",
        "recoil_memory_managament_2020"
    ])
};
function readProcessEnvBooleanFlag(name, set) {
    var _process$env$name, _process$env$name$toL;
    const sanitizedValue = (_process$env$name = process.env[name]) === null || _process$env$name === void 0 ? void 0 : (_process$env$name$toL = _process$env$name.toLowerCase()) === null || _process$env$name$toL === void 0 ? void 0 : _process$env$name$toL.trim();
    if (sanitizedValue == null || sanitizedValue === "") return;
    const allowedValues = [
        "true",
        "false"
    ];
    if (!allowedValues.includes(sanitizedValue)) throw Recoil_err(`process.env.${name} value must be 'true', 'false', or empty: ${sanitizedValue}`);
    set(sanitizedValue === "true");
}
function readProcessEnvStringArrayFlag(name, set) {
    var _process$env$name2;
    const sanitizedValue = (_process$env$name2 = process.env[name]) === null || _process$env$name2 === void 0 ? void 0 : _process$env$name2.trim();
    if (sanitizedValue == null || sanitizedValue === "") return;
    set(sanitizedValue.split(/\s*,\s*|\s+/));
}
/**
 * Allow NodeJS/NextJS/etc to set the initial state through process.env variable
 * Note:  we don't assume 'process' is available in all runtime environments
 *
 * @see https://github.com/facebookexperimental/Recoil/issues/733
 */ function applyProcessEnvFlagOverrides() {
    var _process;
    // note: this check is needed in addition to the check below, runtime error will occur without it!
    // eslint-disable-next-line fb-www/typeof-undefined
    if (typeof process === "undefined") return;
    if (((_process = process) === null || _process === void 0 ? void 0 : _process.env) == null) return;
    readProcessEnvBooleanFlag("RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED", (value)=>{
        env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = value;
    });
    readProcessEnvStringArrayFlag("RECOIL_GKS_ENABLED", (value)=>{
        value.forEach((gk)=>{
            env.RECOIL_GKS_ENABLED.add(gk);
        });
    });
}
applyProcessEnvFlagOverrides();
var Recoil_RecoilEnv = env;
function Recoil_gkx_OSS(gk) {
    return Recoil_RecoilEnv.RECOIL_GKS_ENABLED.has(gk);
}
Recoil_gkx_OSS.setPass = (gk)=>{
    Recoil_RecoilEnv.RECOIL_GKS_ENABLED.add(gk);
};
Recoil_gkx_OSS.setFail = (gk)=>{
    Recoil_RecoilEnv.RECOIL_GKS_ENABLED.delete(gk);
};
Recoil_gkx_OSS.clear = ()=>{
    Recoil_RecoilEnv.RECOIL_GKS_ENABLED.clear();
};
var Recoil_gkx = Recoil_gkx_OSS; // @oss-only
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function recoverableViolation(message, _projectName, { error } = {}) {
    return null;
}
var recoverableViolation_1 = recoverableViolation;
// @oss-only
var Recoil_recoverableViolation = recoverableViolation_1;
var _createMutableSource, _useMutableSource, _useSyncExternalStore;
const createMutableSource = (_createMutableSource = (0, _reactDefault.default).createMutableSource) !== null && _createMutableSource !== void 0 ? _createMutableSource : (0, _reactDefault.default).unstable_createMutableSource;
const useMutableSource = (_useMutableSource = (0, _reactDefault.default).useMutableSource) !== null && _useMutableSource !== void 0 ? _useMutableSource : (0, _reactDefault.default).unstable_useMutableSource; // https://github.com/reactwg/react-18/discussions/86
const useSyncExternalStore = (_useSyncExternalStore = (0, _reactDefault.default).useSyncExternalStore) !== null && _useSyncExternalStore !== void 0 ? _useSyncExternalStore : (0, _reactDefault.default).unstable_useSyncExternalStore;
let ReactRendererVersionMismatchWarnOnce = false; // Check if the current renderer supports `useSyncExternalStore()`.
// Since React goes through a proxy dispatcher and the current renderer can
// change we can't simply check if `React.useSyncExternalStore()` is defined.
function currentRendererSupportsUseSyncExternalStore() {
    var _ReactCurrentDispatch;
    // $FlowFixMe[incompatible-use]
    const { ReactCurrentDispatcher, ReactCurrentOwner } = /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
   * to detect if the current renderer supports useSyncExternalStore()
   * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */ (0, _reactDefault.default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    const dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
    const isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;
    if (useSyncExternalStore && !isUseSyncExternalStoreSupported && !ReactRendererVersionMismatchWarnOnce) {
        ReactRendererVersionMismatchWarnOnce = true;
        Recoil_recoverableViolation("A React renderer without React 18+ API support is being used with React 18+.");
    }
    return isUseSyncExternalStoreSupported;
}
/**
 * mode: The React API and approach to use for syncing state with React
 * early: Re-renders from Recoil updates occur:
 *    1) earlier
 *    2) in sync with React updates in the same batch
 *    3) before transaction observers instead of after.
 * concurrent: Is the current mode compatible with Concurrent Mode and useTransition()
 */ function reactMode() {
    // NOTE: This mode is currently broken with some Suspense cases
    // see Recoil_selector-test.js
    if (Recoil_gkx("recoil_transition_support")) return {
        mode: "TRANSITION_SUPPORT",
        early: true,
        concurrent: true
    };
    if (Recoil_gkx("recoil_sync_external_store") && useSyncExternalStore != null) return {
        mode: "SYNC_EXTERNAL_STORE",
        early: true,
        concurrent: false
    };
    if (Recoil_gkx("recoil_mutable_source") && useMutableSource != null && typeof window !== "undefined" && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) return Recoil_gkx("recoil_suppress_rerender_in_callback") ? {
        mode: "MUTABLE_SOURCE",
        early: true,
        concurrent: true
    } : {
        mode: "MUTABLE_SOURCE",
        early: false,
        concurrent: false
    };
    return Recoil_gkx("recoil_suppress_rerender_in_callback") ? {
        mode: "LEGACY",
        early: true,
        concurrent: false
    } : {
        mode: "LEGACY",
        early: false,
        concurrent: false
    };
} // TODO Need to figure out if there is a standard/open-source equivalent to see if hot module replacement is happening:
function isFastRefreshEnabled() {
    // @fb-only: const {isAcceptingUpdate} = require('__debug');
    // @fb-only: return typeof isAcceptingUpdate === 'function' && isAcceptingUpdate();
    return false; // @oss-only
}
var Recoil_ReactMode = {
    createMutableSource,
    useMutableSource,
    useSyncExternalStore,
    currentRendererSupportsUseSyncExternalStore,
    reactMode,
    isFastRefreshEnabled
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ // eslint-disable-next-line no-unused-vars
class AbstractRecoilValue {
    constructor(newKey){
        _defineProperty(this, "key", void 0);
        this.key = newKey;
    }
    toJSON() {
        return {
            key: this.key
        };
    }
}
class RecoilState extends AbstractRecoilValue {
}
class RecoilValueReadOnly extends AbstractRecoilValue {
}
function isRecoilValue(x) {
    return x instanceof RecoilState || x instanceof RecoilValueReadOnly;
}
var Recoil_RecoilValue = {
    AbstractRecoilValue,
    RecoilState,
    RecoilValueReadOnly,
    isRecoilValue
};
var Recoil_RecoilValue_1 = Recoil_RecoilValue.AbstractRecoilValue;
var Recoil_RecoilValue_2 = Recoil_RecoilValue.RecoilState;
var Recoil_RecoilValue_3 = Recoil_RecoilValue.RecoilValueReadOnly;
var Recoil_RecoilValue_4 = Recoil_RecoilValue.isRecoilValue;
var Recoil_RecoilValue$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AbstractRecoilValue: Recoil_RecoilValue_1,
    RecoilState: Recoil_RecoilValue_2,
    RecoilValueReadOnly: Recoil_RecoilValue_3,
    isRecoilValue: Recoil_RecoilValue_4
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function sprintf(format, ...args) {
    let index = 0;
    return format.replace(/%s/g, ()=>String(args[index++]));
}
var sprintf_1 = sprintf;
function expectationViolation(format, ...args) {}
var expectationViolation_1 = expectationViolation;
// @oss-only
var Recoil_expectationViolation = expectationViolation_1;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the mapper function.
 */ function mapIterable(iterable, callback) {
    // Use generator to create iterable/iterator
    return function*() {
        let index = 0;
        for (const value of iterable)yield callback(value, index++);
    }();
}
var Recoil_mapIterable = mapIterable;
const { isFastRefreshEnabled: isFastRefreshEnabled$1 } = Recoil_ReactMode;
class DefaultValue {
}
const DEFAULT_VALUE = new DefaultValue();
// flowlint-next-line unclear-type:off
const nodes = new Map(); // flowlint-next-line unclear-type:off
const recoilValues = new Map();
/* eslint-disable no-redeclare */ function recoilValuesForKeys(keys) {
    return Recoil_mapIterable(keys, (key)=>Recoil_nullthrows(recoilValues.get(key)));
}
function checkForDuplicateAtomKey(key) {
    if (nodes.has(key)) {
        const message = `Duplicate atom key "${key}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;
        // @fb-only: recoverableViolation(message, 'recoil');
        console.warn(message); // @oss-only
    }
}
function registerNode(node) {
    if (Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) checkForDuplicateAtomKey(node.key);
    nodes.set(node.key, node);
    const recoilValue = node.set == null ? new Recoil_RecoilValue$1.RecoilValueReadOnly(node.key) : new Recoil_RecoilValue$1.RecoilState(node.key);
    recoilValues.set(node.key, recoilValue);
    return recoilValue;
}
/* eslint-enable no-redeclare */ class NodeMissingError extends Error {
} // flowlint-next-line unclear-type:off
function getNode(key) {
    const node = nodes.get(key);
    if (node == null) throw new NodeMissingError(`Missing definition for RecoilValue: "${key}""`);
    return node;
} // flowlint-next-line unclear-type:off
function getNodeMaybe(key) {
    return nodes.get(key);
}
const configDeletionHandlers = new Map();
function deleteNodeConfigIfPossible(key) {
    var _node$shouldDeleteCon;
    if (!Recoil_gkx("recoil_memory_managament_2020")) return;
    const node = nodes.get(key);
    if (node !== null && node !== void 0 && (_node$shouldDeleteCon = node.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node)) {
        var _getConfigDeletionHan;
        nodes.delete(key);
        (_getConfigDeletionHan = getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 || _getConfigDeletionHan();
        configDeletionHandlers.delete(key);
    }
}
function setConfigDeletionHandler(key, fn) {
    if (!Recoil_gkx("recoil_memory_managament_2020")) return;
    if (fn === undefined) configDeletionHandlers.delete(key);
    else configDeletionHandlers.set(key, fn);
}
function getConfigDeletionHandler(key) {
    return configDeletionHandlers.get(key);
}
var Recoil_Node = {
    nodes,
    recoilValues,
    registerNode,
    getNode,
    getNodeMaybe,
    deleteNodeConfigIfPossible,
    setConfigDeletionHandler,
    getConfigDeletionHandler,
    recoilValuesForKeys,
    NodeMissingError,
    DefaultValue,
    DEFAULT_VALUE
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function enqueueExecution(s, f) {
    f();
}
var Recoil_Queue = {
    enqueueExecution
};
function createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var hamt_1 = createCommonjsModule(function(module) {
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    /**
    @fileOverview Hash Array Mapped Trie.

    Code based on: https://github.com/exclipy/pdata
*/ var hamt = {}; // export
    /* Configuration
 ******************************************************************************/ var SIZE = 5;
    var BUCKET_SIZE = Math.pow(2, SIZE);
    var MASK = BUCKET_SIZE - 1;
    var MAX_INDEX_NODE = BUCKET_SIZE / 2;
    var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
    /*
 ******************************************************************************/ var nothing = {};
    var constant = function constant(x) {
        return function() {
            return x;
        };
    };
    /**
    Get 32 bit hash of string.

    Based on:
    http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
*/ var hash = hamt.hash = function(str) {
        var type = typeof str === "undefined" ? "undefined" : _typeof(str);
        if (type === "number") return str;
        if (type !== "string") str += "";
        var hash = 0;
        for(var i = 0, len = str.length; i < len; ++i){
            var c = str.charCodeAt(i);
            hash = (hash << 5) - hash + c | 0;
        }
        return hash;
    };
    /* Bit Ops
 ******************************************************************************/ /**
    Hamming weight.

    Taken from: http://jsperf.com/hamming-weight
*/ var popcount = function popcount(x) {
        x -= x >> 1 & 0x55555555;
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x += x >> 8;
        x += x >> 16;
        return x & 0x7f;
    };
    var hashFragment = function hashFragment(shift, h) {
        return h >>> shift & MASK;
    };
    var toBitmap = function toBitmap(x) {
        return 1 << x;
    };
    var fromBitmap = function fromBitmap(bitmap, bit) {
        return popcount(bitmap & bit - 1);
    };
    /* Array Ops
 ******************************************************************************/ /**
    Set a value in an array.

    @param mutate Should the input array be mutated?
    @param at Index to change.
    @param v New value
    @param arr Array.
*/ var arrayUpdate = function arrayUpdate(mutate, at, v, arr) {
        var out = arr;
        if (!mutate) {
            var len = arr.length;
            out = new Array(len);
            for(var i = 0; i < len; ++i)out[i] = arr[i];
        }
        out[at] = v;
        return out;
    };
    /**
    Remove a value from an array.

    @param mutate Should the input array be mutated?
    @param at Index to remove.
    @param arr Array.
*/ var arraySpliceOut = function arraySpliceOut(mutate, at, arr) {
        var newLen = arr.length - 1;
        var i = 0;
        var g = 0;
        var out = arr;
        if (mutate) i = g = at;
        else {
            out = new Array(newLen);
            while(i < at)out[g++] = arr[i++];
        }
        ++i;
        while(i <= newLen)out[g++] = arr[i++];
        if (mutate) out.length = newLen;
        return out;
    };
    /**
    Insert a value into an array.

    @param mutate Should the input array be mutated?
    @param at Index to insert at.
    @param v Value to insert,
    @param arr Array.
*/ var arraySpliceIn = function arraySpliceIn(mutate, at, v, arr) {
        var len = arr.length;
        if (mutate) {
            var _i = len;
            while(_i >= at)arr[_i--] = arr[_i];
            arr[at] = v;
            return arr;
        }
        var i = 0, g = 0;
        var out = new Array(len + 1);
        while(i < at)out[g++] = arr[i++];
        out[at] = v;
        while(i < len)out[++g] = arr[i++];
        return out;
    };
    /* Node Structures
 ******************************************************************************/ var LEAF = 1;
    var COLLISION = 2;
    var INDEX = 3;
    var ARRAY = 4;
    /**
    Empty node.
*/ var empty = {
        __hamt_isEmpty: true
    };
    var isEmptyNode = function isEmptyNode(x) {
        return x === empty || x && x.__hamt_isEmpty;
    };
    /**
    Leaf holding a value.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member key Key.
    @member value Value stored.
*/ var Leaf = function Leaf(edit, hash, key, value) {
        return {
            type: LEAF,
            edit: edit,
            hash: hash,
            key: key,
            value: value,
            _modify: Leaf__modify
        };
    };
    /**
    Leaf holding multiple values with the same hash but different keys.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member children Array of collision children node.
*/ var Collision = function Collision(edit, hash, children) {
        return {
            type: COLLISION,
            edit: edit,
            hash: hash,
            children: children,
            _modify: Collision__modify
        };
    };
    /**
    Internal node with a sparse set of children.

    Uses a bitmap and array to pack children.

  @member edit Edit of the node.
    @member mask Bitmap that encode the positions of children in the array.
    @member children Array of child nodes.
*/ var IndexedNode = function IndexedNode(edit, mask, children) {
        return {
            type: INDEX,
            edit: edit,
            mask: mask,
            children: children,
            _modify: IndexedNode__modify
        };
    };
    /**
    Internal node with many children.

    @member edit Edit of the node.
    @member size Number of children.
    @member children Array of child nodes.
*/ var ArrayNode = function ArrayNode(edit, size, children) {
        return {
            type: ARRAY,
            edit: edit,
            size: size,
            children: children,
            _modify: ArrayNode__modify
        };
    };
    /**
    Is `node` a leaf node?
*/ var isLeaf = function isLeaf(node) {
        return node === empty || node.type === LEAF || node.type === COLLISION;
    };
    /* Internal node operations.
 ******************************************************************************/ /**
    Expand an indexed node into an array node.

  @param edit Current edit.
    @param frag Index of added child.
    @param child Added child.
    @param mask Index node mask before child added.
    @param subNodes Index node children before child added.
*/ var expand = function expand(edit, frag, child, bitmap, subNodes) {
        var arr = [];
        var bit = bitmap;
        var count = 0;
        for(var i = 0; bit; ++i){
            if (bit & 1) arr[i] = subNodes[count++];
            bit >>>= 1;
        }
        arr[frag] = child;
        return ArrayNode(edit, count + 1, arr);
    };
    /**
    Collapse an array node into a indexed node.

  @param edit Current edit.
    @param count Number of elements in new array.
    @param removed Index of removed element.
    @param elements Array node children before remove.
*/ var pack = function pack(edit, count, removed, elements) {
        var children = new Array(count - 1);
        var g = 0;
        var bitmap = 0;
        for(var i = 0, len = elements.length; i < len; ++i)if (i !== removed) {
            var elem = elements[i];
            if (elem && !isEmptyNode(elem)) {
                children[g++] = elem;
                bitmap |= 1 << i;
            }
        }
        return IndexedNode(edit, bitmap, children);
    };
    /**
    Merge two leaf nodes.

    @param shift Current shift.
    @param h1 Node 1 hash.
    @param n1 Node 1.
    @param h2 Node 2 hash.
    @param n2 Node 2.
*/ var mergeLeaves = function mergeLeaves(edit, shift, h1, n1, h2, n2) {
        if (h1 === h2) return Collision(edit, h1, [
            n2,
            n1
        ]);
        var subH1 = hashFragment(shift, h1);
        var subH2 = hashFragment(shift, h2);
        return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [
            mergeLeaves(edit, shift + SIZE, h1, n1, h2, n2)
        ] : subH1 < subH2 ? [
            n1,
            n2
        ] : [
            n2,
            n1
        ]);
    };
    /**
    Update an entry in a collision list.

    @param mutate Should mutation be used?
    @param edit Current edit.
    @param keyEq Key compare function.
    @param hash Hash of collision.
    @param list Collision list.
    @param f Update function.
    @param k Key to update.
    @param size Size ref.
*/ var updateCollisionList = function updateCollisionList(mutate, edit, keyEq, h, list, f, k, size) {
        var len = list.length;
        for(var i = 0; i < len; ++i){
            var child = list[i];
            if (keyEq(k, child.key)) {
                var value = child.value;
                var _newValue = f(value);
                if (_newValue === value) return list;
                if (_newValue === nothing) {
                    --size.value;
                    return arraySpliceOut(mutate, i, list);
                }
                return arrayUpdate(mutate, i, Leaf(edit, h, k, _newValue), list);
            }
        }
        var newValue = f();
        if (newValue === nothing) return list;
        ++size.value;
        return arrayUpdate(mutate, len, Leaf(edit, h, k, newValue), list);
    };
    var canEditNode = function canEditNode(edit, node) {
        return edit === node.edit;
    };
    /* Editing
 ******************************************************************************/ var Leaf__modify = function Leaf__modify(edit, keyEq, shift, f, h, k, size) {
        if (keyEq(k, this.key)) {
            var _v = f(this.value);
            if (_v === this.value) return this;
            else if (_v === nothing) {
                --size.value;
                return empty;
            }
            if (canEditNode(edit, this)) {
                this.value = _v;
                return this;
            }
            return Leaf(edit, h, k, _v);
        }
        var v = f();
        if (v === nothing) return this;
        ++size.value;
        return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
    };
    var Collision__modify = function Collision__modify(edit, keyEq, shift, f, h, k, size) {
        if (h === this.hash) {
            var canEdit = canEditNode(edit, this);
            var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
            if (list === this.children) return this;
            return list.length > 1 ? Collision(edit, this.hash, list) : list[0]; // collapse single element collision list
        }
        var v = f();
        if (v === nothing) return this;
        ++size.value;
        return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
    };
    var IndexedNode__modify = function IndexedNode__modify(edit, keyEq, shift, f, h, k, size) {
        var mask = this.mask;
        var children = this.children;
        var frag = hashFragment(shift, h);
        var bit = toBitmap(frag);
        var indx = fromBitmap(mask, bit);
        var exists = mask & bit;
        var current = exists ? children[indx] : empty;
        var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);
        if (current === child) return this;
        var canEdit = canEditNode(edit, this);
        var bitmap = mask;
        var newChildren = void 0;
        if (exists && isEmptyNode(child)) {
            // remove
            bitmap &= ~bit;
            if (!bitmap) return empty;
            if (children.length <= 2 && isLeaf(children[indx ^ 1])) return children[indx ^ 1]; // collapse
            newChildren = arraySpliceOut(canEdit, indx, children);
        } else if (!exists && !isEmptyNode(child)) {
            // add
            if (children.length >= MAX_INDEX_NODE) return expand(edit, frag, child, mask, children);
            bitmap |= bit;
            newChildren = arraySpliceIn(canEdit, indx, child, children);
        } else // modify
        newChildren = arrayUpdate(canEdit, indx, child, children);
        if (canEdit) {
            this.mask = bitmap;
            this.children = newChildren;
            return this;
        }
        return IndexedNode(edit, bitmap, newChildren);
    };
    var ArrayNode__modify = function ArrayNode__modify(edit, keyEq, shift, f, h, k, size) {
        var count = this.size;
        var children = this.children;
        var frag = hashFragment(shift, h);
        var child = children[frag];
        var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);
        if (child === newChild) return this;
        var canEdit = canEditNode(edit, this);
        var newChildren = void 0;
        if (isEmptyNode(child) && !isEmptyNode(newChild)) {
            // add
            ++count;
            newChildren = arrayUpdate(canEdit, frag, newChild, children);
        } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
            // remove
            --count;
            if (count <= MIN_ARRAY_NODE) return pack(edit, count, frag, children);
            newChildren = arrayUpdate(canEdit, frag, empty, children);
        } else // modify
        newChildren = arrayUpdate(canEdit, frag, newChild, children);
        if (canEdit) {
            this.size = count;
            this.children = newChildren;
            return this;
        }
        return ArrayNode(edit, count, newChildren);
    };
    empty._modify = function(edit, keyEq, shift, f, h, k, size) {
        var v = f();
        if (v === nothing) return empty;
        ++size.value;
        return Leaf(edit, h, k, v);
    };
    /*
 ******************************************************************************/ function Map1(editable, edit, config, root, size) {
        this._editable = editable;
        this._edit = edit;
        this._config = config;
        this._root = root;
        this._size = size;
    }
    Map1.prototype.setTree = function(newRoot, newSize) {
        if (this._editable) {
            this._root = newRoot;
            this._size = newSize;
            return this;
        }
        return newRoot === this._root ? this : new Map1(this._editable, this._edit, this._config, newRoot, newSize);
    };
    /* Queries
 ******************************************************************************/ /**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `alt` if none.
*/ var tryGetHash = hamt.tryGetHash = function(alt, hash, key, map) {
        var node = map._root;
        var shift = 0;
        var keyEq = map._config.keyEq;
        while(true)switch(node.type){
            case LEAF:
                return keyEq(key, node.key) ? node.value : alt;
            case COLLISION:
                if (hash === node.hash) {
                    var children = node.children;
                    for(var i = 0, len = children.length; i < len; ++i){
                        var child = children[i];
                        if (keyEq(key, child.key)) return child.value;
                    }
                }
                return alt;
            case INDEX:
                var frag = hashFragment(shift, hash);
                var bit = toBitmap(frag);
                if (node.mask & bit) {
                    node = node.children[fromBitmap(node.mask, bit)];
                    shift += SIZE;
                    break;
                }
                return alt;
            case ARRAY:
                node = node.children[hashFragment(shift, hash)];
                if (node) {
                    shift += SIZE;
                    break;
                }
                return alt;
            default:
                return alt;
        }
    };
    Map1.prototype.tryGetHash = function(alt, hash, key) {
        return tryGetHash(alt, hash, key, this);
    };
    /**
    Lookup the value for `key` in `map` using internal hash function.

    @see `tryGetHash`
*/ var tryGet = hamt.tryGet = function(alt, key, map) {
        return tryGetHash(alt, map._config.hash(key), key, map);
    };
    Map1.prototype.tryGet = function(alt, key) {
        return tryGet(alt, key, this);
    };
    /**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `undefined` if none.
*/ var getHash = hamt.getHash = function(hash, key, map) {
        return tryGetHash(undefined, hash, key, map);
    };
    Map1.prototype.getHash = function(hash, key) {
        return getHash(hash, key, this);
    };
    /**
    Lookup the value for `key` in `map` using internal hash function.

    @see `get`
*/ var get = hamt.get = function(key, map) {
        return tryGetHash(undefined, map._config.hash(key), key, map);
    };
    Map1.prototype.get = function(key, alt) {
        return tryGet(alt, key, this);
    };
    /**
    Does an entry exist for `key` in `map`? Uses custom `hash`.
*/ var hasHash = hamt.has = function(hash, key, map) {
        return tryGetHash(nothing, hash, key, map) !== nothing;
    };
    Map1.prototype.hasHash = function(hash, key) {
        return hasHash(hash, key, this);
    };
    /**
    Does an entry exist for `key` in `map`? Uses internal hash function.
*/ var has = hamt.has = function(key, map) {
        return hasHash(map._config.hash(key), key, map);
    };
    Map1.prototype.has = function(key) {
        return has(key, this);
    };
    var defKeyCompare = function defKeyCompare(x, y) {
        return x === y;
    };
    /**
    Create an empty map.

    @param config Configuration.
*/ hamt.make = function(config) {
        return new Map1(0, 0, {
            keyEq: config && config.keyEq || defKeyCompare,
            hash: config && config.hash || hash
        }, empty, 0);
    };
    /**
    Empty map.
*/ hamt.empty = hamt.make();
    /**
    Does `map` contain any elements?
*/ var isEmpty = hamt.isEmpty = function(map) {
        return map && !!isEmptyNode(map._root);
    };
    Map1.prototype.isEmpty = function() {
        return isEmpty(this);
    };
    /* Updates
 ******************************************************************************/ /**
    Alter the value stored for `key` in `map` using function `f` using
    custom hash.

    `f` is invoked with the current value for `k` if it exists,
    or no arguments if no such value exists. `modify` will always either
    update or insert a value into the map.

    Returns a map with the modified value. Does not alter `map`.
*/ var modifyHash = hamt.modifyHash = function(f, hash, key, map) {
        var size = {
            value: map._size
        };
        var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash, key, size);
        return map.setTree(newRoot, size.value);
    };
    Map1.prototype.modifyHash = function(hash, key, f) {
        return modifyHash(f, hash, key, this);
    };
    /**
    Alter the value stored for `key` in `map` using function `f` using
    internal hash function.

    @see `modifyHash`
*/ var modify = hamt.modify = function(f, key, map) {
        return modifyHash(f, map._config.hash(key), key, map);
    };
    Map1.prototype.modify = function(key, f) {
        return modify(f, key, this);
    };
    /**
    Store `value` for `key` in `map` using custom `hash`.

    Returns a map with the modified value. Does not alter `map`.
*/ var setHash = hamt.setHash = function(hash, key, value, map) {
        return modifyHash(constant(value), hash, key, map);
    };
    Map1.prototype.setHash = function(hash, key, value) {
        return setHash(hash, key, value, this);
    };
    /**
    Store `value` for `key` in `map` using internal hash function.

    @see `setHash`
*/ var set = hamt.set = function(key, value, map) {
        return setHash(map._config.hash(key), key, value, map);
    };
    Map1.prototype.set = function(key, value) {
        return set(key, value, this);
    };
    /**
    Remove the entry for `key` in `map`.

    Returns a map with the value removed. Does not alter `map`.
*/ var del = constant(nothing);
    var removeHash = hamt.removeHash = function(hash, key, map) {
        return modifyHash(del, hash, key, map);
    };
    Map1.prototype.removeHash = Map1.prototype.deleteHash = function(hash, key) {
        return removeHash(hash, key, this);
    };
    /**
    Remove the entry for `key` in `map` using internal hash function.

    @see `removeHash`
*/ var remove = hamt.remove = function(key, map) {
        return removeHash(map._config.hash(key), key, map);
    };
    Map1.prototype.remove = Map1.prototype.delete = function(key) {
        return remove(key, this);
    };
    /* Mutation
 ******************************************************************************/ /**
    Mark `map` as mutable.
 */ var beginMutation = hamt.beginMutation = function(map) {
        return new Map1(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
    };
    Map1.prototype.beginMutation = function() {
        return beginMutation(this);
    };
    /**
    Mark `map` as immutable.
 */ var endMutation = hamt.endMutation = function(map) {
        map._editable = map._editable && map._editable - 1;
        return map;
    };
    Map1.prototype.endMutation = function() {
        return endMutation(this);
    };
    /**
    Mutate `map` within the context of `f`.
    @param f
    @param map HAMT
*/ var mutate = hamt.mutate = function(f, map) {
        var transient = beginMutation(map);
        f(transient);
        return endMutation(transient);
    };
    Map1.prototype.mutate = function(f) {
        return mutate(f, this);
    };
    /* Traversal
 ******************************************************************************/ /**
    Apply a continuation.
*/ var appk = function appk(k) {
        return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
    };
    /**
    Recursively visit all values stored in an array of nodes lazily.
*/ var lazyVisitChildren = function lazyVisitChildren(len, children, i, f, k) {
        while(i < len){
            var child = children[i++];
            if (child && !isEmptyNode(child)) return lazyVisit(child, f, [
                len,
                children,
                i,
                f,
                k
            ]);
        }
        return appk(k);
    };
    /**
    Recursively visit all values stored in `node` lazily.
*/ var lazyVisit = function lazyVisit(node, f, k) {
        switch(node.type){
            case LEAF:
                return {
                    value: f(node),
                    rest: k
                };
            case COLLISION:
            case ARRAY:
            case INDEX:
                var children = node.children;
                return lazyVisitChildren(children.length, children, 0, f, k);
            default:
                return appk(k);
        }
    };
    var DONE = {
        done: true
    };
    /**
    Javascript iterator over a map.
*/ function MapIterator(v) {
        this.v = v;
    }
    MapIterator.prototype.next = function() {
        if (!this.v) return DONE;
        var v0 = this.v;
        this.v = appk(v0.rest);
        return v0;
    };
    MapIterator.prototype[Symbol.iterator] = function() {
        return this;
    };
    /**
    Lazily visit each value in map with function `f`.
*/ var visit = function visit(map, f) {
        return new MapIterator(lazyVisit(map._root, f));
    };
    /**
    Get a Javascsript iterator of `map`.

    Iterates over `[key, value]` arrays.
*/ var buildPairs = function buildPairs(x) {
        return [
            x.key,
            x.value
        ];
    };
    var entries = hamt.entries = function(map) {
        return visit(map, buildPairs);
    };
    Map1.prototype.entries = Map1.prototype[Symbol.iterator] = function() {
        return entries(this);
    };
    /**
    Get array of all keys in `map`.

    Order is not guaranteed.
*/ var buildKeys = function buildKeys(x) {
        return x.key;
    };
    var keys = hamt.keys = function(map) {
        return visit(map, buildKeys);
    };
    Map1.prototype.keys = function() {
        return keys(this);
    };
    /**
    Get array of all values in `map`.

    Order is not guaranteed, duplicates are preserved.
*/ var buildValues = function buildValues(x) {
        return x.value;
    };
    var values = hamt.values = Map1.prototype.values = function(map) {
        return visit(map, buildValues);
    };
    Map1.prototype.values = function() {
        return values(this);
    };
    /* Fold
 ******************************************************************************/ /**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function mapping accumulated value, value, and key to new value.
    @param z Starting value.
    @param m HAMT
*/ var fold = hamt.fold = function(f, z, m) {
        var root = m._root;
        if (root.type === LEAF) return f(z, root.value, root.key);
        var toVisit = [
            root.children
        ];
        var children = void 0;
        while(children = toVisit.pop())for(var i = 0, len = children.length; i < len;){
            var child = children[i++];
            if (child && child.type) {
                if (child.type === LEAF) z = f(z, child.value, child.key);
                else toVisit.push(child.children);
            }
        }
        return z;
    };
    Map1.prototype.fold = function(f, z) {
        return fold(f, z, this);
    };
    /**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function invoked with value and key
    @param map HAMT
*/ var forEach = hamt.forEach = function(f, map) {
        return fold(function(_, value, key) {
            return f(value, key, map);
        }, null, map);
    };
    Map1.prototype.forEach = function(f) {
        return forEach(f, this);
    };
    /* Aggregate
 ******************************************************************************/ /**
    Get the number of entries in `map`.
*/ var count = hamt.count = function(map) {
        return map._size;
    };
    Map1.prototype.count = function() {
        return count(this);
    };
    Object.defineProperty(Map1.prototype, "size", {
        get: Map1.prototype.count
    });
    /* Export
 ******************************************************************************/ if (module.exports) module.exports = hamt;
    else undefined.hamt = hamt;
});
class BuiltInMap {
    constructor(existing){
        _defineProperty(this, "_map", void 0);
        this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
    }
    keys() {
        return this._map.keys();
    }
    entries() {
        return this._map.entries();
    }
    get(k) {
        return this._map.get(k);
    }
    has(k) {
        return this._map.has(k);
    }
    set(k, v) {
        this._map.set(k, v);
        return this;
    }
    delete(k) {
        this._map.delete(k);
        return this;
    }
    clone() {
        return persistentMap(this);
    }
    toMap() {
        return new Map(this._map);
    }
}
class HashArrayMappedTrieMap {
    // Because hamt.empty is not a function there is no way to introduce type
    // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
    // $FlowIssue
    constructor(existing){
        _defineProperty(this, "_hamt", hamt_1.empty.beginMutation());
        if (existing instanceof HashArrayMappedTrieMap) {
            const h = existing._hamt.endMutation();
            existing._hamt = h.beginMutation();
            this._hamt = h.beginMutation();
        } else if (existing) for (const [k, v] of existing.entries())this._hamt.set(k, v);
    }
    keys() {
        return this._hamt.keys();
    }
    entries() {
        return this._hamt.entries();
    }
    get(k) {
        return this._hamt.get(k);
    }
    has(k) {
        return this._hamt.has(k);
    }
    set(k, v) {
        this._hamt.set(k, v);
        return this;
    }
    delete(k) {
        this._hamt.delete(k);
        return this;
    }
    clone() {
        return persistentMap(this);
    }
    toMap() {
        return new Map(this._hamt);
    }
}
function persistentMap(existing) {
    if (Recoil_gkx("recoil_hamt_2020")) return new HashArrayMappedTrieMap(existing);
    else return new BuiltInMap(existing);
}
var Recoil_PersistentMap = {
    persistentMap
};
var Recoil_PersistentMap_1 = Recoil_PersistentMap.persistentMap;
var Recoil_PersistentMap$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    persistentMap: Recoil_PersistentMap_1
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a set containing all of the values from the first set that are not
 * present in any of the subsequent sets.
 *
 * Note: this is written procedurally (i.e., without filterSet) for performant
 * use in tight loops.
 */ function differenceSets(set, ...setsWithValuesToRemove) {
    const ret = new Set();
    FIRST: for (const value of set){
        for (const otherSet of setsWithValuesToRemove){
            if (otherSet.has(value)) continue FIRST;
        }
        ret.add(value);
    }
    return ret;
}
var Recoil_differenceSets = differenceSets;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a new Map object with the same keys as the original, but with the
 * values replaced with the output of the given callback function.
 */ function mapMap(map, callback) {
    const result = new Map();
    map.forEach((value, key)=>{
        result.set(key, callback(value, key));
    });
    return result;
}
var Recoil_mapMap = mapMap;
function makeGraph() {
    return {
        nodeDeps: new Map(),
        nodeToNodeSubscriptions: new Map()
    };
}
function cloneGraph(graph) {
    return {
        nodeDeps: Recoil_mapMap(graph.nodeDeps, (s)=>new Set(s)),
        nodeToNodeSubscriptions: Recoil_mapMap(graph.nodeToNodeSubscriptions, (s)=>new Set(s))
    };
} // Note that this overwrites the deps of existing nodes, rather than unioning
// the new deps with the old deps.
function mergeDepsIntoGraph(key, newDeps, graph, // graph compared with olderGraph:
olderGraph) {
    const { nodeDeps, nodeToNodeSubscriptions } = graph;
    const oldDeps = nodeDeps.get(key);
    if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) return;
     // Update nodeDeps:
    nodeDeps.set(key, newDeps); // Add new deps to nodeToNodeSubscriptions:
    const addedDeps = oldDeps == null ? newDeps : Recoil_differenceSets(newDeps, oldDeps);
    for (const dep of addedDeps){
        if (!nodeToNodeSubscriptions.has(dep)) nodeToNodeSubscriptions.set(dep, new Set());
        const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
        existing.add(key);
    } // Remove removed deps from nodeToNodeSubscriptions:
    if (oldDeps) {
        const removedDeps = Recoil_differenceSets(oldDeps, newDeps);
        for (const dep of removedDeps){
            if (!nodeToNodeSubscriptions.has(dep)) return;
            const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
            existing.delete(key);
            if (existing.size === 0) nodeToNodeSubscriptions.delete(dep);
        }
    }
}
function saveDepsToStore(key, deps, store, version) {
    var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;
    const storeState = store.getState();
    if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) Recoil_recoverableViolation("Tried to save dependencies to a discarded tree");
     // Merge the dependencies discovered into the store's dependency map
    // for the version that was read:
    const graph = store.getGraph(version);
    mergeDepsIntoGraph(key, deps, graph); // If this version is not the latest version, also write these dependencies
    // into later versions if they don't already have their own:
    if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
        const currentGraph = store.getGraph(storeState.currentTree.version);
        mergeDepsIntoGraph(key, deps, currentGraph, graph);
    }
    if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
        var _storeState$nextTree2;
        const nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;
        if (nextVersion !== undefined) {
            const nextGraph = store.getGraph(nextVersion);
            mergeDepsIntoGraph(key, deps, nextGraph, graph);
        }
    }
}
var Recoil_Graph = {
    cloneGraph,
    graph: makeGraph,
    saveDepsToStore
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ let nextTreeStateVersion = 0;
const getNextTreeStateVersion = ()=>nextTreeStateVersion++;
let nextStoreID = 0;
const getNextStoreID = ()=>nextStoreID++;
let nextComponentID = 0;
const getNextComponentID = ()=>nextComponentID++;
var Recoil_Keys = {
    getNextTreeStateVersion,
    getNextStoreID,
    getNextComponentID
};
const { persistentMap: persistentMap$1 } = Recoil_PersistentMap$1;
const { graph } = Recoil_Graph;
const { getNextTreeStateVersion: getNextTreeStateVersion$1 } = Recoil_Keys;
function makeEmptyTreeState() {
    const version = getNextTreeStateVersion$1();
    return {
        version,
        stateID: version,
        transactionMetadata: {},
        dirtyAtoms: new Set(),
        atomValues: persistentMap$1(),
        nonvalidatedAtoms: persistentMap$1()
    };
}
function makeEmptyStoreState() {
    const currentTree = makeEmptyTreeState();
    return {
        currentTree,
        nextTree: null,
        previousTree: null,
        commitDepth: 0,
        knownAtoms: new Set(),
        knownSelectors: new Set(),
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(currentTree.version, graph()),
        retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set()
        },
        nodeCleanupFunctions: new Map()
    };
}
var Recoil_State = {
    makeEmptyTreeState,
    makeEmptyStoreState,
    getNextTreeStateVersion: getNextTreeStateVersion$1
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class RetentionZone {
}
function retentionZone() {
    return new RetentionZone();
}
var Recoil_RetentionZone = {
    RetentionZone,
    retentionZone
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Utilities for working with built-in Maps and Sets without mutating them.
 *
 * 
 * @format
 * @oncall recoil
 */ function setByAddingToSet(set, v) {
    const next = new Set(set);
    next.add(v);
    return next;
}
function setByDeletingFromSet(set, v) {
    const next = new Set(set);
    next.delete(v);
    return next;
}
function mapBySettingInMap(map, k, v) {
    const next = new Map(map);
    next.set(k, v);
    return next;
}
function mapByUpdatingInMap(map, k, updater) {
    const next = new Map(map);
    next.set(k, updater(next.get(k)));
    return next;
}
function mapByDeletingFromMap(map, k) {
    const next = new Map(map);
    next.delete(k);
    return next;
}
function mapByDeletingMultipleFromMap(map, ks) {
    const next = new Map(map);
    ks.forEach((k)=>next.delete(k));
    return next;
}
var Recoil_CopyOnWrite = {
    setByAddingToSet,
    setByDeletingFromSet,
    mapBySettingInMap,
    mapByUpdatingInMap,
    mapByDeletingFromMap,
    mapByDeletingMultipleFromMap
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the filter function.
 */ function* filterIterable(iterable, predicate) {
    // Use generator to create iterable/iterator
    let index = 0;
    for (const value of iterable)if (predicate(value, index++)) yield value;
}
var Recoil_filterIterable = filterIterable;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Return a proxy object based on the provided base and factories objects.
 * The proxy will include all properties of the base object as-is.
 * The factories object contains callbacks to obtain the values of the properies
 * for its keys.
 *
 * This is useful for providing users an object where some properties may be
 * lazily computed only on first access.
 */ // $FlowIssue[unclear-type]
function lazyProxy(base, factories) {
    const proxy = new Proxy(base, {
        // Compute and cache lazy property if not already done.
        get: (target, prop)=>{
            if (!(prop in target) && prop in factories) target[prop] = factories[prop]();
            return target[prop];
        },
        // This method allows user to iterate keys as normal
        ownKeys: (target)=>{
            return Object.keys(target);
        }
    }); // $FlowIssue[incompatible-return]
    return proxy;
}
var Recoil_lazyProxy = lazyProxy;
const { getNode: getNode$1, getNodeMaybe: getNodeMaybe$1, recoilValuesForKeys: recoilValuesForKeys$1 } = Recoil_Node;
const { RetentionZone: RetentionZone$1 } = Recoil_RetentionZone;
const { setByAddingToSet: setByAddingToSet$1 } = Recoil_CopyOnWrite;
// flowlint-next-line unclear-type:off
const emptySet = Object.freeze(new Set());
class ReadOnlyRecoilValueError extends Error {
}
function initializeRetentionForNode(store, nodeKey, retainedBy) {
    if (!Recoil_gkx("recoil_memory_managament_2020")) return ()=>undefined;
    const { nodesRetainedByZone } = store.getState().retention;
    function addToZone(zone) {
        let set = nodesRetainedByZone.get(zone);
        if (!set) nodesRetainedByZone.set(zone, set = new Set());
        set.add(nodeKey);
    }
    if (retainedBy instanceof RetentionZone$1) addToZone(retainedBy);
    else if (Array.isArray(retainedBy)) for (const zone of retainedBy)addToZone(zone);
    return ()=>{
        if (!Recoil_gkx("recoil_memory_managament_2020")) return;
        const { retention } = store.getState();
        function deleteFromZone(zone) {
            const set = retention.nodesRetainedByZone.get(zone);
            set === null || set === void 0 || set.delete(nodeKey);
            if (set && set.size === 0) retention.nodesRetainedByZone.delete(zone);
        }
        if (retainedBy instanceof RetentionZone$1) deleteFromZone(retainedBy);
        else if (Array.isArray(retainedBy)) for (const zone of retainedBy)deleteFromZone(zone);
    };
}
function initializeNodeIfNewToStore(store, treeState, key, trigger) {
    const storeState = store.getState();
    if (storeState.nodeCleanupFunctions.has(key)) return;
    const node = getNode$1(key);
    const retentionCleanup = initializeRetentionForNode(store, key, node.retainedBy);
    const nodeCleanup = node.init(store, treeState, trigger);
    storeState.nodeCleanupFunctions.set(key, ()=>{
        nodeCleanup();
        retentionCleanup();
    });
}
function initializeNode(store, key, trigger) {
    initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}
function cleanUpNode(store, key) {
    var _state$nodeCleanupFun;
    const state = store.getState();
    (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 || _state$nodeCleanupFun();
    state.nodeCleanupFunctions.delete(key);
} // Get the current value loadable of a node and update the state.
// Update dependencies and subscriptions for selectors.
// Update saved value validation for atoms.
function getNodeLoadable(store, state, key) {
    initializeNodeIfNewToStore(store, state, key, "get");
    return getNode$1(key).get(store, state);
} // Peek at the current value loadable for a node without any evaluation or state change
function peekNodeLoadable(store, state, key) {
    return getNode$1(key).peek(store, state);
} // Write value directly to state bypassing the Node interface as the node
// definitions may not have been loaded yet when processing the initial snapshot.
function setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
    var _node$invalidate;
    const node = getNodeMaybe$1(key);
    node === null || node === void 0 || (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 || _node$invalidate.call(node, state);
    return {
        ...state,
        atomValues: state.atomValues.clone().delete(key),
        nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
        dirtyAtoms: setByAddingToSet$1(state.dirtyAtoms, key)
    };
} // Return the discovered dependencies and values to be written by setting
// a node value. (Multiple values may be written due to selectors getting to
// set upstreams; deps may be discovered because of reads in updater functions.)
function setNodeValue(store, state, key, newValue) {
    const node = getNode$1(key);
    if (node.set == null) throw new ReadOnlyRecoilValueError(`Attempt to set read-only RecoilValue: ${key}`);
    const set = node.set; // so flow doesn't lose the above refinement.
    initializeNodeIfNewToStore(store, state, key, "set");
    return set(store, state, newValue);
}
function peekNodeInfo(store, state, key) {
    const storeState = store.getState();
    const graph = store.getGraph(state.version);
    const type = getNode$1(key).nodeType;
    return Recoil_lazyProxy({
        type
    }, {
        // $FlowFixMe[underconstrained-implicit-instantiation]
        loadable: ()=>peekNodeLoadable(store, state, key),
        isActive: ()=>storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key),
        isSet: ()=>type === "selector" ? false : state.atomValues.has(key),
        isModified: ()=>state.dirtyAtoms.has(key),
        // Report current dependencies.  If the node hasn't been evaluated, then
        // dependencies may be missing based on the current state.
        deps: ()=>{
            var _graph$nodeDeps$get;
            return recoilValuesForKeys$1((_graph$nodeDeps$get = graph.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
        },
        // Reports all "current" subscribers.  Evaluating other nodes or
        // previous in-progress async evaluations may introduce new subscribers.
        subscribers: ()=>{
            var _storeState$nodeToCom, _storeState$nodeToCom2;
            return {
                nodes: recoilValuesForKeys$1(Recoil_filterIterable(getDownstreamNodes(store, state, new Set([
                    key
                ])), (nodeKey)=>nodeKey !== key)),
                components: Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], ([name])=>({
                        name
                    }))
            };
        }
    });
} // Find all of the recursively dependent nodes
function getDownstreamNodes(store, state, keys) {
    const visitedNodes = new Set();
    const visitingNodes = Array.from(keys);
    const graph = store.getGraph(state.version);
    for(let key = visitingNodes.pop(); key; key = visitingNodes.pop()){
        var _graph$nodeToNodeSubs;
        visitedNodes.add(key);
        const subscribedNodes = (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : emptySet;
        for (const downstreamNode of subscribedNodes)if (!visitedNodes.has(downstreamNode)) visitingNodes.push(downstreamNode);
    }
    return visitedNodes;
}
var Recoil_FunctionalCore = {
    getNodeLoadable,
    peekNodeLoadable,
    setNodeValue,
    initializeNode,
    cleanUpNode,
    setUnvalidatedAtomValue_DEPRECATED,
    peekNodeInfo,
    getDownstreamNodes
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ let _invalidateMemoizedSnapshot = null;
function setInvalidateMemoizedSnapshot(invalidate) {
    _invalidateMemoizedSnapshot = invalidate;
}
function invalidateMemoizedSnapshot() {
    var _invalidateMemoizedSn;
    (_invalidateMemoizedSn = _invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 || _invalidateMemoizedSn();
}
var Recoil_SnapshotCache = {
    setInvalidateMemoizedSnapshot,
    invalidateMemoizedSnapshot
};
const { getDownstreamNodes: getDownstreamNodes$1, getNodeLoadable: getNodeLoadable$1, setNodeValue: setNodeValue$1 } = Recoil_FunctionalCore;
const { getNextComponentID: getNextComponentID$1 } = Recoil_Keys;
const { getNode: getNode$2, getNodeMaybe: getNodeMaybe$2 } = Recoil_Node;
const { DefaultValue: DefaultValue$1 } = Recoil_Node;
const { reactMode: reactMode$1 } = Recoil_ReactMode;
const { AbstractRecoilValue: AbstractRecoilValue$1, RecoilState: RecoilState$1, RecoilValueReadOnly: RecoilValueReadOnly$1, isRecoilValue: isRecoilValue$1 } = Recoil_RecoilValue$1;
const { invalidateMemoizedSnapshot: invalidateMemoizedSnapshot$1 } = Recoil_SnapshotCache;
function getRecoilValueAsLoadable(store, { key }, treeState = store.getState().currentTree) {
    var _storeState$nextTree, _storeState$previousT;
    // Reading from an older tree can cause bugs because the dependencies that we
    // discover during the read are lost.
    const storeState = store.getState();
    if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) Recoil_recoverableViolation("Tried to read from a discarded tree");
    const loadable = getNodeLoadable$1(store, treeState, key);
    if (loadable.state === "loading") loadable.contents.catch(()=>{
        /**
       * HACK: intercept thrown error here to prevent an uncaught promise exception. Ideally this would happen closer to selector
       * execution (perhaps introducing a new ERROR class to be resolved by async selectors that are in an error state)
       */ return;
    });
    return loadable;
}
function applyAtomValueWrites(atomValues, writes) {
    const result = atomValues.clone();
    writes.forEach((v, k)=>{
        if (v.state === "hasValue" && v.contents instanceof DefaultValue$1) result.delete(k);
        else result.set(k, v);
    });
    return result;
}
function valueFromValueOrUpdater(store, state, { key }, valueOrUpdater) {
    if (typeof valueOrUpdater === "function") {
        // Updater form: pass in the current value. Throw if the current value
        // is unavailable (namely when updating an async selector that's
        // pending or errored):
        const current = getNodeLoadable$1(store, state, key);
        if (current.state === "loading") {
            const msg = `Tried to set atom or selector "${key}" using an updater function while the current state is pending, this is not currently supported.`;
            Recoil_recoverableViolation(msg);
            throw Recoil_err(msg);
        } else if (current.state === "hasError") throw current.contents;
         // T itself may be a function, so our refinement is not sufficient:
        return valueOrUpdater(current.contents); // flowlint-line unclear-type:off
    } else return valueOrUpdater;
}
function applyAction(store, state, action) {
    if (action.type === "set") {
        const { recoilValue, valueOrUpdater } = action;
        const newValue = valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
        const writes = setNodeValue$1(store, state, recoilValue.key, newValue);
        for (const [key, loadable] of writes.entries())writeLoadableToTreeState(state, key, loadable);
    } else if (action.type === "setLoadable") {
        const { recoilValue: { key }, loadable } = action;
        writeLoadableToTreeState(state, key, loadable);
    } else if (action.type === "markModified") {
        const { recoilValue: { key } } = action;
        state.dirtyAtoms.add(key);
    } else if (action.type === "setUnvalidated") {
        var _node$invalidate;
        // Write value directly to state bypassing the Node interface as the node
        // definitions may not have been loaded yet when processing the initial snapshot.
        const { recoilValue: { key }, unvalidatedValue } = action;
        const node = getNodeMaybe$2(key);
        node === null || node === void 0 || (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 || _node$invalidate.call(node, state);
        state.atomValues.delete(key);
        state.nonvalidatedAtoms.set(key, unvalidatedValue);
        state.dirtyAtoms.add(key);
    } else Recoil_recoverableViolation(`Unknown action ${action.type}`);
}
function writeLoadableToTreeState(state, key, loadable) {
    if (loadable.state === "hasValue" && loadable.contents instanceof DefaultValue$1) state.atomValues.delete(key);
    else state.atomValues.set(key, loadable);
    state.dirtyAtoms.add(key);
    state.nonvalidatedAtoms.delete(key);
}
function applyActionsToStore(store, actions) {
    store.replaceState((state)=>{
        const newState = copyTreeState(state);
        for (const action of actions)applyAction(store, newState, action);
        invalidateDownstreams(store, newState);
        invalidateMemoizedSnapshot$1();
        return newState;
    });
}
function queueOrPerformStateUpdate(store, action) {
    if (batchStack.length) {
        const actionsByStore = batchStack[batchStack.length - 1];
        let actions = actionsByStore.get(store);
        if (!actions) actionsByStore.set(store, actions = []);
        actions.push(action);
    } else applyActionsToStore(store, [
        action
    ]);
}
const batchStack = [];
function batchStart() {
    const actionsByStore = new Map();
    batchStack.push(actionsByStore);
    return ()=>{
        for (const [store, actions] of actionsByStore)applyActionsToStore(store, actions);
        const popped = batchStack.pop();
        if (popped !== actionsByStore) Recoil_recoverableViolation("Incorrect order of batch popping");
    };
}
function copyTreeState(state) {
    return {
        ...state,
        atomValues: state.atomValues.clone(),
        nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
        dirtyAtoms: new Set(state.dirtyAtoms)
    };
}
function invalidateDownstreams(store, state) {
    // Inform any nodes that were changed or downstream of changes so that they
    // can clear out any caches as needed due to the update:
    const downstreams = getDownstreamNodes$1(store, state, state.dirtyAtoms);
    for (const key of downstreams){
        var _getNodeMaybe, _getNodeMaybe$invalid;
        (_getNodeMaybe = getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 || (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 || _getNodeMaybe$invalid.call(_getNodeMaybe, state);
    }
}
function setRecoilValue(store, recoilValue, valueOrUpdater) {
    queueOrPerformStateUpdate(store, {
        type: "set",
        recoilValue,
        valueOrUpdater
    });
}
function setRecoilValueLoadable(store, recoilValue, loadable) {
    if (loadable instanceof DefaultValue$1) return setRecoilValue(store, recoilValue, loadable);
    queueOrPerformStateUpdate(store, {
        type: "setLoadable",
        recoilValue,
        loadable: loadable
    });
}
function markRecoilValueModified(store, recoilValue) {
    queueOrPerformStateUpdate(store, {
        type: "markModified",
        recoilValue
    });
}
function setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
    queueOrPerformStateUpdate(store, {
        type: "setUnvalidated",
        recoilValue,
        unvalidatedValue
    });
}
function subscribeToRecoilValue(store, { key }, callback, componentDebugName = null) {
    const subID = getNextComponentID$1();
    const storeState = store.getState();
    if (!storeState.nodeToComponentSubscriptions.has(key)) storeState.nodeToComponentSubscriptions.set(key, new Map());
    Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [
        componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : "<not captured>",
        callback
    ]); // Handle the case that, during the same tick that we are subscribing, an atom
    // has been updated by some effect handler. Otherwise we will miss the update.
    const mode = reactMode$1();
    if (mode.early && (mode.mode === "LEGACY" || mode.mode === "MUTABLE_SOURCE")) {
        const nextTree = store.getState().nextTree;
        if (nextTree && nextTree.dirtyAtoms.has(key)) callback(nextTree);
    }
    return {
        release: ()=>{
            const releaseStoreState = store.getState();
            const subs = releaseStoreState.nodeToComponentSubscriptions.get(key);
            if (subs === undefined || !subs.has(subID)) {
                Recoil_recoverableViolation(`Subscription missing at release time for atom ${key}. This is a bug in Recoil.`);
                return;
            }
            subs.delete(subID);
            if (subs.size === 0) releaseStoreState.nodeToComponentSubscriptions.delete(key);
        }
    };
}
function refreshRecoilValue(store, recoilValue) {
    var _node$clearCache;
    const { currentTree } = store.getState();
    const node = getNode$2(recoilValue.key);
    (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 || _node$clearCache.call(node, store, currentTree);
}
var Recoil_RecoilValueInterface = {
    RecoilValueReadOnly: RecoilValueReadOnly$1,
    AbstractRecoilValue: AbstractRecoilValue$1,
    RecoilState: RecoilState$1,
    getRecoilValueAsLoadable,
    setRecoilValue,
    setRecoilValueLoadable,
    markRecoilValueModified,
    setUnvalidatedRecoilValue,
    subscribeToRecoilValue,
    isRecoilValue: isRecoilValue$1,
    applyAtomValueWrites,
    // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
    batchStart,
    writeLoadableToTreeState,
    invalidateDownstreams,
    copyTreeState,
    refreshRecoilValue
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * The someSet() method tests whether some elements in the given Set pass the
 * test implemented by the provided function.
 */ function someSet(set, callback, context) {
    const iterator = set.entries();
    let current = iterator.next();
    while(!current.done){
        const entry = current.value;
        if (callback.call(context, entry[1], entry[0], set)) return true;
        current = iterator.next();
    }
    return false;
}
var Recoil_someSet = someSet;
const { cleanUpNode: cleanUpNode$1 } = Recoil_FunctionalCore;
const { deleteNodeConfigIfPossible: deleteNodeConfigIfPossible$1, getNode: getNode$3 } = Recoil_Node;
const { RetentionZone: RetentionZone$2 } = Recoil_RetentionZone;
// Components that aren't mounted after suspending for this long will be assumed
// to be discarded and their resources released.
const SUSPENSE_TIMEOUT_MS = 120000;
const emptySet$1 = new Set();
function releaseRetainablesNowOnCurrentTree(store, retainables) {
    const storeState = store.getState();
    const treeState = storeState.currentTree;
    if (storeState.nextTree) {
        Recoil_recoverableViolation("releaseNodesNowOnCurrentTree should only be called at the end of a batch");
        return; // leak memory rather than erase something that's about to be used.
    }
    const nodes = new Set();
    for (const r of retainables){
        if (r instanceof RetentionZone$2) for (const n of nodesRetainedByZone(storeState, r))nodes.add(n);
        else nodes.add(r);
    }
    const releasableNodes = findReleasableNodes(store, nodes);
    for (const node of releasableNodes)releaseNode(store, treeState, node);
}
function findReleasableNodes(store, searchFromNodes) {
    const storeState = store.getState();
    const treeState = storeState.currentTree;
    const graph = store.getGraph(treeState.version);
    const releasableNodes = new Set(); // mutated to collect answer
    const nonReleasableNodes = new Set();
    findReleasableNodesInner(searchFromNodes);
    return releasableNodes;
    function findReleasableNodesInner(searchFromNodes) {
        const releasableNodesFoundThisIteration = new Set();
        const downstreams = getDownstreamNodesInTopologicalOrder(store, treeState, searchFromNodes, releasableNodes, nonReleasableNodes // don't descend into these
        ); // Find which of the downstream nodes are releasable and which are not:
        for (const node of downstreams){
            var _storeState$retention;
            // Not releasable if configured to be retained forever:
            if (getNode$3(node).retainedBy === "recoilRoot") {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if retained directly by a component:
            if (((_storeState$retention = storeState.retention.referenceCounts.get(node)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if retained by a zone:
            if (zonesThatCouldRetainNode(node).some((z)=>storeState.retention.referenceCounts.get(z))) {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if it has a non-releasable child (which will already be in
            // nonReleasableNodes because we are going in topological order):
            const nodeChildren = graph.nodeToNodeSubscriptions.get(node);
            if (nodeChildren && Recoil_someSet(nodeChildren, (child)=>nonReleasableNodes.has(child))) {
                nonReleasableNodes.add(node);
                continue;
            }
            releasableNodes.add(node);
            releasableNodesFoundThisIteration.add(node);
        } // If we found any releasable nodes, we need to walk UP from those nodes to
        // find whether their parents can now be released as well:
        const parents = new Set();
        for (const node of releasableNodesFoundThisIteration)for (const parent of (_graph$nodeDeps$get = graph.nodeDeps.get(node)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : emptySet$1){
            var _graph$nodeDeps$get;
            if (!releasableNodes.has(parent)) parents.add(parent);
        }
        if (parents.size) findReleasableNodesInner(parents);
    }
} // Children before parents
function getDownstreamNodesInTopologicalOrder(store, treeState, nodes, doNotDescendInto1, doNotDescendInto2) {
    const graph = store.getGraph(treeState.version);
    const answer = [];
    const visited = new Set();
    while(nodes.size > 0)visit(Recoil_nullthrows(nodes.values().next().value));
    return answer;
    function visit(node) {
        if (doNotDescendInto1.has(node) || doNotDescendInto2.has(node)) {
            nodes.delete(node);
            return;
        }
        if (visited.has(node)) return;
        const children = graph.nodeToNodeSubscriptions.get(node);
        if (children) for (const child of children)visit(child);
        visited.add(node);
        nodes.delete(node);
        answer.push(node);
    }
}
function releaseNode(store, treeState, node) {
    if (!Recoil_gkx("recoil_memory_managament_2020")) return;
     // Atom effects, in-closure caches, etc.:
    cleanUpNode$1(store, node); // Delete from store state:
    const storeState = store.getState();
    storeState.knownAtoms.delete(node);
    storeState.knownSelectors.delete(node);
    storeState.nodeTransactionSubscriptions.delete(node);
    storeState.retention.referenceCounts.delete(node);
    const zones = zonesThatCouldRetainNode(node);
    for (const zone of zones){
        var _storeState$retention2;
        (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 || _storeState$retention2.delete(node);
    } // Note that we DO NOT delete from nodeToComponentSubscriptions because this
    // already happens when the last component that was retaining the node unmounts,
    // and this could happen either before or after that.
    // Delete from TreeState and dep graph:
    treeState.atomValues.delete(node);
    treeState.dirtyAtoms.delete(node);
    treeState.nonvalidatedAtoms.delete(node);
    const graph = storeState.graphsByVersion.get(treeState.version);
    if (graph) {
        const deps = graph.nodeDeps.get(node);
        if (deps !== undefined) {
            graph.nodeDeps.delete(node);
            for (const dep of deps){
                var _graph$nodeToNodeSubs;
                (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 || _graph$nodeToNodeSubs.delete(node);
            }
        } // No need to delete sub's deps as there should be no subs at this point.
        // But an invariant would require deleting nodes in topological order.
        graph.nodeToNodeSubscriptions.delete(node);
    } // Node config (for family members only as their configs can be recreated, and
    // only if they are not retained within any other Stores):
    deleteNodeConfigIfPossible$1(node);
}
function nodesRetainedByZone(storeState, zone) {
    var _storeState$retention3;
    return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : emptySet$1;
}
function zonesThatCouldRetainNode(node) {
    const retainedBy = getNode$3(node).retainedBy;
    if (retainedBy === undefined || retainedBy === "components" || retainedBy === "recoilRoot") return [];
    else if (retainedBy instanceof RetentionZone$2) return [
        retainedBy
    ];
    else return retainedBy; // it's an array of zones
}
function scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
    const state = store.getState();
    if (state.nextTree) state.retention.retainablesToCheckForRelease.add(retainable);
    else releaseRetainablesNowOnCurrentTree(store, new Set([
        retainable
    ]));
}
function updateRetainCount(store, retainable, delta) {
    var _map$get;
    if (!Recoil_gkx("recoil_memory_managament_2020")) return;
    const map = store.getState().retention.referenceCounts;
    const newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;
    if (newCount === 0) updateRetainCountToZero(store, retainable);
    else map.set(retainable, newCount);
}
function updateRetainCountToZero(store, retainable) {
    if (!Recoil_gkx("recoil_memory_managament_2020")) return;
    const map = store.getState().retention.referenceCounts;
    map.delete(retainable);
    scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}
function releaseScheduledRetainablesNow(store) {
    if (!Recoil_gkx("recoil_memory_managament_2020")) return;
    const state = store.getState();
    releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
    state.retention.retainablesToCheckForRelease.clear();
}
function retainedByOptionWithDefault(r) {
    // The default will change from 'recoilRoot' to 'components' in the future.
    return r === undefined ? "recoilRoot" : r;
}
var Recoil_Retention = {
    SUSPENSE_TIMEOUT_MS,
    updateRetainCount,
    updateRetainCountToZero,
    releaseScheduledRetainablesNow,
    retainedByOptionWithDefault
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */ const { unstable_batchedUpdates } = (0, _reactDomDefault.default);
var ReactBatchedUpdates = {
    unstable_batchedUpdates
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */ // @fb-only: const {unstable_batchedUpdates} = require('ReactDOMComet');
// prettier-ignore
const { unstable_batchedUpdates: unstable_batchedUpdates$1 } = ReactBatchedUpdates; // @oss-only
var Recoil_ReactBatchedUpdates = {
    unstable_batchedUpdates: unstable_batchedUpdates$1
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ const { batchStart: batchStart$1 } = Recoil_RecoilValueInterface;
const { unstable_batchedUpdates: unstable_batchedUpdates$2 } = Recoil_ReactBatchedUpdates; // flowlint-next-line unclear-type:off
/*
 * During SSR, unstable_batchedUpdates may be undefined so this
 * falls back to a basic function that executes the batch
 */ let batcher = unstable_batchedUpdates$2 || ((batchFn)=>batchFn());
/**
 * Sets the provided batcher function as the batcher function used by Recoil.
 *
 * Set the batcher to a custom batcher for your renderer,
 * if you use a renderer other than React DOM or React Native.
 */ const setBatcher = (newBatcher)=>{
    batcher = newBatcher;
};
/**
 * Returns the current batcher function.
 */ const getBatcher = ()=>batcher;
/**
 * Calls the current batcher function and passes the
 * provided callback function.
 */ const batchUpdates = (callback)=>{
    batcher(()=>{
        let batchEnd = ()=>undefined;
        try {
            batchEnd = batchStart$1();
            callback();
        } finally{
            batchEnd();
        }
    });
};
var Recoil_Batching = {
    getBatcher,
    setBatcher,
    batchUpdates
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Combines multiple Iterables into a single Iterable.
 * Traverses the input Iterables in the order provided and maintains the order
 * of their elements.
 *
 * Example:
 * ```
 * const r = Array.from(concatIterables(['a', 'b'], ['c'], ['d', 'e', 'f']));
 * r == ['a', 'b', 'c', 'd', 'e', 'f'];
 * ```
 */ function* concatIterables(iters) {
    for (const iter of iters)for (const val of iter)yield val;
}
var Recoil_concatIterables = concatIterables;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /* eslint-disable fb-www/typeof-undefined */ const isSSR = typeof Window === "undefined" || typeof window === "undefined";
/* eslint-enable fb-www/typeof-undefined */ const isWindow = (value)=>!isSSR && (value === window || value instanceof Window);
const isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative"; // eslint-disable-line fb-www/typeof-undefined
var Recoil_Environment = {
    isSSR,
    isReactNative,
    isWindow
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Caches a function's results based on the key returned by the passed
 * hashFunction.
 */ function memoizeWithArgsHash(fn, hashFunction) {
    let cache;
    return (...args)=>{
        if (!cache) cache = {};
        const key = hashFunction(...args);
        if (!Object.hasOwnProperty.call(cache, key)) cache[key] = fn(...args);
        return cache[key];
    };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */ function memoizeOneWithArgsHash(fn, hashFunction) {
    let lastKey;
    let lastResult; // breaking cache when arguments change
    return (...args)=>{
        const key = hashFunction(...args);
        if (lastKey === key) return lastResult;
        lastKey = key;
        lastResult = fn(...args);
        return lastResult;
    };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */ function memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
    let lastKey;
    let lastResult; // breaking cache when arguments change
    const memoizedFn = (...args)=>{
        const key = hashFunction(...args);
        if (lastKey === key) return lastResult;
        lastKey = key;
        lastResult = fn(...args);
        return lastResult;
    };
    const invalidate = ()=>{
        lastKey = null;
    };
    return [
        memoizedFn,
        invalidate
    ];
}
var Recoil_Memoize = {
    memoizeWithArgsHash,
    memoizeOneWithArgsHash,
    memoizeOneWithArgsHashAndInvalidation
};
const { batchUpdates: batchUpdates$1 } = Recoil_Batching;
const { initializeNode: initializeNode$1, peekNodeInfo: peekNodeInfo$1 } = Recoil_FunctionalCore;
const { graph: graph$1 } = Recoil_Graph;
const { getNextStoreID: getNextStoreID$1 } = Recoil_Keys;
const { DEFAULT_VALUE: DEFAULT_VALUE$1, recoilValues: recoilValues$1, recoilValuesForKeys: recoilValuesForKeys$2 } = Recoil_Node;
const { AbstractRecoilValue: AbstractRecoilValue$2, getRecoilValueAsLoadable: getRecoilValueAsLoadable$1, setRecoilValue: setRecoilValue$1, setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$1 } = Recoil_RecoilValueInterface;
const { updateRetainCount: updateRetainCount$1 } = Recoil_Retention;
const { setInvalidateMemoizedSnapshot: setInvalidateMemoizedSnapshot$1 } = Recoil_SnapshotCache;
const { getNextTreeStateVersion: getNextTreeStateVersion$2, makeEmptyStoreState: makeEmptyStoreState$1 } = Recoil_State;
const { isSSR: isSSR$1 } = Recoil_Environment;
const { memoizeOneWithArgsHashAndInvalidation: memoizeOneWithArgsHashAndInvalidation$1 } = Recoil_Memoize;
// Opaque at this surface because it's part of the public API from here.
const retainWarning = `
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`; // A "Snapshot" is "read-only" and captures a specific set of values of atoms.
// However, the data-flow-graph and selector values may evolve as selector
// evaluation functions are executed and async selectors resolve.
class Snapshot {
    // eslint-disable-next-line fb-www/no-uninitialized-properties
    constructor(storeState, parentStoreID){
        _defineProperty(this, "_store", void 0);
        _defineProperty(this, "_refCount", 1);
        _defineProperty(this, "getLoadable", (recoilValue)=>{
            this.checkRefCount_INTERNAL();
            return getRecoilValueAsLoadable$1(this._store, recoilValue);
        });
        _defineProperty(this, "getPromise", (recoilValue)=>{
            this.checkRefCount_INTERNAL();
            return this.getLoadable(recoilValue).toPromise();
        });
        _defineProperty(this, "getNodes_UNSTABLE", (opt)=>{
            this.checkRefCount_INTERNAL(); // TODO Deal with modified selectors
            if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
                if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) return [];
                const state = this._store.getState().currentTree;
                return recoilValuesForKeys$2(state.dirtyAtoms);
            }
            const knownAtoms = this._store.getState().knownAtoms;
            const knownSelectors = this._store.getState().knownSelectors;
            return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? recoilValues$1.values() : opt.isInitialized === true ? recoilValuesForKeys$2(Recoil_concatIterables([
                knownAtoms,
                knownSelectors
            ])) : Recoil_filterIterable(recoilValues$1.values(), ({ key })=>!knownAtoms.has(key) && !knownSelectors.has(key));
        });
        _defineProperty(this, "getInfo_UNSTABLE", ({ key })=>{
            this.checkRefCount_INTERNAL();
            return peekNodeInfo$1(this._store, this._store.getState().currentTree, key);
        });
        _defineProperty(this, "map", (mapper)=>{
            this.checkRefCount_INTERNAL();
            const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
            mapper(mutableSnapshot); // if removing batchUpdates from `set` add it here
            return mutableSnapshot;
        });
        _defineProperty(this, "asyncMap", async (mapper)=>{
            this.checkRefCount_INTERNAL();
            const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
            mutableSnapshot.retain(); // Retain new snapshot during async mapper
            await mapper(mutableSnapshot); // Continue to retain the new snapshot for the user, but auto-release it
            // after the next tick, the same as a new synchronous snapshot.
            mutableSnapshot.autoRelease_INTERNAL();
            return mutableSnapshot;
        });
        this._store = {
            storeID: getNextStoreID$1(),
            parentStoreID,
            getState: ()=>storeState,
            replaceState: (replacer)=>{
                // no batching, so nextTree is never active
                storeState.currentTree = replacer(storeState.currentTree);
            },
            getGraph: (version)=>{
                const graphs = storeState.graphsByVersion;
                if (graphs.has(version)) return Recoil_nullthrows(graphs.get(version));
                const newGraph = graph$1();
                graphs.set(version, newGraph);
                return newGraph;
            },
            subscribeToTransactions: ()=>({
                    release: ()=>{}
                }),
            addTransactionMetadata: ()=>{
                throw Recoil_err("Cannot subscribe to Snapshots");
            }
        }; // Initialize any nodes that are live in the parent store (primarily so that
        // this snapshot gets counted towards the node's live stores count).
        // TODO Optimize this when cloning snapshots for callbacks
        for (const nodeKey of this._store.getState().knownAtoms){
            initializeNode$1(this._store, nodeKey, "get");
            updateRetainCount$1(this._store, nodeKey, 1);
        }
        this.autoRelease_INTERNAL();
    }
    retain() {
        if (this._refCount <= 0) Recoil_recoverableViolation("Attempt to retain() Snapshot that was already released.");
        this._refCount++;
        let released = false;
        return ()=>{
            if (!released) {
                released = true;
                this._release();
            }
        };
    }
    /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */ autoRelease_INTERNAL() {
        if (!isSSR$1) // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
        window.setTimeout(()=>this._release(), 10);
    }
    _release() {
        this._refCount--;
        if (this._refCount === 0) {
            this._store.getState().nodeCleanupFunctions.forEach((cleanup)=>cleanup());
            this._store.getState().nodeCleanupFunctions.clear();
            if (!Recoil_gkx("recoil_memory_managament_2020")) return;
             // Temporarily nerfing this to allow us to find broken call sites without
        // actually breaking anybody yet.
        // for (const k of this._store.getState().knownAtoms) {
        //   updateRetainCountToZero(this._store, k);
        // }
        } else this._refCount;
    }
    isRetained() {
        return this._refCount > 0;
    }
    checkRefCount_INTERNAL() {
        Recoil_gkx("recoil_memory_managament_2020") && this._refCount;
    }
    getStore_INTERNAL() {
        this.checkRefCount_INTERNAL();
        return this._store;
    }
    getID() {
        this.checkRefCount_INTERNAL();
        return this._store.getState().currentTree.stateID;
    }
    getStoreID() {
        this.checkRefCount_INTERNAL();
        return this._store.storeID;
    }
}
function cloneStoreState(store, treeState, bumpVersion = false) {
    const storeState = store.getState();
    const version = bumpVersion ? getNextTreeStateVersion$2() : treeState.version;
    return {
        // Always clone the TreeState to isolate stores from accidental mutations.
        // For example, reading a selector from a cloned snapshot shouldn't cache
        // in the original treestate which may cause the original to skip
        // initialization of upstream atoms.
        currentTree: {
            // TODO snapshots shouldn't really have versions because a new version number
            // is always assigned when the snapshot is gone to.
            version: bumpVersion ? version : treeState.version,
            stateID: bumpVersion ? version : treeState.stateID,
            transactionMetadata: {
                ...treeState.transactionMetadata
            },
            dirtyAtoms: new Set(treeState.dirtyAtoms),
            atomValues: treeState.atomValues.clone(),
            nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
        },
        commitDepth: 0,
        nextTree: null,
        previousTree: null,
        knownAtoms: new Set(storeState.knownAtoms),
        // FIXME here's a copy
        knownSelectors: new Set(storeState.knownSelectors),
        // FIXME here's a copy
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(version, store.getGraph(treeState.version)),
        retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set()
        },
        // FIXME here's a copy
        // Create blank cleanup handlers for atoms so snapshots don't re-run
        // atom effects.
        nodeCleanupFunctions: new Map(Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), ([key])=>[
                key,
                ()=>{}
            ]))
    };
} // Factory to build a fresh snapshot
function freshSnapshot(initializeState) {
    const snapshot = new Snapshot(makeEmptyStoreState$1());
    return initializeState != null ? snapshot.map(initializeState) : snapshot;
} // Factory to clone a snapshot state
const [memoizedCloneSnapshot, invalidateMemoizedSnapshot$2] = memoizeOneWithArgsHashAndInvalidation$1((store, version)=>{
    var _storeState$nextTree;
    const storeState = store.getState();
    const treeState = version === "latest" ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : Recoil_nullthrows(storeState.previousTree);
    return new Snapshot(cloneStoreState(store, treeState), store.storeID);
}, (store, version)=>{
    var _store$getState$nextT, _store$getState$previ;
    return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
}); // Avoid circular dependencies
setInvalidateMemoizedSnapshot$1(invalidateMemoizedSnapshot$2);
function cloneSnapshot(store, version = "latest") {
    const snapshot = memoizedCloneSnapshot(store, version);
    if (!snapshot.isRetained()) {
        invalidateMemoizedSnapshot$2();
        return memoizedCloneSnapshot(store, version);
    }
    return snapshot;
}
class MutableSnapshot extends Snapshot {
    constructor(snapshot, batch){
        super(cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true), snapshot.getStoreID());
        _defineProperty(this, "_batch", void 0);
        _defineProperty(this, "set", (recoilState, newValueOrUpdater)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // This batchUpdates ensures this `set` is applied immediately and you can
            // read the written value after calling `set`. I would like to remove this
            // behavior and only batch in `Snapshot.map`, but this would be a breaking
            // change potentially.
            this._batch(()=>{
                updateRetainCount$1(store, recoilState.key, 1);
                setRecoilValue$1(this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
            });
        });
        _defineProperty(this, "reset", (recoilState)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.
            this._batch(()=>{
                updateRetainCount$1(store, recoilState.key, 1);
                setRecoilValue$1(this.getStore_INTERNAL(), recoilState, DEFAULT_VALUE$1);
            });
        });
        _defineProperty(this, "setUnvalidatedAtomValues_DEPRECATED", (values)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.
            batchUpdates$1(()=>{
                for (const [k, v] of values.entries()){
                    updateRetainCount$1(store, k, 1);
                    setUnvalidatedRecoilValue$1(store, new AbstractRecoilValue$2(k), v);
                }
            });
        });
        this._batch = batch;
    }
}
var Recoil_Snapshot = {
    Snapshot,
    MutableSnapshot,
    freshSnapshot,
    cloneSnapshot
};
var Recoil_Snapshot_1 = Recoil_Snapshot.Snapshot;
var Recoil_Snapshot_2 = Recoil_Snapshot.MutableSnapshot;
var Recoil_Snapshot_3 = Recoil_Snapshot.freshSnapshot;
var Recoil_Snapshot_4 = Recoil_Snapshot.cloneSnapshot;
var Recoil_Snapshot$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Snapshot: Recoil_Snapshot_1,
    MutableSnapshot: Recoil_Snapshot_2,
    freshSnapshot: Recoil_Snapshot_3,
    cloneSnapshot: Recoil_Snapshot_4
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function unionSets(...sets) {
    const result = new Set();
    for (const set of sets)for (const value of set)result.add(value);
    return result;
}
var Recoil_unionSets = unionSets;
const { useRef } = (0, _reactDefault.default);
/**
 * The same as `useRef()` except that if a function is specified then it will
 * call that function to get the value to initialize the reference with.
 * This is similar to how `useState()` behaves when given a function.  It allows
 * the user to avoid generating the initial value for subsequent renders.
 * The tradeoff is that to set the reference to a function itself you need to
 * nest it: useRefInitOnce(() => () => {...});
 */ function useRefInitOnce(initialValue) {
    // $FlowExpectedError[incompatible-call]
    const ref = useRef(initialValue);
    if (ref.current === initialValue && typeof initialValue === "function") // $FlowExpectedError[incompatible-use]
    ref.current = initialValue();
    return ref;
}
var Recoil_useRefInitOnce = useRefInitOnce;
// @fb-only: const RecoilusagelogEvent = require('RecoilusagelogEvent');
// @fb-only: const RecoilUsageLogFalcoEvent = require('RecoilUsageLogFalcoEvent');
// @fb-only: const URI = require('URI');
const { getNextTreeStateVersion: getNextTreeStateVersion$3, makeEmptyStoreState: makeEmptyStoreState$2 } = Recoil_State;
const { cleanUpNode: cleanUpNode$2, getDownstreamNodes: getDownstreamNodes$2, initializeNode: initializeNode$2, setNodeValue: setNodeValue$2, setUnvalidatedAtomValue_DEPRECATED: setUnvalidatedAtomValue_DEPRECATED$1 } = Recoil_FunctionalCore;
const { graph: graph$2 } = Recoil_Graph;
const { cloneGraph: cloneGraph$1 } = Recoil_Graph;
const { getNextStoreID: getNextStoreID$2 } = Recoil_Keys;
const { createMutableSource: createMutableSource$1, reactMode: reactMode$2 } = Recoil_ReactMode;
const { applyAtomValueWrites: applyAtomValueWrites$1 } = Recoil_RecoilValueInterface;
const { releaseScheduledRetainablesNow: releaseScheduledRetainablesNow$1 } = Recoil_Retention;
const { freshSnapshot: freshSnapshot$1 } = Recoil_Snapshot$1;
const { useCallback, useContext, useEffect, useMemo, useRef: useRef$1, useState } = (0, _reactDefault.default);
function notInAContext() {
    throw Recoil_err("This component must be used inside a <RecoilRoot> component.");
}
const defaultStore = Object.freeze({
    storeID: getNextStoreID$2(),
    getState: notInAContext,
    replaceState: notInAContext,
    getGraph: notInAContext,
    subscribeToTransactions: notInAContext,
    addTransactionMetadata: notInAContext
});
let stateReplacerIsBeingExecuted = false;
function startNextTreeIfNeeded(store) {
    if (stateReplacerIsBeingExecuted) throw Recoil_err("An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.");
    const storeState = store.getState();
    if (storeState.nextTree === null) {
        if (Recoil_gkx("recoil_memory_managament_2020") && Recoil_gkx("recoil_release_on_cascading_update_killswitch_2021")) // If this is a cascading update (that is, rendering due to one state change
        // invokes a second state change), we won't have cleaned up retainables yet
        // because this normally happens after notifying components. Do it before
        // proceeding with the cascading update so that it remains predictable:
        {
            if (storeState.commitDepth > 0) releaseScheduledRetainablesNow$1(store);
        }
        const version = storeState.currentTree.version;
        const nextVersion = getNextTreeStateVersion$3();
        storeState.nextTree = {
            ...storeState.currentTree,
            version: nextVersion,
            stateID: nextVersion,
            dirtyAtoms: new Set(),
            transactionMetadata: {}
        };
        storeState.graphsByVersion.set(nextVersion, cloneGraph$1(Recoil_nullthrows(storeState.graphsByVersion.get(version))));
    }
}
const AppContext = (0, _reactDefault.default).createContext({
    current: defaultStore
});
const useStoreRef = ()=>useContext(AppContext); // $FlowExpectedError[incompatible-call]
const MutableSourceContext = (0, _reactDefault.default).createContext(null);
function useRecoilMutableSource() {
    const mutableSource = useContext(MutableSourceContext);
    if (mutableSource == null) Recoil_expectationViolation("Attempted to use a Recoil hook outside of a <RecoilRoot>. <RecoilRoot> must be an ancestor of any component that uses Recoil hooks.");
    return mutableSource;
}
function notifyComponents(store, storeState, treeState) {
    const dependentNodes = getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);
    for (const key of dependentNodes){
        const comps = storeState.nodeToComponentSubscriptions.get(key);
        if (comps) for (const [_subID, [_debugName, callback]] of comps)callback(treeState);
    }
}
function sendEndOfBatchNotifications(store) {
    const storeState = store.getState();
    const treeState = storeState.currentTree; // Inform transaction subscribers of the transaction:
    const dirtyAtoms = treeState.dirtyAtoms;
    if (dirtyAtoms.size) {
        // Execute Node-specific subscribers before global subscribers
        for (const [key, subscriptions] of storeState.nodeTransactionSubscriptions){
            if (dirtyAtoms.has(key)) for (const [_, subscription] of subscriptions)subscription(store);
        }
        for (const [_, subscription] of storeState.transactionSubscriptions)subscription(store);
        if (!reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
            // Notifying components is needed to wake from suspense, even when using
            // early rendering.
            notifyComponents(store, storeState, treeState); // Wake all suspended components so the right one(s) can try to re-render.
            // We need to wake up components not just when some asynchronous selector
            // resolved, but also when changing synchronous values because this may cause
            // a selector to change from asynchronous to synchronous, in which case there
            // would be no follow-up asynchronous resolution to wake us up.
            // TODO OPTIMIZATION Only wake up related downstream components
            storeState.suspendedComponentResolvers.forEach((cb)=>cb());
            storeState.suspendedComponentResolvers.clear();
        }
    } // Special behavior ONLY invoked by useInterface.
    // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.
    storeState.queuedComponentCallbacks_DEPRECATED.forEach((cb)=>cb(treeState));
    storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}
function endBatch(store) {
    const storeState = store.getState();
    storeState.commitDepth++;
    try {
        const { nextTree } = storeState; // Ignore commits that are not because of Recoil transactions -- namely,
        // because something above RecoilRoot re-rendered:
        if (nextTree == null) return;
         // nextTree is now committed -- note that copying and reset occurs when
        // a transaction begins, in startNextTreeIfNeeded:
        storeState.previousTree = storeState.currentTree;
        storeState.currentTree = nextTree;
        storeState.nextTree = null;
        sendEndOfBatchNotifications(store);
        if (storeState.previousTree != null) storeState.graphsByVersion.delete(storeState.previousTree.version);
        else Recoil_recoverableViolation("Ended batch with no previous state, which is unexpected", "recoil");
        storeState.previousTree = null;
        if (Recoil_gkx("recoil_memory_managament_2020")) // Only release retainables if there were no writes during the end of the
        // batch.  This avoids releasing something we might be about to use.
        {
            if (nextTree == null) releaseScheduledRetainablesNow$1(store);
        }
    } finally{
        storeState.commitDepth--;
    }
}
/*
 * The purpose of the Batcher is to observe when React batches end so that
 * Recoil state changes can be batched. Whenever Recoil state changes, we call
 * setState on the batcher. Then we wait for that change to be committed, which
 * signifies the end of the batch. That's when we respond to the Recoil change.
 */ function Batcher({ setNotifyBatcherOfChange }) {
    const storeRef = useStoreRef();
    const [, setState] = useState([]); // $FlowFixMe[incompatible-call]
    setNotifyBatcherOfChange(()=>setState({}));
    useEffect(()=>{
        // $FlowFixMe[incompatible-call]
        setNotifyBatcherOfChange(()=>setState({})); // If an asynchronous selector resolves after the Batcher is unmounted,
        // notifyBatcherOfChange will still be called. An error gets thrown whenever
        // setState is called after a component is already unmounted, so this sets
        // notifyBatcherOfChange to be a no-op.
        return ()=>{
            setNotifyBatcherOfChange(()=>{});
        };
    }, [
        setNotifyBatcherOfChange
    ]);
    useEffect(()=>{
        // enqueueExecution runs this function immediately; it is only used to
        // manipulate the order of useEffects during tests, since React seems to
        // call useEffect in an unpredictable order sometimes.
        Recoil_Queue.enqueueExecution("Batcher", ()=>{
            endBatch(storeRef.current);
        });
    });
    return null;
}
// which will no longer be needed.
function initialStoreState_DEPRECATED(store, initializeState) {
    const initial = makeEmptyStoreState$2();
    initializeState({
        set: (atom, value)=>{
            const state = initial.currentTree;
            const writes = setNodeValue$2(store, state, atom.key, value);
            const writtenNodes = new Set(writes.keys());
            const nonvalidatedAtoms = state.nonvalidatedAtoms.clone();
            for (const n of writtenNodes)nonvalidatedAtoms.delete(n);
            initial.currentTree = {
                ...state,
                dirtyAtoms: Recoil_unionSets(state.dirtyAtoms, writtenNodes),
                atomValues: applyAtomValueWrites$1(state.atomValues, writes),
                // NB: PLEASE un-export applyAtomValueWrites when deleting this code
                nonvalidatedAtoms
            };
        },
        setUnvalidatedAtomValues: (atomValues)=>{
            // FIXME replace this with a mutative loop
            atomValues.forEach((v, k)=>{
                initial.currentTree = setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
            });
        }
    });
    return initial;
} // Initialize state snapshot for <RecoilRoot> for the initializeState prop.
// Atom effect initialization takes precedence over this prop.
// Any atom effects will be run before initialization, but then cleaned up,
// they are then re-run when used as part of rendering.  These semantics are
// compatible with React StrictMode where effects may be re-run multiple times
// but state initialization only happens once the first time.
function initialStoreState(initializeState) {
    // Initialize a snapshot and get its store
    const snapshot = freshSnapshot$1(initializeState);
    const storeState = snapshot.getStore_INTERNAL().getState(); // Counteract the snapshot auto-release
    snapshot.retain(); // Cleanup any effects run during initialization and clear the handlers so
    // they will re-initialize if used during rendering.  This allows atom effect
    // initialization to take precedence over initializeState and be compatible
    // with StrictMode semantics.
    storeState.nodeCleanupFunctions.forEach((cleanup)=>cleanup());
    storeState.nodeCleanupFunctions.clear();
    return storeState;
}
let nextID = 0;
function RecoilRoot_INTERNAL({ initializeState_DEPRECATED, initializeState, store_INTERNAL: storeProp, // For use with React "context bridging"
children }) {
    // prettier-ignore
    // @fb-only: useEffect(() => {
    // @fb-only: if (gkx('recoil_usage_logging')) {
    // @fb-only: try {
    // @fb-only: RecoilUsageLogFalcoEvent.log(() => ({
    // @fb-only: type: RecoilusagelogEvent.RECOIL_ROOT_MOUNTED,
    // @fb-only: path: URI.getRequestURI().getPath(),
    // @fb-only: }));
    // @fb-only: } catch {
    // @fb-only: recoverableViolation(
    // @fb-only: 'Error when logging Recoil Usage event',
    // @fb-only: 'recoil',
    // @fb-only: );
    // @fb-only: }
    // @fb-only: }
    // @fb-only: }, []);
    let storeStateRef; // eslint-disable-line prefer-const
    const getGraph = (version)=>{
        const graphs = storeStateRef.current.graphsByVersion;
        if (graphs.has(version)) return Recoil_nullthrows(graphs.get(version));
        const newGraph = graph$2();
        graphs.set(version, newGraph);
        return newGraph;
    };
    const subscribeToTransactions = (callback, key)=>{
        if (key == null) {
            // Global transaction subscriptions
            const { transactionSubscriptions } = storeRef.current.getState();
            const id = nextID++;
            transactionSubscriptions.set(id, callback);
            return {
                release: ()=>{
                    transactionSubscriptions.delete(id);
                }
            };
        } else {
            // Node-specific transaction subscriptions:
            const { nodeTransactionSubscriptions } = storeRef.current.getState();
            if (!nodeTransactionSubscriptions.has(key)) nodeTransactionSubscriptions.set(key, new Map());
            const id = nextID++;
            Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id, callback);
            return {
                release: ()=>{
                    const subs = nodeTransactionSubscriptions.get(key);
                    if (subs) {
                        subs.delete(id);
                        if (subs.size === 0) nodeTransactionSubscriptions.delete(key);
                    }
                }
            };
        }
    };
    const addTransactionMetadata = (metadata)=>{
        startNextTreeIfNeeded(storeRef.current);
        for (const k of Object.keys(metadata))Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
    };
    const replaceState = (replacer)=>{
        startNextTreeIfNeeded(storeRef.current); // Use replacer to get the next state:
        const nextTree = Recoil_nullthrows(storeStateRef.current.nextTree);
        let replaced;
        try {
            stateReplacerIsBeingExecuted = true;
            replaced = replacer(nextTree);
        } finally{
            stateReplacerIsBeingExecuted = false;
        }
        if (replaced === nextTree) return;
        storeStateRef.current.nextTree = replaced;
        if (reactMode$2().early) notifyComponents(storeRef.current, storeStateRef.current, replaced);
        Recoil_nullthrows(notifyBatcherOfChange.current)();
    };
    const notifyBatcherOfChange = useRef$1(null);
    const setNotifyBatcherOfChange = useCallback((x)=>{
        notifyBatcherOfChange.current = x;
    }, [
        notifyBatcherOfChange
    ]);
    const storeRef = Recoil_useRefInitOnce(()=>storeProp !== null && storeProp !== void 0 ? storeProp : {
            storeID: getNextStoreID$2(),
            getState: ()=>storeStateRef.current,
            replaceState,
            getGraph,
            subscribeToTransactions,
            addTransactionMetadata
        });
    if (storeProp != null) storeRef.current = storeProp;
    storeStateRef = Recoil_useRefInitOnce(()=>initializeState_DEPRECATED != null ? initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? initialStoreState(initializeState) : makeEmptyStoreState$2());
    const mutableSource = useMemo(()=>createMutableSource$1 === null || createMutableSource$1 === void 0 ? void 0 : createMutableSource$1(storeStateRef, ()=>storeStateRef.current.currentTree.version), [
        storeStateRef
    ]); // Cleanup when the <RecoilRoot> is unmounted
    useEffect(()=>{
        // React is free to call effect cleanup handlers and effects at will, the
        // deps array is only an optimization.  For example, React strict mode
        // will execute each effect twice for testing.  Therefore, we need symmetry
        // to re-initialize all known atoms after they were cleaned up.
        const store = storeRef.current;
        for (const atomKey of new Set(store.getState().knownAtoms))initializeNode$2(store, atomKey, "get");
        return ()=>{
            for (const atomKey of store.getState().knownAtoms)cleanUpNode$2(store, atomKey);
        };
    }, [
        storeRef
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(AppContext.Provider, {
        value: storeRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(MutableSourceContext.Provider, {
        value: mutableSource
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Batcher, {
        setNotifyBatcherOfChange: setNotifyBatcherOfChange
    }), children));
}
function RecoilRoot(props) {
    const { override, ...propsExceptOverride } = props;
    const ancestorStoreRef = useStoreRef();
    if (override === false && ancestorStoreRef.current !== defaultStore) // If ancestorStoreRef.current !== defaultStore, it means that this
    // RecoilRoot is not nested within another.
    return props.children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(RecoilRoot_INTERNAL, propsExceptOverride);
}
function useRecoilStoreID() {
    return useStoreRef().current.storeID;
}
var Recoil_RecoilRoot = {
    RecoilRoot,
    useStoreRef,
    useRecoilMutableSource,
    useRecoilStoreID,
    notifyComponents_FOR_TESTING: notifyComponents,
    sendEndOfBatchNotifications_FOR_TESTING: sendEndOfBatchNotifications
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function shallowArrayEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
var Recoil_shallowArrayEqual = shallowArrayEqual;
const { useEffect: useEffect$1, useRef: useRef$2 } = (0, _reactDefault.default);
function usePrevious(value) {
    const ref = useRef$2();
    useEffect$1(()=>{
        // $FlowFixMe[incompatible-type]
        ref.current = value;
    });
    return ref.current;
}
var Recoil_usePrevious = usePrevious;
const { useStoreRef: useStoreRef$1 } = Recoil_RecoilRoot;
const { SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$1 } = Recoil_Retention;
const { updateRetainCount: updateRetainCount$2 } = Recoil_Retention;
const { RetentionZone: RetentionZone$3 } = Recoil_RetentionZone;
const { useEffect: useEffect$2, useRef: useRef$3 } = (0, _reactDefault.default);
const { isSSR: isSSR$2 } = Recoil_Environment;
// I don't see a way to avoid the any type here because we want to accept readable
// and writable values with any type parameter, but normally with writable ones
// RecoilState<SomeT> is not a subtype of RecoilState<mixed>.
// flowlint-line unclear-type:off
function useRetain(toRetain) {
    if (!Recoil_gkx("recoil_memory_managament_2020")) return;
     // eslint-disable-next-line fb-www/react-hooks
    return useRetain_ACTUAL(toRetain);
}
function useRetain_ACTUAL(toRetain) {
    const array = Array.isArray(toRetain) ? toRetain : [
        toRetain
    ];
    const retainables = array.map((a)=>a instanceof RetentionZone$3 ? a : a.key);
    const storeRef = useStoreRef$1();
    useEffect$2(()=>{
        if (!Recoil_gkx("recoil_memory_managament_2020")) return;
        const store = storeRef.current;
        if (timeoutID.current && !isSSR$2) {
            // Already performed a temporary retain on render, simply cancel the release
            // of that temporary retain.
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
        } else for (const r of retainables)updateRetainCount$2(store, r, 1);
        return ()=>{
            for (const r of retainables)updateRetainCount$2(store, r, -1);
        }; // eslint-disable-next-line fb-www/react-hooks-deps
    }, [
        storeRef,
        ...retainables
    ]); // We want to retain if the component suspends. This is terrible but the Suspense
    // API affords us no better option. If we suspend and never commit after some
    // seconds, then release. The 'actual' retain/release in the effect above
    // cancels this.
    const timeoutID = useRef$3();
    const previousRetainables = Recoil_usePrevious(retainables);
    if (!isSSR$2 && (previousRetainables === undefined || !Recoil_shallowArrayEqual(previousRetainables, retainables))) {
        const store = storeRef.current;
        for (const r of retainables)updateRetainCount$2(store, r, 1);
        if (previousRetainables) for (const r of previousRetainables)updateRetainCount$2(store, r, -1);
        if (timeoutID.current) window.clearTimeout(timeoutID.current);
        timeoutID.current = window.setTimeout(()=>{
            timeoutID.current = null;
            for (const r of retainables)updateRetainCount$2(store, r, -1);
        }, SUSPENSE_TIMEOUT_MS$1);
    }
}
var Recoil_useRetain = useRetain;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * THIS CODE HAS BEEN COMMENTED OUT INTENTIONALLY
 *
 * This technique of getting the component name is imperfect, since it both only
 * works in a non-minified code base, and more importantly introduces performance
 * problems since it relies in throwing errors which is an expensive operation.
 *
 * At some point we may want to reevaluate this technique hence why we have commented
 * this code out, rather than delete it all together.
 */ // const {useRef} = require('react');
// const gkx = require('recoil-shared/util/Recoil_gkx');
// const stackTraceParser = require('recoil-shared/util/Recoil_stackTraceParser');
function useComponentName() {
    // const nameRef = useRef();
    // if (__DEV__) {
    //   if (gkx('recoil_infer_component_names')) {
    //     if (nameRef.current === undefined) {
    //       // There is no blessed way to determine the calling React component from
    //       // within a hook. This hack uses the fact that hooks must start with 'use'
    //       // and that hooks are either called by React Components or other hooks. It
    //       // follows therefore, that to find the calling component, you simply need
    //       // to look down the stack and find the first function which doesn't start
    //       // with 'use'. We are only enabling this in dev for now, since once the
    //       // codebase is minified, the naming assumptions no longer hold true.
    //       // eslint-disable-next-line fb-www/no-new-error
    //       const frames = stackTraceParser(new Error().stack);
    //       for (const {methodName} of frames) {
    //         // I observed cases where the frame was of the form 'Object.useXXX'
    //         // hence why I'm searching for hooks following a word boundary
    //         if (!methodName.match(/\buse[^\b]+$/)) {
    //           return (nameRef.current = methodName);
    //         }
    //       }
    //       nameRef.current = null;
    //     }
    //     return nameRef.current ?? '<unable to determine component name>';
    //   }
    // }
    // @fb-only: return "<component name only available when both in dev mode and when passing GK 'recoil_infer_component_names'>";
    return "<component name not available>"; // @oss-only
}
var Recoil_useComponentName = useComponentName;
const { batchUpdates: batchUpdates$2 } = Recoil_Batching;
const { DEFAULT_VALUE: DEFAULT_VALUE$2 } = Recoil_Node;
const { currentRendererSupportsUseSyncExternalStore: currentRendererSupportsUseSyncExternalStore$1, reactMode: reactMode$3, useMutableSource: useMutableSource$1, useSyncExternalStore: useSyncExternalStore$1 } = Recoil_ReactMode;
const { useRecoilMutableSource: useRecoilMutableSource$1, useStoreRef: useStoreRef$2 } = Recoil_RecoilRoot;
const { isRecoilValue: isRecoilValue$2 } = Recoil_RecoilValue$1;
const { AbstractRecoilValue: AbstractRecoilValue$3, getRecoilValueAsLoadable: getRecoilValueAsLoadable$2, setRecoilValue: setRecoilValue$2, setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$2, subscribeToRecoilValue: subscribeToRecoilValue$1 } = Recoil_RecoilValueInterface;
const { useCallback: useCallback$1, useEffect: useEffect$3, useMemo: useMemo$1, useRef: useRef$4, useState: useState$1 } = (0, _reactDefault.default);
const { setByAddingToSet: setByAddingToSet$2 } = Recoil_CopyOnWrite;
const { isSSR: isSSR$3 } = Recoil_Environment;
function handleLoadable(loadable, recoilValue, storeRef) {
    // We can't just throw the promise we are waiting on to Suspense.  If the
    // upstream dependencies change it may produce a state in which the component
    // can render, but it would still be suspended on a Promise that may never resolve.
    if (loadable.state === "hasValue") return loadable.contents;
    else if (loadable.state === "loading") {
        const promise = new Promise((resolve)=>{
            const suspendedComponentResolvers = storeRef.current.getState().suspendedComponentResolvers;
            suspendedComponentResolvers.add(resolve); // SSR should clear out the wake-up resolver if the Promise is resolved
            // to avoid infinite loops.  (See https://github.com/facebookexperimental/Recoil/pull/2073)
            if (isSSR$3 && Recoil_isPromise(loadable.contents)) loadable.contents.finally(()=>{
                suspendedComponentResolvers.delete(resolve);
            });
        }); // $FlowExpectedError Flow(prop-missing) for integrating with tools that inspect thrown promises @fb-only
        // @fb-only: promise.displayName = `Recoil State: ${recoilValue.key}`;
        throw promise;
    } else if (loadable.state === "hasError") throw loadable.contents;
    else throw Recoil_err(`Invalid value of loadable atom "${recoilValue.key}"`);
}
function validateRecoilValue(recoilValue, hookName // $FlowFixMe[missing-local-annot]
) {
    if (!isRecoilValue$2(recoilValue)) throw Recoil_err(`Invalid argument to ${hookName}: expected an atom or selector but got ${String(recoilValue)}`);
}
/**
 * Various things are broken with useRecoilInterface, particularly concurrent
 * mode, React strict mode, and memory management. They will not be fixed.
 * */ function useRecoilInterface_DEPRECATED() {
    const componentName = Recoil_useComponentName();
    const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook
    const [, forceUpdate] = useState$1([]);
    const recoilValuesUsed = useRef$4(new Set());
    recoilValuesUsed.current = new Set(); // Track the RecoilValues used just during this render
    const previousSubscriptions = useRef$4(new Set());
    const subscriptions = useRef$4(new Map());
    const unsubscribeFrom = useCallback$1((key)=>{
        const sub = subscriptions.current.get(key);
        if (sub) {
            sub.release();
            subscriptions.current.delete(key);
        }
    }, [
        subscriptions
    ]);
    const updateState = useCallback$1((_state, key)=>{
        if (subscriptions.current.has(key)) forceUpdate([]);
    }, []); // Effect to add/remove subscriptions as nodes are used
    useEffect$3(()=>{
        const store = storeRef.current;
        Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach((key)=>{
            if (subscriptions.current.has(key)) {
                Recoil_expectationViolation(`Double subscription to RecoilValue "${key}"`);
                return;
            }
            const sub = subscribeToRecoilValue$1(store, new AbstractRecoilValue$3(key), (state)=>updateState(state, key), componentName);
            subscriptions.current.set(key, sub);
            /**
       * Since we're subscribing in an effect we need to update to the latest
       * value of the atom since it may have changed since we rendered. We can
       * go ahead and do that now, unless we're in the middle of a batch --
       * in which case we should do it at the end of the batch, due to the
       * following edge case: Suppose an atom is updated in another useEffect
       * of this same component. Then the following sequence of events occur:
       * 1. Atom is updated and subs fired (but we may not be subscribed
       *    yet depending on order of effects, so we miss this) Updated value
       *    is now in nextTree, but not currentTree.
       * 2. This effect happens. We subscribe and update.
       * 3. From the update we re-render and read currentTree, with old value.
       * 4. Batcher's effect sets currentTree to nextTree.
       * In this sequence we miss the update. To avoid that, add the update
       * to queuedComponentCallback if a batch is in progress.
       */ // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.
            const state = store.getState();
            if (state.nextTree) store.getState().queuedComponentCallbacks_DEPRECATED.push(()=>{
                updateState(store.getState(), key);
            });
            else updateState(store.getState(), key);
        });
        Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach((key)=>{
            unsubscribeFrom(key);
        });
        previousSubscriptions.current = recoilValuesUsed.current;
    }); // Effect to unsubscribe from all when unmounting
    useEffect$3(()=>{
        const currentSubscriptions = subscriptions.current; // Restore subscriptions that were cleared due to StrictMode running this effect twice
        Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach((key)=>{
            const sub = subscribeToRecoilValue$1(storeRef.current, new AbstractRecoilValue$3(key), (state)=>updateState(state, key), componentName);
            currentSubscriptions.set(key, sub);
        });
        return ()=>currentSubscriptions.forEach((_, key)=>unsubscribeFrom(key));
    }, [
        componentName,
        storeRef,
        unsubscribeFrom,
        updateState
    ]);
    return useMemo$1(()=>{
        // eslint-disable-next-line no-shadow
        function useSetRecoilState(recoilState) {
            return (newValueOrUpdater)=>{
                setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
            };
        } // eslint-disable-next-line no-shadow
        function useResetRecoilState(recoilState) {
            return ()=>setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
        } // eslint-disable-next-line no-shadow
        function useRecoilValueLoadable(recoilValue) {
            var _storeState$nextTree;
            if (!recoilValuesUsed.current.has(recoilValue.key)) recoilValuesUsed.current = setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
             // TODO Restore optimization to memoize lookup
            const storeState = storeRef.current.getState();
            return getRecoilValueAsLoadable$2(storeRef.current, recoilValue, reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
        } // eslint-disable-next-line no-shadow
        function useRecoilValue(recoilValue) {
            const loadable = useRecoilValueLoadable(recoilValue);
            return handleLoadable(loadable, recoilValue, storeRef);
        } // eslint-disable-next-line no-shadow
        function useRecoilState(recoilState) {
            return [
                useRecoilValue(recoilState),
                useSetRecoilState(recoilState)
            ];
        } // eslint-disable-next-line no-shadow
        function useRecoilStateLoadable(recoilState) {
            return [
                useRecoilValueLoadable(recoilState),
                useSetRecoilState(recoilState)
            ];
        }
        return {
            getRecoilValue: useRecoilValue,
            getRecoilValueLoadable: useRecoilValueLoadable,
            getRecoilState: useRecoilState,
            getRecoilStateLoadable: useRecoilStateLoadable,
            getSetRecoilState: useSetRecoilState,
            getResetRecoilState: useResetRecoilState
        };
    }, [
        recoilValuesUsed,
        storeRef
    ]);
}
const recoilComponentGetRecoilValueCount_FOR_TESTING = {
    current: 0
};
function useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
    const storeRef = useStoreRef$2();
    const componentName = Recoil_useComponentName();
    const getSnapshot = useCallback$1(()=>{
        var _storeState$nextTree2;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
        const loadable = getRecoilValueAsLoadable$2(store, recoilValue, treeState);
        return {
            loadable,
            key: recoilValue.key
        };
    }, [
        storeRef,
        recoilValue
    ]); // Memoize the state to avoid unnecessary rerenders
    const memoizePreviousSnapshot = useCallback$1((getState)=>{
        let prevState;
        return ()=>{
            var _prevState, _prevState2;
            const nextState = getState();
            if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) return prevState;
            prevState = nextState;
            return nextState;
        };
    }, []);
    const getMemoizedSnapshot = useMemo$1(()=>memoizePreviousSnapshot(getSnapshot), [
        getSnapshot,
        memoizePreviousSnapshot
    ]);
    const subscribe = useCallback$1((notify)=>{
        const store = storeRef.current;
        const subscription = subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
        return subscription.release;
    }, [
        storeRef,
        recoilValue,
        componentName
    ]);
    return useSyncExternalStore$1(subscribe, getMemoizedSnapshot, getMemoizedSnapshot // getServerSnapshot() for SSR support
    ).loadable;
}
function useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
    const storeRef = useStoreRef$2();
    const getLoadable = useCallback$1(()=>{
        var _storeState$nextTree3;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
        return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const getLoadableWithTesting = useCallback$1(()=>{
        return getLoadable();
    }, [
        getLoadable
    ]);
    const componentName = Recoil_useComponentName();
    const subscribe = useCallback$1((_storeState, notify)=>{
        const store = storeRef.current;
        const subscription = subscribeToRecoilValue$1(store, recoilValue, ()=>{
            if (!Recoil_gkx("recoil_suppress_rerender_in_callback")) return notify();
             // Only re-render if the value has changed.
            // This will evaluate the atom/selector now as well as when the
            // component renders, but that may help with prefetching.
            const newLoadable = getLoadable();
            if (!prevLoadableRef.current.is(newLoadable)) notify();
             // If the component is suspended then the effect setting prevLoadableRef
            // will not run.  So, set the previous value here when its subscription
            // is fired to wake it up.  We can't just rely on this, though, because
            // this only executes when an atom/selector is dirty and the atom/selector
            // passed to the hook can dynamically change.
            prevLoadableRef.current = newLoadable;
        }, componentName);
        return subscription.release;
    }, [
        storeRef,
        recoilValue,
        componentName,
        getLoadable
    ]);
    const source = useRecoilMutableSource$1();
    if (source == null) throw Recoil_err("Recoil hooks must be used in components contained within a <RecoilRoot> component.");
    const loadable = useMutableSource$1(source, getLoadableWithTesting, subscribe);
    const prevLoadableRef = useRef$4(loadable);
    useEffect$3(()=>{
        prevLoadableRef.current = loadable;
    });
    return loadable;
}
function useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
    const storeRef = useStoreRef$2();
    const componentName = Recoil_useComponentName(); // Accessors to get the current state
    const getLoadable = useCallback$1(()=>{
        var _storeState$nextTree4;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
        return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const getState = useCallback$1(()=>({
            loadable: getLoadable(),
            key: recoilValue.key
        }), [
        getLoadable,
        recoilValue.key
    ]); // Memoize state snapshots
    const updateState = useCallback$1((prevState)=>{
        const nextState = getState();
        return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
    }, [
        getState
    ]); // Subscribe to Recoil state changes
    useEffect$3(()=>{
        const subscription = subscribeToRecoilValue$1(storeRef.current, recoilValue, (_state)=>{
            setState(updateState);
        }, componentName); // Update state in case we are using a different key
        setState(updateState);
        return subscription.release;
    }, [
        componentName,
        recoilValue,
        storeRef,
        updateState
    ]); // Get the current state
    const [state, setState] = useState$1(getState); // If we changed keys, then return the state for the new key.
    // This is important in case the old key would cause the component to suspend.
    // We don't have to set the new state here since the subscribing effect above
    // will do that.
    return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}
function useRecoilValueLoadable_LEGACY(recoilValue) {
    const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook
    const [, forceUpdate] = useState$1([]);
    const componentName = Recoil_useComponentName();
    const getLoadable = useCallback$1(()=>{
        var _storeState$nextTree5;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
        return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const loadable = getLoadable();
    const prevLoadableRef = useRef$4(loadable);
    useEffect$3(()=>{
        prevLoadableRef.current = loadable;
    });
    useEffect$3(()=>{
        const store = storeRef.current;
        const storeState = store.getState();
        const subscription = subscribeToRecoilValue$1(store, recoilValue, (_state)=>{
            var _prevLoadableRef$curr;
            if (!Recoil_gkx("recoil_suppress_rerender_in_callback")) return forceUpdate([]);
            const newLoadable = getLoadable();
            if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) // $FlowFixMe[incompatible-call]
            forceUpdate(newLoadable);
            prevLoadableRef.current = newLoadable;
        }, componentName);
        /**
     * Since we're subscribing in an effect we need to update to the latest
     * value of the atom since it may have changed since we rendered. We can
     * go ahead and do that now, unless we're in the middle of a batch --
     * in which case we should do it at the end of the batch, due to the
     * following edge case: Suppose an atom is updated in another useEffect
     * of this same component. Then the following sequence of events occur:
     * 1. Atom is updated and subs fired (but we may not be subscribed
     *    yet depending on order of effects, so we miss this) Updated value
     *    is now in nextTree, but not currentTree.
     * 2. This effect happens. We subscribe and update.
     * 3. From the update we re-render and read currentTree, with old value.
     * 4. Batcher's effect sets currentTree to nextTree.
     * In this sequence we miss the update. To avoid that, add the update
     * to queuedComponentCallback if a batch is in progress.
     */ if (storeState.nextTree) store.getState().queuedComponentCallbacks_DEPRECATED.push(()=>{
            // $FlowFixMe[incompatible-type]
            prevLoadableRef.current = null;
            forceUpdate([]);
        });
        else {
            var _prevLoadableRef$curr2;
            if (!Recoil_gkx("recoil_suppress_rerender_in_callback")) return forceUpdate([]);
            const newLoadable = getLoadable();
            if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) // $FlowFixMe[incompatible-call]
            forceUpdate(newLoadable);
            prevLoadableRef.current = newLoadable;
        }
        return subscription.release;
    }, [
        componentName,
        getLoadable,
        recoilValue,
        storeRef
    ]);
    return loadable;
}
/**
  Like useRecoilValue(), but either returns the value if available or
  just undefined if not available for any reason, such as pending or error.
*/ function useRecoilValueLoadable(recoilValue) {
    if (Recoil_gkx("recoil_memory_managament_2020")) // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
    return ({
        TRANSITION_SUPPORT: useRecoilValueLoadable_TRANSITION_SUPPORT,
        // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
        // `reactMode()` before calling it.  However, sometimes the host React
        // environment supports it but uses additional React renderers (such as with
        // `react-three-fiber`) which do not.  While this is technically a user issue
        // by using a renderer with React 18+ that doesn't fully support React 18 we
        // don't want to break users if it can be avoided. As the current renderer can
        // change at runtime, we need to dynamically check and fallback if necessary.
        SYNC_EXTERNAL_STORE: currentRendererSupportsUseSyncExternalStore$1() ? useRecoilValueLoadable_SYNC_EXTERNAL_STORE : useRecoilValueLoadable_TRANSITION_SUPPORT,
        MUTABLE_SOURCE: useRecoilValueLoadable_MUTABLE_SOURCE,
        LEGACY: useRecoilValueLoadable_LEGACY
    })[reactMode$3().mode](recoilValue);
}
/**
  Returns the value represented by the RecoilValue.
  If the value is pending, it will throw a Promise to suspend the component,
  if the value is an error it will throw it for the nearest React error boundary.
  This will also subscribe the component for any updates in the value.
  */ function useRecoilValue(recoilValue) {
    const storeRef = useStoreRef$2();
    const loadable = useRecoilValueLoadable(recoilValue);
    return handleLoadable(loadable, recoilValue, storeRef);
}
/**
  Returns a function that allows the value of a RecoilState to be updated, but does
  not subscribe the component to changes to that RecoilState.
*/ function useSetRecoilState(recoilState) {
    const storeRef = useStoreRef$2();
    return useCallback$1((newValueOrUpdater)=>{
        setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
    }, [
        storeRef,
        recoilState
    ]);
}
/**
  Returns a function that will reset the value of a RecoilState to its default
*/ function useResetRecoilState(recoilState) {
    const storeRef = useStoreRef$2();
    return useCallback$1(()=>{
        setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
    }, [
        storeRef,
        recoilState
    ]);
}
/**
  Equivalent to useState(). Allows the value of the RecoilState to be read and written.
  Subsequent updates to the RecoilState will cause the component to re-render. If the
  RecoilState is pending, this will suspend the component and initiate the
  retrieval of the value. If evaluating the RecoilState resulted in an error, this will
  throw the error so that the nearest React error boundary can catch it.
*/ function useRecoilState(recoilState) {
    return [
        useRecoilValue(recoilState),
        useSetRecoilState(recoilState)
    ];
}
/**
  Like useRecoilState(), but does not cause Suspense or React error handling. Returns
  an object that indicates whether the RecoilState is available, pending, or
  unavailable due to an error.
*/ function useRecoilStateLoadable(recoilState) {
    return [
        useRecoilValueLoadable(recoilState),
        useSetRecoilState(recoilState)
    ];
}
function useSetUnvalidatedAtomValues() {
    const storeRef = useStoreRef$2();
    return (values, transactionMetadata = {})=>{
        batchUpdates$2(()=>{
            storeRef.current.addTransactionMetadata(transactionMetadata);
            values.forEach((value, key)=>setUnvalidatedRecoilValue$2(storeRef.current, new AbstractRecoilValue$3(key), value));
        });
    };
}
/**
 * Experimental variants of hooks with support for useTransition()
 */ function useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
    if (Recoil_gkx("recoil_memory_managament_2020")) // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
    return useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}
function useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
    const storeRef = useStoreRef$2();
    const loadable = useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
    return handleLoadable(loadable, recoilValue, storeRef);
}
function useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
    return [
        useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState),
        useSetRecoilState(recoilState)
    ];
}
var Recoil_Hooks = {
    recoilComponentGetRecoilValueCount_FOR_TESTING,
    useRecoilInterface: useRecoilInterface_DEPRECATED,
    useRecoilState,
    useRecoilStateLoadable,
    useRecoilValue,
    useRecoilValueLoadable,
    useResetRecoilState,
    useSetRecoilState,
    useSetUnvalidatedAtomValues,
    useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a map containing all of the keys + values from the original map where
 * the given callback returned true.
 */ function filterMap(map, callback) {
    const result = new Map();
    for (const [key, value] of map)if (callback(value, key)) result.set(key, value);
    return result;
}
var Recoil_filterMap = filterMap;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a set containing all of the values from the original set where
 * the given callback returned true.
 */ function filterSet(set, callback) {
    const result = new Set();
    for (const value of set)if (callback(value)) result.add(value);
    return result;
}
var Recoil_filterSet = filterSet;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function mergeMaps(...maps) {
    const result = new Map();
    for(let i = 0; i < maps.length; i++){
        const iterator = maps[i].keys();
        let nextKey;
        while(!(nextKey = iterator.next()).done)// $FlowIssue[incompatible-call] - map/iterator knows nothing about flow types
        result.set(nextKey.value, maps[i].get(nextKey.value));
    }
    return result;
}
var Recoil_mergeMaps = mergeMaps;
const { batchUpdates: batchUpdates$3 } = Recoil_Batching;
const { DEFAULT_VALUE: DEFAULT_VALUE$3, getNode: getNode$4, nodes: nodes$1 } = Recoil_Node;
const { useStoreRef: useStoreRef$3 } = Recoil_RecoilRoot;
const { AbstractRecoilValue: AbstractRecoilValue$4, setRecoilValueLoadable: setRecoilValueLoadable$1 } = Recoil_RecoilValueInterface;
const { SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$2 } = Recoil_Retention;
const { cloneSnapshot: cloneSnapshot$1 } = Recoil_Snapshot$1;
const { useCallback: useCallback$2, useEffect: useEffect$4, useRef: useRef$5, useState: useState$2 } = (0, _reactDefault.default);
const { isSSR: isSSR$4 } = Recoil_Environment;
function useTransactionSubscription(callback) {
    const storeRef = useStoreRef$3();
    useEffect$4(()=>{
        const sub = storeRef.current.subscribeToTransactions(callback);
        return sub.release;
    }, [
        callback,
        storeRef
    ]);
}
function externallyVisibleAtomValuesInState(state) {
    const atomValues = state.atomValues.toMap();
    const persistedAtomContentsValues = Recoil_mapMap(Recoil_filterMap(atomValues, (v, k)=>{
        const node = getNode$4(k);
        const persistence = node.persistence_UNSTABLE;
        return persistence != null && persistence.type !== "none" && v.state === "hasValue";
    }), (v)=>v.contents); // Merge in nonvalidated atoms; we may not have defs for them but they will
    // all have persistence on or they wouldn't be there in the first place.
    return Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}
/**
  Calls the given callback after any atoms have been modified and the consequent
  component re-renders have been committed. This is intended for persisting
  the values of the atoms to storage. The stored values can then be restored
  using the useSetUnvalidatedAtomValues hook.

  The callback receives the following info:

  atomValues: The current value of every atom that is both persistable (persistence
              type not set to 'none') and whose value is available (not in an
              error or loading state).

  previousAtomValues: The value of every persistable and available atom before
               the transaction began.

  atomInfo: A map containing the persistence settings for each atom. Every key
            that exists in atomValues will also exist in atomInfo.

  modifiedAtoms: The set of atoms that were written to during the transaction.

  transactionMetadata: Arbitrary information that was added via the
          useSetUnvalidatedAtomValues hook. Useful for ignoring the useSetUnvalidatedAtomValues
          transaction, to avoid loops.
*/ function useTransactionObservation_DEPRECATED(callback) {
    useTransactionSubscription(useCallback$2((store)=>{
        let previousTree = store.getState().previousTree;
        const currentTree = store.getState().currentTree;
        if (!previousTree) {
            Recoil_recoverableViolation("Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil");
            previousTree = store.getState().currentTree; // attempt to trundle on
        }
        const atomValues = externallyVisibleAtomValuesInState(currentTree);
        const previousAtomValues = externallyVisibleAtomValuesInState(previousTree);
        const atomInfo = Recoil_mapMap(nodes$1, (node)=>{
            var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;
            return {
                persistence_UNSTABLE: {
                    type: (_node$persistence_UNS = (_node$persistence_UNS2 = node.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : "none",
                    backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
                }
            };
        }); // Filter on existance in atomValues so that externally-visible rules
        // are also applied to modified atoms (specifically exclude selectors):
        const modifiedAtoms = Recoil_filterSet(currentTree.dirtyAtoms, (k)=>atomValues.has(k) || previousAtomValues.has(k));
        callback({
            atomValues,
            previousAtomValues,
            atomInfo,
            modifiedAtoms,
            transactionMetadata: {
                ...currentTree.transactionMetadata
            }
        });
    }, [
        callback
    ]));
}
function useRecoilTransactionObserver(callback) {
    useTransactionSubscription(useCallback$2((store)=>{
        const snapshot = cloneSnapshot$1(store, "latest");
        const previousSnapshot = cloneSnapshot$1(store, "previous");
        callback({
            snapshot,
            previousSnapshot
        });
    }, [
        callback
    ]));
} // Return a snapshot of the current state and subscribe to all state changes
function useRecoilSnapshot() {
    const storeRef = useStoreRef$3();
    const [snapshot, setSnapshot] = useState$2(()=>cloneSnapshot$1(storeRef.current));
    const previousSnapshot = Recoil_usePrevious(snapshot);
    const timeoutID = useRef$5();
    const releaseRef = useRef$5();
    useTransactionSubscription(useCallback$2((store)=>setSnapshot(cloneSnapshot$1(store)), [])); // Retain snapshot for duration component is mounted
    useEffect$4(()=>{
        const release = snapshot.retain(); // Release the retain from the rendering call
        if (timeoutID.current && !isSSR$4) {
            var _releaseRef$current;
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
            (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 || _releaseRef$current.call(releaseRef);
            releaseRef.current = null;
        }
        return ()=>{
            // Defer the release.  If "Fast Refresh"" is used then the component may
            // re-render with the same state.  The previous cleanup will then run and
            // then the new effect will run. We don't want the snapshot to be released
            // by that cleanup before the new effect has a chance to retain it again.
            // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
            window.setTimeout(release, 10);
        };
    }, [
        snapshot
    ]); // Retain snapshot until above effect is run.
    // Release after a threshold in case component is suspended.
    if (previousSnapshot !== snapshot && !isSSR$4) {
        // Release the previous snapshot
        if (timeoutID.current) {
            var _releaseRef$current2;
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
            (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 || _releaseRef$current2.call(releaseRef);
            releaseRef.current = null;
        }
        releaseRef.current = snapshot.retain();
        timeoutID.current = window.setTimeout(()=>{
            var _releaseRef$current3;
            timeoutID.current = null;
            (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 || _releaseRef$current3.call(releaseRef);
            releaseRef.current = null;
        }, SUSPENSE_TIMEOUT_MS$2);
    }
    return snapshot;
}
function gotoSnapshot(store, snapshot) {
    var _storeState$nextTree;
    const storeState = store.getState();
    const prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
    const next = snapshot.getStore_INTERNAL().getState().currentTree;
    batchUpdates$3(()=>{
        const keysToUpdate = new Set();
        for (const keys of [
            prev.atomValues.keys(),
            next.atomValues.keys()
        ])for (const key of keys){
            var _prev$atomValues$get, _next$atomValues$get;
            if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && getNode$4(key).shouldRestoreFromSnapshots) keysToUpdate.add(key);
        }
        keysToUpdate.forEach((key)=>{
            setRecoilValueLoadable$1(store, new AbstractRecoilValue$4(key), next.atomValues.has(key) ? Recoil_nullthrows(next.atomValues.get(key)) : DEFAULT_VALUE$3);
        });
        store.replaceState((state)=>({
                ...state,
                stateID: snapshot.getID()
            }));
    });
}
function useGotoRecoilSnapshot() {
    const storeRef = useStoreRef$3();
    return useCallback$2((snapshot)=>gotoSnapshot(storeRef.current, snapshot), [
        storeRef
    ]);
}
var Recoil_SnapshotHooks = {
    useRecoilSnapshot,
    gotoSnapshot,
    useGotoRecoilSnapshot,
    useRecoilTransactionObserver,
    useTransactionObservation_DEPRECATED,
    useTransactionSubscription_DEPRECATED: useTransactionSubscription
};
const { peekNodeInfo: peekNodeInfo$2 } = Recoil_FunctionalCore;
const { useStoreRef: useStoreRef$4 } = Recoil_RecoilRoot;
function useGetRecoilValueInfo() {
    const storeRef = useStoreRef$4(); // $FlowFixMe[incompatible-return]
    return ({ key })=>peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
}
var Recoil_useGetRecoilValueInfo = useGetRecoilValueInfo;
const { reactMode: reactMode$4 } = Recoil_ReactMode;
const { RecoilRoot: RecoilRoot$1, useStoreRef: useStoreRef$5 } = Recoil_RecoilRoot;
const { useMemo: useMemo$2 } = (0, _reactDefault.default);
function useRecoilBridgeAcrossReactRoots() {
    // The test fails when using useMutableSource(), but only if act() is used
    // for the nested root.  So, this may only be a testing environment issue.
    if (reactMode$4().mode === "MUTABLE_SOURCE") // eslint-disable-next-line fb-www/no-console
    console.warn("Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.");
    const store = useStoreRef$5().current;
    return useMemo$2(()=>{
        // eslint-disable-next-line no-shadow
        function RecoilBridge({ children }) {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(RecoilRoot$1, {
                store_INTERNAL: store
            }, children);
        }
        return RecoilBridge;
    }, [
        store
    ]);
}
var Recoil_useRecoilBridgeAcrossReactRoots = useRecoilBridgeAcrossReactRoots;
const { loadableWithValue: loadableWithValue$1 } = Recoil_Loadable$1;
const { initializeNode: initializeNode$3 } = Recoil_FunctionalCore;
const { DEFAULT_VALUE: DEFAULT_VALUE$4, getNode: getNode$5 } = Recoil_Node;
const { copyTreeState: copyTreeState$1, getRecoilValueAsLoadable: getRecoilValueAsLoadable$3, invalidateDownstreams: invalidateDownstreams$1, writeLoadableToTreeState: writeLoadableToTreeState$1 } = Recoil_RecoilValueInterface;
function isAtom(recoilValue) {
    return getNode$5(recoilValue.key).nodeType === "atom";
}
class TransactionInterfaceImpl {
    constructor(store, treeState){
        _defineProperty(this, "_store", void 0);
        _defineProperty(this, "_treeState", void 0);
        _defineProperty(this, "_changes", void 0);
        _defineProperty(this, "get", (recoilValue)=>{
            if (this._changes.has(recoilValue.key)) // $FlowIssue[incompatible-return]
            return this._changes.get(recoilValue.key);
            if (!isAtom(recoilValue)) throw Recoil_err("Reading selectors within atomicUpdate is not supported");
            const loadable = getRecoilValueAsLoadable$3(this._store, recoilValue, this._treeState);
            if (loadable.state === "hasValue") return loadable.contents;
            else if (loadable.state === "hasError") throw loadable.contents;
            else throw Recoil_err(`Expected Recoil atom ${recoilValue.key} to have a value, but it is in a loading state.`);
        });
        _defineProperty(this, "set", (recoilState, valueOrUpdater)=>{
            if (!isAtom(recoilState)) throw Recoil_err("Setting selectors within atomicUpdate is not supported");
            if (typeof valueOrUpdater === "function") {
                const current = this.get(recoilState);
                this._changes.set(recoilState.key, valueOrUpdater(current)); // flowlint-line unclear-type:off
            } else {
                // Initialize atom and run effects if not initialized yet
                initializeNode$3(this._store, recoilState.key, "set");
                this._changes.set(recoilState.key, valueOrUpdater);
            }
        });
        _defineProperty(this, "reset", (recoilState)=>{
            this.set(recoilState, DEFAULT_VALUE$4);
        });
        this._store = store;
        this._treeState = treeState;
        this._changes = new Map();
    }
    // eslint-disable-next-line fb-www/extra-arrow-initializer
    newTreeState_INTERNAL() {
        if (this._changes.size === 0) return this._treeState;
        const newState = copyTreeState$1(this._treeState);
        for (const [k, v] of this._changes)writeLoadableToTreeState$1(newState, k, loadableWithValue$1(v));
        invalidateDownstreams$1(this._store, newState);
        return newState;
    }
}
function atomicUpdater(store) {
    return (fn)=>{
        store.replaceState((treeState)=>{
            const changeset = new TransactionInterfaceImpl(store, treeState);
            fn(changeset);
            return changeset.newTreeState_INTERNAL();
        });
    };
}
var Recoil_AtomicUpdates = {
    atomicUpdater
};
var Recoil_AtomicUpdates_1 = Recoil_AtomicUpdates.atomicUpdater;
var Recoil_AtomicUpdates$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    atomicUpdater: Recoil_AtomicUpdates_1
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function invariant(condition, message) {
    if (!condition) throw new Error(message);
}
var invariant_1 = invariant;
// @oss-only
var Recoil_invariant = invariant_1;
const { atomicUpdater: atomicUpdater$1 } = Recoil_AtomicUpdates$1;
const { batchUpdates: batchUpdates$4 } = Recoil_Batching;
const { DEFAULT_VALUE: DEFAULT_VALUE$5 } = Recoil_Node;
const { useStoreRef: useStoreRef$6 } = Recoil_RecoilRoot;
const { refreshRecoilValue: refreshRecoilValue$1, setRecoilValue: setRecoilValue$3 } = Recoil_RecoilValueInterface;
const { cloneSnapshot: cloneSnapshot$2 } = Recoil_Snapshot$1;
const { gotoSnapshot: gotoSnapshot$1 } = Recoil_SnapshotHooks;
const { useCallback: useCallback$3 } = (0, _reactDefault.default);
class Sentinel {
}
const SENTINEL = new Sentinel();
function recoilCallback(store, fn, args, extraInterface) {
    let ret = SENTINEL;
    let releaseSnapshot;
    batchUpdates$4(()=>{
        const errMsg = "useRecoilCallback() expects a function that returns a function: it accepts a function of the type (RecoilInterface) => (Args) => ReturnType and returns a callback function (Args) => ReturnType, where RecoilInterface is an object {snapshot, set, ...} and Args and ReturnType are the argument and return types of the callback you want to create.  Please see the docs at recoiljs.org for details.";
        if (typeof fn !== "function") throw Recoil_err(errMsg);
         // Clone the snapshot lazily to avoid overhead if the callback does not use it.
        // Note that this means the snapshot may represent later state from when
        // the callback was called if it first accesses the snapshot asynchronously.
        const callbackInterface = Recoil_lazyProxy({
            ...extraInterface !== null && extraInterface !== void 0 ? extraInterface : {},
            // flowlint-line unclear-type:off
            // $FlowFixMe[missing-local-annot]
            set: (node, newValue)=>setRecoilValue$3(store, node, newValue),
            // $FlowFixMe[missing-local-annot]
            reset: (node)=>setRecoilValue$3(store, node, DEFAULT_VALUE$5),
            // $FlowFixMe[missing-local-annot]
            refresh: (node)=>refreshRecoilValue$1(store, node),
            gotoSnapshot: (snapshot)=>gotoSnapshot$1(store, snapshot),
            transact_UNSTABLE: (transaction)=>atomicUpdater$1(store)(transaction)
        }, {
            snapshot: ()=>{
                const snapshot = cloneSnapshot$2(store);
                releaseSnapshot = snapshot.retain();
                return snapshot;
            }
        });
        const callback = fn(callbackInterface);
        if (typeof callback !== "function") throw Recoil_err(errMsg);
        ret = callback(...args);
    });
    !!(ret instanceof Sentinel) && Recoil_invariant(false);
    if (Recoil_isPromise(ret)) ret = ret.finally(()=>{
        var _releaseSnapshot;
        (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 || _releaseSnapshot();
    });
    else {
        var _releaseSnapshot2;
        (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 || _releaseSnapshot2();
    }
    return ret;
}
function useRecoilCallback(fn, deps) {
    const storeRef = useStoreRef$6();
    return useCallback$3((...args)=>{
        return recoilCallback(storeRef.current, fn, args);
    }, deps != null ? [
        ...deps,
        storeRef
    ] : undefined // eslint-disable-line fb-www/react-hooks-deps
    );
}
var Recoil_useRecoilCallback = {
    recoilCallback,
    useRecoilCallback
};
const { useStoreRef: useStoreRef$7 } = Recoil_RecoilRoot;
const { refreshRecoilValue: refreshRecoilValue$2 } = Recoil_RecoilValueInterface;
const { useCallback: useCallback$4 } = (0, _reactDefault.default);
function useRecoilRefresher(recoilValue) {
    const storeRef = useStoreRef$7();
    return useCallback$4(()=>{
        const store = storeRef.current;
        refreshRecoilValue$2(store, recoilValue);
    }, [
        recoilValue,
        storeRef
    ]);
}
var Recoil_useRecoilRefresher = useRecoilRefresher;
const { atomicUpdater: atomicUpdater$2 } = Recoil_AtomicUpdates$1;
const { useStoreRef: useStoreRef$8 } = Recoil_RecoilRoot;
const { useMemo: useMemo$3 } = (0, _reactDefault.default);
function useRecoilTransaction(fn, deps) {
    const storeRef = useStoreRef$8();
    return useMemo$3(()=>(...args)=>{
            const atomicUpdate = atomicUpdater$2(storeRef.current);
            atomicUpdate((transactionInterface)=>{
                fn(transactionInterface)(...args);
            });
        }, deps != null ? [
        ...deps,
        storeRef
    ] : undefined // eslint-disable-line fb-www/react-hooks-deps
    );
}
var Recoil_useRecoilTransaction = useRecoilTransaction;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class WrappedValue {
    constructor(value){
        _defineProperty(this, "value", void 0);
        this.value = value;
    }
}
var Recoil_Wrapper = {
    WrappedValue
};
var Recoil_Wrapper_1 = Recoil_Wrapper.WrappedValue;
var Recoil_Wrapper$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    WrappedValue: Recoil_Wrapper_1
});
const { isFastRefreshEnabled: isFastRefreshEnabled$2 } = Recoil_ReactMode;
class ChangedPathError extends Error {
}
class TreeCache {
    // $FlowIssue[unclear-type]
    constructor(options){
        var _options$onHit, _options$onSet, _options$mapNodeValue;
        _defineProperty(this, "_name", void 0);
        _defineProperty(this, "_numLeafs", void 0);
        _defineProperty(this, "_root", void 0);
        _defineProperty(this, "_onHit", void 0);
        _defineProperty(this, "_onSet", void 0);
        _defineProperty(this, "_mapNodeValue", void 0);
        this._name = options === null || options === void 0 ? void 0 : options.name;
        this._numLeafs = 0;
        this._root = null;
        this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : ()=>{};
        this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : ()=>{};
        this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : (val)=>val;
    }
    size() {
        return this._numLeafs;
    }
    root() {
        return this._root;
    }
    get(getNodeValue, handlers) {
        var _this$getLeafNode;
        return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
    }
    getLeafNode(getNodeValue, handlers) {
        if (this._root == null) return undefined;
         // Iterate down the tree based on the current node values until we hit a leaf
        // $FlowIssue[unclear-type]
        let node = this._root;
        while(node){
            handlers === null || handlers === void 0 || handlers.onNodeVisit(node);
            if (node.type === "leaf") {
                this._onHit(node);
                return node;
            }
            const nodeValue = this._mapNodeValue(getNodeValue(node.nodeKey));
            node = node.branches.get(nodeValue);
        }
        return undefined;
    }
    set(route, value, handlers) {
        const addLeaf = ()=>{
            var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;
            // First, setup the branch nodes for the route:
            // Iterate down the tree to find or add branch nodes following the route
            let node;
            let branchKey;
            for (const [nodeKey, nodeValue] of route){
                var _node, _handlers$onNodeVisit, _this$_root;
                // If the previous root was a leaf, while we not have a get(), it means
                // the selector has inconsistent values or implementation changed.
                const root = this._root;
                if ((root === null || root === void 0 ? void 0 : root.type) === "leaf") throw this.invalidCacheError();
                 // node now refers to the next node down in the tree
                const parent = node; // $FlowFixMe[prop-missing]
                // $FlowFixMe[incompatible-type]
                node = parent ? parent.branches.get(branchKey) : root; // $FlowFixMe[prop-missing]
                // $FlowFixMe[incompatible-type]
                node = (_node = node) !== null && _node !== void 0 ? _node : {
                    type: "branch",
                    nodeKey,
                    parent,
                    branches: new Map(),
                    branchKey
                }; // If we found an existing node, confirm it has a consistent value
                if (node.type !== "branch" || node.nodeKey !== nodeKey) throw this.invalidCacheError();
                 // Add the branch node to the tree
                parent === null || parent === void 0 || parent.branches.set(branchKey, node);
                handlers === null || handlers === void 0 || (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 || _handlers$onNodeVisit.call(handlers, node); // Prepare for next iteration and install root if it is new.
                branchKey = this._mapNodeValue(nodeValue);
                this._root = (_this$_root = this._root) !== null && _this$_root !== void 0 ? _this$_root : node;
            } // Second, setup the leaf node:
            // If there is an existing leaf for this route confirm it is consistent
            const oldLeaf = node ? (_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : this._root;
            if (oldLeaf != null && (oldLeaf.type !== "leaf" || oldLeaf.branchKey !== branchKey)) throw this.invalidCacheError();
             // Create a new or replacement leaf.
            const leafNode = {
                type: "leaf",
                value,
                parent: node,
                branchKey
            }; // Install the leaf and call handlers
            (_node3 = node) === null || _node3 === void 0 || _node3.branches.set(branchKey, leafNode);
            this._root = (_this$_root2 = this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
            this._numLeafs++;
            this._onSet(leafNode);
            handlers === null || handlers === void 0 || (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 || _handlers$onNodeVisit2.call(handlers, leafNode);
        };
        try {
            addLeaf();
        } catch (error) {
            // If the cache was stale or observed inconsistent values, such as with
            // Fast Refresh, then clear it and rebuild with the new values.
            if (error instanceof ChangedPathError) {
                this.clear();
                addLeaf();
            } else throw error;
        }
    }
    delete(leaf) {
        const root = this.root();
        if (!root) return false;
        if (leaf === root) {
            this._root = null;
            this._numLeafs = 0;
            return true;
        } // Iterate up from the leaf deleteing it from it's parent's branches.
        let node = leaf.parent;
        let branchKey = leaf.branchKey;
        while(node){
            var _node4;
            node.branches.delete(branchKey); // Stop iterating if we hit the root.
            if (node === root) {
                if (node.branches.size === 0) {
                    this._root = null;
                    this._numLeafs = 0;
                } else this._numLeafs--;
                return true;
            } // Stop iterating if there are other branches since we don't need to
            // remove any more nodes.
            if (node.branches.size > 0) break;
             // Iterate up to our parent
            branchKey = (_node4 = node) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
            node = node.parent;
        } // Confirm that the leaf we are deleting is actually attached to our tree
        for(; node !== root; node = node.parent){
            if (node == null) return false;
        }
        this._numLeafs--;
        return true;
    }
    clear() {
        this._numLeafs = 0;
        this._root = null;
    }
    invalidCacheError() {
        const CHANGED_PATH_ERROR_MESSAGE = isFastRefreshEnabled$2() ? "Possible Fast Refresh module reload detected.  This may also be caused by an selector returning inconsistent values. Resetting cache." : "Invalid cache values.  This happens when selectors do not return consistent values for the same input dependency values.  That may also be caused when using Fast Refresh to change a selector implementation.  Resetting cache.";
        Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? ` - ${this._name}` : ""));
        throw new ChangedPathError();
    }
}
var Recoil_TreeCache = {
    TreeCache
};
var Recoil_TreeCache_1 = Recoil_TreeCache.TreeCache;
var Recoil_TreeCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TreeCache: Recoil_TreeCache_1
});
class LRUCache {
    constructor(options){
        var _options$mapKey;
        _defineProperty(this, "_maxSize", void 0);
        _defineProperty(this, "_size", void 0);
        _defineProperty(this, "_head", void 0);
        _defineProperty(this, "_tail", void 0);
        _defineProperty(this, "_map", void 0);
        _defineProperty(this, "_keyMapper", void 0);
        this._maxSize = options.maxSize;
        this._size = 0;
        this._head = null;
        this._tail = null;
        this._map = new Map();
        this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : (v)=>v;
    }
    head() {
        return this._head;
    }
    tail() {
        return this._tail;
    }
    size() {
        return this._size;
    }
    maxSize() {
        return this._maxSize;
    }
    has(key) {
        return this._map.has(this._keyMapper(key));
    }
    get(key) {
        const mappedKey = this._keyMapper(key);
        const node = this._map.get(mappedKey);
        if (!node) return undefined;
        this.set(key, node.value);
        return node.value;
    }
    set(key, val) {
        const mappedKey = this._keyMapper(key);
        const existingNode = this._map.get(mappedKey);
        if (existingNode) this.delete(key);
        const head = this.head();
        const node = {
            key,
            right: head,
            left: null,
            value: val
        };
        if (head) head.left = node;
        else this._tail = node;
        this._map.set(mappedKey, node);
        this._head = node;
        this._size++;
        this._maybeDeleteLRU();
    }
    _maybeDeleteLRU() {
        if (this.size() > this.maxSize()) this.deleteLru();
    }
    deleteLru() {
        const tail = this.tail();
        if (tail) this.delete(tail.key);
    }
    delete(key) {
        const mappedKey = this._keyMapper(key);
        if (!this._size || !this._map.has(mappedKey)) return;
        const node = Recoil_nullthrows(this._map.get(mappedKey));
        const right = node.right;
        const left = node.left;
        if (right) right.left = node.left;
        if (left) left.right = node.right;
        if (node === this.head()) this._head = right;
        if (node === this.tail()) this._tail = left;
        this._map.delete(mappedKey);
        this._size--;
    }
    clear() {
        this._size = 0;
        this._head = null;
        this._tail = null;
        this._map = new Map();
    }
}
var Recoil_LRUCache = {
    LRUCache
};
var Recoil_LRUCache_1 = Recoil_LRUCache.LRUCache;
var Recoil_LRUCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    LRUCache: Recoil_LRUCache_1
});
const { LRUCache: LRUCache$1 } = Recoil_LRUCache$1;
const { TreeCache: TreeCache$1 } = Recoil_TreeCache$1;
function treeCacheLRU({ name, maxSize, mapNodeValue = (v)=>v }) {
    const lruCache = new LRUCache$1({
        maxSize
    });
    const cache = new TreeCache$1({
        name,
        mapNodeValue,
        onHit: (node)=>{
            lruCache.set(node, true);
        },
        onSet: (node)=>{
            const lruNode = lruCache.tail();
            lruCache.set(node, true);
            if (lruNode && cache.size() > maxSize) // $FlowFixMe[incompatible-call]
            cache.delete(lruNode.key);
        }
    });
    return cache;
}
var Recoil_treeCacheLRU = treeCacheLRU;
const TIME_WARNING_THRESHOLD_MS = 15;
function stringify(x, opt, key) {
    // A optimization to avoid the more expensive JSON.stringify() for simple strings
    // This may lose protection for u2028 and u2029, though.
    if (typeof x === "string" && !x.includes('"') && !x.includes("\\")) return `"${x}"`;
     // Handle primitive types
    switch(typeof x){
        case "undefined":
            return "";
        // JSON.stringify(undefined) returns undefined, but we always want to return a string
        case "boolean":
            return x ? "true" : "false";
        case "number":
        case "symbol":
            // case 'bigint': // BigInt is not supported in www
            return String(x);
        case "string":
            // Add surrounding quotes and escape internal quotes
            return JSON.stringify(x);
        case "function":
            if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) throw Recoil_err("Attempt to serialize function in a Recoil cache key");
            return `__FUNCTION(${x.name})__`;
    }
    if (x === null) return "null";
     // Fallback case for unknown types
    if (typeof x !== "object") {
        var _JSON$stringify;
        return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "";
    } // Deal with all promises as equivalent for now.
    if (Recoil_isPromise(x)) return "__PROMISE__";
     // Arrays handle recursive stringification
    if (Array.isArray(x)) // $FlowFixMe[missing-local-annot]
    return `[${x.map((v, i)=>stringify(v, opt, i.toString()))}]`;
     // If an object defines a toJSON() method, then use that to override the
    // serialization.  This matches the behavior of JSON.stringify().
    // Pass the key for compatibility.
    // Immutable.js collections define this method to allow us to serialize them.
    if (typeof x.toJSON === "function") // flowlint-next-line unclear-type: off
    return stringify(x.toJSON(key), opt, key);
     // For built-in Maps, sort the keys in a stable order instead of the
    // default insertion order.  Support non-string keys.
    if (x instanceof Map) {
        const obj = {};
        for (const [k, v] of x)// Stringify will escape any nested quotes
        obj[typeof k === "string" ? k : stringify(k, opt)] = v;
        return stringify(obj, opt, key);
    } // For built-in Sets, sort the keys in a stable order instead of the
    // default insertion order.
    if (x instanceof Set) return stringify(Array.from(x).sort((a, b)=>stringify(a, opt).localeCompare(stringify(b, opt))), opt, key);
     // Anything else that is iterable serialize as an Array.
    if (Symbol !== undefined && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === "function") // flowlint-next-line unclear-type: off
    return stringify(Array.from(x), opt, key);
     // For all other Objects, sort the keys in a stable order.
    return `{${Object.keys(x).filter((k)=>x[k] !== undefined).sort() // stringify the key to add quotes and escape any nested slashes or quotes.
    .map((k)=>`${stringify(k, opt)}:${stringify(x[k], opt, k)}`).join(",")}}`;
} // Utility similar to JSON.stringify() except:
// * Serialize built-in Sets as an Array
// * Serialize built-in Maps as an Object.  Supports non-string keys.
// * Serialize other iterables as arrays
// * Sort the keys of Objects and Maps to have a stable order based on string conversion.
//    This overrides their default insertion order.
// * Still uses toJSON() of any object to override serialization
// * Support Symbols (though don't guarantee uniqueness)
// * We could support BigInt, but Flow doesn't seem to like it.
// See Recoil_stableStringify-test.js for examples
function stableStringify(x, opt = {
    allowFunctions: false
}) {
    return stringify(x, opt);
}
var Recoil_stableStringify = stableStringify;
const { TreeCache: TreeCache$2 } = Recoil_TreeCache$1;
const defaultPolicy = {
    equality: "reference",
    eviction: "keep-all",
    maxSize: Infinity
};
function treeCacheFromPolicy({ equality = defaultPolicy.equality, eviction = defaultPolicy.eviction, maxSize = defaultPolicy.maxSize } = defaultPolicy, name) {
    const valueMapper = getValueMapper(equality);
    return getTreeCache(eviction, maxSize, valueMapper, name);
}
function getValueMapper(equality) {
    switch(equality){
        case "reference":
            return (val)=>val;
        case "value":
            return (val)=>Recoil_stableStringify(val);
    }
    throw Recoil_err(`Unrecognized equality policy ${equality}`);
}
function getTreeCache(eviction, maxSize, mapNodeValue, name) {
    switch(eviction){
        case "keep-all":
            return new TreeCache$2({
                name,
                mapNodeValue
            });
        case "lru":
            return Recoil_treeCacheLRU({
                name,
                maxSize: Recoil_nullthrows(maxSize),
                mapNodeValue
            });
        case "most-recent":
            return Recoil_treeCacheLRU({
                name,
                maxSize: 1,
                mapNodeValue
            });
    }
    throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}
var Recoil_treeCacheFromPolicy = treeCacheFromPolicy;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function isNode(object) {
    var _ownerDocument, _doc$defaultView;
    if (typeof window === "undefined") return false;
    const doc = object != null ? (_ownerDocument = object.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object : document;
    const defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
    return !!(object != null && (typeof defaultView.Node === "function" ? object instanceof defaultView.Node : typeof object === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string"));
}
var Recoil_isNode = isNode;
const { isReactNative: isReactNative$1, isWindow: isWindow$1 } = Recoil_Environment;
function shouldNotBeFrozen(value) {
    // Primitives and functions:
    if (value === null || typeof value !== "object") return true;
     // React elements:
    switch(typeof value.$$typeof){
        case "symbol":
            return true;
        case "number":
            return true;
    } // Immutable structures:
    if (value["@@__IMMUTABLE_ITERABLE__@@"] != null || value["@@__IMMUTABLE_KEYED__@@"] != null || value["@@__IMMUTABLE_INDEXED__@@"] != null || value["@@__IMMUTABLE_ORDERED__@@"] != null || value["@@__IMMUTABLE_RECORD__@@"] != null) return true;
     // DOM nodes:
    if (Recoil_isNode(value)) return true;
    if (Recoil_isPromise(value)) return true;
    if (value instanceof Error) return true;
    if (ArrayBuffer.isView(value)) return true;
     // Some environments, just as Jest, don't work with the instanceof check
    if (!isReactNative$1 && isWindow$1(value)) return true;
    return false;
} // Recursively freeze a value to enforce it is read-only.
// This may also have minimal performance improvements for enumerating
// objects (based on browser implementations, of course)
function deepFreezeValue(value) {
    if (typeof value !== "object" || shouldNotBeFrozen(value)) return;
    Object.freeze(value); // Make all properties read-only
    for(const key in value)// $FlowIssue[method-unbinding] added when improving typing for this parameters
    if (Object.prototype.hasOwnProperty.call(value, key)) {
        const prop = value[key]; // Prevent infinite recurssion for circular references.
        if (typeof prop === "object" && prop != null && !Object.isFrozen(prop)) deepFreezeValue(prop);
    }
    Object.seal(value); // This also makes existing properties non-configurable.
}
var Recoil_deepFreezeValue = deepFreezeValue;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is a stub for some integration into FB internal stuff
 *
 * 
 * @format
 * @oncall recoil
 */ function startPerfBlock(_id) {
    return ()=>null;
}
var Recoil_PerformanceTimings = {
    startPerfBlock
};
const { isLoadable: isLoadable$1, loadableWithError: loadableWithError$1, loadableWithPromise: loadableWithPromise$1, loadableWithValue: loadableWithValue$2 } = Recoil_Loadable$1;
const { WrappedValue: WrappedValue$1 } = Recoil_Wrapper$1;
const { getNodeLoadable: getNodeLoadable$2, peekNodeLoadable: peekNodeLoadable$1, setNodeValue: setNodeValue$3 } = Recoil_FunctionalCore;
const { saveDepsToStore: saveDepsToStore$1 } = Recoil_Graph;
const { DEFAULT_VALUE: DEFAULT_VALUE$6, getConfigDeletionHandler: getConfigDeletionHandler$1, getNode: getNode$6, registerNode: registerNode$1 } = Recoil_Node;
const { isRecoilValue: isRecoilValue$3 } = Recoil_RecoilValue$1;
const { markRecoilValueModified: markRecoilValueModified$1 } = Recoil_RecoilValueInterface;
const { retainedByOptionWithDefault: retainedByOptionWithDefault$1 } = Recoil_Retention;
const { recoilCallback: recoilCallback$1 } = Recoil_useRecoilCallback;
const { startPerfBlock: startPerfBlock$1 } = Recoil_PerformanceTimings;
class Canceled {
}
const CANCELED = new Canceled();
/**
 * An ExecutionID is an arbitrary ID that lets us distinguish executions from
 * each other. This is necessary as we need a way of solving this problem:
 * "given 3 async executions, only update state for the 'latest' execution when
 * it finishes running regardless of when the other 2 finish". ExecutionIDs
 * provide a convenient way of identifying executions so that we can track and
 * manage them over time.
 */ const dependencyStack = []; // for detecting circular dependencies.
const waitingStores = new Map();
const getNewExecutionID = (()=>{
    let executionID = 0;
    return ()=>executionID++;
})();
/* eslint-disable no-redeclare */ function selector(options) {
    let recoilValue = null;
    const { key, get, cachePolicy_UNSTABLE: cachePolicy } = options;
    const set = options.set != null ? options.set : undefined; // flow
    const discoveredDependencyNodeKeys = new Set();
    const cache = Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
        equality: "reference",
        eviction: "keep-all"
    }, key);
    const retainedBy = retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
    const executionInfoMap = new Map();
    let liveStoresCount = 0;
    function selectorIsLive() {
        return !Recoil_gkx("recoil_memory_managament_2020") || liveStoresCount > 0;
    }
    function selectorInit(store) {
        store.getState().knownSelectors.add(key);
        liveStoresCount++;
        return ()=>{
            liveStoresCount--;
        };
    }
    function selectorShouldDeleteConfigOnRelease() {
        return getConfigDeletionHandler$1(key) !== undefined && !selectorIsLive();
    }
    function resolveAsync(store, state, executionID, loadable, depValues) {
        setCache(state, loadable, depValues);
        notifyStoresOfResolvedAsync(store, executionID);
    }
    function notifyStoresOfResolvedAsync(store, executionID) {
        if (isLatestExecution(store, executionID)) clearExecutionInfo(store);
        notifyWaitingStores(executionID, true);
    }
    /**
   * Notify stores to pull the selector again if a new async dep was discovered.
   * 1) Async selector adds a new dep but doesn't resolve yet.
   *    Note that deps for an async selector are based on the state when the
   *    evaluation started, in order to provide a consistent picture of state.
   * 2) But, new value of dep based on the current state might cause the selector
   *    to resolve or resolve differently.
   * 3) Therefore, this notification will pull the selector based on the current
   *    state for the components
   */ function notifyStoresOfNewAsyncDep(store, executionID) {
        if (isLatestExecution(store, executionID)) {
            const executionInfo = Recoil_nullthrows(getExecutionInfo(store));
            executionInfo.stateVersions.clear();
            notifyWaitingStores(executionID, false);
        }
    }
    function notifyWaitingStores(executionID, clearWaitlist) {
        const stores = waitingStores.get(executionID);
        if (stores != null) {
            for (const waitingStore of stores)markRecoilValueModified$1(waitingStore, Recoil_nullthrows(recoilValue));
            if (clearWaitlist) waitingStores.delete(executionID);
        }
    }
    function markStoreWaitingForResolvedAsync(store, executionID) {
        let stores = waitingStores.get(executionID);
        if (stores == null) waitingStores.set(executionID, stores = new Set());
        stores.add(store);
    }
    /**
   * This function attaches a then() and a catch() to a promise that was
   * returned from a selector's get() (either explicitly or implicitly by
   * running a function that uses the "async" keyword). If a selector's get()
   * returns a promise, we have two possibilities:
   *
   * 1. The promise will resolve, in which case it will have completely finished
   *    executing without any remaining pending dependencies. No more retries
   *    are needed and we can proceed with updating the cache and notifying
   *    subscribers (if it is the latest execution, otherwise only the cache
   *    will be updated and subscriptions will not be fired). This is the case
   *    handled by the attached then() handler.
   *
   * 2. The promise will throw because it either has an error or it came across
   *    an async dependency that has not yet resolved, in which case we will
   *    call wrapDepdencyPromise(), whose responsibility is to handle dependency
   *    promises. This case is handled by the attached catch() handler.
   *
   * Both branches will eventually resolve to the final result of the selector
   * (or an error if a real error occurred).
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was thrown--AKA a
   * dependency promise. Dependency promises should be passed to
   * wrapPendingDependencyPromise()).
   */ function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
        return promise.then((value)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw CANCELED;
            }
            const loadable = loadableWithValue$2(value);
            resolveAsync(store, state, executionID, loadable, depValues);
            return value;
        }).catch((errorOrPromise)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw CANCELED;
            }
            if (Recoil_isPromise(errorOrPromise)) return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
            const loadable = loadableWithError$1(errorOrPromise);
            resolveAsync(store, state, executionID, loadable, depValues);
            throw errorOrPromise;
        });
    }
    /**
   * This function attaches a then() and a catch() to a promise that was
   * thrown from a selector's get(). If a selector's get() throws a promise,
   * we have two possibilities:
   *
   * 1. The promise will resolve, meaning one of our selector's dependencies is
   *    now available and we should "retry" our get() by running it again. This
   *    is the case handled by the attached then() handler.
   *
   * 2. The promise will throw because something went wrong with the dependency
   *    promise (in other words a real error occurred). This case is handled by
   *    the attached catch() handler. If the dependency promise throws, it is
   *    _always_ a real error and not another dependency promise (any dependency
   *    promises would have been handled upstream).
   *
   * The then() branch will eventually resolve to the final result of the
   * selector (or an error if a real error occurs), and the catch() will always
   * resolve to an error because the dependency promise is a promise that was
   * wrapped upstream, meaning it will only resolve to its real value or to a
   * real error.
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was returned from
   * get(). The intention is that this function is only passed promises that
   * were thrown due to a pending dependency. Promises returned by get() should
   * be passed to wrapResultPromise() instead.
   */ function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
        return promise.then((resolvedDep)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw CANCELED;
            } // Check if we are handling a pending Recoil dependency or if the user
            // threw their own Promise to "suspend" a selector evaluation.  We need
            // to check that the loadingDepPromise actually matches the promise that
            // we caught in case the selector happened to catch the promise we threw
            // for a pending Recoil dependency from `getRecoilValue()` and threw
            // their own promise instead.
            if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) /**
         * Note for async atoms, this means we are changing the atom's value
         * in the store for the given version. This should be alright because
         * the version of state is now stale and a new version will have
         * already been triggered by the atom being resolved (see this logic
         * in Recoil_atom.js)
         */ state.atomValues.set(loadingDepsState.loadingDepKey, loadableWithValue$2(resolvedDep));
            else /**
         * If resolvedDepKey is not defined, the promise was a user-thrown
         * promise. User-thrown promises are an advanced feature and they
         * should be avoided in almost all cases. Using `loadable.map()` inside
         * of selectors for loading loadables and then throwing that mapped
         * loadable's promise is an example of a user-thrown promise.
         *
         * When we hit a user-thrown promise, we have to bail out of an optimization
         * where we bypass calculating selector cache keys for selectors that
         * have been previously seen for a given state (these selectors are saved in
         * state.atomValues) to avoid stale state as we have no way of knowing
         * what state changes happened (if any) in result to the promise resolving.
         *
         * Ideally we would only bail out selectors that are in the chain of
         * dependencies for this selector, but there's currently no way to get
         * a full list of a selector's downstream nodes because the state that
         * is executing may be a discarded tree (so store.getGraph(state.version)
         * will be empty), and the full dep tree may not be in the selector
         * caches in the case where the selector's cache was cleared. To solve
         * for this we would have to keep track of all running selector
         * executions and their downstream deps. Because this only covers edge
         * cases, that complexity might not be justifyable.
         */ store.getState().knownSelectors.forEach((nodeKey)=>{
                state.atomValues.delete(nodeKey);
            });
            /**
       * Optimization: Now that the dependency has resolved, let's try hitting
       * the cache in case the dep resolved to a value we have previously seen.
       *
       * TODO:
       * Note this optimization is not perfect because it only prevents re-executions
       * _after_ the point where an async dependency is found. Any code leading
       * up to the async dependency may have run unnecessarily. The ideal case
       * would be to wait for the async dependency to resolve first, check the
       * cache, and prevent _any_ execution of the selector if the resulting
       * value of the dependency leads to a path that is found in the cache.
       * The ideal case is more difficult to implement as it would require that
       * we capture and wait for the the async dependency right after checking
       * the cache. The current approach takes advantage of the fact that running
       * the selector already has a code path that lets us exit early when
       * an async dep resolves.
       */ const cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);
            if (cachedLoadable && cachedLoadable.state !== "loading") {
                /**
         * This has to notify stores of a resolved async, even if there is no
         * current pending execution for the following case:
         * 1) A component renders with this pending loadable.
         * 2) The upstream dependency resolves.
         * 3) While processing some other selector it reads this one, such as
         *    while traversing its dependencies.  At this point it gets the
         *    new resolved value synchronously and clears the current
         *    execution ID.  The component wasn't getting the value itself,
         *    though, so it still has the pending loadable.
         * 4) When this code executes the current execution id was cleared
         *    and it wouldn't notify the component of the new value.
         *
         * I think this is only an issue with "early" rendering since the
         * components got their value using the in-progress execution.
         * We don't have a unit test for this case yet.  I'm not sure it is
         * necessary with recoil_transition_support mode.
         */ if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) notifyStoresOfResolvedAsync(store, executionID);
                if (cachedLoadable.state === "hasValue") return cachedLoadable.contents;
                else throw cachedLoadable.contents;
            }
            /**
       * If this execution is stale, let's check to see if there is some in
       * progress execution with a matching state. If we find a match, then
       * we can take the value from that in-progress execution. Note this may
       * sound like an edge case, but may be very common in cases where a
       * loading dependency resolves from loading to having a value (thus
       * possibly triggering a re-render), and React re-renders before the
       * chained .then() functions run, thus starting a new execution as the
       * dep has changed value. Without this check we will run the selector
       * twice (once in the new execution and once again in this .then(), so
       * this check is necessary to keep unnecessary re-executions to a
       * minimum).
       *
       * Also note this code does not check across all executions that may be
       * running. It only optimizes for the _latest_ execution per store as
       * we currently do not maintain a list of all currently running executions.
       * This means in some cases we may run selectors more than strictly
       * necessary when there are multiple executions running for the same
       * selector. This may be a valid tradeoff as checking for dep changes
       * across all in-progress executions may take longer than just
       * re-running the selector. This will be app-dependent, and maybe in the
       * future we can make the behavior configurable. An ideal fix may be
       * to extend the tree cache to support caching loading states.
       */ if (!isLatestExecution(store, executionID)) {
                const executionInfo = getInProgressExecutionInfo(store, state);
                if (executionInfo != null) /**
           * Returning promise here without wrapping as the wrapper logic was
           * already done upstream when this promise was generated.
           */ return executionInfo.loadingLoadable.contents;
            } // Retry the selector evaluation now that the dependency has resolved
            const [loadable, depValues] = evaluateSelectorGetter(store, state, executionID);
            if (loadable.state !== "loading") resolveAsync(store, state, executionID, loadable, depValues);
            if (loadable.state === "hasError") throw loadable.contents;
            return loadable.contents;
        }).catch((error)=>{
            // The selector was released since the request began; ignore the response.
            if (error instanceof Canceled) throw CANCELED;
            if (!selectorIsLive()) {
                clearExecutionInfo(store);
                throw CANCELED;
            }
            const loadable = loadableWithError$1(error);
            resolveAsync(store, state, executionID, loadable, existingDeps);
            throw error;
        });
    }
    function updateDeps(store, state, deps, executionID) {
        var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;
        if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
            var _store$getState$nextT, _store$getState3, _store$getState3$next;
            saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
        }
        for (const nodeKey of deps)discoveredDependencyNodeKeys.add(nodeKey);
    }
    function evaluateSelectorGetter(store, state, executionID) {
        const endPerfBlock = startPerfBlock$1(key); // TODO T63965866: use execution ID here
        let duringSynchronousExecution = true;
        let duringAsynchronousExecution = true;
        const finishEvaluation = ()=>{
            endPerfBlock();
            duringAsynchronousExecution = false;
        };
        let result;
        let resultIsError = false;
        let loadable;
        const loadingDepsState = {
            loadingDepKey: null,
            loadingDepPromise: null
        };
        /**
     * Starting a fresh set of deps that we'll be using to update state. We're
     * starting a new set versus adding it in existing state deps because
     * the version of state that we update deps for may be a more recent version
     * than the version the selector was called with. This is because the latest
     * execution will update the deps of the current/latest version of state
     * (This is safe to do because the fact that the selector is the latest
     * execution means the deps we discover below are our best guess at the
     * deps for the current/latest state in the store)
     */ const depValues = new Map();
        function getRecoilValue({ key: depKey }) {
            const depLoadable = getNodeLoadable$2(store, state, depKey);
            depValues.set(depKey, depLoadable); // We need to update asynchronous dependencies as we go so the selector
            // knows if it has to restart evaluation if one of them is updated before
            // the asynchronous selector completely resolves.
            if (!duringSynchronousExecution) {
                updateDeps(store, state, new Set(depValues.keys()), executionID);
                notifyStoresOfNewAsyncDep(store, executionID);
            }
            switch(depLoadable.state){
                case "hasValue":
                    return depLoadable.contents;
                case "hasError":
                    throw depLoadable.contents;
                case "loading":
                    loadingDepsState.loadingDepKey = depKey;
                    loadingDepsState.loadingDepPromise = depLoadable.contents;
                    throw depLoadable.contents;
            }
            throw Recoil_err("Invalid Loadable state");
        }
        const getCallback = (fn)=>{
            return (...args)=>{
                if (duringAsynchronousExecution) throw Recoil_err("Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.");
                !(recoilValue != null) && Recoil_invariant(false);
                return recoilCallback$1(store, fn, args, {
                    node: recoilValue
                } // flowlint-line unclear-type:off
                );
            };
        };
        try {
            result = get({
                get: getRecoilValue,
                getCallback
            });
            result = isRecoilValue$3(result) ? getRecoilValue(result) : result;
            if (isLoadable$1(result)) {
                if (result.state === "hasError") resultIsError = true;
                result = result.contents;
            }
            if (Recoil_isPromise(result)) result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
            else finishEvaluation();
            result = result instanceof WrappedValue$1 ? result.value : result;
        } catch (errorOrDepPromise) {
            result = errorOrDepPromise;
            if (Recoil_isPromise(result)) result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
            else {
                resultIsError = true;
                finishEvaluation();
            }
        }
        if (resultIsError) loadable = loadableWithError$1(result);
        else if (Recoil_isPromise(result)) loadable = loadableWithPromise$1(result);
        else loadable = loadableWithValue$2(result);
        duringSynchronousExecution = false;
        updateExecutionInfoDepValues(store, executionID, depValues);
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        return [
            loadable,
            depValues
        ];
    }
    function getLoadableFromCacheAndUpdateDeps(store, state) {
        // First, look up in the state cache
        // If it's here, then the deps in the store should already be valid.
        let cachedLoadable = state.atomValues.get(key);
        if (cachedLoadable != null) return cachedLoadable;
         // Second, look up in the selector cache and update the deps in the store
        const depsAfterCacheLookup = new Set();
        try {
            cachedLoadable = cache.get((nodeKey)=>{
                !(typeof nodeKey === "string") && Recoil_invariant(false);
                return getNodeLoadable$2(store, state, nodeKey).contents;
            }, {
                onNodeVisit: (node)=>{
                    if (node.type === "branch" && node.nodeKey !== key) depsAfterCacheLookup.add(node.nodeKey);
                }
            });
        } catch (error) {
            throw Recoil_err(`Problem with cache lookup for selector "${key}": ${error.message}`);
        }
        if (cachedLoadable) {
            var _getExecutionInfo;
            // Cache the results in the state to allow for cheaper lookup than
            // iterating the tree cache of dependencies.
            state.atomValues.set(key, cachedLoadable);
            /**
       * Ensure store contains correct dependencies if we hit the cache so that
       * the store deps and cache are in sync for a given state. This is important
       * because store deps are normally updated when new executions are created,
       * but cache hits don't trigger new executions but they still _may_ signify
       * a change in deps in the store if the store deps for this state are empty
       * or stale.
       */ updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
        }
        return cachedLoadable;
    }
    /**
   * Given a tree state, this function returns a Loadable of the current state.
   *
   * The selector's get() function will only be re-evaluated if _both_ of the
   * following statements are true:
   *
   * 1. The current dep values from the given state produced a cache key that
   *    was not found in the cache.
   * 2. There is no currently running async execution OR there is an
   *    async execution that is running, but after comparing the dep values in
   *    the given state with the dep values that the execution has discovered so
   *    far we find that at least one dep value has changed, in which case we
   *    start a new execution (the previously running execution will continue to
   *    run to completion, but only the new execution will be deemed the
   *    'latest' execution, meaning it will be the only execution that will
   *    update global state when it is finished. Any non-latest executions will
   *    run to completion and update the selector cache but not global state).
   */ function getSelectorLoadableAndUpdateDeps(store, state) {
        // First, see if our current state is cached
        const cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);
        if (cachedVal != null) {
            clearExecutionInfo(store);
            return cachedVal;
        } // Second, check if there is already an ongoing execution based on the current state
        const inProgressExecutionInfo = getInProgressExecutionInfo(store, state);
        if (inProgressExecutionInfo != null) {
            var _inProgressExecutionI;
            if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === "loading") markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
             // FIXME: check after the fact to see if we made the right choice by waiting
            return inProgressExecutionInfo.loadingLoadable;
        } // Third, start a new evaluation of the selector
        const newExecutionID = getNewExecutionID();
        const [loadable, newDepValues] = evaluateSelectorGetter(store, state, newExecutionID);
        /**
     * Conditionally updates the cache with a given loadable.
     *
     * We only cache loadables that are not loading because our cache keys are
     * based on dep values, which are in an unfinished state for loadables that
     * have a 'loading' state (new deps may be discovered while the selector
     * runs its async code). We never want to cache partial dependencies b/c it
     * could lead to errors, such as prematurely returning the result based on a
     * partial list of deps-- we need the full list of deps to ensure that we
     * are returning the correct result from cache.
     */ if (loadable.state === "loading") {
            setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
            markStoreWaitingForResolvedAsync(store, newExecutionID);
        } else {
            clearExecutionInfo(store);
            setCache(state, loadable, newDepValues);
        }
        return loadable;
    }
    /**
   * Searches execution info across all stores to see if there is an in-progress
   * execution whose dependency values match the values of the requesting store.
   */ function getInProgressExecutionInfo(store, state) {
        // Sort the pending executions so that our current store is checked first.
        const pendingExecutions = Recoil_concatIterables([
            executionInfoMap.has(store) ? [
                Recoil_nullthrows(executionInfoMap.get(store))
            ] : [],
            Recoil_mapIterable(Recoil_filterIterable(executionInfoMap, ([s])=>s !== store), ([, execInfo])=>execInfo)
        ]);
        function anyDepChanged(execDepValues) {
            for (const [depKey, execLoadable] of execDepValues){
                if (!getNodeLoadable$2(store, state, depKey).is(execLoadable)) return true;
            }
            return false;
        }
        for (const execInfo of pendingExecutions)if (// of state, then let's use it!
        execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
        !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)) {
            execInfo.stateVersions.set(state.version, true);
            return execInfo;
        } else execInfo.stateVersions.set(state.version, false);
        return undefined;
    }
    function getExecutionInfo(store) {
        return executionInfoMap.get(store);
    }
    /**
   * This function will update the selector's execution info when the selector
   * has either finished running an execution or has started a new execution. If
   * the given loadable is in a 'loading' state, the intention is that a new
   * execution has started. Otherwise, the intention is that an execution has
   * just finished.
   */ function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
        executionInfoMap.set(store, {
            depValuesDiscoveredSoFarDuringAsyncWork: depValues,
            executionID: newExecutionID,
            loadingLoadable: loadable,
            stateVersions: new Map([
                [
                    state.version,
                    true
                ]
            ])
        });
    }
    function updateExecutionInfoDepValues(store, executionID, depValues) {
        // We only need to bother updating the deps for the latest execution because
        // that's all getInProgressExecutionInfo() will be looking for.
        if (isLatestExecution(store, executionID)) {
            const executionInfo = getExecutionInfo(store);
            if (executionInfo != null) executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
        }
    }
    function clearExecutionInfo(store) {
        executionInfoMap.delete(store);
    }
    function isLatestExecution(store, executionID) {
        var _getExecutionInfo2;
        return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
    }
    /**
   * FIXME: dep keys should take into account the state of the loadable to
   * prevent the edge case where a loadable with an error and a loadable with
   * an error as a value are treated as the same thing incorrectly. For example
   * these two should be treated differently:
   *
   * selector({key: '', get: () => new Error('hi')});
   * selector({key: '', get () => {throw new Error('hi')}});
   *
   * With current implementation they are treated the same
   */ function depValuesToDepRoute(depValues) {
        return Array.from(depValues.entries()).map(([depKey, valLoadable])=>[
                depKey,
                valLoadable.contents
            ]);
    }
    function setCache(state, loadable, depValues) {
        state.atomValues.set(key, loadable);
        try {
            cache.set(depValuesToDepRoute(depValues), loadable);
        } catch (error) {
            throw Recoil_err(`Problem with setting cache for selector "${key}": ${error.message}`);
        }
    }
    function detectCircularDependencies(fn) {
        if (dependencyStack.includes(key)) {
            const message = `Recoil selector has circular dependencies: ${dependencyStack.slice(dependencyStack.indexOf(key)).join(" \u2192 ")}`;
            return loadableWithError$1(Recoil_err(message));
        }
        dependencyStack.push(key);
        try {
            return fn();
        } finally{
            dependencyStack.pop();
        }
    }
    function selectorPeek(store, state) {
        const cachedLoadable = state.atomValues.get(key);
        if (cachedLoadable != null) return cachedLoadable;
        return cache.get((nodeKey)=>{
            var _peekNodeLoadable;
            !(typeof nodeKey === "string") && Recoil_invariant(false);
            return (_peekNodeLoadable = peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
        });
    }
    function selectorGet(store, state) {
        return detectCircularDependencies(()=>getSelectorLoadableAndUpdateDeps(store, state));
    }
    function invalidateSelector(state) {
        state.atomValues.delete(key);
    }
    function clearSelectorCache(store, treeState) {
        !(recoilValue != null) && Recoil_invariant(false);
        for (const nodeKey of discoveredDependencyNodeKeys){
            var _node$clearCache;
            const node = getNode$6(nodeKey);
            (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 || _node$clearCache.call(node, store, treeState);
        }
        discoveredDependencyNodeKeys.clear();
        invalidateSelector(treeState);
        cache.clear();
        markRecoilValueModified$1(store, recoilValue);
    }
    if (set != null) {
        /**
     * ES5 strict mode prohibits defining non-top-level function declarations,
     * so don't use function declaration syntax here
     */ const selectorSet = (store, state, newValue)=>{
            let syncSelectorSetFinished = false;
            const writes = new Map();
            function getRecoilValue({ key: depKey }) {
                if (syncSelectorSetFinished) throw Recoil_err("Recoil: Async selector sets are not currently supported.");
                const loadable = getNodeLoadable$2(store, state, depKey);
                if (loadable.state === "hasValue") return loadable.contents;
                else if (loadable.state === "loading") {
                    const msg = `Getting value of asynchronous atom or selector "${depKey}" in a pending state while setting selector "${key}" is not yet supported.`;
                    Recoil_recoverableViolation(msg);
                    throw Recoil_err(msg);
                } else throw loadable.contents;
            }
            function setRecoilState(recoilState, valueOrUpdater // $FlowFixMe[missing-local-annot]
            ) {
                if (syncSelectorSetFinished) {
                    const msg = "Recoil: Async selector sets are not currently supported.";
                    Recoil_recoverableViolation(msg);
                    throw Recoil_err(msg);
                }
                const setValue = typeof valueOrUpdater === "function" ? // flowlint-next-line unclear-type:off
                valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
                const upstreamWrites = setNodeValue$3(store, state, recoilState.key, setValue);
                upstreamWrites.forEach((v, k)=>writes.set(k, v));
            }
            function resetRecoilState(recoilState) {
                setRecoilState(recoilState, DEFAULT_VALUE$6);
            }
            const ret = set({
                set: setRecoilState,
                get: getRecoilValue,
                reset: resetRecoilState
            }, newValue); // set should be a void method, but if the user makes it `async`, then it
            // will return a Promise, which we don't currently support.
            if (ret !== undefined) throw Recoil_isPromise(ret) ? Recoil_err("Recoil: Async selector sets are not currently supported.") : Recoil_err("Recoil: selector set should be a void function.");
            syncSelectorSetFinished = true;
            return writes;
        };
        return recoilValue = registerNode$1({
            key,
            nodeType: "selector",
            peek: selectorPeek,
            get: selectorGet,
            set: selectorSet,
            init: selectorInit,
            invalidate: invalidateSelector,
            clearCache: clearSelectorCache,
            shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
            dangerouslyAllowMutability: options.dangerouslyAllowMutability,
            shouldRestoreFromSnapshots: false,
            retainedBy
        });
    } else return recoilValue = registerNode$1({
        key,
        nodeType: "selector",
        peek: selectorPeek,
        get: selectorGet,
        init: selectorInit,
        invalidate: invalidateSelector,
        clearCache: clearSelectorCache,
        shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        shouldRestoreFromSnapshots: false,
        retainedBy
    });
}
/* eslint-enable no-redeclare */ // $FlowIssue[incompatible-use]
// $FlowFixMe[missing-local-annot]
selector.value = (value)=>new WrappedValue$1(value);
var Recoil_selector = selector;
// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
// @fb-only: const {scopedAtom} = require('Recoil_ScopedAtom');
const { isLoadable: isLoadable$2, loadableWithError: loadableWithError$2, loadableWithPromise: loadableWithPromise$2, loadableWithValue: loadableWithValue$3 } = Recoil_Loadable$1;
const { WrappedValue: WrappedValue$2 } = Recoil_Wrapper$1;
const { peekNodeInfo: peekNodeInfo$3 } = Recoil_FunctionalCore;
const { DEFAULT_VALUE: DEFAULT_VALUE$7, DefaultValue: DefaultValue$2, getConfigDeletionHandler: getConfigDeletionHandler$2, registerNode: registerNode$2, setConfigDeletionHandler: setConfigDeletionHandler$1 } = Recoil_Node;
const { isRecoilValue: isRecoilValue$4 } = Recoil_RecoilValue$1;
const { getRecoilValueAsLoadable: getRecoilValueAsLoadable$4, markRecoilValueModified: markRecoilValueModified$2, setRecoilValue: setRecoilValue$4, setRecoilValueLoadable: setRecoilValueLoadable$2 } = Recoil_RecoilValueInterface;
const { retainedByOptionWithDefault: retainedByOptionWithDefault$2 } = Recoil_Retention;
const unwrap = (x)=>x instanceof WrappedValue$2 ? x.value : x;
function baseAtom(options) {
    const { key, persistence_UNSTABLE: persistence } = options;
    const retainedBy = retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
    let liveStoresCount = 0;
    function unwrapPromise(promise) {
        return loadableWithPromise$2(promise.then((value)=>{
            defaultLoadable = loadableWithValue$3(value);
            return value;
        }).catch((error)=>{
            defaultLoadable = loadableWithError$2(error);
            throw error;
        }));
    }
    let defaultLoadable = Recoil_isPromise(options.default) ? unwrapPromise(options.default) : isLoadable$2(options.default) ? options.default.state === "loading" ? unwrapPromise(options.default.contents) : options.default : loadableWithValue$3(unwrap(options.default));
    maybeFreezeValueOrPromise(defaultLoadable.contents);
    let cachedAnswerForUnvalidatedValue = undefined; // Cleanup handlers for this atom
    // Rely on stable reference equality of the store to use it as a key per <RecoilRoot>
    const cleanupEffectsByStore = new Map();
    function maybeFreezeValueOrPromise(valueOrPromise) {
        var value;
        return valueOrPromise;
    }
    function wrapPendingPromise(store, promise) {
        const wrappedPromise = promise.then((value)=>{
            var _store$getState$nextT, _state$atomValues$get;
            const state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;
            if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) setRecoilValue$4(store, node, value);
            return value;
        }).catch((error)=>{
            var _store$getState$nextT2, _state$atomValues$get2;
            const state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;
            if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) setRecoilValueLoadable$2(store, node, loadableWithError$2(error));
            throw error;
        });
        return wrappedPromise;
    }
    function initAtom(store, initState, trigger) {
        var _options$effects;
        liveStoresCount++;
        const cleanupAtom = ()=>{
            var _cleanupEffectsByStor;
            liveStoresCount--;
            (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 || _cleanupEffectsByStor.forEach((cleanup)=>cleanup());
            cleanupEffectsByStore.delete(store);
        };
        store.getState().knownAtoms.add(key); // Setup async defaults to notify subscribers when they resolve
        if (defaultLoadable.state === "loading") {
            const notifyDefaultSubscribers = ()=>{
                var _store$getState$nextT3;
                const state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;
                if (!state.atomValues.has(key)) markRecoilValueModified$2(store, node);
            };
            defaultLoadable.contents.finally(notifyDefaultSubscribers);
        } ///////////////////
        // Run Atom Effects
        ///////////////////
        const effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;
        if (effects != null) {
            // This state is scoped by Store, since this is in the initAtom() closure
            let initValue = DEFAULT_VALUE$7;
            let isDuringInit = true;
            let isInitError = false;
            let pendingSetSelf = null;
            function getLoadable(recoilValue) {
                // Normally we can just get the current value of another atom.
                // But for our own value we need to check if there is a pending
                // initialized value or get the fallback default value.
                if (isDuringInit && recoilValue.key === key) {
                    // Cast T to S
                    const retValue = initValue; // flowlint-line unclear-type:off
                    return retValue instanceof DefaultValue$2 ? peekAtom(store, initState) // flowlint-line unclear-type:off
                     : Recoil_isPromise(retValue) ? loadableWithPromise$2(retValue.then((v)=>v instanceof DefaultValue$2 ? defaultLoadable.toPromise() // flowlint-line unclear-type:off
                         : v)) : loadableWithValue$3(retValue);
                }
                return getRecoilValueAsLoadable$4(store, recoilValue);
            }
            function getPromise(recoilValue) {
                return getLoadable(recoilValue).toPromise();
            }
            function getInfo_UNSTABLE(recoilValue) {
                var _store$getState$nextT4;
                const info = peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
                return isDuringInit && recoilValue.key === key && !(initValue instanceof DefaultValue$2) ? {
                    ...info,
                    isSet: true,
                    loadable: getLoadable(recoilValue)
                } : info;
            }
            const setSelf = (effect)=>(valueOrUpdater)=>{
                    if (isDuringInit) {
                        const currentLoadable = getLoadable(node);
                        const currentValue = currentLoadable.state === "hasValue" ? currentLoadable.contents : DEFAULT_VALUE$7;
                        initValue = typeof valueOrUpdater === "function" ? valueOrUpdater(currentValue) // flowlint-line unclear-type:off
                         : valueOrUpdater;
                        if (Recoil_isPromise(initValue)) initValue = initValue.then((value)=>{
                            // Avoid calling onSet() when setSelf() initializes with a Promise
                            pendingSetSelf = {
                                effect,
                                value
                            };
                            return value;
                        });
                    } else {
                        if (Recoil_isPromise(valueOrUpdater)) throw Recoil_err("Setting atoms to async values is not implemented.");
                        if (typeof valueOrUpdater !== "function") pendingSetSelf = {
                            effect,
                            value: unwrap(valueOrUpdater)
                        };
                        setRecoilValue$4(store, node, typeof valueOrUpdater === "function" ? (currentValue)=>{
                            const newValue = unwrap(valueOrUpdater(currentValue) // flowlint-line unclear-type:off
                            ); // $FlowFixMe[incompatible-type]
                            pendingSetSelf = {
                                effect,
                                value: newValue
                            };
                            return newValue;
                        } : unwrap(valueOrUpdater));
                    }
                };
            const resetSelf = (effect)=>()=>setSelf(effect)(DEFAULT_VALUE$7);
            const onSet = (effect)=>(handler)=>{
                    var _cleanupEffectsByStor2;
                    const { release } = store.subscribeToTransactions((currentStore)=>{
                        var _currentTree$atomValu;
                        // eslint-disable-next-line prefer-const
                        let { currentTree, previousTree } = currentStore.getState();
                        if (!previousTree) {
                            Recoil_recoverableViolation("Transaction subscribers notified without a next tree being present -- this is a bug in Recoil");
                            previousTree = currentTree; // attempt to trundle on
                        }
                        const newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;
                        if (newLoadable.state === "hasValue") {
                            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;
                            const newValue = newLoadable.contents;
                            const oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
                            const oldValue = oldLoadable.state === "hasValue" ? oldLoadable.contents : DEFAULT_VALUE$7; // TODO This isn't actually valid, use as a placeholder for now.
                            // Ignore atom value changes that were set via setSelf() in the same effect.
                            // We will still properly call the handler if there was a subsequent
                            // set from something other than an atom effect which was batched
                            // with the `setSelf()` call.  However, we may incorrectly ignore
                            // the handler if the subsequent batched call happens to set the
                            // atom to the exact same value as the `setSelf()`.   But, in that
                            // case, it was kind of a noop, so the semantics are debatable..
                            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) handler(newValue, oldValue, !currentTree.atomValues.has(key));
                            else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) pendingSetSelf = null;
                        }
                    }, key);
                    cleanupEffectsByStore.set(store, [
                        ...(_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : [],
                        release
                    ]);
                };
            for (const effect of effects)try {
                const cleanup = effect({
                    node,
                    storeID: store.storeID,
                    parentStoreID_UNSTABLE: store.parentStoreID,
                    trigger,
                    setSelf: setSelf(effect),
                    resetSelf: resetSelf(effect),
                    onSet: onSet(effect),
                    getPromise,
                    getLoadable,
                    getInfo_UNSTABLE
                });
                if (cleanup != null) {
                    var _cleanupEffectsByStor3;
                    cleanupEffectsByStore.set(store, [
                        ...(_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : [],
                        cleanup
                    ]);
                }
            } catch (error) {
                initValue = error;
                isInitError = true;
            }
            isDuringInit = false; // Mutate initial state in place since we know there are no other subscribers
            // since we are the ones initializing on first use.
            if (!(initValue instanceof DefaultValue$2)) {
                var _store$getState$nextT5;
                const initLoadable = isInitError ? loadableWithError$2(initValue) : Recoil_isPromise(initValue) ? loadableWithPromise$2(wrapPendingPromise(store, initValue)) : loadableWithValue$3(unwrap(initValue));
                maybeFreezeValueOrPromise(initLoadable.contents);
                initState.atomValues.set(key, initLoadable); // If there is a pending transaction, then also mutate the next state tree.
                // This could happen if the atom was first initialized in an action that
                // also updated some other atom's state.
                (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 || _store$getState$nextT5.atomValues.set(key, initLoadable);
            }
        }
        return cleanupAtom;
    }
    function peekAtom(_store, state) {
        var _ref, _state$atomValues$get3;
        return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
    }
    function getAtom(_store, state) {
        if (state.atomValues.has(key)) // Atom value is stored in state:
        return Recoil_nullthrows(state.atomValues.get(key));
        else if (state.nonvalidatedAtoms.has(key)) {
            // Atom value is stored but needs validation before use.
            // We might have already validated it and have a cached validated value:
            if (cachedAnswerForUnvalidatedValue != null) return cachedAnswerForUnvalidatedValue;
            if (persistence == null) {
                Recoil_expectationViolation(`Tried to restore a persisted value for atom ${key} but it has no persistence settings.`);
                return defaultLoadable;
            }
            const nonvalidatedValue = state.nonvalidatedAtoms.get(key);
            const validatorResult = persistence.validator(nonvalidatedValue, DEFAULT_VALUE$7);
            const validatedValueLoadable = validatorResult instanceof DefaultValue$2 ? defaultLoadable : loadableWithValue$3(validatorResult);
            cachedAnswerForUnvalidatedValue = validatedValueLoadable;
            return cachedAnswerForUnvalidatedValue;
        } else return defaultLoadable;
    }
    function invalidateAtom() {
        cachedAnswerForUnvalidatedValue = undefined;
    }
    function setAtom(_store, state, newValue) {
        // Bail out if we're being set to the existing value, or if we're being
        // reset but have no stored value (validated or unvalidated) to reset from:
        if (state.atomValues.has(key)) {
            const existing = Recoil_nullthrows(state.atomValues.get(key));
            if (existing.state === "hasValue" && newValue === existing.contents) return new Map();
        } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof DefaultValue$2) return new Map();
        maybeFreezeValueOrPromise(newValue);
        cachedAnswerForUnvalidatedValue = undefined; // can be released now if it was previously in use
        return new Map().set(key, loadableWithValue$3(newValue));
    }
    function shouldDeleteConfigOnReleaseAtom() {
        return getConfigDeletionHandler$2(key) !== undefined && liveStoresCount <= 0;
    }
    const node = registerNode$2({
        key,
        nodeType: "atom",
        peek: peekAtom,
        get: getAtom,
        set: setAtom,
        init: initAtom,
        invalidate: invalidateAtom,
        shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        persistence_UNSTABLE: options.persistence_UNSTABLE ? {
            type: options.persistence_UNSTABLE.type,
            backButton: options.persistence_UNSTABLE.backButton
        } : undefined,
        shouldRestoreFromSnapshots: true,
        retainedBy
    });
    return node;
} // prettier-ignore
function atom(options) {
    const { ...restOptions } = options;
    const optionsDefault = "default" in options ? options.default : new Promise(()=>{});
    if (isRecoilValue$4(optionsDefault) // Continue to use atomWithFallback for promise defaults for scoped atoms
    ) return atomWithFallback({
        ...restOptions,
        default: optionsDefault // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    }); // @fb-only: } else if (scopeRules_APPEND_ONLY_READ_THE_DOCS
    else return baseAtom({
        ...restOptions,
        default: optionsDefault
    });
}
function atomWithFallback(options) {
    const base = atom({
        ...options,
        default: DEFAULT_VALUE$7,
        persistence_UNSTABLE: options.persistence_UNSTABLE === undefined ? undefined : {
            ...options.persistence_UNSTABLE,
            validator: (storedValue)=>storedValue instanceof DefaultValue$2 ? storedValue : Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, DEFAULT_VALUE$7)
        },
        // TODO Hack for now.
        effects: options.effects,
        // flowlint-line unclear-type: off
        effects_UNSTABLE: options.effects_UNSTABLE // flowlint-line unclear-type: off
    }); // $FlowFixMe[incompatible-call]
    const sel = Recoil_selector({
        key: `${options.key}__withFallback`,
        get: ({ get })=>{
            const baseValue = get(base);
            return baseValue instanceof DefaultValue$2 ? options.default : baseValue;
        },
        // $FlowFixMe[incompatible-call]
        set: ({ set }, newValue)=>set(base, newValue),
        // This selector does not need to cache as it is a wrapper selector
        // and the selector within the wrapper selector will have a cache
        // option by default
        cachePolicy_UNSTABLE: {
            eviction: "most-recent"
        },
        dangerouslyAllowMutability: options.dangerouslyAllowMutability
    });
    setConfigDeletionHandler$1(sel.key, getConfigDeletionHandler$2(options.key));
    return sel;
} // $FlowFixMe[missing-local-annot]
atom.value = (value)=>new WrappedValue$2(value);
var Recoil_atom = atom;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class MapCache {
    constructor(options){
        var _options$mapKey;
        _defineProperty(this, "_map", void 0);
        _defineProperty(this, "_keyMapper", void 0);
        this._map = new Map();
        this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : (v)=>v;
    }
    size() {
        return this._map.size;
    }
    has(key) {
        return this._map.has(this._keyMapper(key));
    }
    get(key) {
        return this._map.get(this._keyMapper(key));
    }
    set(key, val) {
        this._map.set(this._keyMapper(key), val);
    }
    delete(key) {
        this._map.delete(this._keyMapper(key));
    }
    clear() {
        this._map.clear();
    }
}
var Recoil_MapCache = {
    MapCache
};
var Recoil_MapCache_1 = Recoil_MapCache.MapCache;
var Recoil_MapCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MapCache: Recoil_MapCache_1
});
const { LRUCache: LRUCache$2 } = Recoil_LRUCache$1;
const { MapCache: MapCache$1 } = Recoil_MapCache$1;
const defaultPolicy$1 = {
    equality: "reference",
    eviction: "none",
    maxSize: Infinity
};
function cacheFromPolicy({ equality = defaultPolicy$1.equality, eviction = defaultPolicy$1.eviction, maxSize = defaultPolicy$1.maxSize } = defaultPolicy$1) {
    const valueMapper = getValueMapper$1(equality);
    const cache = getCache(eviction, maxSize, valueMapper);
    return cache;
}
function getValueMapper$1(equality) {
    switch(equality){
        case "reference":
            return (val)=>val;
        case "value":
            return (val)=>Recoil_stableStringify(val);
    }
    throw Recoil_err(`Unrecognized equality policy ${equality}`);
}
function getCache(eviction, maxSize, mapKey) {
    switch(eviction){
        case "keep-all":
            return new MapCache$1({
                mapKey
            });
        case "lru":
            return new LRUCache$2({
                mapKey,
                maxSize: Recoil_nullthrows(maxSize)
            });
        case "most-recent":
            return new LRUCache$2({
                mapKey,
                maxSize: 1
            });
    }
    throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}
var Recoil_cacheFromPolicy = cacheFromPolicy;
// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
const { setConfigDeletionHandler: setConfigDeletionHandler$2 } = Recoil_Node;
// Process scopeRules to handle any entries which are functions taking parameters
// prettier-ignore
// @fb-only: function mapScopeRules<P>(
// @fb-only: scopeRules?: ParameterizedScopeRules<P>,
// @fb-only: param: P,
// @fb-only: ): ScopeRules | void {
// @fb-only: return scopeRules?.map(rule =>
// @fb-only: Array.isArray(rule)
// @fb-only: ? rule.map(entry => (typeof entry === 'function' ? entry(param) : entry))
// @fb-only: : rule,
// @fb-only: );
// @fb-only: }
/*
A function which returns an atom based on the input parameter.

Each unique parameter returns a unique atom. E.g.,

  const f = atomFamily(...);
  f({a: 1}) => an atom
  f({a: 2}) => a different atom

This allows components to persist local, private state using atoms.  Each
instance of the component may have a different key, which it uses as the
parameter for a family of atoms; in this way, each component will have
its own atom not shared by other instances.  These state keys may be composed
into children's state keys as well.
*/ function atomFamily(options) {
    var _options$cachePolicyF, _options$cachePolicyF2;
    const atomCache = Recoil_cacheFromPolicy({
        equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : "value",
        eviction: "keep-all"
    }); // Simple atomFamily implementation to cache individual atoms based
    // on the parameter value equality.
    return (params)=>{
        var _stableStringify, _options$effects;
        const cachedAtom = atomCache.get(params);
        if (cachedAtom != null) return cachedAtom;
        const { cachePolicyForParams_UNSTABLE, ...atomOptions } = options;
        const optionsDefault = "default" in options ? options.default : new Promise(()=>{});
        const newAtom = Recoil_atom({
            ...atomOptions,
            key: `${options.key}__${(_stableStringify = Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : "void"}`,
            default: typeof optionsDefault === "function" ? // Flow doesn't know that T isn't a function, so we need to case to any
            // $FlowIssue[incompatible-use]
            optionsDefault(params) : optionsDefault,
            retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === "function" ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
            effects: typeof options.effects === "function" ? options.effects(params) : typeof options.effects_UNSTABLE === "function" ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE // prettier-ignore
        });
        atomCache.set(params, newAtom);
        setConfigDeletionHandler$2(newAtom.key, ()=>{
            atomCache.delete(params);
        });
        return newAtom;
    };
}
var Recoil_atomFamily = atomFamily;
const { setConfigDeletionHandler: setConfigDeletionHandler$3 } = Recoil_Node;
// Keep in mind the parameter needs to be serializable as a cahche key
// using Recoil_stableStringify
// Add a unique index to each selector in case the cache implementation allows
// duplicate keys based on equivalent stringified parameters
let nextIndex = 0;
/* eslint-disable no-redeclare */ // Return a function that returns members of a family of selectors of the same type
// E.g.,
//
// const s = selectorFamily(...);
// s({a: 1}) => a selector
// s({a: 2}) => a different selector
//
// By default, the selectors are distinguished by distinct values of the
// parameter based on value equality, not reference equality.  This allows using
// object literals or other equivalent objects at callsites to not create
// duplicate cache entries.  This behavior may be overridden with the
// cacheImplementationForParams option.
function selectorFamily(options) {
    var _options$cachePolicyF, _options$cachePolicyF2;
    const selectorCache = Recoil_cacheFromPolicy({
        equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : "value",
        eviction: "keep-all"
    });
    return (params)=>{
        var _stableStringify;
        // Throw an error with selector key so that it is clear which
        // selector is causing an error
        let cachedSelector;
        try {
            cachedSelector = selectorCache.get(params);
        } catch (error) {
            throw Recoil_err(`Problem with cache lookup for selector ${options.key}: ${error.message}`);
        }
        if (cachedSelector != null) return cachedSelector;
        const myKey = `${options.key}__selectorFamily/${(_stableStringify = Recoil_stableStringify(params, {
            // It is possible to use functions in parameters if the user uses
            // a cache with reference equality thanks to the incrementing index.
            allowFunctions: true
        })) !== null && _stableStringify !== void 0 ? _stableStringify : "void"}/${nextIndex++}`; // Append index in case values serialize to the same key string
        const myGet = (callbacks)=>options.get(params)(callbacks);
        const myCachePolicy = options.cachePolicy_UNSTABLE;
        const retainedBy = typeof options.retainedBy_UNSTABLE === "function" ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
        let newSelector;
        if (options.set != null) {
            const set = options.set;
            const mySet = (callbacks, newValue)=>set(params)(callbacks, newValue);
            newSelector = Recoil_selector({
                key: myKey,
                get: myGet,
                set: mySet,
                cachePolicy_UNSTABLE: myCachePolicy,
                dangerouslyAllowMutability: options.dangerouslyAllowMutability,
                retainedBy_UNSTABLE: retainedBy
            });
        } else newSelector = Recoil_selector({
            key: myKey,
            get: myGet,
            cachePolicy_UNSTABLE: myCachePolicy,
            dangerouslyAllowMutability: options.dangerouslyAllowMutability,
            retainedBy_UNSTABLE: retainedBy
        });
        selectorCache.set(params, newSelector);
        setConfigDeletionHandler$3(newSelector.key, ()=>{
            selectorCache.delete(params);
        });
        return newSelector;
    };
}
/* eslint-enable no-redeclare */ var Recoil_selectorFamily = selectorFamily;
// flowlint-next-line unclear-type:off
const constantSelector = Recoil_selectorFamily({
    key: "__constant",
    get: (constant)=>()=>constant,
    cachePolicyForParams_UNSTABLE: {
        equality: "reference"
    }
}); // Function that returns a selector which always produces the
// same constant value.  It may be called multiple times with the
// same value, based on reference equality, and will provide the
// same selector.
function constSelector(constant) {
    return constantSelector(constant);
}
var Recoil_constSelector = constSelector;
// flowlint-next-line unclear-type:off
const throwingSelector = Recoil_selectorFamily({
    key: "__error",
    get: (message)=>()=>{
            throw Recoil_err(message);
        },
    // TODO Why?
    cachePolicyForParams_UNSTABLE: {
        equality: "reference"
    }
}); // Function that returns a selector which always throws an error
// with the provided message.
function errorSelector(message) {
    return throwingSelector(message);
}
var Recoil_errorSelector = errorSelector;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Wraps another recoil value and prevents writing to it.
 *
 * 
 * @format
 * @oncall recoil
 */ function readOnlySelector(atom) {
    // flowlint-next-line unclear-type: off
    return atom;
}
var Recoil_readOnlySelector = readOnlySelector;
const { loadableWithError: loadableWithError$3, loadableWithPromise: loadableWithPromise$3, loadableWithValue: loadableWithValue$4 } = Recoil_Loadable$1;
/////////////////
//  TRUTH TABLE
/////////////////
// Dependencies        waitForNone         waitForAny        waitForAll       waitForAllSettled
//  [loading, loading]  [Promise, Promise]  Promise           Promise         Promise
//  [value, loading]    [value, Promise]    [value, Promise]  Promise         Promise
//  [value, value]      [value, value]      [value, value]    [value, value]  [value, value]
//
//  [error, loading]    [Error, Promise]    [Error, Promise]  Error           Promise
//  [error, error]      [Error, Error]      [Error, Error]    Error           [error, error]
//  [value, error]      [value, Error]      [value, Error]    Error           [value, error]
// Issue parallel requests for all dependencies and return the current
// status if they have results, have some error, or are still pending.
function concurrentRequests(getRecoilValue, deps) {
    const results = Array(deps.length).fill(undefined);
    const exceptions = Array(deps.length).fill(undefined);
    for (const [i, dep] of deps.entries())try {
        results[i] = getRecoilValue(dep);
    } catch (e) {
        // exceptions can either be Promises of pending results or real errors
        exceptions[i] = e;
    }
    return [
        results,
        exceptions
    ];
}
function isError(exp) {
    return exp != null && !Recoil_isPromise(exp);
}
function unwrapDependencies(dependencies) {
    return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map((key)=>dependencies[key]);
}
function wrapResults(dependencies, /* $FlowFixMe[missing-local-annot] The type annotation(s) required by Flow's
 * LTI update could not be added via codemod */ results) {
    return Array.isArray(dependencies) ? results : Object.getOwnPropertyNames(dependencies).reduce((out, key, idx)=>({
            ...out,
            [key]: results[idx]
        }), {});
}
function wrapLoadables(dependencies, results, exceptions) {
    const output = exceptions.map((exception, idx)=>exception == null ? loadableWithValue$4(results[idx]) : Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
    return wrapResults(dependencies, output);
}
function combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
    return asyncResults.map((result, idx)=>/**
   * it's important we use === undefined as opposed to == null, because the
   * resolved value of the async promise could be `null`, in which case we
   * don't want to use syncResults[idx], which would be undefined. If async
   * promise resolves to `undefined`, that's ok because `syncResults[idx]`
   * will also be `undefined`. That's a little hacky, but it works.
   */ result === undefined ? syncResults[idx] : result);
} // Selector that requests all dependencies in parallel and immediately returns
// current results without waiting.
const waitForNone = Recoil_selectorFamily({
    key: "__waitForNone",
    get: (dependencies)=>({ get })=>{
            // Issue requests for all dependencies in parallel.
            const deps = unwrapDependencies(dependencies);
            const [results, exceptions] = concurrentRequests(get, deps); // Always return the current status of the results; never block.
            return wrapLoadables(dependencies, results, exceptions);
        },
    dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for at least
// one to be available before returning results.  It will only error if all
// dependencies have errors.
const waitForAny = Recoil_selectorFamily({
    key: "__waitForAny",
    get: (dependencies)=>({ get })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = unwrapDependencies(dependencies);
            const [results, exceptions] = concurrentRequests(get, deps); // If any results are available, value or error, return the current status
            if (exceptions.some((exp)=>!Recoil_isPromise(exp))) return wrapLoadables(dependencies, results, exceptions);
             // Otherwise, return a promise that will resolve when the next result is
            // available, whichever one happens to be next.  But, if all pending
            // dependencies end up with errors, then reject the promise.
            return new Promise((resolve)=>{
                for (const [i, exp] of exceptions.entries())if (Recoil_isPromise(exp)) exp.then((result)=>{
                    results[i] = result;
                    exceptions[i] = undefined;
                    resolve(wrapLoadables(dependencies, results, exceptions));
                }).catch((error)=>{
                    exceptions[i] = error;
                    resolve(wrapLoadables(dependencies, results, exceptions));
                });
            });
        },
    dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for all to be
// available before returning a value.  It will error if any dependencies error.
const waitForAll = Recoil_selectorFamily({
    key: "__waitForAll",
    get: (dependencies)=>({ get })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = unwrapDependencies(dependencies);
            const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results
            if (exceptions.every((exp)=>exp == null)) return wrapResults(dependencies, results);
             // If we have any errors, throw the first error
            const error = exceptions.find(isError);
            if (error != null) throw error;
             // Otherwise, return a promise that will resolve when all results are available
            return Promise.all(exceptions).then((exceptionResults)=>wrapResults(dependencies, combineAsyncResultsWithSyncResults(results, exceptionResults)));
        },
    dangerouslyAllowMutability: true
});
const waitForAllSettled = Recoil_selectorFamily({
    key: "__waitForAllSettled",
    get: (dependencies)=>({ get })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = unwrapDependencies(dependencies);
            const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results
            if (exceptions.every((exp)=>!Recoil_isPromise(exp))) return wrapLoadables(dependencies, results, exceptions);
             // Wait for all results to settle
            return Promise.all(exceptions.map((exp, i)=>Recoil_isPromise(exp) ? exp.then((result)=>{
                    results[i] = result;
                    exceptions[i] = undefined;
                }).catch((error)=>{
                    results[i] = undefined;
                    exceptions[i] = error;
                }) : null)) // Then wrap them as loadables
            .then(()=>wrapLoadables(dependencies, results, exceptions));
        },
    dangerouslyAllowMutability: true
});
const noWait = Recoil_selectorFamily({
    key: "__noWait",
    get: (dependency)=>({ get })=>{
            try {
                return Recoil_selector.value(loadableWithValue$4(get(dependency)));
            } catch (exception) {
                return Recoil_selector.value(Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
            }
        },
    dangerouslyAllowMutability: true
});
var Recoil_WaitFor = {
    waitForNone,
    waitForAny,
    waitForAll,
    waitForAllSettled,
    noWait
};
const { RecoilLoadable } = Recoil_Loadable$1;
const { DefaultValue: DefaultValue$3 } = Recoil_Node;
const { RecoilRoot: RecoilRoot$2, useRecoilStoreID: useRecoilStoreID$1 } = Recoil_RecoilRoot;
const { isRecoilValue: isRecoilValue$5 } = Recoil_RecoilValue$1;
const { retentionZone: retentionZone$1 } = Recoil_RetentionZone;
const { freshSnapshot: freshSnapshot$2 } = Recoil_Snapshot$1;
const { useRecoilState: useRecoilState$1, useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1, useRecoilStateLoadable: useRecoilStateLoadable$1, useRecoilValue: useRecoilValue$1, useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1, useRecoilValueLoadable: useRecoilValueLoadable$1, useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1, useResetRecoilState: useResetRecoilState$1, useSetRecoilState: useSetRecoilState$1 } = Recoil_Hooks;
const { useGotoRecoilSnapshot: useGotoRecoilSnapshot$1, useRecoilSnapshot: useRecoilSnapshot$1, useRecoilTransactionObserver: useRecoilTransactionObserver$1 } = Recoil_SnapshotHooks;
const { useRecoilCallback: useRecoilCallback$1 } = Recoil_useRecoilCallback;
const { noWait: noWait$1, waitForAll: waitForAll$1, waitForAllSettled: waitForAllSettled$1, waitForAny: waitForAny$1, waitForNone: waitForNone$1 } = Recoil_WaitFor;
var Recoil_index = {
    // Types
    DefaultValue: DefaultValue$3,
    isRecoilValue: isRecoilValue$5,
    RecoilLoadable,
    // Global Recoil environment settiongs
    RecoilEnv: Recoil_RecoilEnv,
    // Recoil Root
    RecoilRoot: RecoilRoot$2,
    useRecoilStoreID: useRecoilStoreID$1,
    useRecoilBridgeAcrossReactRoots_UNSTABLE: Recoil_useRecoilBridgeAcrossReactRoots,
    // Atoms/Selectors
    atom: Recoil_atom,
    selector: Recoil_selector,
    // Convenience Atoms/Selectors
    atomFamily: Recoil_atomFamily,
    selectorFamily: Recoil_selectorFamily,
    constSelector: Recoil_constSelector,
    errorSelector: Recoil_errorSelector,
    readOnlySelector: Recoil_readOnlySelector,
    // Concurrency Helpers for Atoms/Selectors
    noWait: noWait$1,
    waitForNone: waitForNone$1,
    waitForAny: waitForAny$1,
    waitForAll: waitForAll$1,
    waitForAllSettled: waitForAllSettled$1,
    // Hooks for Atoms/Selectors
    useRecoilValue: useRecoilValue$1,
    useRecoilValueLoadable: useRecoilValueLoadable$1,
    useRecoilState: useRecoilState$1,
    useRecoilStateLoadable: useRecoilStateLoadable$1,
    useSetRecoilState: useSetRecoilState$1,
    useResetRecoilState: useResetRecoilState$1,
    useGetRecoilValueInfo_UNSTABLE: Recoil_useGetRecoilValueInfo,
    useRecoilRefresher_UNSTABLE: Recoil_useRecoilRefresher,
    useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
    // Hooks for complex operations
    useRecoilCallback: useRecoilCallback$1,
    useRecoilTransaction_UNSTABLE: Recoil_useRecoilTransaction,
    // Snapshots
    useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
    useRecoilSnapshot: useRecoilSnapshot$1,
    useRecoilTransactionObserver_UNSTABLE: useRecoilTransactionObserver$1,
    snapshot_UNSTABLE: freshSnapshot$2,
    // Memory Management
    useRetain: Recoil_useRetain,
    retentionZone: retentionZone$1
};
var Recoil_index_1 = Recoil_index.DefaultValue;
var Recoil_index_2 = Recoil_index.isRecoilValue;
var Recoil_index_3 = Recoil_index.RecoilLoadable;
var Recoil_index_4 = Recoil_index.RecoilEnv;
var Recoil_index_5 = Recoil_index.RecoilRoot;
var Recoil_index_6 = Recoil_index.useRecoilStoreID;
var Recoil_index_7 = Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var Recoil_index_8 = Recoil_index.atom;
var Recoil_index_9 = Recoil_index.selector;
var Recoil_index_10 = Recoil_index.atomFamily;
var Recoil_index_11 = Recoil_index.selectorFamily;
var Recoil_index_12 = Recoil_index.constSelector;
var Recoil_index_13 = Recoil_index.errorSelector;
var Recoil_index_14 = Recoil_index.readOnlySelector;
var Recoil_index_15 = Recoil_index.noWait;
var Recoil_index_16 = Recoil_index.waitForNone;
var Recoil_index_17 = Recoil_index.waitForAny;
var Recoil_index_18 = Recoil_index.waitForAll;
var Recoil_index_19 = Recoil_index.waitForAllSettled;
var Recoil_index_20 = Recoil_index.useRecoilValue;
var Recoil_index_21 = Recoil_index.useRecoilValueLoadable;
var Recoil_index_22 = Recoil_index.useRecoilState;
var Recoil_index_23 = Recoil_index.useRecoilStateLoadable;
var Recoil_index_24 = Recoil_index.useSetRecoilState;
var Recoil_index_25 = Recoil_index.useResetRecoilState;
var Recoil_index_26 = Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var Recoil_index_27 = Recoil_index.useRecoilRefresher_UNSTABLE;
var Recoil_index_28 = Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_29 = Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_30 = Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_31 = Recoil_index.useRecoilCallback;
var Recoil_index_32 = Recoil_index.useRecoilTransaction_UNSTABLE;
var Recoil_index_33 = Recoil_index.useGotoRecoilSnapshot;
var Recoil_index_34 = Recoil_index.useRecoilSnapshot;
var Recoil_index_35 = Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var Recoil_index_36 = Recoil_index.snapshot_UNSTABLE;
var Recoil_index_37 = Recoil_index.useRetain;
var Recoil_index_38 = Recoil_index.retentionZone;
exports.default = Recoil_index;

},{"86da38ec19b50b77":"5QIF0","react":"6uln9","react-dom":"b8T3j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5QIF0":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"bWmmR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./core/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var _indexJs1 = require("./react/index.js");
parcelHelpers.exportAll(_indexJs1, exports);

},{"./core/index.js":"4NtVX","./react/index.js":"3mize","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4NtVX":[function(require,module,exports) {
/* Core */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloClient", ()=>(0, _apolloClientJs.ApolloClient));
parcelHelpers.export(exports, "mergeOptions", ()=>(0, _apolloClientJs.mergeOptions));
parcelHelpers.export(exports, "ObservableQuery", ()=>(0, _observableQueryJs.ObservableQuery));
parcelHelpers.export(exports, "NetworkStatus", ()=>(0, _networkStatusJs.NetworkStatus));
parcelHelpers.export(exports, "isNetworkRequestSettled", ()=>(0, _networkStatusJs.isNetworkRequestSettled));
parcelHelpers.export(exports, "isApolloError", ()=>(0, _indexJs.isApolloError));
parcelHelpers.export(exports, "ApolloError", ()=>(0, _indexJs.ApolloError));
parcelHelpers.export(exports, "Cache", ()=>(0, _indexJs1.Cache));
parcelHelpers.export(exports, "ApolloCache", ()=>(0, _indexJs1.ApolloCache));
parcelHelpers.export(exports, "InMemoryCache", ()=>(0, _indexJs1.InMemoryCache));
parcelHelpers.export(exports, "MissingFieldError", ()=>(0, _indexJs1.MissingFieldError));
parcelHelpers.export(exports, "defaultDataIdFromObject", ()=>(0, _indexJs1.defaultDataIdFromObject));
parcelHelpers.export(exports, "makeVar", ()=>(0, _indexJs1.makeVar));
parcelHelpers.export(exports, "fromError", ()=>(0, _indexJs4.fromError));
parcelHelpers.export(exports, "toPromise", ()=>(0, _indexJs4.toPromise));
parcelHelpers.export(exports, "fromPromise", ()=>(0, _indexJs4.fromPromise));
parcelHelpers.export(exports, "throwServerError", ()=>(0, _indexJs4.throwServerError));
parcelHelpers.export(exports, "DocumentTransform", ()=>(0, _indexJs5.DocumentTransform));
parcelHelpers.export(exports, "Observable", ()=>(0, _indexJs5.Observable));
parcelHelpers.export(exports, "isReference", ()=>(0, _indexJs5.isReference));
parcelHelpers.export(exports, "makeReference", ()=>(0, _indexJs5.makeReference));
// Note that importing `gql` by itself, then destructuring
// additional properties separately before exporting, is intentional.
// Due to the way the `graphql-tag` library is setup, certain bundlers
// can't find the properties added to the exported `gql` function without
// additional guidance (e.g. Rollup - see
// https://rollupjs.org/guide/en/#error-name-is-not-exported-by-module).
// Instead of having people that are using bundlers with `@apollo/client` add
// extra bundler config to help `graphql-tag` exports be found (which would be
// awkward since they aren't importing `graphql-tag` themselves), this
// workaround of pulling the extra properties off the `gql` function,
// then re-exporting them separately, helps keeps bundlers happy without any
// additional config changes.
parcelHelpers.export(exports, "gql", ()=>(0, _graphqlTag.gql));
parcelHelpers.export(exports, "resetCaches", ()=>(0, _graphqlTag.resetCaches));
parcelHelpers.export(exports, "disableFragmentWarnings", ()=>(0, _graphqlTag.disableFragmentWarnings));
parcelHelpers.export(exports, "enableExperimentalFragmentVariables", ()=>(0, _graphqlTag.enableExperimentalFragmentVariables));
parcelHelpers.export(exports, "disableExperimentalFragmentVariables", ()=>(0, _graphqlTag.disableExperimentalFragmentVariables));
parcelHelpers.export(exports, "setLogVerbosity", ()=>(0, _tsInvariant.setVerbosity));
var _apolloClientJs = require("./ApolloClient.js");
var _observableQueryJs = require("./ObservableQuery.js");
var _networkStatusJs = require("./networkStatus.js");
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _indexJs = require("../errors/index.js");
var _indexJs1 = require("../cache/index.js");
var _typesJs1 = require("../cache/inmemory/types.js");
parcelHelpers.exportAll(_typesJs1, exports);
/* Link */ var _indexJs2 = require("../link/core/index.js");
parcelHelpers.exportAll(_indexJs2, exports);
var _indexJs3 = require("../link/http/index.js");
parcelHelpers.exportAll(_indexJs3, exports);
var _indexJs4 = require("../link/utils/index.js");
var _indexJs5 = require("../utilities/index.js");
/* Supporting */ // The verbosity of invariant.{log,warn,error} can be controlled globally
// (for anyone using the same ts-invariant package) by passing "log",
// "warn", "error", or "silent" to setVerbosity ("log" is the default).
// Note that all invariant.* logging is hidden in production.
var _tsInvariant = require("ts-invariant");
var _graphqlTag = require("graphql-tag");
(0, _tsInvariant.setVerbosity)(globalThis.__DEV__ !== false ? "log" : "silent");

},{"./ApolloClient.js":"kXsRW","./ObservableQuery.js":"aszik","./networkStatus.js":"8yReP","./types.js":"jrYcZ","../errors/index.js":"73MUX","../cache/index.js":"fv0fM","../cache/inmemory/types.js":"i6tcv","../link/core/index.js":"gXJ1R","../link/http/index.js":"6rkPi","../link/utils/index.js":"bdwh2","../utilities/index.js":"k55vB","ts-invariant":"16Hjc","graphql-tag":"bEarf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kXsRW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeOptions", ()=>(0, _indexJs3.mergeOptions));
parcelHelpers.export(exports, "ApolloClient", ()=>ApolloClient);
var _tslib = require("tslib");
var _indexJs = require("../utilities/globals/index.js");
var _indexJs1 = require("../link/core/index.js");
var _versionJs = require("../version.js");
var _indexJs2 = require("../link/http/index.js");
var _queryManagerJs = require("./QueryManager.js");
var _localStateJs = require("./LocalState.js");
// Though mergeOptions now resides in @apollo/client/utilities, it was
// previously declared and exported from this module, and then reexported from
// @apollo/client/core. Since we need to preserve that API anyway, the easiest
// solution is to reexport mergeOptions where it was previously declared (here).
var _indexJs3 = require("../utilities/index.js");
var _getMemoryInternalsJs = require("../utilities/caching/getMemoryInternals.js");
var hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an {@link ApolloLink} instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through {@link Observable} instances.
 */ var ApolloClient = /** @class */ function() {
    /**
     * Constructs an instance of {@link ApolloClient}.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, _indexJs.newInvariantError)(15);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        _c = options.connectToDevTools, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = _c === void 0 ? typeof window === "object" && !window.__APOLLO_CLIENT__ && globalThis.__DEV__ !== false : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, _indexJs2.HttpLink)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, _indexJs1.ApolloLink).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, _versionJs.version);
        this.localState = new (0, _localStateJs.LocalState)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, _queryManagerJs.QueryManager)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (connectToDevTools) this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "object") {
            var windowWithDevTools = window;
            var devtoolsSymbol = Symbol.for("apollo.devtools");
            (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
            windowWithDevTools.__APOLLO_CLIENT__ = this;
        }
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            hasSuggestedDevtools = true;
            setTimeout(function() {
                if (typeof window !== "undefined" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, _indexJs.invariant).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an {@link ObservableQuery}. We can subscribe to this {@link ObservableQuery} and
     * receive updated results through a GraphQL observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, _indexJs3.mergeOptions)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type {@link QueryOptions} that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, _indexJs3.mergeOptions)(this.defaultOptions.query, options);
        (0, _indexJs.invariant)(options.fetchPolicy !== "cache-and-network", 16);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, _indexJs3.mergeOptions)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * {@link Observable} which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, _indexJs1.execute)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, _indexJs.invariant).debug(17, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) ApolloClient.prototype.getMemoryInternals = (0, _getMemoryInternalsJs.getApolloClientMemoryInternals);

},{"tslib":"gBS4y","../utilities/globals/index.js":"jejDs","../link/core/index.js":"gXJ1R","../version.js":"7b1d7","../link/http/index.js":"6rkPi","./QueryManager.js":"gzqpZ","./LocalState.js":"9TB6L","../utilities/index.js":"k55vB","../utilities/caching/getMemoryInternals.js":"b13lS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gBS4y":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jejDs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "maybe", ()=>(0, _maybeJs.maybe));
parcelHelpers.export(exports, "global", ()=>(0, _globalJsDefault.default));
parcelHelpers.export(exports, "invariant", ()=>(0, _invariantWrappersJs.invariant));
parcelHelpers.export(exports, "newInvariantError", ()=>(0, _invariantWrappersJs.newInvariantError));
parcelHelpers.export(exports, "InvariantError", ()=>(0, _invariantWrappersJs.InvariantError));
parcelHelpers.export(exports, "DEV", ()=>DEV);
parcelHelpers.export(exports, "__DEV__", ()=>DEV);
var _invariantWrappersJs = require("./invariantWrappers.js");
var _maybeJs = require("./maybe.js");
var _globalJs = require("./global.js");
var _globalJsDefault = parcelHelpers.interopDefault(_globalJs);
var DEV = globalThis.__DEV__ !== false;

},{"./invariantWrappers.js":"90nJn","./maybe.js":"bQOeE","./global.js":"3apOl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"90nJn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "InvariantError", ()=>(0, _tsInvariant.InvariantError));
parcelHelpers.export(exports, "newInvariantError", ()=>newInvariantError);
parcelHelpers.export(exports, "ApolloErrorMessageHandler", ()=>ApolloErrorMessageHandler);
var _tsInvariant = require("ts-invariant");
var _versionJs = require("../../version.js");
var _globalJs = require("./global.js");
var _globalJsDefault = parcelHelpers.interopDefault(_globalJs);
var _stringifyForDisplayJs = require("../common/stringifyForDisplay.js");
function wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = getHandledErrorMsg(arg0);
            if (!message) {
                message = getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var invariant = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, _tsInvariant.invariant)(condition, getHandledErrorMsg(message, args) || getFallbackErrorMsg(message, args));
}, {
    debug: wrap((0, _tsInvariant.invariant).debug),
    log: wrap((0, _tsInvariant.invariant).log),
    warn: wrap((0, _tsInvariant.invariant).warn),
    error: wrap((0, _tsInvariant.invariant).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function newInvariantError(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, _tsInvariant.InvariantError)(getHandledErrorMsg(message, optionalParams) || getFallbackErrorMsg(message, optionalParams));
}
var ApolloErrorMessageHandler = Symbol.for("ApolloErrorMessageHandler_" + (0, _versionJs.version));
function stringify(arg) {
    return typeof arg == "string" ? arg : (0, _stringifyForDisplayJs.stringifyForDisplay)(arg, 2).slice(0, 1000);
}
function getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, _globalJsDefault.default)[ApolloErrorMessageHandler] && (0, _globalJsDefault.default)[ApolloErrorMessageHandler](message, messageArgs.map(stringify));
}
function getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, _versionJs.version),
        message: message,
        args: messageArgs.map(stringify)
    })));
}

},{"ts-invariant":"16Hjc","../../version.js":"7b1d7","./global.js":"3apOl","../common/stringifyForDisplay.js":"9NlXj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"16Hjc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvariantError", ()=>InvariantError);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "setVerbosity", ()=>setVerbosity);
var _tslib = require("tslib");
var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = genericMessage;
        var _this = _super.call(this, typeof message === "number" ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function invariant(condition, message) {
    if (!condition) throw new InvariantError(message);
}
var verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function() {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
exports.default = invariant;

},{"tslib":"gBS4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7b1d7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
var version = "3.9.2";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3apOl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _maybeJs = require("./maybe.js");
var global = arguments[3];
exports.default = (0, _maybeJs.maybe)(function() {
    return globalThis;
}) || (0, _maybeJs.maybe)(function() {
    return window;
}) || (0, _maybeJs.maybe)(function() {
    return self;
}) || (0, _maybeJs.maybe)(function() {
    return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, _maybeJs.maybe)(function() {
    return (0, _maybeJs.maybe).constructor("return this")();
});

},{"./maybe.js":"bQOeE","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bQOeE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "maybe", ()=>maybe);
function maybe(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9NlXj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stringifyForDisplay", ()=>stringifyForDisplay);
var _makeUniqueIdJs = require("./makeUniqueId.js");
function stringifyForDisplay(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, _makeUniqueIdJs.makeUniqueId)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}

},{"./makeUniqueId.js":"bhsS6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bhsS6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// These IDs won't be globally unique, but they will be unique within this
// process, thanks to the counter, and unguessable thanks to the random suffix.
parcelHelpers.export(exports, "makeUniqueId", ()=>makeUniqueId);
var prefixCounts = new Map();
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gXJ1R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "empty", ()=>(0, _emptyJs.empty));
parcelHelpers.export(exports, "from", ()=>(0, _fromJs.from));
parcelHelpers.export(exports, "split", ()=>(0, _splitJs.split));
parcelHelpers.export(exports, "concat", ()=>(0, _concatJs.concat));
parcelHelpers.export(exports, "execute", ()=>(0, _executeJs.execute));
parcelHelpers.export(exports, "ApolloLink", ()=>(0, _apolloLinkJs.ApolloLink));
var _indexJs = require("../../utilities/globals/index.js");
var _emptyJs = require("./empty.js");
var _fromJs = require("./from.js");
var _splitJs = require("./split.js");
var _concatJs = require("./concat.js");
var _executeJs = require("./execute.js");
var _apolloLinkJs = require("./ApolloLink.js");
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);

},{"../../utilities/globals/index.js":"jejDs","./empty.js":"4er58","./from.js":"4imHp","./split.js":"eYGav","./concat.js":"lgjiZ","./execute.js":"iOTkz","./ApolloLink.js":"gu1vX","./types.js":"8IYYS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4er58":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "empty", ()=>empty);
var _apolloLinkJs = require("./ApolloLink.js");
var empty = (0, _apolloLinkJs.ApolloLink).empty;

},{"./ApolloLink.js":"gu1vX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gu1vX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloLink", ()=>ApolloLink);
var _indexJs = require("../../utilities/globals/index.js");
var _indexJs1 = require("../../utilities/index.js");
var _indexJs2 = require("../utils/index.js");
function passthrough(op, forward) {
    return forward ? forward(op) : (0, _indexJs1.Observable).of();
}
function toLink(handler) {
    return typeof handler === "function" ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var ApolloLink = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, _indexJs1.Observable).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map(toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        var ret;
        if (isTerminating(leftLink) && isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, _indexJs1.Observable).of() : rightLink.request(operation) || (0, _indexJs1.Observable).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, _indexJs1.Observable).of() : rightLink.request(operation, forward) || (0, _indexJs1.Observable).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, _indexJs2.createOperation)(operation.context, (0, _indexJs2.transformOperation)((0, _indexJs2.validateOperation)(operation)))) || (0, _indexJs1.Observable).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(35, firstLink);
            return firstLink;
        }
        var nextLink = toLink(second);
        var ret;
        if (isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, _indexJs1.Observable).of();
            }) || (0, _indexJs1.Observable).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, _indexJs1.Observable).of();
            }) || (0, _indexJs1.Observable).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, _indexJs.newInvariantError)(36);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();

},{"../../utilities/globals/index.js":"jejDs","../../utilities/index.js":"k55vB","../utils/index.js":"bdwh2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k55vB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEV", ()=>(0, _indexJs.DEV));
parcelHelpers.export(exports, "maybe", ()=>(0, _indexJs.maybe));
parcelHelpers.export(exports, "shouldInclude", ()=>(0, _directivesJs.shouldInclude));
parcelHelpers.export(exports, "hasDirectives", ()=>(0, _directivesJs.hasDirectives));
parcelHelpers.export(exports, "hasAnyDirectives", ()=>(0, _directivesJs.hasAnyDirectives));
parcelHelpers.export(exports, "hasAllDirectives", ()=>(0, _directivesJs.hasAllDirectives));
parcelHelpers.export(exports, "hasClientExports", ()=>(0, _directivesJs.hasClientExports));
parcelHelpers.export(exports, "getDirectiveNames", ()=>(0, _directivesJs.getDirectiveNames));
parcelHelpers.export(exports, "getInclusionDirectives", ()=>(0, _directivesJs.getInclusionDirectives));
parcelHelpers.export(exports, "DocumentTransform", ()=>(0, _documentTransformJs.DocumentTransform));
parcelHelpers.export(exports, "createFragmentMap", ()=>(0, _fragmentsJs.createFragmentMap));
parcelHelpers.export(exports, "getFragmentQueryDocument", ()=>(0, _fragmentsJs.getFragmentQueryDocument));
parcelHelpers.export(exports, "getFragmentFromSelection", ()=>(0, _fragmentsJs.getFragmentFromSelection));
parcelHelpers.export(exports, "checkDocument", ()=>(0, _getFromASTJs.checkDocument));
parcelHelpers.export(exports, "getOperationDefinition", ()=>(0, _getFromASTJs.getOperationDefinition));
parcelHelpers.export(exports, "getOperationName", ()=>(0, _getFromASTJs.getOperationName));
parcelHelpers.export(exports, "getFragmentDefinitions", ()=>(0, _getFromASTJs.getFragmentDefinitions));
parcelHelpers.export(exports, "getQueryDefinition", ()=>(0, _getFromASTJs.getQueryDefinition));
parcelHelpers.export(exports, "getFragmentDefinition", ()=>(0, _getFromASTJs.getFragmentDefinition));
parcelHelpers.export(exports, "getMainDefinition", ()=>(0, _getFromASTJs.getMainDefinition));
parcelHelpers.export(exports, "getDefaultValues", ()=>(0, _getFromASTJs.getDefaultValues));
parcelHelpers.export(exports, "print", ()=>(0, _printJs.print));
parcelHelpers.export(exports, "makeReference", ()=>(0, _storeUtilsJs.makeReference));
parcelHelpers.export(exports, "isDocumentNode", ()=>(0, _storeUtilsJs.isDocumentNode));
parcelHelpers.export(exports, "isReference", ()=>(0, _storeUtilsJs.isReference));
parcelHelpers.export(exports, "isField", ()=>(0, _storeUtilsJs.isField));
parcelHelpers.export(exports, "isInlineFragment", ()=>(0, _storeUtilsJs.isInlineFragment));
parcelHelpers.export(exports, "valueToObjectRepresentation", ()=>(0, _storeUtilsJs.valueToObjectRepresentation));
parcelHelpers.export(exports, "storeKeyNameFromField", ()=>(0, _storeUtilsJs.storeKeyNameFromField));
parcelHelpers.export(exports, "argumentsObjectFromField", ()=>(0, _storeUtilsJs.argumentsObjectFromField));
parcelHelpers.export(exports, "resultKeyNameFromField", ()=>(0, _storeUtilsJs.resultKeyNameFromField));
parcelHelpers.export(exports, "getStoreKeyName", ()=>(0, _storeUtilsJs.getStoreKeyName));
parcelHelpers.export(exports, "getTypenameFromResult", ()=>(0, _storeUtilsJs.getTypenameFromResult));
parcelHelpers.export(exports, "addTypenameToDocument", ()=>(0, _transformJs.addTypenameToDocument));
parcelHelpers.export(exports, "buildQueryFromSelectionSet", ()=>(0, _transformJs.buildQueryFromSelectionSet));
parcelHelpers.export(exports, "removeDirectivesFromDocument", ()=>(0, _transformJs.removeDirectivesFromDocument));
parcelHelpers.export(exports, "removeConnectionDirectiveFromDocument", ()=>(0, _transformJs.removeConnectionDirectiveFromDocument));
parcelHelpers.export(exports, "removeArgumentsFromDocument", ()=>(0, _transformJs.removeArgumentsFromDocument));
parcelHelpers.export(exports, "removeFragmentSpreadFromDocument", ()=>(0, _transformJs.removeFragmentSpreadFromDocument));
parcelHelpers.export(exports, "removeClientSetsFromDocument", ()=>(0, _transformJs.removeClientSetsFromDocument));
parcelHelpers.export(exports, "isMutationOperation", ()=>(0, _operationsJs.isMutationOperation));
parcelHelpers.export(exports, "isQueryOperation", ()=>(0, _operationsJs.isQueryOperation));
parcelHelpers.export(exports, "isSubscriptionOperation", ()=>(0, _operationsJs.isSubscriptionOperation));
parcelHelpers.export(exports, "concatPagination", ()=>(0, _paginationJs.concatPagination));
parcelHelpers.export(exports, "offsetLimitPagination", ()=>(0, _paginationJs.offsetLimitPagination));
parcelHelpers.export(exports, "relayStylePagination", ()=>(0, _paginationJs.relayStylePagination));
parcelHelpers.export(exports, "Observable", ()=>(0, _observableJs.Observable));
parcelHelpers.export(exports, "isStatefulPromise", ()=>(0, _decorationJs.isStatefulPromise));
parcelHelpers.export(exports, "createFulfilledPromise", ()=>(0, _decorationJs.createFulfilledPromise));
parcelHelpers.export(exports, "createRejectedPromise", ()=>(0, _decorationJs.createRejectedPromise));
parcelHelpers.export(exports, "wrapPromiseWithState", ()=>(0, _decorationJs.wrapPromiseWithState));
parcelHelpers.export(exports, "canonicalStringify", ()=>(0, _canonicalStringifyJs.canonicalStringify));
parcelHelpers.export(exports, "omitDeep", ()=>(0, _omitDeepJs.omitDeep));
parcelHelpers.export(exports, "stripTypename", ()=>(0, _stripTypenameJs.stripTypename));
parcelHelpers.export(exports, "AutoCleanedStrongCache", ()=>(0, _indexJs1.AutoCleanedStrongCache));
parcelHelpers.export(exports, "AutoCleanedWeakCache", ()=>(0, _indexJs1.AutoCleanedWeakCache));
parcelHelpers.export(exports, "cacheSizes", ()=>(0, _indexJs1.cacheSizes));
var _indexJs = require("./globals/index.js");
var _directivesJs = require("./graphql/directives.js");
var _documentTransformJs = require("./graphql/DocumentTransform.js");
var _fragmentsJs = require("./graphql/fragments.js");
var _getFromASTJs = require("./graphql/getFromAST.js");
var _printJs = require("./graphql/print.js");
var _storeUtilsJs = require("./graphql/storeUtils.js");
var _transformJs = require("./graphql/transform.js");
var _operationsJs = require("./graphql/operations.js");
var _paginationJs = require("./policies/pagination.js");
var _observableJs = require("./observables/Observable.js");
var _decorationJs = require("./promises/decoration.js");
var _mergeDeepJs = require("./common/mergeDeep.js");
parcelHelpers.exportAll(_mergeDeepJs, exports);
var _cloneDeepJs = require("./common/cloneDeep.js");
parcelHelpers.exportAll(_cloneDeepJs, exports);
var _maybeDeepFreezeJs = require("./common/maybeDeepFreeze.js");
parcelHelpers.exportAll(_maybeDeepFreezeJs, exports);
var _iterationJs = require("./observables/iteration.js");
parcelHelpers.exportAll(_iterationJs, exports);
var _asyncMapJs = require("./observables/asyncMap.js");
parcelHelpers.exportAll(_asyncMapJs, exports);
var _concastJs = require("./observables/Concast.js");
parcelHelpers.exportAll(_concastJs, exports);
var _subclassingJs = require("./observables/subclassing.js");
parcelHelpers.exportAll(_subclassingJs, exports);
var _arraysJs = require("./common/arrays.js");
parcelHelpers.exportAll(_arraysJs, exports);
var _objectsJs = require("./common/objects.js");
parcelHelpers.exportAll(_objectsJs, exports);
var _errorHandlingJs = require("./common/errorHandling.js");
parcelHelpers.exportAll(_errorHandlingJs, exports);
var _canUseJs = require("./common/canUse.js");
parcelHelpers.exportAll(_canUseJs, exports);
var _compactJs = require("./common/compact.js");
parcelHelpers.exportAll(_compactJs, exports);
var _makeUniqueIdJs = require("./common/makeUniqueId.js");
parcelHelpers.exportAll(_makeUniqueIdJs, exports);
var _stringifyForDisplayJs = require("./common/stringifyForDisplay.js");
parcelHelpers.exportAll(_stringifyForDisplayJs, exports);
var _mergeOptionsJs = require("./common/mergeOptions.js");
parcelHelpers.exportAll(_mergeOptionsJs, exports);
var _incrementalResultJs = require("./common/incrementalResult.js");
parcelHelpers.exportAll(_incrementalResultJs, exports);
var _canonicalStringifyJs = require("./common/canonicalStringify.js");
var _omitDeepJs = require("./common/omitDeep.js");
var _stripTypenameJs = require("./common/stripTypename.js");
var _isStrictlyAnyJs = require("./types/IsStrictlyAny.js");
parcelHelpers.exportAll(_isStrictlyAnyJs, exports);
var _indexJs1 = require("./caching/index.js");

},{"./globals/index.js":"jejDs","./graphql/directives.js":"91pbl","./graphql/DocumentTransform.js":"9buBi","./graphql/fragments.js":"ihq4t","./graphql/getFromAST.js":"2MXZ3","./graphql/print.js":"bXp5G","./graphql/storeUtils.js":"fVqew","./graphql/transform.js":"kI1pM","./graphql/operations.js":false,"./policies/pagination.js":false,"./observables/Observable.js":"jbiGu","./promises/decoration.js":"izMW6","./common/mergeDeep.js":"3DI7j","./common/cloneDeep.js":"hbHBs","./common/maybeDeepFreeze.js":"739CY","./observables/iteration.js":"8Yve4","./observables/asyncMap.js":"gwUgI","./observables/Concast.js":"gSTlz","./observables/subclassing.js":"apAKh","./common/arrays.js":"b8nAm","./common/objects.js":"cr3hk","./common/errorHandling.js":"gjlhw","./common/canUse.js":"5l5O1","./common/compact.js":"38rYW","./common/makeUniqueId.js":"bhsS6","./common/stringifyForDisplay.js":"9NlXj","./common/mergeOptions.js":"1ZcdS","./common/incrementalResult.js":"38Fo8","./common/canonicalStringify.js":"2iAkj","./common/omitDeep.js":false,"./common/stripTypename.js":false,"./types/IsStrictlyAny.js":false,"./caching/index.js":"6yRGA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"91pbl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldInclude", ()=>shouldInclude);
parcelHelpers.export(exports, "getDirectiveNames", ()=>getDirectiveNames);
parcelHelpers.export(exports, "hasAnyDirectives", ()=>hasAnyDirectives);
parcelHelpers.export(exports, "hasAllDirectives", ()=>hasAllDirectives);
parcelHelpers.export(exports, "hasDirectives", ()=>hasDirectives);
parcelHelpers.export(exports, "hasClientExports", ()=>hasClientExports);
parcelHelpers.export(exports, "getInclusionDirectives", ()=>getInclusionDirectives);
var _indexJs = require("../globals/index.js");
var _graphql = require("graphql");
function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return getInclusionDirectives(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, _indexJs.invariant)(evaledValue !== void 0, 67, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(root) {
    var names = [];
    (0, _graphql.visit)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var hasAnyDirectives = function(names, root) {
    return hasDirectives(names, root, false);
};
var hasAllDirectives = function(names, root) {
    return hasDirectives(names, root, true);
};
function hasDirectives(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, _graphql.visit)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, _graphql.BREAK;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function hasClientExports(document) {
    return document && hasDirectives([
        "client",
        "export"
    ], document, true);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, _indexJs.invariant)(directiveArguments && directiveArguments.length === 1, 68, directiveName);
        var ifArgument = directiveArguments[0];
        (0, _indexJs.invariant)(ifArgument.name && ifArgument.name.value === "if", 69, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, _indexJs.invariant)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 70, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}

},{"../globals/index.js":"jejDs","graphql":"crWS5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"crWS5":[function(require,module,exports) {
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 * ```ts
 * import { parse } from 'graphql';
 * import { parse } from 'graphql/language';
 * ```
 *
 * @packageDocumentation
 */ // The GraphQL.js version info.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>(0, _versionMjs.version)) // The primary entry point into fulfilling a GraphQL request.
;
parcelHelpers.export(exports, "versionInfo", ()=>(0, _versionMjs.versionInfo));
parcelHelpers.export(exports, "graphql", ()=>(0, _graphqlMjs.graphql)) // Create and operate on GraphQL type definitions and schema.
;
parcelHelpers.export(exports, "graphqlSync", ()=>(0, _graphqlMjs.graphqlSync));
parcelHelpers.export(exports, "resolveObjMapThunk", ()=>(0, _indexMjs.resolveObjMapThunk));
parcelHelpers.export(exports, "resolveReadonlyArrayThunk", ()=>(0, _indexMjs.resolveReadonlyArrayThunk));
parcelHelpers.export(exports, "GraphQLSchema", ()=>(0, _indexMjs.GraphQLSchema));
parcelHelpers.export(exports, "GraphQLDirective", ()=>(0, _indexMjs.GraphQLDirective));
parcelHelpers.export(exports, "GraphQLScalarType", ()=>(0, _indexMjs.GraphQLScalarType));
parcelHelpers.export(exports, "GraphQLObjectType", ()=>(0, _indexMjs.GraphQLObjectType));
parcelHelpers.export(exports, "GraphQLInterfaceType", ()=>(0, _indexMjs.GraphQLInterfaceType));
parcelHelpers.export(exports, "GraphQLUnionType", ()=>(0, _indexMjs.GraphQLUnionType));
parcelHelpers.export(exports, "GraphQLEnumType", ()=>(0, _indexMjs.GraphQLEnumType));
parcelHelpers.export(exports, "GraphQLInputObjectType", ()=>(0, _indexMjs.GraphQLInputObjectType));
parcelHelpers.export(exports, "GraphQLList", ()=>(0, _indexMjs.GraphQLList));
parcelHelpers.export(exports, "GraphQLNonNull", ()=>(0, _indexMjs.GraphQLNonNull));
parcelHelpers.export(exports, "specifiedScalarTypes", ()=>(0, _indexMjs.specifiedScalarTypes));
parcelHelpers.export(exports, "GraphQLInt", ()=>(0, _indexMjs.GraphQLInt));
parcelHelpers.export(exports, "GraphQLFloat", ()=>(0, _indexMjs.GraphQLFloat));
parcelHelpers.export(exports, "GraphQLString", ()=>(0, _indexMjs.GraphQLString));
parcelHelpers.export(exports, "GraphQLBoolean", ()=>(0, _indexMjs.GraphQLBoolean));
parcelHelpers.export(exports, "GraphQLID", ()=>(0, _indexMjs.GraphQLID));
parcelHelpers.export(exports, "GRAPHQL_MAX_INT", ()=>(0, _indexMjs.GRAPHQL_MAX_INT));
parcelHelpers.export(exports, "GRAPHQL_MIN_INT", ()=>(0, _indexMjs.GRAPHQL_MIN_INT));
parcelHelpers.export(exports, "specifiedDirectives", ()=>(0, _indexMjs.specifiedDirectives));
parcelHelpers.export(exports, "GraphQLIncludeDirective", ()=>(0, _indexMjs.GraphQLIncludeDirective));
parcelHelpers.export(exports, "GraphQLSkipDirective", ()=>(0, _indexMjs.GraphQLSkipDirective));
parcelHelpers.export(exports, "GraphQLDeprecatedDirective", ()=>(0, _indexMjs.GraphQLDeprecatedDirective));
parcelHelpers.export(exports, "GraphQLSpecifiedByDirective", ()=>(0, _indexMjs.GraphQLSpecifiedByDirective));
parcelHelpers.export(exports, "TypeKind", ()=>(0, _indexMjs.TypeKind));
parcelHelpers.export(exports, "DEFAULT_DEPRECATION_REASON", ()=>(0, _indexMjs.DEFAULT_DEPRECATION_REASON));
parcelHelpers.export(exports, "introspectionTypes", ()=>(0, _indexMjs.introspectionTypes));
parcelHelpers.export(exports, "__Schema", ()=>(0, _indexMjs.__Schema));
parcelHelpers.export(exports, "__Directive", ()=>(0, _indexMjs.__Directive));
parcelHelpers.export(exports, "__DirectiveLocation", ()=>(0, _indexMjs.__DirectiveLocation));
parcelHelpers.export(exports, "__Type", ()=>(0, _indexMjs.__Type));
parcelHelpers.export(exports, "__Field", ()=>(0, _indexMjs.__Field));
parcelHelpers.export(exports, "__InputValue", ()=>(0, _indexMjs.__InputValue));
parcelHelpers.export(exports, "__EnumValue", ()=>(0, _indexMjs.__EnumValue));
parcelHelpers.export(exports, "__TypeKind", ()=>(0, _indexMjs.__TypeKind));
parcelHelpers.export(exports, "SchemaMetaFieldDef", ()=>(0, _indexMjs.SchemaMetaFieldDef));
parcelHelpers.export(exports, "TypeMetaFieldDef", ()=>(0, _indexMjs.TypeMetaFieldDef));
parcelHelpers.export(exports, "TypeNameMetaFieldDef", ()=>(0, _indexMjs.TypeNameMetaFieldDef));
parcelHelpers.export(exports, "isSchema", ()=>(0, _indexMjs.isSchema));
parcelHelpers.export(exports, "isDirective", ()=>(0, _indexMjs.isDirective));
parcelHelpers.export(exports, "isType", ()=>(0, _indexMjs.isType));
parcelHelpers.export(exports, "isScalarType", ()=>(0, _indexMjs.isScalarType));
parcelHelpers.export(exports, "isObjectType", ()=>(0, _indexMjs.isObjectType));
parcelHelpers.export(exports, "isInterfaceType", ()=>(0, _indexMjs.isInterfaceType));
parcelHelpers.export(exports, "isUnionType", ()=>(0, _indexMjs.isUnionType));
parcelHelpers.export(exports, "isEnumType", ()=>(0, _indexMjs.isEnumType));
parcelHelpers.export(exports, "isInputObjectType", ()=>(0, _indexMjs.isInputObjectType));
parcelHelpers.export(exports, "isListType", ()=>(0, _indexMjs.isListType));
parcelHelpers.export(exports, "isNonNullType", ()=>(0, _indexMjs.isNonNullType));
parcelHelpers.export(exports, "isInputType", ()=>(0, _indexMjs.isInputType));
parcelHelpers.export(exports, "isOutputType", ()=>(0, _indexMjs.isOutputType));
parcelHelpers.export(exports, "isLeafType", ()=>(0, _indexMjs.isLeafType));
parcelHelpers.export(exports, "isCompositeType", ()=>(0, _indexMjs.isCompositeType));
parcelHelpers.export(exports, "isAbstractType", ()=>(0, _indexMjs.isAbstractType));
parcelHelpers.export(exports, "isWrappingType", ()=>(0, _indexMjs.isWrappingType));
parcelHelpers.export(exports, "isNullableType", ()=>(0, _indexMjs.isNullableType));
parcelHelpers.export(exports, "isNamedType", ()=>(0, _indexMjs.isNamedType));
parcelHelpers.export(exports, "isRequiredArgument", ()=>(0, _indexMjs.isRequiredArgument));
parcelHelpers.export(exports, "isRequiredInputField", ()=>(0, _indexMjs.isRequiredInputField));
parcelHelpers.export(exports, "isSpecifiedScalarType", ()=>(0, _indexMjs.isSpecifiedScalarType));
parcelHelpers.export(exports, "isIntrospectionType", ()=>(0, _indexMjs.isIntrospectionType));
parcelHelpers.export(exports, "isSpecifiedDirective", ()=>(0, _indexMjs.isSpecifiedDirective));
parcelHelpers.export(exports, "assertSchema", ()=>(0, _indexMjs.assertSchema));
parcelHelpers.export(exports, "assertDirective", ()=>(0, _indexMjs.assertDirective));
parcelHelpers.export(exports, "assertType", ()=>(0, _indexMjs.assertType));
parcelHelpers.export(exports, "assertScalarType", ()=>(0, _indexMjs.assertScalarType));
parcelHelpers.export(exports, "assertObjectType", ()=>(0, _indexMjs.assertObjectType));
parcelHelpers.export(exports, "assertInterfaceType", ()=>(0, _indexMjs.assertInterfaceType));
parcelHelpers.export(exports, "assertUnionType", ()=>(0, _indexMjs.assertUnionType));
parcelHelpers.export(exports, "assertEnumType", ()=>(0, _indexMjs.assertEnumType));
parcelHelpers.export(exports, "assertInputObjectType", ()=>(0, _indexMjs.assertInputObjectType));
parcelHelpers.export(exports, "assertListType", ()=>(0, _indexMjs.assertListType));
parcelHelpers.export(exports, "assertNonNullType", ()=>(0, _indexMjs.assertNonNullType));
parcelHelpers.export(exports, "assertInputType", ()=>(0, _indexMjs.assertInputType));
parcelHelpers.export(exports, "assertOutputType", ()=>(0, _indexMjs.assertOutputType));
parcelHelpers.export(exports, "assertLeafType", ()=>(0, _indexMjs.assertLeafType));
parcelHelpers.export(exports, "assertCompositeType", ()=>(0, _indexMjs.assertCompositeType));
parcelHelpers.export(exports, "assertAbstractType", ()=>(0, _indexMjs.assertAbstractType));
parcelHelpers.export(exports, "assertWrappingType", ()=>(0, _indexMjs.assertWrappingType));
parcelHelpers.export(exports, "assertNullableType", ()=>(0, _indexMjs.assertNullableType));
parcelHelpers.export(exports, "assertNamedType", ()=>(0, _indexMjs.assertNamedType));
parcelHelpers.export(exports, "getNullableType", ()=>(0, _indexMjs.getNullableType));
parcelHelpers.export(exports, "getNamedType", ()=>(0, _indexMjs.getNamedType));
parcelHelpers.export(exports, "validateSchema", ()=>(0, _indexMjs.validateSchema));
parcelHelpers.export(exports, "assertValidSchema", ()=>(0, _indexMjs.assertValidSchema));
parcelHelpers.export(exports, "assertName", ()=>(0, _indexMjs.assertName));
parcelHelpers.export(exports, "assertEnumValueName", ()=>(0, _indexMjs.assertEnumValueName));
// Parse and operate on GraphQL language source files.
parcelHelpers.export(exports, "Token", ()=>(0, _indexMjs1.Token));
parcelHelpers.export(exports, "Source", ()=>(0, _indexMjs1.Source));
parcelHelpers.export(exports, "Location", ()=>(0, _indexMjs1.Location));
parcelHelpers.export(exports, "OperationTypeNode", ()=>(0, _indexMjs1.OperationTypeNode));
parcelHelpers.export(exports, "getLocation", ()=>(0, _indexMjs1.getLocation));
parcelHelpers.export(exports, "printLocation", ()=>(0, _indexMjs1.printLocation));
parcelHelpers.export(exports, "printSourceLocation", ()=>(0, _indexMjs1.printSourceLocation));
parcelHelpers.export(exports, "Lexer", ()=>(0, _indexMjs1.Lexer));
parcelHelpers.export(exports, "TokenKind", ()=>(0, _indexMjs1.TokenKind));
parcelHelpers.export(exports, "parse", ()=>(0, _indexMjs1.parse));
parcelHelpers.export(exports, "parseValue", ()=>(0, _indexMjs1.parseValue));
parcelHelpers.export(exports, "parseConstValue", ()=>(0, _indexMjs1.parseConstValue));
parcelHelpers.export(exports, "parseType", ()=>(0, _indexMjs1.parseType));
parcelHelpers.export(exports, "print", ()=>(0, _indexMjs1.print));
parcelHelpers.export(exports, "visit", ()=>(0, _indexMjs1.visit));
parcelHelpers.export(exports, "visitInParallel", ()=>(0, _indexMjs1.visitInParallel));
parcelHelpers.export(exports, "getVisitFn", ()=>(0, _indexMjs1.getVisitFn));
parcelHelpers.export(exports, "getEnterLeaveForKind", ()=>(0, _indexMjs1.getEnterLeaveForKind));
parcelHelpers.export(exports, "BREAK", ()=>(0, _indexMjs1.BREAK));
parcelHelpers.export(exports, "Kind", ()=>(0, _indexMjs1.Kind));
parcelHelpers.export(exports, "DirectiveLocation", ()=>(0, _indexMjs1.DirectiveLocation));
parcelHelpers.export(exports, "isDefinitionNode", ()=>(0, _indexMjs1.isDefinitionNode));
parcelHelpers.export(exports, "isExecutableDefinitionNode", ()=>(0, _indexMjs1.isExecutableDefinitionNode));
parcelHelpers.export(exports, "isSelectionNode", ()=>(0, _indexMjs1.isSelectionNode));
parcelHelpers.export(exports, "isValueNode", ()=>(0, _indexMjs1.isValueNode));
parcelHelpers.export(exports, "isConstValueNode", ()=>(0, _indexMjs1.isConstValueNode));
parcelHelpers.export(exports, "isTypeNode", ()=>(0, _indexMjs1.isTypeNode));
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", ()=>(0, _indexMjs1.isTypeSystemDefinitionNode));
parcelHelpers.export(exports, "isTypeDefinitionNode", ()=>(0, _indexMjs1.isTypeDefinitionNode));
parcelHelpers.export(exports, "isTypeSystemExtensionNode", ()=>(0, _indexMjs1.isTypeSystemExtensionNode));
parcelHelpers.export(exports, "isTypeExtensionNode", ()=>(0, _indexMjs1.isTypeExtensionNode));
// Execute GraphQL queries.
parcelHelpers.export(exports, "execute", ()=>(0, _indexMjs2.execute));
parcelHelpers.export(exports, "executeSync", ()=>(0, _indexMjs2.executeSync));
parcelHelpers.export(exports, "defaultFieldResolver", ()=>(0, _indexMjs2.defaultFieldResolver));
parcelHelpers.export(exports, "defaultTypeResolver", ()=>(0, _indexMjs2.defaultTypeResolver));
parcelHelpers.export(exports, "responsePathAsArray", ()=>(0, _indexMjs2.responsePathAsArray));
parcelHelpers.export(exports, "getArgumentValues", ()=>(0, _indexMjs2.getArgumentValues));
parcelHelpers.export(exports, "getVariableValues", ()=>(0, _indexMjs2.getVariableValues));
parcelHelpers.export(exports, "getDirectiveValues", ()=>(0, _indexMjs2.getDirectiveValues));
parcelHelpers.export(exports, "subscribe", ()=>(0, _indexMjs2.subscribe));
parcelHelpers.export(exports, "createSourceEventStream", ()=>(0, _indexMjs2.createSourceEventStream));
// Validate GraphQL documents.
parcelHelpers.export(exports, "validate", ()=>(0, _indexMjs3.validate));
parcelHelpers.export(exports, "ValidationContext", ()=>(0, _indexMjs3.ValidationContext));
parcelHelpers.export(exports, "specifiedRules", ()=>(0, _indexMjs3.specifiedRules));
parcelHelpers.export(exports, "ExecutableDefinitionsRule", ()=>(0, _indexMjs3.ExecutableDefinitionsRule));
parcelHelpers.export(exports, "FieldsOnCorrectTypeRule", ()=>(0, _indexMjs3.FieldsOnCorrectTypeRule));
parcelHelpers.export(exports, "FragmentsOnCompositeTypesRule", ()=>(0, _indexMjs3.FragmentsOnCompositeTypesRule));
parcelHelpers.export(exports, "KnownArgumentNamesRule", ()=>(0, _indexMjs3.KnownArgumentNamesRule));
parcelHelpers.export(exports, "KnownDirectivesRule", ()=>(0, _indexMjs3.KnownDirectivesRule));
parcelHelpers.export(exports, "KnownFragmentNamesRule", ()=>(0, _indexMjs3.KnownFragmentNamesRule));
parcelHelpers.export(exports, "KnownTypeNamesRule", ()=>(0, _indexMjs3.KnownTypeNamesRule));
parcelHelpers.export(exports, "LoneAnonymousOperationRule", ()=>(0, _indexMjs3.LoneAnonymousOperationRule));
parcelHelpers.export(exports, "NoFragmentCyclesRule", ()=>(0, _indexMjs3.NoFragmentCyclesRule));
parcelHelpers.export(exports, "NoUndefinedVariablesRule", ()=>(0, _indexMjs3.NoUndefinedVariablesRule));
parcelHelpers.export(exports, "NoUnusedFragmentsRule", ()=>(0, _indexMjs3.NoUnusedFragmentsRule));
parcelHelpers.export(exports, "NoUnusedVariablesRule", ()=>(0, _indexMjs3.NoUnusedVariablesRule));
parcelHelpers.export(exports, "OverlappingFieldsCanBeMergedRule", ()=>(0, _indexMjs3.OverlappingFieldsCanBeMergedRule));
parcelHelpers.export(exports, "PossibleFragmentSpreadsRule", ()=>(0, _indexMjs3.PossibleFragmentSpreadsRule));
parcelHelpers.export(exports, "ProvidedRequiredArgumentsRule", ()=>(0, _indexMjs3.ProvidedRequiredArgumentsRule));
parcelHelpers.export(exports, "ScalarLeafsRule", ()=>(0, _indexMjs3.ScalarLeafsRule));
parcelHelpers.export(exports, "SingleFieldSubscriptionsRule", ()=>(0, _indexMjs3.SingleFieldSubscriptionsRule));
parcelHelpers.export(exports, "UniqueArgumentNamesRule", ()=>(0, _indexMjs3.UniqueArgumentNamesRule));
parcelHelpers.export(exports, "UniqueDirectivesPerLocationRule", ()=>(0, _indexMjs3.UniqueDirectivesPerLocationRule));
parcelHelpers.export(exports, "UniqueFragmentNamesRule", ()=>(0, _indexMjs3.UniqueFragmentNamesRule));
parcelHelpers.export(exports, "UniqueInputFieldNamesRule", ()=>(0, _indexMjs3.UniqueInputFieldNamesRule));
parcelHelpers.export(exports, "UniqueOperationNamesRule", ()=>(0, _indexMjs3.UniqueOperationNamesRule));
parcelHelpers.export(exports, "UniqueVariableNamesRule", ()=>(0, _indexMjs3.UniqueVariableNamesRule));
parcelHelpers.export(exports, "ValuesOfCorrectTypeRule", ()=>(0, _indexMjs3.ValuesOfCorrectTypeRule));
parcelHelpers.export(exports, "VariablesAreInputTypesRule", ()=>(0, _indexMjs3.VariablesAreInputTypesRule));
parcelHelpers.export(exports, "VariablesInAllowedPositionRule", ()=>(0, _indexMjs3.VariablesInAllowedPositionRule));
parcelHelpers.export(exports, "LoneSchemaDefinitionRule", ()=>(0, _indexMjs3.LoneSchemaDefinitionRule));
parcelHelpers.export(exports, "UniqueOperationTypesRule", ()=>(0, _indexMjs3.UniqueOperationTypesRule));
parcelHelpers.export(exports, "UniqueTypeNamesRule", ()=>(0, _indexMjs3.UniqueTypeNamesRule));
parcelHelpers.export(exports, "UniqueEnumValueNamesRule", ()=>(0, _indexMjs3.UniqueEnumValueNamesRule));
parcelHelpers.export(exports, "UniqueFieldDefinitionNamesRule", ()=>(0, _indexMjs3.UniqueFieldDefinitionNamesRule));
parcelHelpers.export(exports, "UniqueArgumentDefinitionNamesRule", ()=>(0, _indexMjs3.UniqueArgumentDefinitionNamesRule));
parcelHelpers.export(exports, "UniqueDirectiveNamesRule", ()=>(0, _indexMjs3.UniqueDirectiveNamesRule));
parcelHelpers.export(exports, "PossibleTypeExtensionsRule", ()=>(0, _indexMjs3.PossibleTypeExtensionsRule));
parcelHelpers.export(exports, "NoDeprecatedCustomRule", ()=>(0, _indexMjs3.NoDeprecatedCustomRule));
parcelHelpers.export(exports, "NoSchemaIntrospectionCustomRule", ()=>(0, _indexMjs3.NoSchemaIntrospectionCustomRule));
// Create, format, and print GraphQL errors.
parcelHelpers.export(exports, "GraphQLError", ()=>(0, _indexMjs4.GraphQLError));
parcelHelpers.export(exports, "syntaxError", ()=>(0, _indexMjs4.syntaxError));
parcelHelpers.export(exports, "locatedError", ()=>(0, _indexMjs4.locatedError));
parcelHelpers.export(exports, "printError", ()=>(0, _indexMjs4.printError));
parcelHelpers.export(exports, "formatError", ()=>(0, _indexMjs4.formatError));
// Utilities for operating on GraphQL type schema and parsed sources.
parcelHelpers.export(exports, "getIntrospectionQuery", ()=>(0, _indexMjs5.getIntrospectionQuery));
parcelHelpers.export(exports, "getOperationAST", ()=>(0, _indexMjs5.getOperationAST));
parcelHelpers.export(exports, "getOperationRootType", ()=>(0, _indexMjs5.getOperationRootType));
parcelHelpers.export(exports, "introspectionFromSchema", ()=>(0, _indexMjs5.introspectionFromSchema));
parcelHelpers.export(exports, "buildClientSchema", ()=>(0, _indexMjs5.buildClientSchema));
parcelHelpers.export(exports, "buildASTSchema", ()=>(0, _indexMjs5.buildASTSchema));
parcelHelpers.export(exports, "buildSchema", ()=>(0, _indexMjs5.buildSchema));
parcelHelpers.export(exports, "extendSchema", ()=>(0, _indexMjs5.extendSchema));
parcelHelpers.export(exports, "lexicographicSortSchema", ()=>(0, _indexMjs5.lexicographicSortSchema));
parcelHelpers.export(exports, "printSchema", ()=>(0, _indexMjs5.printSchema));
parcelHelpers.export(exports, "printType", ()=>(0, _indexMjs5.printType));
parcelHelpers.export(exports, "printIntrospectionSchema", ()=>(0, _indexMjs5.printIntrospectionSchema));
parcelHelpers.export(exports, "typeFromAST", ()=>(0, _indexMjs5.typeFromAST));
parcelHelpers.export(exports, "valueFromAST", ()=>(0, _indexMjs5.valueFromAST));
parcelHelpers.export(exports, "valueFromASTUntyped", ()=>(0, _indexMjs5.valueFromASTUntyped));
parcelHelpers.export(exports, "astFromValue", ()=>(0, _indexMjs5.astFromValue));
parcelHelpers.export(exports, "TypeInfo", ()=>(0, _indexMjs5.TypeInfo));
parcelHelpers.export(exports, "visitWithTypeInfo", ()=>(0, _indexMjs5.visitWithTypeInfo));
parcelHelpers.export(exports, "coerceInputValue", ()=>(0, _indexMjs5.coerceInputValue));
parcelHelpers.export(exports, "concatAST", ()=>(0, _indexMjs5.concatAST));
parcelHelpers.export(exports, "separateOperations", ()=>(0, _indexMjs5.separateOperations));
parcelHelpers.export(exports, "stripIgnoredCharacters", ()=>(0, _indexMjs5.stripIgnoredCharacters));
parcelHelpers.export(exports, "isEqualType", ()=>(0, _indexMjs5.isEqualType));
parcelHelpers.export(exports, "isTypeSubTypeOf", ()=>(0, _indexMjs5.isTypeSubTypeOf));
parcelHelpers.export(exports, "doTypesOverlap", ()=>(0, _indexMjs5.doTypesOverlap));
parcelHelpers.export(exports, "assertValidName", ()=>(0, _indexMjs5.assertValidName));
parcelHelpers.export(exports, "isValidNameError", ()=>(0, _indexMjs5.isValidNameError));
parcelHelpers.export(exports, "BreakingChangeType", ()=>(0, _indexMjs5.BreakingChangeType));
parcelHelpers.export(exports, "DangerousChangeType", ()=>(0, _indexMjs5.DangerousChangeType));
parcelHelpers.export(exports, "findBreakingChanges", ()=>(0, _indexMjs5.findBreakingChanges));
parcelHelpers.export(exports, "findDangerousChanges", ()=>(0, _indexMjs5.findDangerousChanges));
var _versionMjs = require("./version.mjs");
var _graphqlMjs = require("./graphql.mjs");
var _indexMjs = require("./type/index.mjs");
var _indexMjs1 = require("./language/index.mjs");
var _indexMjs2 = require("./execution/index.mjs");
var _indexMjs3 = require("./validation/index.mjs");
var _indexMjs4 = require("./error/index.mjs");
var _indexMjs5 = require("./utilities/index.mjs");

},{"./version.mjs":false,"./graphql.mjs":false,"./type/index.mjs":false,"./language/index.mjs":"aRjPy","./execution/index.mjs":false,"./validation/index.mjs":false,"./error/index.mjs":false,"./utilities/index.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aRjPy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Source", ()=>(0, _sourceMjs.Source));
parcelHelpers.export(exports, "getLocation", ()=>(0, _locationMjs.getLocation));
parcelHelpers.export(exports, "printLocation", ()=>(0, _printLocationMjs.printLocation));
parcelHelpers.export(exports, "printSourceLocation", ()=>(0, _printLocationMjs.printSourceLocation));
parcelHelpers.export(exports, "Kind", ()=>(0, _kindsMjs.Kind));
parcelHelpers.export(exports, "TokenKind", ()=>(0, _tokenKindMjs.TokenKind));
parcelHelpers.export(exports, "Lexer", ()=>(0, _lexerMjs.Lexer));
parcelHelpers.export(exports, "parse", ()=>(0, _parserMjs.parse));
parcelHelpers.export(exports, "parseValue", ()=>(0, _parserMjs.parseValue));
parcelHelpers.export(exports, "parseConstValue", ()=>(0, _parserMjs.parseConstValue));
parcelHelpers.export(exports, "parseType", ()=>(0, _parserMjs.parseType));
parcelHelpers.export(exports, "print", ()=>(0, _printerMjs.print));
parcelHelpers.export(exports, "visit", ()=>(0, _visitorMjs.visit));
parcelHelpers.export(exports, "visitInParallel", ()=>(0, _visitorMjs.visitInParallel));
parcelHelpers.export(exports, "getVisitFn", ()=>(0, _visitorMjs.getVisitFn));
parcelHelpers.export(exports, "getEnterLeaveForKind", ()=>(0, _visitorMjs.getEnterLeaveForKind));
parcelHelpers.export(exports, "BREAK", ()=>(0, _visitorMjs.BREAK));
parcelHelpers.export(exports, "Location", ()=>(0, _astMjs.Location));
parcelHelpers.export(exports, "Token", ()=>(0, _astMjs.Token));
parcelHelpers.export(exports, "OperationTypeNode", ()=>(0, _astMjs.OperationTypeNode));
parcelHelpers.export(exports, "isDefinitionNode", ()=>(0, _predicatesMjs.isDefinitionNode));
parcelHelpers.export(exports, "isExecutableDefinitionNode", ()=>(0, _predicatesMjs.isExecutableDefinitionNode));
parcelHelpers.export(exports, "isSelectionNode", ()=>(0, _predicatesMjs.isSelectionNode));
parcelHelpers.export(exports, "isValueNode", ()=>(0, _predicatesMjs.isValueNode));
parcelHelpers.export(exports, "isConstValueNode", ()=>(0, _predicatesMjs.isConstValueNode));
parcelHelpers.export(exports, "isTypeNode", ()=>(0, _predicatesMjs.isTypeNode));
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", ()=>(0, _predicatesMjs.isTypeSystemDefinitionNode));
parcelHelpers.export(exports, "isTypeDefinitionNode", ()=>(0, _predicatesMjs.isTypeDefinitionNode));
parcelHelpers.export(exports, "isTypeSystemExtensionNode", ()=>(0, _predicatesMjs.isTypeSystemExtensionNode));
parcelHelpers.export(exports, "isTypeExtensionNode", ()=>(0, _predicatesMjs.isTypeExtensionNode));
parcelHelpers.export(exports, "DirectiveLocation", ()=>(0, _directiveLocationMjs.DirectiveLocation));
var _sourceMjs = require("./source.mjs");
var _locationMjs = require("./location.mjs");
var _printLocationMjs = require("./printLocation.mjs");
var _kindsMjs = require("./kinds.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
var _lexerMjs = require("./lexer.mjs");
var _parserMjs = require("./parser.mjs");
var _printerMjs = require("./printer.mjs");
var _visitorMjs = require("./visitor.mjs");
var _astMjs = require("./ast.mjs");
var _predicatesMjs = require("./predicates.mjs");
var _directiveLocationMjs = require("./directiveLocation.mjs");

},{"./source.mjs":false,"./location.mjs":false,"./printLocation.mjs":false,"./kinds.mjs":"9hEEX","./tokenKind.mjs":false,"./lexer.mjs":false,"./parser.mjs":"dXvX2","./printer.mjs":"c8XDu","./visitor.mjs":"h7DdO","./ast.mjs":false,"./predicates.mjs":"kQ93z","./directiveLocation.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8OEpO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */ parcelHelpers.export(exports, "Source", ()=>Source);
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */ parcelHelpers.export(exports, "isSource", ()=>isSource);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _inspectMjs = require("../jsutils/inspect.mjs");
var _instanceOfMjs = require("../jsutils/instanceOf.mjs");
class Source {
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, _devAssertMjs.devAssert)(false, `Body must be a string. Received: ${(0, _inspectMjs.inspect)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, _devAssertMjs.devAssert)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, _devAssertMjs.devAssert)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    get [Symbol.toStringTag]() {
        return "Source";
    }
}
function isSource(source) {
    return (0, _instanceOfMjs.instanceOf)(source, Source);
}

},{"../jsutils/devAssert.mjs":"fGYz0","../jsutils/inspect.mjs":"WQahI","../jsutils/instanceOf.mjs":"joPSX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fGYz0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "devAssert", ()=>devAssert);
function devAssert(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"WQahI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Used to print values in error messages.
 */ parcelHelpers.export(exports, "inspect", ()=>inspect);
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
function inspect(value) {
    return formatValue(value, []);
}
function formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if (isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return formatArray(value, seenValues);
    return formatObject(value, seenValues);
}
function isJSONable(value) {
    return typeof value.toJSON === "function";
}
function formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > MAX_RECURSIVE_DEPTH) return "[" + getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min(MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push(formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"joPSX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instanceOf", ()=>instanceOf);
var _inspectMjs = require("./inspect.mjs");
const instanceOf = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, _inspectMjs.inspect)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};

},{"./inspect.mjs":"WQahI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3bC3H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ parcelHelpers.export(exports, "getLocation", ()=>getLocation);
var _invariantMjs = require("../jsutils/invariant.mjs");
const LineRegExp = /\r\n|[\n\r]/g;
function getLocation(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll(LineRegExp)){
        typeof match.index === "number" || (0, _invariantMjs.invariant)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line,
        column: position + 1 - lastLineStart
    };
}

},{"../jsutils/invariant.mjs":"khvRB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"khvRB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", ()=>invariant);
function invariant(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a4p9f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ parcelHelpers.export(exports, "printLocation", ()=>printLocation);
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */ parcelHelpers.export(exports, "printSourceLocation", ()=>printSourceLocation);
var _locationMjs = require("./location.mjs");
function printLocation(location) {
    return printSourceLocation(location.source, (0, _locationMjs.getLocation)(location.source, location.start));
}
function printSourceLocation(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}

},{"./location.mjs":"3bC3H","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9hEEX":[function(require,module,exports) {
/**
 * The set of allowed kind values for AST nodes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Kind", ()=>Kind) /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ ;
var Kind;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})(Kind || (Kind = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2CCFz":[function(require,module,exports) {
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenKind", ()=>TokenKind) /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ ;
var TokenKind;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})(TokenKind || (TokenKind = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6B9aw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */ parcelHelpers.export(exports, "Lexer", ()=>Lexer);
/**
 * @internal
 */ parcelHelpers.export(exports, "isPunctuatorTokenKind", ()=>isPunctuatorTokenKind);
var _syntaxErrorMjs = require("../error/syntaxError.mjs");
var _astMjs = require("./ast.mjs");
var _blockStringMjs = require("./blockString.mjs");
var _characterClassesMjs = require("./characterClasses.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
class Lexer {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, _astMjs.Token)((0, _tokenKindMjs.TokenKind).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, _tokenKindMjs.TokenKind).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, _tokenKindMjs.TokenKind).COMMENT);
        }
        return token;
    }
}
function isPunctuatorTokenKind(kind) {
    return kind === (0, _tokenKindMjs.TokenKind).BANG || kind === (0, _tokenKindMjs.TokenKind).DOLLAR || kind === (0, _tokenKindMjs.TokenKind).AMP || kind === (0, _tokenKindMjs.TokenKind).PAREN_L || kind === (0, _tokenKindMjs.TokenKind).PAREN_R || kind === (0, _tokenKindMjs.TokenKind).SPREAD || kind === (0, _tokenKindMjs.TokenKind).COLON || kind === (0, _tokenKindMjs.TokenKind).EQUALS || kind === (0, _tokenKindMjs.TokenKind).AT || kind === (0, _tokenKindMjs.TokenKind).BRACKET_L || kind === (0, _tokenKindMjs.TokenKind).BRACKET_R || kind === (0, _tokenKindMjs.TokenKind).BRACE_L || kind === (0, _tokenKindMjs.TokenKind).PIPE || kind === (0, _tokenKindMjs.TokenKind).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function isSupplementaryCodePoint(body, location) {
    return isLeadingSurrogate(body.charCodeAt(location)) && isTrailingSurrogate(body.charCodeAt(location + 1));
}
function isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, _tokenKindMjs.TokenKind).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, _astMjs.Token)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).BANG, position, position + 1);
            case 0x0024:
                // $
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).AMP, position, position + 1);
            case 0x0028:
                // (
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return createToken(lexer, (0, _tokenKindMjs.TokenKind).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).COLON, position, position + 1);
            case 0x003d:
                // =
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).AT, position, position + 1);
            case 0x005b:
                // [
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).PIPE, position, position + 1);
            case 0x007d:
                // }
                return createToken(lexer, (0, _tokenKindMjs.TokenKind).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return readBlockString(lexer, position);
                return readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, _characterClassesMjs.isDigit)(code) || code === 0x002d) return readNumber(lexer, position, code);
         // Name
        if ((0, _characterClassesMjs.isNameStart)(code)) return readName(lexer, position);
        throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position) ? `Unexpected character: ${printCodePointAt(lexer, position)}.` : `Invalid character: ${printCodePointAt(lexer, position)}.`);
    }
    return createToken(lexer, (0, _tokenKindMjs.TokenKind).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if (isUnicodeScalarValue(code)) ++position;
        else if (isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return createToken(lexer, (0, _tokenKindMjs.TokenKind).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, _characterClassesMjs.isDigit)(code)) throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, position, `Invalid number, unexpected digit after 0: ${printCodePointAt(lexer, position)}.`);
    } else {
        position = readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, _characterClassesMjs.isNameStart)(code)) throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, position, `Invalid number, expected digit but got: ${printCodePointAt(lexer, position)}.`);
    return createToken(lexer, isFloat ? (0, _tokenKindMjs.TokenKind).FLOAT : (0, _tokenKindMjs.TokenKind).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function readDigits(lexer, start, firstCode) {
    if (!(0, _characterClassesMjs.isDigit)(firstCode)) throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, start, `Invalid number, expected digit but got: ${printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, _characterClassesMjs.isDigit)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return createToken(lexer, (0, _tokenKindMjs.TokenKind).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? readEscapedUnicodeVariableWidth(lexer, position) : readEscapedUnicodeFixedWidth(lexer, position) : readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if (isUnicodeScalarValue(code)) ++position;
        else if (isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, position, `Invalid character within String: ${printCodePointAt(lexer, position)}.`);
    }
    throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = read16BitHexCode(body, position + 2);
    if (isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if (isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = read16BitHexCode(body, position + 8);
            if (isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return readHexDigit(body.charCodeAt(position)) << 12 | readHexDigit(body.charCodeAt(position + 1)) << 8 | readHexDigit(body.charCodeAt(position + 2)) << 4 | readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = createToken(lexer, (0, _tokenKindMjs.TokenKind).BLOCK_STRING, start, position + 3, (0, _blockStringMjs.dedentBlockStringLines)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if (isUnicodeScalarValue(code)) ++position;
        else if (isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, position, `Invalid character within String: ${printCodePointAt(lexer, position)}.`);
    }
    throw (0, _syntaxErrorMjs.syntaxError)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, _characterClassesMjs.isNameContinue)(code)) ++position;
        else break;
    }
    return createToken(lexer, (0, _tokenKindMjs.TokenKind).NAME, start, position, body.slice(start, position));
}

},{"../error/syntaxError.mjs":"5mJxx","./ast.mjs":"fbjye","./blockString.mjs":"1Vj4i","./characterClasses.mjs":"JApDH","./tokenKind.mjs":"2CCFz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5mJxx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */ parcelHelpers.export(exports, "syntaxError", ()=>syntaxError);
var _graphQLErrorMjs = require("./GraphQLError.mjs");
function syntaxError(source, position, description) {
    return new (0, _graphQLErrorMjs.GraphQLError)(`Syntax Error: ${description}`, {
        source,
        positions: [
            position
        ]
    });
}

},{"./GraphQLError.mjs":"es92y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"es92y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */ parcelHelpers.export(exports, "GraphQLError", ()=>GraphQLError);
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */ /**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */ parcelHelpers.export(exports, "printError", ()=>printError);
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */ parcelHelpers.export(exports, "formatError", ()=>formatError);
var _isObjectLikeMjs = require("../jsutils/isObjectLike.mjs");
var _locationMjs = require("../language/location.mjs");
var _printLocationMjs = require("../language/printLocation.mjs");
function toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class GraphQLError extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes, source, positions, path, originalError, extensions } = toNormalizedOptions(rawArgs);
        super(message);
        this.name = "GraphQLError";
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, _locationMjs.getLocation)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, _locationMjs.getLocation)(loc.source, loc.start));
        const originalExtensions = (0, _isObjectLikeMjs.isObjectLike)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, GraphQLError);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, _printLocationMjs.printLocation)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, _printLocationMjs.printSourceLocation)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function printError(error) {
    return error.toString();
}
function formatError(error) {
    return error.toJSON();
}

},{"../jsutils/isObjectLike.mjs":"6GqPU","../language/location.mjs":"3bC3H","../language/printLocation.mjs":"a4p9f","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6GqPU":[function(require,module,exports) {
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObjectLike", ()=>isObjectLike);
function isObjectLike(value) {
    return typeof value == "object" && value !== null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fbjye":[function(require,module,exports) {
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Location", ()=>Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ parcelHelpers.export(exports, "Token", ()=>Token);
parcelHelpers.export(exports, "QueryDocumentKeys", ()=>QueryDocumentKeys);
/**
 * @internal
 */ parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "OperationTypeNode", ()=>OperationTypeNode);
class Location {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class Token {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const QueryDocumentKeys = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
function isNode(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && kindValues.has(maybeKind);
}
/** Name */ var OperationTypeNode;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})(OperationTypeNode || (OperationTypeNode = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1Vj4i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ parcelHelpers.export(exports, "dedentBlockStringLines", ()=>dedentBlockStringLines);
/**
 * @internal
 */ parcelHelpers.export(exports, "isPrintableAsBlockString", ()=>isPrintableAsBlockString);
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ parcelHelpers.export(exports, "printBlockString", ()=>printBlockString);
var _characterClassesMjs = require("./characterClasses.mjs");
function dedentBlockStringLines(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, _characterClassesMjs.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function isPrintableAsBlockString(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function printBlockString(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, _characterClassesMjs.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, _characterClassesMjs.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}

},{"./characterClasses.mjs":"JApDH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"JApDH":[function(require,module,exports) {
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWhiteSpace", ()=>isWhiteSpace);
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */ parcelHelpers.export(exports, "isDigit", ()=>isDigit);
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */ parcelHelpers.export(exports, "isLetter", ()=>isLetter);
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */ parcelHelpers.export(exports, "isNameStart", ()=>isNameStart);
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */ parcelHelpers.export(exports, "isNameContinue", ()=>isNameContinue);
function isWhiteSpace(code) {
    return code === 0x0009 || code === 0x0020;
}
function isDigit(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function isLetter(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function isNameStart(code) {
    return isLetter(code) || code === 0x005f;
}
function isNameContinue(code) {
    return isLetter(code) || isDigit(code) || code === 0x005f;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dXvX2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Configuration options to control parser behavior
 */ /**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */ parcelHelpers.export(exports, "parse", ()=>parse);
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */ parcelHelpers.export(exports, "parseValue", ()=>parseValue);
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */ parcelHelpers.export(exports, "parseConstValue", ()=>parseConstValue);
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */ parcelHelpers.export(exports, "parseType", ()=>parseType);
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */ parcelHelpers.export(exports, "Parser", ()=>Parser);
var _syntaxErrorMjs = require("../error/syntaxError.mjs");
var _astMjs = require("./ast.mjs");
var _directiveLocationMjs = require("./directiveLocation.mjs");
var _kindsMjs = require("./kinds.mjs");
var _lexerMjs = require("./lexer.mjs");
var _sourceMjs = require("./source.mjs");
var _tokenKindMjs = require("./tokenKind.mjs");
function parse(source, options) {
    const parser = new Parser(source, options);
    return parser.parseDocument();
}
function parseValue(source, options) {
    const parser = new Parser(source, options);
    parser.expectToken((0, _tokenKindMjs.TokenKind).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, _tokenKindMjs.TokenKind).EOF);
    return value;
}
function parseConstValue(source, options) {
    const parser = new Parser(source, options);
    parser.expectToken((0, _tokenKindMjs.TokenKind).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, _tokenKindMjs.TokenKind).EOF);
    return value;
}
function parseType(source, options) {
    const parser = new Parser(source, options);
    parser.expectToken((0, _tokenKindMjs.TokenKind).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, _tokenKindMjs.TokenKind).EOF);
    return type;
}
class Parser {
    constructor(source, options = {}){
        const sourceObj = (0, _sourceMjs.isSource)(source) ? source : new (0, _sourceMjs.Source)(source);
        this._lexer = new (0, _lexerMjs.Lexer)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, _tokenKindMjs.TokenKind).NAME);
        return this.node(token, {
            kind: (0, _kindsMjs.Kind).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, _kindsMjs.Kind).DOCUMENT,
            definitions: this.many((0, _tokenKindMjs.TokenKind).SOF, this.parseDefinition, (0, _tokenKindMjs.TokenKind).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, _tokenKindMjs.TokenKind).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, _tokenKindMjs.TokenKind).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, _tokenKindMjs.TokenKind).BRACE_L)) return this.node(start, {
            kind: (0, _kindsMjs.Kind).OPERATION_DEFINITION,
            operation: (0, _astMjs.OperationTypeNode).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, _tokenKindMjs.TokenKind).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).OPERATION_DEFINITION,
            operation,
            name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, _tokenKindMjs.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return (0, _astMjs.OperationTypeNode).QUERY;
            case "mutation":
                return (0, _astMjs.OperationTypeNode).MUTATION;
            case "subscription":
                return (0, _astMjs.OperationTypeNode).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, this.parseVariableDefinition, (0, _tokenKindMjs.TokenKind).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, _kindsMjs.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, _tokenKindMjs.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).DOLLAR);
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, _kindsMjs.Kind).SELECTION_SET,
            selections: this.many((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseSelection, (0, _tokenKindMjs.TokenKind).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, _tokenKindMjs.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).FIELD,
            alias,
            name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, _tokenKindMjs.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, item, (0, _tokenKindMjs.TokenKind).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).ARGUMENT,
            name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, _tokenKindMjs.TokenKind).NAME)) return this.node(start, {
            kind: (0, _kindsMjs.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, _kindsMjs.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, _tokenKindMjs.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, _tokenKindMjs.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, _tokenKindMjs.TokenKind).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, _kindsMjs.Kind).INT,
                    value: token.value
                });
            case (0, _tokenKindMjs.TokenKind).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, _kindsMjs.Kind).FLOAT,
                    value: token.value
                });
            case (0, _tokenKindMjs.TokenKind).STRING:
            case (0, _tokenKindMjs.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, _tokenKindMjs.TokenKind).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, _kindsMjs.Kind).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, _kindsMjs.Kind).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, _kindsMjs.Kind).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, _kindsMjs.Kind).ENUM,
                            value: token.value
                        });
                }
            case (0, _tokenKindMjs.TokenKind).DOLLAR:
                if (isConst) {
                    this.expectToken((0, _tokenKindMjs.TokenKind).DOLLAR);
                    if (this._lexer.token.kind === (0, _tokenKindMjs.TokenKind).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, _kindsMjs.Kind).STRING,
            value: token.value,
            block: token.kind === (0, _tokenKindMjs.TokenKind).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, _kindsMjs.Kind).LIST,
            values: this.any((0, _tokenKindMjs.TokenKind).BRACKET_L, item, (0, _tokenKindMjs.TokenKind).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, _kindsMjs.Kind).OBJECT,
            fields: this.any((0, _tokenKindMjs.TokenKind).BRACE_L, item, (0, _tokenKindMjs.TokenKind).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).OBJECT_FIELD,
            name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, _tokenKindMjs.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, _tokenKindMjs.TokenKind).AT);
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, _tokenKindMjs.TokenKind).BRACKET_R);
            type = this.node(start, {
                kind: (0, _kindsMjs.Kind).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).BANG)) return this.node(start, {
            kind: (0, _kindsMjs.Kind).NON_NULL_TYPE,
            type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, _kindsMjs.Kind).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, _tokenKindMjs.TokenKind).STRING) || this.peek((0, _tokenKindMjs.TokenKind).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).SCHEMA_DEFINITION,
            description,
            directives,
            operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).OPERATION_TYPE_DEFINITION,
            operation,
            type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).SCALAR_TYPE_DEFINITION,
            description,
            name,
            directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).OBJECT_TYPE_DEFINITION,
            description,
            name,
            interfaces,
            directives,
            fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, _tokenKindMjs.TokenKind).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseFieldDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).FIELD_DEFINITION,
            description,
            name,
            arguments: args,
            type,
            directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).PAREN_L, this.parseInputValueDef, (0, _tokenKindMjs.TokenKind).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, _tokenKindMjs.TokenKind).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).INPUT_VALUE_DEFINITION,
            description,
            name,
            type,
            defaultValue,
            directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).INTERFACE_TYPE_DEFINITION,
            description,
            name,
            interfaces,
            directives,
            fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).UNION_TYPE_DEFINITION,
            description,
            name,
            directives,
            types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, _tokenKindMjs.TokenKind).EQUALS) ? this.delimitedMany((0, _tokenKindMjs.TokenKind).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).ENUM_TYPE_DEFINITION,
            description,
            name,
            directives,
            values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).ENUM_VALUE_DEFINITION,
            description,
            name,
            directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, this._lexer.token.start, `${getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description,
            name,
            directives,
            fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseInputValueDef, (0, _tokenKindMjs.TokenKind).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, _tokenKindMjs.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, _tokenKindMjs.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, _tokenKindMjs.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).SCHEMA_EXTENSION,
            directives,
            operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).SCALAR_TYPE_EXTENSION,
            name,
            directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).OBJECT_TYPE_EXTENSION,
            name,
            interfaces,
            directives,
            fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).INTERFACE_TYPE_EXTENSION,
            name,
            interfaces,
            directives,
            fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).UNION_TYPE_EXTENSION,
            name,
            directives,
            types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).ENUM_TYPE_EXTENSION,
            name,
            directives,
            values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name,
            directives,
            fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, _tokenKindMjs.TokenKind).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION,
            description,
            name,
            arguments: args,
            repeatable,
            locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, _tokenKindMjs.TokenKind).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, _directiveLocationMjs.DirectiveLocation), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, _astMjs.Location)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, _tokenKindMjs.TokenKind).NAME && token.value === value) this.advanceLexer();
        else throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, `Expected "${value}", found ${getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, _tokenKindMjs.TokenKind).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, `Unexpected ${getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, _tokenKindMjs.TokenKind).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, _syntaxErrorMjs.syntaxError)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function getTokenDesc(token) {
    const value = token.value;
    return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function getTokenKindDesc(kind) {
    return (0, _lexerMjs.isPunctuatorTokenKind)(kind) ? `"${kind}"` : kind;
}

},{"../error/syntaxError.mjs":"5mJxx","./ast.mjs":"fbjye","./directiveLocation.mjs":"lKgz6","./kinds.mjs":"9hEEX","./lexer.mjs":"6B9aw","./source.mjs":"8OEpO","./tokenKind.mjs":"2CCFz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lKgz6":[function(require,module,exports) {
/**
 * The set of allowed directive location values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectiveLocation", ()=>DirectiveLocation) /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ ;
var DirectiveLocation;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})(DirectiveLocation || (DirectiveLocation = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c8XDu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ parcelHelpers.export(exports, "print", ()=>print);
var _blockStringMjs = require("./blockString.mjs");
var _printStringMjs = require("./printString.mjs");
var _visitorMjs = require("./visitor.mjs");
function print(ast) {
    return (0, _visitorMjs.visit)(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = wrap("(", join(node.variableDefinitions, ", "), ")");
            const prefix = join([
                node.operation,
                join([
                    node.name,
                    varDefs
                ]),
                join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable, type, defaultValue, directives })=>variable + ": " + type + wrap(" = ", defaultValue) + wrap(" ", join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections })=>block(selections)
    },
    Field: {
        leave ({ alias, name, arguments: args, directives, selectionSet }) {
            const prefix = wrap("", alias, ": ") + name;
            let argsLine = prefix + wrap("(", join(args, ", "), ")");
            if (argsLine.length > MAX_LINE_LENGTH) argsLine = prefix + wrap("(\n", indent(join(args, "\n")), "\n)");
            return join([
                argsLine,
                join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name, value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name, directives })=>"..." + name + wrap(" ", join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition, directives, selectionSet })=>join([
                "...",
                wrap("on ", typeCondition),
                join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name, typeCondition, variableDefinitions, directives, selectionSet })=>// or removed in the future.
            `fragment ${name}${wrap("(", join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${wrap("", join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value })=>value
    },
    FloatValue: {
        leave: ({ value })=>value
    },
    StringValue: {
        leave: ({ value, block: isBlockString })=>isBlockString ? (0, _blockStringMjs.printBlockString)(value) : (0, _printStringMjs.printString)(value)
    },
    BooleanValue: {
        leave: ({ value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value })=>value
    },
    ListValue: {
        leave: ({ values })=>"[" + join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields })=>"{" + join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name, value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name, arguments: args })=>"@" + name + wrap("(", join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name })=>name
    },
    ListType: {
        leave: ({ type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description, directives, operationTypes })=>wrap("", description, "\n") + join([
                "schema",
                join(directives, " "),
                block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation, type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description, name, directives })=>wrap("", description, "\n") + join([
                "scalar",
                name,
                join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description, name, interfaces, directives, fields })=>wrap("", description, "\n") + join([
                "type",
                name,
                wrap("implements ", join(interfaces, " & ")),
                join(directives, " "),
                block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description, name, arguments: args, type, directives })=>wrap("", description, "\n") + name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + ": " + type + wrap(" ", join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description, name, type, defaultValue, directives })=>wrap("", description, "\n") + join([
                name + ": " + type,
                wrap("= ", defaultValue),
                join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description, name, interfaces, directives, fields })=>wrap("", description, "\n") + join([
                "interface",
                name,
                wrap("implements ", join(interfaces, " & ")),
                join(directives, " "),
                block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description, name, directives, types })=>wrap("", description, "\n") + join([
                "union",
                name,
                join(directives, " "),
                wrap("= ", join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description, name, directives, values })=>wrap("", description, "\n") + join([
                "enum",
                name,
                join(directives, " "),
                block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description, name, directives })=>wrap("", description, "\n") + join([
                name,
                join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description, name, directives, fields })=>wrap("", description, "\n") + join([
                "input",
                name,
                join(directives, " "),
                block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description, name, arguments: args, repeatable, locations })=>wrap("", description, "\n") + "directive @" + name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives, operationTypes })=>join([
                "extend schema",
                join(directives, " "),
                block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name, directives })=>join([
                "extend scalar",
                name,
                join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name, interfaces, directives, fields })=>join([
                "extend type",
                name,
                wrap("implements ", join(interfaces, " & ")),
                join(directives, " "),
                block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name, interfaces, directives, fields })=>join([
                "extend interface",
                name,
                wrap("implements ", join(interfaces, " & ")),
                join(directives, " "),
                block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name, directives, types })=>join([
                "extend union",
                name,
                join(directives, " "),
                wrap("= ", join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name, directives, values })=>join([
                "extend enum",
                name,
                join(directives, " "),
                block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name, directives, fields })=>join([
                "extend input",
                name,
                join(directives, " "),
                block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function block(array) {
    return wrap("{\n", indent(join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function indent(str) {
    return wrap("  ", str.replace(/\n/g, "\n  "));
}
function hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

},{"./blockString.mjs":"1Vj4i","./printString.mjs":"58Bpf","./visitor.mjs":"h7DdO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"58Bpf":[function(require,module,exports) {
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "printString", ()=>printString) // eslint-disable-next-line no-control-regex
;
function printString(str) {
    return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
}
const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function escapedReplacer(str) {
    return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h7DdO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BREAK", ()=>BREAK);
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */ parcelHelpers.export(exports, "visit", ()=>visit);
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ parcelHelpers.export(exports, "visitInParallel", ()=>visitInParallel);
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */ parcelHelpers.export(exports, "getEnterLeaveForKind", ()=>getEnterLeaveForKind);
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */ /* c8 ignore next 8 */ parcelHelpers.export(exports, "getVisitFn", ()=>getVisitFn);
var _devAssertMjs = require("../jsutils/devAssert.mjs");
var _inspectMjs = require("../jsutils/inspect.mjs");
var _astMjs = require("./ast.mjs");
var _kindsMjs = require("./kinds.mjs");
const BREAK = Object.freeze({});
function visit(root, visitor, visitorKeys = (0, _astMjs.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, _kindsMjs.Kind)))enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, _astMjs.isNode)(node) || (0, _devAssertMjs.devAssert)(false, `Invalid AST Node: ${(0, _inspectMjs.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === BREAK) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, _astMjs.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray,
                index,
                keys,
                edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function visitInParallel(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, _kindsMjs.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === BREAK) skipping[i] = BREAK;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === BREAK) skipping[i] = BREAK;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function getEnterLeaveForKind(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function getVisitFn(visitor, kind, isLeaving) {
    const { enter, leave } = getEnterLeaveForKind(visitor, kind);
    return isLeaving ? leave : enter;
}

},{"../jsutils/devAssert.mjs":"fGYz0","../jsutils/inspect.mjs":"WQahI","./ast.mjs":"fbjye","./kinds.mjs":"9hEEX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQ93z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDefinitionNode", ()=>isDefinitionNode);
parcelHelpers.export(exports, "isExecutableDefinitionNode", ()=>isExecutableDefinitionNode);
parcelHelpers.export(exports, "isSelectionNode", ()=>isSelectionNode);
parcelHelpers.export(exports, "isValueNode", ()=>isValueNode);
parcelHelpers.export(exports, "isConstValueNode", ()=>isConstValueNode);
parcelHelpers.export(exports, "isTypeNode", ()=>isTypeNode);
parcelHelpers.export(exports, "isTypeSystemDefinitionNode", ()=>isTypeSystemDefinitionNode);
parcelHelpers.export(exports, "isTypeDefinitionNode", ()=>isTypeDefinitionNode);
parcelHelpers.export(exports, "isTypeSystemExtensionNode", ()=>isTypeSystemExtensionNode);
parcelHelpers.export(exports, "isTypeExtensionNode", ()=>isTypeExtensionNode);
var _kindsMjs = require("./kinds.mjs");
function isDefinitionNode(node) {
    return isExecutableDefinitionNode(node) || isTypeSystemDefinitionNode(node) || isTypeSystemExtensionNode(node);
}
function isExecutableDefinitionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).OPERATION_DEFINITION || node.kind === (0, _kindsMjs.Kind).FRAGMENT_DEFINITION;
}
function isSelectionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).FIELD || node.kind === (0, _kindsMjs.Kind).FRAGMENT_SPREAD || node.kind === (0, _kindsMjs.Kind).INLINE_FRAGMENT;
}
function isValueNode(node) {
    return node.kind === (0, _kindsMjs.Kind).VARIABLE || node.kind === (0, _kindsMjs.Kind).INT || node.kind === (0, _kindsMjs.Kind).FLOAT || node.kind === (0, _kindsMjs.Kind).STRING || node.kind === (0, _kindsMjs.Kind).BOOLEAN || node.kind === (0, _kindsMjs.Kind).NULL || node.kind === (0, _kindsMjs.Kind).ENUM || node.kind === (0, _kindsMjs.Kind).LIST || node.kind === (0, _kindsMjs.Kind).OBJECT;
}
function isConstValueNode(node) {
    return isValueNode(node) && (node.kind === (0, _kindsMjs.Kind).LIST ? node.values.some(isConstValueNode) : node.kind === (0, _kindsMjs.Kind).OBJECT ? node.fields.some((field)=>isConstValueNode(field.value)) : node.kind !== (0, _kindsMjs.Kind).VARIABLE);
}
function isTypeNode(node) {
    return node.kind === (0, _kindsMjs.Kind).NAMED_TYPE || node.kind === (0, _kindsMjs.Kind).LIST_TYPE || node.kind === (0, _kindsMjs.Kind).NON_NULL_TYPE;
}
function isTypeSystemDefinitionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).SCHEMA_DEFINITION || isTypeDefinitionNode(node) || node.kind === (0, _kindsMjs.Kind).DIRECTIVE_DEFINITION;
}
function isTypeDefinitionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, _kindsMjs.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, _kindsMjs.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, _kindsMjs.Kind).UNION_TYPE_DEFINITION || node.kind === (0, _kindsMjs.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function isTypeSystemExtensionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
    return node.kind === (0, _kindsMjs.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, _kindsMjs.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, _kindsMjs.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, _kindsMjs.Kind).UNION_TYPE_EXTENSION || node.kind === (0, _kindsMjs.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, _kindsMjs.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

},{"./kinds.mjs":"9hEEX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9buBi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentTransform", ()=>DocumentTransform);
var _trie = require("@wry/trie");
var _canUseJs = require("../common/canUse.js");
var _getFromASTJs = require("./getFromAST.js");
var _indexJs = require("../globals/index.js");
var _caches = require("@wry/caches");
var _optimism = require("optimism");
var _indexJs1 = require("../caching/index.js");
function identity(document) {
    return document;
}
var DocumentTransform = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, _canUseJs.canUseWeakSet) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform(identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, _trie.Trie)((0, _canUseJs.canUseWeakMap));
            this.performWork = (0, _optimism.wrap)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, _indexJs.invariant)(Array.isArray(cacheKeys), 66);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, _indexJs1.cacheSizes)["documentTransform.cache"],
                cache: (0, _caches.WeakCache)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, _getFromASTJs.checkDocument)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();

},{"@wry/trie":"fd6oo","../common/canUse.js":"5l5O1","./getFromAST.js":"2MXZ3","../globals/index.js":"jejDs","@wry/caches":"c7ATU","optimism":"3eQSw","../caching/index.js":"6yRGA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fd6oo":[function(require,module,exports) {
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trie", ()=>Trie);
const defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach, slice } = Array.prototype;
const { hasOwnProperty } = Object.prototype;
class Trie {
    constructor(weakness = true, makeData = defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        forEach.call(array, (key)=>node = node.getChildTrie(key));
        return hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData(slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray(slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5l5O1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseWeakMap", ()=>canUseWeakMap);
parcelHelpers.export(exports, "canUseWeakSet", ()=>canUseWeakSet);
parcelHelpers.export(exports, "canUseSymbol", ()=>canUseSymbol);
parcelHelpers.export(exports, "canUseAsyncIteratorSymbol", ()=>canUseAsyncIteratorSymbol);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "canUseLayoutEffect", ()=>canUseLayoutEffect);
var _indexJs = require("../globals/index.js");
var global = arguments[3];
var canUseWeakMap = typeof WeakMap === "function" && !(0, _indexJs.maybe)(function() {
    return navigator.product == "ReactNative" && !global.HermesInternal;
});
var canUseWeakSet = typeof WeakSet === "function";
var canUseSymbol = typeof Symbol === "function" && typeof Symbol.for === "function";
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
var canUseDOM = typeof (0, _indexJs.maybe)(function() {
    return window.document.createElement;
}) === "function";
var usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, _indexJs.maybe)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var canUseLayoutEffect = canUseDOM && !usingJSDOM;

},{"../globals/index.js":"jejDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2MXZ3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Checks the document for errors and throws an exception if there is an error.
parcelHelpers.export(exports, "checkDocument", ()=>checkDocument);
parcelHelpers.export(exports, "getOperationDefinition", ()=>getOperationDefinition);
parcelHelpers.export(exports, "getOperationName", ()=>getOperationName);
// Returns the FragmentDefinitions from a particular document as an array
parcelHelpers.export(exports, "getFragmentDefinitions", ()=>getFragmentDefinitions);
parcelHelpers.export(exports, "getQueryDefinition", ()=>getQueryDefinition);
parcelHelpers.export(exports, "getFragmentDefinition", ()=>getFragmentDefinition);
/**
 * Returns the first operation definition found in this document.
 * If no operation definition is found, the first fragment definition will be returned.
 * If no definitions are found, an error will be thrown.
 */ parcelHelpers.export(exports, "getMainDefinition", ()=>getMainDefinition);
parcelHelpers.export(exports, "getDefaultValues", ()=>getDefaultValues);
var _indexJs = require("../globals/index.js");
var _storeUtilsJs = require("./storeUtils.js");
function checkDocument(doc) {
    (0, _indexJs.invariant)(doc && doc.kind === "Document", 74);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, _indexJs.newInvariantError)(75, definition.kind);
        return definition;
    });
    (0, _indexJs.invariant)(operations.length <= 1, 76, operations.length);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function getOperationName(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    (0, _indexJs.invariant)(queryDef && queryDef.operation === "query", 77);
    return queryDef;
}
function getFragmentDefinition(doc) {
    (0, _indexJs.invariant)(doc.kind === "Document", 78);
    (0, _indexJs.invariant)(doc.definitions.length <= 1, 79);
    var fragmentDef = doc.definitions[0];
    (0, _indexJs.invariant)(fragmentDef.kind === "FragmentDefinition", 80);
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, _indexJs.newInvariantError)(81);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, _storeUtilsJs.valueToObjectRepresentation)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}

},{"../globals/index.js":"jejDs","./storeUtils.js":"fVqew","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fVqew":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeReference", ()=>makeReference);
parcelHelpers.export(exports, "isReference", ()=>isReference);
parcelHelpers.export(exports, "isDocumentNode", ()=>isDocumentNode);
parcelHelpers.export(exports, "valueToObjectRepresentation", ()=>valueToObjectRepresentation);
parcelHelpers.export(exports, "storeKeyNameFromField", ()=>storeKeyNameFromField);
parcelHelpers.export(exports, "getStoreKeyName", ()=>getStoreKeyName);
parcelHelpers.export(exports, "argumentsObjectFromField", ()=>argumentsObjectFromField);
parcelHelpers.export(exports, "resultKeyNameFromField", ()=>resultKeyNameFromField);
parcelHelpers.export(exports, "getTypenameFromResult", ()=>getTypenameFromResult);
parcelHelpers.export(exports, "isField", ()=>isField);
parcelHelpers.export(exports, "isInlineFragment", ()=>isInlineFragment);
var _indexJs = require("../globals/index.js");
var _objectsJs = require("../common/objects.js");
var _fragmentsJs = require("./fragments.js");
var _canonicalStringifyJs = require("../common/canonicalStringify.js");
function makeReference(id) {
    return {
        __ref: String(id)
    };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function isDocumentNode(value) {
    return (0, _objectsJs.isNonNullObject)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function isStringValue(value) {
    return value.kind === "StringValue";
}
function isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function isIntValue(value) {
    return value.kind === "IntValue";
}
function isFloatValue(value) {
    return value.kind === "FloatValue";
}
function isVariable(value) {
    return value.kind === "Variable";
}
function isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function isListValue(value) {
    return value.kind === "ListValue";
}
function isEnumValue(value) {
    return value.kind === "EnumValue";
}
function isNullValue(value) {
    return value.kind === "NullValue";
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if (isBooleanValue(value) || isStringValue(value)) argObj[name.value] = value.value;
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if (isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if (isEnumValue(value)) argObj[name.value] = value.value;
    else if (isNullValue(value)) argObj[name.value] = null;
    else throw (0, _indexJs.newInvariantError)(82, name.value, value.kind);
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var storeKeyNameStringify = (0, _canonicalStringifyJs.canonicalStringify);
var getStoreKeyName = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat(storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if (KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat(storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = storeKeyNameStringify;
        storeKeyNameStringify = s;
        return previous;
    }
});
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if (isField(selection)) {
            if (selection.name.value === "__typename") return result[resultKeyNameFromField(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = getTypenameFromResult(result, (0, _fragmentsJs.getFragmentFromSelection)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function isField(selection) {
    return selection.kind === "Field";
}
function isInlineFragment(selection) {
    return selection.kind === "InlineFragment";
}

},{"../globals/index.js":"jejDs","../common/objects.js":"cr3hk","./fragments.js":"ihq4t","../common/canonicalStringify.js":"2iAkj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cr3hk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNonNullObject", ()=>isNonNullObject);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
function isNonNullObject(obj) {
    return obj !== null && typeof obj === "object";
}
function isPlainObject(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ihq4t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a query document which adds a single query operation that only
 * spreads the target fragment inside of it.
 *
 * So for example a document of:
 *
 * ```graphql
 * fragment foo on Foo { a b c }
 * ```
 *
 * Turns into:
 *
 * ```graphql
 * { ...foo }
 *
 * fragment foo on Foo { a b c }
 * ```
 *
 * The target fragment will either be the only fragment in the document, or a
 * fragment specified by the provided `fragmentName`. If there is more than one
 * fragment, but a `fragmentName` was not defined then an error will be thrown.
 */ parcelHelpers.export(exports, "getFragmentQueryDocument", ()=>getFragmentQueryDocument);
// Utility function that takes a list of fragment definitions and makes a hash out of them
// that maps the name of the fragment to the fragment definition.
parcelHelpers.export(exports, "createFragmentMap", ()=>createFragmentMap);
parcelHelpers.export(exports, "getFragmentFromSelection", ()=>getFragmentFromSelection);
var _tslib = require("tslib");
var _indexJs = require("../globals/index.js");
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, _indexJs.newInvariantError)(71, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, _indexJs.invariant)(fragments.length === 1, 72, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, _tslib.__assign)((0, _tslib.__assign)({}, document), {
        definitions: (0, _tslib.__spreadArray)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, _indexJs.invariant)(fragment, 73, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}

},{"tslib":"gBS4y","../globals/index.js":"jejDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2iAkj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canonicalStringify", ()=>canonicalStringify);
var _indexJs = require("../../utilities/caching/index.js");
var _getMemoryInternalsJs = require("../caching/getMemoryInternals.js");
var canonicalStringify = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        sortingMap = new (0, _indexJs.AutoCleanedStrongCache)((0, _indexJs.cacheSizes).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, _getMemoryInternalsJs.registerGlobalCache)("canonicalStringify", function() {
    return sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var sortingMap;
canonicalStringify.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every(everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = sortingMap.get(sortedKey) || keys;
                sortingMap.set(unsortedKey, sortedKeys);
                sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}

},{"../../utilities/caching/index.js":"6yRGA","../caching/getMemoryInternals.js":"b13lS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6yRGA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoCleanedStrongCache", ()=>(0, _cachesJs.AutoCleanedStrongCache));
parcelHelpers.export(exports, "AutoCleanedWeakCache", ()=>(0, _cachesJs.AutoCleanedWeakCache));
parcelHelpers.export(exports, "cacheSizes", ()=>(0, _sizesJs.cacheSizes));
var _cachesJs = require("./caches.js");
var _sizesJs = require("./sizes.js");

},{"./caches.js":"knoH2","./sizes.js":"cFEae","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knoH2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoCleanedWeakCache", ()=>AutoCleanedWeakCache);
parcelHelpers.export(exports, "AutoCleanedStrongCache", ()=>AutoCleanedStrongCache);
var _caches = require("@wry/caches");
var scheduledCleanup = new WeakSet();
function schedule(cache) {
    if (!scheduledCleanup.has(cache)) {
        scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            scheduledCleanup.delete(cache);
        }, 100);
    }
}
var AutoCleanedWeakCache = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, _caches.WeakCache)(max, dispose);
    cache.set = function(key, value) {
        schedule(this);
        return (0, _caches.WeakCache).prototype.set.call(this, key, value);
    };
    return cache;
};
var AutoCleanedStrongCache = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, _caches.StrongCache)(max, dispose);
    cache.set = function(key, value) {
        schedule(this);
        return (0, _caches.StrongCache).prototype.set.call(this, key, value);
    };
    return cache;
};

},{"@wry/caches":"c7ATU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c7ATU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StrongCache", ()=>(0, _strongJs.StrongCache));
parcelHelpers.export(exports, "WeakCache", ()=>(0, _weakJs.WeakCache));
var _strongJs = require("./strong.js");
var _weakJs = require("./weak.js");

},{"./strong.js":"kU25P","./weak.js":"knSxH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kU25P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StrongCache", ()=>StrongCache);
function defaultDispose() {}
class StrongCache {
    constructor(max = Infinity, dispose = defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older, newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key,
            value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"knSxH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WeakCache", ()=>WeakCache);
function noop() {}
const defaultDispose = noop;
const _WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const _WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const _FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: noop,
        unregister: noop
    };
};
const finalizationBatchSize = 10024;
class WeakCache {
    constructor(max = Infinity, dispose = defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new _WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new _WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new _FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older, newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key,
            value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cFEae":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cacheSizes", ()=>cacheSizes);
var _tslib = require("tslib");
var _indexJs = require("../globals/index.js");
var cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var cacheSizes = (0, _tslib.__assign)({}, (0, _indexJs.global)[cacheSizeSymbol]);

},{"tslib":"gBS4y","../globals/index.js":"jejDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b13lS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerGlobalCache", ()=>registerGlobalCache);
parcelHelpers.export(exports, "getApolloClientMemoryInternals", ()=>getApolloClientMemoryInternals);
parcelHelpers.export(exports, "getInMemoryCacheMemoryInternals", ()=>getInMemoryCacheMemoryInternals);
parcelHelpers.export(exports, "getApolloCacheMemoryInternals", ()=>getApolloCacheMemoryInternals);
var _tslib = require("tslib");
var _sizesJs = require("./sizes.js");
var globalCaches = {};
function registerGlobalCache(name, getSize) {
    globalCaches[name] = getSize;
}
var getApolloClientMemoryInternals = globalThis.__DEV__ !== false ? _getApolloClientMemoryInternals : undefined;
var getInMemoryCacheMemoryInternals = globalThis.__DEV__ !== false ? _getInMemoryCacheMemoryInternals : undefined;
var getApolloCacheMemoryInternals = globalThis.__DEV__ !== false ? _getApolloCacheMemoryInternals : undefined;
function getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, _sizesJs.cacheSizes)[k] || v
        ];
    }));
}
function _getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: getCurrentCacheSizes(),
        sizes: (0, _tslib.__assign)({
            print: (_a = globalCaches.print) === null || _a === void 0 ? void 0 : _a.call(globalCaches),
            parser: (_b = globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call(globalCaches),
            canonicalStringify: (_c = globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call(globalCaches),
            links: linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function _getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function _getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, _getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function getWrapperInformation(f) {
    return isWrapper(f) ? f.size : undefined;
}
function isDefined(value) {
    return value != null;
}
function transformInfo(transform) {
    return recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function recurseTransformInfo(transform) {
    return transform ? (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([
        getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter(isDefined) : [];
}
function linkInfo(link) {
    var _a;
    return link ? (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], linkInfo(link === null || link === void 0 ? void 0 : link.left), true), linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter(isDefined) : [];
}

},{"tslib":"gBS4y","./sizes.js":"cFEae","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3eQSw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// These helper functions are important for making optimism work with
// asynchronous code. In order to register parent-child dependencies,
// optimism needs to know about any currently active parent computations.
// In ordinary synchronous code, the parent context is implicit in the
// execution stack, but asynchronous code requires some extra guidance in
// order to propagate context from one async task segment to the next.
parcelHelpers.export(exports, "bindContext", ()=>(0, _contextJs.bindContext));
parcelHelpers.export(exports, "noContext", ()=>(0, _contextJs.noContext));
parcelHelpers.export(exports, "nonReactive", ()=>(0, _contextJs.nonReactive));
parcelHelpers.export(exports, "setTimeout", ()=>(0, _contextJs.setTimeout));
parcelHelpers.export(exports, "asyncFromGen", ()=>(0, _contextJs.asyncFromGen));
parcelHelpers.export(exports, "Slot", ()=>(0, _contextJs.Slot));
// A lighter-weight dependency, similar to OptimisticWrapperFunction, except
// with only one argument, no makeCacheKey, no wrapped function to recompute,
// and no result value. Useful for representing dependency leaves in the graph
// of computation. Subscriptions are supported.
parcelHelpers.export(exports, "dep", ()=>(0, _depJs.dep));
parcelHelpers.export(exports, "defaultMakeCacheKey", ()=>defaultMakeCacheKey);
// If you're paranoid about memory leaks, or you want to avoid using WeakMap
// under the hood, but you still need the behavior of defaultMakeCacheKey,
// import this constructor to create your own tries.
parcelHelpers.export(exports, "KeyTrie", ()=>(0, _trie.Trie));
parcelHelpers.export(exports, "wrap", ()=>wrap);
var _trie = require("@wry/trie");
var _caches = require("@wry/caches");
var _entryJs = require("./entry.js");
var _contextJs = require("./context.js");
var _depJs = require("./dep.js");
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let defaultKeyTrie;
function defaultMakeCacheKey(...args) {
    const trie = defaultKeyTrie || (defaultKeyTrie = new (0, _trie.Trie)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const caches = new Set();
function wrap(originalFunction, { max = Math.pow(2, 16), keyArgs, makeCacheKey = defaultMakeCacheKey, normalizeResult, subscribe, cache: cacheOption = (0, _caches.StrongCache) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, _entryJs.Entry)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, _contextJs.parentEntrySlot).hasValue()) {
            caches.forEach((cache)=>cache.clean());
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max,
        keyArgs,
        makeCacheKey,
        normalizeResult,
        subscribe,
        cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}

},{"@wry/trie":"Hbaaq","@wry/caches":"c7ATU","./entry.js":"lxxhY","./context.js":"7JSim","./dep.js":"eDoko","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Hbaaq":[function(require,module,exports) {
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trie", ()=>Trie);
const defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach, slice } = Array.prototype;
const { hasOwnProperty } = Object.prototype;
class Trie {
    constructor(weakness = true, makeData = defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        forEach.call(array, (key)=>node = node.getChildTrie(key));
        return hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData(slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = this.weakness && isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    }
}
function isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lxxhY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Entry", ()=>Entry);
var _contextJs = require("./context.js");
var _helpersJs = require("./helpers.js");
const emptySetPool = [];
const POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
class Entry {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    peek() {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this) ? reallyRecompute(this, args) : valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, _helpersJs.maybeUnsubscribe)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, (parent, child)=>{
            parent.setDirty();
            forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, _helpersJs.arrayFromSet)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
Entry.count = 0;
function rememberParent(child) {
    const parent = (0, _contextJs.parentEntrySlot).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if (mightBeDirty(child)) reportDirtyChild(parent, child);
        else reportCleanChild(parent, child);
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, _contextJs.parentEntrySlot).withValue(entry, recomputeNewValue, [
        entry,
        args
    ]);
    if (maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    setClean(entry);
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, _helpersJs.arrayFromSet)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    const parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, valueCopy(child.value));
    else if (!valueIs(childValue, child.value)) parent.setDirty();
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) return;
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, _helpersJs.maybeUnsubscribe)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

},{"./context.js":"7JSim","./helpers.js":"k6u7L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7JSim":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindContext", ()=>(0, _context.bind));
parcelHelpers.export(exports, "noContext", ()=>(0, _context.noContext));
parcelHelpers.export(exports, "setTimeout", ()=>(0, _context.setTimeout));
parcelHelpers.export(exports, "asyncFromGen", ()=>(0, _context.asyncFromGen));
parcelHelpers.export(exports, "parentEntrySlot", ()=>parentEntrySlot);
parcelHelpers.export(exports, "nonReactive", ()=>nonReactive);
parcelHelpers.export(exports, "Slot", ()=>(0, _context.Slot));
var _context = require("@wry/context");
const parentEntrySlot = new (0, _context.Slot)();
function nonReactive(fn) {
    return parentEntrySlot.withValue(void 0, fn);
}

},{"@wry/context":"7n4uQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7n4uQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slot", ()=>(0, _slotJs.Slot));
parcelHelpers.export(exports, "bind", ()=>bind);
parcelHelpers.export(exports, "noContext", ()=>noContext);
// Like global.setTimeout, except the callback runs with captured context.
parcelHelpers.export(exports, "setTimeout", ()=>setTimeoutWithContext);
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
parcelHelpers.export(exports, "asyncFromGen", ()=>asyncFromGen);
parcelHelpers.export(exports, "wrapYieldingFiberMethods", ()=>wrapYieldingFiberMethods);
var _slotJs = require("./slot.js");
const { bind, noContext } = (0, _slotJs.Slot);
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
function asyncFromGen(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = bind(gen.next);
        const boundThrow = bind(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const wrappedFibers = [];
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}

},{"./slot.js":"7VGUi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7VGUi":[function(require,module,exports) {
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slot", ()=>Slot);
var global = arguments[3];
let currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const MISSING_VALUE = {};
let idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === MISSING_VALUE) break;
                if (context !== currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                currentContext.slots[this.id] = value;
                return true;
            }
            if (currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = currentContext;
            currentContext = {
                parent,
                slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = currentContext;
            return function() {
                const saved = currentContext;
                try {
                    currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if (currentContext) {
                const saved = currentContext;
                try {
                    currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const globalKey = "@wry/context:Slot";
const host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
maybe(()=>global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const globalHost = host;
const Slot = globalHost[globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[globalKey] || function(Slot) {
    try {
        Object.defineProperty(globalHost, globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}(makeSlotClass());

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k6u7L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasOwnProperty", ()=>hasOwnProperty);
parcelHelpers.export(exports, "arrayFromSet", ()=>arrayFromSet);
parcelHelpers.export(exports, "maybeUnsubscribe", ()=>maybeUnsubscribe);
const { hasOwnProperty } = Object.prototype;
const arrayFromSet = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function maybeUnsubscribe(entryOrDep) {
    const { unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eDoko":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dep", ()=>dep);
var _contextJs = require("./context.js");
var _helpersJs = require("./helpers.js");
const EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function dep(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, _contextJs.parentEntrySlot).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, _helpersJs.maybeUnsubscribe)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, _helpersJs.hasOwnProperty).call(EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, _helpersJs.arrayFromSet)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, _helpersJs.maybeUnsubscribe)(dep);
        }
    };
    return depend;
}

},{"./context.js":"7JSim","./helpers.js":"k6u7L","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bXp5G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "print", ()=>print);
var _graphql = require("graphql");
var _indexJs = require("../caching/index.js");
var _getMemoryInternalsJs = require("../caching/getMemoryInternals.js");
var printCache;
var print = Object.assign(function(ast) {
    var result = printCache.get(ast);
    if (!result) {
        result = (0, _graphql.print)(ast);
        printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        printCache = new (0, _indexJs.AutoCleanedWeakCache)((0, _indexJs.cacheSizes).print || 2000 /* defaultCacheSizes.print */ );
    }
});
print.reset();
if (globalThis.__DEV__ !== false) (0, _getMemoryInternalsJs.registerGlobalCache)("print", function() {
    return printCache ? printCache.size : 0;
});

},{"graphql":"crWS5","../caching/index.js":"6yRGA","../caching/getMemoryInternals.js":"b13lS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kI1pM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removeDirectivesFromDocument", ()=>removeDirectivesFromDocument);
parcelHelpers.export(exports, "addTypenameToDocument", ()=>addTypenameToDocument);
parcelHelpers.export(exports, "removeConnectionDirectiveFromDocument", ()=>removeConnectionDirectiveFromDocument);
parcelHelpers.export(exports, "removeArgumentsFromDocument", ()=>removeArgumentsFromDocument);
parcelHelpers.export(exports, "removeFragmentSpreadFromDocument", ()=>removeFragmentSpreadFromDocument);
// If the incoming document is a query, return it as is. Otherwise, build a
// new document containing a query operation based on the selection set
// of the previous main operation.
parcelHelpers.export(exports, "buildQueryFromSelectionSet", ()=>buildQueryFromSelectionSet);
// Remove fields / selection sets that include an @client directive.
parcelHelpers.export(exports, "removeClientSetsFromDocument", ()=>removeClientSetsFromDocument);
var _tslib = require("tslib");
var _indexJs = require("../globals/index.js");
var _graphql = require("graphql");
var _getFromASTJs = require("./getFromAST.js");
var _storeUtilsJs = require("./storeUtils.js");
var _fragmentsJs = require("./fragments.js");
var _arraysJs = require("../common/arrays.js");
var TYPENAME_FIELD = {
    kind: (0, _graphql.Kind).FIELD,
    name: {
        kind: (0, _graphql.Kind).NAME,
        value: "__typename"
    }
};
function isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, _graphql.Kind).FRAGMENT_SPREAD && isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty((0, _getFromASTJs.getOperationDefinition)(doc) || (0, _getFromASTJs.getFragmentDefinition)(doc), (0, _fragmentsJs.createFragmentMap)((0, _getFromASTJs.getFragmentDefinitions)(doc))) ? null : doc;
}
function getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function removeDirectivesFromDocument(directives, doc) {
    (0, _getFromASTJs.checkDocument)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = makeInUseGetterFunction("");
    var getInUseByFragmentName = makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, _arraysJs.isArray)(ancestor)) continue;
            if (ancestor.kind === (0, _graphql.Kind).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, _graphql.Kind).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, _indexJs.invariant).error(83);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, _graphql.Kind).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, _arraysJs.isNonEmptyArray)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, _graphql.visit)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, _graphql.Kind).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, _graphql.Kind).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, _graphql.Kind).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return nullIfDocIsEmpty((0, _graphql.visit)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var addTypenameToDocument = Object.assign(function(doc) {
    return (0, _graphql.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, _graphql.Kind).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, _storeUtilsJs.isField)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, _storeUtilsJs.isField)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
                    selections: (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], selections, true), [
                        TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === TYPENAME_FIELD;
    }
});
var connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(84);
        }
        return willRemove;
    }
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([
        connectionRemoveConfig
    ], (0, _getFromASTJs.checkDocument)(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, _storeUtilsJs.isField)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some(getDirectiveMatcher(directives)) || nestedCheck && hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, _graphql.Kind).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty((0, _graphql.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return nullIfDocIsEmpty((0, _graphql.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function buildQueryFromSelectionSet(document) {
    var definition = (0, _getFromASTJs.getMainDefinition)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, _graphql.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    (0, _getFromASTJs.checkDocument)(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}

},{"tslib":"gBS4y","../globals/index.js":"jejDs","graphql":"crWS5","./getFromAST.js":"2MXZ3","./storeUtils.js":"fVqew","./fragments.js":"ihq4t","../common/arrays.js":"b8nAm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b8nAm":[function(require,module,exports) {
// A version of Array.isArray that works better with readonly arrays.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isNonEmptyArray", ()=>isNonEmptyArray);
var isArray = Array.isArray;
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jbiGu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _zenObservableTs.Observable));
var _zenObservableTs = require("zen-observable-ts");
// This simplified polyfill attempts to follow the ECMAScript Observable
// proposal (https://github.com/zenparsing/es-observable)
var _symbolObservable = require("symbol-observable");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var prototype = (0, _zenObservableTs.Observable).prototype;
var fakeObsSymbol = "@@observable";
if (!prototype[fakeObsSymbol]) // @ts-expect-error
prototype[fakeObsSymbol] = function() {
    return this;
};

},{"zen-observable-ts":"hWuwo","symbol-observable":"94vFV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hWuwo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var hasSymbols = function() {
    return typeof Symbol === "function";
};
var hasSymbol = function(name) {
    return hasSymbols() && Boolean(Symbol[name]);
};
var getSymbol = function(name) {
    return hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if (hasSymbols() && !hasSymbol("observable")) Symbol.observable = Symbol("observable");
var SymbolIterator = getSymbol("iterator");
var SymbolObservable = getSymbol("observable");
var SymbolSpecies = getSymbol("species"); // === Abstract Operations ===
function getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : Observable;
}
function isObservable(x) {
    return x instanceof Observable; // SPEC: Brand check
}
function hostReportError(e) {
    if (hostReportError.log) hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            hostReportError(e);
        }
    });
}
function cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        hostReportError(e);
    }
}
function closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        hostReportError(e);
    }
    if (subscription._state === "closed") cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        enqueue(function() {
            return flushSubscription(subscription);
        });
        return;
    }
    notifySubscription(subscription, type, value);
}
var Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== "closed") {
            closeSubscription(this);
            cleanupSubscription(this);
        }
    };
    _createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        onNotify(this._subscription, "next", value);
    };
    _proto2.error = function error(value) {
        onNotify(this._subscription, "error", value);
    };
    _proto2.complete = function complete() {
        onNotify(this._subscription, "complete");
    };
    _createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== "object" || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== "function") {
                reject(new TypeError(fn + " is not a function"));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === "function" ? this : Observable;
        if (x == null) throw new TypeError(x + " is not an object");
        var method = getMethod(x, SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
            if (isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if (hasSymbol("iterator")) {
            method = getMethod(x, SymbolIterator);
            if (method) return new C(function(observer) {
                enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + " is not observable");
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === "function" ? this : Observable;
        return new C(function(observer) {
            enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    _createClass(Observable, null, [
        {
            key: SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if (hasSymbols()) Object.defineProperty(Observable, Symbol("extensions"), {
    value: {
        symbol: SymbolObservable,
        hostReportError: hostReportError
    },
    configurable: true
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"94vFV":[function(require,module,exports) {
/* global window */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ponyfillJs = require("./ponyfill.js");
var _ponyfillJsDefault = parcelHelpers.interopDefault(_ponyfillJs);
var global = arguments[3];
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof global !== "undefined") root = global;
else root = module;
var result = (0, _ponyfillJsDefault.default)(root);
exports.default = result;

},{"./ponyfill.js":"5YVuf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5YVuf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>symbolObservablePonyfill);
function symbolObservablePonyfill(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === "function") // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for("https://github.com/benlesh/symbol-observable");
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol("https://github.com/benlesh/symbol-observable");
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = "@@observable";
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"izMW6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFulfilledPromise", ()=>createFulfilledPromise);
parcelHelpers.export(exports, "createRejectedPromise", ()=>createRejectedPromise);
parcelHelpers.export(exports, "isStatefulPromise", ()=>isStatefulPromise);
parcelHelpers.export(exports, "wrapPromiseWithState", ()=>wrapPromiseWithState);
function createFulfilledPromise(value) {
    var promise = Promise.resolve(value);
    promise.status = "fulfilled";
    promise.value = value;
    return promise;
}
function createRejectedPromise(reason) {
    var promise = Promise.reject(reason);
    // prevent potential edge cases leaking unhandled error rejections
    promise.catch(function() {});
    promise.status = "rejected";
    promise.reason = reason;
    return promise;
}
function isStatefulPromise(promise) {
    return "status" in promise;
}
function wrapPromiseWithState(promise) {
    if (isStatefulPromise(promise)) return promise;
    var pendingPromise = promise;
    pendingPromise.status = "pending";
    pendingPromise.then(function(value) {
        if (pendingPromise.status === "pending") {
            var fulfilledPromise = pendingPromise;
            fulfilledPromise.status = "fulfilled";
            fulfilledPromise.value = value;
        }
    }, function(reason) {
        if (pendingPromise.status === "pending") {
            var rejectedPromise = pendingPromise;
            rejectedPromise.status = "rejected";
            rejectedPromise.reason = reason;
        }
    });
    return promise;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3DI7j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeDeep", ()=>mergeDeep);
// In almost any situation where you could succeed in getting the
// TypeScript compiler to infer a tuple type for the sources array, you
// could just use mergeDeep instead of mergeDeepArray, so instead of
// trying to convert T[] to an intersection type we just infer the array
// element type, which works perfectly when the sources array has a
// consistent element type.
parcelHelpers.export(exports, "mergeDeepArray", ()=>mergeDeepArray);
parcelHelpers.export(exports, "DeepMerger", ()=>DeepMerger);
var _tslib = require("tslib");
var _objectsJs = require("./objects.js");
var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, _objectsJs.isNonNullObject);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, _objectsJs.isNonNullObject)(source) && (0, _objectsJs.isNonNullObject)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if (hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, _tslib.__spreadArray)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, _objectsJs.isNonNullObject)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, _tslib.__assign)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();

},{"tslib":"gBS4y","./objects.js":"cr3hk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hbHBs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Deeply clones a value to create a new instance.
 */ parcelHelpers.export(exports, "cloneDeep", ()=>cloneDeep);
var toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch(toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"739CY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "maybeDeepFreeze", ()=>maybeDeepFreeze);
var _objectsJs = require("./objects.js");
function deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, _objectsJs.isNonNullObject)(obj) && shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, _objectsJs.isNonNullObject)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (globalThis.__DEV__ !== false) deepFreeze(obj);
    return obj;
}

},{"./objects.js":"cr3hk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Yve4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iterateObserversSafely", ()=>iterateObserversSafely);
function iterateObserversSafely(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gwUgI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Like Observable.prototype.map, except that the mapping function can
// optionally return a Promise (or be async).
parcelHelpers.export(exports, "asyncMap", ()=>asyncMap);
var _observableJs = require("./Observable.js");
function asyncMap(observable, mapFn, catchFn) {
    return new (0, _observableJs.Observable)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}

},{"./Observable.js":"jbiGu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSTlz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Concast", ()=>Concast);
var _tslib = require("tslib");
var _observableJs = require("./Observable.js");
var _iterationJs = require("./iteration.js");
var _subclassingJs = require("./subclassing.js");
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var Concast = /** @class */ function(_super) {
    (0, _tslib.__extends)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, _iterationJs.iterateObserversSafely)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, _iterationJs.iterateObserversSafely)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, _iterationJs.iterateObserversSafely)(_this.observers, "complete");
                    } else if (isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, _observableJs.Observable)(sources)
        ];
        if (isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, _observableJs.Observable));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, _subclassingJs.fixObservableSubclass)(Concast);

},{"tslib":"gBS4y","./Observable.js":"jbiGu","./iteration.js":"8Yve4","./subclassing.js":"apAKh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"apAKh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Generic implementations of Observable.prototype methods like map and
// filter need to know how to create a new Observable from an Observable
// subclass (like Concast or ObservableQuery). Those methods assume
// (perhaps unwisely?) that they can call the subtype's constructor with a
// Subscriber function, even though the subclass constructor might expect
// different parameters. Defining this static Symbol.species property on
// the subclass is a hint to generic Observable code to use the default
// constructor instead of trying to do `new Subclass(observer => ...)`.
parcelHelpers.export(exports, "fixObservableSubclass", ()=>fixObservableSubclass);
var _observableJs = require("./Observable.js");
var _canUseJs = require("../common/canUse.js");
function fixObservableSubclass(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, _observableJs.Observable)
        });
    }
    if ((0, _canUseJs.canUseSymbol) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}

},{"./Observable.js":"jbiGu","../common/canUse.js":"5l5O1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gjlhw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "graphQLResultHasError", ()=>graphQLResultHasError);
parcelHelpers.export(exports, "getGraphQLErrorsFromResult", ()=>getGraphQLErrorsFromResult);
var _arraysJs = require("./arrays.js");
var _incrementalResultJs = require("./incrementalResult.js");
function graphQLResultHasError(result) {
    var errors = getGraphQLErrorsFromResult(result);
    return (0, _arraysJs.isNonEmptyArray)(errors);
}
function getGraphQLErrorsFromResult(result) {
    var graphQLErrors = (0, _arraysJs.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
    if ((0, _incrementalResultJs.isExecutionPatchIncrementalResult)(result) && (0, _arraysJs.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}

},{"./arrays.js":"b8nAm","./incrementalResult.js":"38Fo8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"38Fo8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isExecutionPatchIncrementalResult", ()=>isExecutionPatchIncrementalResult);
parcelHelpers.export(exports, "isExecutionPatchInitialResult", ()=>isExecutionPatchInitialResult);
parcelHelpers.export(exports, "isExecutionPatchResult", ()=>isExecutionPatchResult);
// This function detects an Apollo payload result before it is transformed
// into a FetchResult via HttpLink; it cannot detect an ApolloPayloadResult
// once it leaves the link chain.
parcelHelpers.export(exports, "isApolloPayloadResult", ()=>isApolloPayloadResult);
parcelHelpers.export(exports, "mergeIncrementalData", ()=>mergeIncrementalData);
var _objectsJs = require("./objects.js");
var _arraysJs = require("./arrays.js");
var _mergeDeepJs = require("./mergeDeep.js");
function isExecutionPatchIncrementalResult(value) {
    return "incremental" in value;
}
function isExecutionPatchInitialResult(value) {
    return "hasNext" in value && "data" in value;
}
function isExecutionPatchResult(value) {
    return isExecutionPatchIncrementalResult(value) || isExecutionPatchInitialResult(value);
}
function isApolloPayloadResult(value) {
    return (0, _objectsJs.isNonNullObject)(value) && "payload" in value;
}
function mergeIncrementalData(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, _mergeDeepJs.DeepMerger)();
    if (isExecutionPatchIncrementalResult(result) && (0, _arraysJs.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}

},{"./objects.js":"cr3hk","./arrays.js":"b8nAm","./mergeDeep.js":"3DI7j","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"38rYW":[function(require,module,exports) {
/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compact", ()=>compact);
function compact() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1ZcdS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeOptions", ()=>mergeOptions);
var _tslib = require("tslib");
var _compactJs = require("./compact.js");
function mergeOptions(defaults, options) {
    return (0, _compactJs.compact)(defaults, options, options.variables && {
        variables: (0, _compactJs.compact)((0, _tslib.__assign)((0, _tslib.__assign)({}, defaults && defaults.variables), options.variables))
    });
}

},{"tslib":"gBS4y","./compact.js":"38rYW","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bdwh2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromError", ()=>(0, _fromErrorJs.fromError));
parcelHelpers.export(exports, "toPromise", ()=>(0, _toPromiseJs.toPromise));
parcelHelpers.export(exports, "fromPromise", ()=>(0, _fromPromiseJs.fromPromise));
parcelHelpers.export(exports, "throwServerError", ()=>(0, _throwServerErrorJs.throwServerError));
parcelHelpers.export(exports, "validateOperation", ()=>(0, _validateOperationJs.validateOperation));
parcelHelpers.export(exports, "createOperation", ()=>(0, _createOperationJs.createOperation));
parcelHelpers.export(exports, "transformOperation", ()=>(0, _transformOperationJs.transformOperation));
parcelHelpers.export(exports, "filterOperationVariables", ()=>(0, _filterOperationVariablesJs.filterOperationVariables));
var _indexJs = require("../../utilities/globals/index.js");
var _fromErrorJs = require("./fromError.js");
var _toPromiseJs = require("./toPromise.js");
var _fromPromiseJs = require("./fromPromise.js");
var _throwServerErrorJs = require("./throwServerError.js");
var _validateOperationJs = require("./validateOperation.js");
var _createOperationJs = require("./createOperation.js");
var _transformOperationJs = require("./transformOperation.js");
var _filterOperationVariablesJs = require("./filterOperationVariables.js");

},{"../../utilities/globals/index.js":"jejDs","./fromError.js":"diI07","./toPromise.js":"chdT7","./fromPromise.js":"6p27v","./throwServerError.js":"6cmEm","./validateOperation.js":"5ObUR","./createOperation.js":"cXYpD","./transformOperation.js":"fuwrx","./filterOperationVariables.js":"c7Uvr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"diI07":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromError", ()=>fromError);
var _indexJs = require("../../utilities/index.js");
function fromError(errorValue) {
    return new (0, _indexJs.Observable)(function(observer) {
        observer.error(errorValue);
    });
}

},{"../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"chdT7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toPromise", ()=>toPromise);
var _indexJs = require("../../utilities/globals/index.js");
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(42);
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}

},{"../../utilities/globals/index.js":"jejDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6p27v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromPromise", ()=>fromPromise);
var _indexJs = require("../../utilities/index.js");
function fromPromise(promise) {
    return new (0, _indexJs.Observable)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}

},{"../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6cmEm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwServerError", ()=>throwServerError);
var throwServerError = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ObUR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateOperation", ()=>validateOperation);
var _indexJs = require("../../utilities/globals/index.js");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, _indexJs.newInvariantError)(43, key);
    }
    return operation;
}

},{"../../utilities/globals/index.js":"jejDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cXYpD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOperation", ()=>createOperation);
var _tslib = require("tslib");
function createOperation(starting, operation) {
    var context = (0, _tslib.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, _tslib.__assign)((0, _tslib.__assign)({}, context), next(context));
        else context = (0, _tslib.__assign)((0, _tslib.__assign)({}, context), next);
    };
    var getContext = function() {
        return (0, _tslib.__assign)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}

},{"tslib":"gBS4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fuwrx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformOperation", ()=>transformOperation);
var _indexJs = require("../../utilities/index.js");
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, _indexJs.getOperationName)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}

},{"../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c7Uvr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterOperationVariables", ()=>filterOperationVariables);
var _tslib = require("tslib");
var _graphql = require("graphql");
function filterOperationVariables(variables, query) {
    var result = (0, _tslib.__assign)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, _graphql.visit)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}

},{"tslib":"gBS4y","graphql":"crWS5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4imHp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _apolloLinkJs = require("./ApolloLink.js");
var from = (0, _apolloLinkJs.ApolloLink).from;

},{"./ApolloLink.js":"gu1vX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eYGav":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "split", ()=>split);
var _apolloLinkJs = require("./ApolloLink.js");
var split = (0, _apolloLinkJs.ApolloLink).split;

},{"./ApolloLink.js":"gu1vX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lgjiZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _apolloLinkJs = require("./ApolloLink.js");
var concat = (0, _apolloLinkJs.ApolloLink).concat;

},{"./ApolloLink.js":"gu1vX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iOTkz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "execute", ()=>execute);
var _apolloLinkJs = require("./ApolloLink.js");
var execute = (0, _apolloLinkJs.ApolloLink).execute;

},{"./ApolloLink.js":"gu1vX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8IYYS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6rkPi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseAndCheckHttpResponse", ()=>(0, _parseAndCheckHttpResponseJs.parseAndCheckHttpResponse));
parcelHelpers.export(exports, "serializeFetchParameter", ()=>(0, _serializeFetchParameterJs.serializeFetchParameter));
parcelHelpers.export(exports, "fallbackHttpConfig", ()=>(0, _selectHttpOptionsAndBodyJs.fallbackHttpConfig));
parcelHelpers.export(exports, "defaultPrinter", ()=>(0, _selectHttpOptionsAndBodyJs.defaultPrinter));
parcelHelpers.export(exports, "selectHttpOptionsAndBody", ()=>(0, _selectHttpOptionsAndBodyJs.selectHttpOptionsAndBody));
parcelHelpers.export(exports, "selectHttpOptionsAndBodyInternal", ()=>(0, _selectHttpOptionsAndBodyJs.selectHttpOptionsAndBodyInternal));
parcelHelpers.export(exports, "checkFetcher", ()=>(0, _checkFetcherJs.checkFetcher));
parcelHelpers.export(exports, "createSignalIfSupported", ()=>(0, _createSignalIfSupportedJs.createSignalIfSupported));
parcelHelpers.export(exports, "selectURI", ()=>(0, _selectURIJs.selectURI));
parcelHelpers.export(exports, "createHttpLink", ()=>(0, _createHttpLinkJs.createHttpLink));
parcelHelpers.export(exports, "HttpLink", ()=>(0, _httpLinkJs.HttpLink));
parcelHelpers.export(exports, "rewriteURIForGET", ()=>(0, _rewriteURIForGETJs.rewriteURIForGET));
var _indexJs = require("../../utilities/globals/index.js");
var _parseAndCheckHttpResponseJs = require("./parseAndCheckHttpResponse.js");
var _serializeFetchParameterJs = require("./serializeFetchParameter.js");
var _selectHttpOptionsAndBodyJs = require("./selectHttpOptionsAndBody.js");
var _checkFetcherJs = require("./checkFetcher.js");
var _createSignalIfSupportedJs = require("./createSignalIfSupported.js");
var _selectURIJs = require("./selectURI.js");
var _createHttpLinkJs = require("./createHttpLink.js");
var _httpLinkJs = require("./HttpLink.js");
var _rewriteURIForGETJs = require("./rewriteURIForGET.js");

},{"../../utilities/globals/index.js":"jejDs","./parseAndCheckHttpResponse.js":"87K8b","./serializeFetchParameter.js":"aDWte","./selectHttpOptionsAndBody.js":"4mnJ8","./checkFetcher.js":"anoPt","./createSignalIfSupported.js":"gphXs","./selectURI.js":"gey39","./createHttpLink.js":"q6VKi","./HttpLink.js":"gS1LW","./rewriteURIForGET.js":"lOvFy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"87K8b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readMultipartBody", ()=>readMultipartBody);
parcelHelpers.export(exports, "parseHeaders", ()=>parseHeaders);
parcelHelpers.export(exports, "parseJsonBody", ()=>parseJsonBody);
parcelHelpers.export(exports, "handleError", ()=>handleError);
parcelHelpers.export(exports, "parseAndCheckHttpResponse", ()=>parseAndCheckHttpResponse);
var _tslib = require("tslib");
var _responseIteratorJs = require("./responseIterator.js");
var _indexJs = require("../utils/index.js");
var _indexJs1 = require("../../errors/index.js");
var _incrementalResultJs = require("../../utilities/common/incrementalResult.js");
var hasOwnProperty = Object.prototype.hasOwnProperty;
function readMultipartBody(response, nextValue) {
    var _a;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _b, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _c, _d;
        return (0, _tslib.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, _responseIteratorJs.responseIterator)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _b = _e.sent(), value = _b.value, done = _b.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _c = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _c[0], buffer = _c[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = parseHeaders(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = parseJsonBody(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, _incrementalResultJs.isApolloPayloadResult)(result)) {
                                    next = {};
                                    if ("payload" in result) next = (0, _tslib.__assign)({}, result.payload);
                                    if ("errors" in result) next = (0, _tslib.__assign)((0, _tslib.__assign)({}, next), {
                                        extensions: (0, _tslib.__assign)((0, _tslib.__assign)({}, "extensions" in next ? next.extensions : null), (_d = {}, _d[0, _indexJs1.PROTOCOL_ERRORS_SYMBOL] = result.errors, _d))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function parseHeaders(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function parseJsonBody(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, _indexJs.throwServerError)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function handleError(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function parseAndCheckHttpResponse(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return parseJsonBody(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !hasOwnProperty.call(result, "data") && !hasOwnProperty.call(result, "errors")) // Data error
            (0, _indexJs.throwServerError)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}

},{"tslib":"gBS4y","./responseIterator.js":"21bhn","../utils/index.js":"bdwh2","../../errors/index.js":"73MUX","../../utilities/common/incrementalResult.js":"38Fo8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"21bhn":[function(require,module,exports) {
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "responseIterator", ()=>responseIterator);
var _indexJs = require("../../utilities/index.js");
var _asyncJs = require("./iterators/async.js");
var _asyncJsDefault = parcelHelpers.interopDefault(_asyncJs);
var _nodeStreamJs = require("./iterators/nodeStream.js");
var _nodeStreamJsDefault = parcelHelpers.interopDefault(_nodeStreamJs);
var _promiseJs = require("./iterators/promise.js");
var _promiseJsDefault = parcelHelpers.interopDefault(_promiseJs);
var _readerJs = require("./iterators/reader.js");
var _readerJsDefault = parcelHelpers.interopDefault(_readerJs);
function isNodeResponse(value) {
    return !!value.body;
}
function isReadableStream(value) {
    return !!value.getReader;
}
function isAsyncIterableIterator(value) {
    return !!((0, _indexJs.canUseAsyncIteratorSymbol) && value[Symbol.asyncIterator]);
}
function isStreamableBlob(value) {
    return !!value.stream;
}
function isBlob(value) {
    return !!value.arrayBuffer;
}
function isNodeReadableStream(value) {
    return !!value.pipe;
}
function responseIterator(response) {
    var body = response;
    if (isNodeResponse(response)) body = response.body;
    if (isAsyncIterableIterator(body)) return (0, _asyncJsDefault.default)(body);
    if (isReadableStream(body)) return (0, _readerJsDefault.default)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if (isStreamableBlob(body)) return (0, _readerJsDefault.default)(body.stream().getReader());
    if (isBlob(body)) return (0, _promiseJsDefault.default)(body.arrayBuffer());
    if (isNodeReadableStream(body)) return (0, _nodeStreamJsDefault.default)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}

},{"../../utilities/index.js":"k55vB","./iterators/async.js":"KXbvT","./iterators/nodeStream.js":"8JfJQ","./iterators/promise.js":"9HqfW","./iterators/reader.js":"3ldLu","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"KXbvT":[function(require,module,exports) {
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>asyncIterator);
function asyncIterator(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8JfJQ":[function(require,module,exports) {
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>nodeStreamIterator);
var _indexJs = require("../../../utilities/index.js");
function nodeStreamIterator(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, _indexJs.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

},{"../../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9HqfW":[function(require,module,exports) {
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>promiseIterator);
var _indexJs = require("../../../utilities/index.js");
function promiseIterator(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, _indexJs.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

},{"../../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ldLu":[function(require,module,exports) {
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>readerIterator);
var _indexJs = require("../../../utilities/index.js");
function readerIterator(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, _indexJs.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

},{"../../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73MUX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROTOCOL_ERRORS_SYMBOL", ()=>PROTOCOL_ERRORS_SYMBOL);
parcelHelpers.export(exports, "graphQLResultHasProtocolErrors", ()=>graphQLResultHasProtocolErrors);
parcelHelpers.export(exports, "isApolloError", ()=>isApolloError);
parcelHelpers.export(exports, "ApolloError", ()=>ApolloError);
var _tslib = require("tslib");
var _indexJs = require("../utilities/globals/index.js");
var _indexJs1 = require("../utilities/index.js");
var PROTOCOL_ERRORS_SYMBOL = Symbol();
function graphQLResultHasProtocolErrors(result) {
    if (result.extensions) return Array.isArray(result.extensions[PROTOCOL_ERRORS_SYMBOL]);
    return false;
}
function isApolloError(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var generateErrorMessage = function(err) {
    var errors = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, _indexJs1.isNonNullObject)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var ApolloError = /** @class */ function(_super) {
    (0, _tslib.__extends)(ApolloError, _super);
    // Constructs an instance of ApolloError given a GraphQLError
    // or a network error. Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);

},{"tslib":"gBS4y","../utilities/globals/index.js":"jejDs","../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aDWte":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeFetchParameter", ()=>serializeFetchParameter);
var _indexJs = require("../../utilities/globals/index.js");
var serializeFetchParameter = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, _indexJs.newInvariantError)(39, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};

},{"../../utilities/globals/index.js":"jejDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4mnJ8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fallbackHttpConfig", ()=>fallbackHttpConfig);
parcelHelpers.export(exports, "defaultPrinter", ()=>defaultPrinter);
parcelHelpers.export(exports, "selectHttpOptionsAndBody", ()=>selectHttpOptionsAndBody);
parcelHelpers.export(exports, "selectHttpOptionsAndBodyInternal", ()=>selectHttpOptionsAndBodyInternal);
var _tslib = require("tslib");
var _indexJs = require("../../utilities/index.js");
var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var defaultOptions = {
    method: "POST"
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions
};
var defaultPrinter = function(ast, printer) {
    return printer(ast);
};
function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal.apply(void 0, (0, _tslib.__spreadArray)([
        operation,
        defaultPrinter
    ], configs, false));
}
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, options), config.options), {
            headers: (0, _tslib.__assign)((0, _tslib.__assign)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, _tslib.__assign)((0, _tslib.__assign)({}, http), config.http);
    });
    if (options.headers) options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, _indexJs.print));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}

},{"tslib":"gBS4y","../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"anoPt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkFetcher", ()=>checkFetcher);
var _indexJs = require("../../utilities/globals/index.js");
var checkFetcher = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, _indexJs.newInvariantError)(37);
};

},{"../../utilities/globals/index.js":"jejDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gphXs":[function(require,module,exports) {
/**
 * @deprecated
 * This is not used internally any more and will be removed in
 * the next major version of Apollo Client.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSignalIfSupported", ()=>createSignalIfSupported);
var createSignalIfSupported = function() {
    if (typeof AbortController === "undefined") return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gey39":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectURI", ()=>selectURI);
var selectURI = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"q6VKi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHttpLink", ()=>createHttpLink);
var _tslib = require("tslib");
var _indexJs = require("../../utilities/globals/index.js");
var _indexJs1 = require("../core/index.js");
var _indexJs2 = require("../../utilities/index.js");
var _serializeFetchParameterJs = require("./serializeFetchParameter.js");
var _selectURIJs = require("./selectURI.js");
var _parseAndCheckHttpResponseJs = require("./parseAndCheckHttpResponse.js");
var _checkFetcherJs = require("./checkFetcher.js");
var _selectHttpOptionsAndBodyJs = require("./selectHttpOptionsAndBody.js");
var _rewriteURIForGETJs = require("./rewriteURIForGET.js");
var _indexJs3 = require("../utils/index.js");
var backupFetch = (0, _indexJs2.maybe)(function() {
    return fetch;
});
var createHttpLink = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, _selectHttpOptionsAndBodyJs.defaultPrinter) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, _tslib.__rest)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, _checkFetcherJs.checkFetcher)(preferredFetch || backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, _indexJs1.ApolloLink)(function(operation) {
        var chosenURI = (0, _selectURIJs.selectURI)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, _tslib.__assign)((0, _tslib.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, _indexJs2.hasDirectives)([
            "client"
        ], operation.query)) {
            var transformedQuery = (0, _indexJs2.removeClientSetsFromDocument)(operation.query);
            if (!transformedQuery) return (0, _indexJs3.fromError)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, _selectHttpOptionsAndBodyJs.selectHttpOptionsAndBodyInternal)(operation, print, (0, _selectHttpOptionsAndBodyJs.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, _indexJs3.filterOperationVariables)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, _indexJs2.getMainDefinition)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, _indexJs2.hasDirectives)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(38);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, _rewriteURIForGETJs.rewriteURIForGET)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, _indexJs3.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, _serializeFetchParameterJs.serializeFetchParameter)(body, "Payload");
        } catch (parseError) {
            return (0, _indexJs3.fromError)(parseError);
        }
        return new (0, _indexJs2.Observable)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, _indexJs2.maybe)(function() {
                return fetch;
            }) || backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, _parseAndCheckHttpResponseJs.readMultipartBody)(response, observerNext);
                else return (0, _parseAndCheckHttpResponseJs.parseAndCheckHttpResponse)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, _parseAndCheckHttpResponseJs.handleError)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};

},{"tslib":"gBS4y","../../utilities/globals/index.js":"jejDs","../core/index.js":"gXJ1R","../../utilities/index.js":"k55vB","./serializeFetchParameter.js":"aDWte","./selectURI.js":"gey39","./parseAndCheckHttpResponse.js":"87K8b","./checkFetcher.js":"anoPt","./selectHttpOptionsAndBody.js":"4mnJ8","./rewriteURIForGET.js":"lOvFy","../utils/index.js":"bdwh2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lOvFy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// For GET operations, returns the given URI rewritten with parameters, or a
// parse error.
parcelHelpers.export(exports, "rewriteURIForGET", ()=>rewriteURIForGET);
var _serializeFetchParameterJs = require("./serializeFetchParameter.js");
function rewriteURIForGET(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, _serializeFetchParameterJs.serializeFetchParameter)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, _serializeFetchParameterJs.serializeFetchParameter)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}

},{"./serializeFetchParameter.js":"aDWte","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gS1LW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpLink", ()=>HttpLink);
var _tslib = require("tslib");
var _indexJs = require("../core/index.js");
var _createHttpLinkJs = require("./createHttpLink.js");
var HttpLink = /** @class */ function(_super) {
    (0, _tslib.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, _createHttpLinkJs.createHttpLink)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, _indexJs.ApolloLink));

},{"tslib":"gBS4y","../core/index.js":"gXJ1R","./createHttpLink.js":"q6VKi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gzqpZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryManager", ()=>QueryManager);
var _tslib = require("tslib");
var _indexJs = require("../utilities/globals/index.js");
var _equality = require("@wry/equality");
var _indexJs1 = require("../link/core/index.js");
var _indexJs2 = require("../utilities/index.js");
var _indexJs3 = require("../cache/index.js");
var _incrementalResultJs = require("../utilities/common/incrementalResult.js");
var _indexJs4 = require("../errors/index.js");
var _observableQueryJs = require("./ObservableQuery.js");
var _networkStatusJs = require("./networkStatus.js");
var _localStateJs = require("./LocalState.js");
var _queryInfoJs = require("./QueryInfo.js");
var _trie = require("@wry/trie");
var hasOwnProperty = Object.prototype.hasOwnProperty;
var IGNORE = Object.create(null);
var QueryManager = /** @class */ function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, documentTransform = _a.documentTransform, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, _e = _a.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? !!cache.assumeImmutableResults : _e, defaultContext = _a.defaultContext;
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, _indexJs2.AutoCleanedWeakCache)((0, _indexJs2.cacheSizes)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, _trie.Trie)(false);
        var defaultDocumentTransform = new (0, _indexJs2.DocumentTransform)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, _localStateJs.LocalState)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = assumeImmutableResults;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = defaultContext || Object.create(null);
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, _indexJs.newInvariantError)(25));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            return (0, _tslib.__generator)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        (0, _indexJs.invariant)(mutation, 26);
                        (0, _indexJs.invariant)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 27);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _h.sent();
                        _h.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, _indexJs2.asyncMap)(self.getObservableFromLink(mutation, (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, false), function(result) {
                                    if ((0, _indexJs2.graphQLResultHasError)(result) && errorPolicy === "none") throw new (0, _indexJs4.ApolloError)({
                                        graphQLErrors: (0, _indexJs2.getGraphQLErrorsFromResult)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, _tslib.__assign)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, _indexJs2.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, _indexJs4.ApolloError) ? err : new (0, _indexJs4.ApolloError)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, _queryInfoJs.shouldWriteResult)(result, mutation.errorPolicy)) {
            if (!(0, _indexJs2.isExecutionPatchIncrementalResult)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, _indexJs2.isExecutionPatchIncrementalResult)(result) && (0, _indexJs2.isNonEmptyArray)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, _incrementalResultJs.mergeIncrementalData)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, _indexJs2.getOperationName)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, _indexJs2.isExecutionPatchResult)(result) || (0, _indexJs2.isExecutionPatchIncrementalResult)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: IGNORE
        }) : optimisticResponse;
        if (data === IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, _tslib.__assign)((0, _tslib.__assign)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, _indexJs.invariant).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, _indexJs2.hasClientExports)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, _indexJs2.hasDirectives)([
                    "nonreactive"
                ], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, _indexJs2.removeDirectivesFromDocument)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    }
                ], document),
                defaultVars: (0, _indexJs2.getDefaultValues)((0, _indexJs2.getOperationDefinition)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, _tslib.__assign)((0, _tslib.__assign)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, _tslib.__assign)((0, _tslib.__assign)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, _queryInfoJs.QueryInfo)(this);
        var observable = new (0, _observableQueryJs.ObservableQuery)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, _indexJs.invariant)(options.query, 28);
        (0, _indexJs.invariant)(options.query.kind === "Document", 29);
        (0, _indexJs.invariant)(!options.returnPartialData, 30);
        (0, _indexJs.invariant)(!options.pollInterval, 31);
        return this.fetchQuery(queryId, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            query: this.transform(options.query)
        })).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, _indexJs.newInvariantError)(32));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, _networkStatusJs.NetworkStatus).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, _indexJs2.isDocumentNode)(desc)) queryNamesAndDocs.set(_this.transform(desc), false);
            else if ((0, _indexJs2.isNonNullObject)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, _indexJs2.makeUniqueId)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, _observableQueryJs.ObservableQuery)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, _indexJs.invariant)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(typeof nameOrDoc === "string" ? 33 : 34, nameOrDoc);
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, _b = _a.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, variables = _a.variables, _c = _a.context, context = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, _queryInfoJs.shouldWriteResult)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, _indexJs2.graphQLResultHasError)(result);
                var hasProtocolErrors = (0, _indexJs4.graphQLResultHasProtocolErrors)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, _indexJs4.PROTOCOL_ERRORS_SYMBOL];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, _indexJs4.ApolloError)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, _indexJs2.Observable)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, _indexJs2.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, _indexJs2.print)(serverQuery);
                var varJson_1 = (0, _indexJs3.canonicalStringify)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast = new (0, _indexJs2.Concast)([
                        (0, _indexJs1.execute)(link, operation)
                    ]);
                    observable = entry.observable = concast;
                    concast.beforeNext(function() {
                        inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, _indexJs2.Concast)([
                (0, _indexJs1.execute)(link, operation)
            ]);
        } else {
            observable = new (0, _indexJs2.Concast)([
                (0, _indexJs2.Observable).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, _indexJs2.asyncMap)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, _indexJs2.asyncMap)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, _indexJs2.getGraphQLErrorsFromResult)(result);
            var hasErrors = graphQLErrors.length > 0;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, _indexJs4.ApolloError)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                result = queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, _networkStatusJs.NetworkStatus).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, _networkStatusJs.NetworkStatus).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, _indexJs4.isApolloError)(networkError) ? networkError : new (0, _indexJs4.ApolloError)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryId, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, _networkStatusJs.NetworkStatus).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, _indexJs2.Concast)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, _indexJs2.Concast)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, _indexJs2.makeUniqueId)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, _queryInfoJs.QueryInfo) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset(); // Force info.getDiff() to read from cache.
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, _networkStatusJs.NetworkStatus).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, _equality.equal)(data, {})) (0, _observableQueryJs.logMissingFieldErrors)(diff.missing);
            var fromData = function(data) {
                return (0, _indexJs2.Observable).of((0, _tslib.__assign)({
                    data: data,
                    loading: (0, _networkStatusJs.isNetworkRequestInFlight)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, _networkStatusJs.NetworkStatus).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, _networkStatusJs.NetworkStatus).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, _networkStatusJs.isNetworkRequestInFlight)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, _queryInfoJs.QueryInfo)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();

},{"tslib":"gBS4y","../utilities/globals/index.js":"jejDs","@wry/equality":"H2Jtg","../link/core/index.js":"gXJ1R","../utilities/index.js":"k55vB","../cache/index.js":"fv0fM","../utilities/common/incrementalResult.js":"38Fo8","../errors/index.js":"73MUX","./ObservableQuery.js":"aszik","./networkStatus.js":"8yReP","./LocalState.js":"9TB6L","./QueryInfo.js":"2iGeB","@wry/trie":"fd6oo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"H2Jtg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ parcelHelpers.export(exports, "equal", ()=>equal);
const { toString, hasOwnProperty } = Object.prototype;
const fnToStr = Function.prototype.toString;
const previousComparisons = new Map();
function equal(a, b) {
    try {
        return check(a, b);
    } finally{
        previousComparisons.clear();
    }
}
// Allow default imports as well.
exports.default = equal;
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = toString.call(a);
    const bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case "[object Array]":
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case "[object Object]":
            {
                if (previouslyCompared(a, b)) return true;
                const aKeys = definedKeys(a);
                const bKeys = definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!check(a[key], b[key])) return false;
                }
                return true;
            }
        case "[object Error]":
            return a.name === b.name && a.message === b.message;
        case "[object Number]":
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case "[object Boolean]":
        case "[object Date]":
            return +a === +b;
        case "[object RegExp]":
        case "[object String]":
            return a == `${b}`;
        case "[object Map]":
        case "[object Set]":
            {
                if (a.size !== b.size) return false;
                if (previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === "[object Map]";
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case "[object Uint16Array]":
        case "[object Uint8Array]":
        case "[object Uint32Array]":
        case "[object Int32Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object ArrayBuffer]":
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case "[object DataView]":
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case "[object AsyncFunction]":
        case "[object GeneratorFunction]":
        case "[object AsyncGeneratorFunction]":
        case "[object Function]":
            {
                const aCode = fnToStr.call(a);
                if (aCode !== fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !endsWith(aCode, nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
const nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fv0fM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloCache", ()=>(0, _cacheJs.ApolloCache));
parcelHelpers.export(exports, "Cache", ()=>(0, _cacheJs1.Cache));
parcelHelpers.export(exports, "MissingFieldError", ()=>(0, _commonJs.MissingFieldError));
parcelHelpers.export(exports, "isReference", ()=>(0, _indexJs1.isReference));
parcelHelpers.export(exports, "makeReference", ()=>(0, _indexJs1.makeReference));
parcelHelpers.export(exports, "canonicalStringify", ()=>(0, _indexJs1.canonicalStringify));
parcelHelpers.export(exports, "EntityStore", ()=>(0, _entityStoreJs.EntityStore));
parcelHelpers.export(exports, "fieldNameFromStoreName", ()=>(0, _helpersJs.fieldNameFromStoreName));
parcelHelpers.export(exports, "defaultDataIdFromObject", ()=>(0, _helpersJs.defaultDataIdFromObject));
parcelHelpers.export(exports, "InMemoryCache", ()=>(0, _inMemoryCacheJs.InMemoryCache));
parcelHelpers.export(exports, "makeVar", ()=>(0, _reactiveVarsJs.makeVar));
parcelHelpers.export(exports, "cacheSlot", ()=>(0, _reactiveVarsJs.cacheSlot));
parcelHelpers.export(exports, "Policies", ()=>(0, _policiesJs.Policies));
parcelHelpers.export(exports, "createFragmentRegistry", ()=>(0, _fragmentRegistryJs.createFragmentRegistry));
var _indexJs = require("../utilities/globals/index.js");
var _cacheJs = require("./core/cache.js");
var _cacheJs1 = require("./core/types/Cache.js");
var _commonJs = require("./core/types/common.js");
var _indexJs1 = require("../utilities/index.js");
var _entityStoreJs = require("./inmemory/entityStore.js");
var _helpersJs = require("./inmemory/helpers.js");
var _inMemoryCacheJs = require("./inmemory/inMemoryCache.js");
var _reactiveVarsJs = require("./inmemory/reactiveVars.js");
var _policiesJs = require("./inmemory/policies.js");
var _fragmentRegistryJs = require("./inmemory/fragmentRegistry.js");
var _typesJs = require("./inmemory/types.js");
parcelHelpers.exportAll(_typesJs, exports);

},{"../utilities/globals/index.js":"jejDs","./core/cache.js":"ktbzp","./core/types/Cache.js":"xTrhF","./core/types/common.js":"bp7SS","../utilities/index.js":"k55vB","./inmemory/entityStore.js":false,"./inmemory/helpers.js":"2vRuy","./inmemory/inMemoryCache.js":"f5Hyy","./inmemory/reactiveVars.js":"7nqYk","./inmemory/policies.js":false,"./inmemory/fragmentRegistry.js":false,"./inmemory/types.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ktbzp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloCache", ()=>ApolloCache);
var _tslib = require("tslib");
var _optimism = require("optimism");
var _indexJs = require("../../utilities/index.js");
var _caches = require("@wry/caches");
var _getMemoryInternalsJs = require("../../utilities/caching/getMemoryInternals.js");
var ApolloCache = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, _optimism.wrap)((0, _indexJs.getFragmentQueryDocument), {
            max: (0, _indexJs.cacheSizes)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, _caches.WeakCache)
        });
    }
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, _tslib.__rest)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, _tslib.__rest)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) ApolloCache.prototype.getMemoryInternals = (0, _getMemoryInternalsJs.getApolloCacheMemoryInternals);

},{"tslib":"gBS4y","optimism":"3eQSw","../../utilities/index.js":"k55vB","@wry/caches":"c7ATU","../../utilities/caching/getMemoryInternals.js":"b13lS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"xTrhF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cache", ()=>Cache);
var Cache;
Cache || (Cache = {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bp7SS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MissingFieldError", ()=>MissingFieldError);
var _tslib = require("tslib");
var MissingFieldError = /** @class */ function(_super) {
    (0, _tslib.__extends)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);

},{"tslib":"gBS4y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKv8k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EntityStore", ()=>EntityStore);
parcelHelpers.export(exports, "maybeDependOnExistenceOfEntity", ()=>maybeDependOnExistenceOfEntity);
parcelHelpers.export(exports, "supportsResultCaching", ()=>supportsResultCaching);
var _tslib = require("tslib");
var _indexJs = require("../../utilities/globals/index.js");
var _optimism = require("optimism");
var _equality = require("@wry/equality");
var _trie = require("@wry/trie");
var _indexJs1 = require("../../utilities/index.js");
var _helpersJs = require("./helpers.js");
var DELETE = Object.create(null);
var delModifier = function() {
    return DELETE;
};
var INVALIDATE = Object.create(null);
var EntityStore = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, _indexJs1.maybeDeepFreeze)((0, _indexJs1.isReference)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, _indexJs1.isReference)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, _indexJs1.makeReference)(objOrIdOrRef);
            if ((0, _indexJs1.isReference)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, _indexJs1.makeReference)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, _tslib.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, _helpersJs.hasOwn).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, _helpersJs.hasOwn).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, _helpersJs.hasOwn).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, _helpersJs.hasOwn).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, _indexJs1.isReference)(older)) older = older.__ref;
        if ((0, _indexJs1.isReference)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, _indexJs.invariant)(typeof dataId === "string", 1);
        var merged = new (0, _indexJs1.DeepMerger)(storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, _helpersJs.fieldNameFromStoreName)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: (0, _indexJs1.isReference),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, _indexJs1.makeReference)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, _helpersJs.fieldNameFromStoreName)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === delModifier ? DELETE : modify((0, _indexJs1.maybeDeepFreeze)(fieldValue), (0, _tslib.__assign)((0, _tslib.__assign)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(2, ref);
                                        return true;
                                    }
                                };
                                if ((0, _indexJs1.isReference)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, _indexJs1.isReference)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(3, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = delModifier, _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, _helpersJs.hasOwn).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, _helpersJs.hasOwn).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, _helpersJs.hasOwn).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, _tslib.__rest)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, _helpersJs.hasOwn).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, _helpersJs.hasOwn).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, _indexJs1.isReference)(obj)) found_1[obj.__ref] = true;
                if ((0, _indexJs1.isNonNullObject)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, _indexJs1.isNonNullObject)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, _optimism.dep)() : null;
        this.keyMaker = new (0, _trie.Trie)((0, _indexJs1.canUseWeakMap));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = (0, _helpersJs.fieldNameFromStoreName)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d(makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty(makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, _tslib.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new (0, _trie.Trie)((0, _indexJs1.canUseWeakMap));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var Layer = /** @class */ function(_super) {
    (0, _tslib.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, _equality.equal)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, _helpersJs.hasOwn).call(this.data, dataId) ? (0, _tslib.__assign)((0, _tslib.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}(EntityStore);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var Stump = /** @class */ function(_super) {
    (0, _tslib.__extends)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}(Layer);
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, _equality.equal)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof EntityStore && store.group.caching);
}

},{"tslib":"gBS4y","../../utilities/globals/index.js":"jejDs","optimism":"3eQSw","@wry/equality":"H2Jtg","@wry/trie":"fd6oo","../../utilities/index.js":"k55vB","./helpers.js":"2vRuy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2vRuy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasOwn", ()=>hasOwn);
parcelHelpers.export(exports, "isNullish", ()=>isNullish);
parcelHelpers.export(exports, "isArray", ()=>(0, _indexJs.isArray));
parcelHelpers.export(exports, "defaultDataIdFromObject", ()=>defaultDataIdFromObject);
parcelHelpers.export(exports, "normalizeConfig", ()=>normalizeConfig);
parcelHelpers.export(exports, "shouldCanonizeResults", ()=>shouldCanonizeResults);
parcelHelpers.export(exports, "getTypenameFromStoreObject", ()=>getTypenameFromStoreObject);
parcelHelpers.export(exports, "TypeOrFieldNameRegExp", ()=>TypeOrFieldNameRegExp);
parcelHelpers.export(exports, "fieldNameFromStoreName", ()=>fieldNameFromStoreName);
parcelHelpers.export(exports, "selectionSetMatchesResult", ()=>selectionSetMatchesResult);
parcelHelpers.export(exports, "storeValueIsStoreObject", ()=>storeValueIsStoreObject);
parcelHelpers.export(exports, "makeProcessedFieldsMerger", ()=>makeProcessedFieldsMerger);
parcelHelpers.export(exports, "extractFragmentContext", ()=>extractFragmentContext);
var _indexJs = require("../../utilities/index.js");
var hasOwn = Object.prototype.hasOwnProperty;
function isNullish(value) {
    return value === null || value === void 0;
}
function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !isNullish(id) ? {
            id: id
        } : !isNullish(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if (isNullish(id) && !isNullish(_id)) id = _id;
        if (!isNullish(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function normalizeConfig(config) {
    return (0, _indexJs.compact)(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return (0, _indexJs.isReference)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if ((0, _indexJs.isNonNullObject)(result)) return (0, _indexJs.isArray)(result) ? result.every(function(item) {
        return selectionSetMatchesResult(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, _indexJs.isField)(field) && (0, _indexJs.shouldInclude)(field, variables)) {
            var key = (0, _indexJs.resultKeyNameFromField)(field);
            return hasOwn.call(result, key) && (!field.selectionSet || selectionSetMatchesResult(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function storeValueIsStoreObject(value) {
    return (0, _indexJs.isNonNullObject)(value) && !(0, _indexJs.isReference)(value) && !(0, _indexJs.isArray)(value);
}
function makeProcessedFieldsMerger() {
    return new (0, _indexJs.DeepMerger)();
}
function extractFragmentContext(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, _indexJs.createFragmentMap)((0, _indexJs.getFragmentDefinitions)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}

},{"../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f5Hyy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemoryCache", ()=>InMemoryCache);
var _tslib = require("tslib");
var _indexJs = require("../../utilities/globals/index.js");
// Make builtins like Map and Set safe to use with non-extensible objects.
var _fixPolyfillsJs = require("./fixPolyfills.js");
var _optimism = require("optimism");
var _equality = require("@wry/equality");
var _cacheJs = require("../core/cache.js");
var _commonJs = require("../core/types/common.js");
var _indexJs1 = require("../../utilities/index.js");
var _readFromStoreJs = require("./readFromStore.js");
var _writeToStoreJs = require("./writeToStore.js");
var _entityStoreJs = require("./entityStore.js");
var _reactiveVarsJs = require("./reactiveVars.js");
var _policiesJs = require("./policies.js");
var _helpersJs = require("./helpers.js");
var _getMemoryInternalsJs = require("../../utilities/caching/getMemoryInternals.js");
var InMemoryCache = /** @class */ function(_super) {
    (0, _tslib.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, _indexJs1.DocumentTransform)((0, _indexJs1.addTypenameToDocument));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, _reactiveVarsJs.makeVar);
        _this.txCount = 0;
        _this.config = (0, _helpersJs.normalizeConfig)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, _policiesJs.Policies)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, _entityStoreJs.EntityStore).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, _writeToStoreJs.StoreWriter)(this, this.storeReader = new (0, _readFromStoreJs.StoreReader)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, _helpersJs.shouldCanonizeResults)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, _optimism.wrap)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, _indexJs1.cacheSizes)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, _entityStoreJs.supportsResultCaching)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, _indexJs1.canonicalStringify)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, _commonJs.MissingFieldError)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, _helpersJs.hasOwn).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, _reactiveVarsJs.recallCache)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, _reactiveVarsJs.forgetCache)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        var _a;
        (0, _indexJs1.canonicalStringify).reset();
        (0, _indexJs1.print).reset();
        this.addTypenameTransform.resetCache();
        (_a = this.config.fragments) === null || _a === void 0 || _a.resetCaches();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, _indexJs1.isReference)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, _helpersJs.hasOwn).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, _indexJs1.canonicalStringify).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, _reactiveVarsJs.forgetCache)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, _equality.equal)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, _cacheJs.ApolloCache));
if (globalThis.__DEV__ !== false) InMemoryCache.prototype.getMemoryInternals = (0, _getMemoryInternalsJs.getInMemoryCacheMemoryInternals);

},{"tslib":"gBS4y","../../utilities/globals/index.js":"jejDs","./fixPolyfills.js":"bxtp5","optimism":"3eQSw","@wry/equality":"H2Jtg","../core/cache.js":"ktbzp","../core/types/common.js":"bp7SS","../../utilities/index.js":"k55vB","./readFromStore.js":"fiqlx","./writeToStore.js":"p7BPt","./entityStore.js":"jKv8k","./reactiveVars.js":"7nqYk","./policies.js":"6FYrH","./helpers.js":"2vRuy","../../utilities/caching/getMemoryInternals.js":"b13lS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bxtp5":[function(require,module,exports) {
"use strict"; // Most JavaScript environments do not need the workarounds implemented in
 // fixPolyfills.native.ts, so importing fixPolyfills.ts merely imports
 // this empty module, adding nothing to bundle sizes or execution times.
 // When bundling for React Native, we substitute fixPolyfills.native.js
 // for fixPolyfills.js (see the "react-native" section of package.json),
 // to work around problems with Map and Set polyfills in older versions of
 // React Native (which should have been fixed in react-native@0.59.0):
 // https://github.com/apollographql/apollo-client/pull/5962

},{}],"fiqlx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StoreReader", ()=>StoreReader);
var _tslib = require("tslib");
var _indexJs = require("../../utilities/globals/index.js");
var _graphql = require("graphql");
var _optimism = require("optimism");
var _indexJs1 = require("../../utilities/index.js");
var _entityStoreJs = require("./entityStore.js");
var _helpersJs = require("./helpers.js");
var _commonJs = require("../core/types/common.js");
var _objectCanonJs = require("./object-canon.js");
function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var StoreReader = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, _indexJs1.canUseWeakMap) ? WeakMap : Map)();
        this.config = (0, _indexJs1.compact)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, _helpersJs.shouldCanonizeResults)(config)
        });
        this.canon = config.canon || new (0, _objectCanonJs.ObjectCanon)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, _optimism.wrap)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, _tslib.__assign)((0, _tslib.__assign)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, _entityStoreJs.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, _indexJs1.cacheSizes)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, _entityStoreJs.supportsResultCaching)(context.store)) return context.store.makeCacheKey(selectionSet, (0, _indexJs1.isReference)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, _optimism.wrap)(function(options) {
            (0, _entityStoreJs.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, _indexJs1.cacheSizes)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, _entityStoreJs.supportsResultCaching)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, _objectCanonJs.ObjectCanon)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _indexJs1.getDefaultValues)((0, _indexJs1.getQueryDefinition)(query))), variables);
        var rootRef = (0, _indexJs1.makeReference)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, _indexJs1.getMainDefinition)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, _tslib.__assign)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, _indexJs1.canonicalStringify)(variables),
                canonizeResults: canonizeResults
            }, (0, _helpersJs.extractFragmentContext)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, _commonJs.MissingFieldError)(firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, _entityStoreJs.supportsResultCaching)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, _indexJs1.isReference)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, _indexJs1.DeepMerger)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, _indexJs1.shouldInclude)(selection, variables)) return;
            if ((0, _indexJs1.isField)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, _indexJs1.resultKeyNameFromField)(selection);
                if (fieldValue === void 0) {
                    if (!(0, _indexJs1.addTypenameToDocument).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, _indexJs1.isReference)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, _helpersJs.isArray)(fieldValue)) fieldValue = handleMissing(_this.executeSubSelectedArray({
                    field: selection,
                    array: fieldValue,
                    enclosingRef: enclosingRef,
                    context: context
                }), resultName);
                else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, _indexJs1.isReference)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, _indexJs1.getFragmentFromSelection)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, _graphql.Kind).FRAGMENT_SPREAD) throw (0, _indexJs.newInvariantError)(9, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, _indexJs1.mergeDeepArray)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, _indexJs1.maybeDeepFreeze)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, _indexJs1.DeepMerger)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, _helpersJs.isArray)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, _indexJs1.isReference)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, _indexJs1.isNonNullObject)(value)) {
                (0, _indexJs.invariant)(!(0, _indexJs1.isReference)(value), 10, (0, _helpersJs.getTypenameFromStoreObject)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

},{"tslib":"gBS4y","../../utilities/globals/index.js":"jejDs","graphql":"crWS5","optimism":"3eQSw","../../utilities/index.js":"k55vB","./entityStore.js":"jKv8k","./helpers.js":"2vRuy","../core/types/common.js":"bp7SS","./object-canon.js":"epooc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"epooc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectCanon", ()=>ObjectCanon);
var _tslib = require("tslib");
var _trie = require("@wry/trie");
var _indexJs = require("../../utilities/index.js");
var _helpersJs = require("./helpers.js");
function shallowCopy(value) {
    if ((0, _indexJs.isNonNullObject)(value)) return (0, _helpersJs.isArray)(value) ? value.slice(0) : (0, _tslib.__assign)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var ObjectCanon = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, _indexJs.canUseWeakSet) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, _trie.Trie)((0, _indexJs.canUseWeakMap));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, _indexJs.isNonNullObject)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, _indexJs.isNonNullObject)(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, _indexJs.isNonNullObject)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();

},{"tslib":"gBS4y","@wry/trie":"fd6oo","../../utilities/index.js":"k55vB","./helpers.js":"2vRuy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"p7BPt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StoreWriter", ()=>StoreWriter);
var _tslib = require("tslib");
var _indexJs = require("../../utilities/globals/index.js");
var _equality = require("@wry/equality");
var _trie = require("@wry/trie");
var _graphql = require("graphql");
var _indexJs1 = require("../../utilities/index.js");
var _helpersJs = require("./helpers.js");
var _policiesJs = require("./policies.js");
// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var StoreWriter = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, _indexJs1.getOperationDefinition)(query);
        var merger = (0, _helpersJs.makeProcessedFieldsMerger)();
        variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _indexJs1.getDefaultValues)(operationDefinition)), variables);
        var context = (0, _tslib.__assign)((0, _tslib.__assign)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, _indexJs1.canonicalStringify)(variables)
        }, (0, _helpersJs.extractFragmentContext)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, _indexJs1.isReference)(ref)) throw (0, _indexJs.newInvariantError)(11, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, _indexJs1.makeReference)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, _indexJs1.isReference)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, _helpersJs.fieldNameFromStoreName)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, _indexJs1.getTypenameFromResult)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, _policiesJs.normalizeReadFieldOptions)(arguments, incoming, context.variables);
            if ((0, _indexJs1.isReference)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, _indexJs1.resultKeyNameFromField)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, _indexJs1.isReference)(incomingValue) || (0, _helpersJs.storeValueIsStoreObject)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, _indexJs1.addTypenameToDocument).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, _indexJs.invariant).error(12, (0, _indexJs1.resultKeyNameFromField)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, _indexJs1.makeReference)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, _indexJs1.cloneDeep)(value) : value;
        if ((0, _helpersJs.isArray)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
            maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, _indexJs1.getTypenameFromResult)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, _trie.Trie)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, _indexJs1.shouldInclude)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, _indexJs1.isNonEmptyArray)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, _indexJs1.argumentsObjectFromField)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, _indexJs1.isField)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, _indexJs1.getFragmentFromSelection)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, _graphql.Kind).FRAGMENT_SPREAD) throw (0, _indexJs.newInvariantError)(13, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, _indexJs1.isReference)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, _helpersJs.isArray)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, _indexJs1.isReference)(existing) || (0, _helpersJs.storeValueIsStoreObject)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, _indexJs1.isReference)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, _helpersJs.isArray)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, _indexJs.invariant)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, _helpersJs.isArray)(i_1) ? i_1.slice(0) : (0, _tslib.__assign)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right)) return left;
    if (!left || mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, _tslib.__assign)((0, _tslib.__assign)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, _indexJs1.isReference)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, _equality.equal)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, _helpersJs.fieldNameFromStoreName)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if (warnings.has(typeDotName)) return;
    warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, _helpersJs.isArray)(existing) && !(0, _helpersJs.isArray)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(14, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, existing, incoming);
}

},{"tslib":"gBS4y","../../utilities/globals/index.js":"jejDs","@wry/equality":"H2Jtg","@wry/trie":"fd6oo","graphql":"crWS5","../../utilities/index.js":"k55vB","./helpers.js":"2vRuy","./policies.js":"6FYrH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6FYrH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Policies", ()=>Policies);
parcelHelpers.export(exports, "normalizeReadFieldOptions", ()=>normalizeReadFieldOptions);
var _tslib = require("tslib");
var _indexJs = require("../../utilities/globals/index.js");
var _indexJs1 = require("../../utilities/index.js");
var _helpersJs = require("./helpers.js");
var _reactiveVarsJs = require("./reactiveVars.js");
var _keyExtractorJs = require("./key-extractor.js");
function argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, _indexJs1.argumentsObjectFromField)(spec.field, spec.variables) : null;
}
var nullKeyFieldsFn = function() {
    return void 0;
};
var simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function(_, incoming) {
    return incoming;
};
var Policies = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, _tslib.__assign)({
            dataIdFromObject: (0, _helpersJs.defaultDataIdFromObject)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, _tslib.__assign)((0, _tslib.__assign)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = normalizeReadFieldOptions(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn((0, _tslib.__assign)((0, _tslib.__assign)({}, object), storeObject), context);
            if ((0, _helpersJs.isArray)(specifierOrId)) keyFn = (0, _keyExtractorJs.keyFieldsFnFromSpecifier)(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, _tslib.__rest)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, _helpersJs.hasOwn).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? mergeTrueFn : merge === false ? mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? nullKeyFieldsFn : (0, _helpersJs.isArray)(keyFields) ? (0, _keyExtractorJs.keyFieldsFnFromSpecifier)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? simpleKeyArgsFn : (0, _helpersJs.isArray)(keyArgs) ? (0, _keyExtractorJs.keyArgsFnFromSpecifier)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, _indexJs.invariant)(!old || old === which, 5, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, _helpersJs.TypeOrFieldNameRegExp));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, _helpersJs.hasOwn).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, _tslib.__rest)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(6, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, _helpersJs.selectionSetMatchesResult)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, _helpersJs.isArray)(specifierOrString)) keyFn = (0, _keyExtractorJs.keyArgsFnFromSpecifier)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, _indexJs1.storeKeyNameFromField)(fieldSpec.field, fieldSpec.variables) : (0, _indexJs1.getStoreKeyName)(fieldName, argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, _helpersJs.fieldNameFromStoreName)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, _helpersJs.fieldNameFromStoreName)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, _indexJs1.isReference)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, _reactiveVarsJs.cacheSlot).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, _helpersJs.fieldNameFromStoreName)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, _indexJs1.isReference),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store)
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, _tslib.__assign)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, _helpersJs.hasOwn).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(7, (0, _indexJs1.stringifyForDisplay)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, _helpersJs.isArray)(existing) || (0, _helpersJs.isArray)(incoming)) throw (0, _indexJs.newInvariantError)(8);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, _indexJs1.isNonNullObject)(existing) && (0, _indexJs1.isNonNullObject)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, _indexJs1.isReference)(existing) && (0, _helpersJs.storeValueIsStoreObject)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, _helpersJs.storeValueIsStoreObject)(existing) && (0, _indexJs1.isReference)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, _helpersJs.storeValueIsStoreObject)(existing) && (0, _helpersJs.storeValueIsStoreObject)(incoming)) return (0, _tslib.__assign)((0, _tslib.__assign)({}, existing), incoming);
        }
        return incoming;
    };
}

},{"tslib":"gBS4y","../../utilities/globals/index.js":"jejDs","../../utilities/index.js":"k55vB","./helpers.js":"2vRuy","./reactiveVars.js":"7nqYk","./key-extractor.js":"jGmbN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7nqYk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cacheSlot", ()=>cacheSlot);
parcelHelpers.export(exports, "forgetCache", ()=>forgetCache);
// Calling forgetCache(cache) serves to silence broadcasts and allows the
// cache to be garbage collected. However, the varsByCache WeakMap
// preserves the set of reactive variables that were previously associated
// with this cache, which makes it possible to "recall" the cache at a
// later time, by reattaching it to those variables. If the cache has been
// garbage collected in the meantime, because it is no longer reachable,
// you won't be able to call recallCache(cache), and the cache will
// automatically disappear from the varsByCache WeakMap.
parcelHelpers.export(exports, "recallCache", ()=>recallCache);
parcelHelpers.export(exports, "makeVar", ()=>makeVar);
var _optimism = require("optimism");
var cacheSlot = new (0, _optimism.Slot)();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, _optimism.dep)()
    });
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}

},{"optimism":"3eQSw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jGmbN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "keyFieldsFnFromSpecifier", ()=>keyFieldsFnFromSpecifier);
// The keyArgs extraction process is roughly analogous to keyFields extraction,
// but there are no aliases involved, missing fields are tolerated (by merely
// omitting them from the key), and drawing from field.directives or variables
// is allowed (in addition to drawing from the field's arguments object).
// Concretely, these differences mean passing a different key path extractor
// function to collectSpecifierPaths, reusing the shared extractKeyPath helper
// wherever possible.
parcelHelpers.export(exports, "keyArgsFnFromSpecifier", ()=>keyArgsFnFromSpecifier);
parcelHelpers.export(exports, "collectSpecifierPaths", ()=>collectSpecifierPaths);
parcelHelpers.export(exports, "getSpecifierPaths", ()=>getSpecifierPaths);
parcelHelpers.export(exports, "extractKeyPath", ()=>extractKeyPath);
var _indexJs = require("../../utilities/globals/index.js");
var _indexJs1 = require("../../utilities/index.js");
var _helpersJs = require("./helpers.js");
// Mapping from JSON-encoded KeySpecifier strings to associated information.
var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return specifierInfoCache[cacheKey] || (specifierInfoCache[cacheKey] = Object.create(null));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = collectSpecifierPaths(specifier, function(schemaKeyPath) {
            var extracted = extractKeyPath(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, _helpersJs.hasOwn).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = extractKeyPath(object, schemaKeyPath, extractKey);
            (0, _indexJs.invariant)(extracted !== void 0, 4, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = collectSpecifierPaths(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, _indexJs1.isNonEmptyArray)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, _indexJs1.argumentsObjectFromField)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && extractKeyPath(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, _helpersJs.hasOwn).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return extractKeyPath(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return extractKeyPath(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function collectSpecifierPaths(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, _indexJs1.DeepMerger)();
    return getSpecifierPaths(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, _helpersJs.isArray)(s)) {
                getSpecifierPaths(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, _helpersJs.isArray)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || extractKey;
    return normalize(path.reduce(function reducer(obj, key) {
        return (0, _helpersJs.isArray)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, _indexJs1.isNonNullObject)(value)) {
        if ((0, _helpersJs.isArray)(value)) return value.map(normalize);
        return collectSpecifierPaths(Object.keys(value).sort(), function(path) {
            return extractKeyPath(value, path);
        });
    }
    return value;
}

},{"../../utilities/globals/index.js":"jejDs","../../utilities/index.js":"k55vB","./helpers.js":"2vRuy","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i6tcv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aszik":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObservableQuery", ()=>ObservableQuery);
// Reobserve with fetchPolicy effectively set to "cache-first", triggering
// delivery of any new data from the cache, possibly falling back to the network
// if any cache data are missing. This allows _complete_ cache results to be
// delivered without also kicking off unnecessary network requests when
// this.options.fetchPolicy is "cache-and-network" or "network-only". When
// this.options.fetchPolicy is any other policy ("cache-first", "cache-only",
// "standby", or "no-cache"), we call this.reobserve() as usual.
parcelHelpers.export(exports, "reobserveCacheFirst", ()=>reobserveCacheFirst);
parcelHelpers.export(exports, "logMissingFieldErrors", ()=>logMissingFieldErrors);
var _tslib = require("tslib");
var _indexJs = require("../utilities/globals/index.js");
var _equality = require("@wry/equality");
var _networkStatusJs = require("./networkStatus.js");
var _indexJs1 = require("../utilities/index.js");
var _equalByQueryJs = require("./equalByQuery.js");
var assign = Object.assign, hasOwnProperty = Object.hasOwnProperty;
var ObservableQuery = /** @class */ function(_super) {
    (0, _tslib.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, _indexJs1.getOperationDefinition)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, _networkStatusJs.NetworkStatus).ready;
        var result = (0, _tslib.__assign)((0, _tslib.__assign)({}, lastResult), {
            loading: (0, _networkStatusJs.isNetworkRequestInFlight)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, _equality.equal)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, _networkStatusJs.NetworkStatus).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, _networkStatusJs.NetworkStatus).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) logMissingFieldErrors(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !(0, _equalByQueryJs.equalByQuery)(this.query, this.last.result, newResult, this.variables) : !(0, _equality.equal)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, _equality.equal)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, _equality.equal)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, _indexJs1.getQueryDefinition)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(20, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, _equality.equal)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, _networkStatusJs.NetworkStatus).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, _tslib.__assign)((0, _tslib.__assign)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, _networkStatusJs.NetworkStatus).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, _networkStatusJs.NetworkStatus).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, _networkStatusJs.NetworkStatus).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            return fetchMoreResult;
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (!updatedQuerySet.has(_this.query)) reobserveCacheFirst(_this);
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, _indexJs.invariant).error(21, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, _indexJs1.compact)(this.options, newOptions || {});
        assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, _equality.equal)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, _networkStatusJs.NetworkStatus).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, _indexJs.invariant)(pollInterval, 22);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, _networkStatusJs.isNetworkRequestInFlight)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, _networkStatusJs.NetworkStatus).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, _equality.equal)(variables, this.last.variables)) error = void 0;
        return this.last = (0, _tslib.__assign)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, _indexJs1.cloneDeep)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, _networkStatusJs.NetworkStatus).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, _networkStatusJs.NetworkStatus).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, _networkStatusJs.NetworkStatus).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, _indexJs1.compact)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, _equality.equal)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, _networkStatusJs.NetworkStatus).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, _tslib.__assign)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, _equality.equal)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, _equality.equal)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, _indexJs1.iterateObserversSafely)(this.observers, "next", result);
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, _networkStatusJs.NetworkStatus).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, _indexJs1.iterateObserversSafely)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}((0, _indexJs1.Observable));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, _indexJs1.fixObservableSubclass)(ObservableQuery);
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(currentFetchPolicy, context) {
            // Replace this nextFetchPolicy function in the options object with the
            // original this.options.nextFetchPolicy value.
            this.nextFetchPolicy = nextFetchPolicy;
            // If the original nextFetchPolicy value was a function, give it a
            // chance to decide what happens here.
            if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
            // Otherwise go back to the original this.options.fetchPolicy.
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, _indexJs.invariant).error(23, error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, _indexJs.invariant).debug(24, missing);
}
function skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}

},{"tslib":"gBS4y","../utilities/globals/index.js":"jejDs","@wry/equality":"H2Jtg","./networkStatus.js":"8yReP","../utilities/index.js":"k55vB","./equalByQuery.js":"5wmeI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8yReP":[function(require,module,exports) {
/**
 * The current status of a query’s execution in our system.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkStatus", ()=>NetworkStatus);
/**
 * Returns true if there is currently a network request in flight according to a given network
 * status.
 */ parcelHelpers.export(exports, "isNetworkRequestInFlight", ()=>isNetworkRequestInFlight);
/**
 * Returns true if the network request is in ready or error state according to a given network
 * status.
 */ parcelHelpers.export(exports, "isNetworkRequestSettled", ()=>isNetworkRequestSettled);
var NetworkStatus;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function isNetworkRequestSettled(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5wmeI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Returns true if aResult and bResult are deeply equal according to the fields
// selected by the given query, ignoring any fields marked as @nonreactive.
parcelHelpers.export(exports, "equalByQuery", ()=>equalByQuery);
var _tslib = require("tslib");
var _equality = require("@wry/equality");
var _equalityDefault = parcelHelpers.interopDefault(_equality);
var _indexJs = require("../utilities/index.js");
function equalByQuery(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, _tslib.__rest)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, _tslib.__rest)(_b, [
        "data"
    ]);
    return (0, _equalityDefault.default)(aRest, bRest) && equalBySelectionSet((0, _indexJs.getMainDefinition)(query).selectionSet, aData, bData, {
        fragmentMap: (0, _indexJs.createFragmentMap)((0, _indexJs.getFragmentDefinitions)(query)),
        variables: variables
    });
}
function equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, _indexJs.shouldInclude)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if (selectionHasNonreactiveDirective(selection)) return true;
        if ((0, _indexJs.isField)(selection)) {
            var resultKey = (0, _indexJs.resultKeyNameFromField)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, _equalityDefault.default)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, _indexJs.getFragmentFromSelection)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if (selectionHasNonreactiveDirective(fragment)) return true;
                return equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some(directiveIsNonreactive);
}
function directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}

},{"tslib":"gBS4y","@wry/equality":"H2Jtg","../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9TB6L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalState", ()=>LocalState);
var _tslib = require("tslib");
var _indexJs = require("../utilities/globals/index.js");
var _graphql = require("graphql");
var _indexJs1 = require("../utilities/index.js");
var _indexJs2 = require("../cache/index.js");
var LocalState = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, _indexJs1.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, _indexJs1.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_c) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, _tslib.__assign)((0, _tslib.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, _indexJs1.hasDirectives)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, _indexJs1.removeClientSetsFromDocument)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, _tslib.__assign)((0, _tslib.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, _tslib.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, _graphql.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, _graphql.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, _indexJs1.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0, _tslib.__generator)(this, function(_b) {
                mainDefinition = (0, _indexJs1.getMainDefinition)(document);
                fragments = (0, _indexJs1.getFragmentDefinitions)(document);
                fragmentMap = (0, _indexJs1.createFragmentMap)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, _tslib.__generator)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, _indexJs1.shouldInclude)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, _indexJs1.isField)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, _indexJs1.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, _indexJs1.isInlineFragment)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, _indexJs.invariant)(fragment, 18, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, _indexJs1.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, _indexJs1.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, _indexJs2.cacheSlot).withValue(this.cache, resolve, [
                            rootValue,
                            (0, _indexJs1.argumentsObjectFromField)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, _graphql.visit)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, _graphql.isSelectionNode)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, _indexJs.invariant)(fragment, 19, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, _graphql.isSelectionNode)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();

},{"tslib":"gBS4y","../utilities/globals/index.js":"jejDs","graphql":"crWS5","../utilities/index.js":"k55vB","../cache/index.js":"fv0fM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2iGeB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryInfo", ()=>QueryInfo);
parcelHelpers.export(exports, "shouldWriteResult", ()=>shouldWriteResult);
var _tslib = require("tslib");
var _equality = require("@wry/equality");
var _indexJs = require("../utilities/index.js");
var _observableQueryJs = require("./ObservableQuery.js");
var _networkStatusJs = require("./networkStatus.js");
var destructiveMethodCounts = new ((0, _indexJs.canUseWeakMap) ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        (destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var QueryInfo = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, _networkStatusJs.NetworkStatus).loading;
        if (this.variables && this.networkStatus !== (0, _networkStatusJs.NetworkStatus).loading && !(0, _equality.equal)(this.variables, query.variables)) networkStatus = (0, _networkStatusJs.NetworkStatus).setVariables;
        if (!(0, _equality.equal)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, _equality.equal)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, _equality.equal)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                oq["observe"]();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                (0, _observableQueryJs.reobserveCacheFirst)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, _networkStatusJs.isNetworkRequestInFlight)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            this.reset();
            this.cancel();
            // Revert back to the no-op version of cancel inherited from
            // QueryInfo.prototype.
            this.cancel = QueryInfo.prototype.cancel;
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    // This method is a no-op by default, until/unless overridden by the
    // updateWatch method.
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, _equality.equal)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === destructiveMethodCounts.get(this.cache) && (0, _equality.equal)(variables, lastWrite.variables) && (0, _equality.equal)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        result = (0, _tslib.__assign)({}, result);
        var merger = new (0, _indexJs.DeepMerger)();
        var graphQLErrors = (0, _indexJs.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.reset();
        if ("incremental" in result && (0, _indexJs.isNonEmptyArray)(result.incremental)) {
            var mergedData = (0, _indexJs.mergeIncrementalData)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if (shouldWriteResult(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        // Make a shallow defensive copy of the result object, in case we
                        // later later modify result.data in place, since we don't want
                        // that mutation affecting the saved lastWrite.result.data.
                        result: (0, _tslib.__assign)({}, result),
                        variables: options.variables,
                        dmCount: destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, _equality.equal)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, update result.data to be
                // the result as re-read from the cache, rather than the raw network
                // result. Set without setDiff to avoid triggering a notify call,
                // since we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
        return result;
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, _networkStatusJs.NetworkStatus).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, _networkStatusJs.NetworkStatus).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, _indexJs.graphQLResultHasError)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}

},{"tslib":"gBS4y","@wry/equality":"H2Jtg","../utilities/index.js":"k55vB","./ObservableQuery.js":"aszik","./networkStatus.js":"8yReP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jrYcZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bEarf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gql", ()=>gql);
parcelHelpers.export(exports, "resetCaches", ()=>resetCaches);
parcelHelpers.export(exports, "disableFragmentWarnings", ()=>disableFragmentWarnings);
parcelHelpers.export(exports, "enableExperimentalFragmentVariables", ()=>enableExperimentalFragmentVariables);
parcelHelpers.export(exports, "disableExperimentalFragmentVariables", ()=>disableExperimentalFragmentVariables);
var _tslib = require("tslib");
var _graphql = require("graphql");
var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, " ").trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === "FragmentDefinition") {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, ast), {
        definitions: definitions
    });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === "object") workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = (0, _graphql.parse)(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== "Document") throw new Error("Not a valid GraphQL document.");
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === "string") literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === "Document") result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function(gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
exports.default = gql;

},{"tslib":"gBS4y","graphql":"crWS5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3mize":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloProvider", ()=>(0, _indexJs1.ApolloProvider));
parcelHelpers.export(exports, "ApolloConsumer", ()=>(0, _indexJs1.ApolloConsumer));
parcelHelpers.export(exports, "getApolloContext", ()=>(0, _indexJs1.getApolloContext));
parcelHelpers.export(exports, "resetApolloContext", ()=>(0, _indexJs1.resetApolloContext));
parcelHelpers.export(exports, "DocumentType", ()=>(0, _indexJs3.DocumentType));
parcelHelpers.export(exports, "operationName", ()=>(0, _indexJs3.operationName));
parcelHelpers.export(exports, "parser", ()=>(0, _indexJs3.parser));
parcelHelpers.export(exports, "createQueryPreloader", ()=>(0, _createQueryPreloaderJs.createQueryPreloader));
var _indexJs = require("../utilities/globals/index.js");
var _indexJs1 = require("./context/index.js");
var _indexJs2 = require("./hooks/index.js");
parcelHelpers.exportAll(_indexJs2, exports);
var _indexJs3 = require("./parser/index.js");
var _createQueryPreloaderJs = require("./query-preloader/createQueryPreloader.js");
var _typesJs = require("./types/types.js");
parcelHelpers.exportAll(_typesJs, exports);

},{"../utilities/globals/index.js":"jejDs","./context/index.js":"hwMAq","./hooks/index.js":"8oYkn","./parser/index.js":"fn08x","./query-preloader/createQueryPreloader.js":"7dFoS","./types/types.js":"eHNp0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hwMAq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloConsumer", ()=>(0, _apolloConsumerJs.ApolloConsumer));
parcelHelpers.export(exports, "getApolloContext", ()=>(0, _apolloContextJs.getApolloContext));
parcelHelpers.export(exports, "resetApolloContext", ()=>(0, _apolloContextJs.resetApolloContext));
parcelHelpers.export(exports, "ApolloProvider", ()=>(0, _apolloProviderJs.ApolloProvider));
var _indexJs = require("../../utilities/globals/index.js");
var _apolloConsumerJs = require("./ApolloConsumer.js");
var _apolloContextJs = require("./ApolloContext.js");
var _apolloProviderJs = require("./ApolloProvider.js");

},{"../../utilities/globals/index.js":"jejDs","./ApolloConsumer.js":"h1UDO","./ApolloContext.js":"fGSCO","./ApolloProvider.js":"2zOPA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h1UDO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloConsumer", ()=>ApolloConsumer);
var _indexJs = require("../../utilities/globals/index.js");
var _rehackt = require("rehackt");
var _apolloContextJs = require("./ApolloContext.js");
var ApolloConsumer = function(props) {
    var ApolloContext = (0, _apolloContextJs.getApolloContext)();
    return _rehackt.createElement(ApolloContext.Consumer, null, function(context) {
        (0, _indexJs.invariant)(context && context.client, 44);
        return props.children(context.client);
    });
};

},{"../../utilities/globals/index.js":"jejDs","rehackt":"flttF","./ApolloContext.js":"fGSCO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"flttF":[function(require,module,exports) {
"use strict";
module.exports = require("3c1e5cdd32d5f73");

},{"3c1e5cdd32d5f73":"6uln9"}],"fGSCO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getApolloContext", ()=>getApolloContext);
parcelHelpers.export(exports, "resetApolloContext", ()=>resetApolloContext);
var _rehackt = require("rehackt");
var _indexJs = require("../../utilities/index.js");
var _indexJs1 = require("../../utilities/globals/index.js");
// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var contextKey = (0, _indexJs.canUseSymbol) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function getApolloContext() {
    (0, _indexJs1.invariant)("createContext" in _rehackt, 45);
    var context = _rehackt.createContext[contextKey];
    if (!context) {
        Object.defineProperty(_rehackt.createContext, contextKey, {
            value: context = _rehackt.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var resetApolloContext = getApolloContext;

},{"rehackt":"flttF","../../utilities/index.js":"k55vB","../../utilities/globals/index.js":"jejDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2zOPA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloProvider", ()=>ApolloProvider);
var _tslib = require("tslib");
var _indexJs = require("../../utilities/globals/index.js");
var _rehackt = require("rehackt");
var _apolloContextJs = require("./ApolloContext.js");
var ApolloProvider = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, _apolloContextJs.getApolloContext)();
    var parentContext = _rehackt.useContext(ApolloContext);
    var context = _rehackt.useMemo(function() {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, _indexJs.invariant)(context.client, 46);
    return _rehackt.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};

},{"tslib":"gBS4y","../../utilities/globals/index.js":"jejDs","rehackt":"flttF","./ApolloContext.js":"fGSCO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8oYkn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQueryJs.useQuery));
parcelHelpers.export(exports, "useSuspenseQuery", ()=>(0, _useSuspenseQueryJs.useSuspenseQuery));
parcelHelpers.export(exports, "useBackgroundQuery", ()=>(0, _useBackgroundQueryJs.useBackgroundQuery));
parcelHelpers.export(exports, "useLoadableQuery", ()=>(0, _useLoadableQueryJs.useLoadableQuery));
parcelHelpers.export(exports, "useQueryRefHandlers", ()=>(0, _useQueryRefHandlersJs.useQueryRefHandlers));
parcelHelpers.export(exports, "useReadQuery", ()=>(0, _useReadQueryJs.useReadQuery));
parcelHelpers.export(exports, "skipToken", ()=>(0, _constantsJs.skipToken));
var _indexJs = require("../../utilities/globals/index.js");
var _useApolloClientJs = require("./useApolloClient.js");
parcelHelpers.exportAll(_useApolloClientJs, exports);
var _useLazyQueryJs = require("./useLazyQuery.js");
parcelHelpers.exportAll(_useLazyQueryJs, exports);
var _useMutationJs = require("./useMutation.js");
parcelHelpers.exportAll(_useMutationJs, exports);
var _useQueryJs = require("./useQuery.js");
var _useSubscriptionJs = require("./useSubscription.js");
parcelHelpers.exportAll(_useSubscriptionJs, exports);
var _useReactiveVarJs = require("./useReactiveVar.js");
parcelHelpers.exportAll(_useReactiveVarJs, exports);
var _useFragmentJs = require("./useFragment.js");
parcelHelpers.exportAll(_useFragmentJs, exports);
var _useSuspenseQueryJs = require("./useSuspenseQuery.js");
var _useBackgroundQueryJs = require("./useBackgroundQuery.js");
var _useLoadableQueryJs = require("./useLoadableQuery.js");
var _useQueryRefHandlersJs = require("./useQueryRefHandlers.js");
var _useReadQueryJs = require("./useReadQuery.js");
var _constantsJs = require("./constants.js");

},{"../../utilities/globals/index.js":"jejDs","./useApolloClient.js":"bsPvH","./useLazyQuery.js":"13o2Z","./useMutation.js":"7062L","./useQuery.js":"bKifF","./useSubscription.js":"gy0Ll","./useReactiveVar.js":"iEInr","./useFragment.js":"iDKc8","./useSuspenseQuery.js":"I86pU","./useBackgroundQuery.js":"8PZgZ","./useLoadableQuery.js":"bEfmp","./useQueryRefHandlers.js":"bTra5","./useReadQuery.js":"euTqa","./constants.js":"g22Xq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bsPvH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @example
 * ```jsx
 * import { useApolloClient } from '@apollo/client';
 *
 * function SomeComponent() {
 *   const client = useApolloClient();
 *   // `client` is now set to the `ApolloClient` instance being used by the
 *   // application (that was configured using something like `ApolloProvider`)
 * }
 * ```
 *
 * @since 3.0.0
 * @returns The `ApolloClient` instance being used by the application.
 */ parcelHelpers.export(exports, "useApolloClient", ()=>useApolloClient);
var _indexJs = require("../../utilities/globals/index.js");
var _rehackt = require("rehackt");
var _indexJs1 = require("../context/index.js");
function useApolloClient(override) {
    var context = _rehackt.useContext((0, _indexJs1.getApolloContext)());
    var client = override || context.client;
    (0, _indexJs.invariant)(!!client, 49);
    return client;
}

},{"../../utilities/globals/index.js":"jejDs","rehackt":"flttF","../context/index.js":"hwMAq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"13o2Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook for imperatively executing queries in an Apollo application, e.g. in response to user interaction.
 *
 * > Refer to the [Queries - Manual execution with useLazyQuery](https://www.apollographql.com/docs/react/data/queries#manual-execution-with-uselazyquery) section for a more in-depth overview of `useLazyQuery`.
 *
 * @example
 * ```jsx
 * import { gql, useLazyQuery } from "@apollo/client";
 *
 * const GET_GREETING = gql`
 *   query GetGreeting($language: String!) {
 *     greeting(language: $language) {
 *       message
 *     }
 *   }
 * `;
 *
 * function Hello() {
 *   const [loadGreeting, { called, loading, data }] = useLazyQuery(
 *     GET_GREETING,
 *     { variables: { language: "english" } }
 *   );
 *   if (called && loading) return <p>Loading ...</p>
 *   if (!called) {
 *     return <button onClick={() => loadGreeting()}>Load greeting</button>
 *   }
 *   return <h1>Hello {data.greeting.message}!</h1>;
 * }
 * ```
 * @since 3.0.0
 *
 * @param query - A GraphQL query document parsed into an AST by `gql`.
 * @param options - Default options to control how the query is executed.
 * @returns A tuple in the form of `[execute, result]`
 */ parcelHelpers.export(exports, "useLazyQuery", ()=>useLazyQuery);
var _tslib = require("tslib");
var _rehackt = require("rehackt");
var _indexJs = require("../../utilities/index.js");
var _useQueryJs = require("./useQuery.js");
var _useApolloClientJs = require("./useApolloClient.js");
// The following methods, when called will execute the query, regardless of
// whether the useLazyQuery execute function was called before.
var EAGER_METHODS = [
    "refetch",
    "reobserve",
    "fetchMore",
    "updateQuery",
    "startPolling",
    "subscribeToMore"
];
function useLazyQuery(query, options) {
    var _a;
    var execOptionsRef = _rehackt.useRef();
    var optionsRef = _rehackt.useRef();
    var queryRef = _rehackt.useRef();
    var merged = (0, _indexJs.mergeOptions)(options, execOptionsRef.current || {});
    var document = (_a = merged === null || merged === void 0 ? void 0 : merged.query) !== null && _a !== void 0 ? _a : query;
    // Use refs to track options and the used query to ensure the `execute`
    // function remains referentially stable between renders.
    optionsRef.current = merged;
    queryRef.current = document;
    var internalState = (0, _useQueryJs.useInternalState)((0, _useApolloClientJs.useApolloClient)(options && options.client), document);
    var useQueryResult = internalState.useQuery((0, _tslib.__assign)((0, _tslib.__assign)({}, merged), {
        skip: !execOptionsRef.current
    }));
    var initialFetchPolicy = useQueryResult.observable.options.initialFetchPolicy || internalState.getDefaultFetchPolicy();
    var result = Object.assign(useQueryResult, {
        called: !!execOptionsRef.current
    });
    // We use useMemo here to make sure the eager methods have a stable identity.
    var eagerMethods = _rehackt.useMemo(function() {
        var eagerMethods = {};
        var _loop_1 = function(key) {
            var method = result[key];
            eagerMethods[key] = function() {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    // Only the first time populating execOptionsRef.current matters here.
                    internalState.forceUpdateState();
                }
                // @ts-expect-error this is just too generic to type
                return method.apply(this, arguments);
            };
        };
        for(var _i = 0, EAGER_METHODS_1 = EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++){
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, []);
    Object.assign(result, eagerMethods);
    var execute = _rehackt.useCallback(function(executeOptions) {
        execOptionsRef.current = executeOptions ? (0, _tslib.__assign)((0, _tslib.__assign)({}, executeOptions), {
            fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy
        }) : {
            fetchPolicy: initialFetchPolicy
        };
        var options = (0, _indexJs.mergeOptions)(optionsRef.current, (0, _tslib.__assign)({
            query: queryRef.current
        }, execOptionsRef.current));
        var promise = internalState.executeQuery((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            skip: false
        })).then(function(queryResult) {
            return Object.assign(queryResult, eagerMethods);
        });
        // Because the return value of `useLazyQuery` is usually floated, we need
        // to catch the promise to prevent unhandled rejections.
        promise.catch(function() {});
        return promise;
    }, []);
    return [
        execute,
        result
    ];
}

},{"tslib":"gBS4y","rehackt":"flttF","../../utilities/index.js":"k55vB","./useQuery.js":"bKifF","./useApolloClient.js":"bsPvH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bKifF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook for executing queries in an Apollo application.
 *
 * To run a query within a React component, call `useQuery` and pass it a GraphQL query document.
 *
 * When your component renders, `useQuery` returns an object from Apollo Client that contains `loading`, `error`, and `data` properties you can use to render your UI.
 *
 * > Refer to the [Queries](https://www.apollographql.com/docs/react/data/queries) section for a more in-depth overview of `useQuery`.
 *
 * @example
 * ```jsx
 * import { gql, useQuery } from '@apollo/client';
 *
 * const GET_GREETING = gql`
 *   query GetGreeting($language: String!) {
 *     greeting(language: $language) {
 *       message
 *     }
 *   }
 * `;
 *
 * function Hello() {
 *   const { loading, error, data } = useQuery(GET_GREETING, {
 *     variables: { language: 'english' },
 *   });
 *   if (loading) return <p>Loading ...</p>;
 *   return <h1>Hello {data.greeting.message}!</h1>;
 * }
 * ```
 * @since 3.0.0
 * @param query - A GraphQL query document parsed into an AST by `gql`.
 * @param options - Options to control how the query is executed.
 * @returns Query result object
 */ parcelHelpers.export(exports, "useQuery", ()=>useQuery);
parcelHelpers.export(exports, "useInternalState", ()=>useInternalState);
var _tslib = require("tslib");
var _indexJs = require("../../utilities/globals/index.js");
var _rehackt = require("rehackt");
var _useSyncExternalStoreJs = require("./useSyncExternalStore.js");
var _equality = require("@wry/equality");
var _indexJs1 = require("../../utilities/index.js");
var _indexJs2 = require("../context/index.js");
var _indexJs3 = require("../../errors/index.js");
var _indexJs4 = require("../../core/index.js");
var _indexJs5 = require("../parser/index.js");
var _useApolloClientJs = require("./useApolloClient.js");
var hasOwnProperty = Object.prototype.hasOwnProperty;
function useQuery(query, options) {
    if (options === void 0) options = Object.create(null);
    return useInternalState((0, _useApolloClientJs.useApolloClient)(options.client), query).useQuery(options);
}
function useInternalState(client, query) {
    var stateRef = _rehackt.useRef();
    if (!stateRef.current || client !== stateRef.current.client || query !== stateRef.current.query) stateRef.current = new InternalState(client, query, stateRef.current);
    var state = stateRef.current;
    // By default, InternalState.prototype.forceUpdate is an empty function, but
    // we replace it here (before anyone has had a chance to see this state yet)
    // with a function that unconditionally forces an update, using the latest
    // setTick function. Updating this state by calling state.forceUpdate is the
    // only way we trigger React component updates (no other useState calls within
    // the InternalState class).
    state.forceUpdateState = _rehackt.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    return state;
}
var InternalState = /** @class */ function() {
    function InternalState(client, query, previous) {
        var _this = this;
        this.client = client;
        this.query = query;
        /**
         * Will be overwritten by the `useSyncExternalStore` "force update" method
         * whenever it is available and reset to `forceUpdateState` when it isn't.
         */ this.forceUpdate = function() {
            return _this.forceUpdateState();
        };
        this.ssrDisabledResult = (0, _indexJs1.maybeDeepFreeze)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: (0, _indexJs4.NetworkStatus).loading
        });
        this.skipStandbyResult = (0, _indexJs1.maybeDeepFreeze)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: (0, _indexJs4.NetworkStatus).ready
        });
        // This cache allows the referential stability of this.result (as returned by
        // getCurrentResult) to translate into referential stability of the resulting
        // QueryResult object returned by toQueryResult.
        this.toQueryResultCache = new ((0, _indexJs1.canUseWeakMap) ? WeakMap : Map)();
        (0, _indexJs5.verifyDocumentType)(query, (0, _indexJs5.DocumentType).Query);
        // Reuse previousData from previous InternalState (if any) to provide
        // continuity of previousData even if/when the query or client changes.
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) this.previousData = previousData;
    }
    /**
     * Forces an update using local component state.
     * As this is not batched with `useSyncExternalStore` updates,
     * this is only used as a fallback if the `useSyncExternalStore` "force update"
     * method is not registered at the moment.
     * See https://github.com/facebook/react/issues/25191
     *  */ InternalState.prototype.forceUpdateState = function() {
        // Replaced (in useInternalState) with a method that triggers an update.
        globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(51);
    };
    InternalState.prototype.executeQuery = function(options) {
        var _this = this;
        var _a;
        if (options.query) Object.assign(this, {
            query: options.query
        });
        this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function(resolve) {
            var result;
            // Subscribe to the concast independently of the ObservableQuery in case
            // the component gets unmounted before the promise resolves. This prevents
            // the concast from terminating early and resolving with `undefined` when
            // there are no more subscribers for the concast.
            concast.subscribe({
                next: function(value) {
                    result = value;
                },
                error: function() {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function() {
                    resolve(_this.toQueryResult(result));
                }
            });
        });
    };
    // Methods beginning with use- should be called according to the standard
    // rules of React hooks: only at the top level of the calling function, and
    // without any dynamic conditional logic.
    InternalState.prototype.useQuery = function(options) {
        var _this = this;
        // The renderPromises field gets initialized here in the useQuery method, at
        // the beginning of everything (for a given component rendering, at least),
        // so we can safely use this.renderPromises in other/later InternalState
        // methods without worrying it might be uninitialized. Even after
        // initialization, this.renderPromises is usually undefined (unless SSR is
        // happening), but that's fine as long as it has been initialized that way,
        // rather than left uninitialized.
        this.renderPromises = _rehackt.useContext((0, _indexJs2.getApolloContext)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = (0, _useSyncExternalStoreJs.useSyncExternalStore)(_rehackt.useCallback(function(handleStoreChange) {
            if (_this.renderPromises) return function() {};
            _this.forceUpdate = handleStoreChange;
            var onNext = function() {
                var previousResult = _this.result;
                // We use `getCurrentResult()` instead of the onNext argument because
                // the values differ slightly. Specifically, loading results will have
                // an empty object for data instead of `undefined` for some reason.
                var result = obsQuery.getCurrentResult();
                // Make sure we're not attempting to re-render similar results
                if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, _equality.equal)(previousResult.data, result.data)) return;
                _this.setResult(result);
            };
            var onError = function(error) {
                subscription.unsubscribe();
                subscription = obsQuery.resubscribeAfterError(onNext, onError);
                if (!hasOwnProperty.call(error, "graphQLErrors")) // The error is not a GraphQL error
                throw error;
                var previousResult = _this.result;
                if (!previousResult || previousResult && previousResult.loading || !(0, _equality.equal)(error, previousResult.error)) _this.setResult({
                    data: previousResult && previousResult.data,
                    error: error,
                    loading: false,
                    networkStatus: (0, _indexJs4.NetworkStatus).error
                });
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            // Do the "unsubscribe" with a short delay.
            // This way, an existing subscription can be reused without an additional
            // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
            // happen in very fast succession.
            return function() {
                setTimeout(function() {
                    return subscription.unsubscribe();
                });
                _this.forceUpdate = function() {
                    return _this.forceUpdateState();
                };
            };
        }, [
            // We memoize the subscribe function using useCallback and the following
            // dependency keys, because the subscribe function reference is all that
            // useSyncExternalStore uses internally as a dependency key for the
            // useEffect ultimately responsible for the subscription, so we are
            // effectively passing this dependency array to that useEffect buried
            // inside useSyncExternalStore, as desired.
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches
        ]), function() {
            return _this.getCurrentResult();
        }, function() {
            return _this.getCurrentResult();
        });
        // TODO Remove this method when we remove support for options.partialRefetch.
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function(options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        // Update this.watchQueryOptions, but only when they have changed, which
        // allows us to depend on the referential stability of
        // this.watchQueryOptions elsewhere.
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0, _equality.equal)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                // Though it might be tempting to postpone this reobserve call to the
                // useEffect block, we need getCurrentResult to return an appropriate
                // loading:true result synchronously (later within the same call to
                // useQuery). Since we already have this.observable here (not true for
                // the very first call to useQuery), we are not initiating any new
                // subscriptions, though it does feel less than ideal that reobserve
                // (potentially) kicks off a network request (for example, when the
                // variables have changed), which is technically a side-effect.
                this.observable.reobserve(this.getObsQueryOptions());
                // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
                // but save the current data as this.previousData, just like setResult
                // usually does.
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === false && !this.queryHookOptions.skip) // If SSR has been explicitly disabled, and this function has been called
        // on the server side, return the default loading state.
        this.result = this.ssrDisabledResult;
        else if (this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby") // When skipping a query (ie. we're not querying for data but still want to
        // render children), make sure the `data` is cleared out and `loading` is
        // set to `false` (since we aren't loading anything).
        //
        // NOTE: We no longer think this is the correct behavior. Skipping should
        // not automatically set `data` to `undefined`, but instead leave the
        // previous data in place. In other words, skipping should not mandate that
        // previously received data is all of a sudden removed. Unfortunately,
        // changing this is breaking, so we'll have to wait until Apollo Client 4.0
        // to address this.
        this.result = this.skipStandbyResult;
        else if (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) this.result = void 0;
    };
    InternalState.prototype.getObsQueryOptions = function() {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults) toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) toMerge.push(this.queryHookOptions.defaultOptions);
        // We use compact rather than mergeOptions for this part of the merge,
        // because we want watchQueryOptions.variables (if defined) to replace
        // this.observable.options.variables whole. This replacement allows
        // removing variables by removing them from the variables input to
        // useQuery. If the variables were always merged together (rather than
        // replaced), there would be no way to remove existing variables.
        // However, the variables from options.defaultOptions and globalDefaults
        // (if provided) should be merged, to ensure individual defaulted
        // variables always have values, if not otherwise defined in
        // observable.options or watchQueryOptions.
        toMerge.push((0, _indexJs1.compact)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce((0, _indexJs1.mergeOptions));
    };
    // A function to massage options before passing them to ObservableQuery.
    InternalState.prototype.createWatchQueryOptions = function(_a) {
        var _b;
        if (_a === void 0) _a = {};
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, // The above options are useQuery-specific, so this ...otherOptions spread
        // makes otherOptions almost a WatchQueryOptions object, except for the
        // query property that we add below.
        otherOptions = (0, _tslib.__rest)(_a, [
            "skip",
            "ssr",
            "onCompleted",
            "onError",
            "defaultOptions"
        ]);
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, {
            query: this.query
        });
        if (this.renderPromises && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) // this behavior was added to react-apollo without explanation in this PR
        // https://github.com/apollographql/react-apollo/pull/1579
        watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: "standby"
            });
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) || this.getDefaultFetchPolicy();
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function() {
        var _a, _b;
        return ((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "cache-first";
    };
    // Defining these methods as no-ops on the prototype allows us to call
    // state.onCompleted and/or state.onError without worrying about whether a
    // callback was provided.
    InternalState.prototype.onCompleted = function(data) {};
    InternalState.prototype.onError = function(error) {};
    InternalState.prototype.useObservableQuery = function() {
        // See if there is an existing observable that was used to fetch the same
        // data and if so, use it instead since it will contain the proper queryId
        // to fetch the result set. This is used during SSR.
        var obsQuery = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || // Reuse this.observable if possible (and not SSR)
        this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = _rehackt.useMemo(function() {
            return {
                refetch: obsQuery.refetch.bind(obsQuery),
                reobserve: obsQuery.reobserve.bind(obsQuery),
                fetchMore: obsQuery.fetchMore.bind(obsQuery),
                updateQuery: obsQuery.updateQuery.bind(obsQuery),
                startPolling: obsQuery.startPolling.bind(obsQuery),
                stopPolling: obsQuery.stopPolling.bind(obsQuery),
                subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery)
            };
        }, [
            obsQuery
        ]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false || this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) // TODO: This is a legacy API which could probably be cleaned up
            this.renderPromises.addObservableQueryPromise(obsQuery);
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function(nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) this.previousData = previousResult.data;
        this.result = nextResult;
        // Calling state.setResult always triggers an update, though some call sites
        // perform additional equality checks before committing to an update.
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult, previousResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function(result, previousResult) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            // wait a tick in case we are in the middle of rendering a component
            Promise.resolve().then(function() {
                if (error_1) _this.onError(error_1);
                else if (result.data && (previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus) !== result.networkStatus && result.networkStatus === (0, _indexJs4.NetworkStatus).ready) _this.onCompleted(result.data);
            }).catch(function(error) {
                globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function(result) {
        return (0, _indexJs1.isNonEmptyArray)(result.errors) ? new (0, _indexJs3.ApolloError)({
            graphQLErrors: result.errors
        }) : result.error;
    };
    InternalState.prototype.getCurrentResult = function() {
        // Using this.result as a cache ensures getCurrentResult continues returning
        // the same (===) result object, unless state.setResult has been called, or
        // we're doing server rendering and therefore override the result below.
        if (!this.result) this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        return this.result;
    };
    InternalState.prototype.toQueryResult = function(result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult) return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0, _tslib.__rest)(result, [
            "data",
            "partial"
        ]);
        this.toQueryResultCache.set(result, queryResult = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({
            data: data
        }, resultWithoutPartial), this.obsQueryFields), {
            client: this.client,
            observable: this.observable,
            variables: this.observable.variables,
            called: !this.queryHookOptions.skip,
            previousData: this.previousData
        }));
        if (!queryResult.error && (0, _indexJs1.isNonEmptyArray)(result.errors)) // Until a set naming convention for networkError and graphQLErrors is
        // decided upon, we map errors (graphQLErrors) to the error options.
        // TODO: Is it possible for both result.error and result.errors to be
        // defined here?
        queryResult.error = new (0, _indexJs3.ApolloError)({
            graphQLErrors: result.errors
        });
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function(result) {
        // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
        //
        // TODO: This code should be removed when the partialRefetch option is
        // removed. I was unable to get this hook to behave reasonably in certain
        // edge cases when this block was put in an effect.
        if (result.partial && this.queryHookOptions.partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only") {
            Object.assign(result, {
                loading: true,
                networkStatus: (0, _indexJs4.NetworkStatus).refetch
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}();

},{"tslib":"gBS4y","../../utilities/globals/index.js":"jejDs","rehackt":"flttF","./useSyncExternalStore.js":"d6KJ0","@wry/equality":"H2Jtg","../../utilities/index.js":"k55vB","../context/index.js":"hwMAq","../../errors/index.js":"73MUX","../../core/index.js":"4NtVX","../parser/index.js":"fn08x","./useApolloClient.js":"bsPvH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d6KJ0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>useSyncExternalStore);
var _indexJs = require("../../utilities/globals/index.js");
var _rehackt = require("rehackt");
var _indexJs1 = require("../../utilities/index.js");
var didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var uSESKey = "useSyncExternalStore";
var realHook = _rehackt[uSESKey];
var useSyncExternalStore = realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    globalThis.__DEV__ !== false && !didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        globalThis.__DEV__ !== false && (0, _indexJs.invariant).error(58);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _a = _rehackt.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if (0, _indexJs1.canUseLayoutEffect) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    _rehackt.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    _rehackt.useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    return value;
};
function checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}

},{"../../utilities/globals/index.js":"jejDs","rehackt":"flttF","../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fn08x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentType", ()=>DocumentType);
parcelHelpers.export(exports, "operationName", ()=>operationName);
// This parser is mostly used to safety check incoming documents.
parcelHelpers.export(exports, "parser", ()=>parser);
parcelHelpers.export(exports, "verifyDocumentType", ()=>verifyDocumentType);
var _indexJs = require("../../utilities/globals/index.js");
var _indexJs1 = require("../../utilities/index.js");
var _getMemoryInternalsJs = require("../../utilities/caching/getMemoryInternals.js");
var DocumentType;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache;
function operationName(type) {
    var name;
    switch(type){
        case DocumentType.Query:
            name = "Query";
            break;
        case DocumentType.Mutation:
            name = "Mutation";
            break;
        case DocumentType.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function parser(document) {
    if (!cache) cache = new (0, _indexJs1.AutoCleanedWeakCache)((0, _indexJs1.cacheSizes).parser || 1000 /* defaultCacheSizes.parser */ );
    var cached = cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, _indexJs.invariant)(!!document && !!document.kind, 59, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, _indexJs.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 60);
    (0, _indexJs.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 61, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length) type = DocumentType.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, _indexJs.invariant)(definitions.length === 1, 62, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data"; // fallback to using data if no name
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    cache.set(document, payload);
    return payload;
}
parser.resetCache = function() {
    cache = undefined;
};
if (globalThis.__DEV__ !== false) (0, _getMemoryInternalsJs.registerGlobalCache)("parser", function() {
    return cache ? cache.size : 0;
});
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    (0, _indexJs.invariant)(operation.type === type, 63, requiredOperationName, requiredOperationName, usedOperationName);
}

},{"../../utilities/globals/index.js":"jejDs","../../utilities/index.js":"k55vB","../../utilities/caching/getMemoryInternals.js":"b13lS","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7062L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 *
 * > Refer to the [Mutations](https://www.apollographql.com/docs/react/data/mutations/) section for a more in-depth overview of `useMutation`.
 *
 * @example
 * ```jsx
 * import { gql, useMutation } from '@apollo/client';
 *
 * const ADD_TODO = gql`
 *   mutation AddTodo($type: String!) {
 *     addTodo(type: $type) {
 *       id
 *       type
 *     }
 *   }
 * `;
 *
 * function AddTodo() {
 *   let input;
 *   const [addTodo, { data }] = useMutation(ADD_TODO);
 *
 *   return (
 *     <div>
 *       <form
 *         onSubmit={e => {
 *           e.preventDefault();
 *           addTodo({ variables: { type: input.value } });
 *           input.value = '';
 *         }}
 *       >
 *         <input
 *           ref={node => {
 *             input = node;
 *           }}
 *         />
 *         <button type="submit">Add Todo</button>
 *       </form>
 *     </div>
 *   );
 * }
 * ```
 * @since 3.0.0
 * @param mutation - A GraphQL mutation document parsed into an AST by `gql`.
 * @param options - Options to control how the mutation is executed.
 * @returns A tuple in the form of `[mutate, result]`
 */ parcelHelpers.export(exports, "useMutation", ()=>useMutation);
var _tslib = require("tslib");
var _rehackt = require("rehackt");
var _indexJs = require("../../utilities/index.js");
var _equality = require("@wry/equality");
var _indexJs1 = require("../parser/index.js");
var _indexJs2 = require("../../errors/index.js");
var _useApolloClientJs = require("./useApolloClient.js");
function useMutation(mutation, options) {
    var client = (0, _useApolloClientJs.useApolloClient)(options === null || options === void 0 ? void 0 : options.client);
    (0, _indexJs1.verifyDocumentType)(mutation, (0, _indexJs1.DocumentType).Mutation);
    var _a = _rehackt.useState({
        called: false,
        loading: false,
        client: client
    }), result = _a[0], setResult = _a[1];
    var ref = _rehackt.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options
    });
    Object.assign(ref.current, {
        client: client,
        options: options,
        mutation: mutation
    });
    var execute = _rehackt.useCallback(function(executeOptions) {
        if (executeOptions === void 0) executeOptions = {};
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            mutation: mutation
        });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) setResult(ref.current.result = {
            loading: true,
            error: void 0,
            data: void 0,
            called: true,
            client: client
        });
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0, _indexJs.mergeOptions)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function(response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, _indexJs2.ApolloError)({
                graphQLErrors: errors
            }) : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) onError(error, clientOptions);
            if (mutationId === ref.current.mutationId && !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client
                };
                if (ref.current.isMounted && !(0, _equality.equal)(ref.current.result, result_1)) setResult(ref.current.result = result_1);
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) onCompleted === null || onCompleted === void 0 || onCompleted(response.data, clientOptions);
            return response;
        }).catch(function(error) {
            var _a;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client
                };
                if (!(0, _equality.equal)(ref.current.result, result_2)) setResult(ref.current.result = result_2);
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return {
                    data: void 0,
                    errors: error
                };
            }
            throw error;
        });
    }, []);
    var reset = _rehackt.useCallback(function() {
        if (ref.current.isMounted) {
            var result_3 = {
                called: false,
                loading: false,
                client: client
            };
            Object.assign(ref.current, {
                mutationId: 0,
                result: result_3
            });
            setResult(result_3);
        }
    }, []);
    _rehackt.useEffect(function() {
        ref.current.isMounted = true;
        return function() {
            ref.current.isMounted = false;
        };
    }, []);
    return [
        execute,
        (0, _tslib.__assign)({
            reset: reset
        }, result)
    ];
}

},{"tslib":"gBS4y","rehackt":"flttF","../../utilities/index.js":"k55vB","@wry/equality":"H2Jtg","../parser/index.js":"fn08x","../../errors/index.js":"73MUX","./useApolloClient.js":"bsPvH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gy0Ll":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * > Refer to the [Subscriptions](https://www.apollographql.com/docs/react/data/subscriptions/) section for a more in-depth overview of `useSubscription`.
 *
 * @example
 * ```jsx
 * const COMMENTS_SUBSCRIPTION = gql`
 *   subscription OnCommentAdded($repoFullName: String!) {
 *     commentAdded(repoFullName: $repoFullName) {
 *       id
 *       content
 *     }
 *   }
 * `;
 *
 * function DontReadTheComments({ repoFullName }) {
 *   const {
 *     data: { commentAdded },
 *     loading,
 *   } = useSubscription(COMMENTS_SUBSCRIPTION, { variables: { repoFullName } });
 *   return <h4>New comment: {!loading && commentAdded.content}</h4>;
 * }
 * ```
 * @remarks
 * #### Subscriptions and React 18 Automatic Batching
 *
 * With React 18's [automatic batching](https://react.dev/blog/2022/03/29/react-v18#new-feature-automatic-batching), multiple state updates may be grouped into a single re-render for better performance.
 *
 * If your subscription API sends multiple messages at the same time or in very fast succession (within fractions of a millisecond), it is likely that only the last message received in that narrow time frame will result in a re-render.
 *
 * Consider the following component:
 *
 * ```jsx
 * export function Subscriptions() {
 *   const { data, error, loading } = useSubscription(query);
 *   const [accumulatedData, setAccumulatedData] = useState([]);
 *
 *   useEffect(() => {
 *     setAccumulatedData((prev) => [...prev, data]);
 *   }, [data]);
 *
 *   return (
 *     <>
 *       {loading && <p>Loading...</p>}
 *       {JSON.stringify(accumulatedData, undefined, 2)}
 *     </>
 *   );
 * }
 * ```
 *
 * If your subscription back-end emits two messages with the same timestamp, only the last message received by Apollo Client will be rendered. This is because React 18 will batch these two state updates into a single re-render.
 *
 * Since the component above is using `useEffect` to push `data` into a piece of local state on each `Subscriptions` re-render, the first message will never be added to the `accumulatedData` array since its render was skipped.
 *
 * Instead of using `useEffect` here, we can re-write this component to use the `onData` callback function accepted in `useSubscription`'s `options` object:
 *
 * ```jsx
 * export function Subscriptions() {
 *   const [accumulatedData, setAccumulatedData] = useState([]);
 *   const { data, error, loading } = useSubscription(
 *     query,
 *     {
 *       onData({ data }) {
 *         setAccumulatedData((prev) => [...prev, data])
 *       }
 *     }
 *   );
 *
 *   return (
 *     <>
 *       {loading && <p>Loading...</p>}
 *       {JSON.stringify(accumulatedData, undefined, 2)}
 *     </>
 *   );
 * }
 * ```
 *
 * > ⚠️ **Note:** The `useSubscription` option `onData` is available in Apollo Client >= 3.7. In previous versions, the equivalent option is named `onSubscriptionData`.
 *
 * Now, the first message will be added to the `accumulatedData` array since `onData` is called _before_ the component re-renders. React 18 automatic batching is still in effect and results in a single re-render, but with `onData` we can guarantee each message received after the component mounts is added to `accumulatedData`.
 *
 * @since 3.0.0
 * @param subscription - A GraphQL subscription document parsed into an AST by `gql`.
 * @param options - Options to control how the subscription is executed.
 * @returns Query result object
 */ parcelHelpers.export(exports, "useSubscription", ()=>useSubscription);
var _indexJs = require("../../utilities/globals/index.js");
var _rehackt = require("rehackt");
var _equality = require("@wry/equality");
var _indexJs1 = require("../parser/index.js");
var _useApolloClientJs = require("./useApolloClient.js");
function useSubscription(subscription, options) {
    var hasIssuedDeprecationWarningRef = _rehackt.useRef(false);
    var client = (0, _useApolloClientJs.useApolloClient)(options === null || options === void 0 ? void 0 : options.client);
    (0, _indexJs1.verifyDocumentType)(subscription, (0, _indexJs1.DocumentType).Subscription);
    var _a = _rehackt.useState({
        loading: !(options === null || options === void 0 ? void 0 : options.skip),
        error: void 0,
        data: void 0,
        variables: options === null || options === void 0 ? void 0 : options.variables
    }), result = _a[0], setResult = _a[1];
    if (!hasIssuedDeprecationWarningRef.current) {
        hasIssuedDeprecationWarningRef.current = true;
        if (options === null || options === void 0 ? void 0 : options.onSubscriptionData) globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(options.onData ? 52 : 53);
        if (options === null || options === void 0 ? void 0 : options.onSubscriptionComplete) globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(options.onComplete ? 54 : 55);
    }
    var _b = _rehackt.useState(function() {
        if (options === null || options === void 0 ? void 0 : options.skip) return null;
        return client.subscribe({
            query: subscription,
            variables: options === null || options === void 0 ? void 0 : options.variables,
            fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
            context: options === null || options === void 0 ? void 0 : options.context
        });
    }), observable = _b[0], setObservable = _b[1];
    var canResetObservableRef = _rehackt.useRef(false);
    _rehackt.useEffect(function() {
        return function() {
            canResetObservableRef.current = true;
        };
    }, []);
    var ref = _rehackt.useRef({
        client: client,
        subscription: subscription,
        options: options
    });
    _rehackt.useEffect(function() {
        var _a, _b, _c, _d;
        var shouldResubscribe = options === null || options === void 0 ? void 0 : options.shouldResubscribe;
        if (typeof shouldResubscribe === "function") shouldResubscribe = !!shouldResubscribe(options);
        if (options === null || options === void 0 ? void 0 : options.skip) {
            if (!(options === null || options === void 0 ? void 0 : options.skip) !== !((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.skip) || canResetObservableRef.current) {
                setResult({
                    loading: false,
                    data: void 0,
                    error: void 0,
                    variables: options === null || options === void 0 ? void 0 : options.variables
                });
                setObservable(null);
                canResetObservableRef.current = false;
            }
        } else if (shouldResubscribe !== false && (client !== ref.current.client || subscription !== ref.current.subscription || (options === null || options === void 0 ? void 0 : options.fetchPolicy) !== ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || !(options === null || options === void 0 ? void 0 : options.skip) !== !((_c = ref.current.options) === null || _c === void 0 ? void 0 : _c.skip) || !(0, _equality.equal)(options === null || options === void 0 ? void 0 : options.variables, (_d = ref.current.options) === null || _d === void 0 ? void 0 : _d.variables)) || canResetObservableRef.current) {
            setResult({
                loading: true,
                data: void 0,
                error: void 0,
                variables: options === null || options === void 0 ? void 0 : options.variables
            });
            setObservable(client.subscribe({
                query: subscription,
                variables: options === null || options === void 0 ? void 0 : options.variables,
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                context: options === null || options === void 0 ? void 0 : options.context
            }));
            canResetObservableRef.current = false;
        }
        Object.assign(ref.current, {
            client: client,
            subscription: subscription,
            options: options
        });
    }, [
        client,
        subscription,
        options,
        canResetObservableRef.current
    ]);
    _rehackt.useEffect(function() {
        if (!observable) return;
        var subscriptionStopped = false;
        var subscription = observable.subscribe({
            next: function(fetchResult) {
                var _a, _b;
                if (subscriptionStopped) return;
                var result = {
                    loading: false,
                    // TODO: fetchResult.data can be null but SubscriptionResult.data
                    // expects TData | undefined only
                    data: fetchResult.data,
                    error: void 0,
                    variables: options === null || options === void 0 ? void 0 : options.variables
                };
                setResult(result);
                if ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onData) ref.current.options.onData({
                    client: client,
                    data: result
                });
                else if ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onSubscriptionData) ref.current.options.onSubscriptionData({
                    client: client,
                    subscriptionData: result
                });
            },
            error: function(error) {
                var _a, _b;
                if (!subscriptionStopped) {
                    setResult({
                        loading: false,
                        data: void 0,
                        error: error,
                        variables: options === null || options === void 0 ? void 0 : options.variables
                    });
                    (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) === null || _b === void 0 || _b.call(_a, error);
                }
            },
            complete: function() {
                var _a, _b;
                if (!subscriptionStopped) {
                    if ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onComplete) ref.current.options.onComplete();
                    else if ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onSubscriptionComplete) ref.current.options.onSubscriptionComplete();
                }
            }
        });
        return function() {
            // immediately stop receiving subscription values, but do not unsubscribe
            // until after a short delay in case another useSubscription hook is
            // reusing the same underlying observable and is about to subscribe
            subscriptionStopped = true;
            setTimeout(function() {
                subscription.unsubscribe();
            });
        };
    }, [
        observable
    ]);
    return result;
}

},{"../../utilities/globals/index.js":"jejDs","rehackt":"flttF","@wry/equality":"H2Jtg","../parser/index.js":"fn08x","./useApolloClient.js":"bsPvH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iEInr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Reads the value of a [reactive variable](https://www.apollographql.com/docs/react/local-state/reactive-variables/) and re-renders the containing component whenever that variable's value changes. This enables a reactive variable to trigger changes _without_ relying on the `useQuery` hook.
 *
 * @example
 * ```jsx
 * import { makeVar, useReactiveVar } from "@apollo/client";
 * export const cartItemsVar = makeVar([]);
 *
 * export function Cart() {
 *   const cartItems = useReactiveVar(cartItemsVar);
 *   // ...
 * }
 * ```
 * @since 3.2.0
 * @param rv - A reactive variable.
 * @returns The current value of the reactive variable.
 */ parcelHelpers.export(exports, "useReactiveVar", ()=>useReactiveVar);
var _rehackt = require("rehackt");
var _useSyncExternalStoreJs = require("./useSyncExternalStore.js");
function useReactiveVar(rv) {
    return (0, _useSyncExternalStoreJs.useSyncExternalStore)(_rehackt.useCallback(function(update) {
        // By reusing the same onNext function in the nested call to
        // rv.onNextChange(onNext), we can keep using the initial clean-up function
        // returned by rv.onNextChange(function onNext(v){...}), without having to
        // register the new clean-up function (returned by the nested
        // rv.onNextChange(onNext)) with yet another callback.
        return rv.onNextChange(function onNext() {
            update();
            rv.onNextChange(onNext);
        });
    }, [
        rv
    ]), rv, rv);
}

},{"rehackt":"flttF","./useSyncExternalStore.js":"d6KJ0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iDKc8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFragment", ()=>useFragment);
var _tslib = require("tslib");
var _rehackt = require("rehackt");
var _equality = require("@wry/equality");
var _indexJs = require("../../utilities/index.js");
var _useApolloClientJs = require("./useApolloClient.js");
var _useSyncExternalStoreJs = require("./useSyncExternalStore.js");
var _indexJs1 = require("./internal/index.js");
function useFragment(options) {
    var cache = (0, _useApolloClientJs.useApolloClient)().cache;
    var diffOptions = (0, _indexJs1.useDeepMemo)(function() {
        var fragment = options.fragment, fragmentName = options.fragmentName, from = options.from, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, rest = (0, _tslib.__rest)(options, [
            "fragment",
            "fragmentName",
            "from",
            "optimistic"
        ]);
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), {
            returnPartialData: true,
            id: typeof from === "string" ? from : cache.identify(from),
            query: cache["getFragmentDoc"](fragment, fragmentName),
            optimistic: optimistic
        });
    }, [
        options
    ]);
    var resultRef = (0, _indexJs1.useLazyRef)(function() {
        return diffToResult(cache.diff(diffOptions));
    });
    // Used for both getSnapshot and getServerSnapshot
    var getSnapshot = _rehackt.useCallback(function() {
        return resultRef.current;
    }, []);
    return (0, _useSyncExternalStoreJs.useSyncExternalStore)(_rehackt.useCallback(function(forceUpdate) {
        var lastTimeout = 0;
        var unsubscribe = cache.watch((0, _tslib.__assign)((0, _tslib.__assign)({}, diffOptions), {
            immediate: true,
            callback: function(diff) {
                if (!(0, _equality.equal)(diff.result, resultRef.current.data)) {
                    resultRef.current = diffToResult(diff);
                    // If we get another update before we've re-rendered, bail out of
                    // the update and try again. This ensures that the relative timing
                    // between useQuery and useFragment stays roughly the same as
                    // fixed in https://github.com/apollographql/apollo-client/pull/11083
                    clearTimeout(lastTimeout);
                    lastTimeout = setTimeout(forceUpdate);
                }
            }
        }));
        return function() {
            unsubscribe();
            clearTimeout(lastTimeout);
        };
    }, [
        cache,
        diffOptions
    ]), getSnapshot, getSnapshot);
}
function diffToResult(diff) {
    var result = {
        data: diff.result,
        complete: !!diff.complete
    };
    if (diff.missing) result.missing = (0, _indexJs.mergeDeepArray)(diff.missing.map(function(error) {
        return error.missing;
    }));
    return result;
}

},{"tslib":"gBS4y","rehackt":"flttF","@wry/equality":"H2Jtg","../../utilities/index.js":"k55vB","./useApolloClient.js":"bsPvH","./useSyncExternalStore.js":"d6KJ0","./internal/index.js":"bKi56","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bKi56":[function(require,module,exports) {
// These hooks are used internally and are not exported publicly by the library
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeepMemo", ()=>(0, _useDeepMemoJs.useDeepMemo));
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>(0, _useIsomorphicLayoutEffectJs.useIsomorphicLayoutEffect));
parcelHelpers.export(exports, "useRenderGuard", ()=>(0, _useRenderGuardJs.useRenderGuard));
parcelHelpers.export(exports, "useLazyRef", ()=>(0, _useLazyRefJs.useLazyRef));
parcelHelpers.export(exports, "__use", ()=>(0, _useJs.__use));
var _useDeepMemoJs = require("./useDeepMemo.js");
var _useIsomorphicLayoutEffectJs = require("./useIsomorphicLayoutEffect.js");
var _useRenderGuardJs = require("./useRenderGuard.js");
var _useLazyRefJs = require("./useLazyRef.js");
var _useJs = require("./__use.js");

},{"./useDeepMemo.js":"3EIEQ","./useIsomorphicLayoutEffect.js":false,"./useRenderGuard.js":"cFOsG","./useLazyRef.js":"hNVDF","./__use.js":"gnMtd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3EIEQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeepMemo", ()=>useDeepMemo);
var _rehackt = require("rehackt");
var _equality = require("@wry/equality");
function useDeepMemo(memoFn, deps) {
    var ref = _rehackt.useRef();
    if (!ref.current || !(0, _equality.equal)(ref.current.deps, deps)) ref.current = {
        value: memoFn(),
        deps: deps
    };
    return ref.current.value;
}

},{"rehackt":"flttF","@wry/equality":"H2Jtg","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cFOsG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
Relay does this too, so we hope this is safe.
https://github.com/facebook/relay/blob/8651fbca19adbfbb79af7a3bc40834d105fd7747/packages/react-relay/relay-hooks/loadQuery.js#L90-L98
*/ parcelHelpers.export(exports, "useRenderGuard", ()=>useRenderGuard);
var _rehackt = require("rehackt");
function getRenderDispatcher() {
    var _a, _b;
    return (_b = (_a = _rehackt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _a === void 0 ? void 0 : _a.ReactCurrentDispatcher) === null || _b === void 0 ? void 0 : _b.current;
}
var RenderDispatcher = null;
function useRenderGuard() {
    RenderDispatcher = getRenderDispatcher();
    return _rehackt.useCallback(function() {
        return RenderDispatcher !== null && RenderDispatcher === getRenderDispatcher();
    }, []);
}

},{"rehackt":"flttF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hNVDF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLazyRef", ()=>useLazyRef);
var _rehackt = require("rehackt");
var INIT = {};
function useLazyRef(getInitialValue) {
    var ref = _rehackt.useRef(INIT);
    if (ref.current === INIT) ref.current = getInitialValue();
    return ref;
}

},{"rehackt":"flttF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gnMtd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__use", ()=>__use);
var _indexJs = require("../../../utilities/index.js");
var _rehackt = require("rehackt");
// Prevent webpack from complaining about our feature detection of the
// use property of the React namespace, which is expected not
// to exist when using current stable versions, and that's fine.
var useKey = "use";
var realHook = _rehackt[useKey];
var __use = realHook || function __use(promise) {
    var statefulPromise = (0, _indexJs.wrapPromiseWithState)(promise);
    switch(statefulPromise.status){
        case "pending":
            throw statefulPromise;
        case "rejected":
            throw statefulPromise.reason;
        case "fulfilled":
            return statefulPromise.value;
    }
};

},{"../../../utilities/index.js":"k55vB","rehackt":"flttF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"I86pU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSuspenseQuery", ()=>useSuspenseQuery);
parcelHelpers.export(exports, "toApolloError", ()=>toApolloError);
parcelHelpers.export(exports, "useWatchQueryOptions", ()=>useWatchQueryOptions);
var _tslib = require("tslib");
var _rehackt = require("rehackt");
var _indexJs = require("../../utilities/globals/index.js");
var _indexJs1 = require("../../core/index.js");
var _indexJs2 = require("../../utilities/index.js");
var _useApolloClientJs = require("./useApolloClient.js");
var _indexJs3 = require("../parser/index.js");
var _indexJs4 = require("./internal/index.js");
var _indexJs5 = require("../internal/index.js");
var _indexJs6 = require("../../cache/index.js");
var _constantsJs = require("./constants.js");
function useSuspenseQuery(query, options) {
    if (options === void 0) options = Object.create(null);
    var client = (0, _useApolloClientJs.useApolloClient)(options.client);
    var suspenseCache = (0, _indexJs5.getSuspenseCache)(client);
    var watchQueryOptions = useWatchQueryOptions({
        client: client,
        query: query,
        options: options
    });
    var fetchPolicy = watchQueryOptions.fetchPolicy, variables = watchQueryOptions.variables;
    var _a = options.queryKey, queryKey = _a === void 0 ? [] : _a;
    var cacheKey = (0, _tslib.__spreadArray)([
        query,
        (0, _indexJs6.canonicalStringify)(variables)
    ], [].concat(queryKey), true);
    var queryRef = suspenseCache.getQueryRef(cacheKey, function() {
        return client.watchQuery(watchQueryOptions);
    });
    var _b = _rehackt.useState([
        queryRef.key,
        queryRef.promise
    ]), current = _b[0], setPromise = _b[1];
    // This saves us a re-execution of the render function when a variable changed.
    if (current[0] !== queryRef.key) {
        current[0] = queryRef.key;
        current[1] = queryRef.promise;
    }
    var promise = current[1];
    if (queryRef.didChangeOptions(watchQueryOptions)) current[1] = promise = queryRef.applyOptions(watchQueryOptions);
    _rehackt.useEffect(function() {
        var dispose = queryRef.retain();
        var removeListener = queryRef.listen(function(promise) {
            setPromise([
                queryRef.key,
                promise
            ]);
        });
        return function() {
            removeListener();
            dispose();
        };
    }, [
        queryRef
    ]);
    var skipResult = _rehackt.useMemo(function() {
        var error = toApolloError(queryRef.result);
        return {
            loading: false,
            data: queryRef.result.data,
            networkStatus: error ? (0, _indexJs1.NetworkStatus).error : (0, _indexJs1.NetworkStatus).ready,
            error: error
        };
    }, [
        queryRef.result
    ]);
    var result = fetchPolicy === "standby" ? skipResult : (0, _indexJs4.__use)(promise);
    var fetchMore = _rehackt.useCallback(function(options) {
        var promise = queryRef.fetchMore(options);
        setPromise([
            queryRef.key,
            queryRef.promise
        ]);
        return promise;
    }, [
        queryRef
    ]);
    var refetch = _rehackt.useCallback(function(variables) {
        var promise = queryRef.refetch(variables);
        setPromise([
            queryRef.key,
            queryRef.promise
        ]);
        return promise;
    }, [
        queryRef
    ]);
    var subscribeToMore = _rehackt.useCallback(function(options) {
        return queryRef.observable.subscribeToMore(options);
    }, [
        queryRef
    ]);
    return _rehackt.useMemo(function() {
        return {
            client: client,
            data: result.data,
            error: toApolloError(result),
            networkStatus: result.networkStatus,
            fetchMore: fetchMore,
            refetch: refetch,
            subscribeToMore: subscribeToMore
        };
    }, [
        client,
        fetchMore,
        refetch,
        result,
        subscribeToMore
    ]);
}
function validateOptions(options) {
    var query = options.query, fetchPolicy = options.fetchPolicy, returnPartialData = options.returnPartialData;
    (0, _indexJs3.verifyDocumentType)(query, (0, _indexJs3.DocumentType).Query);
    validateFetchPolicy(fetchPolicy);
    validatePartialDataReturn(fetchPolicy, returnPartialData);
}
function validateFetchPolicy(fetchPolicy) {
    if (fetchPolicy === void 0) fetchPolicy = "cache-first";
    var supportedFetchPolicies = [
        "cache-first",
        "network-only",
        "no-cache",
        "cache-and-network"
    ];
    (0, _indexJs.invariant)(supportedFetchPolicies.includes(fetchPolicy), 56, fetchPolicy);
}
function validatePartialDataReturn(fetchPolicy, returnPartialData) {
    if (fetchPolicy === "no-cache" && returnPartialData) globalThis.__DEV__ !== false && (0, _indexJs.invariant).warn(57);
}
function toApolloError(result) {
    return (0, _indexJs2.isNonEmptyArray)(result.errors) ? new (0, _indexJs1.ApolloError)({
        graphQLErrors: result.errors
    }) : result.error;
}
function useWatchQueryOptions(_a) {
    var client = _a.client, query = _a.query, options = _a.options;
    return (0, _indexJs4.useDeepMemo)(function() {
        var _a;
        if (options === (0, _constantsJs.skipToken)) return {
            query: query,
            fetchPolicy: "standby"
        };
        var fetchPolicy = options.fetchPolicy || ((_a = client.defaultOptions.watchQuery) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || "cache-first";
        var watchQueryOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            fetchPolicy: fetchPolicy,
            query: query,
            notifyOnNetworkStatusChange: false,
            nextFetchPolicy: void 0
        });
        if (globalThis.__DEV__ !== false) validateOptions(watchQueryOptions);
        // Assign the updated fetch policy after our validation since `standby` is
        // not a supported fetch policy on its own without the use of `skip`.
        if (options.skip) watchQueryOptions.fetchPolicy = "standby";
        return watchQueryOptions;
    }, [
        client,
        options,
        query
    ]);
}

},{"tslib":"gBS4y","rehackt":"flttF","../../utilities/globals/index.js":"jejDs","../../core/index.js":"4NtVX","../../utilities/index.js":"k55vB","./useApolloClient.js":"bsPvH","../parser/index.js":"fn08x","./internal/index.js":"bKi56","../internal/index.js":"1DTgf","../../cache/index.js":"fv0fM","./constants.js":"g22Xq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1DTgf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSuspenseCache", ()=>(0, _getSuspenseCacheJs.getSuspenseCache));
parcelHelpers.export(exports, "InternalQueryReference", ()=>(0, _queryReferenceJs.InternalQueryReference));
parcelHelpers.export(exports, "getWrappedPromise", ()=>(0, _queryReferenceJs.getWrappedPromise));
parcelHelpers.export(exports, "unwrapQueryRef", ()=>(0, _queryReferenceJs.unwrapQueryRef));
parcelHelpers.export(exports, "updateWrappedQueryRef", ()=>(0, _queryReferenceJs.updateWrappedQueryRef));
parcelHelpers.export(exports, "wrapQueryRef", ()=>(0, _queryReferenceJs.wrapQueryRef));
var _getSuspenseCacheJs = require("./cache/getSuspenseCache.js");
var _queryReferenceJs = require("./cache/QueryReference.js");

},{"./cache/getSuspenseCache.js":"erHVk","./cache/QueryReference.js":"eCXPP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"erHVk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSuspenseCache", ()=>getSuspenseCache);
var _suspenseCacheJs = require("./SuspenseCache.js");
var suspenseCacheSymbol = Symbol.for("apollo.suspenseCache");
function getSuspenseCache(client) {
    var _a;
    if (!client[suspenseCacheSymbol]) client[suspenseCacheSymbol] = new (0, _suspenseCacheJs.SuspenseCache)((_a = client.defaultOptions.react) === null || _a === void 0 ? void 0 : _a.suspense);
    return client[suspenseCacheSymbol];
}

},{"./SuspenseCache.js":"jsz2f","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jsz2f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SuspenseCache", ()=>SuspenseCache);
var _trie = require("@wry/trie");
var _indexJs = require("../../../utilities/index.js");
var _queryReferenceJs = require("./QueryReference.js");
var SuspenseCache = /** @class */ function() {
    function SuspenseCache(options) {
        if (options === void 0) options = Object.create(null);
        this.queryRefs = new (0, _trie.Trie)((0, _indexJs.canUseWeakMap));
        this.options = options;
    }
    SuspenseCache.prototype.getQueryRef = function(cacheKey, createObservable) {
        var ref = this.queryRefs.lookupArray(cacheKey);
        if (!ref.current) ref.current = new (0, _queryReferenceJs.InternalQueryReference)(createObservable(), {
            autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
            onDispose: function() {
                delete ref.current;
            }
        });
        return ref.current;
    };
    return SuspenseCache;
}();

},{"@wry/trie":"fd6oo","../../../utilities/index.js":"k55vB","./QueryReference.js":"eCXPP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eCXPP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapQueryRef", ()=>wrapQueryRef);
parcelHelpers.export(exports, "getWrappedPromise", ()=>getWrappedPromise);
parcelHelpers.export(exports, "unwrapQueryRef", ()=>unwrapQueryRef);
parcelHelpers.export(exports, "updateWrappedQueryRef", ()=>updateWrappedQueryRef);
parcelHelpers.export(exports, "InternalQueryReference", ()=>InternalQueryReference);
var _tslib = require("tslib");
var _equality = require("@wry/equality");
var _indexJs = require("../../../utilities/index.js");
var QUERY_REFERENCE_SYMBOL = Symbol();
var PROMISE_SYMBOL = Symbol();
function wrapQueryRef(internalQueryRef) {
    var _a;
    var ref = (_a = {
        toPromise: function() {
            // We avoid resolving this promise with the query data because we want to
            // discourage using the server data directly from the queryRef. Instead,
            // the data should be accessed through `useReadQuery`. When the server
            // data is needed, its better to use `client.query()` directly.
            //
            // Here we resolve with the ref itself to make using this in React Router
            // or TanStack Router `loader` functions a bit more ergonomic e.g.
            //
            // function loader() {
            //   return { queryRef: await preloadQuery(query).toPromise() }
            // }
            return getWrappedPromise(ref).then(function() {
                return ref;
            });
        }
    }, _a[QUERY_REFERENCE_SYMBOL] = internalQueryRef, _a[PROMISE_SYMBOL] = internalQueryRef.promise, _a);
    return ref;
}
function getWrappedPromise(queryRef) {
    var internalQueryRef = unwrapQueryRef(queryRef);
    return internalQueryRef.promise.status === "fulfilled" ? internalQueryRef.promise : queryRef[PROMISE_SYMBOL];
}
function unwrapQueryRef(queryRef) {
    return queryRef[QUERY_REFERENCE_SYMBOL];
}
function updateWrappedQueryRef(queryRef, promise) {
    queryRef[PROMISE_SYMBOL] = promise;
}
var OBSERVED_CHANGED_OPTIONS = [
    "canonizeResults",
    "context",
    "errorPolicy",
    "fetchPolicy",
    "refetchWritePolicy",
    "returnPartialData"
];
var InternalQueryReference = /** @class */ function() {
    function InternalQueryReference(observable, options) {
        var _this = this;
        this.key = {};
        this.listeners = new Set();
        this.references = 0;
        this.handleNext = this.handleNext.bind(this);
        this.handleError = this.handleError.bind(this);
        this.dispose = this.dispose.bind(this);
        this.observable = observable;
        if (options.onDispose) this.onDispose = options.onDispose;
        this.setResult();
        this.subscribeToQuery();
        // Start a timer that will automatically dispose of the query if the
        // suspended resource does not use this queryRef in the given time. This
        // helps prevent memory leaks when a component has unmounted before the
        // query has finished loading.
        var startDisposeTimer = function() {
            var _a;
            if (!_this.references) _this.autoDisposeTimeoutId = setTimeout(_this.dispose, (_a = options.autoDisposeTimeoutMs) !== null && _a !== void 0 ? _a : 30000);
        };
        // We wait until the request has settled to ensure we don't dispose of the
        // query ref before the request finishes, otherwise we would leave the
        // promise in a pending state rendering the suspense boundary indefinitely.
        this.promise.then(startDisposeTimer, startDisposeTimer);
    }
    Object.defineProperty(InternalQueryReference.prototype, "disposed", {
        get: function() {
            return this.subscription.closed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InternalQueryReference.prototype, "watchQueryOptions", {
        get: function() {
            return this.observable.options;
        },
        enumerable: false,
        configurable: true
    });
    InternalQueryReference.prototype.reinitialize = function() {
        var observable = this.observable;
        var originalFetchPolicy = this.watchQueryOptions.fetchPolicy;
        try {
            if (originalFetchPolicy !== "no-cache") {
                observable.resetLastResults();
                observable.silentSetOptions({
                    fetchPolicy: "cache-first"
                });
            } else observable.silentSetOptions({
                fetchPolicy: "standby"
            });
            this.subscribeToQuery();
            if (originalFetchPolicy === "no-cache") return;
            observable.resetDiff();
            this.setResult();
        } finally{
            observable.silentSetOptions({
                fetchPolicy: originalFetchPolicy
            });
        }
    };
    InternalQueryReference.prototype.retain = function() {
        var _this = this;
        this.references++;
        clearTimeout(this.autoDisposeTimeoutId);
        var disposed = false;
        return function() {
            if (disposed) return;
            disposed = true;
            _this.references--;
            // Wait before fully disposing in case the app is running in strict mode.
            setTimeout(function() {
                if (!_this.references) _this.dispose();
            });
        };
    };
    InternalQueryReference.prototype.didChangeOptions = function(watchQueryOptions) {
        var _this = this;
        return OBSERVED_CHANGED_OPTIONS.some(function(option) {
            return !(0, _equality.equal)(_this.watchQueryOptions[option], watchQueryOptions[option]);
        });
    };
    InternalQueryReference.prototype.applyOptions = function(watchQueryOptions) {
        var _a = this.watchQueryOptions, currentFetchPolicy = _a.fetchPolicy, currentCanonizeResults = _a.canonizeResults;
        // "standby" is used when `skip` is set to `true`. Detect when we've
        // enabled the query (i.e. `skip` is `false`) to execute a network request.
        if (currentFetchPolicy === "standby" && currentFetchPolicy !== watchQueryOptions.fetchPolicy) this.initiateFetch(this.observable.reobserve(watchQueryOptions));
        else {
            this.observable.silentSetOptions(watchQueryOptions);
            if (currentCanonizeResults !== watchQueryOptions.canonizeResults) {
                this.result = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.result), this.observable.getCurrentResult());
                this.promise = (0, _indexJs.createFulfilledPromise)(this.result);
            }
        }
        return this.promise;
    };
    InternalQueryReference.prototype.listen = function(listener) {
        var _this = this;
        this.listeners.add(listener);
        return function() {
            _this.listeners.delete(listener);
        };
    };
    InternalQueryReference.prototype.refetch = function(variables) {
        return this.initiateFetch(this.observable.refetch(variables));
    };
    InternalQueryReference.prototype.fetchMore = function(options) {
        return this.initiateFetch(this.observable.fetchMore(options));
    };
    InternalQueryReference.prototype.dispose = function() {
        this.subscription.unsubscribe();
        this.onDispose();
    };
    InternalQueryReference.prototype.onDispose = function() {
    // noop. overridable by options
    };
    InternalQueryReference.prototype.handleNext = function(result) {
        var _a;
        switch(this.promise.status){
            case "pending":
                // Maintain the last successful `data` value if the next result does not
                // have one.
                if (result.data === void 0) result.data = this.result.data;
                this.result = result;
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, result);
                break;
            default:
                // This occurs when switching to a result that is fully cached when this
                // class is instantiated. ObservableQuery will run reobserve when
                // subscribing, which delivers a result from the cache.
                if (result.data === this.result.data && result.networkStatus === this.result.networkStatus) return;
                // Maintain the last successful `data` value if the next result does not
                // have one.
                if (result.data === void 0) result.data = this.result.data;
                this.result = result;
                this.promise = (0, _indexJs.createFulfilledPromise)(result);
                this.deliver(this.promise);
                break;
        }
    };
    InternalQueryReference.prototype.handleError = function(error) {
        var _a;
        this.subscription.unsubscribe();
        this.subscription = this.observable.resubscribeAfterError(this.handleNext, this.handleError);
        switch(this.promise.status){
            case "pending":
                (_a = this.reject) === null || _a === void 0 || _a.call(this, error);
                break;
            default:
                this.promise = (0, _indexJs.createRejectedPromise)(error);
                this.deliver(this.promise);
        }
    };
    InternalQueryReference.prototype.deliver = function(promise) {
        this.listeners.forEach(function(listener) {
            return listener(promise);
        });
    };
    InternalQueryReference.prototype.initiateFetch = function(returnedPromise) {
        var _this = this;
        this.promise = this.createPendingPromise();
        this.promise.catch(function() {});
        // If the data returned from the fetch is deeply equal to the data already
        // in the cache, `handleNext` will not be triggered leaving the promise we
        // created in a pending state forever. To avoid this situtation, we attempt
        // to resolve the promise if `handleNext` hasn't been run to ensure the
        // promise is resolved correctly.
        returnedPromise.then(function(result) {
            var _a;
            if (_this.promise.status === "pending") {
                _this.result = result;
                (_a = _this.resolve) === null || _a === void 0 || _a.call(_this, result);
            }
        }).catch(function() {});
        return returnedPromise;
    };
    InternalQueryReference.prototype.subscribeToQuery = function() {
        var _this = this;
        this.subscription = this.observable.filter(function(result) {
            return !(0, _equality.equal)(result.data, {}) && !(0, _equality.equal)(result, _this.result);
        }).subscribe(this.handleNext, this.handleError);
    };
    InternalQueryReference.prototype.setResult = function() {
        // Don't save this result as last result to prevent delivery of last result
        // when first subscribing
        var result = this.observable.getCurrentResult(false);
        if ((0, _equality.equal)(result, this.result)) return;
        this.result = result;
        this.promise = result.data && (!result.partial || this.watchQueryOptions.returnPartialData) ? (0, _indexJs.createFulfilledPromise)(result) : this.createPendingPromise();
    };
    InternalQueryReference.prototype.createPendingPromise = function() {
        var _this = this;
        return (0, _indexJs.wrapPromiseWithState)(new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        }));
    };
    return InternalQueryReference;
}();

},{"tslib":"gBS4y","@wry/equality":"H2Jtg","../../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g22Xq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipToken", ()=>skipToken);
var skipToken = Symbol.for("apollo.skipToken");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8PZgZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBackgroundQuery", ()=>useBackgroundQuery);
var _tslib = require("tslib");
var _rehackt = require("rehackt");
var _useApolloClientJs = require("./useApolloClient.js");
var _indexJs = require("../internal/index.js");
var _useSuspenseQueryJs = require("./useSuspenseQuery.js");
var _indexJs1 = require("../../cache/index.js");
function useBackgroundQuery(query, options) {
    if (options === void 0) options = Object.create(null);
    var client = (0, _useApolloClientJs.useApolloClient)(options.client);
    var suspenseCache = (0, _indexJs.getSuspenseCache)(client);
    var watchQueryOptions = (0, _useSuspenseQueryJs.useWatchQueryOptions)({
        client: client,
        query: query,
        options: options
    });
    var fetchPolicy = watchQueryOptions.fetchPolicy, variables = watchQueryOptions.variables;
    var _a = options.queryKey, queryKey = _a === void 0 ? [] : _a;
    // This ref tracks the first time query execution is enabled to determine
    // whether to return a query ref or `undefined`. When initialized
    // in a skipped state (either via `skip: true` or `skipToken`) we return
    // `undefined` for the `queryRef` until the query has been enabled. Once
    // enabled, a query ref is always returned regardless of whether the query is
    // skipped again later.
    var didFetchResult = _rehackt.useRef(fetchPolicy !== "standby");
    didFetchResult.current || (didFetchResult.current = fetchPolicy !== "standby");
    var cacheKey = (0, _tslib.__spreadArray)([
        query,
        (0, _indexJs1.canonicalStringify)(variables)
    ], [].concat(queryKey), true);
    var queryRef = suspenseCache.getQueryRef(cacheKey, function() {
        return client.watchQuery(watchQueryOptions);
    });
    var _b = _rehackt.useState((0, _indexJs.wrapQueryRef)(queryRef)), wrappedQueryRef = _b[0], setWrappedQueryRef = _b[1];
    if ((0, _indexJs.unwrapQueryRef)(wrappedQueryRef) !== queryRef) setWrappedQueryRef((0, _indexJs.wrapQueryRef)(queryRef));
    if (queryRef.didChangeOptions(watchQueryOptions)) {
        var promise = queryRef.applyOptions(watchQueryOptions);
        (0, _indexJs.updateWrappedQueryRef)(wrappedQueryRef, promise);
    }
    var fetchMore = _rehackt.useCallback(function(options) {
        var promise = queryRef.fetchMore(options);
        setWrappedQueryRef((0, _indexJs.wrapQueryRef)(queryRef));
        return promise;
    }, [
        queryRef
    ]);
    var refetch = _rehackt.useCallback(function(variables) {
        var promise = queryRef.refetch(variables);
        setWrappedQueryRef((0, _indexJs.wrapQueryRef)(queryRef));
        return promise;
    }, [
        queryRef
    ]);
    return [
        didFetchResult.current ? wrappedQueryRef : void 0,
        {
            fetchMore: fetchMore,
            refetch: refetch
        }
    ];
}

},{"tslib":"gBS4y","rehackt":"flttF","./useApolloClient.js":"bsPvH","../internal/index.js":"1DTgf","./useSuspenseQuery.js":"I86pU","../../cache/index.js":"fv0fM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bEfmp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLoadableQuery", ()=>useLoadableQuery);
var _tslib = require("tslib");
var _rehackt = require("rehackt");
var _useApolloClientJs = require("./useApolloClient.js");
var _indexJs = require("../internal/index.js");
var _indexJs1 = require("./internal/index.js");
var _useSuspenseQueryJs = require("./useSuspenseQuery.js");
var _indexJs2 = require("../../cache/index.js");
var _indexJs3 = require("../../utilities/globals/index.js");
function useLoadableQuery(query, options) {
    if (options === void 0) options = Object.create(null);
    var client = (0, _useApolloClientJs.useApolloClient)(options.client);
    var suspenseCache = (0, _indexJs.getSuspenseCache)(client);
    var watchQueryOptions = (0, _useSuspenseQueryJs.useWatchQueryOptions)({
        client: client,
        query: query,
        options: options
    });
    var _a = options.queryKey, queryKey = _a === void 0 ? [] : _a;
    var _b = _rehackt.useState(null), queryRef = _b[0], setQueryRef = _b[1];
    var internalQueryRef = queryRef && (0, _indexJs.unwrapQueryRef)(queryRef);
    if (queryRef && (internalQueryRef === null || internalQueryRef === void 0 ? void 0 : internalQueryRef.didChangeOptions(watchQueryOptions))) {
        var promise = internalQueryRef.applyOptions(watchQueryOptions);
        (0, _indexJs.updateWrappedQueryRef)(queryRef, promise);
    }
    var calledDuringRender = (0, _indexJs1.useRenderGuard)();
    var fetchMore = _rehackt.useCallback(function(options) {
        if (!internalQueryRef) throw new Error("The query has not been loaded. Please load the query.");
        var promise = internalQueryRef.fetchMore(options);
        setQueryRef((0, _indexJs.wrapQueryRef)(internalQueryRef));
        return promise;
    }, [
        internalQueryRef
    ]);
    var refetch = _rehackt.useCallback(function(options) {
        if (!internalQueryRef) throw new Error("The query has not been loaded. Please load the query.");
        var promise = internalQueryRef.refetch(options);
        setQueryRef((0, _indexJs.wrapQueryRef)(internalQueryRef));
        return promise;
    }, [
        internalQueryRef
    ]);
    var loadQuery = _rehackt.useCallback(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        (0, _indexJs3.invariant)(!calledDuringRender(), 50);
        var variables = args[0];
        var cacheKey = (0, _tslib.__spreadArray)([
            query,
            (0, _indexJs2.canonicalStringify)(variables)
        ], [].concat(queryKey), true);
        var queryRef = suspenseCache.getQueryRef(cacheKey, function() {
            return client.watchQuery((0, _tslib.__assign)((0, _tslib.__assign)({}, watchQueryOptions), {
                variables: variables
            }));
        });
        setQueryRef((0, _indexJs.wrapQueryRef)(queryRef));
    }, [
        query,
        queryKey,
        suspenseCache,
        watchQueryOptions,
        calledDuringRender
    ]);
    var reset = _rehackt.useCallback(function() {
        setQueryRef(null);
    }, [
        queryRef
    ]);
    return [
        loadQuery,
        queryRef,
        {
            fetchMore: fetchMore,
            refetch: refetch,
            reset: reset
        }
    ];
}

},{"tslib":"gBS4y","rehackt":"flttF","./useApolloClient.js":"bsPvH","../internal/index.js":"1DTgf","./internal/index.js":"bKi56","./useSuspenseQuery.js":"I86pU","../../cache/index.js":"fv0fM","../../utilities/globals/index.js":"jejDs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bTra5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A React hook that returns a `refetch` and `fetchMore` function for a given
 * `queryRef`.
 *
 * This is useful to get access to handlers for a `queryRef` that was created by
 * `createQueryPreloader` or when the handlers for a `queryRef` produced in
 * a different component are inaccessible.
 *
 * @example
 * ```tsx
 * const MyComponent({ queryRef }) {
 *   const { refetch, fetchMore } = useQueryRefHandlers(queryRef);
 *
 *   // ...
 * }
 * ```
 * @since 3.9.0
 * @param queryRef - A `QueryReference` returned from `useBackgroundQuery`, `useLoadableQuery`, or `createQueryPreloader`.
 */ parcelHelpers.export(exports, "useQueryRefHandlers", ()=>useQueryRefHandlers);
var _rehackt = require("rehackt");
var _indexJs = require("../internal/index.js");
function useQueryRefHandlers(queryRef) {
    var _a = _rehackt.useState(queryRef), previousQueryRef = _a[0], setPreviousQueryRef = _a[1];
    var _b = _rehackt.useState(queryRef), wrappedQueryRef = _b[0], setWrappedQueryRef = _b[1];
    var internalQueryRef = (0, _indexJs.unwrapQueryRef)(queryRef);
    // To ensure we can support React transitions, this hook needs to manage the
    // queryRef state and apply React's state value immediately to the existing
    // queryRef since this hook doesn't return the queryRef directly
    if (previousQueryRef !== queryRef) {
        setPreviousQueryRef(queryRef);
        setWrappedQueryRef(queryRef);
    } else (0, _indexJs.updateWrappedQueryRef)(queryRef, (0, _indexJs.getWrappedPromise)(wrappedQueryRef));
    var refetch = _rehackt.useCallback(function(variables) {
        var promise = internalQueryRef.refetch(variables);
        setWrappedQueryRef((0, _indexJs.wrapQueryRef)(internalQueryRef));
        return promise;
    }, [
        internalQueryRef
    ]);
    var fetchMore = _rehackt.useCallback(function(options) {
        var promise = internalQueryRef.fetchMore(options);
        setWrappedQueryRef((0, _indexJs.wrapQueryRef)(internalQueryRef));
        return promise;
    }, [
        internalQueryRef
    ]);
    return {
        refetch: refetch,
        fetchMore: fetchMore
    };
}

},{"rehackt":"flttF","../internal/index.js":"1DTgf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"euTqa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useReadQuery", ()=>useReadQuery);
var _rehackt = require("rehackt");
var _indexJs = require("../internal/index.js");
var _indexJs1 = require("./internal/index.js");
var _useSuspenseQueryJs = require("./useSuspenseQuery.js");
var _useSyncExternalStoreJs = require("./useSyncExternalStore.js");
function useReadQuery(queryRef) {
    var internalQueryRef = _rehackt.useMemo(function() {
        return (0, _indexJs.unwrapQueryRef)(queryRef);
    }, [
        queryRef
    ]);
    var getPromise = _rehackt.useCallback(function() {
        return (0, _indexJs.getWrappedPromise)(queryRef);
    }, [
        queryRef
    ]);
    if (internalQueryRef.disposed) {
        internalQueryRef.reinitialize();
        (0, _indexJs.updateWrappedQueryRef)(queryRef, internalQueryRef.promise);
    }
    _rehackt.useEffect(function() {
        return internalQueryRef.retain();
    }, [
        internalQueryRef
    ]);
    var promise = (0, _useSyncExternalStoreJs.useSyncExternalStore)(_rehackt.useCallback(function(forceUpdate) {
        return internalQueryRef.listen(function(promise) {
            (0, _indexJs.updateWrappedQueryRef)(queryRef, promise);
            forceUpdate();
        });
    }, [
        internalQueryRef
    ]), getPromise, getPromise);
    var result = (0, _indexJs1.__use)(promise);
    return _rehackt.useMemo(function() {
        return {
            data: result.data,
            networkStatus: result.networkStatus,
            error: (0, _useSuspenseQueryJs.toApolloError)(result)
        };
    }, [
        result
    ]);
}

},{"rehackt":"flttF","../internal/index.js":"1DTgf","./internal/index.js":"bKi56","./useSuspenseQuery.js":"I86pU","./useSyncExternalStore.js":"d6KJ0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7dFoS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A higher order function that returns a `preloadQuery` function which
 * can be used to begin loading a query with the given `client`. This is useful
 * when you want to start loading a query as early as possible outside of a
 * React component.
 *
 * > Refer to the [Suspense - Initiating queries outside React](https://www.apollographql.com/docs/react/data/suspense#initiating-queries-outside-react) section for a more in-depth overview.
 *
 * @param client - The `ApolloClient` instance that will be used to load queries
 * from the returned `preloadQuery` function.
 * @returns The `preloadQuery` function.
 *
 * @example
 * ```js
 * const preloadQuery = createQueryPreloader(client);
 * ```
 * @since 3.9.0
 * @alpha
 */ parcelHelpers.export(exports, "createQueryPreloader", ()=>createQueryPreloader);
var _tslib = require("tslib");
var _indexJs = require("../internal/index.js");
function createQueryPreloader(client) {
    return function preloadQuery(query, options) {
        var _a, _b;
        if (options === void 0) options = Object.create(null);
        var queryRef = new (0, _indexJs.InternalQueryReference)(client.watchQuery((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            query: query
        })), {
            autoDisposeTimeoutMs: (_b = (_a = client.defaultOptions.react) === null || _a === void 0 ? void 0 : _a.suspense) === null || _b === void 0 ? void 0 : _b.autoDisposeTimeoutMs
        });
        return (0, _indexJs.wrapQueryRef)(queryRef);
    };
}

},{"tslib":"gBS4y","../internal/index.js":"1DTgf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eHNp0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c2s6j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setContext", ()=>setContext);
var _tslib = require("tslib");
var _indexJs = require("../core/index.js");
var _indexJs1 = require("../../utilities/index.js");
function setContext(setter) {
    return new (0, _indexJs.ApolloLink)(function(operation, forward) {
        var request = (0, _tslib.__rest)(operation, []);
        return new (0, _indexJs1.Observable)(function(observer) {
            var handle;
            var closed = false;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                // if the observer is already closed, no need to subscribe.
                if (closed) return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                closed = true;
                if (handle) handle.unsubscribe();
            };
        });
    });
}

},{"tslib":"gBS4y","../core/index.js":"gXJ1R","../../utilities/index.js":"k55vB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9MM2L":[function(require,module,exports) {
// This file is adapted from the graphql-ws npm package:
// https://github.com/enisdenjo/graphql-ws
//
// Most of the file comes from that package's README; some other parts (such as
// isLikeCloseEvent) come from its source.
//
// Here's the license of the original code:
//
// The MIT License (MIT)
//
// Copyright (c) 2020-2021 Denis Badurina
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQLWsLink", ()=>GraphQLWsLink);
var _tslib = require("tslib");
var _indexJs = require("../../utilities/index.js");
var _indexJs1 = require("../core/index.js");
var _indexJs2 = require("../../errors/index.js");
// https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/close_event
function isLikeCloseEvent(val) {
    return (0, _indexJs.isNonNullObject)(val) && "code" in val && "reason" in val;
}
// https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/error_event
function isLikeErrorEvent(err) {
    var _a;
    return (0, _indexJs.isNonNullObject)(err) && ((_a = err.target) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.CLOSED;
}
var GraphQLWsLink = /** @class */ function(_super) {
    (0, _tslib.__extends)(GraphQLWsLink, _super);
    function GraphQLWsLink(client) {
        var _this = _super.call(this) || this;
        _this.client = client;
        return _this;
    }
    GraphQLWsLink.prototype.request = function(operation) {
        var _this = this;
        return new (0, _indexJs.Observable)(function(observer) {
            return _this.client.subscribe((0, _tslib.__assign)((0, _tslib.__assign)({}, operation), {
                query: (0, _indexJs.print)(operation.query)
            }), {
                next: observer.next.bind(observer),
                complete: observer.complete.bind(observer),
                error: function(err) {
                    if (err instanceof Error) return observer.error(err);
                    var likeClose = isLikeCloseEvent(err);
                    if (likeClose || isLikeErrorEvent(err)) return observer.error(// reason will be available on clean closes
                    new Error("Socket closed".concat(likeClose ? " with event ".concat(err.code) : "").concat(likeClose ? " ".concat(err.reason) : "")));
                    return observer.error(new (0, _indexJs2.ApolloError)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
        });
    };
    return GraphQLWsLink;
}((0, _indexJs1.ApolloLink));

},{"tslib":"gBS4y","../../utilities/index.js":"k55vB","../core/index.js":"gXJ1R","../../errors/index.js":"73MUX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bRngE":[function(require,module,exports) {
var global = arguments[3];
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }
    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
            return this;
        }, i;
        function verb(n) {
            if (g[n]) i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
        }
        function resume(n, v) {
            try {
                step(g[n](v));
            } catch (e) {
                settle(q[0][3], e);
            }
        }
        function step(r) {
            r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
        }
        function fulfill(value) {
            resume("next", value);
        }
        function reject(value) {
            resume("throw", value);
        }
        function settle(f, v) {
            if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
        }
    }
    /** @private */ function extendedTypeof(val) {
        if (val === null) return "null";
        if (Array.isArray(val)) return "array";
        return typeof val;
    }
    /** @private */ function isObject(val) {
        return extendedTypeof(val) === "object";
    }
    /** @private */ function areGraphQLErrors(obj) {
        return Array.isArray(obj) && // must be at least one error
        obj.length > 0 && // error has at least a message
        obj.every((ob)=>"message" in ob);
    }
    /**
     * Limits the WebSocket close event reason to not exceed a length of one frame.
     * Reference: https://datatracker.ietf.org/doc/html/rfc6455#section-5.2.
     *
     * @private
     */ function limitCloseReason(reason, whenTooLong) {
        return reason.length < 124 ? reason : whenTooLong;
    }
    /**
     *
     * common
     *
     */ /**
     * The WebSocket sub-protocol used for the [GraphQL over WebSocket Protocol](https://github.com/graphql/graphql-over-http/blob/main/rfcs/GraphQLOverWebSocket.md).
     *
     * @category Common
     */ const GRAPHQL_TRANSPORT_WS_PROTOCOL = "graphql-transport-ws";
    /**
     * The deprecated subprotocol used by [subscriptions-transport-ws](https://github.com/apollographql/subscriptions-transport-ws).
     *
     * @private
     */ const DEPRECATED_GRAPHQL_WS_PROTOCOL = "graphql-ws";
    /**
     * `graphql-ws` expected and standard close codes of the [GraphQL over WebSocket Protocol](https://github.com/graphql/graphql-over-http/blob/main/rfcs/GraphQLOverWebSocket.md).
     *
     * @category Common
     */ exports1.CloseCode = void 0;
    (function(CloseCode) {
        CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
        CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
        CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
        CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
        /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
        CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
        CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
        CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
        CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
        /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
        CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
    })(exports1.CloseCode || (exports1.CloseCode = {}));
    /**
     * Types of messages allowed to be sent by the client/server over the WS protocol.
     *
     * @category Common
     */ exports1.MessageType = void 0;
    (function(MessageType) {
        MessageType["ConnectionInit"] = "connection_init";
        MessageType["ConnectionAck"] = "connection_ack";
        MessageType["Ping"] = "ping";
        MessageType["Pong"] = "pong";
        MessageType["Subscribe"] = "subscribe";
        MessageType["Next"] = "next";
        MessageType["Error"] = "error";
        MessageType["Complete"] = "complete";
    })(exports1.MessageType || (exports1.MessageType = {}));
    /**
     * Validates the message against the GraphQL over WebSocket Protocol.
     *
     * Invalid messages will throw descriptive errors.
     *
     * @category Common
     */ function validateMessage(val) {
        if (!isObject(val)) throw new Error(`Message is expected to be an object, but got ${extendedTypeof(val)}`);
        if (!val.type) throw new Error(`Message is missing the 'type' property`);
        if (typeof val.type !== "string") throw new Error(`Message is expects the 'type' property to be a string, but got ${extendedTypeof(val.type)}`);
        switch(val.type){
            case exports1.MessageType.ConnectionInit:
            case exports1.MessageType.ConnectionAck:
            case exports1.MessageType.Ping:
            case exports1.MessageType.Pong:
                if (val.payload != null && !isObject(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
                break;
            case exports1.MessageType.Subscribe:
                if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                if (!isObject(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${extendedTypeof(val.payload)}`);
                if (typeof val.payload.query !== "string") throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${extendedTypeof(val.payload.query)}`);
                if (val.payload.variables != null && !isObject(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${extendedTypeof(val.payload.variables)}`);
                if (val.payload.operationName != null && extendedTypeof(val.payload.operationName) !== "string") throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${extendedTypeof(val.payload.operationName)}`);
                if (val.payload.extensions != null && !isObject(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${extendedTypeof(val.payload.extensions)}`);
                break;
            case exports1.MessageType.Next:
                if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                if (!isObject(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${extendedTypeof(val.payload)}`);
                break;
            case exports1.MessageType.Error:
                if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                if (!areGraphQLErrors(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
                break;
            case exports1.MessageType.Complete:
                if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                break;
            default:
                throw new Error(`Invalid message 'type' property "${val.type}"`);
        }
        return val;
    }
    /**
     * Checks if the provided value is a valid GraphQL over WebSocket message.
     *
     * @deprecated Use `validateMessage` instead.
     *
     * @category Common
     */ function isMessage(val) {
        try {
            validateMessage(val);
            return true;
        } catch (_a) {
            return false;
        }
    }
    /**
     * Parses the raw websocket message data to a valid message.
     *
     * @category Common
     */ function parseMessage(data, reviver) {
        return validateMessage(typeof data === "string" ? JSON.parse(data, reviver) : data);
    }
    /**
     * Stringifies a valid message ready to be sent through the socket.
     *
     * @category Common
     */ function stringifyMessage(msg, replacer) {
        validateMessage(msg);
        return JSON.stringify(msg, replacer);
    }
    /**
     *
     * client
     *
     */ /**
     * Creates a disposable GraphQL over WebSocket client.
     *
     * @category Client
     */ function createClient(options) {
        const { url, connectionParams, lazy = true, onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive = 0, disablePong, connectionAckWaitTimeout = 0, retryAttempts = 5, retryWait = async function randomisedExponentialBackoff(retries) {
            let retryDelay = 1000; // start with 1s delay
            for(let i = 0; i < retries; i++)retryDelay *= 2;
            await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
                Math.floor(Math.random() * 2700 + 300)));
        }, shouldRetry = isLikeCloseEvent, isFatalConnectionProblem, on, webSocketImpl, /**
         * Generates a v4 UUID to be used as the ID using `Math`
         * as the random number generator. Supply your own generator
         * in case you need more uniqueness.
         *
         * Reference: https://gist.github.com/jed/982883
         */ generateID = function generateUUID() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
                const r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
        let ws;
        if (webSocketImpl) {
            if (!isWebSocket(webSocketImpl)) throw new Error("Invalid WebSocket implementation provided");
            ws = webSocketImpl;
        } else if (typeof WebSocket !== "undefined") ws = WebSocket;
        else if (typeof global !== "undefined") ws = global.WebSocket || // @ts-expect-error: Support more browsers
        global.MozWebSocket;
        else if (typeof window !== "undefined") ws = window.WebSocket || // @ts-expect-error: Support more browsers
        window.MozWebSocket;
        if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
        const WebSocketImpl = ws;
        // websocket status emitter, subscriptions are handled differently
        const emitter = (()=>{
            const message = (()=>{
                const listeners = {};
                return {
                    on (id, listener) {
                        listeners[id] = listener;
                        return ()=>{
                            delete listeners[id];
                        };
                    },
                    emit (message) {
                        var _a;
                        if ("id" in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                    }
                };
            })();
            const listeners = {
                connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                    on.connecting
                ] : [],
                opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                    on.opened
                ] : [],
                connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                    on.connected
                ] : [],
                ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                    on.ping
                ] : [],
                pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                    on.pong
                ] : [],
                message: (on === null || on === void 0 ? void 0 : on.message) ? [
                    message.emit,
                    on.message
                ] : [
                    message.emit
                ],
                closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                    on.closed
                ] : [],
                error: (on === null || on === void 0 ? void 0 : on.error) ? [
                    on.error
                ] : []
            };
            return {
                onMessage: message.on,
                on (event, listener) {
                    const l = listeners[event];
                    l.push(listener);
                    return ()=>{
                        l.splice(l.indexOf(listener), 1);
                    };
                },
                emit (event, ...args) {
                    // we copy the listeners so that unlistens dont "pull the rug under our feet"
                    for (const listener of [
                        ...listeners[event]
                    ])// @ts-expect-error: The args should fit
                    listener(...args);
                }
            };
        })();
        // invokes the callback either when an error or closed event is emitted,
        // first one that gets called prevails, other emissions are ignored
        function errorOrClosed(cb) {
            const listening = [
                // errors are fatal and more critical than close events, throw them first
                emitter.on("error", (err)=>{
                    listening.forEach((unlisten)=>unlisten());
                    cb(err);
                }),
                // closes can be graceful and not fatal, throw them second (if error didnt throw)
                emitter.on("closed", (event)=>{
                    listening.forEach((unlisten)=>unlisten());
                    cb(event);
                })
            ];
        }
        let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
        async function connect() {
            // clear the lazy close timeout immediatelly so that close gets debounced
            // see: https://github.com/enisdenjo/graphql-ws/issues/388
            clearTimeout(lazyCloseTimeout);
            const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                    if (retrying) {
                        await retryWait(retries);
                        // subscriptions might complete while waiting for retry
                        if (!locks) {
                            connecting = undefined;
                            return denied({
                                code: 1000,
                                reason: "All Subscriptions Gone"
                            });
                        }
                        retries++;
                    }
                    emitter.emit("connecting");
                    const socket = new WebSocketImpl(typeof url === "function" ? await url() : url, GRAPHQL_TRANSPORT_WS_PROTOCOL);
                    let connectionAckTimeout, queuedPing;
                    function enqueuePing() {
                        if (isFinite(keepAlive) && keepAlive > 0) {
                            clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                            queuedPing = setTimeout(()=>{
                                if (socket.readyState === WebSocketImpl.OPEN) {
                                    socket.send(stringifyMessage({
                                        type: exports1.MessageType.Ping
                                    }));
                                    emitter.emit("ping", false, undefined);
                                }
                            }, keepAlive);
                        }
                    }
                    errorOrClosed((errOrEvent)=>{
                        connecting = undefined;
                        clearTimeout(connectionAckTimeout);
                        clearTimeout(queuedPing);
                        denied(errOrEvent);
                        if (isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                            socket.close(4499, "Terminated"); // close event is artificial and emitted manually, see `Client.terminate()` below
                            socket.onerror = null;
                            socket.onclose = null;
                        }
                    });
                    socket.onerror = (err)=>emitter.emit("error", err);
                    socket.onclose = (event)=>emitter.emit("closed", event);
                    socket.onopen = async ()=>{
                        try {
                            emitter.emit("opened", socket);
                            const payload = typeof connectionParams === "function" ? await connectionParams() : connectionParams;
                            // connectionParams might take too long causing the server to kick off the client
                            // the necessary error/close event is already reported - simply stop execution
                            if (socket.readyState !== WebSocketImpl.OPEN) return;
                            socket.send(stringifyMessage(payload ? {
                                type: exports1.MessageType.ConnectionInit,
                                payload
                            } : {
                                type: exports1.MessageType.ConnectionInit
                            }, replacer));
                            if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                                socket.close(exports1.CloseCode.ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
                            }, connectionAckWaitTimeout);
                            enqueuePing(); // enqueue ping (noop if disabled)
                        } catch (err) {
                            emitter.emit("error", err);
                            socket.close(exports1.CloseCode.InternalClientError, limitCloseReason(err instanceof Error ? err.message : new Error(err).message, "Internal client error"));
                        }
                    };
                    let acknowledged = false;
                    socket.onmessage = ({ data })=>{
                        try {
                            const message = parseMessage(data, reviver);
                            emitter.emit("message", message);
                            if (message.type === "ping" || message.type === "pong") {
                                emitter.emit(message.type, true, message.payload); // received
                                if (message.type === "pong") enqueuePing(); // enqueue next ping (noop if disabled)
                                else if (!disablePong) {
                                    // respond with pong on ping
                                    socket.send(stringifyMessage(message.payload ? {
                                        type: exports1.MessageType.Pong,
                                        payload: message.payload
                                    } : {
                                        type: exports1.MessageType.Pong
                                    }));
                                    emitter.emit("pong", false, message.payload);
                                }
                                return; // ping and pongs can be received whenever
                            }
                            if (acknowledged) return; // already connected and acknowledged
                            if (message.type !== exports1.MessageType.ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                            clearTimeout(connectionAckTimeout);
                            acknowledged = true;
                            emitter.emit("connected", socket, message.payload); // connected = socket opened + acknowledged
                            retrying = false; // future lazy connects are not retries
                            retries = 0; // reset the retries on connect
                            connected([
                                socket,
                                new Promise((_, reject)=>errorOrClosed(reject))
                            ]);
                        } catch (err) {
                            socket.onmessage = null; // stop reading messages as soon as reading breaks once
                            emitter.emit("error", err);
                            socket.close(exports1.CloseCode.BadResponse, limitCloseReason(err instanceof Error ? err.message : new Error(err).message, "Bad response"));
                        }
                    };
                })()));
            // if the provided socket is in a closing state, wait for the throw on close
            if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
            let release = ()=>{
            // releases this connection
            };
            const released = new Promise((resolve)=>release = resolve);
            return [
                socket,
                release,
                Promise.race([
                    // wait for
                    released.then(()=>{
                        if (!locks) {
                            // and if no more locks are present, complete the connection
                            const complete = ()=>socket.close(1000, "Normal Closure");
                            if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                            // then complete if the socket is still open.
                            lazyCloseTimeout = setTimeout(()=>{
                                if (socket.readyState === WebSocketImpl.OPEN) complete();
                            }, lazyCloseTimeoutMs);
                            else // otherwise complete immediately
                            complete();
                        }
                    }),
                    // or
                    throwOnClose
                ])
            ];
        }
        /**
         * Checks the `connect` problem and evaluates if the client should retry.
         */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
            // some close codes are worth reporting immediately
            if (isLikeCloseEvent(errOrCloseEvent) && (isFatalInternalCloseCode(errOrCloseEvent.code) || [
                exports1.CloseCode.InternalServerError,
                exports1.CloseCode.InternalClientError,
                exports1.CloseCode.BadRequest,
                exports1.CloseCode.BadResponse,
                exports1.CloseCode.Unauthorized,
                // CloseCode.Forbidden, might grant access out after retry
                exports1.CloseCode.SubprotocolNotAcceptable,
                // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
                // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
                exports1.CloseCode.SubscriberAlreadyExists,
                exports1.CloseCode.TooManyInitialisationRequests
            ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
            // client was disposed, no retries should proceed regardless
            if (disposed) return false;
            // normal closure (possibly all subscriptions have completed)
            // if no locks were acquired in the meantime, shouldnt try again
            if (isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
            // retries are not allowed or we tried to many times, report error
            if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
            // throw non-retryable connection problems
            if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
            // @deprecated throw fatal connection problems immediately
            if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
            // looks good, start retrying
            return retrying = true;
        }
        // in non-lazy (hot?) mode always hold one connection lock to persist the socket
        if (!lazy) (async ()=>{
            locks++;
            for(;;)try {
                const [, , throwOnClose] = await connect();
                await throwOnClose; // will always throw because releaser is not used
            } catch (errOrCloseEvent) {
                try {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                } catch (errOrCloseEvent) {
                    // report thrown error, no further retries
                    return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
                }
            }
        })();
        function subscribe(payload, sink) {
            const id = generateID(payload);
            let done = false, errored = false, releaser = ()=>{
                // for handling completions before connect
                locks--;
                done = true;
            };
            (async ()=>{
                locks++;
                for(;;)try {
                    const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                    // if done while waiting for connect, release the connection lock right away
                    if (done) return release();
                    const unlisten = emitter.onMessage(id, (message)=>{
                        switch(message.type){
                            case exports1.MessageType.Next:
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                sink.next(message.payload);
                                return;
                            case exports1.MessageType.Error:
                                errored = true, done = true;
                                sink.error(message.payload);
                                releaser();
                                return;
                            case exports1.MessageType.Complete:
                                done = true;
                                releaser(); // release completes the sink
                                return;
                        }
                    });
                    socket.send(stringifyMessage({
                        id,
                        type: exports1.MessageType.Subscribe,
                        payload
                    }, replacer));
                    releaser = ()=>{
                        if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                        socket.send(stringifyMessage({
                            id,
                            type: exports1.MessageType.Complete
                        }, replacer));
                        locks--;
                        done = true;
                        release();
                    };
                    // either the releaser will be called, connection completed and
                    // the promise resolved or the socket closed and the promise rejected.
                    // whatever happens though, we want to stop listening for messages
                    await waitForReleaseOrThrowOnClose.finally(unlisten);
                    return; // completed, shouldnt try again
                } catch (errOrCloseEvent) {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                }
            })().then(()=>{
                // delivering either an error or a complete terminates the sequence
                if (!errored) sink.complete();
            }) // resolves on release or normal closure
            .catch((err)=>{
                sink.error(err);
            }); // rejects on close events and errors
            return ()=>{
                // dispose only of active subscriptions
                if (!done) releaser();
            };
        }
        return {
            on: emitter.on,
            subscribe,
            iterate (request) {
                const pending = [];
                const deferred = {
                    done: false,
                    error: null,
                    resolve: ()=>{
                    // noop
                    }
                };
                const dispose = subscribe(request, {
                    next (val) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        pending.push(val);
                        deferred.resolve();
                    },
                    error (err) {
                        deferred.done = true;
                        deferred.error = err;
                        deferred.resolve();
                    },
                    complete () {
                        deferred.done = true;
                        deferred.resolve();
                    }
                });
                const iterator = function iterator() {
                    return __asyncGenerator(this, arguments, function* iterator_1() {
                        for(;;){
                            if (!pending.length) // only wait if there are no pending messages available
                            yield __await(new Promise((resolve)=>deferred.resolve = resolve));
                            // first flush
                            while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            yield yield __await(pending.shift());
                            // then error
                            if (deferred.error) throw deferred.error;
                            // or complete
                            if (deferred.done) return yield __await(void 0);
                        }
                    });
                }();
                iterator.throw = async (err)=>{
                    if (!deferred.done) {
                        deferred.done = true;
                        deferred.error = err;
                        deferred.resolve();
                    }
                    return {
                        done: true,
                        value: undefined
                    };
                };
                iterator.return = async ()=>{
                    dispose();
                    return {
                        done: true,
                        value: undefined
                    };
                };
                return iterator;
            },
            async dispose () {
                disposed = true;
                if (connecting) {
                    // if there is a connection, close it
                    const [socket] = await connecting;
                    socket.close(1000, "Normal Closure");
                }
            },
            terminate () {
                if (connecting) // only if there is a connection
                emitter.emit("closed", {
                    code: 4499,
                    reason: "Terminated",
                    wasClean: false
                });
            }
        };
    }
    function isLikeCloseEvent(val) {
        return isObject(val) && "code" in val && "reason" in val;
    }
    function isFatalInternalCloseCode(code) {
        if ([
            1000,
            1001,
            1006,
            1005,
            1012,
            1013,
            1014
        ].includes(code)) return false;
        // all other internal errors are fatal
        return code >= 1000 && code <= 1999;
    }
    function isWebSocket(val) {
        return typeof val === "function" && "constructor" in val && "CLOSED" in val && "CLOSING" in val && "CONNECTING" in val && "OPEN" in val;
    }
    exports1.DEPRECATED_GRAPHQL_WS_PROTOCOL = DEPRECATED_GRAPHQL_WS_PROTOCOL;
    exports1.GRAPHQL_TRANSPORT_WS_PROTOCOL = GRAPHQL_TRANSPORT_WS_PROTOCOL;
    exports1.createClient = createClient;
    exports1.isMessage = isMessage;
    exports1.parseMessage = parseMessage;
    exports1.stringifyMessage = stringifyMessage;
    exports1.validateMessage = validateMessage;
});

},{}],"l6ORY":[function(require,module,exports) {
/**
 * React Router DOM v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "unstable_useViewTransitionState", ()=>useViewTransitionState);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, unstable_viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, unstable_viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, unstable_viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            unstable_viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"6uln9","react-dom":"b8T3j","react-router":"kbGcH","@remix-run/router":"aNWKZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kbGcH":[function(require,module,exports) {
/**
 * React Router v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? AwaitRenderStatus.error : promise._data !== undefined ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties
    }).initialize();
}

},{"react":"6uln9","@remix-run/router":"aNWKZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aNWKZ":[function(require,module,exports) {
/**
 * @remix-run/router v1.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    safelyDecodeURI(pathname));
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        warning(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        warning(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited, loaderData, errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState(_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results, loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results, loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission, fetcherSubmission, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        invariant(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return callLoaderOrAction("loader", createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: ResultType.error,
                        error: getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results,
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        invariant(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation, nextLocation, historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if (isQueryRouteResponse(e)) {
                if (e.type === ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            result = await callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest,
                requestContext
            });
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return _extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: _extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest,
                    requestContext
                }))
        ]);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if (isResponse(result)) {
        let status = result.status;
        // Process redirects
        if (redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!ABSOLUTE_URL_REGEX.test(location)) location = normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = stripBasename(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: ResultType.redirect,
                status,
                location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === ResultType.error ? ResultType.error : ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (resultType === ResultType.error) return {
            type: resultType,
            error: new ErrorResponseImpl(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === ResultType.error) return {
        type: resultType,
        error: result
    };
    if (isDeferredData(result)) {
        var _result$init, _result$init2;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if (isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, match, controller } = revalidatingFetchers[index];
        invariant(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if (isRedirectResult(result)) return {
            result,
            idx: i
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isQueryRouteResponse(obj) {
    return obj && isResponse(obj.response) && (obj.type === ResultType.data || obj.type === ResultType.error);
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            invariant(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eUR2H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>Immer2);
parcelHelpers.export(exports, "applyPatches", ()=>applyPatches);
parcelHelpers.export(exports, "castDraft", ()=>castDraft);
parcelHelpers.export(exports, "castImmutable", ()=>castImmutable);
parcelHelpers.export(exports, "createDraft", ()=>createDraft);
parcelHelpers.export(exports, "current", ()=>current);
parcelHelpers.export(exports, "enableMapSet", ()=>enableMapSet);
parcelHelpers.export(exports, "enablePatches", ()=>enablePatches);
parcelHelpers.export(exports, "finishDraft", ()=>finishDraft);
parcelHelpers.export(exports, "freeze", ()=>freeze);
parcelHelpers.export(exports, "immerable", ()=>DRAFTABLE);
parcelHelpers.export(exports, "isDraft", ()=>isDraft);
parcelHelpers.export(exports, "isDraftable", ()=>isDraftable);
parcelHelpers.export(exports, "nothing", ()=>NOTHING);
parcelHelpers.export(exports, "original", ()=>original);
parcelHelpers.export(exports, "produce", ()=>produce);
parcelHelpers.export(exports, "produceWithPatches", ()=>produceWithPatches);
parcelHelpers.export(exports, "setAutoFreeze", ()=>setAutoFreeze);
parcelHelpers.export(exports, "setUseStrictShallowCopy", ()=>setUseStrictShallowCopy);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(([key, value])=>{
        iter(key, value, obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function getArchtype(thing) {
    const state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    const t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && isPlainObject(base)) {
        if (!getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return __spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
}
function freeze(obj, deep = false) {
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) each(obj, (_key, value)=>freeze(value, true), true);
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    const plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_,
        immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    const state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    if (!state) {
        each(value, (key, childValue)=>finalizeProperty(rootScope, state, value, key, childValue, path), true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, (key, childValue)=>finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    const { revoke, proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get (state, prop) {
        if (prop === DRAFT_STATE) return state;
        const source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys(latest(state));
    },
    set (state, prop, value) {
        const desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = peek(latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        die(11);
    },
    getPrototypeOf (state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, (key, fn)=>{
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    const state = draft[DRAFT_STATE];
    const source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    const desc = getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            let result;
            if (isDraftable(base)) {
                const scope = enterScope(this);
                const proxy = createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!isDraftable(base)) die(8);
        if (isDraft(base)) base = current(base);
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        proxy[DRAFT_STATE].isManual_ = true;
        leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[DRAFT_STATE];
        if (!state || !state.isManual_) die(9);
        const { scope_: scope } = state;
        usePatchesInScope(scope, patchListener);
        return processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = getPlugin("Patches").applyPatches_;
        if (isDraft(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function createProxy(value, parent) {
    const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, (key, childValue)=>{
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_, assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_, copy_ } = state;
        each(state.assigned_, (key, assignedValue)=>{
            const origValue = get(base_, key);
            const value = get(copy_, key);
            const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op,
                path
            } : {
                op,
                path,
                value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path
            } : op === REMOVE ? {
                op: ADD,
                path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_, copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: ADD,
                    path,
                    value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path,
                    value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path, op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            const type = getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create(getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_,
        generatePatches_,
        generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(key) {
            return latest(this[DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!latest(state).has(key) || latest(state).get(key) !== value) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[DRAFT_STATE];
            latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            const value = latest(state).get(key);
            if (state.finalized_ || !isDraftable(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return latest(this[DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if (isDraftable(value)) {
                    const draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_,
        proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kfzWb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Auth);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _recoil = require("recoil");
var _client = require("@apollo/client");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var _signInForm = require("./SignInForm");
var _signInFormDefault = parcelHelpers.interopDefault(_signInForm);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _atoms = require("./atoms");
const GET_USER = (0, _client.gql)`
	query GetUser($token: String!) {
		user(token: $token) {
			userId
			name
			email
			emailHash
			role
		}
	}`;
function Auth({ children }) {
    const [user, setUser] = (0, _recoil.useRecoilState)((0, _atoms.userAtom));
    const [getUser, { loading, data }] = (0, _client.useLazyQuery)(GET_USER, {
    });
    (0, _react.useEffect)(()=>{
        if (data?.user) {
            const token = localStorage.getItem("token");
            if (!!token) (0, _jsCookieDefault.default).set("token", token, {
                expires: 30,
                domain: ".content.catering"
            });
            setUser(data.user);
        }
    }, [
        data
    ]);
    (0, _react.useEffect)(()=>{
        const token = localStorage.getItem("token");
        if (!!token) try {
            getUser({
                variables: {
                    token
                }
            });
        } catch (e) {
            console.error(e);
        }
    }, []);
    if (!!user) return children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "AuthScreen",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signInFormDefault.default), {}),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                children: "Restoring previous session..."
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","recoil":"2QijJ","@apollo/client":"bWmmR","js-cookie":"2P5RE","./SignInForm":"7MH2R","../utils/Spinner":"lspMb","./atoms":"jppgz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2P5RE":[function(require,module,exports) {
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set,
            get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

},{}],"7MH2R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SignInForm);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _recoil = require("recoil");
var _queryStatus = require("../utils/QueryStatus");
var _queryStatusDefault = parcelHelpers.interopDefault(_queryStatus);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _atoms = require("./atoms");
const SIGN_IN = (0, _client.gql)`
	mutation SignIn($email: String!, $password: String!) {
		signIn(email: $email, password: $password) {
			user {
				userId
				name
				email
				emailHash
				role
			}
			token
		}
	}`;
function setCookie(name, value, days = 7) {
    const date = new Date();
    date.setTime(date.getTime() + days * 86400000);
    // TODO: enable SSL
    // document.cookie = `${name}=${value}${expires}; path=/; SameSite=Strict; Secure`;
    const daisyUrl = "http://pp.content.catering";
    const mainDomainAndTld = daisyUrl.match(/([a-z0-9-]+\.[a-z0-9-]+)$/i)[1];
    // console.log(mainDomainAndTld)
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; domain=.${mainDomainAndTld}; path=/;`;
}
function SignInForm() {
    const [signIn, { loading, error }] = (0, _client.useMutation)(SIGN_IN);
    const setUser = (0, _recoil.useSetRecoilState)((0, _atoms.userAtom));
    function handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData(event.target);
        const email = formData.get("email");
        const password = formData.get("password");
        handleSignIn(email, password);
    }
    async function handleSignIn(email, password) {
        try {
            const { data } = await signIn({
                variables: {
                    email,
                    password
                }
            });
            localStorage.setItem("token", data.signIn.token);
            setCookie("token", data.signIn.token, 7);
            setUser(data.signIn.user);
        } catch (error) {
            console.error(error);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "Form",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                required: true,
                                name: "email",
                                type: "email",
                                autoComplete: "username",
                                className: "Input"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                required: true,
                                name: "password",
                                type: "password",
                                className: "Input",
                                autoComplete: "current-password"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "Submit",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                className: "Primary",
                                disabled: !!loading,
                                children: "Sign in"
                            }),
                            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                                children: "Authenticating..."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _queryStatusDefault.default), {
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","recoil":"2QijJ","../utils/QueryStatus":"dSO6d","../utils/Spinner":"lspMb","./atoms":"jppgz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dSO6d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QueryStatus);
var _jsxRuntime = require("react/jsx-runtime");
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
function QueryStatus({ loading, error }) {
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: "Loading..."
    });
    if (!!error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
        error: error
    });
    return null;
} // function Error({ error }) {
 // 	return <div className='border-4 border-red-700 rounded-lg p-3 text-red-800'>
 // 		<h4 className='font-bold text-lg'>
 // 			{ error.name || "Error" }</h4>
 // 		<p className='font-semibold'>
 // 			{ error.message || <em>Unknown</em> }</p>
 // 		<details className='text-sm'>
 // 			<summary className='py-1'>
 // 				details</summary>
 // 			<pre>
 // 				{JSON.stringify(error, null, 2)}
 // 			</pre>
 // 		</details>
 // 	</div>
 // }

},{"react/jsx-runtime":"gaGEj","./Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5W3pt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Alert);
var _jsxRuntime = require("react/jsx-runtime");
function Alert({ error, sticky = false }) {
    if (!error) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
        className: `Alert ${sticky ? "isSticky" : ""}`,
        open: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("summary", {
                children: [
                    error.message || "Something went wrong.",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
                        children: [
                            "[",
                            error.name || "ERROR",
                            "]"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                children: JSON.stringify(error, null, 2)
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lspMb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Spinner);
var _jsxRuntime = require("react/jsx-runtime");
function Spinner({ children, show = true }) {
    if (typeof show === "undefined") show = true;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        role: "status",
        className: "spinner",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                className: "spinner-svg",
                viewBox: "0 0 50 50",
                xmlns: "http://www.w3.org/2000/svg",
                children: !!show && /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    className: "spinner-circle",
                    cx: "25",
                    cy: "25",
                    r: "20",
                    fill: "none",
                    strokeWidth: "4"
                })
            }),
            !!children && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: children
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jppgz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAtom", ()=>userAtom);
parcelHelpers.export(exports, "buildDateAtom", ()=>buildDateAtom);
var _recoil = require("recoil");
const userAtom = (0, _recoil.atom)({
    key: "userAtom",
    default: null
});
const buildDateAtom = (0, _recoil.atom)({
    key: "buildDateAtom",
    default: null
});

},{"recoil":"2QijJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"flxrc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Navbar);
var _jsxRuntime = require("react/jsx-runtime");
var _recoil = require("recoil");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _collections = require("./Collections");
var _collectionsDefault = parcelHelpers.interopDefault(_collections);
var _buildInfo = require("./BuildInfo");
var _buildInfoDefault = parcelHelpers.interopDefault(_buildInfo);
var _avatar = require("../users/Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _atoms = require("./atoms");
const LINKS = [
    [
        "/collections",
        "Collections",
        [
            "ADMIN",
            "EDITOR"
        ]
    ],
    [
        "/files",
        "Files",
        [
            "ADMIN",
            "EDITOR"
        ]
    ],
    [
        "/urls",
        "URLs",
        [
            "ADMIN",
            "EDITOR",
            "GUEST"
        ]
    ],
    [
        "/import",
        "Import",
        [
            "ADMIN"
        ]
    ],
    [
        "/logs",
        "Logs",
        [
            "ADMIN"
        ]
    ],
    [
        "/users",
        "Users",
        [
            "ADMIN"
        ]
    ]
];
function Navbar() {
    const user = (0, _recoil.useRecoilValue)((0, _atoms.userAtom));
    const links = (0, _react.useMemo)(()=>LINKS.filter((link)=>link[2].includes(user.role)), [
        user
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
        id: "Navbar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.NavLink), {
                to: "/",
                id: "SiteLogo",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: `${"http://cms.pp.content.catering"}/favicon.png`,
                        alt: "",
                        width: "1.5rem"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        id: "SiteName",
                        children: "PozyczkaPortal"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectionsDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.NavLink), {
                to: "/build",
                id: "BuildLink",
                children: [
                    "Build\xa0 ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildInfoDefault.default), {})
                ]
            }),
            links.map(([href, label])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                    to: href,
                    children: label
                }, href)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            !!user && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.NavLink), {
                to: "/account",
                className: "UserLink",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                        emailHash: user.emailHash
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: user.name
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","recoil":"2QijJ","react":"6uln9","react-router-dom":"l6ORY","./Collections":"fogPQ","./BuildInfo":"jc7so","../users/Avatar":"8GHf3","./atoms":"jppgz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fogPQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_COLLECTIONS", ()=>GET_COLLECTIONS);
parcelHelpers.export(exports, "default", ()=>CollectionsNav);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _reactRouterDom = require("react-router-dom");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
const GET_COLLECTIONS = (0, _client.gql)`
	query Collections {
		collections {
			collectionId
			name
			icon
		}
	}
`;
function CollectionsNav() {
    const { loading, error, data } = (0, _client.useQuery)(GET_COLLECTIONS);
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
        error: error
    });
    if (!data || loading) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: data.collections.map(({ collectionId, name, icon })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.NavLink), {
                to: `/collection/${collectionId}`,
                className: "CollectionLink",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: icon
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: name
                    })
                ]
            }, collectionId))
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","react-router-dom":"l6ORY","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jc7so":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuildInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _recoil = require("recoil");
var _timestamp = require("../utils/Timestamp");
var _timestampDefault = parcelHelpers.interopDefault(_timestamp);
var _liveDuration = require("../utils/LiveDuration");
var _liveDurationDefault = parcelHelpers.interopDefault(_liveDuration);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _atoms = require("./atoms");
const GET_BUILD = (0, _client.gql)`
	query GetBuild {
		latestBuild {
			buildId
			started
			finished
			status
		}
		latestFinishedBuild: latestBuild(status: "FINISHED") {
			buildId
			started
			finished
			status
		}
	}`;
const BUILD_SUB = (0, _client.gql)`
	subscription BuildSub {
		latestBuild {
			buildId
			started
			finished
			status
		}
	}`;
function BuildInfo() {
    const setBuildDate = (0, _recoil.useSetRecoilState)((0, _atoms.buildDateAtom));
    const { data, loading, error, subscribeToMore } = (0, _client.useQuery)(GET_BUILD);
    // const build = buildData?.latestBuild || {}
    const build = data?.latestBuild;
    const finishedBuild = data?.latestBuild?.status === "FINISHED" ? build : data?.latestFinishedBuild;
    (0, _react.useEffect)(()=>{
        subscribeToMore({
            document: BUILD_SUB,
            variables: {},
            updateQuery: (prev, { subscriptionData: { data: { latestBuild } } })=>{
                return Object.assign({}, prev, {
                    latestBuild
                });
            }
        });
    }, []);
    (0, _react.useEffect)(()=>{
        if (finishedBuild?.started) setBuildDate(new Date(finishedBuild.started));
    }, [
        finishedBuild
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: "BuildInfo",
        children: [
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            build?.status === "RUNNING" ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liveDurationDefault.default), {
                        startIso: build.started,
                        finishIso: build.finished
                    })
                ]
            }) : !!finishedBuild ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "\u2705 ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timestampDefault.default), {
                        live: true,
                        iso: finishedBuild.started
                    })
                ]
            }) : !!build ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "\u274C ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timestampDefault.default), {
                        live: true,
                        iso: build.finished
                    })
                ]
            }) : null
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","recoil":"2QijJ","../utils/Timestamp":"aW5w6","../utils/LiveDuration":"92TDG","../utils/Spinner":"lspMb","./atoms":"jppgz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aW5w6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Timestamp);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _relativeTime = require("dayjs/plugin/relativeTime");
var _relativeTimeDefault = parcelHelpers.interopDefault(_relativeTime);
var _localizedFormat = require("dayjs/plugin/localizedFormat");
var _localizedFormatDefault = parcelHelpers.interopDefault(_localizedFormat);
(0, _dayjsDefault.default).extend((0, _relativeTimeDefault.default));
(0, _dayjsDefault.default).extend((0, _localizedFormatDefault.default));
function Timestamp({ iso, live = false }) {
    const [fromNow, setFromNow] = (0, _react.useState)(()=>(0, _dayjsDefault.default)(iso).fromNow());
    const format = (0, _react.useMemo)(()=>(0, _dayjsDefault.default)(iso).format("llll"), [
        iso
    ]);
    (0, _react.useEffect)(()=>{
        if (!iso) return;
        setFromNow((0, _dayjsDefault.default)(iso).fromNow());
        if (!live) return;
        const intervalId = setInterval(()=>{
            setFromNow((0, _dayjsDefault.default)(iso).fromNow());
        }, 30000);
        return ()=>clearInterval(intervalId);
    }, [
        iso,
        live
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        "data-title": format,
        className: "timestamp tooltip",
        children: fromNow
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","dayjs":"8F3kd","dayjs/plugin/relativeTime":"hgDes","dayjs/plugin/localizedFormat":"45gkk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8F3kd":[function(require,module,exports) {
!function(t, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

},{}],"hgDes":[function(require,module,exports) {
!function(r, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

},{}],"45gkk":[function(require,module,exports) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});

},{}],"92TDG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LiveDuration);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _duration = require("dayjs/plugin/duration");
var _durationDefault = parcelHelpers.interopDefault(_duration);
var _relativeTime = require("dayjs/plugin/relativeTime");
var _relativeTimeDefault = parcelHelpers.interopDefault(_relativeTime);
(0, _dayjsDefault.default).extend((0, _durationDefault.default));
(0, _dayjsDefault.default).extend((0, _relativeTimeDefault.default));
function LiveDuration({ startIso, finishIso, format = "m[m] ss[s]" }) {
    // console.log(finishIso, startIso)
    const [formatted, setFormatted] = (0, _react.useState)(()=>{
        const finish = !finishIso ? (0, _dayjsDefault.default)() : (0, _dayjsDefault.default)(finishIso);
        const start = (0, _dayjsDefault.default)(startIso);
        return (0, _dayjsDefault.default).duration(finish.diff(start)).format(format);
    });
    (0, _react.useEffect)(()=>{
        const intervalId = setInterval(()=>{
            const finish = !finishIso ? (0, _dayjsDefault.default)() : (0, _dayjsDefault.default)(finishIso);
            const start = (0, _dayjsDefault.default)(startIso);
            setFormatted((0, _dayjsDefault.default).duration(finish.diff(start)).format(format));
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        startIso,
        finishIso
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: formatted
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","dayjs":"8F3kd","dayjs/plugin/duration":"cKu5j","dayjs/plugin/relativeTime":"hgDes","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cKu5j":[function(require,module,exports) {
!function(t, s) {
    module.exports = s();
}(this, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});

},{}],"8GHf3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Avatar);
var _jsxRuntime = require("react/jsx-runtime");
function Avatar({ emailHash, size = 64, // width = 64,
defaultImage = "identicon", className = "avatar" }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: className,
        src: `https://www.gravatar.com/avatar/${emailHash}?s=${size}&d=${defaultImage}`
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eC2FZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomePage);
var _jsxRuntime = require("react/jsx-runtime");
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
function HomePage() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
            children: "Home"
        })
    });
}

},{"react/jsx-runtime":"gaGEj","../utils/Title":"IV4kx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"IV4kx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Title);
var _react = require("react");
function Title({ children }) {
    (0, _react.useEffect)(()=>{
        document.title = `${children} | ${"PozyczkaPortal"}`;
    }, [
        children
    ]);
    return null;
}

},{"react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"20461":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuildRouter);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _tokensPage = require("./TokensPage");
var _tokensPageDefault = parcelHelpers.interopDefault(_tokensPage);
var _buildPage = require("./BuildPage");
var _buildPageDefault = parcelHelpers.interopDefault(_buildPage);
function BuildRouter() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                            to: `/build`,
                            end: true,
                            children: "Build"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                            to: `/build/tokens`,
                            end: true,
                            children: "Tokens"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Routes), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        index: true,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildPageDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/tokens",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokensPageDefault.default), {})
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","./TokensPage":"3IULR","./BuildPage":"5HoER","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3IULR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TokensPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _client = require("@apollo/client");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _relativeTime = require("dayjs/plugin/relativeTime");
var _relativeTimeDefault = parcelHelpers.interopDefault(_relativeTime);
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
(0, _dayjsDefault.default).extend((0, _relativeTimeDefault.default));
const GET_TOKENS = (0, _client.gql)`
	query Tokens {
		tokens {
			tokenId
			label
			created
			expiresIn
			token
			created
		}
	}`;
const DELETE_TOKEN = (0, _client.gql)`
	mutation DeleteToken($tokenId: ID!) {
		deleteToken(tokenId: $tokenId)
	}`;
function TokensPage() {
    const { data, loading, error } = (0, _client.useQuery)(GET_TOKENS);
    const tokens = data?.tokens || [];
    const [deleteToken] = (0, _client.useMutation)(DELETE_TOKEN, {
        refetchQueries: [
            {
                query: GET_TOKENS
            }
        ]
    });
    const handleDelete = (0, _react.useCallback)((tokenId)=>{
        deleteToken({
            variables: {
                tokenId
            }
        });
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Access Tokens"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddToken, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ItemsList",
                children: tokens.map((token)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Token, {
                        token: token,
                        handleDelete: handleDelete
                    }, token.tokenId))
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}
const ADD_TOKEN = (0, _client.gql)`
	mutation AddToken($label: String!, $expiresIn: String!) {
		addToken(label: $label, expiresIn: $expiresIn)
	}
`;
function AddToken() {
    const [addToken, { data, loading, error }] = (0, _client.useMutation)(ADD_TOKEN, {
        refetchQueries: [
            {
                query: GET_TOKENS
            }
        ]
    });
    const handleSubmit = (0, _react.useCallback)(async (event)=>{
        event.preventDefault();
        try {
            const form = new FormData(event.target);
            await addToken({
                variables: {
                    label: form.get("label"),
                    expiresIn: form.get("expiresIn")
                }
            });
            event.target.reset();
        } catch (error) {
            console.error(error);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "Form width-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Add token"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Label:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                required: true,
                                type: "text",
                                name: "label",
                                defaultValue: "",
                                placeholder: "",
                                className: "Input"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Expires in:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                required: true,
                                name: "expiresIn",
                                defaultValue: "1 year",
                                className: "Input",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        children: "1 year"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        children: "30 days"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        children: "7 days"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        children: "1 day"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "Submit",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                disabled: loading,
                                children: "Add token"
                            }),
                            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            })
        ]
    });
}
function Token({ token, handleDelete }) {
    const expiresSplit = token.expiresIn.split(" ");
    const expires = (0, _dayjsDefault.default)(token.created).add(parseInt(expiresSplit[0]), expiresSplit[1]);
    const expired = expires.isBefore();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "DeveloperToken",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "delete",
                onClick: ()=>handleDelete(token.tokenId),
                children: "Delete"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: token.label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: expired ? "danger" : "",
                        children: [
                            expired ? "Expired" : "Expires",
                            " ",
                            expires.fromNow()
                        ]
                    }),
                    " \u2014 ",
                    expires.format("D MMMM YYYY")
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                children: token.token
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","react":"6uln9","@apollo/client":"bWmmR","dayjs":"8F3kd","dayjs/plugin/relativeTime":"hgDes","../utils/Title":"IV4kx","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5HoER":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BuildPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _duration = require("dayjs/plugin/duration");
var _durationDefault = parcelHelpers.interopDefault(_duration);
var _relativeTime = require("dayjs/plugin/relativeTime");
var _relativeTimeDefault = parcelHelpers.interopDefault(_relativeTime);
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _timestamp = require("../utils/Timestamp");
var _timestampDefault = parcelHelpers.interopDefault(_timestamp);
var _liveDuration = require("../utils/LiveDuration");
var _liveDurationDefault = parcelHelpers.interopDefault(_liveDuration);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
(0, _dayjsDefault.default).extend((0, _durationDefault.default));
(0, _dayjsDefault.default).extend((0, _relativeTimeDefault.default));
const GET_BUILD = (0, _client.gql)`
	query GetBuildsInfo {
		latestFinishedBuild: latestBuild(status: "FINISHED") {
			buildId
			started
			finished
			status
		}
		latestBuild {
			buildId
			command
			started
			finished
			status
			log
		}
	}`;
const BUILD_SUB = (0, _client.gql)`
	subscription BuildSub {
		latestBuild {
			buildId
			command
			started
			finished
			status
			log
		}
	}`;
const START_BUILD = (0, _client.gql)`
	mutation StartBuild {
		startBuild
	}`;
const ABORT_BUILD = (0, _client.gql)`
	mutation AbortBuild {
		abortBuild
	}`;
const GATSBY_CLEAN = (0, _client.gql)`
	mutation GatbsyClean {
		gatsbyClean
	}`;
function BuildPage() {
    const { data: buildData, loading: buildLoading, error: buildError, subscribeToMore } = (0, _client.useQuery)(GET_BUILD);
    const [startBuild, { data: startBuildData, loading: startBuildLoading, error: startBuildError }] = (0, _client.useMutation)(START_BUILD);
    const [abortBuild, { loading: abortBuildLoading, error: abortBuildError }] = (0, _client.useMutation)(ABORT_BUILD);
    const [gatsbyClean, { loading: gatsbyCleanLoading, error: gatsbyCleanError }] = (0, _client.useMutation)(GATSBY_CLEAN);
    const build = buildData?.latestBuild;
    const latestFinishedBuild = buildData?.latestFinishedBuild;
    const handleStartBuild = (0, _react.useCallback)(async ()=>{
        try {
            const response = await startBuild();
            if (!!response?.data?.startBuild) console.log("build started");
        } catch (error) {
            console.error(error);
        }
    }, []);
    async function handleAbort() {
        try {
            await abortBuild();
            console.log("aborted");
        } catch (e) {
            console.error(e);
        }
    }
    (0, _react.useEffect)(()=>{
        subscribeToMore({
            document: BUILD_SUB,
            variables: {},
            updateQuery: (prev, { subscriptionData: { data: { latestBuild } } })=>{
                const nextVal = {
                    latestBuild
                };
                return Object.assign({}, prev, nextVal);
            }
        });
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Build"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Menu",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleStartBuild,
                        className: "primary",
                        children: build?.status === "RUNNING" ? "Building..." : "Start build"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>gatsbyClean(),
                        className: "delete small",
                        children: "gatsby clean"
                    }),
                    gatsbyCleanLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
                    build?.status === "RUNNING" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: gatsbyCleanError
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: startBuildError
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: buildError
            }),
            build?.status !== "FINISHED" && !!latestFinishedBuild && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        children: "Latest successful build"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FinishedBuild, {
                        build: latestFinishedBuild
                    })
                ]
            }),
            !!build && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "Last build"
            }),
            build?.status === "FINISHED" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FinishedBuild, {
                build: build
            }),
            build?.status === "RUNNING" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Started ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liveDurationDefault.default), {
                        startIso: build.started
                    }),
                    " ago \u2014 ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleAbort(),
                        className: "delete small",
                        children: abortBuildLoading ? "Aborting..." : "Abort"
                    })
                ]
            }),
            (build?.status === "ERRORED" || build?.status === "ABORTED" || build?.status === "KILLED") && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "\u274C ",
                    build.status,
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timestampDefault.default), {
                        live: true,
                        iso: build.finished
                    }),
                    " after ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liveDurationDefault.default), {
                        startIso: build.started,
                        finishIso: build.finished
                    }),
                    "."
                ]
            }),
            build?.status === "ABORTING" || build?.status === "KILLING" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "\u26A0\uFE0F ",
                    build.status
                ]
            }),
            !!build?.log && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "BuildLog",
                dangerouslySetInnerHTML: {
                    __html: build.log
                }
            })
        ]
    });
}
function FinishedBuild({ build }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            "\u2705 Finished ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timestampDefault.default), {
                live: true,
                iso: build.finished
            }),
            " after ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liveDurationDefault.default), {
                startIso: build.started,
                finishIso: build.finished
            }),
            " \u2014 ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                href: "http://preview.pp.content.catering",
                target: "DaisyPreview",
                children: "See preview"
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","dayjs/plugin/duration":"cKu5j","dayjs/plugin/relativeTime":"hgDes","dayjs":"8F3kd","../utils/Timestamp":"aW5w6","../utils/LiveDuration":"92TDG","../utils/Alert":"5W3pt","../utils/Title":"IV4kx","../utils/Spinner":"lspMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"evMyr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CollectionsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _client = require("@apollo/client");
var _collections = require("../layout/Collections");
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _collectionEditor = require("./CollectionEditor");
var _collectionEditorDefault = parcelHelpers.interopDefault(_collectionEditor);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _reorderCollections = require("./ReorderCollections");
var _reorderCollectionsDefault = parcelHelpers.interopDefault(_reorderCollections);
const CREATE_COLLECTION = (0, _client.gql)`
	mutation CreateCollection($values:JSON!) {
		createCollection(values:$values)
	}
`;
function CollectionsPage() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [createCollection, { loading, error }] = (0, _client.useMutation)(CREATE_COLLECTION, {
        refetchQueries: [
            {
                query: (0, _collections.GET_COLLECTIONS)
            }
        ]
    });
    async function handleCreate(values) {
        try {
            await createCollection({
                variables: {
                    values
                }
            });
            navigate(`/collection/${values.collectionId}/fields`);
        } catch (e) {
            console.error(e);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Collections"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Create a collection"
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectionEditorDefault.default), {
                collection: {},
                handleSave: handleCreate,
                withCopyFrom: true
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reorderCollectionsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","@apollo/client":"bWmmR","../layout/Collections":"fogPQ","../utils/Title":"IV4kx","./CollectionEditor":"5cxiT","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","./ReorderCollections":"daBzQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5cxiT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CollectionEditor);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _react = require("react");
var _useImmer = require("use-immer");
var _iconPicker = require("../utils/IconPicker");
var _iconPickerDefault = parcelHelpers.interopDefault(_iconPicker);
var _collections = require("../layout/Collections");
function CollectionEditor({ collection, handleSave, withCopyFrom = false }) {
    const { data } = (0, _client.useQuery)((0, _collections.GET_COLLECTIONS));
    const [draft, setDraft] = (0, _useImmer.useImmer)({
        collectionId: collection.collectionId ?? "",
        name: collection.name ?? "",
        icon: collection.icon ?? ""
    });
    const [copyFrom, setCopyFrom] = (0, _react.useState)(null);
    const [withData, setWithData] = (0, _react.useState)(false);
    function handleSubmit(event) {
        event.preventDefault();
        handleSave({
            ...draft,
            copyFrom,
            withData
        });
    }
    // const handleSubmit = useCallback(async (event) => {
    // 	event.preventDefault()
    // 	try {
    // 		setStatus("Adding collection...")
    // 		await addCollection({ variables: { 
    // 			collectionId, name, icon, typeName, 
    // 			copyFrom: copyFrom === '' ? null : copyFrom
    // 		}})
    // 		navigate(`/collection/${collectionId}/fields`)
    // 	} catch (error) { setStatus(error.toString())}
    // }, [collectionId, name, icon, typeName, copyFrom])
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "Form width-sm",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Name:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        required: true,
                        type: "text",
                        value: draft.name ?? "",
                        onChange: (e)=>setDraft((d)=>{
                                d.name = e.target.value;
                            })
                    }),
                    ' e.g. "Best Movies"'
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "ID:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        required: true,
                        type: "text",
                        value: draft.collectionId ?? "",
                        onChange: (e)=>setDraft((d)=>{
                                d.collectionId = e.target.value;
                            })
                    }),
                    ' e.g. "BestMovies"'
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Icon:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconPickerDefault.default), {
                        icon: draft.icon ?? "",
                        onPick: (icon)=>setDraft((d)=>{
                                d.icon = icon;
                            })
                    })
                ]
            }),
            !!withCopyFrom && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                            children: "Copy from:"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                            value: copyFrom ?? "",
                            onChange: (e)=>setCopyFrom(e.target.value),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: ""
                                }),
                                data?.collections.map(({ collectionId, icon, name })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                                        value: collectionId,
                                        children: [
                                            icon,
                                            " ",
                                            name
                                        ]
                                    }, collectionId))
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    checked: withData,
                                    onChange: (e)=>setWithData(e.target.checked)
                                }),
                                " with entries"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "submit",
                className: "primary",
                children: "Save"
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","react":"6uln9","use-immer":"cnEe2","../utils/IconPicker":"cy32z","../layout/Collections":"fogPQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cnEe2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useImmer", ()=>i);
parcelHelpers.export(exports, "useImmerReducer", ()=>e);
var _immer = require("immer");
var _react = require("react");
function i(f) {
    var u = (0, _react.useState)(function() {
        return (0, _immer.freeze)("function" == typeof f ? f() : f, !0);
    }), i = u[1];
    return [
        u[0],
        (0, _react.useCallback)(function(t) {
            i("function" == typeof t ? (0, _immer.produce)(t) : (0, _immer.freeze)(t));
        }, [])
    ];
}
function e(n, t, o) {
    var i = (0, _react.useMemo)(function() {
        return (0, _immer.produce)(n);
    }, [
        n
    ]);
    return (0, _react.useReducer)(i, t, o);
}

},{"immer":"eUR2H","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cy32z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IconPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _emojiPickerReact = require("emoji-picker-react");
var _emojiPickerReactDefault = parcelHelpers.interopDefault(_emojiPickerReact);
function IconPicker({ icon, onPick, forceShowPicker = false }) {
    const [showPicker, setShowPicker] = (0, _react.useState)(forceShowPicker);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            showPicker && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emojiPickerReactDefault.default), {
                    width: "20em",
                    height: "30em",
                    emojiStyle: "native",
                    lazyLoadEmojis: true,
                    skinTonePickerLocation: "PREVIEW",
                    onEmojiClick: (emoji)=>{
                        setShowPicker(false);
                        onPick(emoji.emoji);
                    }
                })
            }),
            !forceShowPicker && showPicker && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: (e)=>{
                    e.preventDefault();
                    setShowPicker(false);
                },
                type: "button",
                className: "Button",
                children: "Close"
            }),
            icon && !forceShowPicker && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>setShowPicker(true),
                type: "button",
                className: "Button",
                children: icon
            }),
            !icon && !forceShowPicker && !showPicker && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: (e)=>{
                    e.preventDefault();
                    setShowPicker(true);
                },
                type: "button",
                className: "Button",
                children: "Choose icon"
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","emoji-picker-react":"4s16w","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4s16w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Categories", ()=>Categories);
parcelHelpers.export(exports, "Emoji", ()=>ExportedEmoji);
parcelHelpers.export(exports, "EmojiStyle", ()=>EmojiStyle);
parcelHelpers.export(exports, "SkinTonePickerLocation", ()=>SkinTonePickerLocation);
parcelHelpers.export(exports, "SkinTones", ()=>SkinTones);
parcelHelpers.export(exports, "SuggestionMode", ()=>SuggestionMode);
parcelHelpers.export(exports, "Theme", ()=>Theme);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _flairup = require("flairup");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var ClassNames;
(function(ClassNames) {
    ClassNames["hiddenOnSearch"] = "epr-hidden-on-search";
    ClassNames["searchActive"] = "epr-search-active";
    ClassNames["hidden"] = "epr-hidden";
    ClassNames["visible"] = "epr-visible";
    ClassNames["active"] = "epr-active";
    ClassNames["emoji"] = "epr-emoji";
    ClassNames["category"] = "epr-emoji-category";
    ClassNames["label"] = "epr-emoji-category-label";
    ClassNames["categoryContent"] = "epr-emoji-category-content";
    ClassNames["emojiHasVariations"] = "epr-emoji-has-variations";
    ClassNames["scrollBody"] = "epr-body";
    ClassNames["emojiList"] = "epr-emoji-list";
    ClassNames["external"] = "__EmojiPicker__";
    ClassNames["emojiPicker"] = "EmojiPickerReact";
    ClassNames["open"] = "epr-open";
    ClassNames["vertical"] = "epr-vertical";
    ClassNames["horizontal"] = "epr-horizontal";
    ClassNames["variationPicker"] = "epr-emoji-variation-picker";
    ClassNames["darkTheme"] = "epr-dark-theme";
    ClassNames["autoTheme"] = "epr-auto-theme";
})(ClassNames || (ClassNames = {}));
function asSelectors() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.map(function(c) {
        return "." + c;
    }).join("");
}
var stylesheet = /*#__PURE__*/ (0, _flairup.createSheet)("epr", null);
var hidden = {
    display: "none",
    opacity: "0",
    pointerEvents: "none",
    visibility: "hidden",
    overflow: "hidden"
};
var commonStyles = /*#__PURE__*/ stylesheet.create({
    hidden: /*#__PURE__*/ _extends({
        ".": ClassNames.hidden
    }, hidden)
});
var PickerStyleTag = /*#__PURE__*/ (0, _react.memo)(function PickerStyleTag() {
    return (0, _react.createElement)("style", {
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: stylesheet.getStyle()
        }
    });
});
var commonInteractionStyles = /*#__PURE__*/ stylesheet.create({
    ".epr-main": {
        ":has(input:not(:placeholder-shown))": {
            categoryBtn: {
                ":hover": {
                    opacity: "1",
                    backgroundPositionY: "var(--epr-category-navigation-button-size)"
                }
            },
            hiddenOnSearch: /*#__PURE__*/ _extends({
                ".": ClassNames.hiddenOnSearch
            }, hidden)
        },
        ":has(input(:placeholder-shown))": {
            visibleOnSearchOnly: hidden
        }
    },
    hiddenOnReactions: {
        transition: "all 0.5s ease-in-out"
    },
    ".epr-reactions": {
        hiddenOnReactions: {
            height: "0px",
            width: "0px",
            opacity: "0",
            pointerEvents: "none",
            overflow: "hidden"
        }
    },
    ".EmojiPickerReact:not(.epr-search-active)": {
        categoryBtn: {
            ":hover": {
                opacity: "1",
                backgroundPositionY: "var(--epr-category-navigation-button-size)"
            },
            // @ts-ignore
            "&.epr-active": {
                opacity: "1",
                backgroundPositionY: "var(--epr-category-navigation-button-size)"
            }
        },
        visibleOnSearchOnly: /*#__PURE__*/ _extends({
            ".": "epr-visible-on-search-only"
        }, hidden)
    }
});
function darkMode(key, value) {
    var _eprDarkTheme, _eprAutoTheme;
    return {
        ".epr-dark-theme": (_eprDarkTheme = {}, _eprDarkTheme[key] = value, _eprDarkTheme),
        ".epr-auto-theme": (_eprAutoTheme = {}, _eprAutoTheme[key] = {
            "@media (prefers-color-scheme: dark)": value
        }, _eprAutoTheme)
    };
}
var DEFAULT_REACTIONS = [
    "1f44d",
    "2764-fe0f",
    "1f603",
    "1f622",
    "1f64f",
    "1f44e",
    "1f621" // 😡
];
var SuggestionMode;
(function(SuggestionMode) {
    SuggestionMode["RECENT"] = "recent";
    SuggestionMode["FREQUENT"] = "frequent";
})(SuggestionMode || (SuggestionMode = {}));
var EmojiStyle;
(function(EmojiStyle) {
    EmojiStyle["NATIVE"] = "native";
    EmojiStyle["APPLE"] = "apple";
    EmojiStyle["TWITTER"] = "twitter";
    EmojiStyle["GOOGLE"] = "google";
    EmojiStyle["FACEBOOK"] = "facebook";
})(EmojiStyle || (EmojiStyle = {}));
var Theme;
(function(Theme) {
    Theme["DARK"] = "dark";
    Theme["LIGHT"] = "light";
    Theme["AUTO"] = "auto";
})(Theme || (Theme = {}));
var SkinTones;
(function(SkinTones) {
    SkinTones["NEUTRAL"] = "neutral";
    SkinTones["LIGHT"] = "1f3fb";
    SkinTones["MEDIUM_LIGHT"] = "1f3fc";
    SkinTones["MEDIUM"] = "1f3fd";
    SkinTones["MEDIUM_DARK"] = "1f3fe";
    SkinTones["DARK"] = "1f3ff";
})(SkinTones || (SkinTones = {}));
var Categories;
(function(Categories) {
    Categories["SUGGESTED"] = "suggested";
    Categories["CUSTOM"] = "custom";
    Categories["SMILEYS_PEOPLE"] = "smileys_people";
    Categories["ANIMALS_NATURE"] = "animals_nature";
    Categories["FOOD_DRINK"] = "food_drink";
    Categories["TRAVEL_PLACES"] = "travel_places";
    Categories["ACTIVITIES"] = "activities";
    Categories["OBJECTS"] = "objects";
    Categories["SYMBOLS"] = "symbols";
    Categories["FLAGS"] = "flags";
})(Categories || (Categories = {}));
var SkinTonePickerLocation;
(function(SkinTonePickerLocation) {
    SkinTonePickerLocation["SEARCH"] = "SEARCH";
    SkinTonePickerLocation["PREVIEW"] = "PREVIEW";
})(SkinTonePickerLocation || (SkinTonePickerLocation = {}));
var _configByCategory;
var categoriesOrdered = [
    Categories.SUGGESTED,
    Categories.CUSTOM,
    Categories.SMILEYS_PEOPLE,
    Categories.ANIMALS_NATURE,
    Categories.FOOD_DRINK,
    Categories.TRAVEL_PLACES,
    Categories.ACTIVITIES,
    Categories.OBJECTS,
    Categories.SYMBOLS,
    Categories.FLAGS
];
var SuggestedRecent = {
    name: "Recently Used",
    category: Categories.SUGGESTED
};
var configByCategory = (_configByCategory = {}, _configByCategory[Categories.SUGGESTED] = {
    category: Categories.SUGGESTED,
    name: "Frequently Used"
}, _configByCategory[Categories.CUSTOM] = {
    category: Categories.CUSTOM,
    name: "Custom Emojis"
}, _configByCategory[Categories.SMILEYS_PEOPLE] = {
    category: Categories.SMILEYS_PEOPLE,
    name: "Smileys & People"
}, _configByCategory[Categories.ANIMALS_NATURE] = {
    category: Categories.ANIMALS_NATURE,
    name: "Animals & Nature"
}, _configByCategory[Categories.FOOD_DRINK] = {
    category: Categories.FOOD_DRINK,
    name: "Food & Drink"
}, _configByCategory[Categories.TRAVEL_PLACES] = {
    category: Categories.TRAVEL_PLACES,
    name: "Travel & Places"
}, _configByCategory[Categories.ACTIVITIES] = {
    category: Categories.ACTIVITIES,
    name: "Activities"
}, _configByCategory[Categories.OBJECTS] = {
    category: Categories.OBJECTS,
    name: "Objects"
}, _configByCategory[Categories.SYMBOLS] = {
    category: Categories.SYMBOLS,
    name: "Symbols"
}, _configByCategory[Categories.FLAGS] = {
    category: Categories.FLAGS,
    name: "Flags"
}, _configByCategory);
function baseCategoriesConfig(modifiers) {
    return categoriesOrdered.map(function(category) {
        return _extends({}, configByCategory[category], modifiers && modifiers[category] && modifiers[category]);
    });
}
function categoryFromCategoryConfig(category) {
    return category.category;
}
function categoryNameFromCategoryConfig(category) {
    return category.name;
}
function mergeCategoriesConfig(userCategoriesConfig, modifiers) {
    var _userCategoriesConfig;
    if (userCategoriesConfig === void 0) userCategoriesConfig = [];
    if (modifiers === void 0) modifiers = {};
    var extra = {};
    if (modifiers.suggestionMode === SuggestionMode.RECENT) extra[Categories.SUGGESTED] = SuggestedRecent;
    var base = baseCategoriesConfig(extra);
    if (!((_userCategoriesConfig = userCategoriesConfig) != null && _userCategoriesConfig.length)) return base;
    return userCategoriesConfig.map(function(category) {
        if (typeof category === "string") return getBaseConfigByCategory(category, extra[category]);
        return _extends({}, getBaseConfigByCategory(category.category, extra[category.category]), category);
    });
}
function getBaseConfigByCategory(category, modifier) {
    if (modifier === void 0) modifier = {};
    return Object.assign(configByCategory[category], modifier);
}
var CDN_URL_APPLE = "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/";
var CDN_URL_FACEBOOK = "https://cdn.jsdelivr.net/npm/emoji-datasource-facebook/img/facebook/64/";
var CDN_URL_TWITTER = "https://cdn.jsdelivr.net/npm/emoji-datasource-twitter/img/twitter/64/";
var CDN_URL_GOOGLE = "https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/";
function cdnUrl(emojiStyle) {
    switch(emojiStyle){
        case EmojiStyle.TWITTER:
            return CDN_URL_TWITTER;
        case EmojiStyle.GOOGLE:
            return CDN_URL_GOOGLE;
        case EmojiStyle.FACEBOOK:
            return CDN_URL_FACEBOOK;
        case EmojiStyle.APPLE:
        default:
            return CDN_URL_APPLE;
    }
}
var custom = [];
var smileys_people = [
    {
        n: [
            "grinning",
            "grinning face"
        ],
        u: "1f600",
        a: "1.0"
    },
    {
        n: [
            "smiley",
            "smiling face with open mouth"
        ],
        u: "1f603",
        a: "0.6"
    },
    {
        n: [
            "smile",
            "smiling face with open mouth and smiling eyes"
        ],
        u: "1f604",
        a: "0.6"
    },
    {
        n: [
            "grin",
            "grinning face with smiling eyes"
        ],
        u: "1f601",
        a: "0.6"
    },
    {
        n: [
            "laughing",
            "satisfied",
            "smiling face with open mouth and tightly-closed eyes"
        ],
        u: "1f606",
        a: "0.6"
    },
    {
        n: [
            "sweat smile",
            "smiling face with open mouth and cold sweat"
        ],
        u: "1f605",
        a: "0.6"
    },
    {
        n: [
            "rolling on the floor laughing"
        ],
        u: "1f923",
        a: "3.0"
    },
    {
        n: [
            "joy",
            "face with tears of joy"
        ],
        u: "1f602",
        a: "0.6"
    },
    {
        n: [
            "slightly smiling face"
        ],
        u: "1f642",
        a: "1.0"
    },
    {
        n: [
            "upside-down face",
            "upside down face"
        ],
        u: "1f643",
        a: "1.0"
    },
    {
        n: [
            "melting face"
        ],
        u: "1fae0",
        a: "14.0"
    },
    {
        n: [
            "wink",
            "winking face"
        ],
        u: "1f609",
        a: "0.6"
    },
    {
        n: [
            "blush",
            "smiling face with smiling eyes"
        ],
        u: "1f60a",
        a: "0.6"
    },
    {
        n: [
            "innocent",
            "smiling face with halo"
        ],
        u: "1f607",
        a: "1.0"
    },
    {
        n: [
            "smiling face with 3 hearts",
            "smiling face with smiling eyes and three hearts"
        ],
        u: "1f970",
        a: "11.0"
    },
    {
        n: [
            "heart eyes",
            "smiling face with heart-shaped eyes"
        ],
        u: "1f60d",
        a: "0.6"
    },
    {
        n: [
            "star-struck",
            "grinning face with star eyes"
        ],
        u: "1f929",
        a: "5.0"
    },
    {
        n: [
            "kissing heart",
            "face throwing a kiss"
        ],
        u: "1f618",
        a: "0.6"
    },
    {
        n: [
            "kissing",
            "kissing face"
        ],
        u: "1f617",
        a: "1.0"
    },
    {
        n: [
            "relaxed",
            "white smiling face"
        ],
        u: "263a-fe0f",
        a: "0.6"
    },
    {
        n: [
            "kissing closed eyes",
            "kissing face with closed eyes"
        ],
        u: "1f61a",
        a: "0.6"
    },
    {
        n: [
            "kissing smiling eyes",
            "kissing face with smiling eyes"
        ],
        u: "1f619",
        a: "1.0"
    },
    {
        n: [
            "smiling face with tear"
        ],
        u: "1f972",
        a: "13.0"
    },
    {
        n: [
            "yum",
            "face savouring delicious food"
        ],
        u: "1f60b",
        a: "0.6"
    },
    {
        n: [
            "stuck out tongue",
            "face with stuck-out tongue"
        ],
        u: "1f61b",
        a: "1.0"
    },
    {
        n: [
            "stuck out tongue winking eye",
            "face with stuck-out tongue and winking eye"
        ],
        u: "1f61c",
        a: "0.6"
    },
    {
        n: [
            "zany face",
            "grinning face with one large and one small eye"
        ],
        u: "1f92a",
        a: "5.0"
    },
    {
        n: [
            "stuck out tongue closed eyes",
            "face with stuck-out tongue and tightly-closed eyes"
        ],
        u: "1f61d",
        a: "0.6"
    },
    {
        n: [
            "money-mouth face",
            "money mouth face"
        ],
        u: "1f911",
        a: "1.0"
    },
    {
        n: [
            "hugging face"
        ],
        u: "1f917",
        a: "1.0"
    },
    {
        n: [
            "face with hand over mouth",
            "smiling face with smiling eyes and hand covering mouth"
        ],
        u: "1f92d",
        a: "5.0"
    },
    {
        n: [
            "face with open eyes and hand over mouth"
        ],
        u: "1fae2",
        a: "14.0"
    },
    {
        n: [
            "face with peeking eye"
        ],
        u: "1fae3",
        a: "14.0"
    },
    {
        n: [
            "shushing face",
            "face with finger covering closed lips"
        ],
        u: "1f92b",
        a: "5.0"
    },
    {
        n: [
            "thinking face"
        ],
        u: "1f914",
        a: "1.0"
    },
    {
        n: [
            "saluting face"
        ],
        u: "1fae1",
        a: "14.0"
    },
    {
        n: [
            "zipper-mouth face",
            "zipper mouth face"
        ],
        u: "1f910",
        a: "1.0"
    },
    {
        n: [
            "face with raised eyebrow",
            "face with one eyebrow raised"
        ],
        u: "1f928",
        a: "5.0"
    },
    {
        n: [
            "neutral face"
        ],
        u: "1f610",
        a: "0.7"
    },
    {
        n: [
            "expressionless",
            "expressionless face"
        ],
        u: "1f611",
        a: "1.0"
    },
    {
        n: [
            "no mouth",
            "face without mouth"
        ],
        u: "1f636",
        a: "1.0"
    },
    {
        n: [
            "dotted line face"
        ],
        u: "1fae5",
        a: "14.0"
    },
    {
        n: [
            "face in clouds"
        ],
        u: "1f636-200d-1f32b-fe0f",
        a: "13.1"
    },
    {
        n: [
            "smirk",
            "smirking face"
        ],
        u: "1f60f",
        a: "0.6"
    },
    {
        n: [
            "unamused",
            "unamused face"
        ],
        u: "1f612",
        a: "0.6"
    },
    {
        n: [
            "face with rolling eyes"
        ],
        u: "1f644",
        a: "1.0"
    },
    {
        n: [
            "grimacing",
            "grimacing face"
        ],
        u: "1f62c",
        a: "1.0"
    },
    {
        n: [
            "face exhaling"
        ],
        u: "1f62e-200d-1f4a8",
        a: "13.1"
    },
    {
        n: [
            "lying face"
        ],
        u: "1f925",
        a: "3.0"
    },
    {
        n: [
            "relieved",
            "relieved face"
        ],
        u: "1f60c",
        a: "0.6"
    },
    {
        n: [
            "pensive",
            "pensive face"
        ],
        u: "1f614",
        a: "0.6"
    },
    {
        n: [
            "sleepy",
            "sleepy face"
        ],
        u: "1f62a",
        a: "0.6"
    },
    {
        n: [
            "drooling face"
        ],
        u: "1f924",
        a: "3.0"
    },
    {
        n: [
            "sleeping",
            "sleeping face"
        ],
        u: "1f634",
        a: "1.0"
    },
    {
        n: [
            "mask",
            "face with medical mask"
        ],
        u: "1f637",
        a: "0.6"
    },
    {
        n: [
            "face with thermometer"
        ],
        u: "1f912",
        a: "1.0"
    },
    {
        n: [
            "face with head-bandage",
            "face with head bandage"
        ],
        u: "1f915",
        a: "1.0"
    },
    {
        n: [
            "nauseated face"
        ],
        u: "1f922",
        a: "3.0"
    },
    {
        n: [
            "face vomiting",
            "face with open mouth vomiting"
        ],
        u: "1f92e",
        a: "5.0"
    },
    {
        n: [
            "sneezing face"
        ],
        u: "1f927",
        a: "3.0"
    },
    {
        n: [
            "hot face",
            "overheated face"
        ],
        u: "1f975",
        a: "11.0"
    },
    {
        n: [
            "cold face",
            "freezing face"
        ],
        u: "1f976",
        a: "11.0"
    },
    {
        n: [
            "woozy face",
            "face with uneven eyes and wavy mouth"
        ],
        u: "1f974",
        a: "11.0"
    },
    {
        n: [
            "dizzy face"
        ],
        u: "1f635",
        a: "0.6"
    },
    {
        n: [
            "face with spiral eyes"
        ],
        u: "1f635-200d-1f4ab",
        a: "13.1"
    },
    {
        n: [
            "exploding head",
            "shocked face with exploding head"
        ],
        u: "1f92f",
        a: "5.0"
    },
    {
        n: [
            "face with cowboy hat"
        ],
        u: "1f920",
        a: "3.0"
    },
    {
        n: [
            "partying face",
            "face with party horn and party hat"
        ],
        u: "1f973",
        a: "11.0"
    },
    {
        n: [
            "disguised face"
        ],
        u: "1f978",
        a: "13.0"
    },
    {
        n: [
            "sunglasses",
            "smiling face with sunglasses"
        ],
        u: "1f60e",
        a: "1.0"
    },
    {
        n: [
            "nerd face"
        ],
        u: "1f913",
        a: "1.0"
    },
    {
        n: [
            "face with monocle"
        ],
        u: "1f9d0",
        a: "5.0"
    },
    {
        n: [
            "confused",
            "confused face"
        ],
        u: "1f615",
        a: "1.0"
    },
    {
        n: [
            "face with diagonal mouth"
        ],
        u: "1fae4",
        a: "14.0"
    },
    {
        n: [
            "worried",
            "worried face"
        ],
        u: "1f61f",
        a: "1.0"
    },
    {
        n: [
            "slightly frowning face"
        ],
        u: "1f641",
        a: "1.0"
    },
    {
        n: [
            "frowning face",
            "white frowning face"
        ],
        u: "2639-fe0f",
        a: "0.7"
    },
    {
        n: [
            "open mouth",
            "face with open mouth"
        ],
        u: "1f62e",
        a: "1.0"
    },
    {
        n: [
            "hushed",
            "hushed face"
        ],
        u: "1f62f",
        a: "1.0"
    },
    {
        n: [
            "astonished",
            "astonished face"
        ],
        u: "1f632",
        a: "0.6"
    },
    {
        n: [
            "flushed",
            "flushed face"
        ],
        u: "1f633",
        a: "0.6"
    },
    {
        n: [
            "pleading face",
            "face with pleading eyes"
        ],
        u: "1f97a",
        a: "11.0"
    },
    {
        n: [
            "face holding back tears"
        ],
        u: "1f979",
        a: "14.0"
    },
    {
        n: [
            "frowning",
            "frowning face with open mouth"
        ],
        u: "1f626",
        a: "1.0"
    },
    {
        n: [
            "anguished",
            "anguished face"
        ],
        u: "1f627",
        a: "1.0"
    },
    {
        n: [
            "fearful",
            "fearful face"
        ],
        u: "1f628",
        a: "0.6"
    },
    {
        n: [
            "cold sweat",
            "face with open mouth and cold sweat"
        ],
        u: "1f630",
        a: "0.6"
    },
    {
        n: [
            "disappointed relieved",
            "disappointed but relieved face"
        ],
        u: "1f625",
        a: "0.6"
    },
    {
        n: [
            "cry",
            "crying face"
        ],
        u: "1f622",
        a: "0.6"
    },
    {
        n: [
            "sob",
            "loudly crying face"
        ],
        u: "1f62d",
        a: "0.6"
    },
    {
        n: [
            "scream",
            "face screaming in fear"
        ],
        u: "1f631",
        a: "0.6"
    },
    {
        n: [
            "confounded",
            "confounded face"
        ],
        u: "1f616",
        a: "0.6"
    },
    {
        n: [
            "persevere",
            "persevering face"
        ],
        u: "1f623",
        a: "0.6"
    },
    {
        n: [
            "disappointed",
            "disappointed face"
        ],
        u: "1f61e",
        a: "0.6"
    },
    {
        n: [
            "sweat",
            "face with cold sweat"
        ],
        u: "1f613",
        a: "0.6"
    },
    {
        n: [
            "weary",
            "weary face"
        ],
        u: "1f629",
        a: "0.6"
    },
    {
        n: [
            "tired face"
        ],
        u: "1f62b",
        a: "0.6"
    },
    {
        n: [
            "yawning face"
        ],
        u: "1f971",
        a: "12.0"
    },
    {
        n: [
            "triumph",
            "face with look of triumph"
        ],
        u: "1f624",
        a: "0.6"
    },
    {
        n: [
            "rage",
            "pouting face"
        ],
        u: "1f621",
        a: "0.6"
    },
    {
        n: [
            "angry",
            "angry face"
        ],
        u: "1f620",
        a: "0.6"
    },
    {
        n: [
            "face with symbols on mouth",
            "serious face with symbols covering mouth"
        ],
        u: "1f92c",
        a: "5.0"
    },
    {
        n: [
            "smiling imp",
            "smiling face with horns"
        ],
        u: "1f608",
        a: "1.0"
    },
    {
        n: [
            "imp"
        ],
        u: "1f47f",
        a: "0.6"
    },
    {
        n: [
            "skull"
        ],
        u: "1f480",
        a: "0.6"
    },
    {
        n: [
            "skull and crossbones"
        ],
        u: "2620-fe0f",
        a: "1.0"
    },
    {
        n: [
            "poop",
            "shit",
            "hankey",
            "pile of poo"
        ],
        u: "1f4a9",
        a: "0.6"
    },
    {
        n: [
            "clown face"
        ],
        u: "1f921",
        a: "3.0"
    },
    {
        n: [
            "japanese ogre"
        ],
        u: "1f479",
        a: "0.6"
    },
    {
        n: [
            "japanese goblin"
        ],
        u: "1f47a",
        a: "0.6"
    },
    {
        n: [
            "ghost"
        ],
        u: "1f47b",
        a: "0.6"
    },
    {
        n: [
            "alien",
            "extraterrestrial alien"
        ],
        u: "1f47d",
        a: "0.6"
    },
    {
        n: [
            "alien monster",
            "space invader"
        ],
        u: "1f47e",
        a: "0.6"
    },
    {
        n: [
            "robot face"
        ],
        u: "1f916",
        a: "1.0"
    },
    {
        n: [
            "smiley cat",
            "smiling cat face with open mouth"
        ],
        u: "1f63a",
        a: "0.6"
    },
    {
        n: [
            "smile cat",
            "grinning cat face with smiling eyes"
        ],
        u: "1f638",
        a: "0.6"
    },
    {
        n: [
            "joy cat",
            "cat face with tears of joy"
        ],
        u: "1f639",
        a: "0.6"
    },
    {
        n: [
            "heart eyes cat",
            "smiling cat face with heart-shaped eyes"
        ],
        u: "1f63b",
        a: "0.6"
    },
    {
        n: [
            "smirk cat",
            "cat face with wry smile"
        ],
        u: "1f63c",
        a: "0.6"
    },
    {
        n: [
            "kissing cat",
            "kissing cat face with closed eyes"
        ],
        u: "1f63d",
        a: "0.6"
    },
    {
        n: [
            "scream cat",
            "weary cat face"
        ],
        u: "1f640",
        a: "0.6"
    },
    {
        n: [
            "crying cat face"
        ],
        u: "1f63f",
        a: "0.6"
    },
    {
        n: [
            "pouting cat",
            "pouting cat face"
        ],
        u: "1f63e",
        a: "0.6"
    },
    {
        n: [
            "see no evil",
            "see-no-evil monkey"
        ],
        u: "1f648",
        a: "0.6"
    },
    {
        n: [
            "hear no evil",
            "hear-no-evil monkey"
        ],
        u: "1f649",
        a: "0.6"
    },
    {
        n: [
            "speak no evil",
            "speak-no-evil monkey"
        ],
        u: "1f64a",
        a: "0.6"
    },
    {
        n: [
            "kiss",
            "kiss mark"
        ],
        u: "1f48b",
        a: "0.6"
    },
    {
        n: [
            "love letter"
        ],
        u: "1f48c",
        a: "0.6"
    },
    {
        n: [
            "cupid",
            "heart with arrow"
        ],
        u: "1f498",
        a: "0.6"
    },
    {
        n: [
            "gift heart",
            "heart with ribbon"
        ],
        u: "1f49d",
        a: "0.6"
    },
    {
        n: [
            "sparkling heart"
        ],
        u: "1f496",
        a: "0.6"
    },
    {
        n: [
            "heartpulse",
            "growing heart"
        ],
        u: "1f497",
        a: "0.6"
    },
    {
        n: [
            "heartbeat",
            "beating heart"
        ],
        u: "1f493",
        a: "0.6"
    },
    {
        n: [
            "revolving hearts"
        ],
        u: "1f49e",
        a: "0.6"
    },
    {
        n: [
            "two hearts"
        ],
        u: "1f495",
        a: "0.6"
    },
    {
        n: [
            "heart decoration"
        ],
        u: "1f49f",
        a: "0.6"
    },
    {
        n: [
            "heart exclamation",
            "heavy heart exclamation mark ornament"
        ],
        u: "2763-fe0f",
        a: "1.0"
    },
    {
        n: [
            "broken heart"
        ],
        u: "1f494",
        a: "0.6"
    },
    {
        n: [
            "heart on fire"
        ],
        u: "2764-fe0f-200d-1f525",
        a: "13.1"
    },
    {
        n: [
            "mending heart"
        ],
        u: "2764-fe0f-200d-1fa79",
        a: "13.1"
    },
    {
        n: [
            "heart",
            "heavy black heart"
        ],
        u: "2764-fe0f",
        a: "0.6"
    },
    {
        n: [
            "orange heart"
        ],
        u: "1f9e1",
        a: "5.0"
    },
    {
        n: [
            "yellow heart"
        ],
        u: "1f49b",
        a: "0.6"
    },
    {
        n: [
            "green heart"
        ],
        u: "1f49a",
        a: "0.6"
    },
    {
        n: [
            "blue heart"
        ],
        u: "1f499",
        a: "0.6"
    },
    {
        n: [
            "purple heart"
        ],
        u: "1f49c",
        a: "0.6"
    },
    {
        n: [
            "brown heart"
        ],
        u: "1f90e",
        a: "12.0"
    },
    {
        n: [
            "black heart"
        ],
        u: "1f5a4",
        a: "3.0"
    },
    {
        n: [
            "white heart"
        ],
        u: "1f90d",
        a: "12.0"
    },
    {
        n: [
            "100",
            "hundred points symbol"
        ],
        u: "1f4af",
        a: "0.6"
    },
    {
        n: [
            "anger",
            "anger symbol"
        ],
        u: "1f4a2",
        a: "0.6"
    },
    {
        n: [
            "boom",
            "collision",
            "collision symbol"
        ],
        u: "1f4a5",
        a: "0.6"
    },
    {
        n: [
            "dizzy",
            "dizzy symbol"
        ],
        u: "1f4ab",
        a: "0.6"
    },
    {
        n: [
            "sweat drops",
            "splashing sweat symbol"
        ],
        u: "1f4a6",
        a: "0.6"
    },
    {
        n: [
            "dash",
            "dash symbol"
        ],
        u: "1f4a8",
        a: "0.6"
    },
    {
        n: [
            "hole"
        ],
        u: "1f573-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bomb"
        ],
        u: "1f4a3",
        a: "0.6"
    },
    {
        n: [
            "speech balloon"
        ],
        u: "1f4ac",
        a: "0.6"
    },
    {
        n: [
            "eye in speech bubble",
            "eye-in-speech-bubble"
        ],
        u: "1f441-fe0f-200d-1f5e8-fe0f",
        a: "2.0"
    },
    {
        n: [
            "left speech bubble"
        ],
        u: "1f5e8-fe0f",
        a: "2.0"
    },
    {
        n: [
            "right anger bubble"
        ],
        u: "1f5ef-fe0f",
        a: "0.7"
    },
    {
        n: [
            "thought balloon"
        ],
        u: "1f4ad",
        a: "1.0"
    },
    {
        n: [
            "zzz",
            "sleeping symbol"
        ],
        u: "1f4a4",
        a: "0.6"
    },
    {
        n: [
            "wave",
            "waving hand sign"
        ],
        u: "1f44b",
        v: [
            "1f44b-1f3fb",
            "1f44b-1f3fc",
            "1f44b-1f3fd",
            "1f44b-1f3fe",
            "1f44b-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "raised back of hand"
        ],
        u: "1f91a",
        v: [
            "1f91a-1f3fb",
            "1f91a-1f3fc",
            "1f91a-1f3fd",
            "1f91a-1f3fe",
            "1f91a-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "hand with fingers splayed",
            "raised hand with fingers splayed"
        ],
        u: "1f590-fe0f",
        v: [
            "1f590-1f3fb",
            "1f590-1f3fc",
            "1f590-1f3fd",
            "1f590-1f3fe",
            "1f590-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "hand",
            "raised hand"
        ],
        u: "270b",
        v: [
            "270b-1f3fb",
            "270b-1f3fc",
            "270b-1f3fd",
            "270b-1f3fe",
            "270b-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "spock-hand",
            "raised hand with part between middle and ring fingers"
        ],
        u: "1f596",
        v: [
            "1f596-1f3fb",
            "1f596-1f3fc",
            "1f596-1f3fd",
            "1f596-1f3fe",
            "1f596-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "rightwards hand"
        ],
        u: "1faf1",
        v: [
            "1faf1-1f3fb",
            "1faf1-1f3fc",
            "1faf1-1f3fd",
            "1faf1-1f3fe",
            "1faf1-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "leftwards hand"
        ],
        u: "1faf2",
        v: [
            "1faf2-1f3fb",
            "1faf2-1f3fc",
            "1faf2-1f3fd",
            "1faf2-1f3fe",
            "1faf2-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "palm down hand"
        ],
        u: "1faf3",
        v: [
            "1faf3-1f3fb",
            "1faf3-1f3fc",
            "1faf3-1f3fd",
            "1faf3-1f3fe",
            "1faf3-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "palm up hand"
        ],
        u: "1faf4",
        v: [
            "1faf4-1f3fb",
            "1faf4-1f3fc",
            "1faf4-1f3fd",
            "1faf4-1f3fe",
            "1faf4-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "ok hand",
            "ok hand sign"
        ],
        u: "1f44c",
        v: [
            "1f44c-1f3fb",
            "1f44c-1f3fc",
            "1f44c-1f3fd",
            "1f44c-1f3fe",
            "1f44c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "pinched fingers"
        ],
        u: "1f90c",
        v: [
            "1f90c-1f3fb",
            "1f90c-1f3fc",
            "1f90c-1f3fd",
            "1f90c-1f3fe",
            "1f90c-1f3ff"
        ],
        a: "13.0"
    },
    {
        n: [
            "pinching hand"
        ],
        u: "1f90f",
        v: [
            "1f90f-1f3fb",
            "1f90f-1f3fc",
            "1f90f-1f3fd",
            "1f90f-1f3fe",
            "1f90f-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "v",
            "victory hand"
        ],
        u: "270c-fe0f",
        v: [
            "270c-1f3fb",
            "270c-1f3fc",
            "270c-1f3fd",
            "270c-1f3fe",
            "270c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "crossed fingers",
            "hand with index and middle fingers crossed"
        ],
        u: "1f91e",
        v: [
            "1f91e-1f3fb",
            "1f91e-1f3fc",
            "1f91e-1f3fd",
            "1f91e-1f3fe",
            "1f91e-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "hand with index finger and thumb crossed"
        ],
        u: "1faf0",
        v: [
            "1faf0-1f3fb",
            "1faf0-1f3fc",
            "1faf0-1f3fd",
            "1faf0-1f3fe",
            "1faf0-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "i love you hand sign"
        ],
        u: "1f91f",
        v: [
            "1f91f-1f3fb",
            "1f91f-1f3fc",
            "1f91f-1f3fd",
            "1f91f-1f3fe",
            "1f91f-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "the horns",
            "sign of the horns"
        ],
        u: "1f918",
        v: [
            "1f918-1f3fb",
            "1f918-1f3fc",
            "1f918-1f3fd",
            "1f918-1f3fe",
            "1f918-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "call me hand"
        ],
        u: "1f919",
        v: [
            "1f919-1f3fb",
            "1f919-1f3fc",
            "1f919-1f3fd",
            "1f919-1f3fe",
            "1f919-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "point left",
            "white left pointing backhand index"
        ],
        u: "1f448",
        v: [
            "1f448-1f3fb",
            "1f448-1f3fc",
            "1f448-1f3fd",
            "1f448-1f3fe",
            "1f448-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "point right",
            "white right pointing backhand index"
        ],
        u: "1f449",
        v: [
            "1f449-1f3fb",
            "1f449-1f3fc",
            "1f449-1f3fd",
            "1f449-1f3fe",
            "1f449-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "point up 2",
            "white up pointing backhand index"
        ],
        u: "1f446",
        v: [
            "1f446-1f3fb",
            "1f446-1f3fc",
            "1f446-1f3fd",
            "1f446-1f3fe",
            "1f446-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "middle finger",
            "reversed hand with middle finger extended"
        ],
        u: "1f595",
        v: [
            "1f595-1f3fb",
            "1f595-1f3fc",
            "1f595-1f3fd",
            "1f595-1f3fe",
            "1f595-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "point down",
            "white down pointing backhand index"
        ],
        u: "1f447",
        v: [
            "1f447-1f3fb",
            "1f447-1f3fc",
            "1f447-1f3fd",
            "1f447-1f3fe",
            "1f447-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "point up",
            "white up pointing index"
        ],
        u: "261d-fe0f",
        v: [
            "261d-1f3fb",
            "261d-1f3fc",
            "261d-1f3fd",
            "261d-1f3fe",
            "261d-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "index pointing at the viewer"
        ],
        u: "1faf5",
        v: [
            "1faf5-1f3fb",
            "1faf5-1f3fc",
            "1faf5-1f3fd",
            "1faf5-1f3fe",
            "1faf5-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "+1",
            "thumbsup",
            "thumbs up sign"
        ],
        u: "1f44d",
        v: [
            "1f44d-1f3fb",
            "1f44d-1f3fc",
            "1f44d-1f3fd",
            "1f44d-1f3fe",
            "1f44d-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "-1",
            "thumbsdown",
            "thumbs down sign"
        ],
        u: "1f44e",
        v: [
            "1f44e-1f3fb",
            "1f44e-1f3fc",
            "1f44e-1f3fd",
            "1f44e-1f3fe",
            "1f44e-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "fist",
            "raised fist"
        ],
        u: "270a",
        v: [
            "270a-1f3fb",
            "270a-1f3fc",
            "270a-1f3fd",
            "270a-1f3fe",
            "270a-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "punch",
            "facepunch",
            "fisted hand sign"
        ],
        u: "1f44a",
        v: [
            "1f44a-1f3fb",
            "1f44a-1f3fc",
            "1f44a-1f3fd",
            "1f44a-1f3fe",
            "1f44a-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "left-facing fist"
        ],
        u: "1f91b",
        v: [
            "1f91b-1f3fb",
            "1f91b-1f3fc",
            "1f91b-1f3fd",
            "1f91b-1f3fe",
            "1f91b-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "right-facing fist"
        ],
        u: "1f91c",
        v: [
            "1f91c-1f3fb",
            "1f91c-1f3fc",
            "1f91c-1f3fd",
            "1f91c-1f3fe",
            "1f91c-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "clap",
            "clapping hands sign"
        ],
        u: "1f44f",
        v: [
            "1f44f-1f3fb",
            "1f44f-1f3fc",
            "1f44f-1f3fd",
            "1f44f-1f3fe",
            "1f44f-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "raised hands",
            "person raising both hands in celebration"
        ],
        u: "1f64c",
        v: [
            "1f64c-1f3fb",
            "1f64c-1f3fc",
            "1f64c-1f3fd",
            "1f64c-1f3fe",
            "1f64c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "heart hands"
        ],
        u: "1faf6",
        v: [
            "1faf6-1f3fb",
            "1faf6-1f3fc",
            "1faf6-1f3fd",
            "1faf6-1f3fe",
            "1faf6-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "open hands",
            "open hands sign"
        ],
        u: "1f450",
        v: [
            "1f450-1f3fb",
            "1f450-1f3fc",
            "1f450-1f3fd",
            "1f450-1f3fe",
            "1f450-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "palms up together"
        ],
        u: "1f932",
        v: [
            "1f932-1f3fb",
            "1f932-1f3fc",
            "1f932-1f3fd",
            "1f932-1f3fe",
            "1f932-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "handshake"
        ],
        u: "1f91d",
        v: [
            "1f91d-1f3fb",
            "1f91d-1f3fc",
            "1f91d-1f3fd",
            "1f91d-1f3fe",
            "1f91d-1f3ff",
            "1faf1-1f3fb-200d-1faf2-1f3fc",
            "1faf1-1f3fb-200d-1faf2-1f3fd",
            "1faf1-1f3fb-200d-1faf2-1f3fe",
            "1faf1-1f3fb-200d-1faf2-1f3ff",
            "1faf1-1f3fc-200d-1faf2-1f3fb",
            "1faf1-1f3fc-200d-1faf2-1f3fd",
            "1faf1-1f3fc-200d-1faf2-1f3fe",
            "1faf1-1f3fc-200d-1faf2-1f3ff",
            "1faf1-1f3fd-200d-1faf2-1f3fb",
            "1faf1-1f3fd-200d-1faf2-1f3fc",
            "1faf1-1f3fd-200d-1faf2-1f3fe",
            "1faf1-1f3fd-200d-1faf2-1f3ff",
            "1faf1-1f3fe-200d-1faf2-1f3fb",
            "1faf1-1f3fe-200d-1faf2-1f3fc",
            "1faf1-1f3fe-200d-1faf2-1f3fd",
            "1faf1-1f3fe-200d-1faf2-1f3ff",
            "1faf1-1f3ff-200d-1faf2-1f3fb",
            "1faf1-1f3ff-200d-1faf2-1f3fc",
            "1faf1-1f3ff-200d-1faf2-1f3fd",
            "1faf1-1f3ff-200d-1faf2-1f3fe"
        ],
        a: "3.0"
    },
    {
        n: [
            "pray",
            "person with folded hands"
        ],
        u: "1f64f",
        v: [
            "1f64f-1f3fb",
            "1f64f-1f3fc",
            "1f64f-1f3fd",
            "1f64f-1f3fe",
            "1f64f-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "writing hand"
        ],
        u: "270d-fe0f",
        v: [
            "270d-1f3fb",
            "270d-1f3fc",
            "270d-1f3fd",
            "270d-1f3fe",
            "270d-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "nail care",
            "nail polish"
        ],
        u: "1f485",
        v: [
            "1f485-1f3fb",
            "1f485-1f3fc",
            "1f485-1f3fd",
            "1f485-1f3fe",
            "1f485-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "selfie"
        ],
        u: "1f933",
        v: [
            "1f933-1f3fb",
            "1f933-1f3fc",
            "1f933-1f3fd",
            "1f933-1f3fe",
            "1f933-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "muscle",
            "flexed biceps"
        ],
        u: "1f4aa",
        v: [
            "1f4aa-1f3fb",
            "1f4aa-1f3fc",
            "1f4aa-1f3fd",
            "1f4aa-1f3fe",
            "1f4aa-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "mechanical arm"
        ],
        u: "1f9be",
        a: "12.0"
    },
    {
        n: [
            "mechanical leg"
        ],
        u: "1f9bf",
        a: "12.0"
    },
    {
        n: [
            "leg"
        ],
        u: "1f9b5",
        v: [
            "1f9b5-1f3fb",
            "1f9b5-1f3fc",
            "1f9b5-1f3fd",
            "1f9b5-1f3fe",
            "1f9b5-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "foot"
        ],
        u: "1f9b6",
        v: [
            "1f9b6-1f3fb",
            "1f9b6-1f3fc",
            "1f9b6-1f3fd",
            "1f9b6-1f3fe",
            "1f9b6-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "ear"
        ],
        u: "1f442",
        v: [
            "1f442-1f3fb",
            "1f442-1f3fc",
            "1f442-1f3fd",
            "1f442-1f3fe",
            "1f442-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "ear with hearing aid"
        ],
        u: "1f9bb",
        v: [
            "1f9bb-1f3fb",
            "1f9bb-1f3fc",
            "1f9bb-1f3fd",
            "1f9bb-1f3fe",
            "1f9bb-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "nose"
        ],
        u: "1f443",
        v: [
            "1f443-1f3fb",
            "1f443-1f3fc",
            "1f443-1f3fd",
            "1f443-1f3fe",
            "1f443-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "brain"
        ],
        u: "1f9e0",
        a: "5.0"
    },
    {
        n: [
            "anatomical heart"
        ],
        u: "1fac0",
        a: "13.0"
    },
    {
        n: [
            "lungs"
        ],
        u: "1fac1",
        a: "13.0"
    },
    {
        n: [
            "tooth"
        ],
        u: "1f9b7",
        a: "11.0"
    },
    {
        n: [
            "bone"
        ],
        u: "1f9b4",
        a: "11.0"
    },
    {
        n: [
            "eyes"
        ],
        u: "1f440",
        a: "0.6"
    },
    {
        n: [
            "eye"
        ],
        u: "1f441-fe0f",
        a: "0.7"
    },
    {
        n: [
            "tongue"
        ],
        u: "1f445",
        a: "0.6"
    },
    {
        n: [
            "lips",
            "mouth"
        ],
        u: "1f444",
        a: "0.6"
    },
    {
        n: [
            "biting lip"
        ],
        u: "1fae6",
        a: "14.0"
    },
    {
        n: [
            "baby"
        ],
        u: "1f476",
        v: [
            "1f476-1f3fb",
            "1f476-1f3fc",
            "1f476-1f3fd",
            "1f476-1f3fe",
            "1f476-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "child"
        ],
        u: "1f9d2",
        v: [
            "1f9d2-1f3fb",
            "1f9d2-1f3fc",
            "1f9d2-1f3fd",
            "1f9d2-1f3fe",
            "1f9d2-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "boy"
        ],
        u: "1f466",
        v: [
            "1f466-1f3fb",
            "1f466-1f3fc",
            "1f466-1f3fd",
            "1f466-1f3fe",
            "1f466-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "girl"
        ],
        u: "1f467",
        v: [
            "1f467-1f3fb",
            "1f467-1f3fc",
            "1f467-1f3fd",
            "1f467-1f3fe",
            "1f467-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "adult"
        ],
        u: "1f9d1",
        v: [
            "1f9d1-1f3fb",
            "1f9d1-1f3fc",
            "1f9d1-1f3fd",
            "1f9d1-1f3fe",
            "1f9d1-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "person with blond hair"
        ],
        u: "1f471",
        v: [
            "1f471-1f3fb",
            "1f471-1f3fc",
            "1f471-1f3fd",
            "1f471-1f3fe",
            "1f471-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man"
        ],
        u: "1f468",
        v: [
            "1f468-1f3fb",
            "1f468-1f3fc",
            "1f468-1f3fd",
            "1f468-1f3fe",
            "1f468-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "bearded person"
        ],
        u: "1f9d4",
        v: [
            "1f9d4-1f3fb",
            "1f9d4-1f3fc",
            "1f9d4-1f3fd",
            "1f9d4-1f3fe",
            "1f9d4-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man: beard",
            "man with beard"
        ],
        u: "1f9d4-200d-2642-fe0f",
        v: [
            "1f9d4-1f3fb-200d-2642-fe0f",
            "1f9d4-1f3fc-200d-2642-fe0f",
            "1f9d4-1f3fd-200d-2642-fe0f",
            "1f9d4-1f3fe-200d-2642-fe0f",
            "1f9d4-1f3ff-200d-2642-fe0f"
        ],
        a: "13.1"
    },
    {
        n: [
            "woman: beard",
            "woman with beard"
        ],
        u: "1f9d4-200d-2640-fe0f",
        v: [
            "1f9d4-1f3fb-200d-2640-fe0f",
            "1f9d4-1f3fc-200d-2640-fe0f",
            "1f9d4-1f3fd-200d-2640-fe0f",
            "1f9d4-1f3fe-200d-2640-fe0f",
            "1f9d4-1f3ff-200d-2640-fe0f"
        ],
        a: "13.1"
    },
    {
        n: [
            "man: red hair",
            "red haired man"
        ],
        u: "1f468-200d-1f9b0",
        v: [
            "1f468-1f3fb-200d-1f9b0",
            "1f468-1f3fc-200d-1f9b0",
            "1f468-1f3fd-200d-1f9b0",
            "1f468-1f3fe-200d-1f9b0",
            "1f468-1f3ff-200d-1f9b0"
        ],
        a: "11.0"
    },
    {
        n: [
            "man: curly hair",
            "curly haired man"
        ],
        u: "1f468-200d-1f9b1",
        v: [
            "1f468-1f3fb-200d-1f9b1",
            "1f468-1f3fc-200d-1f9b1",
            "1f468-1f3fd-200d-1f9b1",
            "1f468-1f3fe-200d-1f9b1",
            "1f468-1f3ff-200d-1f9b1"
        ],
        a: "11.0"
    },
    {
        n: [
            "man: white hair",
            "white haired man"
        ],
        u: "1f468-200d-1f9b3",
        v: [
            "1f468-1f3fb-200d-1f9b3",
            "1f468-1f3fc-200d-1f9b3",
            "1f468-1f3fd-200d-1f9b3",
            "1f468-1f3fe-200d-1f9b3",
            "1f468-1f3ff-200d-1f9b3"
        ],
        a: "11.0"
    },
    {
        n: [
            "bald man",
            "man: bald"
        ],
        u: "1f468-200d-1f9b2",
        v: [
            "1f468-1f3fb-200d-1f9b2",
            "1f468-1f3fc-200d-1f9b2",
            "1f468-1f3fd-200d-1f9b2",
            "1f468-1f3fe-200d-1f9b2",
            "1f468-1f3ff-200d-1f9b2"
        ],
        a: "11.0"
    },
    {
        n: [
            "woman"
        ],
        u: "1f469",
        v: [
            "1f469-1f3fb",
            "1f469-1f3fc",
            "1f469-1f3fd",
            "1f469-1f3fe",
            "1f469-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "woman: red hair",
            "red haired woman"
        ],
        u: "1f469-200d-1f9b0",
        v: [
            "1f469-1f3fb-200d-1f9b0",
            "1f469-1f3fc-200d-1f9b0",
            "1f469-1f3fd-200d-1f9b0",
            "1f469-1f3fe-200d-1f9b0",
            "1f469-1f3ff-200d-1f9b0"
        ],
        a: "11.0"
    },
    {
        n: [
            "person: red hair",
            "red haired person"
        ],
        u: "1f9d1-200d-1f9b0",
        v: [
            "1f9d1-1f3fb-200d-1f9b0",
            "1f9d1-1f3fc-200d-1f9b0",
            "1f9d1-1f3fd-200d-1f9b0",
            "1f9d1-1f3fe-200d-1f9b0",
            "1f9d1-1f3ff-200d-1f9b0"
        ],
        a: "12.1"
    },
    {
        n: [
            "woman: curly hair",
            "curly haired woman"
        ],
        u: "1f469-200d-1f9b1",
        v: [
            "1f469-1f3fb-200d-1f9b1",
            "1f469-1f3fc-200d-1f9b1",
            "1f469-1f3fd-200d-1f9b1",
            "1f469-1f3fe-200d-1f9b1",
            "1f469-1f3ff-200d-1f9b1"
        ],
        a: "11.0"
    },
    {
        n: [
            "person: curly hair",
            "curly haired person"
        ],
        u: "1f9d1-200d-1f9b1",
        v: [
            "1f9d1-1f3fb-200d-1f9b1",
            "1f9d1-1f3fc-200d-1f9b1",
            "1f9d1-1f3fd-200d-1f9b1",
            "1f9d1-1f3fe-200d-1f9b1",
            "1f9d1-1f3ff-200d-1f9b1"
        ],
        a: "12.1"
    },
    {
        n: [
            "woman: white hair",
            "white haired woman"
        ],
        u: "1f469-200d-1f9b3",
        v: [
            "1f469-1f3fb-200d-1f9b3",
            "1f469-1f3fc-200d-1f9b3",
            "1f469-1f3fd-200d-1f9b3",
            "1f469-1f3fe-200d-1f9b3",
            "1f469-1f3ff-200d-1f9b3"
        ],
        a: "11.0"
    },
    {
        n: [
            "person: white hair",
            "white haired person"
        ],
        u: "1f9d1-200d-1f9b3",
        v: [
            "1f9d1-1f3fb-200d-1f9b3",
            "1f9d1-1f3fc-200d-1f9b3",
            "1f9d1-1f3fd-200d-1f9b3",
            "1f9d1-1f3fe-200d-1f9b3",
            "1f9d1-1f3ff-200d-1f9b3"
        ],
        a: "12.1"
    },
    {
        n: [
            "bald woman",
            "woman: bald"
        ],
        u: "1f469-200d-1f9b2",
        v: [
            "1f469-1f3fb-200d-1f9b2",
            "1f469-1f3fc-200d-1f9b2",
            "1f469-1f3fd-200d-1f9b2",
            "1f469-1f3fe-200d-1f9b2",
            "1f469-1f3ff-200d-1f9b2"
        ],
        a: "11.0"
    },
    {
        n: [
            "bald person",
            "person: bald"
        ],
        u: "1f9d1-200d-1f9b2",
        v: [
            "1f9d1-1f3fb-200d-1f9b2",
            "1f9d1-1f3fc-200d-1f9b2",
            "1f9d1-1f3fd-200d-1f9b2",
            "1f9d1-1f3fe-200d-1f9b2",
            "1f9d1-1f3ff-200d-1f9b2"
        ],
        a: "12.1"
    },
    {
        n: [
            "woman: blond hair",
            "blond-haired-woman"
        ],
        u: "1f471-200d-2640-fe0f",
        v: [
            "1f471-1f3fb-200d-2640-fe0f",
            "1f471-1f3fc-200d-2640-fe0f",
            "1f471-1f3fd-200d-2640-fe0f",
            "1f471-1f3fe-200d-2640-fe0f",
            "1f471-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "man: blond hair",
            "blond-haired-man"
        ],
        u: "1f471-200d-2642-fe0f",
        v: [
            "1f471-1f3fb-200d-2642-fe0f",
            "1f471-1f3fc-200d-2642-fe0f",
            "1f471-1f3fd-200d-2642-fe0f",
            "1f471-1f3fe-200d-2642-fe0f",
            "1f471-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "older adult"
        ],
        u: "1f9d3",
        v: [
            "1f9d3-1f3fb",
            "1f9d3-1f3fc",
            "1f9d3-1f3fd",
            "1f9d3-1f3fe",
            "1f9d3-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "older man"
        ],
        u: "1f474",
        v: [
            "1f474-1f3fb",
            "1f474-1f3fc",
            "1f474-1f3fd",
            "1f474-1f3fe",
            "1f474-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "older woman"
        ],
        u: "1f475",
        v: [
            "1f475-1f3fb",
            "1f475-1f3fc",
            "1f475-1f3fd",
            "1f475-1f3fe",
            "1f475-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "person frowning"
        ],
        u: "1f64d",
        v: [
            "1f64d-1f3fb",
            "1f64d-1f3fc",
            "1f64d-1f3fd",
            "1f64d-1f3fe",
            "1f64d-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man frowning",
            "man-frowning"
        ],
        u: "1f64d-200d-2642-fe0f",
        v: [
            "1f64d-1f3fb-200d-2642-fe0f",
            "1f64d-1f3fc-200d-2642-fe0f",
            "1f64d-1f3fd-200d-2642-fe0f",
            "1f64d-1f3fe-200d-2642-fe0f",
            "1f64d-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman frowning",
            "woman-frowning"
        ],
        u: "1f64d-200d-2640-fe0f",
        v: [
            "1f64d-1f3fb-200d-2640-fe0f",
            "1f64d-1f3fc-200d-2640-fe0f",
            "1f64d-1f3fd-200d-2640-fe0f",
            "1f64d-1f3fe-200d-2640-fe0f",
            "1f64d-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person with pouting face"
        ],
        u: "1f64e",
        v: [
            "1f64e-1f3fb",
            "1f64e-1f3fc",
            "1f64e-1f3fd",
            "1f64e-1f3fe",
            "1f64e-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man pouting",
            "man-pouting"
        ],
        u: "1f64e-200d-2642-fe0f",
        v: [
            "1f64e-1f3fb-200d-2642-fe0f",
            "1f64e-1f3fc-200d-2642-fe0f",
            "1f64e-1f3fd-200d-2642-fe0f",
            "1f64e-1f3fe-200d-2642-fe0f",
            "1f64e-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman pouting",
            "woman-pouting"
        ],
        u: "1f64e-200d-2640-fe0f",
        v: [
            "1f64e-1f3fb-200d-2640-fe0f",
            "1f64e-1f3fc-200d-2640-fe0f",
            "1f64e-1f3fd-200d-2640-fe0f",
            "1f64e-1f3fe-200d-2640-fe0f",
            "1f64e-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "no good",
            "face with no good gesture"
        ],
        u: "1f645",
        v: [
            "1f645-1f3fb",
            "1f645-1f3fc",
            "1f645-1f3fd",
            "1f645-1f3fe",
            "1f645-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man gesturing no",
            "man-gesturing-no"
        ],
        u: "1f645-200d-2642-fe0f",
        v: [
            "1f645-1f3fb-200d-2642-fe0f",
            "1f645-1f3fc-200d-2642-fe0f",
            "1f645-1f3fd-200d-2642-fe0f",
            "1f645-1f3fe-200d-2642-fe0f",
            "1f645-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman gesturing no",
            "woman-gesturing-no"
        ],
        u: "1f645-200d-2640-fe0f",
        v: [
            "1f645-1f3fb-200d-2640-fe0f",
            "1f645-1f3fc-200d-2640-fe0f",
            "1f645-1f3fd-200d-2640-fe0f",
            "1f645-1f3fe-200d-2640-fe0f",
            "1f645-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "ok woman",
            "face with ok gesture"
        ],
        u: "1f646",
        v: [
            "1f646-1f3fb",
            "1f646-1f3fc",
            "1f646-1f3fd",
            "1f646-1f3fe",
            "1f646-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man gesturing ok",
            "man-gesturing-ok"
        ],
        u: "1f646-200d-2642-fe0f",
        v: [
            "1f646-1f3fb-200d-2642-fe0f",
            "1f646-1f3fc-200d-2642-fe0f",
            "1f646-1f3fd-200d-2642-fe0f",
            "1f646-1f3fe-200d-2642-fe0f",
            "1f646-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman gesturing ok",
            "woman-gesturing-ok"
        ],
        u: "1f646-200d-2640-fe0f",
        v: [
            "1f646-1f3fb-200d-2640-fe0f",
            "1f646-1f3fc-200d-2640-fe0f",
            "1f646-1f3fd-200d-2640-fe0f",
            "1f646-1f3fe-200d-2640-fe0f",
            "1f646-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "information desk person"
        ],
        u: "1f481",
        v: [
            "1f481-1f3fb",
            "1f481-1f3fc",
            "1f481-1f3fd",
            "1f481-1f3fe",
            "1f481-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man tipping hand",
            "man-tipping-hand"
        ],
        u: "1f481-200d-2642-fe0f",
        v: [
            "1f481-1f3fb-200d-2642-fe0f",
            "1f481-1f3fc-200d-2642-fe0f",
            "1f481-1f3fd-200d-2642-fe0f",
            "1f481-1f3fe-200d-2642-fe0f",
            "1f481-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman tipping hand",
            "woman-tipping-hand"
        ],
        u: "1f481-200d-2640-fe0f",
        v: [
            "1f481-1f3fb-200d-2640-fe0f",
            "1f481-1f3fc-200d-2640-fe0f",
            "1f481-1f3fd-200d-2640-fe0f",
            "1f481-1f3fe-200d-2640-fe0f",
            "1f481-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "raising hand",
            "happy person raising one hand"
        ],
        u: "1f64b",
        v: [
            "1f64b-1f3fb",
            "1f64b-1f3fc",
            "1f64b-1f3fd",
            "1f64b-1f3fe",
            "1f64b-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man raising hand",
            "man-raising-hand"
        ],
        u: "1f64b-200d-2642-fe0f",
        v: [
            "1f64b-1f3fb-200d-2642-fe0f",
            "1f64b-1f3fc-200d-2642-fe0f",
            "1f64b-1f3fd-200d-2642-fe0f",
            "1f64b-1f3fe-200d-2642-fe0f",
            "1f64b-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman raising hand",
            "woman-raising-hand"
        ],
        u: "1f64b-200d-2640-fe0f",
        v: [
            "1f64b-1f3fb-200d-2640-fe0f",
            "1f64b-1f3fc-200d-2640-fe0f",
            "1f64b-1f3fd-200d-2640-fe0f",
            "1f64b-1f3fe-200d-2640-fe0f",
            "1f64b-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "deaf person"
        ],
        u: "1f9cf",
        v: [
            "1f9cf-1f3fb",
            "1f9cf-1f3fc",
            "1f9cf-1f3fd",
            "1f9cf-1f3fe",
            "1f9cf-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "deaf man"
        ],
        u: "1f9cf-200d-2642-fe0f",
        v: [
            "1f9cf-1f3fb-200d-2642-fe0f",
            "1f9cf-1f3fc-200d-2642-fe0f",
            "1f9cf-1f3fd-200d-2642-fe0f",
            "1f9cf-1f3fe-200d-2642-fe0f",
            "1f9cf-1f3ff-200d-2642-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "deaf woman"
        ],
        u: "1f9cf-200d-2640-fe0f",
        v: [
            "1f9cf-1f3fb-200d-2640-fe0f",
            "1f9cf-1f3fc-200d-2640-fe0f",
            "1f9cf-1f3fd-200d-2640-fe0f",
            "1f9cf-1f3fe-200d-2640-fe0f",
            "1f9cf-1f3ff-200d-2640-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "bow",
            "person bowing deeply"
        ],
        u: "1f647",
        v: [
            "1f647-1f3fb",
            "1f647-1f3fc",
            "1f647-1f3fd",
            "1f647-1f3fe",
            "1f647-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man bowing",
            "man-bowing"
        ],
        u: "1f647-200d-2642-fe0f",
        v: [
            "1f647-1f3fb-200d-2642-fe0f",
            "1f647-1f3fc-200d-2642-fe0f",
            "1f647-1f3fd-200d-2642-fe0f",
            "1f647-1f3fe-200d-2642-fe0f",
            "1f647-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman bowing",
            "woman-bowing"
        ],
        u: "1f647-200d-2640-fe0f",
        v: [
            "1f647-1f3fb-200d-2640-fe0f",
            "1f647-1f3fc-200d-2640-fe0f",
            "1f647-1f3fd-200d-2640-fe0f",
            "1f647-1f3fe-200d-2640-fe0f",
            "1f647-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "face palm"
        ],
        u: "1f926",
        v: [
            "1f926-1f3fb",
            "1f926-1f3fc",
            "1f926-1f3fd",
            "1f926-1f3fe",
            "1f926-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man facepalming",
            "man-facepalming"
        ],
        u: "1f926-200d-2642-fe0f",
        v: [
            "1f926-1f3fb-200d-2642-fe0f",
            "1f926-1f3fc-200d-2642-fe0f",
            "1f926-1f3fd-200d-2642-fe0f",
            "1f926-1f3fe-200d-2642-fe0f",
            "1f926-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman facepalming",
            "woman-facepalming"
        ],
        u: "1f926-200d-2640-fe0f",
        v: [
            "1f926-1f3fb-200d-2640-fe0f",
            "1f926-1f3fc-200d-2640-fe0f",
            "1f926-1f3fd-200d-2640-fe0f",
            "1f926-1f3fe-200d-2640-fe0f",
            "1f926-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "shrug"
        ],
        u: "1f937",
        v: [
            "1f937-1f3fb",
            "1f937-1f3fc",
            "1f937-1f3fd",
            "1f937-1f3fe",
            "1f937-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man shrugging",
            "man-shrugging"
        ],
        u: "1f937-200d-2642-fe0f",
        v: [
            "1f937-1f3fb-200d-2642-fe0f",
            "1f937-1f3fc-200d-2642-fe0f",
            "1f937-1f3fd-200d-2642-fe0f",
            "1f937-1f3fe-200d-2642-fe0f",
            "1f937-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman shrugging",
            "woman-shrugging"
        ],
        u: "1f937-200d-2640-fe0f",
        v: [
            "1f937-1f3fb-200d-2640-fe0f",
            "1f937-1f3fc-200d-2640-fe0f",
            "1f937-1f3fd-200d-2640-fe0f",
            "1f937-1f3fe-200d-2640-fe0f",
            "1f937-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "health worker"
        ],
        u: "1f9d1-200d-2695-fe0f",
        v: [
            "1f9d1-1f3fb-200d-2695-fe0f",
            "1f9d1-1f3fc-200d-2695-fe0f",
            "1f9d1-1f3fd-200d-2695-fe0f",
            "1f9d1-1f3fe-200d-2695-fe0f",
            "1f9d1-1f3ff-200d-2695-fe0f"
        ],
        a: "12.1"
    },
    {
        n: [
            "male-doctor",
            "man health worker"
        ],
        u: "1f468-200d-2695-fe0f",
        v: [
            "1f468-1f3fb-200d-2695-fe0f",
            "1f468-1f3fc-200d-2695-fe0f",
            "1f468-1f3fd-200d-2695-fe0f",
            "1f468-1f3fe-200d-2695-fe0f",
            "1f468-1f3ff-200d-2695-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "female-doctor",
            "woman health worker"
        ],
        u: "1f469-200d-2695-fe0f",
        v: [
            "1f469-1f3fb-200d-2695-fe0f",
            "1f469-1f3fc-200d-2695-fe0f",
            "1f469-1f3fd-200d-2695-fe0f",
            "1f469-1f3fe-200d-2695-fe0f",
            "1f469-1f3ff-200d-2695-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "student"
        ],
        u: "1f9d1-200d-1f393",
        v: [
            "1f9d1-1f3fb-200d-1f393",
            "1f9d1-1f3fc-200d-1f393",
            "1f9d1-1f3fd-200d-1f393",
            "1f9d1-1f3fe-200d-1f393",
            "1f9d1-1f3ff-200d-1f393"
        ],
        a: "12.1"
    },
    {
        n: [
            "man student",
            "male-student"
        ],
        u: "1f468-200d-1f393",
        v: [
            "1f468-1f3fb-200d-1f393",
            "1f468-1f3fc-200d-1f393",
            "1f468-1f3fd-200d-1f393",
            "1f468-1f3fe-200d-1f393",
            "1f468-1f3ff-200d-1f393"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman student",
            "female-student"
        ],
        u: "1f469-200d-1f393",
        v: [
            "1f469-1f3fb-200d-1f393",
            "1f469-1f3fc-200d-1f393",
            "1f469-1f3fd-200d-1f393",
            "1f469-1f3fe-200d-1f393",
            "1f469-1f3ff-200d-1f393"
        ],
        a: "4.0"
    },
    {
        n: [
            "teacher"
        ],
        u: "1f9d1-200d-1f3eb",
        v: [
            "1f9d1-1f3fb-200d-1f3eb",
            "1f9d1-1f3fc-200d-1f3eb",
            "1f9d1-1f3fd-200d-1f3eb",
            "1f9d1-1f3fe-200d-1f3eb",
            "1f9d1-1f3ff-200d-1f3eb"
        ],
        a: "12.1"
    },
    {
        n: [
            "man teacher",
            "male-teacher"
        ],
        u: "1f468-200d-1f3eb",
        v: [
            "1f468-1f3fb-200d-1f3eb",
            "1f468-1f3fc-200d-1f3eb",
            "1f468-1f3fd-200d-1f3eb",
            "1f468-1f3fe-200d-1f3eb",
            "1f468-1f3ff-200d-1f3eb"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman teacher",
            "female-teacher"
        ],
        u: "1f469-200d-1f3eb",
        v: [
            "1f469-1f3fb-200d-1f3eb",
            "1f469-1f3fc-200d-1f3eb",
            "1f469-1f3fd-200d-1f3eb",
            "1f469-1f3fe-200d-1f3eb",
            "1f469-1f3ff-200d-1f3eb"
        ],
        a: "4.0"
    },
    {
        n: [
            "judge"
        ],
        u: "1f9d1-200d-2696-fe0f",
        v: [
            "1f9d1-1f3fb-200d-2696-fe0f",
            "1f9d1-1f3fc-200d-2696-fe0f",
            "1f9d1-1f3fd-200d-2696-fe0f",
            "1f9d1-1f3fe-200d-2696-fe0f",
            "1f9d1-1f3ff-200d-2696-fe0f"
        ],
        a: "12.1"
    },
    {
        n: [
            "man judge",
            "male-judge"
        ],
        u: "1f468-200d-2696-fe0f",
        v: [
            "1f468-1f3fb-200d-2696-fe0f",
            "1f468-1f3fc-200d-2696-fe0f",
            "1f468-1f3fd-200d-2696-fe0f",
            "1f468-1f3fe-200d-2696-fe0f",
            "1f468-1f3ff-200d-2696-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman judge",
            "female-judge"
        ],
        u: "1f469-200d-2696-fe0f",
        v: [
            "1f469-1f3fb-200d-2696-fe0f",
            "1f469-1f3fc-200d-2696-fe0f",
            "1f469-1f3fd-200d-2696-fe0f",
            "1f469-1f3fe-200d-2696-fe0f",
            "1f469-1f3ff-200d-2696-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "farmer"
        ],
        u: "1f9d1-200d-1f33e",
        v: [
            "1f9d1-1f3fb-200d-1f33e",
            "1f9d1-1f3fc-200d-1f33e",
            "1f9d1-1f3fd-200d-1f33e",
            "1f9d1-1f3fe-200d-1f33e",
            "1f9d1-1f3ff-200d-1f33e"
        ],
        a: "12.1"
    },
    {
        n: [
            "man farmer",
            "male-farmer"
        ],
        u: "1f468-200d-1f33e",
        v: [
            "1f468-1f3fb-200d-1f33e",
            "1f468-1f3fc-200d-1f33e",
            "1f468-1f3fd-200d-1f33e",
            "1f468-1f3fe-200d-1f33e",
            "1f468-1f3ff-200d-1f33e"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman farmer",
            "female-farmer"
        ],
        u: "1f469-200d-1f33e",
        v: [
            "1f469-1f3fb-200d-1f33e",
            "1f469-1f3fc-200d-1f33e",
            "1f469-1f3fd-200d-1f33e",
            "1f469-1f3fe-200d-1f33e",
            "1f469-1f3ff-200d-1f33e"
        ],
        a: "4.0"
    },
    {
        n: [
            "cook"
        ],
        u: "1f9d1-200d-1f373",
        v: [
            "1f9d1-1f3fb-200d-1f373",
            "1f9d1-1f3fc-200d-1f373",
            "1f9d1-1f3fd-200d-1f373",
            "1f9d1-1f3fe-200d-1f373",
            "1f9d1-1f3ff-200d-1f373"
        ],
        a: "12.1"
    },
    {
        n: [
            "man cook",
            "male-cook"
        ],
        u: "1f468-200d-1f373",
        v: [
            "1f468-1f3fb-200d-1f373",
            "1f468-1f3fc-200d-1f373",
            "1f468-1f3fd-200d-1f373",
            "1f468-1f3fe-200d-1f373",
            "1f468-1f3ff-200d-1f373"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman cook",
            "female-cook"
        ],
        u: "1f469-200d-1f373",
        v: [
            "1f469-1f3fb-200d-1f373",
            "1f469-1f3fc-200d-1f373",
            "1f469-1f3fd-200d-1f373",
            "1f469-1f3fe-200d-1f373",
            "1f469-1f3ff-200d-1f373"
        ],
        a: "4.0"
    },
    {
        n: [
            "mechanic"
        ],
        u: "1f9d1-200d-1f527",
        v: [
            "1f9d1-1f3fb-200d-1f527",
            "1f9d1-1f3fc-200d-1f527",
            "1f9d1-1f3fd-200d-1f527",
            "1f9d1-1f3fe-200d-1f527",
            "1f9d1-1f3ff-200d-1f527"
        ],
        a: "12.1"
    },
    {
        n: [
            "man mechanic",
            "male-mechanic"
        ],
        u: "1f468-200d-1f527",
        v: [
            "1f468-1f3fb-200d-1f527",
            "1f468-1f3fc-200d-1f527",
            "1f468-1f3fd-200d-1f527",
            "1f468-1f3fe-200d-1f527",
            "1f468-1f3ff-200d-1f527"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman mechanic",
            "female-mechanic"
        ],
        u: "1f469-200d-1f527",
        v: [
            "1f469-1f3fb-200d-1f527",
            "1f469-1f3fc-200d-1f527",
            "1f469-1f3fd-200d-1f527",
            "1f469-1f3fe-200d-1f527",
            "1f469-1f3ff-200d-1f527"
        ],
        a: "4.0"
    },
    {
        n: [
            "factory worker"
        ],
        u: "1f9d1-200d-1f3ed",
        v: [
            "1f9d1-1f3fb-200d-1f3ed",
            "1f9d1-1f3fc-200d-1f3ed",
            "1f9d1-1f3fd-200d-1f3ed",
            "1f9d1-1f3fe-200d-1f3ed",
            "1f9d1-1f3ff-200d-1f3ed"
        ],
        a: "12.1"
    },
    {
        n: [
            "man factory worker",
            "male-factory-worker"
        ],
        u: "1f468-200d-1f3ed",
        v: [
            "1f468-1f3fb-200d-1f3ed",
            "1f468-1f3fc-200d-1f3ed",
            "1f468-1f3fd-200d-1f3ed",
            "1f468-1f3fe-200d-1f3ed",
            "1f468-1f3ff-200d-1f3ed"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman factory worker",
            "female-factory-worker"
        ],
        u: "1f469-200d-1f3ed",
        v: [
            "1f469-1f3fb-200d-1f3ed",
            "1f469-1f3fc-200d-1f3ed",
            "1f469-1f3fd-200d-1f3ed",
            "1f469-1f3fe-200d-1f3ed",
            "1f469-1f3ff-200d-1f3ed"
        ],
        a: "4.0"
    },
    {
        n: [
            "office worker"
        ],
        u: "1f9d1-200d-1f4bc",
        v: [
            "1f9d1-1f3fb-200d-1f4bc",
            "1f9d1-1f3fc-200d-1f4bc",
            "1f9d1-1f3fd-200d-1f4bc",
            "1f9d1-1f3fe-200d-1f4bc",
            "1f9d1-1f3ff-200d-1f4bc"
        ],
        a: "12.1"
    },
    {
        n: [
            "man office worker",
            "male-office-worker"
        ],
        u: "1f468-200d-1f4bc",
        v: [
            "1f468-1f3fb-200d-1f4bc",
            "1f468-1f3fc-200d-1f4bc",
            "1f468-1f3fd-200d-1f4bc",
            "1f468-1f3fe-200d-1f4bc",
            "1f468-1f3ff-200d-1f4bc"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman office worker",
            "female-office-worker"
        ],
        u: "1f469-200d-1f4bc",
        v: [
            "1f469-1f3fb-200d-1f4bc",
            "1f469-1f3fc-200d-1f4bc",
            "1f469-1f3fd-200d-1f4bc",
            "1f469-1f3fe-200d-1f4bc",
            "1f469-1f3ff-200d-1f4bc"
        ],
        a: "4.0"
    },
    {
        n: [
            "scientist"
        ],
        u: "1f9d1-200d-1f52c",
        v: [
            "1f9d1-1f3fb-200d-1f52c",
            "1f9d1-1f3fc-200d-1f52c",
            "1f9d1-1f3fd-200d-1f52c",
            "1f9d1-1f3fe-200d-1f52c",
            "1f9d1-1f3ff-200d-1f52c"
        ],
        a: "12.1"
    },
    {
        n: [
            "man scientist",
            "male-scientist"
        ],
        u: "1f468-200d-1f52c",
        v: [
            "1f468-1f3fb-200d-1f52c",
            "1f468-1f3fc-200d-1f52c",
            "1f468-1f3fd-200d-1f52c",
            "1f468-1f3fe-200d-1f52c",
            "1f468-1f3ff-200d-1f52c"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman scientist",
            "female-scientist"
        ],
        u: "1f469-200d-1f52c",
        v: [
            "1f469-1f3fb-200d-1f52c",
            "1f469-1f3fc-200d-1f52c",
            "1f469-1f3fd-200d-1f52c",
            "1f469-1f3fe-200d-1f52c",
            "1f469-1f3ff-200d-1f52c"
        ],
        a: "4.0"
    },
    {
        n: [
            "technologist"
        ],
        u: "1f9d1-200d-1f4bb",
        v: [
            "1f9d1-1f3fb-200d-1f4bb",
            "1f9d1-1f3fc-200d-1f4bb",
            "1f9d1-1f3fd-200d-1f4bb",
            "1f9d1-1f3fe-200d-1f4bb",
            "1f9d1-1f3ff-200d-1f4bb"
        ],
        a: "12.1"
    },
    {
        n: [
            "man technologist",
            "male-technologist"
        ],
        u: "1f468-200d-1f4bb",
        v: [
            "1f468-1f3fb-200d-1f4bb",
            "1f468-1f3fc-200d-1f4bb",
            "1f468-1f3fd-200d-1f4bb",
            "1f468-1f3fe-200d-1f4bb",
            "1f468-1f3ff-200d-1f4bb"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman technologist",
            "female-technologist"
        ],
        u: "1f469-200d-1f4bb",
        v: [
            "1f469-1f3fb-200d-1f4bb",
            "1f469-1f3fc-200d-1f4bb",
            "1f469-1f3fd-200d-1f4bb",
            "1f469-1f3fe-200d-1f4bb",
            "1f469-1f3ff-200d-1f4bb"
        ],
        a: "4.0"
    },
    {
        n: [
            "singer"
        ],
        u: "1f9d1-200d-1f3a4",
        v: [
            "1f9d1-1f3fb-200d-1f3a4",
            "1f9d1-1f3fc-200d-1f3a4",
            "1f9d1-1f3fd-200d-1f3a4",
            "1f9d1-1f3fe-200d-1f3a4",
            "1f9d1-1f3ff-200d-1f3a4"
        ],
        a: "12.1"
    },
    {
        n: [
            "man singer",
            "male-singer"
        ],
        u: "1f468-200d-1f3a4",
        v: [
            "1f468-1f3fb-200d-1f3a4",
            "1f468-1f3fc-200d-1f3a4",
            "1f468-1f3fd-200d-1f3a4",
            "1f468-1f3fe-200d-1f3a4",
            "1f468-1f3ff-200d-1f3a4"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman singer",
            "female-singer"
        ],
        u: "1f469-200d-1f3a4",
        v: [
            "1f469-1f3fb-200d-1f3a4",
            "1f469-1f3fc-200d-1f3a4",
            "1f469-1f3fd-200d-1f3a4",
            "1f469-1f3fe-200d-1f3a4",
            "1f469-1f3ff-200d-1f3a4"
        ],
        a: "4.0"
    },
    {
        n: [
            "artist"
        ],
        u: "1f9d1-200d-1f3a8",
        v: [
            "1f9d1-1f3fb-200d-1f3a8",
            "1f9d1-1f3fc-200d-1f3a8",
            "1f9d1-1f3fd-200d-1f3a8",
            "1f9d1-1f3fe-200d-1f3a8",
            "1f9d1-1f3ff-200d-1f3a8"
        ],
        a: "12.1"
    },
    {
        n: [
            "man artist",
            "male-artist"
        ],
        u: "1f468-200d-1f3a8",
        v: [
            "1f468-1f3fb-200d-1f3a8",
            "1f468-1f3fc-200d-1f3a8",
            "1f468-1f3fd-200d-1f3a8",
            "1f468-1f3fe-200d-1f3a8",
            "1f468-1f3ff-200d-1f3a8"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman artist",
            "female-artist"
        ],
        u: "1f469-200d-1f3a8",
        v: [
            "1f469-1f3fb-200d-1f3a8",
            "1f469-1f3fc-200d-1f3a8",
            "1f469-1f3fd-200d-1f3a8",
            "1f469-1f3fe-200d-1f3a8",
            "1f469-1f3ff-200d-1f3a8"
        ],
        a: "4.0"
    },
    {
        n: [
            "pilot"
        ],
        u: "1f9d1-200d-2708-fe0f",
        v: [
            "1f9d1-1f3fb-200d-2708-fe0f",
            "1f9d1-1f3fc-200d-2708-fe0f",
            "1f9d1-1f3fd-200d-2708-fe0f",
            "1f9d1-1f3fe-200d-2708-fe0f",
            "1f9d1-1f3ff-200d-2708-fe0f"
        ],
        a: "12.1"
    },
    {
        n: [
            "man pilot",
            "male-pilot"
        ],
        u: "1f468-200d-2708-fe0f",
        v: [
            "1f468-1f3fb-200d-2708-fe0f",
            "1f468-1f3fc-200d-2708-fe0f",
            "1f468-1f3fd-200d-2708-fe0f",
            "1f468-1f3fe-200d-2708-fe0f",
            "1f468-1f3ff-200d-2708-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman pilot",
            "female-pilot"
        ],
        u: "1f469-200d-2708-fe0f",
        v: [
            "1f469-1f3fb-200d-2708-fe0f",
            "1f469-1f3fc-200d-2708-fe0f",
            "1f469-1f3fd-200d-2708-fe0f",
            "1f469-1f3fe-200d-2708-fe0f",
            "1f469-1f3ff-200d-2708-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "astronaut"
        ],
        u: "1f9d1-200d-1f680",
        v: [
            "1f9d1-1f3fb-200d-1f680",
            "1f9d1-1f3fc-200d-1f680",
            "1f9d1-1f3fd-200d-1f680",
            "1f9d1-1f3fe-200d-1f680",
            "1f9d1-1f3ff-200d-1f680"
        ],
        a: "12.1"
    },
    {
        n: [
            "man astronaut",
            "male-astronaut"
        ],
        u: "1f468-200d-1f680",
        v: [
            "1f468-1f3fb-200d-1f680",
            "1f468-1f3fc-200d-1f680",
            "1f468-1f3fd-200d-1f680",
            "1f468-1f3fe-200d-1f680",
            "1f468-1f3ff-200d-1f680"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman astronaut",
            "female-astronaut"
        ],
        u: "1f469-200d-1f680",
        v: [
            "1f469-1f3fb-200d-1f680",
            "1f469-1f3fc-200d-1f680",
            "1f469-1f3fd-200d-1f680",
            "1f469-1f3fe-200d-1f680",
            "1f469-1f3ff-200d-1f680"
        ],
        a: "4.0"
    },
    {
        n: [
            "firefighter"
        ],
        u: "1f9d1-200d-1f692",
        v: [
            "1f9d1-1f3fb-200d-1f692",
            "1f9d1-1f3fc-200d-1f692",
            "1f9d1-1f3fd-200d-1f692",
            "1f9d1-1f3fe-200d-1f692",
            "1f9d1-1f3ff-200d-1f692"
        ],
        a: "12.1"
    },
    {
        n: [
            "man firefighter",
            "male-firefighter"
        ],
        u: "1f468-200d-1f692",
        v: [
            "1f468-1f3fb-200d-1f692",
            "1f468-1f3fc-200d-1f692",
            "1f468-1f3fd-200d-1f692",
            "1f468-1f3fe-200d-1f692",
            "1f468-1f3ff-200d-1f692"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman firefighter",
            "female-firefighter"
        ],
        u: "1f469-200d-1f692",
        v: [
            "1f469-1f3fb-200d-1f692",
            "1f469-1f3fc-200d-1f692",
            "1f469-1f3fd-200d-1f692",
            "1f469-1f3fe-200d-1f692",
            "1f469-1f3ff-200d-1f692"
        ],
        a: "4.0"
    },
    {
        n: [
            "cop",
            "police officer"
        ],
        u: "1f46e",
        v: [
            "1f46e-1f3fb",
            "1f46e-1f3fc",
            "1f46e-1f3fd",
            "1f46e-1f3fe",
            "1f46e-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man police officer",
            "male-police-officer"
        ],
        u: "1f46e-200d-2642-fe0f",
        v: [
            "1f46e-1f3fb-200d-2642-fe0f",
            "1f46e-1f3fc-200d-2642-fe0f",
            "1f46e-1f3fd-200d-2642-fe0f",
            "1f46e-1f3fe-200d-2642-fe0f",
            "1f46e-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman police officer",
            "female-police-officer"
        ],
        u: "1f46e-200d-2640-fe0f",
        v: [
            "1f46e-1f3fb-200d-2640-fe0f",
            "1f46e-1f3fc-200d-2640-fe0f",
            "1f46e-1f3fd-200d-2640-fe0f",
            "1f46e-1f3fe-200d-2640-fe0f",
            "1f46e-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "detective",
            "sleuth or spy"
        ],
        u: "1f575-fe0f",
        v: [
            "1f575-1f3fb",
            "1f575-1f3fc",
            "1f575-1f3fd",
            "1f575-1f3fe",
            "1f575-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man detective",
            "male-detective"
        ],
        u: "1f575-fe0f-200d-2642-fe0f",
        v: [
            "1f575-1f3fb-200d-2642-fe0f",
            "1f575-1f3fc-200d-2642-fe0f",
            "1f575-1f3fd-200d-2642-fe0f",
            "1f575-1f3fe-200d-2642-fe0f",
            "1f575-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman detective",
            "female-detective"
        ],
        u: "1f575-fe0f-200d-2640-fe0f",
        v: [
            "1f575-1f3fb-200d-2640-fe0f",
            "1f575-1f3fc-200d-2640-fe0f",
            "1f575-1f3fd-200d-2640-fe0f",
            "1f575-1f3fe-200d-2640-fe0f",
            "1f575-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "guardsman"
        ],
        u: "1f482",
        v: [
            "1f482-1f3fb",
            "1f482-1f3fc",
            "1f482-1f3fd",
            "1f482-1f3fe",
            "1f482-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man guard",
            "male-guard"
        ],
        u: "1f482-200d-2642-fe0f",
        v: [
            "1f482-1f3fb-200d-2642-fe0f",
            "1f482-1f3fc-200d-2642-fe0f",
            "1f482-1f3fd-200d-2642-fe0f",
            "1f482-1f3fe-200d-2642-fe0f",
            "1f482-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman guard",
            "female-guard"
        ],
        u: "1f482-200d-2640-fe0f",
        v: [
            "1f482-1f3fb-200d-2640-fe0f",
            "1f482-1f3fc-200d-2640-fe0f",
            "1f482-1f3fd-200d-2640-fe0f",
            "1f482-1f3fe-200d-2640-fe0f",
            "1f482-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "ninja"
        ],
        u: "1f977",
        v: [
            "1f977-1f3fb",
            "1f977-1f3fc",
            "1f977-1f3fd",
            "1f977-1f3fe",
            "1f977-1f3ff"
        ],
        a: "13.0"
    },
    {
        n: [
            "construction worker"
        ],
        u: "1f477",
        v: [
            "1f477-1f3fb",
            "1f477-1f3fc",
            "1f477-1f3fd",
            "1f477-1f3fe",
            "1f477-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man construction worker",
            "male-construction-worker"
        ],
        u: "1f477-200d-2642-fe0f",
        v: [
            "1f477-1f3fb-200d-2642-fe0f",
            "1f477-1f3fc-200d-2642-fe0f",
            "1f477-1f3fd-200d-2642-fe0f",
            "1f477-1f3fe-200d-2642-fe0f",
            "1f477-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman construction worker",
            "female-construction-worker"
        ],
        u: "1f477-200d-2640-fe0f",
        v: [
            "1f477-1f3fb-200d-2640-fe0f",
            "1f477-1f3fc-200d-2640-fe0f",
            "1f477-1f3fd-200d-2640-fe0f",
            "1f477-1f3fe-200d-2640-fe0f",
            "1f477-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person with crown"
        ],
        u: "1fac5",
        v: [
            "1fac5-1f3fb",
            "1fac5-1f3fc",
            "1fac5-1f3fd",
            "1fac5-1f3fe",
            "1fac5-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "prince"
        ],
        u: "1f934",
        v: [
            "1f934-1f3fb",
            "1f934-1f3fc",
            "1f934-1f3fd",
            "1f934-1f3fe",
            "1f934-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "princess"
        ],
        u: "1f478",
        v: [
            "1f478-1f3fb",
            "1f478-1f3fc",
            "1f478-1f3fd",
            "1f478-1f3fe",
            "1f478-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man with turban"
        ],
        u: "1f473",
        v: [
            "1f473-1f3fb",
            "1f473-1f3fc",
            "1f473-1f3fd",
            "1f473-1f3fe",
            "1f473-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man wearing turban",
            "man-wearing-turban"
        ],
        u: "1f473-200d-2642-fe0f",
        v: [
            "1f473-1f3fb-200d-2642-fe0f",
            "1f473-1f3fc-200d-2642-fe0f",
            "1f473-1f3fd-200d-2642-fe0f",
            "1f473-1f3fe-200d-2642-fe0f",
            "1f473-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman wearing turban",
            "woman-wearing-turban"
        ],
        u: "1f473-200d-2640-fe0f",
        v: [
            "1f473-1f3fb-200d-2640-fe0f",
            "1f473-1f3fc-200d-2640-fe0f",
            "1f473-1f3fd-200d-2640-fe0f",
            "1f473-1f3fe-200d-2640-fe0f",
            "1f473-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "man with gua pi mao"
        ],
        u: "1f472",
        v: [
            "1f472-1f3fb",
            "1f472-1f3fc",
            "1f472-1f3fd",
            "1f472-1f3fe",
            "1f472-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "person with headscarf"
        ],
        u: "1f9d5",
        v: [
            "1f9d5-1f3fb",
            "1f9d5-1f3fc",
            "1f9d5-1f3fd",
            "1f9d5-1f3fe",
            "1f9d5-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man in tuxedo",
            "person in tuxedo"
        ],
        u: "1f935",
        v: [
            "1f935-1f3fb",
            "1f935-1f3fc",
            "1f935-1f3fd",
            "1f935-1f3fe",
            "1f935-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man in tuxedo"
        ],
        u: "1f935-200d-2642-fe0f",
        v: [
            "1f935-1f3fb-200d-2642-fe0f",
            "1f935-1f3fc-200d-2642-fe0f",
            "1f935-1f3fd-200d-2642-fe0f",
            "1f935-1f3fe-200d-2642-fe0f",
            "1f935-1f3ff-200d-2642-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "woman in tuxedo"
        ],
        u: "1f935-200d-2640-fe0f",
        v: [
            "1f935-1f3fb-200d-2640-fe0f",
            "1f935-1f3fc-200d-2640-fe0f",
            "1f935-1f3fd-200d-2640-fe0f",
            "1f935-1f3fe-200d-2640-fe0f",
            "1f935-1f3ff-200d-2640-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "bride with veil"
        ],
        u: "1f470",
        v: [
            "1f470-1f3fb",
            "1f470-1f3fc",
            "1f470-1f3fd",
            "1f470-1f3fe",
            "1f470-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man with veil"
        ],
        u: "1f470-200d-2642-fe0f",
        v: [
            "1f470-1f3fb-200d-2642-fe0f",
            "1f470-1f3fc-200d-2642-fe0f",
            "1f470-1f3fd-200d-2642-fe0f",
            "1f470-1f3fe-200d-2642-fe0f",
            "1f470-1f3ff-200d-2642-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "woman with veil"
        ],
        u: "1f470-200d-2640-fe0f",
        v: [
            "1f470-1f3fb-200d-2640-fe0f",
            "1f470-1f3fc-200d-2640-fe0f",
            "1f470-1f3fd-200d-2640-fe0f",
            "1f470-1f3fe-200d-2640-fe0f",
            "1f470-1f3ff-200d-2640-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "pregnant woman"
        ],
        u: "1f930",
        v: [
            "1f930-1f3fb",
            "1f930-1f3fc",
            "1f930-1f3fd",
            "1f930-1f3fe",
            "1f930-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "pregnant man"
        ],
        u: "1fac3",
        v: [
            "1fac3-1f3fb",
            "1fac3-1f3fc",
            "1fac3-1f3fd",
            "1fac3-1f3fe",
            "1fac3-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "pregnant person"
        ],
        u: "1fac4",
        v: [
            "1fac4-1f3fb",
            "1fac4-1f3fc",
            "1fac4-1f3fd",
            "1fac4-1f3fe",
            "1fac4-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "breast-feeding"
        ],
        u: "1f931",
        v: [
            "1f931-1f3fb",
            "1f931-1f3fc",
            "1f931-1f3fd",
            "1f931-1f3fe",
            "1f931-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman feeding baby"
        ],
        u: "1f469-200d-1f37c",
        v: [
            "1f469-1f3fb-200d-1f37c",
            "1f469-1f3fc-200d-1f37c",
            "1f469-1f3fd-200d-1f37c",
            "1f469-1f3fe-200d-1f37c",
            "1f469-1f3ff-200d-1f37c"
        ],
        a: "13.0"
    },
    {
        n: [
            "man feeding baby"
        ],
        u: "1f468-200d-1f37c",
        v: [
            "1f468-1f3fb-200d-1f37c",
            "1f468-1f3fc-200d-1f37c",
            "1f468-1f3fd-200d-1f37c",
            "1f468-1f3fe-200d-1f37c",
            "1f468-1f3ff-200d-1f37c"
        ],
        a: "13.0"
    },
    {
        n: [
            "person feeding baby"
        ],
        u: "1f9d1-200d-1f37c",
        v: [
            "1f9d1-1f3fb-200d-1f37c",
            "1f9d1-1f3fc-200d-1f37c",
            "1f9d1-1f3fd-200d-1f37c",
            "1f9d1-1f3fe-200d-1f37c",
            "1f9d1-1f3ff-200d-1f37c"
        ],
        a: "13.0"
    },
    {
        n: [
            "angel",
            "baby angel"
        ],
        u: "1f47c",
        v: [
            "1f47c-1f3fb",
            "1f47c-1f3fc",
            "1f47c-1f3fd",
            "1f47c-1f3fe",
            "1f47c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "santa",
            "father christmas"
        ],
        u: "1f385",
        v: [
            "1f385-1f3fb",
            "1f385-1f3fc",
            "1f385-1f3fd",
            "1f385-1f3fe",
            "1f385-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "mrs claus",
            "mother christmas"
        ],
        u: "1f936",
        v: [
            "1f936-1f3fb",
            "1f936-1f3fc",
            "1f936-1f3fd",
            "1f936-1f3fe",
            "1f936-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "mx claus"
        ],
        u: "1f9d1-200d-1f384",
        v: [
            "1f9d1-1f3fb-200d-1f384",
            "1f9d1-1f3fc-200d-1f384",
            "1f9d1-1f3fd-200d-1f384",
            "1f9d1-1f3fe-200d-1f384",
            "1f9d1-1f3ff-200d-1f384"
        ],
        a: "13.0"
    },
    {
        n: [
            "superhero"
        ],
        u: "1f9b8",
        v: [
            "1f9b8-1f3fb",
            "1f9b8-1f3fc",
            "1f9b8-1f3fd",
            "1f9b8-1f3fe",
            "1f9b8-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "man superhero",
            "male superhero"
        ],
        u: "1f9b8-200d-2642-fe0f",
        v: [
            "1f9b8-1f3fb-200d-2642-fe0f",
            "1f9b8-1f3fc-200d-2642-fe0f",
            "1f9b8-1f3fd-200d-2642-fe0f",
            "1f9b8-1f3fe-200d-2642-fe0f",
            "1f9b8-1f3ff-200d-2642-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "woman superhero",
            "female superhero"
        ],
        u: "1f9b8-200d-2640-fe0f",
        v: [
            "1f9b8-1f3fb-200d-2640-fe0f",
            "1f9b8-1f3fc-200d-2640-fe0f",
            "1f9b8-1f3fd-200d-2640-fe0f",
            "1f9b8-1f3fe-200d-2640-fe0f",
            "1f9b8-1f3ff-200d-2640-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "supervillain"
        ],
        u: "1f9b9",
        v: [
            "1f9b9-1f3fb",
            "1f9b9-1f3fc",
            "1f9b9-1f3fd",
            "1f9b9-1f3fe",
            "1f9b9-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "man supervillain",
            "male supervillain"
        ],
        u: "1f9b9-200d-2642-fe0f",
        v: [
            "1f9b9-1f3fb-200d-2642-fe0f",
            "1f9b9-1f3fc-200d-2642-fe0f",
            "1f9b9-1f3fd-200d-2642-fe0f",
            "1f9b9-1f3fe-200d-2642-fe0f",
            "1f9b9-1f3ff-200d-2642-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "woman supervillain",
            "female supervillain"
        ],
        u: "1f9b9-200d-2640-fe0f",
        v: [
            "1f9b9-1f3fb-200d-2640-fe0f",
            "1f9b9-1f3fc-200d-2640-fe0f",
            "1f9b9-1f3fd-200d-2640-fe0f",
            "1f9b9-1f3fe-200d-2640-fe0f",
            "1f9b9-1f3ff-200d-2640-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "mage"
        ],
        u: "1f9d9",
        v: [
            "1f9d9-1f3fb",
            "1f9d9-1f3fc",
            "1f9d9-1f3fd",
            "1f9d9-1f3fe",
            "1f9d9-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man mage",
            "male mage"
        ],
        u: "1f9d9-200d-2642-fe0f",
        v: [
            "1f9d9-1f3fb-200d-2642-fe0f",
            "1f9d9-1f3fc-200d-2642-fe0f",
            "1f9d9-1f3fd-200d-2642-fe0f",
            "1f9d9-1f3fe-200d-2642-fe0f",
            "1f9d9-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman mage",
            "female mage"
        ],
        u: "1f9d9-200d-2640-fe0f",
        v: [
            "1f9d9-1f3fb-200d-2640-fe0f",
            "1f9d9-1f3fc-200d-2640-fe0f",
            "1f9d9-1f3fd-200d-2640-fe0f",
            "1f9d9-1f3fe-200d-2640-fe0f",
            "1f9d9-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "fairy"
        ],
        u: "1f9da",
        v: [
            "1f9da-1f3fb",
            "1f9da-1f3fc",
            "1f9da-1f3fd",
            "1f9da-1f3fe",
            "1f9da-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man fairy",
            "male fairy"
        ],
        u: "1f9da-200d-2642-fe0f",
        v: [
            "1f9da-1f3fb-200d-2642-fe0f",
            "1f9da-1f3fc-200d-2642-fe0f",
            "1f9da-1f3fd-200d-2642-fe0f",
            "1f9da-1f3fe-200d-2642-fe0f",
            "1f9da-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman fairy",
            "female fairy"
        ],
        u: "1f9da-200d-2640-fe0f",
        v: [
            "1f9da-1f3fb-200d-2640-fe0f",
            "1f9da-1f3fc-200d-2640-fe0f",
            "1f9da-1f3fd-200d-2640-fe0f",
            "1f9da-1f3fe-200d-2640-fe0f",
            "1f9da-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "vampire"
        ],
        u: "1f9db",
        v: [
            "1f9db-1f3fb",
            "1f9db-1f3fc",
            "1f9db-1f3fd",
            "1f9db-1f3fe",
            "1f9db-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man vampire",
            "male vampire"
        ],
        u: "1f9db-200d-2642-fe0f",
        v: [
            "1f9db-1f3fb-200d-2642-fe0f",
            "1f9db-1f3fc-200d-2642-fe0f",
            "1f9db-1f3fd-200d-2642-fe0f",
            "1f9db-1f3fe-200d-2642-fe0f",
            "1f9db-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman vampire",
            "female vampire"
        ],
        u: "1f9db-200d-2640-fe0f",
        v: [
            "1f9db-1f3fb-200d-2640-fe0f",
            "1f9db-1f3fc-200d-2640-fe0f",
            "1f9db-1f3fd-200d-2640-fe0f",
            "1f9db-1f3fe-200d-2640-fe0f",
            "1f9db-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "merperson"
        ],
        u: "1f9dc",
        v: [
            "1f9dc-1f3fb",
            "1f9dc-1f3fc",
            "1f9dc-1f3fd",
            "1f9dc-1f3fe",
            "1f9dc-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "merman"
        ],
        u: "1f9dc-200d-2642-fe0f",
        v: [
            "1f9dc-1f3fb-200d-2642-fe0f",
            "1f9dc-1f3fc-200d-2642-fe0f",
            "1f9dc-1f3fd-200d-2642-fe0f",
            "1f9dc-1f3fe-200d-2642-fe0f",
            "1f9dc-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "mermaid"
        ],
        u: "1f9dc-200d-2640-fe0f",
        v: [
            "1f9dc-1f3fb-200d-2640-fe0f",
            "1f9dc-1f3fc-200d-2640-fe0f",
            "1f9dc-1f3fd-200d-2640-fe0f",
            "1f9dc-1f3fe-200d-2640-fe0f",
            "1f9dc-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "elf"
        ],
        u: "1f9dd",
        v: [
            "1f9dd-1f3fb",
            "1f9dd-1f3fc",
            "1f9dd-1f3fd",
            "1f9dd-1f3fe",
            "1f9dd-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man elf",
            "male elf"
        ],
        u: "1f9dd-200d-2642-fe0f",
        v: [
            "1f9dd-1f3fb-200d-2642-fe0f",
            "1f9dd-1f3fc-200d-2642-fe0f",
            "1f9dd-1f3fd-200d-2642-fe0f",
            "1f9dd-1f3fe-200d-2642-fe0f",
            "1f9dd-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman elf",
            "female elf"
        ],
        u: "1f9dd-200d-2640-fe0f",
        v: [
            "1f9dd-1f3fb-200d-2640-fe0f",
            "1f9dd-1f3fc-200d-2640-fe0f",
            "1f9dd-1f3fd-200d-2640-fe0f",
            "1f9dd-1f3fe-200d-2640-fe0f",
            "1f9dd-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "genie"
        ],
        u: "1f9de",
        a: "5.0"
    },
    {
        n: [
            "man genie",
            "male genie"
        ],
        u: "1f9de-200d-2642-fe0f",
        a: "5.0"
    },
    {
        n: [
            "woman genie",
            "female genie"
        ],
        u: "1f9de-200d-2640-fe0f",
        a: "5.0"
    },
    {
        n: [
            "zombie"
        ],
        u: "1f9df",
        a: "5.0"
    },
    {
        n: [
            "man zombie",
            "male zombie"
        ],
        u: "1f9df-200d-2642-fe0f",
        a: "5.0"
    },
    {
        n: [
            "woman zombie",
            "female zombie"
        ],
        u: "1f9df-200d-2640-fe0f",
        a: "5.0"
    },
    {
        n: [
            "troll"
        ],
        u: "1f9cc",
        a: "14.0"
    },
    {
        n: [
            "massage",
            "face massage"
        ],
        u: "1f486",
        v: [
            "1f486-1f3fb",
            "1f486-1f3fc",
            "1f486-1f3fd",
            "1f486-1f3fe",
            "1f486-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man getting massage",
            "man-getting-massage"
        ],
        u: "1f486-200d-2642-fe0f",
        v: [
            "1f486-1f3fb-200d-2642-fe0f",
            "1f486-1f3fc-200d-2642-fe0f",
            "1f486-1f3fd-200d-2642-fe0f",
            "1f486-1f3fe-200d-2642-fe0f",
            "1f486-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman getting massage",
            "woman-getting-massage"
        ],
        u: "1f486-200d-2640-fe0f",
        v: [
            "1f486-1f3fb-200d-2640-fe0f",
            "1f486-1f3fc-200d-2640-fe0f",
            "1f486-1f3fd-200d-2640-fe0f",
            "1f486-1f3fe-200d-2640-fe0f",
            "1f486-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "haircut"
        ],
        u: "1f487",
        v: [
            "1f487-1f3fb",
            "1f487-1f3fc",
            "1f487-1f3fd",
            "1f487-1f3fe",
            "1f487-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man getting haircut",
            "man-getting-haircut"
        ],
        u: "1f487-200d-2642-fe0f",
        v: [
            "1f487-1f3fb-200d-2642-fe0f",
            "1f487-1f3fc-200d-2642-fe0f",
            "1f487-1f3fd-200d-2642-fe0f",
            "1f487-1f3fe-200d-2642-fe0f",
            "1f487-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman getting haircut",
            "woman-getting-haircut"
        ],
        u: "1f487-200d-2640-fe0f",
        v: [
            "1f487-1f3fb-200d-2640-fe0f",
            "1f487-1f3fc-200d-2640-fe0f",
            "1f487-1f3fd-200d-2640-fe0f",
            "1f487-1f3fe-200d-2640-fe0f",
            "1f487-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "walking",
            "pedestrian"
        ],
        u: "1f6b6",
        v: [
            "1f6b6-1f3fb",
            "1f6b6-1f3fc",
            "1f6b6-1f3fd",
            "1f6b6-1f3fe",
            "1f6b6-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man walking",
            "man-walking"
        ],
        u: "1f6b6-200d-2642-fe0f",
        v: [
            "1f6b6-1f3fb-200d-2642-fe0f",
            "1f6b6-1f3fc-200d-2642-fe0f",
            "1f6b6-1f3fd-200d-2642-fe0f",
            "1f6b6-1f3fe-200d-2642-fe0f",
            "1f6b6-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman walking",
            "woman-walking"
        ],
        u: "1f6b6-200d-2640-fe0f",
        v: [
            "1f6b6-1f3fb-200d-2640-fe0f",
            "1f6b6-1f3fc-200d-2640-fe0f",
            "1f6b6-1f3fd-200d-2640-fe0f",
            "1f6b6-1f3fe-200d-2640-fe0f",
            "1f6b6-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "standing person"
        ],
        u: "1f9cd",
        v: [
            "1f9cd-1f3fb",
            "1f9cd-1f3fc",
            "1f9cd-1f3fd",
            "1f9cd-1f3fe",
            "1f9cd-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "man standing"
        ],
        u: "1f9cd-200d-2642-fe0f",
        v: [
            "1f9cd-1f3fb-200d-2642-fe0f",
            "1f9cd-1f3fc-200d-2642-fe0f",
            "1f9cd-1f3fd-200d-2642-fe0f",
            "1f9cd-1f3fe-200d-2642-fe0f",
            "1f9cd-1f3ff-200d-2642-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman standing"
        ],
        u: "1f9cd-200d-2640-fe0f",
        v: [
            "1f9cd-1f3fb-200d-2640-fe0f",
            "1f9cd-1f3fc-200d-2640-fe0f",
            "1f9cd-1f3fd-200d-2640-fe0f",
            "1f9cd-1f3fe-200d-2640-fe0f",
            "1f9cd-1f3ff-200d-2640-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "kneeling person"
        ],
        u: "1f9ce",
        v: [
            "1f9ce-1f3fb",
            "1f9ce-1f3fc",
            "1f9ce-1f3fd",
            "1f9ce-1f3fe",
            "1f9ce-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "man kneeling"
        ],
        u: "1f9ce-200d-2642-fe0f",
        v: [
            "1f9ce-1f3fb-200d-2642-fe0f",
            "1f9ce-1f3fc-200d-2642-fe0f",
            "1f9ce-1f3fd-200d-2642-fe0f",
            "1f9ce-1f3fe-200d-2642-fe0f",
            "1f9ce-1f3ff-200d-2642-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman kneeling"
        ],
        u: "1f9ce-200d-2640-fe0f",
        v: [
            "1f9ce-1f3fb-200d-2640-fe0f",
            "1f9ce-1f3fc-200d-2640-fe0f",
            "1f9ce-1f3fd-200d-2640-fe0f",
            "1f9ce-1f3fe-200d-2640-fe0f",
            "1f9ce-1f3ff-200d-2640-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "person with white cane",
            "person with probing cane"
        ],
        u: "1f9d1-200d-1f9af",
        v: [
            "1f9d1-1f3fb-200d-1f9af",
            "1f9d1-1f3fc-200d-1f9af",
            "1f9d1-1f3fd-200d-1f9af",
            "1f9d1-1f3fe-200d-1f9af",
            "1f9d1-1f3ff-200d-1f9af"
        ],
        a: "12.1"
    },
    {
        n: [
            "man with white cane",
            "man with probing cane"
        ],
        u: "1f468-200d-1f9af",
        v: [
            "1f468-1f3fb-200d-1f9af",
            "1f468-1f3fc-200d-1f9af",
            "1f468-1f3fd-200d-1f9af",
            "1f468-1f3fe-200d-1f9af",
            "1f468-1f3ff-200d-1f9af"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman with white cane",
            "woman with probing cane"
        ],
        u: "1f469-200d-1f9af",
        v: [
            "1f469-1f3fb-200d-1f9af",
            "1f469-1f3fc-200d-1f9af",
            "1f469-1f3fd-200d-1f9af",
            "1f469-1f3fe-200d-1f9af",
            "1f469-1f3ff-200d-1f9af"
        ],
        a: "12.0"
    },
    {
        n: [
            "person in motorized wheelchair"
        ],
        u: "1f9d1-200d-1f9bc",
        v: [
            "1f9d1-1f3fb-200d-1f9bc",
            "1f9d1-1f3fc-200d-1f9bc",
            "1f9d1-1f3fd-200d-1f9bc",
            "1f9d1-1f3fe-200d-1f9bc",
            "1f9d1-1f3ff-200d-1f9bc"
        ],
        a: "12.1"
    },
    {
        n: [
            "man in motorized wheelchair"
        ],
        u: "1f468-200d-1f9bc",
        v: [
            "1f468-1f3fb-200d-1f9bc",
            "1f468-1f3fc-200d-1f9bc",
            "1f468-1f3fd-200d-1f9bc",
            "1f468-1f3fe-200d-1f9bc",
            "1f468-1f3ff-200d-1f9bc"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman in motorized wheelchair"
        ],
        u: "1f469-200d-1f9bc",
        v: [
            "1f469-1f3fb-200d-1f9bc",
            "1f469-1f3fc-200d-1f9bc",
            "1f469-1f3fd-200d-1f9bc",
            "1f469-1f3fe-200d-1f9bc",
            "1f469-1f3ff-200d-1f9bc"
        ],
        a: "12.0"
    },
    {
        n: [
            "person in manual wheelchair"
        ],
        u: "1f9d1-200d-1f9bd",
        v: [
            "1f9d1-1f3fb-200d-1f9bd",
            "1f9d1-1f3fc-200d-1f9bd",
            "1f9d1-1f3fd-200d-1f9bd",
            "1f9d1-1f3fe-200d-1f9bd",
            "1f9d1-1f3ff-200d-1f9bd"
        ],
        a: "12.1"
    },
    {
        n: [
            "man in manual wheelchair"
        ],
        u: "1f468-200d-1f9bd",
        v: [
            "1f468-1f3fb-200d-1f9bd",
            "1f468-1f3fc-200d-1f9bd",
            "1f468-1f3fd-200d-1f9bd",
            "1f468-1f3fe-200d-1f9bd",
            "1f468-1f3ff-200d-1f9bd"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman in manual wheelchair"
        ],
        u: "1f469-200d-1f9bd",
        v: [
            "1f469-1f3fb-200d-1f9bd",
            "1f469-1f3fc-200d-1f9bd",
            "1f469-1f3fd-200d-1f9bd",
            "1f469-1f3fe-200d-1f9bd",
            "1f469-1f3ff-200d-1f9bd"
        ],
        a: "12.0"
    },
    {
        n: [
            "runner",
            "running"
        ],
        u: "1f3c3",
        v: [
            "1f3c3-1f3fb",
            "1f3c3-1f3fc",
            "1f3c3-1f3fd",
            "1f3c3-1f3fe",
            "1f3c3-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man running",
            "man-running"
        ],
        u: "1f3c3-200d-2642-fe0f",
        v: [
            "1f3c3-1f3fb-200d-2642-fe0f",
            "1f3c3-1f3fc-200d-2642-fe0f",
            "1f3c3-1f3fd-200d-2642-fe0f",
            "1f3c3-1f3fe-200d-2642-fe0f",
            "1f3c3-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman running",
            "woman-running"
        ],
        u: "1f3c3-200d-2640-fe0f",
        v: [
            "1f3c3-1f3fb-200d-2640-fe0f",
            "1f3c3-1f3fc-200d-2640-fe0f",
            "1f3c3-1f3fd-200d-2640-fe0f",
            "1f3c3-1f3fe-200d-2640-fe0f",
            "1f3c3-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "dancer"
        ],
        u: "1f483",
        v: [
            "1f483-1f3fb",
            "1f483-1f3fc",
            "1f483-1f3fd",
            "1f483-1f3fe",
            "1f483-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man dancing"
        ],
        u: "1f57a",
        v: [
            "1f57a-1f3fb",
            "1f57a-1f3fc",
            "1f57a-1f3fd",
            "1f57a-1f3fe",
            "1f57a-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "person in suit levitating",
            "man in business suit levitating"
        ],
        u: "1f574-fe0f",
        v: [
            "1f574-1f3fb",
            "1f574-1f3fc",
            "1f574-1f3fd",
            "1f574-1f3fe",
            "1f574-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "dancers",
            "woman with bunny ears"
        ],
        u: "1f46f",
        a: "0.6"
    },
    {
        n: [
            "men with bunny ears",
            "men-with-bunny-ears-partying",
            "man-with-bunny-ears-partying"
        ],
        u: "1f46f-200d-2642-fe0f",
        a: "4.0"
    },
    {
        n: [
            "women with bunny ears",
            "women-with-bunny-ears-partying",
            "woman-with-bunny-ears-partying"
        ],
        u: "1f46f-200d-2640-fe0f",
        a: "4.0"
    },
    {
        n: [
            "person in steamy room"
        ],
        u: "1f9d6",
        v: [
            "1f9d6-1f3fb",
            "1f9d6-1f3fc",
            "1f9d6-1f3fd",
            "1f9d6-1f3fe",
            "1f9d6-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man in steamy room"
        ],
        u: "1f9d6-200d-2642-fe0f",
        v: [
            "1f9d6-1f3fb-200d-2642-fe0f",
            "1f9d6-1f3fc-200d-2642-fe0f",
            "1f9d6-1f3fd-200d-2642-fe0f",
            "1f9d6-1f3fe-200d-2642-fe0f",
            "1f9d6-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman in steamy room"
        ],
        u: "1f9d6-200d-2640-fe0f",
        v: [
            "1f9d6-1f3fb-200d-2640-fe0f",
            "1f9d6-1f3fc-200d-2640-fe0f",
            "1f9d6-1f3fd-200d-2640-fe0f",
            "1f9d6-1f3fe-200d-2640-fe0f",
            "1f9d6-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "person climbing"
        ],
        u: "1f9d7",
        v: [
            "1f9d7-1f3fb",
            "1f9d7-1f3fc",
            "1f9d7-1f3fd",
            "1f9d7-1f3fe",
            "1f9d7-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man climbing"
        ],
        u: "1f9d7-200d-2642-fe0f",
        v: [
            "1f9d7-1f3fb-200d-2642-fe0f",
            "1f9d7-1f3fc-200d-2642-fe0f",
            "1f9d7-1f3fd-200d-2642-fe0f",
            "1f9d7-1f3fe-200d-2642-fe0f",
            "1f9d7-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman climbing"
        ],
        u: "1f9d7-200d-2640-fe0f",
        v: [
            "1f9d7-1f3fb-200d-2640-fe0f",
            "1f9d7-1f3fc-200d-2640-fe0f",
            "1f9d7-1f3fd-200d-2640-fe0f",
            "1f9d7-1f3fe-200d-2640-fe0f",
            "1f9d7-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "fencer"
        ],
        u: "1f93a",
        a: "3.0"
    },
    {
        n: [
            "horse racing"
        ],
        u: "1f3c7",
        v: [
            "1f3c7-1f3fb",
            "1f3c7-1f3fc",
            "1f3c7-1f3fd",
            "1f3c7-1f3fe",
            "1f3c7-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "skier"
        ],
        u: "26f7-fe0f",
        a: "0.7"
    },
    {
        n: [
            "snowboarder"
        ],
        u: "1f3c2",
        v: [
            "1f3c2-1f3fb",
            "1f3c2-1f3fc",
            "1f3c2-1f3fd",
            "1f3c2-1f3fe",
            "1f3c2-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "golfer",
            "person golfing"
        ],
        u: "1f3cc-fe0f",
        v: [
            "1f3cc-1f3fb",
            "1f3cc-1f3fc",
            "1f3cc-1f3fd",
            "1f3cc-1f3fe",
            "1f3cc-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man golfing",
            "man-golfing"
        ],
        u: "1f3cc-fe0f-200d-2642-fe0f",
        v: [
            "1f3cc-1f3fb-200d-2642-fe0f",
            "1f3cc-1f3fc-200d-2642-fe0f",
            "1f3cc-1f3fd-200d-2642-fe0f",
            "1f3cc-1f3fe-200d-2642-fe0f",
            "1f3cc-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman golfing",
            "woman-golfing"
        ],
        u: "1f3cc-fe0f-200d-2640-fe0f",
        v: [
            "1f3cc-1f3fb-200d-2640-fe0f",
            "1f3cc-1f3fc-200d-2640-fe0f",
            "1f3cc-1f3fd-200d-2640-fe0f",
            "1f3cc-1f3fe-200d-2640-fe0f",
            "1f3cc-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "surfer"
        ],
        u: "1f3c4",
        v: [
            "1f3c4-1f3fb",
            "1f3c4-1f3fc",
            "1f3c4-1f3fd",
            "1f3c4-1f3fe",
            "1f3c4-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man surfing",
            "man-surfing"
        ],
        u: "1f3c4-200d-2642-fe0f",
        v: [
            "1f3c4-1f3fb-200d-2642-fe0f",
            "1f3c4-1f3fc-200d-2642-fe0f",
            "1f3c4-1f3fd-200d-2642-fe0f",
            "1f3c4-1f3fe-200d-2642-fe0f",
            "1f3c4-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman surfing",
            "woman-surfing"
        ],
        u: "1f3c4-200d-2640-fe0f",
        v: [
            "1f3c4-1f3fb-200d-2640-fe0f",
            "1f3c4-1f3fc-200d-2640-fe0f",
            "1f3c4-1f3fd-200d-2640-fe0f",
            "1f3c4-1f3fe-200d-2640-fe0f",
            "1f3c4-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "rowboat"
        ],
        u: "1f6a3",
        v: [
            "1f6a3-1f3fb",
            "1f6a3-1f3fc",
            "1f6a3-1f3fd",
            "1f6a3-1f3fe",
            "1f6a3-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "man rowing boat",
            "man-rowing-boat"
        ],
        u: "1f6a3-200d-2642-fe0f",
        v: [
            "1f6a3-1f3fb-200d-2642-fe0f",
            "1f6a3-1f3fc-200d-2642-fe0f",
            "1f6a3-1f3fd-200d-2642-fe0f",
            "1f6a3-1f3fe-200d-2642-fe0f",
            "1f6a3-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman rowing boat",
            "woman-rowing-boat"
        ],
        u: "1f6a3-200d-2640-fe0f",
        v: [
            "1f6a3-1f3fb-200d-2640-fe0f",
            "1f6a3-1f3fc-200d-2640-fe0f",
            "1f6a3-1f3fd-200d-2640-fe0f",
            "1f6a3-1f3fe-200d-2640-fe0f",
            "1f6a3-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "swimmer"
        ],
        u: "1f3ca",
        v: [
            "1f3ca-1f3fb",
            "1f3ca-1f3fc",
            "1f3ca-1f3fd",
            "1f3ca-1f3fe",
            "1f3ca-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man swimming",
            "man-swimming"
        ],
        u: "1f3ca-200d-2642-fe0f",
        v: [
            "1f3ca-1f3fb-200d-2642-fe0f",
            "1f3ca-1f3fc-200d-2642-fe0f",
            "1f3ca-1f3fd-200d-2642-fe0f",
            "1f3ca-1f3fe-200d-2642-fe0f",
            "1f3ca-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman swimming",
            "woman-swimming"
        ],
        u: "1f3ca-200d-2640-fe0f",
        v: [
            "1f3ca-1f3fb-200d-2640-fe0f",
            "1f3ca-1f3fc-200d-2640-fe0f",
            "1f3ca-1f3fd-200d-2640-fe0f",
            "1f3ca-1f3fe-200d-2640-fe0f",
            "1f3ca-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person with ball",
            "person bouncing ball"
        ],
        u: "26f9-fe0f",
        v: [
            "26f9-1f3fb",
            "26f9-1f3fc",
            "26f9-1f3fd",
            "26f9-1f3fe",
            "26f9-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man bouncing ball",
            "man-bouncing-ball"
        ],
        u: "26f9-fe0f-200d-2642-fe0f",
        v: [
            "26f9-1f3fb-200d-2642-fe0f",
            "26f9-1f3fc-200d-2642-fe0f",
            "26f9-1f3fd-200d-2642-fe0f",
            "26f9-1f3fe-200d-2642-fe0f",
            "26f9-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman bouncing ball",
            "woman-bouncing-ball"
        ],
        u: "26f9-fe0f-200d-2640-fe0f",
        v: [
            "26f9-1f3fb-200d-2640-fe0f",
            "26f9-1f3fc-200d-2640-fe0f",
            "26f9-1f3fd-200d-2640-fe0f",
            "26f9-1f3fe-200d-2640-fe0f",
            "26f9-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "weight lifter",
            "person lifting weights"
        ],
        u: "1f3cb-fe0f",
        v: [
            "1f3cb-1f3fb",
            "1f3cb-1f3fc",
            "1f3cb-1f3fd",
            "1f3cb-1f3fe",
            "1f3cb-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man lifting weights",
            "man-lifting-weights"
        ],
        u: "1f3cb-fe0f-200d-2642-fe0f",
        v: [
            "1f3cb-1f3fb-200d-2642-fe0f",
            "1f3cb-1f3fc-200d-2642-fe0f",
            "1f3cb-1f3fd-200d-2642-fe0f",
            "1f3cb-1f3fe-200d-2642-fe0f",
            "1f3cb-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman lifting weights",
            "woman-lifting-weights"
        ],
        u: "1f3cb-fe0f-200d-2640-fe0f",
        v: [
            "1f3cb-1f3fb-200d-2640-fe0f",
            "1f3cb-1f3fc-200d-2640-fe0f",
            "1f3cb-1f3fd-200d-2640-fe0f",
            "1f3cb-1f3fe-200d-2640-fe0f",
            "1f3cb-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "bicyclist"
        ],
        u: "1f6b4",
        v: [
            "1f6b4-1f3fb",
            "1f6b4-1f3fc",
            "1f6b4-1f3fd",
            "1f6b4-1f3fe",
            "1f6b4-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "man biking",
            "man-biking"
        ],
        u: "1f6b4-200d-2642-fe0f",
        v: [
            "1f6b4-1f3fb-200d-2642-fe0f",
            "1f6b4-1f3fc-200d-2642-fe0f",
            "1f6b4-1f3fd-200d-2642-fe0f",
            "1f6b4-1f3fe-200d-2642-fe0f",
            "1f6b4-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman biking",
            "woman-biking"
        ],
        u: "1f6b4-200d-2640-fe0f",
        v: [
            "1f6b4-1f3fb-200d-2640-fe0f",
            "1f6b4-1f3fc-200d-2640-fe0f",
            "1f6b4-1f3fd-200d-2640-fe0f",
            "1f6b4-1f3fe-200d-2640-fe0f",
            "1f6b4-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "mountain bicyclist"
        ],
        u: "1f6b5",
        v: [
            "1f6b5-1f3fb",
            "1f6b5-1f3fc",
            "1f6b5-1f3fd",
            "1f6b5-1f3fe",
            "1f6b5-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "man mountain biking",
            "man-mountain-biking"
        ],
        u: "1f6b5-200d-2642-fe0f",
        v: [
            "1f6b5-1f3fb-200d-2642-fe0f",
            "1f6b5-1f3fc-200d-2642-fe0f",
            "1f6b5-1f3fd-200d-2642-fe0f",
            "1f6b5-1f3fe-200d-2642-fe0f",
            "1f6b5-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman mountain biking",
            "woman-mountain-biking"
        ],
        u: "1f6b5-200d-2640-fe0f",
        v: [
            "1f6b5-1f3fb-200d-2640-fe0f",
            "1f6b5-1f3fc-200d-2640-fe0f",
            "1f6b5-1f3fd-200d-2640-fe0f",
            "1f6b5-1f3fe-200d-2640-fe0f",
            "1f6b5-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person doing cartwheel"
        ],
        u: "1f938",
        v: [
            "1f938-1f3fb",
            "1f938-1f3fc",
            "1f938-1f3fd",
            "1f938-1f3fe",
            "1f938-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man cartwheeling",
            "man-cartwheeling"
        ],
        u: "1f938-200d-2642-fe0f",
        v: [
            "1f938-1f3fb-200d-2642-fe0f",
            "1f938-1f3fc-200d-2642-fe0f",
            "1f938-1f3fd-200d-2642-fe0f",
            "1f938-1f3fe-200d-2642-fe0f",
            "1f938-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman cartwheeling",
            "woman-cartwheeling"
        ],
        u: "1f938-200d-2640-fe0f",
        v: [
            "1f938-1f3fb-200d-2640-fe0f",
            "1f938-1f3fc-200d-2640-fe0f",
            "1f938-1f3fd-200d-2640-fe0f",
            "1f938-1f3fe-200d-2640-fe0f",
            "1f938-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "wrestlers"
        ],
        u: "1f93c",
        a: "3.0"
    },
    {
        n: [
            "men wrestling",
            "man-wrestling"
        ],
        u: "1f93c-200d-2642-fe0f",
        a: "4.0"
    },
    {
        n: [
            "women wrestling",
            "woman-wrestling"
        ],
        u: "1f93c-200d-2640-fe0f",
        a: "4.0"
    },
    {
        n: [
            "water polo"
        ],
        u: "1f93d",
        v: [
            "1f93d-1f3fb",
            "1f93d-1f3fc",
            "1f93d-1f3fd",
            "1f93d-1f3fe",
            "1f93d-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man playing water polo",
            "man-playing-water-polo"
        ],
        u: "1f93d-200d-2642-fe0f",
        v: [
            "1f93d-1f3fb-200d-2642-fe0f",
            "1f93d-1f3fc-200d-2642-fe0f",
            "1f93d-1f3fd-200d-2642-fe0f",
            "1f93d-1f3fe-200d-2642-fe0f",
            "1f93d-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman playing water polo",
            "woman-playing-water-polo"
        ],
        u: "1f93d-200d-2640-fe0f",
        v: [
            "1f93d-1f3fb-200d-2640-fe0f",
            "1f93d-1f3fc-200d-2640-fe0f",
            "1f93d-1f3fd-200d-2640-fe0f",
            "1f93d-1f3fe-200d-2640-fe0f",
            "1f93d-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "handball"
        ],
        u: "1f93e",
        v: [
            "1f93e-1f3fb",
            "1f93e-1f3fc",
            "1f93e-1f3fd",
            "1f93e-1f3fe",
            "1f93e-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man playing handball",
            "man-playing-handball"
        ],
        u: "1f93e-200d-2642-fe0f",
        v: [
            "1f93e-1f3fb-200d-2642-fe0f",
            "1f93e-1f3fc-200d-2642-fe0f",
            "1f93e-1f3fd-200d-2642-fe0f",
            "1f93e-1f3fe-200d-2642-fe0f",
            "1f93e-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman playing handball",
            "woman-playing-handball"
        ],
        u: "1f93e-200d-2640-fe0f",
        v: [
            "1f93e-1f3fb-200d-2640-fe0f",
            "1f93e-1f3fc-200d-2640-fe0f",
            "1f93e-1f3fd-200d-2640-fe0f",
            "1f93e-1f3fe-200d-2640-fe0f",
            "1f93e-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "juggling"
        ],
        u: "1f939",
        v: [
            "1f939-1f3fb",
            "1f939-1f3fc",
            "1f939-1f3fd",
            "1f939-1f3fe",
            "1f939-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man juggling",
            "man-juggling"
        ],
        u: "1f939-200d-2642-fe0f",
        v: [
            "1f939-1f3fb-200d-2642-fe0f",
            "1f939-1f3fc-200d-2642-fe0f",
            "1f939-1f3fd-200d-2642-fe0f",
            "1f939-1f3fe-200d-2642-fe0f",
            "1f939-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman juggling",
            "woman-juggling"
        ],
        u: "1f939-200d-2640-fe0f",
        v: [
            "1f939-1f3fb-200d-2640-fe0f",
            "1f939-1f3fc-200d-2640-fe0f",
            "1f939-1f3fd-200d-2640-fe0f",
            "1f939-1f3fe-200d-2640-fe0f",
            "1f939-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person in lotus position"
        ],
        u: "1f9d8",
        v: [
            "1f9d8-1f3fb",
            "1f9d8-1f3fc",
            "1f9d8-1f3fd",
            "1f9d8-1f3fe",
            "1f9d8-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man in lotus position"
        ],
        u: "1f9d8-200d-2642-fe0f",
        v: [
            "1f9d8-1f3fb-200d-2642-fe0f",
            "1f9d8-1f3fc-200d-2642-fe0f",
            "1f9d8-1f3fd-200d-2642-fe0f",
            "1f9d8-1f3fe-200d-2642-fe0f",
            "1f9d8-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman in lotus position"
        ],
        u: "1f9d8-200d-2640-fe0f",
        v: [
            "1f9d8-1f3fb-200d-2640-fe0f",
            "1f9d8-1f3fc-200d-2640-fe0f",
            "1f9d8-1f3fd-200d-2640-fe0f",
            "1f9d8-1f3fe-200d-2640-fe0f",
            "1f9d8-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "bath"
        ],
        u: "1f6c0",
        v: [
            "1f6c0-1f3fb",
            "1f6c0-1f3fc",
            "1f6c0-1f3fd",
            "1f6c0-1f3fe",
            "1f6c0-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "sleeping accommodation"
        ],
        u: "1f6cc",
        v: [
            "1f6cc-1f3fb",
            "1f6cc-1f3fc",
            "1f6cc-1f3fd",
            "1f6cc-1f3fe",
            "1f6cc-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "people holding hands"
        ],
        u: "1f9d1-200d-1f91d-200d-1f9d1",
        v: [
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "women holding hands",
            "two women holding hands"
        ],
        u: "1f46d",
        v: [
            "1f46d-1f3fb",
            "1f46d-1f3fc",
            "1f46d-1f3fd",
            "1f46d-1f3fe",
            "1f46d-1f3ff",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"
        ],
        a: "1.0"
    },
    {
        n: [
            "couple",
            "man and woman holding hands",
            "woman and man holding hands"
        ],
        u: "1f46b",
        v: [
            "1f46b-1f3fb",
            "1f46b-1f3fc",
            "1f46b-1f3fd",
            "1f46b-1f3fe",
            "1f46b-1f3ff",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"
        ],
        a: "0.6"
    },
    {
        n: [
            "men holding hands",
            "two men holding hands"
        ],
        u: "1f46c",
        v: [
            "1f46c-1f3fb",
            "1f46c-1f3fc",
            "1f46c-1f3fd",
            "1f46c-1f3fe",
            "1f46c-1f3ff",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"
        ],
        a: "1.0"
    },
    {
        n: [
            "kiss",
            "couplekiss"
        ],
        u: "1f48f",
        v: [
            "1f48f-1f3fb",
            "1f48f-1f3fc",
            "1f48f-1f3fd",
            "1f48f-1f3fe",
            "1f48f-1f3ff",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"
        ],
        a: "0.6"
    },
    {
        n: [
            "woman-kiss-man",
            "kiss: woman, man"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "man-kiss-man",
            "kiss: man, man"
        ],
        u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
        v: [
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "woman-kiss-woman",
            "kiss: woman, woman"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "couple with heart"
        ],
        u: "1f491",
        v: [
            "1f491-1f3fb",
            "1f491-1f3fc",
            "1f491-1f3fd",
            "1f491-1f3fe",
            "1f491-1f3ff",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"
        ],
        a: "0.6"
    },
    {
        n: [
            "woman-heart-man",
            "couple with heart: woman, man"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f468",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "man-heart-man",
            "couple with heart: man, man"
        ],
        u: "1f468-200d-2764-fe0f-200d-1f468",
        v: [
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "woman-heart-woman",
            "couple with heart: woman, woman"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f469",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "family"
        ],
        u: "1f46a",
        a: "0.6"
    },
    {
        n: [
            "man-woman-boy",
            "family: man, woman, boy"
        ],
        u: "1f468-200d-1f469-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-woman-girl",
            "family: man, woman, girl"
        ],
        u: "1f468-200d-1f469-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-woman-girl-boy",
            "family: man, woman, girl, boy"
        ],
        u: "1f468-200d-1f469-200d-1f467-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-woman-boy-boy",
            "family: man, woman, boy, boy"
        ],
        u: "1f468-200d-1f469-200d-1f466-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-woman-girl-girl",
            "family: man, woman, girl, girl"
        ],
        u: "1f468-200d-1f469-200d-1f467-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-man-boy",
            "family: man, man, boy"
        ],
        u: "1f468-200d-1f468-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-man-girl",
            "family: man, man, girl"
        ],
        u: "1f468-200d-1f468-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-man-girl-boy",
            "family: man, man, girl, boy"
        ],
        u: "1f468-200d-1f468-200d-1f467-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-man-boy-boy",
            "family: man, man, boy, boy"
        ],
        u: "1f468-200d-1f468-200d-1f466-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-man-girl-girl",
            "family: man, man, girl, girl"
        ],
        u: "1f468-200d-1f468-200d-1f467-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-boy",
            "family: woman, woman, boy"
        ],
        u: "1f469-200d-1f469-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-girl",
            "family: woman, woman, girl"
        ],
        u: "1f469-200d-1f469-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-girl-boy",
            "family: woman, woman, girl, boy"
        ],
        u: "1f469-200d-1f469-200d-1f467-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-boy-boy",
            "family: woman, woman, boy, boy"
        ],
        u: "1f469-200d-1f469-200d-1f466-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-girl-girl",
            "family: woman, woman, girl, girl"
        ],
        u: "1f469-200d-1f469-200d-1f467-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-boy",
            "family: man, boy"
        ],
        u: "1f468-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "man-boy-boy",
            "family: man, boy, boy"
        ],
        u: "1f468-200d-1f466-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "man-girl",
            "family: man, girl"
        ],
        u: "1f468-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "man-girl-boy",
            "family: man, girl, boy"
        ],
        u: "1f468-200d-1f467-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "man-girl-girl",
            "family: man, girl, girl"
        ],
        u: "1f468-200d-1f467-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "woman-boy",
            "family: woman, boy"
        ],
        u: "1f469-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "woman-boy-boy",
            "family: woman, boy, boy"
        ],
        u: "1f469-200d-1f466-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "woman-girl",
            "family: woman, girl"
        ],
        u: "1f469-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "woman-girl-boy",
            "family: woman, girl, boy"
        ],
        u: "1f469-200d-1f467-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "woman-girl-girl",
            "family: woman, girl, girl"
        ],
        u: "1f469-200d-1f467-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "speaking head",
            "speaking head in silhouette"
        ],
        u: "1f5e3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bust in silhouette"
        ],
        u: "1f464",
        a: "0.6"
    },
    {
        n: [
            "busts in silhouette"
        ],
        u: "1f465",
        a: "1.0"
    },
    {
        n: [
            "people hugging"
        ],
        u: "1fac2",
        a: "13.0"
    },
    {
        n: [
            "footprints"
        ],
        u: "1f463",
        a: "0.6"
    }
];
var animals_nature = [
    {
        n: [
            "monkey face"
        ],
        u: "1f435",
        a: "0.6"
    },
    {
        n: [
            "monkey"
        ],
        u: "1f412",
        a: "0.6"
    },
    {
        n: [
            "gorilla"
        ],
        u: "1f98d",
        a: "3.0"
    },
    {
        n: [
            "orangutan"
        ],
        u: "1f9a7",
        a: "12.0"
    },
    {
        n: [
            "dog",
            "dog face"
        ],
        u: "1f436",
        a: "0.6"
    },
    {
        n: [
            "dog",
            "dog2"
        ],
        u: "1f415",
        a: "0.7"
    },
    {
        n: [
            "guide dog"
        ],
        u: "1f9ae",
        a: "12.0"
    },
    {
        n: [
            "service dog"
        ],
        u: "1f415-200d-1f9ba",
        a: "12.0"
    },
    {
        n: [
            "poodle"
        ],
        u: "1f429",
        a: "0.6"
    },
    {
        n: [
            "wolf",
            "wolf face"
        ],
        u: "1f43a",
        a: "0.6"
    },
    {
        n: [
            "fox face"
        ],
        u: "1f98a",
        a: "3.0"
    },
    {
        n: [
            "raccoon"
        ],
        u: "1f99d",
        a: "11.0"
    },
    {
        n: [
            "cat",
            "cat face"
        ],
        u: "1f431",
        a: "0.6"
    },
    {
        n: [
            "cat",
            "cat2"
        ],
        u: "1f408",
        a: "0.7"
    },
    {
        n: [
            "black cat"
        ],
        u: "1f408-200d-2b1b",
        a: "13.0"
    },
    {
        n: [
            "lion face"
        ],
        u: "1f981",
        a: "1.0"
    },
    {
        n: [
            "tiger",
            "tiger face"
        ],
        u: "1f42f",
        a: "0.6"
    },
    {
        n: [
            "tiger",
            "tiger2"
        ],
        u: "1f405",
        a: "1.0"
    },
    {
        n: [
            "leopard"
        ],
        u: "1f406",
        a: "1.0"
    },
    {
        n: [
            "horse",
            "horse face"
        ],
        u: "1f434",
        a: "0.6"
    },
    {
        n: [
            "horse",
            "racehorse"
        ],
        u: "1f40e",
        a: "0.6"
    },
    {
        n: [
            "unicorn face"
        ],
        u: "1f984",
        a: "1.0"
    },
    {
        n: [
            "zebra face"
        ],
        u: "1f993",
        a: "5.0"
    },
    {
        n: [
            "deer"
        ],
        u: "1f98c",
        a: "3.0"
    },
    {
        n: [
            "bison"
        ],
        u: "1f9ac",
        a: "13.0"
    },
    {
        n: [
            "cow",
            "cow face"
        ],
        u: "1f42e",
        a: "0.6"
    },
    {
        n: [
            "ox"
        ],
        u: "1f402",
        a: "1.0"
    },
    {
        n: [
            "water buffalo"
        ],
        u: "1f403",
        a: "1.0"
    },
    {
        n: [
            "cow",
            "cow2"
        ],
        u: "1f404",
        a: "1.0"
    },
    {
        n: [
            "pig",
            "pig face"
        ],
        u: "1f437",
        a: "0.6"
    },
    {
        n: [
            "pig",
            "pig2"
        ],
        u: "1f416",
        a: "1.0"
    },
    {
        n: [
            "boar"
        ],
        u: "1f417",
        a: "0.6"
    },
    {
        n: [
            "pig nose"
        ],
        u: "1f43d",
        a: "0.6"
    },
    {
        n: [
            "ram"
        ],
        u: "1f40f",
        a: "1.0"
    },
    {
        n: [
            "sheep"
        ],
        u: "1f411",
        a: "0.6"
    },
    {
        n: [
            "goat"
        ],
        u: "1f410",
        a: "1.0"
    },
    {
        n: [
            "dromedary camel"
        ],
        u: "1f42a",
        a: "1.0"
    },
    {
        n: [
            "camel",
            "bactrian camel"
        ],
        u: "1f42b",
        a: "0.6"
    },
    {
        n: [
            "llama"
        ],
        u: "1f999",
        a: "11.0"
    },
    {
        n: [
            "giraffe face"
        ],
        u: "1f992",
        a: "5.0"
    },
    {
        n: [
            "elephant"
        ],
        u: "1f418",
        a: "0.6"
    },
    {
        n: [
            "mammoth"
        ],
        u: "1f9a3",
        a: "13.0"
    },
    {
        n: [
            "rhinoceros"
        ],
        u: "1f98f",
        a: "3.0"
    },
    {
        n: [
            "hippopotamus"
        ],
        u: "1f99b",
        a: "11.0"
    },
    {
        n: [
            "mouse",
            "mouse face"
        ],
        u: "1f42d",
        a: "0.6"
    },
    {
        n: [
            "mouse",
            "mouse2"
        ],
        u: "1f401",
        a: "1.0"
    },
    {
        n: [
            "rat"
        ],
        u: "1f400",
        a: "1.0"
    },
    {
        n: [
            "hamster",
            "hamster face"
        ],
        u: "1f439",
        a: "0.6"
    },
    {
        n: [
            "rabbit",
            "rabbit face"
        ],
        u: "1f430",
        a: "0.6"
    },
    {
        n: [
            "rabbit",
            "rabbit2"
        ],
        u: "1f407",
        a: "1.0"
    },
    {
        n: [
            "chipmunk"
        ],
        u: "1f43f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "beaver"
        ],
        u: "1f9ab",
        a: "13.0"
    },
    {
        n: [
            "hedgehog"
        ],
        u: "1f994",
        a: "5.0"
    },
    {
        n: [
            "bat"
        ],
        u: "1f987",
        a: "3.0"
    },
    {
        n: [
            "bear",
            "bear face"
        ],
        u: "1f43b",
        a: "0.6"
    },
    {
        n: [
            "polar bear"
        ],
        u: "1f43b-200d-2744-fe0f",
        a: "13.0"
    },
    {
        n: [
            "koala"
        ],
        u: "1f428",
        a: "0.6"
    },
    {
        n: [
            "panda face"
        ],
        u: "1f43c",
        a: "0.6"
    },
    {
        n: [
            "sloth"
        ],
        u: "1f9a5",
        a: "12.0"
    },
    {
        n: [
            "otter"
        ],
        u: "1f9a6",
        a: "12.0"
    },
    {
        n: [
            "skunk"
        ],
        u: "1f9a8",
        a: "12.0"
    },
    {
        n: [
            "kangaroo"
        ],
        u: "1f998",
        a: "11.0"
    },
    {
        n: [
            "badger"
        ],
        u: "1f9a1",
        a: "11.0"
    },
    {
        n: [
            "feet",
            "paw prints"
        ],
        u: "1f43e",
        a: "0.6"
    },
    {
        n: [
            "turkey"
        ],
        u: "1f983",
        a: "1.0"
    },
    {
        n: [
            "chicken"
        ],
        u: "1f414",
        a: "0.6"
    },
    {
        n: [
            "rooster"
        ],
        u: "1f413",
        a: "1.0"
    },
    {
        n: [
            "hatching chick"
        ],
        u: "1f423",
        a: "0.6"
    },
    {
        n: [
            "baby chick"
        ],
        u: "1f424",
        a: "0.6"
    },
    {
        n: [
            "hatched chick",
            "front-facing baby chick"
        ],
        u: "1f425",
        a: "0.6"
    },
    {
        n: [
            "bird"
        ],
        u: "1f426",
        a: "0.6"
    },
    {
        n: [
            "penguin"
        ],
        u: "1f427",
        a: "0.6"
    },
    {
        n: [
            "dove",
            "dove of peace"
        ],
        u: "1f54a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "eagle"
        ],
        u: "1f985",
        a: "3.0"
    },
    {
        n: [
            "duck"
        ],
        u: "1f986",
        a: "3.0"
    },
    {
        n: [
            "swan"
        ],
        u: "1f9a2",
        a: "11.0"
    },
    {
        n: [
            "owl"
        ],
        u: "1f989",
        a: "3.0"
    },
    {
        n: [
            "dodo"
        ],
        u: "1f9a4",
        a: "13.0"
    },
    {
        n: [
            "feather"
        ],
        u: "1fab6",
        a: "13.0"
    },
    {
        n: [
            "flamingo"
        ],
        u: "1f9a9",
        a: "12.0"
    },
    {
        n: [
            "peacock"
        ],
        u: "1f99a",
        a: "11.0"
    },
    {
        n: [
            "parrot"
        ],
        u: "1f99c",
        a: "11.0"
    },
    {
        n: [
            "frog",
            "frog face"
        ],
        u: "1f438",
        a: "0.6"
    },
    {
        n: [
            "crocodile"
        ],
        u: "1f40a",
        a: "1.0"
    },
    {
        n: [
            "turtle"
        ],
        u: "1f422",
        a: "0.6"
    },
    {
        n: [
            "lizard"
        ],
        u: "1f98e",
        a: "3.0"
    },
    {
        n: [
            "snake"
        ],
        u: "1f40d",
        a: "0.6"
    },
    {
        n: [
            "dragon face"
        ],
        u: "1f432",
        a: "0.6"
    },
    {
        n: [
            "dragon"
        ],
        u: "1f409",
        a: "1.0"
    },
    {
        n: [
            "sauropod"
        ],
        u: "1f995",
        a: "5.0"
    },
    {
        n: [
            "t-rex"
        ],
        u: "1f996",
        a: "5.0"
    },
    {
        n: [
            "whale",
            "spouting whale"
        ],
        u: "1f433",
        a: "0.6"
    },
    {
        n: [
            "whale",
            "whale2"
        ],
        u: "1f40b",
        a: "1.0"
    },
    {
        n: [
            "dolphin",
            "flipper"
        ],
        u: "1f42c",
        a: "0.6"
    },
    {
        n: [
            "seal"
        ],
        u: "1f9ad",
        a: "13.0"
    },
    {
        n: [
            "fish"
        ],
        u: "1f41f",
        a: "0.6"
    },
    {
        n: [
            "tropical fish"
        ],
        u: "1f420",
        a: "0.6"
    },
    {
        n: [
            "blowfish"
        ],
        u: "1f421",
        a: "0.6"
    },
    {
        n: [
            "shark"
        ],
        u: "1f988",
        a: "3.0"
    },
    {
        n: [
            "octopus"
        ],
        u: "1f419",
        a: "0.6"
    },
    {
        n: [
            "shell",
            "spiral shell"
        ],
        u: "1f41a",
        a: "0.6"
    },
    {
        n: [
            "coral"
        ],
        u: "1fab8",
        a: "14.0"
    },
    {
        n: [
            "snail"
        ],
        u: "1f40c",
        a: "0.6"
    },
    {
        n: [
            "butterfly"
        ],
        u: "1f98b",
        a: "3.0"
    },
    {
        n: [
            "bug"
        ],
        u: "1f41b",
        a: "0.6"
    },
    {
        n: [
            "ant"
        ],
        u: "1f41c",
        a: "0.6"
    },
    {
        n: [
            "bee",
            "honeybee"
        ],
        u: "1f41d",
        a: "0.6"
    },
    {
        n: [
            "beetle"
        ],
        u: "1fab2",
        a: "13.0"
    },
    {
        n: [
            "ladybug",
            "lady beetle"
        ],
        u: "1f41e",
        a: "0.6"
    },
    {
        n: [
            "cricket"
        ],
        u: "1f997",
        a: "5.0"
    },
    {
        n: [
            "cockroach"
        ],
        u: "1fab3",
        a: "13.0"
    },
    {
        n: [
            "spider"
        ],
        u: "1f577-fe0f",
        a: "0.7"
    },
    {
        n: [
            "spider web"
        ],
        u: "1f578-fe0f",
        a: "0.7"
    },
    {
        n: [
            "scorpion"
        ],
        u: "1f982",
        a: "1.0"
    },
    {
        n: [
            "mosquito"
        ],
        u: "1f99f",
        a: "11.0"
    },
    {
        n: [
            "fly"
        ],
        u: "1fab0",
        a: "13.0"
    },
    {
        n: [
            "worm"
        ],
        u: "1fab1",
        a: "13.0"
    },
    {
        n: [
            "microbe"
        ],
        u: "1f9a0",
        a: "11.0"
    },
    {
        n: [
            "bouquet"
        ],
        u: "1f490",
        a: "0.6"
    },
    {
        n: [
            "cherry blossom"
        ],
        u: "1f338",
        a: "0.6"
    },
    {
        n: [
            "white flower"
        ],
        u: "1f4ae",
        a: "0.6"
    },
    {
        n: [
            "lotus"
        ],
        u: "1fab7",
        a: "14.0"
    },
    {
        n: [
            "rosette"
        ],
        u: "1f3f5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rose"
        ],
        u: "1f339",
        a: "0.6"
    },
    {
        n: [
            "wilted flower"
        ],
        u: "1f940",
        a: "3.0"
    },
    {
        n: [
            "hibiscus"
        ],
        u: "1f33a",
        a: "0.6"
    },
    {
        n: [
            "sunflower"
        ],
        u: "1f33b",
        a: "0.6"
    },
    {
        n: [
            "blossom"
        ],
        u: "1f33c",
        a: "0.6"
    },
    {
        n: [
            "tulip"
        ],
        u: "1f337",
        a: "0.6"
    },
    {
        n: [
            "seedling"
        ],
        u: "1f331",
        a: "0.6"
    },
    {
        n: [
            "potted plant"
        ],
        u: "1fab4",
        a: "13.0"
    },
    {
        n: [
            "evergreen tree"
        ],
        u: "1f332",
        a: "1.0"
    },
    {
        n: [
            "deciduous tree"
        ],
        u: "1f333",
        a: "1.0"
    },
    {
        n: [
            "palm tree"
        ],
        u: "1f334",
        a: "0.6"
    },
    {
        n: [
            "cactus"
        ],
        u: "1f335",
        a: "0.6"
    },
    {
        n: [
            "ear of rice"
        ],
        u: "1f33e",
        a: "0.6"
    },
    {
        n: [
            "herb"
        ],
        u: "1f33f",
        a: "0.6"
    },
    {
        n: [
            "shamrock"
        ],
        u: "2618-fe0f",
        a: "1.0"
    },
    {
        n: [
            "four leaf clover"
        ],
        u: "1f340",
        a: "0.6"
    },
    {
        n: [
            "maple leaf"
        ],
        u: "1f341",
        a: "0.6"
    },
    {
        n: [
            "fallen leaf"
        ],
        u: "1f342",
        a: "0.6"
    },
    {
        n: [
            "leaves",
            "leaf fluttering in wind"
        ],
        u: "1f343",
        a: "0.6"
    },
    {
        n: [
            "empty nest"
        ],
        u: "1fab9",
        a: "14.0"
    },
    {
        n: [
            "nest with eggs"
        ],
        u: "1faba",
        a: "14.0"
    }
];
var food_drink = [
    {
        n: [
            "grapes"
        ],
        u: "1f347",
        a: "0.6"
    },
    {
        n: [
            "melon"
        ],
        u: "1f348",
        a: "0.6"
    },
    {
        n: [
            "watermelon"
        ],
        u: "1f349",
        a: "0.6"
    },
    {
        n: [
            "tangerine"
        ],
        u: "1f34a",
        a: "0.6"
    },
    {
        n: [
            "lemon"
        ],
        u: "1f34b",
        a: "1.0"
    },
    {
        n: [
            "banana"
        ],
        u: "1f34c",
        a: "0.6"
    },
    {
        n: [
            "pineapple"
        ],
        u: "1f34d",
        a: "0.6"
    },
    {
        n: [
            "mango"
        ],
        u: "1f96d",
        a: "11.0"
    },
    {
        n: [
            "apple",
            "red apple"
        ],
        u: "1f34e",
        a: "0.6"
    },
    {
        n: [
            "green apple"
        ],
        u: "1f34f",
        a: "0.6"
    },
    {
        n: [
            "pear"
        ],
        u: "1f350",
        a: "1.0"
    },
    {
        n: [
            "peach"
        ],
        u: "1f351",
        a: "0.6"
    },
    {
        n: [
            "cherries"
        ],
        u: "1f352",
        a: "0.6"
    },
    {
        n: [
            "strawberry"
        ],
        u: "1f353",
        a: "0.6"
    },
    {
        n: [
            "blueberries"
        ],
        u: "1fad0",
        a: "13.0"
    },
    {
        n: [
            "kiwifruit"
        ],
        u: "1f95d",
        a: "3.0"
    },
    {
        n: [
            "tomato"
        ],
        u: "1f345",
        a: "0.6"
    },
    {
        n: [
            "olive"
        ],
        u: "1fad2",
        a: "13.0"
    },
    {
        n: [
            "coconut"
        ],
        u: "1f965",
        a: "5.0"
    },
    {
        n: [
            "avocado"
        ],
        u: "1f951",
        a: "3.0"
    },
    {
        n: [
            "eggplant",
            "aubergine"
        ],
        u: "1f346",
        a: "0.6"
    },
    {
        n: [
            "potato"
        ],
        u: "1f954",
        a: "3.0"
    },
    {
        n: [
            "carrot"
        ],
        u: "1f955",
        a: "3.0"
    },
    {
        n: [
            "corn",
            "ear of maize"
        ],
        u: "1f33d",
        a: "0.6"
    },
    {
        n: [
            "hot pepper"
        ],
        u: "1f336-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bell pepper"
        ],
        u: "1fad1",
        a: "13.0"
    },
    {
        n: [
            "cucumber"
        ],
        u: "1f952",
        a: "3.0"
    },
    {
        n: [
            "leafy green"
        ],
        u: "1f96c",
        a: "11.0"
    },
    {
        n: [
            "broccoli"
        ],
        u: "1f966",
        a: "5.0"
    },
    {
        n: [
            "garlic"
        ],
        u: "1f9c4",
        a: "12.0"
    },
    {
        n: [
            "onion"
        ],
        u: "1f9c5",
        a: "12.0"
    },
    {
        n: [
            "mushroom"
        ],
        u: "1f344",
        a: "0.6"
    },
    {
        n: [
            "peanuts"
        ],
        u: "1f95c",
        a: "3.0"
    },
    {
        n: [
            "beans"
        ],
        u: "1fad8",
        a: "14.0"
    },
    {
        n: [
            "chestnut"
        ],
        u: "1f330",
        a: "0.6"
    },
    {
        n: [
            "bread"
        ],
        u: "1f35e",
        a: "0.6"
    },
    {
        n: [
            "croissant"
        ],
        u: "1f950",
        a: "3.0"
    },
    {
        n: [
            "baguette bread"
        ],
        u: "1f956",
        a: "3.0"
    },
    {
        n: [
            "flatbread"
        ],
        u: "1fad3",
        a: "13.0"
    },
    {
        n: [
            "pretzel"
        ],
        u: "1f968",
        a: "5.0"
    },
    {
        n: [
            "bagel"
        ],
        u: "1f96f",
        a: "11.0"
    },
    {
        n: [
            "pancakes"
        ],
        u: "1f95e",
        a: "3.0"
    },
    {
        n: [
            "waffle"
        ],
        u: "1f9c7",
        a: "12.0"
    },
    {
        n: [
            "cheese wedge"
        ],
        u: "1f9c0",
        a: "1.0"
    },
    {
        n: [
            "meat on bone"
        ],
        u: "1f356",
        a: "0.6"
    },
    {
        n: [
            "poultry leg"
        ],
        u: "1f357",
        a: "0.6"
    },
    {
        n: [
            "cut of meat"
        ],
        u: "1f969",
        a: "5.0"
    },
    {
        n: [
            "bacon"
        ],
        u: "1f953",
        a: "3.0"
    },
    {
        n: [
            "hamburger"
        ],
        u: "1f354",
        a: "0.6"
    },
    {
        n: [
            "fries",
            "french fries"
        ],
        u: "1f35f",
        a: "0.6"
    },
    {
        n: [
            "pizza",
            "slice of pizza"
        ],
        u: "1f355",
        a: "0.6"
    },
    {
        n: [
            "hotdog",
            "hot dog"
        ],
        u: "1f32d",
        a: "1.0"
    },
    {
        n: [
            "sandwich"
        ],
        u: "1f96a",
        a: "5.0"
    },
    {
        n: [
            "taco"
        ],
        u: "1f32e",
        a: "1.0"
    },
    {
        n: [
            "burrito"
        ],
        u: "1f32f",
        a: "1.0"
    },
    {
        n: [
            "tamale"
        ],
        u: "1fad4",
        a: "13.0"
    },
    {
        n: [
            "stuffed flatbread"
        ],
        u: "1f959",
        a: "3.0"
    },
    {
        n: [
            "falafel"
        ],
        u: "1f9c6",
        a: "12.0"
    },
    {
        n: [
            "egg"
        ],
        u: "1f95a",
        a: "3.0"
    },
    {
        n: [
            "cooking",
            "fried egg"
        ],
        u: "1f373",
        a: "0.6"
    },
    {
        n: [
            "shallow pan of food"
        ],
        u: "1f958",
        a: "3.0"
    },
    {
        n: [
            "stew",
            "pot of food"
        ],
        u: "1f372",
        a: "0.6"
    },
    {
        n: [
            "fondue"
        ],
        u: "1fad5",
        a: "13.0"
    },
    {
        n: [
            "bowl with spoon"
        ],
        u: "1f963",
        a: "5.0"
    },
    {
        n: [
            "green salad"
        ],
        u: "1f957",
        a: "3.0"
    },
    {
        n: [
            "popcorn"
        ],
        u: "1f37f",
        a: "1.0"
    },
    {
        n: [
            "butter"
        ],
        u: "1f9c8",
        a: "12.0"
    },
    {
        n: [
            "salt",
            "salt shaker"
        ],
        u: "1f9c2",
        a: "11.0"
    },
    {
        n: [
            "canned food"
        ],
        u: "1f96b",
        a: "5.0"
    },
    {
        n: [
            "bento",
            "bento box"
        ],
        u: "1f371",
        a: "0.6"
    },
    {
        n: [
            "rice cracker"
        ],
        u: "1f358",
        a: "0.6"
    },
    {
        n: [
            "rice ball"
        ],
        u: "1f359",
        a: "0.6"
    },
    {
        n: [
            "rice",
            "cooked rice"
        ],
        u: "1f35a",
        a: "0.6"
    },
    {
        n: [
            "curry",
            "curry and rice"
        ],
        u: "1f35b",
        a: "0.6"
    },
    {
        n: [
            "ramen",
            "steaming bowl"
        ],
        u: "1f35c",
        a: "0.6"
    },
    {
        n: [
            "spaghetti"
        ],
        u: "1f35d",
        a: "0.6"
    },
    {
        n: [
            "sweet potato",
            "roasted sweet potato"
        ],
        u: "1f360",
        a: "0.6"
    },
    {
        n: [
            "oden"
        ],
        u: "1f362",
        a: "0.6"
    },
    {
        n: [
            "sushi"
        ],
        u: "1f363",
        a: "0.6"
    },
    {
        n: [
            "fried shrimp"
        ],
        u: "1f364",
        a: "0.6"
    },
    {
        n: [
            "fish cake",
            "fish cake with swirl design"
        ],
        u: "1f365",
        a: "0.6"
    },
    {
        n: [
            "moon cake"
        ],
        u: "1f96e",
        a: "11.0"
    },
    {
        n: [
            "dango"
        ],
        u: "1f361",
        a: "0.6"
    },
    {
        n: [
            "dumpling"
        ],
        u: "1f95f",
        a: "5.0"
    },
    {
        n: [
            "fortune cookie"
        ],
        u: "1f960",
        a: "5.0"
    },
    {
        n: [
            "takeout box"
        ],
        u: "1f961",
        a: "5.0"
    },
    {
        n: [
            "crab"
        ],
        u: "1f980",
        a: "1.0"
    },
    {
        n: [
            "lobster"
        ],
        u: "1f99e",
        a: "11.0"
    },
    {
        n: [
            "shrimp"
        ],
        u: "1f990",
        a: "3.0"
    },
    {
        n: [
            "squid"
        ],
        u: "1f991",
        a: "3.0"
    },
    {
        n: [
            "oyster"
        ],
        u: "1f9aa",
        a: "12.0"
    },
    {
        n: [
            "icecream",
            "soft ice cream"
        ],
        u: "1f366",
        a: "0.6"
    },
    {
        n: [
            "shaved ice"
        ],
        u: "1f367",
        a: "0.6"
    },
    {
        n: [
            "ice cream"
        ],
        u: "1f368",
        a: "0.6"
    },
    {
        n: [
            "doughnut"
        ],
        u: "1f369",
        a: "0.6"
    },
    {
        n: [
            "cookie"
        ],
        u: "1f36a",
        a: "0.6"
    },
    {
        n: [
            "birthday",
            "birthday cake"
        ],
        u: "1f382",
        a: "0.6"
    },
    {
        n: [
            "cake",
            "shortcake"
        ],
        u: "1f370",
        a: "0.6"
    },
    {
        n: [
            "cupcake"
        ],
        u: "1f9c1",
        a: "11.0"
    },
    {
        n: [
            "pie"
        ],
        u: "1f967",
        a: "5.0"
    },
    {
        n: [
            "chocolate bar"
        ],
        u: "1f36b",
        a: "0.6"
    },
    {
        n: [
            "candy"
        ],
        u: "1f36c",
        a: "0.6"
    },
    {
        n: [
            "lollipop"
        ],
        u: "1f36d",
        a: "0.6"
    },
    {
        n: [
            "custard"
        ],
        u: "1f36e",
        a: "0.6"
    },
    {
        n: [
            "honey pot"
        ],
        u: "1f36f",
        a: "0.6"
    },
    {
        n: [
            "baby bottle"
        ],
        u: "1f37c",
        a: "1.0"
    },
    {
        n: [
            "glass of milk"
        ],
        u: "1f95b",
        a: "3.0"
    },
    {
        n: [
            "coffee",
            "hot beverage"
        ],
        u: "2615",
        a: "0.6"
    },
    {
        n: [
            "teapot"
        ],
        u: "1fad6",
        a: "13.0"
    },
    {
        n: [
            "tea",
            "teacup without handle"
        ],
        u: "1f375",
        a: "0.6"
    },
    {
        n: [
            "sake",
            "sake bottle and cup"
        ],
        u: "1f376",
        a: "0.6"
    },
    {
        n: [
            "champagne",
            "bottle with popping cork"
        ],
        u: "1f37e",
        a: "1.0"
    },
    {
        n: [
            "wine glass"
        ],
        u: "1f377",
        a: "0.6"
    },
    {
        n: [
            "cocktail",
            "cocktail glass"
        ],
        u: "1f378",
        a: "0.6"
    },
    {
        n: [
            "tropical drink"
        ],
        u: "1f379",
        a: "0.6"
    },
    {
        n: [
            "beer",
            "beer mug"
        ],
        u: "1f37a",
        a: "0.6"
    },
    {
        n: [
            "beers",
            "clinking beer mugs"
        ],
        u: "1f37b",
        a: "0.6"
    },
    {
        n: [
            "clinking glasses"
        ],
        u: "1f942",
        a: "3.0"
    },
    {
        n: [
            "tumbler glass"
        ],
        u: "1f943",
        a: "3.0"
    },
    {
        n: [
            "pouring liquid"
        ],
        u: "1fad7",
        a: "14.0"
    },
    {
        n: [
            "cup with straw"
        ],
        u: "1f964",
        a: "5.0"
    },
    {
        n: [
            "bubble tea"
        ],
        u: "1f9cb",
        a: "13.0"
    },
    {
        n: [
            "beverage box"
        ],
        u: "1f9c3",
        a: "12.0"
    },
    {
        n: [
            "mate drink"
        ],
        u: "1f9c9",
        a: "12.0"
    },
    {
        n: [
            "ice cube"
        ],
        u: "1f9ca",
        a: "12.0"
    },
    {
        n: [
            "chopsticks"
        ],
        u: "1f962",
        a: "5.0"
    },
    {
        n: [
            "knife fork plate",
            "fork and knife with plate"
        ],
        u: "1f37d-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fork and knife"
        ],
        u: "1f374",
        a: "0.6"
    },
    {
        n: [
            "spoon"
        ],
        u: "1f944",
        a: "3.0"
    },
    {
        n: [
            "hocho",
            "knife"
        ],
        u: "1f52a",
        a: "0.6"
    },
    {
        n: [
            "jar"
        ],
        u: "1fad9",
        a: "14.0"
    },
    {
        n: [
            "amphora"
        ],
        u: "1f3fa",
        a: "1.0"
    }
];
var travel_places = [
    {
        n: [
            "earth africa",
            "earth globe europe-africa"
        ],
        u: "1f30d",
        a: "0.7"
    },
    {
        n: [
            "earth americas",
            "earth globe americas"
        ],
        u: "1f30e",
        a: "0.7"
    },
    {
        n: [
            "earth asia",
            "earth globe asia-australia"
        ],
        u: "1f30f",
        a: "0.6"
    },
    {
        n: [
            "globe with meridians"
        ],
        u: "1f310",
        a: "1.0"
    },
    {
        n: [
            "world map"
        ],
        u: "1f5fa-fe0f",
        a: "0.7"
    },
    {
        n: [
            "japan",
            "silhouette of japan"
        ],
        u: "1f5fe",
        a: "0.6"
    },
    {
        n: [
            "compass"
        ],
        u: "1f9ed",
        a: "11.0"
    },
    {
        n: [
            "snow-capped mountain",
            "snow capped mountain"
        ],
        u: "1f3d4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "mountain"
        ],
        u: "26f0-fe0f",
        a: "0.7"
    },
    {
        n: [
            "volcano"
        ],
        u: "1f30b",
        a: "0.6"
    },
    {
        n: [
            "mount fuji"
        ],
        u: "1f5fb",
        a: "0.6"
    },
    {
        n: [
            "camping"
        ],
        u: "1f3d5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "beach with umbrella"
        ],
        u: "1f3d6-fe0f",
        a: "0.7"
    },
    {
        n: [
            "desert"
        ],
        u: "1f3dc-fe0f",
        a: "0.7"
    },
    {
        n: [
            "desert island"
        ],
        u: "1f3dd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "national park"
        ],
        u: "1f3de-fe0f",
        a: "0.7"
    },
    {
        n: [
            "stadium"
        ],
        u: "1f3df-fe0f",
        a: "0.7"
    },
    {
        n: [
            "classical building"
        ],
        u: "1f3db-fe0f",
        a: "0.7"
    },
    {
        n: [
            "building construction"
        ],
        u: "1f3d7-fe0f",
        a: "0.7"
    },
    {
        n: [
            "brick",
            "bricks"
        ],
        u: "1f9f1",
        a: "11.0"
    },
    {
        n: [
            "rock"
        ],
        u: "1faa8",
        a: "13.0"
    },
    {
        n: [
            "wood"
        ],
        u: "1fab5",
        a: "13.0"
    },
    {
        n: [
            "hut"
        ],
        u: "1f6d6",
        a: "13.0"
    },
    {
        n: [
            "houses",
            "house buildings"
        ],
        u: "1f3d8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "derelict house",
            "derelict house building"
        ],
        u: "1f3da-fe0f",
        a: "0.7"
    },
    {
        n: [
            "house",
            "house building"
        ],
        u: "1f3e0",
        a: "0.6"
    },
    {
        n: [
            "house with garden"
        ],
        u: "1f3e1",
        a: "0.6"
    },
    {
        n: [
            "office",
            "office building"
        ],
        u: "1f3e2",
        a: "0.6"
    },
    {
        n: [
            "post office",
            "japanese post office"
        ],
        u: "1f3e3",
        a: "0.6"
    },
    {
        n: [
            "european post office"
        ],
        u: "1f3e4",
        a: "1.0"
    },
    {
        n: [
            "hospital"
        ],
        u: "1f3e5",
        a: "0.6"
    },
    {
        n: [
            "bank"
        ],
        u: "1f3e6",
        a: "0.6"
    },
    {
        n: [
            "hotel"
        ],
        u: "1f3e8",
        a: "0.6"
    },
    {
        n: [
            "love hotel"
        ],
        u: "1f3e9",
        a: "0.6"
    },
    {
        n: [
            "convenience store"
        ],
        u: "1f3ea",
        a: "0.6"
    },
    {
        n: [
            "school"
        ],
        u: "1f3eb",
        a: "0.6"
    },
    {
        n: [
            "department store"
        ],
        u: "1f3ec",
        a: "0.6"
    },
    {
        n: [
            "factory"
        ],
        u: "1f3ed",
        a: "0.6"
    },
    {
        n: [
            "japanese castle"
        ],
        u: "1f3ef",
        a: "0.6"
    },
    {
        n: [
            "european castle"
        ],
        u: "1f3f0",
        a: "0.6"
    },
    {
        n: [
            "wedding"
        ],
        u: "1f492",
        a: "0.6"
    },
    {
        n: [
            "tokyo tower"
        ],
        u: "1f5fc",
        a: "0.6"
    },
    {
        n: [
            "statue of liberty"
        ],
        u: "1f5fd",
        a: "0.6"
    },
    {
        n: [
            "church"
        ],
        u: "26ea",
        a: "0.6"
    },
    {
        n: [
            "mosque"
        ],
        u: "1f54c",
        a: "1.0"
    },
    {
        n: [
            "hindu temple"
        ],
        u: "1f6d5",
        a: "12.0"
    },
    {
        n: [
            "synagogue"
        ],
        u: "1f54d",
        a: "1.0"
    },
    {
        n: [
            "shinto shrine"
        ],
        u: "26e9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "kaaba"
        ],
        u: "1f54b",
        a: "1.0"
    },
    {
        n: [
            "fountain"
        ],
        u: "26f2",
        a: "0.6"
    },
    {
        n: [
            "tent"
        ],
        u: "26fa",
        a: "0.6"
    },
    {
        n: [
            "foggy"
        ],
        u: "1f301",
        a: "0.6"
    },
    {
        n: [
            "night with stars"
        ],
        u: "1f303",
        a: "0.6"
    },
    {
        n: [
            "cityscape"
        ],
        u: "1f3d9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "sunrise over mountains"
        ],
        u: "1f304",
        a: "0.6"
    },
    {
        n: [
            "sunrise"
        ],
        u: "1f305",
        a: "0.6"
    },
    {
        n: [
            "city sunset",
            "cityscape at dusk"
        ],
        u: "1f306",
        a: "0.6"
    },
    {
        n: [
            "city sunrise",
            "sunset over buildings"
        ],
        u: "1f307",
        a: "0.6"
    },
    {
        n: [
            "bridge at night"
        ],
        u: "1f309",
        a: "0.6"
    },
    {
        n: [
            "hotsprings",
            "hot springs"
        ],
        u: "2668-fe0f",
        a: "0.6"
    },
    {
        n: [
            "carousel horse"
        ],
        u: "1f3a0",
        a: "0.6"
    },
    {
        n: [
            "playground slide"
        ],
        u: "1f6dd",
        a: "14.0"
    },
    {
        n: [
            "ferris wheel"
        ],
        u: "1f3a1",
        a: "0.6"
    },
    {
        n: [
            "roller coaster"
        ],
        u: "1f3a2",
        a: "0.6"
    },
    {
        n: [
            "barber",
            "barber pole"
        ],
        u: "1f488",
        a: "0.6"
    },
    {
        n: [
            "circus tent"
        ],
        u: "1f3aa",
        a: "0.6"
    },
    {
        n: [
            "steam locomotive"
        ],
        u: "1f682",
        a: "1.0"
    },
    {
        n: [
            "railway car"
        ],
        u: "1f683",
        a: "0.6"
    },
    {
        n: [
            "high-speed train",
            "bullettrain side"
        ],
        u: "1f684",
        a: "0.6"
    },
    {
        n: [
            "bullettrain front",
            "high-speed train with bullet nose"
        ],
        u: "1f685",
        a: "0.6"
    },
    {
        n: [
            "train",
            "train2"
        ],
        u: "1f686",
        a: "1.0"
    },
    {
        n: [
            "metro"
        ],
        u: "1f687",
        a: "0.6"
    },
    {
        n: [
            "light rail"
        ],
        u: "1f688",
        a: "1.0"
    },
    {
        n: [
            "station"
        ],
        u: "1f689",
        a: "0.6"
    },
    {
        n: [
            "tram"
        ],
        u: "1f68a",
        a: "1.0"
    },
    {
        n: [
            "monorail"
        ],
        u: "1f69d",
        a: "1.0"
    },
    {
        n: [
            "mountain railway"
        ],
        u: "1f69e",
        a: "1.0"
    },
    {
        n: [
            "train",
            "tram car"
        ],
        u: "1f68b",
        a: "1.0"
    },
    {
        n: [
            "bus"
        ],
        u: "1f68c",
        a: "0.6"
    },
    {
        n: [
            "oncoming bus"
        ],
        u: "1f68d",
        a: "0.7"
    },
    {
        n: [
            "trolleybus"
        ],
        u: "1f68e",
        a: "1.0"
    },
    {
        n: [
            "minibus"
        ],
        u: "1f690",
        a: "1.0"
    },
    {
        n: [
            "ambulance"
        ],
        u: "1f691",
        a: "0.6"
    },
    {
        n: [
            "fire engine"
        ],
        u: "1f692",
        a: "0.6"
    },
    {
        n: [
            "police car"
        ],
        u: "1f693",
        a: "0.6"
    },
    {
        n: [
            "oncoming police car"
        ],
        u: "1f694",
        a: "0.7"
    },
    {
        n: [
            "taxi"
        ],
        u: "1f695",
        a: "0.6"
    },
    {
        n: [
            "oncoming taxi"
        ],
        u: "1f696",
        a: "1.0"
    },
    {
        n: [
            "car",
            "red car",
            "automobile"
        ],
        u: "1f697",
        a: "0.6"
    },
    {
        n: [
            "oncoming automobile"
        ],
        u: "1f698",
        a: "0.7"
    },
    {
        n: [
            "blue car",
            "recreational vehicle"
        ],
        u: "1f699",
        a: "0.6"
    },
    {
        n: [
            "pickup truck"
        ],
        u: "1f6fb",
        a: "13.0"
    },
    {
        n: [
            "truck",
            "delivery truck"
        ],
        u: "1f69a",
        a: "0.6"
    },
    {
        n: [
            "articulated lorry"
        ],
        u: "1f69b",
        a: "1.0"
    },
    {
        n: [
            "tractor"
        ],
        u: "1f69c",
        a: "1.0"
    },
    {
        n: [
            "racing car"
        ],
        u: "1f3ce-fe0f",
        a: "0.7"
    },
    {
        n: [
            "motorcycle",
            "racing motorcycle"
        ],
        u: "1f3cd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "motor scooter"
        ],
        u: "1f6f5",
        a: "3.0"
    },
    {
        n: [
            "manual wheelchair"
        ],
        u: "1f9bd",
        a: "12.0"
    },
    {
        n: [
            "motorized wheelchair"
        ],
        u: "1f9bc",
        a: "12.0"
    },
    {
        n: [
            "auto rickshaw"
        ],
        u: "1f6fa",
        a: "12.0"
    },
    {
        n: [
            "bike",
            "bicycle"
        ],
        u: "1f6b2",
        a: "0.6"
    },
    {
        n: [
            "scooter"
        ],
        u: "1f6f4",
        a: "3.0"
    },
    {
        n: [
            "skateboard"
        ],
        u: "1f6f9",
        a: "11.0"
    },
    {
        n: [
            "roller skate"
        ],
        u: "1f6fc",
        a: "13.0"
    },
    {
        n: [
            "busstop",
            "bus stop"
        ],
        u: "1f68f",
        a: "0.6"
    },
    {
        n: [
            "motorway"
        ],
        u: "1f6e3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "railway track"
        ],
        u: "1f6e4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "oil drum"
        ],
        u: "1f6e2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fuelpump",
            "fuel pump"
        ],
        u: "26fd",
        a: "0.6"
    },
    {
        n: [
            "wheel"
        ],
        u: "1f6de",
        a: "14.0"
    },
    {
        n: [
            "rotating light",
            "police cars revolving light"
        ],
        u: "1f6a8",
        a: "0.6"
    },
    {
        n: [
            "traffic light",
            "horizontal traffic light"
        ],
        u: "1f6a5",
        a: "0.6"
    },
    {
        n: [
            "vertical traffic light"
        ],
        u: "1f6a6",
        a: "1.0"
    },
    {
        n: [
            "octagonal sign"
        ],
        u: "1f6d1",
        a: "3.0"
    },
    {
        n: [
            "construction",
            "construction sign"
        ],
        u: "1f6a7",
        a: "0.6"
    },
    {
        n: [
            "anchor"
        ],
        u: "2693",
        a: "0.6"
    },
    {
        n: [
            "ring buoy"
        ],
        u: "1f6df",
        a: "14.0"
    },
    {
        n: [
            "boat",
            "sailboat"
        ],
        u: "26f5",
        a: "0.6"
    },
    {
        n: [
            "canoe"
        ],
        u: "1f6f6",
        a: "3.0"
    },
    {
        n: [
            "speedboat"
        ],
        u: "1f6a4",
        a: "0.6"
    },
    {
        n: [
            "passenger ship"
        ],
        u: "1f6f3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "ferry"
        ],
        u: "26f4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "motor boat"
        ],
        u: "1f6e5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "ship"
        ],
        u: "1f6a2",
        a: "0.6"
    },
    {
        n: [
            "airplane"
        ],
        u: "2708-fe0f",
        a: "0.6"
    },
    {
        n: [
            "small airplane"
        ],
        u: "1f6e9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "airplane departure"
        ],
        u: "1f6eb",
        a: "1.0"
    },
    {
        n: [
            "airplane arriving"
        ],
        u: "1f6ec",
        a: "1.0"
    },
    {
        n: [
            "parachute"
        ],
        u: "1fa82",
        a: "12.0"
    },
    {
        n: [
            "seat"
        ],
        u: "1f4ba",
        a: "0.6"
    },
    {
        n: [
            "helicopter"
        ],
        u: "1f681",
        a: "1.0"
    },
    {
        n: [
            "suspension railway"
        ],
        u: "1f69f",
        a: "1.0"
    },
    {
        n: [
            "mountain cableway"
        ],
        u: "1f6a0",
        a: "1.0"
    },
    {
        n: [
            "aerial tramway"
        ],
        u: "1f6a1",
        a: "1.0"
    },
    {
        n: [
            "satellite"
        ],
        u: "1f6f0-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rocket"
        ],
        u: "1f680",
        a: "0.6"
    },
    {
        n: [
            "flying saucer"
        ],
        u: "1f6f8",
        a: "5.0"
    },
    {
        n: [
            "bellhop bell"
        ],
        u: "1f6ce-fe0f",
        a: "0.7"
    },
    {
        n: [
            "luggage"
        ],
        u: "1f9f3",
        a: "11.0"
    },
    {
        n: [
            "hourglass"
        ],
        u: "231b",
        a: "0.6"
    },
    {
        n: [
            "hourglass flowing sand",
            "hourglass with flowing sand"
        ],
        u: "23f3",
        a: "0.6"
    },
    {
        n: [
            "watch"
        ],
        u: "231a",
        a: "0.6"
    },
    {
        n: [
            "alarm clock"
        ],
        u: "23f0",
        a: "0.6"
    },
    {
        n: [
            "stopwatch"
        ],
        u: "23f1-fe0f",
        a: "1.0"
    },
    {
        n: [
            "timer clock"
        ],
        u: "23f2-fe0f",
        a: "1.0"
    },
    {
        n: [
            "mantelpiece clock"
        ],
        u: "1f570-fe0f",
        a: "0.7"
    },
    {
        n: [
            "clock12",
            "clock face twelve oclock"
        ],
        u: "1f55b",
        a: "0.6"
    },
    {
        n: [
            "clock1230",
            "clock face twelve-thirty"
        ],
        u: "1f567",
        a: "0.7"
    },
    {
        n: [
            "clock1",
            "clock face one oclock"
        ],
        u: "1f550",
        a: "0.6"
    },
    {
        n: [
            "clock130",
            "clock face one-thirty"
        ],
        u: "1f55c",
        a: "0.7"
    },
    {
        n: [
            "clock2",
            "clock face two oclock"
        ],
        u: "1f551",
        a: "0.6"
    },
    {
        n: [
            "clock230",
            "clock face two-thirty"
        ],
        u: "1f55d",
        a: "0.7"
    },
    {
        n: [
            "clock3",
            "clock face three oclock"
        ],
        u: "1f552",
        a: "0.6"
    },
    {
        n: [
            "clock330",
            "clock face three-thirty"
        ],
        u: "1f55e",
        a: "0.7"
    },
    {
        n: [
            "clock4",
            "clock face four oclock"
        ],
        u: "1f553",
        a: "0.6"
    },
    {
        n: [
            "clock430",
            "clock face four-thirty"
        ],
        u: "1f55f",
        a: "0.7"
    },
    {
        n: [
            "clock5",
            "clock face five oclock"
        ],
        u: "1f554",
        a: "0.6"
    },
    {
        n: [
            "clock530",
            "clock face five-thirty"
        ],
        u: "1f560",
        a: "0.7"
    },
    {
        n: [
            "clock6",
            "clock face six oclock"
        ],
        u: "1f555",
        a: "0.6"
    },
    {
        n: [
            "clock630",
            "clock face six-thirty"
        ],
        u: "1f561",
        a: "0.7"
    },
    {
        n: [
            "clock7",
            "clock face seven oclock"
        ],
        u: "1f556",
        a: "0.6"
    },
    {
        n: [
            "clock730",
            "clock face seven-thirty"
        ],
        u: "1f562",
        a: "0.7"
    },
    {
        n: [
            "clock8",
            "clock face eight oclock"
        ],
        u: "1f557",
        a: "0.6"
    },
    {
        n: [
            "clock830",
            "clock face eight-thirty"
        ],
        u: "1f563",
        a: "0.7"
    },
    {
        n: [
            "clock9",
            "clock face nine oclock"
        ],
        u: "1f558",
        a: "0.6"
    },
    {
        n: [
            "clock930",
            "clock face nine-thirty"
        ],
        u: "1f564",
        a: "0.7"
    },
    {
        n: [
            "clock10",
            "clock face ten oclock"
        ],
        u: "1f559",
        a: "0.6"
    },
    {
        n: [
            "clock1030",
            "clock face ten-thirty"
        ],
        u: "1f565",
        a: "0.7"
    },
    {
        n: [
            "clock11",
            "clock face eleven oclock"
        ],
        u: "1f55a",
        a: "0.6"
    },
    {
        n: [
            "clock1130",
            "clock face eleven-thirty"
        ],
        u: "1f566",
        a: "0.7"
    },
    {
        n: [
            "new moon",
            "new moon symbol"
        ],
        u: "1f311",
        a: "0.6"
    },
    {
        n: [
            "waxing crescent moon",
            "waxing crescent moon symbol"
        ],
        u: "1f312",
        a: "1.0"
    },
    {
        n: [
            "first quarter moon",
            "first quarter moon symbol"
        ],
        u: "1f313",
        a: "0.6"
    },
    {
        n: [
            "moon",
            "waxing gibbous moon",
            "waxing gibbous moon symbol"
        ],
        u: "1f314",
        a: "0.6"
    },
    {
        n: [
            "full moon",
            "full moon symbol"
        ],
        u: "1f315",
        a: "0.6"
    },
    {
        n: [
            "waning gibbous moon",
            "waning gibbous moon symbol"
        ],
        u: "1f316",
        a: "1.0"
    },
    {
        n: [
            "last quarter moon",
            "last quarter moon symbol"
        ],
        u: "1f317",
        a: "1.0"
    },
    {
        n: [
            "waning crescent moon",
            "waning crescent moon symbol"
        ],
        u: "1f318",
        a: "1.0"
    },
    {
        n: [
            "crescent moon"
        ],
        u: "1f319",
        a: "0.6"
    },
    {
        n: [
            "new moon with face"
        ],
        u: "1f31a",
        a: "1.0"
    },
    {
        n: [
            "first quarter moon with face"
        ],
        u: "1f31b",
        a: "0.6"
    },
    {
        n: [
            "last quarter moon with face"
        ],
        u: "1f31c",
        a: "0.7"
    },
    {
        n: [
            "thermometer"
        ],
        u: "1f321-fe0f",
        a: "0.7"
    },
    {
        n: [
            "sunny",
            "black sun with rays"
        ],
        u: "2600-fe0f",
        a: "0.6"
    },
    {
        n: [
            "full moon with face"
        ],
        u: "1f31d",
        a: "1.0"
    },
    {
        n: [
            "sun with face"
        ],
        u: "1f31e",
        a: "1.0"
    },
    {
        n: [
            "ringed planet"
        ],
        u: "1fa90",
        a: "12.0"
    },
    {
        n: [
            "star",
            "white medium star"
        ],
        u: "2b50",
        a: "0.6"
    },
    {
        n: [
            "star2",
            "glowing star"
        ],
        u: "1f31f",
        a: "0.6"
    },
    {
        n: [
            "stars",
            "shooting star"
        ],
        u: "1f320",
        a: "0.6"
    },
    {
        n: [
            "milky way"
        ],
        u: "1f30c",
        a: "0.6"
    },
    {
        n: [
            "cloud"
        ],
        u: "2601-fe0f",
        a: "0.6"
    },
    {
        n: [
            "partly sunny",
            "sun behind cloud"
        ],
        u: "26c5",
        a: "0.6"
    },
    {
        n: [
            "thunder cloud and rain",
            "cloud with lightning and rain"
        ],
        u: "26c8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "mostly sunny",
            "sun small cloud",
            "sun behind small cloud"
        ],
        u: "1f324-fe0f",
        a: "0.7"
    },
    {
        n: [
            "barely sunny",
            "sun behind cloud",
            "sun behind large cloud"
        ],
        u: "1f325-fe0f",
        a: "0.7"
    },
    {
        n: [
            "partly sunny rain",
            "sun behind rain cloud"
        ],
        u: "1f326-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rain cloud",
            "cloud with rain"
        ],
        u: "1f327-fe0f",
        a: "0.7"
    },
    {
        n: [
            "snow cloud",
            "cloud with snow"
        ],
        u: "1f328-fe0f",
        a: "0.7"
    },
    {
        n: [
            "lightning",
            "lightning cloud",
            "cloud with lightning"
        ],
        u: "1f329-fe0f",
        a: "0.7"
    },
    {
        n: [
            "tornado",
            "tornado cloud"
        ],
        u: "1f32a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fog"
        ],
        u: "1f32b-fe0f",
        a: "0.7"
    },
    {
        n: [
            "wind face",
            "wind blowing face"
        ],
        u: "1f32c-fe0f",
        a: "0.7"
    },
    {
        n: [
            "cyclone"
        ],
        u: "1f300",
        a: "0.6"
    },
    {
        n: [
            "rainbow"
        ],
        u: "1f308",
        a: "0.6"
    },
    {
        n: [
            "closed umbrella"
        ],
        u: "1f302",
        a: "0.6"
    },
    {
        n: [
            "umbrella"
        ],
        u: "2602-fe0f",
        a: "0.7"
    },
    {
        n: [
            "umbrella with rain drops"
        ],
        u: "2614",
        a: "0.6"
    },
    {
        n: [
            "umbrella on ground"
        ],
        u: "26f1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "zap",
            "high voltage sign"
        ],
        u: "26a1",
        a: "0.6"
    },
    {
        n: [
            "snowflake"
        ],
        u: "2744-fe0f",
        a: "0.6"
    },
    {
        n: [
            "snowman"
        ],
        u: "2603-fe0f",
        a: "0.7"
    },
    {
        n: [
            "snowman without snow"
        ],
        u: "26c4",
        a: "0.6"
    },
    {
        n: [
            "comet"
        ],
        u: "2604-fe0f",
        a: "1.0"
    },
    {
        n: [
            "fire"
        ],
        u: "1f525",
        a: "0.6"
    },
    {
        n: [
            "droplet"
        ],
        u: "1f4a7",
        a: "0.6"
    },
    {
        n: [
            "ocean",
            "water wave"
        ],
        u: "1f30a",
        a: "0.6"
    }
];
var activities = [
    {
        n: [
            "jack-o-lantern",
            "jack o lantern"
        ],
        u: "1f383",
        a: "0.6"
    },
    {
        n: [
            "christmas tree"
        ],
        u: "1f384",
        a: "0.6"
    },
    {
        n: [
            "fireworks"
        ],
        u: "1f386",
        a: "0.6"
    },
    {
        n: [
            "sparkler",
            "firework sparkler"
        ],
        u: "1f387",
        a: "0.6"
    },
    {
        n: [
            "firecracker"
        ],
        u: "1f9e8",
        a: "11.0"
    },
    {
        n: [
            "sparkles"
        ],
        u: "2728",
        a: "0.6"
    },
    {
        n: [
            "balloon"
        ],
        u: "1f388",
        a: "0.6"
    },
    {
        n: [
            "tada",
            "party popper"
        ],
        u: "1f389",
        a: "0.6"
    },
    {
        n: [
            "confetti ball"
        ],
        u: "1f38a",
        a: "0.6"
    },
    {
        n: [
            "tanabata tree"
        ],
        u: "1f38b",
        a: "0.6"
    },
    {
        n: [
            "bamboo",
            "pine decoration"
        ],
        u: "1f38d",
        a: "0.6"
    },
    {
        n: [
            "dolls",
            "japanese dolls"
        ],
        u: "1f38e",
        a: "0.6"
    },
    {
        n: [
            "flags",
            "carp streamer"
        ],
        u: "1f38f",
        a: "0.6"
    },
    {
        n: [
            "wind chime"
        ],
        u: "1f390",
        a: "0.6"
    },
    {
        n: [
            "rice scene",
            "moon viewing ceremony"
        ],
        u: "1f391",
        a: "0.6"
    },
    {
        n: [
            "red envelope",
            "red gift envelope"
        ],
        u: "1f9e7",
        a: "11.0"
    },
    {
        n: [
            "ribbon"
        ],
        u: "1f380",
        a: "0.6"
    },
    {
        n: [
            "gift",
            "wrapped present"
        ],
        u: "1f381",
        a: "0.6"
    },
    {
        n: [
            "reminder ribbon"
        ],
        u: "1f397-fe0f",
        a: "0.7"
    },
    {
        n: [
            "admission tickets"
        ],
        u: "1f39f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "ticket"
        ],
        u: "1f3ab",
        a: "0.6"
    },
    {
        n: [
            "medal",
            "military medal"
        ],
        u: "1f396-fe0f",
        a: "0.7"
    },
    {
        n: [
            "trophy"
        ],
        u: "1f3c6",
        a: "0.6"
    },
    {
        n: [
            "sports medal"
        ],
        u: "1f3c5",
        a: "1.0"
    },
    {
        n: [
            "first place medal"
        ],
        u: "1f947",
        a: "3.0"
    },
    {
        n: [
            "second place medal"
        ],
        u: "1f948",
        a: "3.0"
    },
    {
        n: [
            "third place medal"
        ],
        u: "1f949",
        a: "3.0"
    },
    {
        n: [
            "soccer",
            "soccer ball"
        ],
        u: "26bd",
        a: "0.6"
    },
    {
        n: [
            "baseball"
        ],
        u: "26be",
        a: "0.6"
    },
    {
        n: [
            "softball"
        ],
        u: "1f94e",
        a: "11.0"
    },
    {
        n: [
            "basketball",
            "basketball and hoop"
        ],
        u: "1f3c0",
        a: "0.6"
    },
    {
        n: [
            "volleyball"
        ],
        u: "1f3d0",
        a: "1.0"
    },
    {
        n: [
            "football",
            "american football"
        ],
        u: "1f3c8",
        a: "0.6"
    },
    {
        n: [
            "rugby football"
        ],
        u: "1f3c9",
        a: "1.0"
    },
    {
        n: [
            "tennis",
            "tennis racquet and ball"
        ],
        u: "1f3be",
        a: "0.6"
    },
    {
        n: [
            "flying disc"
        ],
        u: "1f94f",
        a: "11.0"
    },
    {
        n: [
            "bowling"
        ],
        u: "1f3b3",
        a: "0.6"
    },
    {
        n: [
            "cricket bat and ball"
        ],
        u: "1f3cf",
        a: "1.0"
    },
    {
        n: [
            "field hockey stick and ball"
        ],
        u: "1f3d1",
        a: "1.0"
    },
    {
        n: [
            "ice hockey stick and puck"
        ],
        u: "1f3d2",
        a: "1.0"
    },
    {
        n: [
            "lacrosse",
            "lacrosse stick and ball"
        ],
        u: "1f94d",
        a: "11.0"
    },
    {
        n: [
            "table tennis paddle and ball"
        ],
        u: "1f3d3",
        a: "1.0"
    },
    {
        n: [
            "badminton racquet and shuttlecock"
        ],
        u: "1f3f8",
        a: "1.0"
    },
    {
        n: [
            "boxing glove"
        ],
        u: "1f94a",
        a: "3.0"
    },
    {
        n: [
            "martial arts uniform"
        ],
        u: "1f94b",
        a: "3.0"
    },
    {
        n: [
            "goal net"
        ],
        u: "1f945",
        a: "3.0"
    },
    {
        n: [
            "golf",
            "flag in hole"
        ],
        u: "26f3",
        a: "0.6"
    },
    {
        n: [
            "ice skate"
        ],
        u: "26f8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fishing pole and fish"
        ],
        u: "1f3a3",
        a: "0.6"
    },
    {
        n: [
            "diving mask"
        ],
        u: "1f93f",
        a: "12.0"
    },
    {
        n: [
            "running shirt with sash"
        ],
        u: "1f3bd",
        a: "0.6"
    },
    {
        n: [
            "ski",
            "ski and ski boot"
        ],
        u: "1f3bf",
        a: "0.6"
    },
    {
        n: [
            "sled"
        ],
        u: "1f6f7",
        a: "5.0"
    },
    {
        n: [
            "curling stone"
        ],
        u: "1f94c",
        a: "5.0"
    },
    {
        n: [
            "dart",
            "direct hit"
        ],
        u: "1f3af",
        a: "0.6"
    },
    {
        n: [
            "yo-yo"
        ],
        u: "1fa80",
        a: "12.0"
    },
    {
        n: [
            "kite"
        ],
        u: "1fa81",
        a: "12.0"
    },
    {
        n: [
            "8ball",
            "billiards"
        ],
        u: "1f3b1",
        a: "0.6"
    },
    {
        n: [
            "crystal ball"
        ],
        u: "1f52e",
        a: "0.6"
    },
    {
        n: [
            "magic wand"
        ],
        u: "1fa84",
        a: "13.0"
    },
    {
        n: [
            "nazar amulet"
        ],
        u: "1f9ff",
        a: "11.0"
    },
    {
        n: [
            "hamsa"
        ],
        u: "1faac",
        a: "14.0"
    },
    {
        n: [
            "video game"
        ],
        u: "1f3ae",
        a: "0.6"
    },
    {
        n: [
            "joystick"
        ],
        u: "1f579-fe0f",
        a: "0.7"
    },
    {
        n: [
            "slot machine"
        ],
        u: "1f3b0",
        a: "0.6"
    },
    {
        n: [
            "game die"
        ],
        u: "1f3b2",
        a: "0.6"
    },
    {
        n: [
            "jigsaw",
            "jigsaw puzzle piece"
        ],
        u: "1f9e9",
        a: "11.0"
    },
    {
        n: [
            "teddy bear"
        ],
        u: "1f9f8",
        a: "11.0"
    },
    {
        n: [
            "pinata"
        ],
        u: "1fa85",
        a: "13.0"
    },
    {
        n: [
            "mirror ball"
        ],
        u: "1faa9",
        a: "14.0"
    },
    {
        n: [
            "nesting dolls"
        ],
        u: "1fa86",
        a: "13.0"
    },
    {
        n: [
            "spades",
            "black spade suit"
        ],
        u: "2660-fe0f",
        a: "0.6"
    },
    {
        n: [
            "hearts",
            "black heart suit"
        ],
        u: "2665-fe0f",
        a: "0.6"
    },
    {
        n: [
            "diamonds",
            "black diamond suit"
        ],
        u: "2666-fe0f",
        a: "0.6"
    },
    {
        n: [
            "clubs",
            "black club suit"
        ],
        u: "2663-fe0f",
        a: "0.6"
    },
    {
        n: [
            "chess pawn"
        ],
        u: "265f-fe0f",
        a: "11.0"
    },
    {
        n: [
            "black joker",
            "playing card black joker"
        ],
        u: "1f0cf",
        a: "0.6"
    },
    {
        n: [
            "mahjong",
            "mahjong tile red dragon"
        ],
        u: "1f004",
        a: "0.6"
    },
    {
        n: [
            "flower playing cards"
        ],
        u: "1f3b4",
        a: "0.6"
    },
    {
        n: [
            "performing arts"
        ],
        u: "1f3ad",
        a: "0.6"
    },
    {
        n: [
            "framed picture",
            "frame with picture"
        ],
        u: "1f5bc-fe0f",
        a: "0.7"
    },
    {
        n: [
            "art",
            "artist palette"
        ],
        u: "1f3a8",
        a: "0.6"
    },
    {
        n: [
            "thread",
            "spool of thread"
        ],
        u: "1f9f5",
        a: "11.0"
    },
    {
        n: [
            "sewing needle"
        ],
        u: "1faa1",
        a: "13.0"
    },
    {
        n: [
            "yarn",
            "ball of yarn"
        ],
        u: "1f9f6",
        a: "11.0"
    },
    {
        n: [
            "knot"
        ],
        u: "1faa2",
        a: "13.0"
    }
];
var objects = [
    {
        n: [
            "eyeglasses"
        ],
        u: "1f453",
        a: "0.6"
    },
    {
        n: [
            "sunglasses",
            "dark sunglasses"
        ],
        u: "1f576-fe0f",
        a: "0.7"
    },
    {
        n: [
            "goggles"
        ],
        u: "1f97d",
        a: "11.0"
    },
    {
        n: [
            "lab coat"
        ],
        u: "1f97c",
        a: "11.0"
    },
    {
        n: [
            "safety vest"
        ],
        u: "1f9ba",
        a: "12.0"
    },
    {
        n: [
            "necktie"
        ],
        u: "1f454",
        a: "0.6"
    },
    {
        n: [
            "shirt",
            "tshirt",
            "t-shirt"
        ],
        u: "1f455",
        a: "0.6"
    },
    {
        n: [
            "jeans"
        ],
        u: "1f456",
        a: "0.6"
    },
    {
        n: [
            "scarf"
        ],
        u: "1f9e3",
        a: "5.0"
    },
    {
        n: [
            "gloves"
        ],
        u: "1f9e4",
        a: "5.0"
    },
    {
        n: [
            "coat"
        ],
        u: "1f9e5",
        a: "5.0"
    },
    {
        n: [
            "socks"
        ],
        u: "1f9e6",
        a: "5.0"
    },
    {
        n: [
            "dress"
        ],
        u: "1f457",
        a: "0.6"
    },
    {
        n: [
            "kimono"
        ],
        u: "1f458",
        a: "0.6"
    },
    {
        n: [
            "sari"
        ],
        u: "1f97b",
        a: "12.0"
    },
    {
        n: [
            "one-piece swimsuit"
        ],
        u: "1fa71",
        a: "12.0"
    },
    {
        n: [
            "briefs"
        ],
        u: "1fa72",
        a: "12.0"
    },
    {
        n: [
            "shorts"
        ],
        u: "1fa73",
        a: "12.0"
    },
    {
        n: [
            "bikini"
        ],
        u: "1f459",
        a: "0.6"
    },
    {
        n: [
            "womans clothes"
        ],
        u: "1f45a",
        a: "0.6"
    },
    {
        n: [
            "purse"
        ],
        u: "1f45b",
        a: "0.6"
    },
    {
        n: [
            "handbag"
        ],
        u: "1f45c",
        a: "0.6"
    },
    {
        n: [
            "pouch"
        ],
        u: "1f45d",
        a: "0.6"
    },
    {
        n: [
            "shopping bags"
        ],
        u: "1f6cd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "school satchel"
        ],
        u: "1f392",
        a: "0.6"
    },
    {
        n: [
            "thong sandal"
        ],
        u: "1fa74",
        a: "13.0"
    },
    {
        n: [
            "shoe",
            "mans shoe"
        ],
        u: "1f45e",
        a: "0.6"
    },
    {
        n: [
            "athletic shoe"
        ],
        u: "1f45f",
        a: "0.6"
    },
    {
        n: [
            "hiking boot"
        ],
        u: "1f97e",
        a: "11.0"
    },
    {
        n: [
            "flat shoe",
            "womans flat shoe"
        ],
        u: "1f97f",
        a: "11.0"
    },
    {
        n: [
            "high heel",
            "high-heeled shoe"
        ],
        u: "1f460",
        a: "0.6"
    },
    {
        n: [
            "sandal",
            "womans sandal"
        ],
        u: "1f461",
        a: "0.6"
    },
    {
        n: [
            "ballet shoes"
        ],
        u: "1fa70",
        a: "12.0"
    },
    {
        n: [
            "boot",
            "womans boots"
        ],
        u: "1f462",
        a: "0.6"
    },
    {
        n: [
            "crown"
        ],
        u: "1f451",
        a: "0.6"
    },
    {
        n: [
            "womans hat"
        ],
        u: "1f452",
        a: "0.6"
    },
    {
        n: [
            "tophat",
            "top hat"
        ],
        u: "1f3a9",
        a: "0.6"
    },
    {
        n: [
            "mortar board",
            "graduation cap"
        ],
        u: "1f393",
        a: "0.6"
    },
    {
        n: [
            "billed cap"
        ],
        u: "1f9e2",
        a: "5.0"
    },
    {
        n: [
            "military helmet"
        ],
        u: "1fa96",
        a: "13.0"
    },
    {
        n: [
            "rescue worker\u2019s helmet",
            "helmet with white cross"
        ],
        u: "26d1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "prayer beads"
        ],
        u: "1f4ff",
        a: "1.0"
    },
    {
        n: [
            "lipstick"
        ],
        u: "1f484",
        a: "0.6"
    },
    {
        n: [
            "ring"
        ],
        u: "1f48d",
        a: "0.6"
    },
    {
        n: [
            "gem",
            "gem stone"
        ],
        u: "1f48e",
        a: "0.6"
    },
    {
        n: [
            "mute",
            "speaker with cancellation stroke"
        ],
        u: "1f507",
        a: "1.0"
    },
    {
        n: [
            "speaker"
        ],
        u: "1f508",
        a: "0.7"
    },
    {
        n: [
            "sound",
            "speaker with one sound wave"
        ],
        u: "1f509",
        a: "1.0"
    },
    {
        n: [
            "loud sound",
            "speaker with three sound waves"
        ],
        u: "1f50a",
        a: "0.6"
    },
    {
        n: [
            "loudspeaker",
            "public address loudspeaker"
        ],
        u: "1f4e2",
        a: "0.6"
    },
    {
        n: [
            "mega",
            "cheering megaphone"
        ],
        u: "1f4e3",
        a: "0.6"
    },
    {
        n: [
            "postal horn"
        ],
        u: "1f4ef",
        a: "1.0"
    },
    {
        n: [
            "bell"
        ],
        u: "1f514",
        a: "0.6"
    },
    {
        n: [
            "no bell",
            "bell with cancellation stroke"
        ],
        u: "1f515",
        a: "1.0"
    },
    {
        n: [
            "musical score"
        ],
        u: "1f3bc",
        a: "0.6"
    },
    {
        n: [
            "musical note"
        ],
        u: "1f3b5",
        a: "0.6"
    },
    {
        n: [
            "notes",
            "multiple musical notes"
        ],
        u: "1f3b6",
        a: "0.6"
    },
    {
        n: [
            "studio microphone"
        ],
        u: "1f399-fe0f",
        a: "0.7"
    },
    {
        n: [
            "level slider"
        ],
        u: "1f39a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "control knobs"
        ],
        u: "1f39b-fe0f",
        a: "0.7"
    },
    {
        n: [
            "microphone"
        ],
        u: "1f3a4",
        a: "0.6"
    },
    {
        n: [
            "headphone",
            "headphones"
        ],
        u: "1f3a7",
        a: "0.6"
    },
    {
        n: [
            "radio"
        ],
        u: "1f4fb",
        a: "0.6"
    },
    {
        n: [
            "saxophone"
        ],
        u: "1f3b7",
        a: "0.6"
    },
    {
        n: [
            "accordion"
        ],
        u: "1fa97",
        a: "13.0"
    },
    {
        n: [
            "guitar"
        ],
        u: "1f3b8",
        a: "0.6"
    },
    {
        n: [
            "musical keyboard"
        ],
        u: "1f3b9",
        a: "0.6"
    },
    {
        n: [
            "trumpet"
        ],
        u: "1f3ba",
        a: "0.6"
    },
    {
        n: [
            "violin"
        ],
        u: "1f3bb",
        a: "0.6"
    },
    {
        n: [
            "banjo"
        ],
        u: "1fa95",
        a: "12.0"
    },
    {
        n: [
            "drum with drumsticks"
        ],
        u: "1f941",
        a: "3.0"
    },
    {
        n: [
            "long drum"
        ],
        u: "1fa98",
        a: "13.0"
    },
    {
        n: [
            "iphone",
            "mobile phone"
        ],
        u: "1f4f1",
        a: "0.6"
    },
    {
        n: [
            "calling",
            "mobile phone with rightwards arrow at left"
        ],
        u: "1f4f2",
        a: "0.6"
    },
    {
        n: [
            "phone",
            "telephone",
            "black telephone"
        ],
        u: "260e-fe0f",
        a: "0.6"
    },
    {
        n: [
            "telephone receiver"
        ],
        u: "1f4de",
        a: "0.6"
    },
    {
        n: [
            "pager"
        ],
        u: "1f4df",
        a: "0.6"
    },
    {
        n: [
            "fax",
            "fax machine"
        ],
        u: "1f4e0",
        a: "0.6"
    },
    {
        n: [
            "battery"
        ],
        u: "1f50b",
        a: "0.6"
    },
    {
        n: [
            "low battery"
        ],
        u: "1faab",
        a: "14.0"
    },
    {
        n: [
            "electric plug"
        ],
        u: "1f50c",
        a: "0.6"
    },
    {
        n: [
            "computer",
            "personal computer"
        ],
        u: "1f4bb",
        a: "0.6"
    },
    {
        n: [
            "desktop computer"
        ],
        u: "1f5a5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "printer"
        ],
        u: "1f5a8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "keyboard"
        ],
        u: "2328-fe0f",
        a: "1.0"
    },
    {
        n: [
            "computer mouse",
            "three button mouse"
        ],
        u: "1f5b1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "trackball"
        ],
        u: "1f5b2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "minidisc"
        ],
        u: "1f4bd",
        a: "0.6"
    },
    {
        n: [
            "floppy disk"
        ],
        u: "1f4be",
        a: "0.6"
    },
    {
        n: [
            "cd",
            "optical disc"
        ],
        u: "1f4bf",
        a: "0.6"
    },
    {
        n: [
            "dvd"
        ],
        u: "1f4c0",
        a: "0.6"
    },
    {
        n: [
            "abacus"
        ],
        u: "1f9ee",
        a: "11.0"
    },
    {
        n: [
            "movie camera"
        ],
        u: "1f3a5",
        a: "0.6"
    },
    {
        n: [
            "film frames"
        ],
        u: "1f39e-fe0f",
        a: "0.7"
    },
    {
        n: [
            "film projector"
        ],
        u: "1f4fd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "clapper",
            "clapper board"
        ],
        u: "1f3ac",
        a: "0.6"
    },
    {
        n: [
            "tv",
            "television"
        ],
        u: "1f4fa",
        a: "0.6"
    },
    {
        n: [
            "camera"
        ],
        u: "1f4f7",
        a: "0.6"
    },
    {
        n: [
            "camera with flash"
        ],
        u: "1f4f8",
        a: "1.0"
    },
    {
        n: [
            "video camera"
        ],
        u: "1f4f9",
        a: "0.6"
    },
    {
        n: [
            "vhs",
            "videocassette"
        ],
        u: "1f4fc",
        a: "0.6"
    },
    {
        n: [
            "mag",
            "left-pointing magnifying glass"
        ],
        u: "1f50d",
        a: "0.6"
    },
    {
        n: [
            "mag right",
            "right-pointing magnifying glass"
        ],
        u: "1f50e",
        a: "0.6"
    },
    {
        n: [
            "candle"
        ],
        u: "1f56f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bulb",
            "electric light bulb"
        ],
        u: "1f4a1",
        a: "0.6"
    },
    {
        n: [
            "flashlight",
            "electric torch"
        ],
        u: "1f526",
        a: "0.6"
    },
    {
        n: [
            "lantern",
            "izakaya lantern"
        ],
        u: "1f3ee",
        a: "0.6"
    },
    {
        n: [
            "diya lamp"
        ],
        u: "1fa94",
        a: "12.0"
    },
    {
        n: [
            "notebook with decorative cover"
        ],
        u: "1f4d4",
        a: "0.6"
    },
    {
        n: [
            "closed book"
        ],
        u: "1f4d5",
        a: "0.6"
    },
    {
        n: [
            "book",
            "open book"
        ],
        u: "1f4d6",
        a: "0.6"
    },
    {
        n: [
            "green book"
        ],
        u: "1f4d7",
        a: "0.6"
    },
    {
        n: [
            "blue book"
        ],
        u: "1f4d8",
        a: "0.6"
    },
    {
        n: [
            "orange book"
        ],
        u: "1f4d9",
        a: "0.6"
    },
    {
        n: [
            "books"
        ],
        u: "1f4da",
        a: "0.6"
    },
    {
        n: [
            "notebook"
        ],
        u: "1f4d3",
        a: "0.6"
    },
    {
        n: [
            "ledger"
        ],
        u: "1f4d2",
        a: "0.6"
    },
    {
        n: [
            "page with curl"
        ],
        u: "1f4c3",
        a: "0.6"
    },
    {
        n: [
            "scroll"
        ],
        u: "1f4dc",
        a: "0.6"
    },
    {
        n: [
            "page facing up"
        ],
        u: "1f4c4",
        a: "0.6"
    },
    {
        n: [
            "newspaper"
        ],
        u: "1f4f0",
        a: "0.6"
    },
    {
        n: [
            "rolled-up newspaper",
            "rolled up newspaper"
        ],
        u: "1f5de-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bookmark tabs"
        ],
        u: "1f4d1",
        a: "0.6"
    },
    {
        n: [
            "bookmark"
        ],
        u: "1f516",
        a: "0.6"
    },
    {
        n: [
            "label"
        ],
        u: "1f3f7-fe0f",
        a: "0.7"
    },
    {
        n: [
            "moneybag",
            "money bag"
        ],
        u: "1f4b0",
        a: "0.6"
    },
    {
        n: [
            "coin"
        ],
        u: "1fa99",
        a: "13.0"
    },
    {
        n: [
            "yen",
            "banknote with yen sign"
        ],
        u: "1f4b4",
        a: "0.6"
    },
    {
        n: [
            "dollar",
            "banknote with dollar sign"
        ],
        u: "1f4b5",
        a: "0.6"
    },
    {
        n: [
            "euro",
            "banknote with euro sign"
        ],
        u: "1f4b6",
        a: "1.0"
    },
    {
        n: [
            "pound",
            "banknote with pound sign"
        ],
        u: "1f4b7",
        a: "1.0"
    },
    {
        n: [
            "money with wings"
        ],
        u: "1f4b8",
        a: "0.6"
    },
    {
        n: [
            "credit card"
        ],
        u: "1f4b3",
        a: "0.6"
    },
    {
        n: [
            "receipt"
        ],
        u: "1f9fe",
        a: "11.0"
    },
    {
        n: [
            "chart",
            "chart with upwards trend and yen sign"
        ],
        u: "1f4b9",
        a: "0.6"
    },
    {
        n: [
            "email",
            "envelope"
        ],
        u: "2709-fe0f",
        a: "0.6"
    },
    {
        n: [
            "e-mail",
            "e-mail symbol"
        ],
        u: "1f4e7",
        a: "0.6"
    },
    {
        n: [
            "incoming envelope"
        ],
        u: "1f4e8",
        a: "0.6"
    },
    {
        n: [
            "envelope with arrow",
            "envelope with downwards arrow above"
        ],
        u: "1f4e9",
        a: "0.6"
    },
    {
        n: [
            "outbox tray"
        ],
        u: "1f4e4",
        a: "0.6"
    },
    {
        n: [
            "inbox tray"
        ],
        u: "1f4e5",
        a: "0.6"
    },
    {
        n: [
            "package"
        ],
        u: "1f4e6",
        a: "0.6"
    },
    {
        n: [
            "mailbox",
            "closed mailbox with raised flag"
        ],
        u: "1f4eb",
        a: "0.6"
    },
    {
        n: [
            "mailbox closed",
            "closed mailbox with lowered flag"
        ],
        u: "1f4ea",
        a: "0.6"
    },
    {
        n: [
            "mailbox with mail",
            "open mailbox with raised flag"
        ],
        u: "1f4ec",
        a: "0.7"
    },
    {
        n: [
            "mailbox with no mail",
            "open mailbox with lowered flag"
        ],
        u: "1f4ed",
        a: "0.7"
    },
    {
        n: [
            "postbox"
        ],
        u: "1f4ee",
        a: "0.6"
    },
    {
        n: [
            "ballot box with ballot"
        ],
        u: "1f5f3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "pencil",
            "pencil2"
        ],
        u: "270f-fe0f",
        a: "0.6"
    },
    {
        n: [
            "black nib"
        ],
        u: "2712-fe0f",
        a: "0.6"
    },
    {
        n: [
            "fountain pen",
            "lower left fountain pen"
        ],
        u: "1f58b-fe0f",
        a: "0.7"
    },
    {
        n: [
            "pen",
            "lower left ballpoint pen"
        ],
        u: "1f58a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "paintbrush",
            "lower left paintbrush"
        ],
        u: "1f58c-fe0f",
        a: "0.7"
    },
    {
        n: [
            "crayon",
            "lower left crayon"
        ],
        u: "1f58d-fe0f",
        a: "0.7"
    },
    {
        n: [
            "memo",
            "pencil"
        ],
        u: "1f4dd",
        a: "0.6"
    },
    {
        n: [
            "briefcase"
        ],
        u: "1f4bc",
        a: "0.6"
    },
    {
        n: [
            "file folder"
        ],
        u: "1f4c1",
        a: "0.6"
    },
    {
        n: [
            "open file folder"
        ],
        u: "1f4c2",
        a: "0.6"
    },
    {
        n: [
            "card index dividers"
        ],
        u: "1f5c2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "date",
            "calendar"
        ],
        u: "1f4c5",
        a: "0.6"
    },
    {
        n: [
            "calendar",
            "tear-off calendar"
        ],
        u: "1f4c6",
        a: "0.6"
    },
    {
        n: [
            "spiral notepad",
            "spiral note pad"
        ],
        u: "1f5d2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "spiral calendar",
            "spiral calendar pad"
        ],
        u: "1f5d3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "card index"
        ],
        u: "1f4c7",
        a: "0.6"
    },
    {
        n: [
            "chart with upwards trend"
        ],
        u: "1f4c8",
        a: "0.6"
    },
    {
        n: [
            "chart with downwards trend"
        ],
        u: "1f4c9",
        a: "0.6"
    },
    {
        n: [
            "bar chart"
        ],
        u: "1f4ca",
        a: "0.6"
    },
    {
        n: [
            "clipboard"
        ],
        u: "1f4cb",
        a: "0.6"
    },
    {
        n: [
            "pushpin"
        ],
        u: "1f4cc",
        a: "0.6"
    },
    {
        n: [
            "round pushpin"
        ],
        u: "1f4cd",
        a: "0.6"
    },
    {
        n: [
            "paperclip"
        ],
        u: "1f4ce",
        a: "0.6"
    },
    {
        n: [
            "linked paperclips"
        ],
        u: "1f587-fe0f",
        a: "0.7"
    },
    {
        n: [
            "straight ruler"
        ],
        u: "1f4cf",
        a: "0.6"
    },
    {
        n: [
            "triangular ruler"
        ],
        u: "1f4d0",
        a: "0.6"
    },
    {
        n: [
            "scissors",
            "black scissors"
        ],
        u: "2702-fe0f",
        a: "0.6"
    },
    {
        n: [
            "card file box"
        ],
        u: "1f5c3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "file cabinet"
        ],
        u: "1f5c4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "wastebasket"
        ],
        u: "1f5d1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "lock"
        ],
        u: "1f512",
        a: "0.6"
    },
    {
        n: [
            "unlock",
            "open lock"
        ],
        u: "1f513",
        a: "0.6"
    },
    {
        n: [
            "lock with ink pen"
        ],
        u: "1f50f",
        a: "0.6"
    },
    {
        n: [
            "closed lock with key"
        ],
        u: "1f510",
        a: "0.6"
    },
    {
        n: [
            "key"
        ],
        u: "1f511",
        a: "0.6"
    },
    {
        n: [
            "old key"
        ],
        u: "1f5dd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "hammer"
        ],
        u: "1f528",
        a: "0.6"
    },
    {
        n: [
            "axe"
        ],
        u: "1fa93",
        a: "12.0"
    },
    {
        n: [
            "pick"
        ],
        u: "26cf-fe0f",
        a: "0.7"
    },
    {
        n: [
            "hammer and pick"
        ],
        u: "2692-fe0f",
        a: "1.0"
    },
    {
        n: [
            "hammer and wrench"
        ],
        u: "1f6e0-fe0f",
        a: "0.7"
    },
    {
        n: [
            "dagger",
            "dagger knife"
        ],
        u: "1f5e1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "crossed swords"
        ],
        u: "2694-fe0f",
        a: "1.0"
    },
    {
        n: [
            "gun",
            "pistol"
        ],
        u: "1f52b",
        a: "0.6"
    },
    {
        n: [
            "boomerang"
        ],
        u: "1fa83",
        a: "13.0"
    },
    {
        n: [
            "bow and arrow"
        ],
        u: "1f3f9",
        a: "1.0"
    },
    {
        n: [
            "shield"
        ],
        u: "1f6e1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "carpentry saw"
        ],
        u: "1fa9a",
        a: "13.0"
    },
    {
        n: [
            "wrench"
        ],
        u: "1f527",
        a: "0.6"
    },
    {
        n: [
            "screwdriver"
        ],
        u: "1fa9b",
        a: "13.0"
    },
    {
        n: [
            "nut and bolt"
        ],
        u: "1f529",
        a: "0.6"
    },
    {
        n: [
            "gear"
        ],
        u: "2699-fe0f",
        a: "1.0"
    },
    {
        n: [
            "clamp",
            "compression"
        ],
        u: "1f5dc-fe0f",
        a: "0.7"
    },
    {
        n: [
            "scales",
            "balance scale"
        ],
        u: "2696-fe0f",
        a: "1.0"
    },
    {
        n: [
            "probing cane"
        ],
        u: "1f9af",
        a: "12.0"
    },
    {
        n: [
            "link",
            "link symbol"
        ],
        u: "1f517",
        a: "0.6"
    },
    {
        n: [
            "chains"
        ],
        u: "26d3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "hook"
        ],
        u: "1fa9d",
        a: "13.0"
    },
    {
        n: [
            "toolbox"
        ],
        u: "1f9f0",
        a: "11.0"
    },
    {
        n: [
            "magnet"
        ],
        u: "1f9f2",
        a: "11.0"
    },
    {
        n: [
            "ladder"
        ],
        u: "1fa9c",
        a: "13.0"
    },
    {
        n: [
            "alembic"
        ],
        u: "2697-fe0f",
        a: "1.0"
    },
    {
        n: [
            "test tube"
        ],
        u: "1f9ea",
        a: "11.0"
    },
    {
        n: [
            "petri dish"
        ],
        u: "1f9eb",
        a: "11.0"
    },
    {
        n: [
            "dna",
            "dna double helix"
        ],
        u: "1f9ec",
        a: "11.0"
    },
    {
        n: [
            "microscope"
        ],
        u: "1f52c",
        a: "1.0"
    },
    {
        n: [
            "telescope"
        ],
        u: "1f52d",
        a: "1.0"
    },
    {
        n: [
            "satellite antenna"
        ],
        u: "1f4e1",
        a: "0.6"
    },
    {
        n: [
            "syringe"
        ],
        u: "1f489",
        a: "0.6"
    },
    {
        n: [
            "drop of blood"
        ],
        u: "1fa78",
        a: "12.0"
    },
    {
        n: [
            "pill"
        ],
        u: "1f48a",
        a: "0.6"
    },
    {
        n: [
            "adhesive bandage"
        ],
        u: "1fa79",
        a: "12.0"
    },
    {
        n: [
            "crutch"
        ],
        u: "1fa7c",
        a: "14.0"
    },
    {
        n: [
            "stethoscope"
        ],
        u: "1fa7a",
        a: "12.0"
    },
    {
        n: [
            "x-ray"
        ],
        u: "1fa7b",
        a: "14.0"
    },
    {
        n: [
            "door"
        ],
        u: "1f6aa",
        a: "0.6"
    },
    {
        n: [
            "elevator"
        ],
        u: "1f6d7",
        a: "13.0"
    },
    {
        n: [
            "mirror"
        ],
        u: "1fa9e",
        a: "13.0"
    },
    {
        n: [
            "window"
        ],
        u: "1fa9f",
        a: "13.0"
    },
    {
        n: [
            "bed"
        ],
        u: "1f6cf-fe0f",
        a: "0.7"
    },
    {
        n: [
            "couch and lamp"
        ],
        u: "1f6cb-fe0f",
        a: "0.7"
    },
    {
        n: [
            "chair"
        ],
        u: "1fa91",
        a: "12.0"
    },
    {
        n: [
            "toilet"
        ],
        u: "1f6bd",
        a: "0.6"
    },
    {
        n: [
            "plunger"
        ],
        u: "1faa0",
        a: "13.0"
    },
    {
        n: [
            "shower"
        ],
        u: "1f6bf",
        a: "1.0"
    },
    {
        n: [
            "bathtub"
        ],
        u: "1f6c1",
        a: "1.0"
    },
    {
        n: [
            "mouse trap"
        ],
        u: "1faa4",
        a: "13.0"
    },
    {
        n: [
            "razor"
        ],
        u: "1fa92",
        a: "12.0"
    },
    {
        n: [
            "lotion bottle"
        ],
        u: "1f9f4",
        a: "11.0"
    },
    {
        n: [
            "safety pin"
        ],
        u: "1f9f7",
        a: "11.0"
    },
    {
        n: [
            "broom"
        ],
        u: "1f9f9",
        a: "11.0"
    },
    {
        n: [
            "basket"
        ],
        u: "1f9fa",
        a: "11.0"
    },
    {
        n: [
            "roll of paper"
        ],
        u: "1f9fb",
        a: "11.0"
    },
    {
        n: [
            "bucket"
        ],
        u: "1faa3",
        a: "13.0"
    },
    {
        n: [
            "soap",
            "bar of soap"
        ],
        u: "1f9fc",
        a: "11.0"
    },
    {
        n: [
            "bubbles"
        ],
        u: "1fae7",
        a: "14.0"
    },
    {
        n: [
            "toothbrush"
        ],
        u: "1faa5",
        a: "13.0"
    },
    {
        n: [
            "sponge"
        ],
        u: "1f9fd",
        a: "11.0"
    },
    {
        n: [
            "fire extinguisher"
        ],
        u: "1f9ef",
        a: "11.0"
    },
    {
        n: [
            "shopping trolley"
        ],
        u: "1f6d2",
        a: "3.0"
    },
    {
        n: [
            "smoking",
            "smoking symbol"
        ],
        u: "1f6ac",
        a: "0.6"
    },
    {
        n: [
            "coffin"
        ],
        u: "26b0-fe0f",
        a: "1.0"
    },
    {
        n: [
            "headstone"
        ],
        u: "1faa6",
        a: "13.0"
    },
    {
        n: [
            "funeral urn"
        ],
        u: "26b1-fe0f",
        a: "1.0"
    },
    {
        n: [
            "moyai"
        ],
        u: "1f5ff",
        a: "0.6"
    },
    {
        n: [
            "placard"
        ],
        u: "1faa7",
        a: "13.0"
    },
    {
        n: [
            "identification card"
        ],
        u: "1faaa",
        a: "14.0"
    }
];
var symbols = [
    {
        n: [
            "atm",
            "automated teller machine"
        ],
        u: "1f3e7",
        a: "0.6"
    },
    {
        n: [
            "put litter in its place",
            "put litter in its place symbol"
        ],
        u: "1f6ae",
        a: "1.0"
    },
    {
        n: [
            "potable water",
            "potable water symbol"
        ],
        u: "1f6b0",
        a: "1.0"
    },
    {
        n: [
            "wheelchair",
            "wheelchair symbol"
        ],
        u: "267f",
        a: "0.6"
    },
    {
        n: [
            "mens",
            "mens symbol"
        ],
        u: "1f6b9",
        a: "0.6"
    },
    {
        n: [
            "womens",
            "womens symbol"
        ],
        u: "1f6ba",
        a: "0.6"
    },
    {
        n: [
            "restroom"
        ],
        u: "1f6bb",
        a: "0.6"
    },
    {
        n: [
            "baby symbol"
        ],
        u: "1f6bc",
        a: "0.6"
    },
    {
        n: [
            "wc",
            "water closet"
        ],
        u: "1f6be",
        a: "0.6"
    },
    {
        n: [
            "passport control"
        ],
        u: "1f6c2",
        a: "1.0"
    },
    {
        n: [
            "customs"
        ],
        u: "1f6c3",
        a: "1.0"
    },
    {
        n: [
            "baggage claim"
        ],
        u: "1f6c4",
        a: "1.0"
    },
    {
        n: [
            "left luggage"
        ],
        u: "1f6c5",
        a: "1.0"
    },
    {
        n: [
            "warning",
            "warning sign"
        ],
        u: "26a0-fe0f",
        a: "0.6"
    },
    {
        n: [
            "children crossing"
        ],
        u: "1f6b8",
        a: "1.0"
    },
    {
        n: [
            "no entry"
        ],
        u: "26d4",
        a: "0.6"
    },
    {
        n: [
            "no entry sign"
        ],
        u: "1f6ab",
        a: "0.6"
    },
    {
        n: [
            "no bicycles"
        ],
        u: "1f6b3",
        a: "1.0"
    },
    {
        n: [
            "no smoking",
            "no smoking symbol"
        ],
        u: "1f6ad",
        a: "0.6"
    },
    {
        n: [
            "do not litter",
            "do not litter symbol"
        ],
        u: "1f6af",
        a: "1.0"
    },
    {
        n: [
            "non-potable water",
            "non-potable water symbol"
        ],
        u: "1f6b1",
        a: "1.0"
    },
    {
        n: [
            "no pedestrians"
        ],
        u: "1f6b7",
        a: "1.0"
    },
    {
        n: [
            "no mobile phones"
        ],
        u: "1f4f5",
        a: "1.0"
    },
    {
        n: [
            "underage",
            "no one under eighteen symbol"
        ],
        u: "1f51e",
        a: "0.6"
    },
    {
        n: [
            "radioactive",
            "radioactive sign"
        ],
        u: "2622-fe0f",
        a: "1.0"
    },
    {
        n: [
            "biohazard",
            "biohazard sign"
        ],
        u: "2623-fe0f",
        a: "1.0"
    },
    {
        n: [
            "arrow up",
            "upwards black arrow"
        ],
        u: "2b06-fe0f",
        a: "0.6"
    },
    {
        n: [
            "north east arrow",
            "arrow upper right"
        ],
        u: "2197-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow right",
            "black rightwards arrow"
        ],
        u: "27a1-fe0f",
        a: "0.6"
    },
    {
        n: [
            "south east arrow",
            "arrow lower right"
        ],
        u: "2198-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow down",
            "downwards black arrow"
        ],
        u: "2b07-fe0f",
        a: "0.6"
    },
    {
        n: [
            "south west arrow",
            "arrow lower left"
        ],
        u: "2199-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow left",
            "leftwards black arrow"
        ],
        u: "2b05-fe0f",
        a: "0.6"
    },
    {
        n: [
            "north west arrow",
            "arrow upper left"
        ],
        u: "2196-fe0f",
        a: "0.6"
    },
    {
        n: [
            "up down arrow",
            "arrow up down"
        ],
        u: "2195-fe0f",
        a: "0.6"
    },
    {
        n: [
            "left right arrow"
        ],
        u: "2194-fe0f",
        a: "0.6"
    },
    {
        n: [
            "leftwards arrow with hook"
        ],
        u: "21a9-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow right hook",
            "rightwards arrow with hook"
        ],
        u: "21aa-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow heading up",
            "arrow pointing rightwards then curving upwards"
        ],
        u: "2934-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow heading down",
            "arrow pointing rightwards then curving downwards"
        ],
        u: "2935-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrows clockwise",
            "clockwise downwards and upwards open circle arrows"
        ],
        u: "1f503",
        a: "0.6"
    },
    {
        n: [
            "arrows counterclockwise",
            "anticlockwise downwards and upwards open circle arrows"
        ],
        u: "1f504",
        a: "1.0"
    },
    {
        n: [
            "back",
            "back with leftwards arrow above"
        ],
        u: "1f519",
        a: "0.6"
    },
    {
        n: [
            "end",
            "end with leftwards arrow above"
        ],
        u: "1f51a",
        a: "0.6"
    },
    {
        n: [
            "on",
            "on with exclamation mark with left right arrow above"
        ],
        u: "1f51b",
        a: "0.6"
    },
    {
        n: [
            "soon",
            "soon with rightwards arrow above"
        ],
        u: "1f51c",
        a: "0.6"
    },
    {
        n: [
            "top",
            "top with upwards arrow above"
        ],
        u: "1f51d",
        a: "0.6"
    },
    {
        n: [
            "place of worship"
        ],
        u: "1f6d0",
        a: "1.0"
    },
    {
        n: [
            "atom symbol"
        ],
        u: "269b-fe0f",
        a: "1.0"
    },
    {
        n: [
            "om",
            "om symbol"
        ],
        u: "1f549-fe0f",
        a: "0.7"
    },
    {
        n: [
            "star of david"
        ],
        u: "2721-fe0f",
        a: "0.7"
    },
    {
        n: [
            "wheel of dharma"
        ],
        u: "2638-fe0f",
        a: "0.7"
    },
    {
        n: [
            "yin yang"
        ],
        u: "262f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "latin cross"
        ],
        u: "271d-fe0f",
        a: "0.7"
    },
    {
        n: [
            "orthodox cross"
        ],
        u: "2626-fe0f",
        a: "1.0"
    },
    {
        n: [
            "star and crescent"
        ],
        u: "262a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "peace symbol"
        ],
        u: "262e-fe0f",
        a: "1.0"
    },
    {
        n: [
            "menorah with nine branches"
        ],
        u: "1f54e",
        a: "1.0"
    },
    {
        n: [
            "six pointed star",
            "six pointed star with middle dot"
        ],
        u: "1f52f",
        a: "0.6"
    },
    {
        n: [
            "aries"
        ],
        u: "2648",
        a: "0.6"
    },
    {
        n: [
            "taurus"
        ],
        u: "2649",
        a: "0.6"
    },
    {
        n: [
            "gemini"
        ],
        u: "264a",
        a: "0.6"
    },
    {
        n: [
            "cancer"
        ],
        u: "264b",
        a: "0.6"
    },
    {
        n: [
            "leo"
        ],
        u: "264c",
        a: "0.6"
    },
    {
        n: [
            "virgo"
        ],
        u: "264d",
        a: "0.6"
    },
    {
        n: [
            "libra"
        ],
        u: "264e",
        a: "0.6"
    },
    {
        n: [
            "scorpius"
        ],
        u: "264f",
        a: "0.6"
    },
    {
        n: [
            "sagittarius"
        ],
        u: "2650",
        a: "0.6"
    },
    {
        n: [
            "capricorn"
        ],
        u: "2651",
        a: "0.6"
    },
    {
        n: [
            "aquarius"
        ],
        u: "2652",
        a: "0.6"
    },
    {
        n: [
            "pisces"
        ],
        u: "2653",
        a: "0.6"
    },
    {
        n: [
            "ophiuchus"
        ],
        u: "26ce",
        a: "0.6"
    },
    {
        n: [
            "twisted rightwards arrows"
        ],
        u: "1f500",
        a: "1.0"
    },
    {
        n: [
            "repeat",
            "clockwise rightwards and leftwards open circle arrows"
        ],
        u: "1f501",
        a: "1.0"
    },
    {
        n: [
            "repeat one",
            "clockwise rightwards and leftwards open circle arrows with circled one overlay"
        ],
        u: "1f502",
        a: "1.0"
    },
    {
        n: [
            "arrow forward",
            "black right-pointing triangle"
        ],
        u: "25b6-fe0f",
        a: "0.6"
    },
    {
        n: [
            "fast forward",
            "black right-pointing double triangle"
        ],
        u: "23e9",
        a: "0.6"
    },
    {
        n: [
            "next track button",
            "black right pointing double triangle with vertical bar"
        ],
        u: "23ed-fe0f",
        a: "0.7"
    },
    {
        n: [
            "play or pause button",
            "black right pointing triangle with double vertical bar"
        ],
        u: "23ef-fe0f",
        a: "1.0"
    },
    {
        n: [
            "arrow backward",
            "black left-pointing triangle"
        ],
        u: "25c0-fe0f",
        a: "0.6"
    },
    {
        n: [
            "rewind",
            "black left-pointing double triangle"
        ],
        u: "23ea",
        a: "0.6"
    },
    {
        n: [
            "last track button",
            "black left pointing double triangle with vertical bar"
        ],
        u: "23ee-fe0f",
        a: "0.7"
    },
    {
        n: [
            "arrow up small",
            "up-pointing small red triangle"
        ],
        u: "1f53c",
        a: "0.6"
    },
    {
        n: [
            "arrow double up",
            "black up-pointing double triangle"
        ],
        u: "23eb",
        a: "0.6"
    },
    {
        n: [
            "arrow down small",
            "down-pointing small red triangle"
        ],
        u: "1f53d",
        a: "0.6"
    },
    {
        n: [
            "arrow double down",
            "black down-pointing double triangle"
        ],
        u: "23ec",
        a: "0.6"
    },
    {
        n: [
            "pause button",
            "double vertical bar"
        ],
        u: "23f8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "stop button",
            "black square for stop"
        ],
        u: "23f9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "record button",
            "black circle for record"
        ],
        u: "23fa-fe0f",
        a: "0.7"
    },
    {
        n: [
            "eject",
            "eject button"
        ],
        u: "23cf-fe0f",
        a: "1.0"
    },
    {
        n: [
            "cinema"
        ],
        u: "1f3a6",
        a: "0.6"
    },
    {
        n: [
            "low brightness",
            "low brightness symbol"
        ],
        u: "1f505",
        a: "1.0"
    },
    {
        n: [
            "high brightness",
            "high brightness symbol"
        ],
        u: "1f506",
        a: "1.0"
    },
    {
        n: [
            "signal strength",
            "antenna with bars"
        ],
        u: "1f4f6",
        a: "0.6"
    },
    {
        n: [
            "vibration mode"
        ],
        u: "1f4f3",
        a: "0.6"
    },
    {
        n: [
            "mobile phone off"
        ],
        u: "1f4f4",
        a: "0.6"
    },
    {
        n: [
            "female sign"
        ],
        u: "2640-fe0f",
        a: "4.0"
    },
    {
        n: [
            "male sign"
        ],
        u: "2642-fe0f",
        a: "4.0"
    },
    {
        n: [
            "transgender symbol"
        ],
        u: "26a7-fe0f",
        a: "13.0"
    },
    {
        n: [
            "heavy multiplication x"
        ],
        u: "2716-fe0f",
        a: "0.6"
    },
    {
        n: [
            "heavy plus sign"
        ],
        u: "2795",
        a: "0.6"
    },
    {
        n: [
            "heavy minus sign"
        ],
        u: "2796",
        a: "0.6"
    },
    {
        n: [
            "heavy division sign"
        ],
        u: "2797",
        a: "0.6"
    },
    {
        n: [
            "heavy equals sign"
        ],
        u: "1f7f0",
        a: "14.0"
    },
    {
        n: [
            "infinity"
        ],
        u: "267e-fe0f",
        a: "11.0"
    },
    {
        n: [
            "bangbang",
            "double exclamation mark"
        ],
        u: "203c-fe0f",
        a: "0.6"
    },
    {
        n: [
            "interrobang",
            "exclamation question mark"
        ],
        u: "2049-fe0f",
        a: "0.6"
    },
    {
        n: [
            "question",
            "black question mark ornament"
        ],
        u: "2753",
        a: "0.6"
    },
    {
        n: [
            "grey question",
            "white question mark ornament"
        ],
        u: "2754",
        a: "0.6"
    },
    {
        n: [
            "grey exclamation",
            "white exclamation mark ornament"
        ],
        u: "2755",
        a: "0.6"
    },
    {
        n: [
            "exclamation",
            "heavy exclamation mark",
            "heavy exclamation mark symbol"
        ],
        u: "2757",
        a: "0.6"
    },
    {
        n: [
            "wavy dash"
        ],
        u: "3030-fe0f",
        a: "0.6"
    },
    {
        n: [
            "currency exchange"
        ],
        u: "1f4b1",
        a: "0.6"
    },
    {
        n: [
            "heavy dollar sign"
        ],
        u: "1f4b2",
        a: "0.6"
    },
    {
        n: [
            "medical symbol",
            "staff of aesculapius"
        ],
        u: "2695-fe0f",
        a: "4.0"
    },
    {
        n: [
            "recycle",
            "black universal recycling symbol"
        ],
        u: "267b-fe0f",
        a: "0.6"
    },
    {
        n: [
            "fleur-de-lis",
            "fleur de lis"
        ],
        u: "269c-fe0f",
        a: "1.0"
    },
    {
        n: [
            "trident",
            "trident emblem"
        ],
        u: "1f531",
        a: "0.6"
    },
    {
        n: [
            "name badge"
        ],
        u: "1f4db",
        a: "0.6"
    },
    {
        n: [
            "beginner",
            "japanese symbol for beginner"
        ],
        u: "1f530",
        a: "0.6"
    },
    {
        n: [
            "o",
            "heavy large circle"
        ],
        u: "2b55",
        a: "0.6"
    },
    {
        n: [
            "white check mark",
            "white heavy check mark"
        ],
        u: "2705",
        a: "0.6"
    },
    {
        n: [
            "ballot box with check"
        ],
        u: "2611-fe0f",
        a: "0.6"
    },
    {
        n: [
            "heavy check mark"
        ],
        u: "2714-fe0f",
        a: "0.6"
    },
    {
        n: [
            "x",
            "cross mark"
        ],
        u: "274c",
        a: "0.6"
    },
    {
        n: [
            "negative squared cross mark"
        ],
        u: "274e",
        a: "0.6"
    },
    {
        n: [
            "curly loop"
        ],
        u: "27b0",
        a: "0.6"
    },
    {
        n: [
            "loop",
            "double curly loop"
        ],
        u: "27bf",
        a: "1.0"
    },
    {
        n: [
            "part alternation mark"
        ],
        u: "303d-fe0f",
        a: "0.6"
    },
    {
        n: [
            "eight spoked asterisk"
        ],
        u: "2733-fe0f",
        a: "0.6"
    },
    {
        n: [
            "eight pointed black star"
        ],
        u: "2734-fe0f",
        a: "0.6"
    },
    {
        n: [
            "sparkle"
        ],
        u: "2747-fe0f",
        a: "0.6"
    },
    {
        n: [
            "copyright",
            "copyright sign"
        ],
        u: "00a9-fe0f",
        a: "0.6"
    },
    {
        n: [
            "registered",
            "registered sign"
        ],
        u: "00ae-fe0f",
        a: "0.6"
    },
    {
        n: [
            "tm",
            "trade mark sign"
        ],
        u: "2122-fe0f",
        a: "0.6"
    },
    {
        n: [
            "hash",
            "hash key"
        ],
        u: "0023-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "keycap: *",
            "keycap star"
        ],
        u: "002a-fe0f-20e3",
        a: "2.0"
    },
    {
        n: [
            "zero",
            "keycap 0"
        ],
        u: "0030-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "one",
            "keycap 1"
        ],
        u: "0031-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "two",
            "keycap 2"
        ],
        u: "0032-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "three",
            "keycap 3"
        ],
        u: "0033-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "four",
            "keycap 4"
        ],
        u: "0034-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "five",
            "keycap 5"
        ],
        u: "0035-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "six",
            "keycap 6"
        ],
        u: "0036-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "seven",
            "keycap 7"
        ],
        u: "0037-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "eight",
            "keycap 8"
        ],
        u: "0038-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "nine",
            "keycap 9"
        ],
        u: "0039-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "keycap ten"
        ],
        u: "1f51f",
        a: "0.6"
    },
    {
        n: [
            "capital abcd",
            "input symbol for latin capital letters"
        ],
        u: "1f520",
        a: "0.6"
    },
    {
        n: [
            "abcd",
            "input symbol for latin small letters"
        ],
        u: "1f521",
        a: "0.6"
    },
    {
        n: [
            "1234",
            "input symbol for numbers"
        ],
        u: "1f522",
        a: "0.6"
    },
    {
        n: [
            "symbols",
            "input symbol for symbols"
        ],
        u: "1f523",
        a: "0.6"
    },
    {
        n: [
            "abc",
            "input symbol for latin letters"
        ],
        u: "1f524",
        a: "0.6"
    },
    {
        n: [
            "a",
            "negative squared latin capital letter a"
        ],
        u: "1f170-fe0f",
        a: "0.6"
    },
    {
        n: [
            "ab",
            "negative squared ab"
        ],
        u: "1f18e",
        a: "0.6"
    },
    {
        n: [
            "b",
            "negative squared latin capital letter b"
        ],
        u: "1f171-fe0f",
        a: "0.6"
    },
    {
        n: [
            "cl",
            "squared cl"
        ],
        u: "1f191",
        a: "0.6"
    },
    {
        n: [
            "cool",
            "squared cool"
        ],
        u: "1f192",
        a: "0.6"
    },
    {
        n: [
            "free",
            "squared free"
        ],
        u: "1f193",
        a: "0.6"
    },
    {
        n: [
            "information source"
        ],
        u: "2139-fe0f",
        a: "0.6"
    },
    {
        n: [
            "id",
            "squared id"
        ],
        u: "1f194",
        a: "0.6"
    },
    {
        n: [
            "m",
            "circled latin capital letter m"
        ],
        u: "24c2-fe0f",
        a: "0.6"
    },
    {
        n: [
            "new",
            "squared new"
        ],
        u: "1f195",
        a: "0.6"
    },
    {
        n: [
            "ng",
            "squared ng"
        ],
        u: "1f196",
        a: "0.6"
    },
    {
        n: [
            "o2",
            "negative squared latin capital letter o"
        ],
        u: "1f17e-fe0f",
        a: "0.6"
    },
    {
        n: [
            "ok",
            "squared ok"
        ],
        u: "1f197",
        a: "0.6"
    },
    {
        n: [
            "parking",
            "negative squared latin capital letter p"
        ],
        u: "1f17f-fe0f",
        a: "0.6"
    },
    {
        n: [
            "sos",
            "squared sos"
        ],
        u: "1f198",
        a: "0.6"
    },
    {
        n: [
            "up",
            "squared up with exclamation mark"
        ],
        u: "1f199",
        a: "0.6"
    },
    {
        n: [
            "vs",
            "squared vs"
        ],
        u: "1f19a",
        a: "0.6"
    },
    {
        n: [
            "koko",
            "squared katakana koko"
        ],
        u: "1f201",
        a: "0.6"
    },
    {
        n: [
            "sa",
            "squared katakana sa"
        ],
        u: "1f202-fe0f",
        a: "0.6"
    },
    {
        n: [
            "u6708",
            "squared cjk unified ideograph-6708"
        ],
        u: "1f237-fe0f",
        a: "0.6"
    },
    {
        n: [
            "u6709",
            "squared cjk unified ideograph-6709"
        ],
        u: "1f236",
        a: "0.6"
    },
    {
        n: [
            "u6307",
            "squared cjk unified ideograph-6307"
        ],
        u: "1f22f",
        a: "0.6"
    },
    {
        n: [
            "ideograph advantage",
            "circled ideograph advantage"
        ],
        u: "1f250",
        a: "0.6"
    },
    {
        n: [
            "u5272",
            "squared cjk unified ideograph-5272"
        ],
        u: "1f239",
        a: "0.6"
    },
    {
        n: [
            "u7121",
            "squared cjk unified ideograph-7121"
        ],
        u: "1f21a",
        a: "0.6"
    },
    {
        n: [
            "u7981",
            "squared cjk unified ideograph-7981"
        ],
        u: "1f232",
        a: "0.6"
    },
    {
        n: [
            "accept",
            "circled ideograph accept"
        ],
        u: "1f251",
        a: "0.6"
    },
    {
        n: [
            "u7533",
            "squared cjk unified ideograph-7533"
        ],
        u: "1f238",
        a: "0.6"
    },
    {
        n: [
            "u5408",
            "squared cjk unified ideograph-5408"
        ],
        u: "1f234",
        a: "0.6"
    },
    {
        n: [
            "u7a7a",
            "squared cjk unified ideograph-7a7a"
        ],
        u: "1f233",
        a: "0.6"
    },
    {
        n: [
            "congratulations",
            "circled ideograph congratulation"
        ],
        u: "3297-fe0f",
        a: "0.6"
    },
    {
        n: [
            "secret",
            "circled ideograph secret"
        ],
        u: "3299-fe0f",
        a: "0.6"
    },
    {
        n: [
            "u55b6",
            "squared cjk unified ideograph-55b6"
        ],
        u: "1f23a",
        a: "0.6"
    },
    {
        n: [
            "u6e80",
            "squared cjk unified ideograph-6e80"
        ],
        u: "1f235",
        a: "0.6"
    },
    {
        n: [
            "red circle",
            "large red circle"
        ],
        u: "1f534",
        a: "0.6"
    },
    {
        n: [
            "large orange circle"
        ],
        u: "1f7e0",
        a: "12.0"
    },
    {
        n: [
            "large yellow circle"
        ],
        u: "1f7e1",
        a: "12.0"
    },
    {
        n: [
            "large green circle"
        ],
        u: "1f7e2",
        a: "12.0"
    },
    {
        n: [
            "large blue circle"
        ],
        u: "1f535",
        a: "0.6"
    },
    {
        n: [
            "large purple circle"
        ],
        u: "1f7e3",
        a: "12.0"
    },
    {
        n: [
            "large brown circle"
        ],
        u: "1f7e4",
        a: "12.0"
    },
    {
        n: [
            "black circle",
            "medium black circle"
        ],
        u: "26ab",
        a: "0.6"
    },
    {
        n: [
            "white circle",
            "medium white circle"
        ],
        u: "26aa",
        a: "0.6"
    },
    {
        n: [
            "large red square"
        ],
        u: "1f7e5",
        a: "12.0"
    },
    {
        n: [
            "large orange square"
        ],
        u: "1f7e7",
        a: "12.0"
    },
    {
        n: [
            "large yellow square"
        ],
        u: "1f7e8",
        a: "12.0"
    },
    {
        n: [
            "large green square"
        ],
        u: "1f7e9",
        a: "12.0"
    },
    {
        n: [
            "large blue square"
        ],
        u: "1f7e6",
        a: "12.0"
    },
    {
        n: [
            "large purple square"
        ],
        u: "1f7ea",
        a: "12.0"
    },
    {
        n: [
            "large brown square"
        ],
        u: "1f7eb",
        a: "12.0"
    },
    {
        n: [
            "black large square"
        ],
        u: "2b1b",
        a: "0.6"
    },
    {
        n: [
            "white large square"
        ],
        u: "2b1c",
        a: "0.6"
    },
    {
        n: [
            "black medium square"
        ],
        u: "25fc-fe0f",
        a: "0.6"
    },
    {
        n: [
            "white medium square"
        ],
        u: "25fb-fe0f",
        a: "0.6"
    },
    {
        n: [
            "black medium small square"
        ],
        u: "25fe",
        a: "0.6"
    },
    {
        n: [
            "white medium small square"
        ],
        u: "25fd",
        a: "0.6"
    },
    {
        n: [
            "black small square"
        ],
        u: "25aa-fe0f",
        a: "0.6"
    },
    {
        n: [
            "white small square"
        ],
        u: "25ab-fe0f",
        a: "0.6"
    },
    {
        n: [
            "large orange diamond"
        ],
        u: "1f536",
        a: "0.6"
    },
    {
        n: [
            "large blue diamond"
        ],
        u: "1f537",
        a: "0.6"
    },
    {
        n: [
            "small orange diamond"
        ],
        u: "1f538",
        a: "0.6"
    },
    {
        n: [
            "small blue diamond"
        ],
        u: "1f539",
        a: "0.6"
    },
    {
        n: [
            "small red triangle",
            "up-pointing red triangle"
        ],
        u: "1f53a",
        a: "0.6"
    },
    {
        n: [
            "small red triangle down",
            "down-pointing red triangle"
        ],
        u: "1f53b",
        a: "0.6"
    },
    {
        n: [
            "diamond shape with a dot inside"
        ],
        u: "1f4a0",
        a: "0.6"
    },
    {
        n: [
            "radio button"
        ],
        u: "1f518",
        a: "0.6"
    },
    {
        n: [
            "white square button"
        ],
        u: "1f533",
        a: "0.6"
    },
    {
        n: [
            "black square button"
        ],
        u: "1f532",
        a: "0.6"
    }
];
var flags = [
    {
        n: [
            "chequered flag",
            "checkered flag"
        ],
        u: "1f3c1",
        a: "0.6"
    },
    {
        n: [
            "triangular flag on post"
        ],
        u: "1f6a9",
        a: "0.6"
    },
    {
        n: [
            "crossed flags"
        ],
        u: "1f38c",
        a: "0.6"
    },
    {
        n: [
            "waving black flag"
        ],
        u: "1f3f4",
        a: "1.0"
    },
    {
        n: [
            "white flag",
            "waving white flag"
        ],
        u: "1f3f3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rainbow flag",
            "rainbow-flag"
        ],
        u: "1f3f3-fe0f-200d-1f308",
        a: "4.0"
    },
    {
        n: [
            "transgender flag"
        ],
        u: "1f3f3-fe0f-200d-26a7-fe0f",
        a: "13.0"
    },
    {
        n: [
            "pirate flag"
        ],
        u: "1f3f4-200d-2620-fe0f",
        a: "11.0"
    },
    {
        n: [
            "flag-ac",
            "ascension island flag"
        ],
        u: "1f1e6-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ad",
            "andorra flag"
        ],
        u: "1f1e6-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-ae",
            "united arab emirates flag"
        ],
        u: "1f1e6-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-af",
            "afghanistan flag"
        ],
        u: "1f1e6-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-ag",
            "antigua & barbuda flag"
        ],
        u: "1f1e6-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ai",
            "anguilla flag"
        ],
        u: "1f1e6-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-al",
            "albania flag"
        ],
        u: "1f1e6-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-am",
            "armenia flag"
        ],
        u: "1f1e6-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-ao",
            "angola flag"
        ],
        u: "1f1e6-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-aq",
            "antarctica flag"
        ],
        u: "1f1e6-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-ar",
            "argentina flag"
        ],
        u: "1f1e6-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-as",
            "american samoa flag"
        ],
        u: "1f1e6-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-at",
            "austria flag"
        ],
        u: "1f1e6-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-au",
            "australia flag"
        ],
        u: "1f1e6-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-aw",
            "aruba flag"
        ],
        u: "1f1e6-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-ax",
            "\xe5land islands flag"
        ],
        u: "1f1e6-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-az",
            "azerbaijan flag"
        ],
        u: "1f1e6-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ba",
            "bosnia & herzegovina flag"
        ],
        u: "1f1e7-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-bb",
            "barbados flag"
        ],
        u: "1f1e7-1f1e7",
        a: "2.0"
    },
    {
        n: [
            "flag-bd",
            "bangladesh flag"
        ],
        u: "1f1e7-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-be",
            "belgium flag"
        ],
        u: "1f1e7-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-bf",
            "burkina faso flag"
        ],
        u: "1f1e7-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-bg",
            "bulgaria flag"
        ],
        u: "1f1e7-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-bh",
            "bahrain flag"
        ],
        u: "1f1e7-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-bi",
            "burundi flag"
        ],
        u: "1f1e7-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-bj",
            "benin flag"
        ],
        u: "1f1e7-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-bl",
            "st. barth\xe9lemy flag"
        ],
        u: "1f1e7-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-bm",
            "bermuda flag"
        ],
        u: "1f1e7-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-bn",
            "brunei flag"
        ],
        u: "1f1e7-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-bo",
            "bolivia flag"
        ],
        u: "1f1e7-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-bq",
            "caribbean netherlands flag"
        ],
        u: "1f1e7-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-br",
            "brazil flag"
        ],
        u: "1f1e7-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-bs",
            "bahamas flag"
        ],
        u: "1f1e7-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-bt",
            "bhutan flag"
        ],
        u: "1f1e7-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-bv",
            "bouvet island flag"
        ],
        u: "1f1e7-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-bw",
            "botswana flag"
        ],
        u: "1f1e7-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-by",
            "belarus flag"
        ],
        u: "1f1e7-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-bz",
            "belize flag"
        ],
        u: "1f1e7-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ca",
            "canada flag"
        ],
        u: "1f1e8-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-cc",
            "cocos (keeling) islands flag"
        ],
        u: "1f1e8-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-cd",
            "congo - kinshasa flag"
        ],
        u: "1f1e8-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-cf",
            "central african republic flag"
        ],
        u: "1f1e8-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-cg",
            "congo - brazzaville flag"
        ],
        u: "1f1e8-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ch",
            "switzerland flag"
        ],
        u: "1f1e8-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-ci",
            "c\xf4te d\u2019ivoire flag"
        ],
        u: "1f1e8-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-ck",
            "cook islands flag"
        ],
        u: "1f1e8-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-cl",
            "chile flag"
        ],
        u: "1f1e8-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-cm",
            "cameroon flag"
        ],
        u: "1f1e8-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "cn",
            "flag-cn",
            "china flag"
        ],
        u: "1f1e8-1f1f3",
        a: "0.6"
    },
    {
        n: [
            "flag-co",
            "colombia flag"
        ],
        u: "1f1e8-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-cp",
            "clipperton island flag"
        ],
        u: "1f1e8-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-cr",
            "costa rica flag"
        ],
        u: "1f1e8-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-cu",
            "cuba flag"
        ],
        u: "1f1e8-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-cv",
            "cape verde flag"
        ],
        u: "1f1e8-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-cw",
            "cura\xe7ao flag"
        ],
        u: "1f1e8-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-cx",
            "christmas island flag"
        ],
        u: "1f1e8-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-cy",
            "cyprus flag"
        ],
        u: "1f1e8-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-cz",
            "czechia flag"
        ],
        u: "1f1e8-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "de",
            "flag-de",
            "germany flag"
        ],
        u: "1f1e9-1f1ea",
        a: "0.6"
    },
    {
        n: [
            "flag-dg",
            "diego garcia flag"
        ],
        u: "1f1e9-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-dj",
            "djibouti flag"
        ],
        u: "1f1e9-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-dk",
            "denmark flag"
        ],
        u: "1f1e9-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-dm",
            "dominica flag"
        ],
        u: "1f1e9-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-do",
            "dominican republic flag"
        ],
        u: "1f1e9-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-dz",
            "algeria flag"
        ],
        u: "1f1e9-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ea",
            "ceuta & melilla flag"
        ],
        u: "1f1ea-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-ec",
            "ecuador flag"
        ],
        u: "1f1ea-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ee",
            "estonia flag"
        ],
        u: "1f1ea-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-eg",
            "egypt flag"
        ],
        u: "1f1ea-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-eh",
            "western sahara flag"
        ],
        u: "1f1ea-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-er",
            "eritrea flag"
        ],
        u: "1f1ea-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "es",
            "flag-es",
            "spain flag"
        ],
        u: "1f1ea-1f1f8",
        a: "0.6"
    },
    {
        n: [
            "flag-et",
            "ethiopia flag"
        ],
        u: "1f1ea-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-eu",
            "european union flag"
        ],
        u: "1f1ea-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-fi",
            "finland flag"
        ],
        u: "1f1eb-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-fj",
            "fiji flag"
        ],
        u: "1f1eb-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-fk",
            "falkland islands flag"
        ],
        u: "1f1eb-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-fm",
            "micronesia flag"
        ],
        u: "1f1eb-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-fo",
            "faroe islands flag"
        ],
        u: "1f1eb-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "fr",
            "flag-fr",
            "france flag"
        ],
        u: "1f1eb-1f1f7",
        a: "0.6"
    },
    {
        n: [
            "flag-ga",
            "gabon flag"
        ],
        u: "1f1ec-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "gb",
            "uk",
            "flag-gb",
            "united kingdom flag"
        ],
        u: "1f1ec-1f1e7",
        a: "0.6"
    },
    {
        n: [
            "flag-gd",
            "grenada flag"
        ],
        u: "1f1ec-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-ge",
            "georgia flag"
        ],
        u: "1f1ec-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-gf",
            "french guiana flag"
        ],
        u: "1f1ec-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-gg",
            "guernsey flag"
        ],
        u: "1f1ec-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-gh",
            "ghana flag"
        ],
        u: "1f1ec-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-gi",
            "gibraltar flag"
        ],
        u: "1f1ec-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-gl",
            "greenland flag"
        ],
        u: "1f1ec-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-gm",
            "gambia flag"
        ],
        u: "1f1ec-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-gn",
            "guinea flag"
        ],
        u: "1f1ec-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-gp",
            "guadeloupe flag"
        ],
        u: "1f1ec-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-gq",
            "equatorial guinea flag"
        ],
        u: "1f1ec-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-gr",
            "greece flag"
        ],
        u: "1f1ec-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-gs",
            "south georgia & south sandwich islands flag"
        ],
        u: "1f1ec-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-gt",
            "guatemala flag"
        ],
        u: "1f1ec-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-gu",
            "guam flag"
        ],
        u: "1f1ec-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-gw",
            "guinea-bissau flag"
        ],
        u: "1f1ec-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-gy",
            "guyana flag"
        ],
        u: "1f1ec-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-hk",
            "hong kong sar china flag"
        ],
        u: "1f1ed-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-hm",
            "heard & mcdonald islands flag"
        ],
        u: "1f1ed-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-hn",
            "honduras flag"
        ],
        u: "1f1ed-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-hr",
            "croatia flag"
        ],
        u: "1f1ed-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ht",
            "haiti flag"
        ],
        u: "1f1ed-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-hu",
            "hungary flag"
        ],
        u: "1f1ed-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-ic",
            "canary islands flag"
        ],
        u: "1f1ee-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-id",
            "indonesia flag"
        ],
        u: "1f1ee-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-ie",
            "ireland flag"
        ],
        u: "1f1ee-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-il",
            "israel flag"
        ],
        u: "1f1ee-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-im",
            "isle of man flag"
        ],
        u: "1f1ee-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-in",
            "india flag"
        ],
        u: "1f1ee-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-io",
            "british indian ocean territory flag"
        ],
        u: "1f1ee-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-iq",
            "iraq flag"
        ],
        u: "1f1ee-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-ir",
            "iran flag"
        ],
        u: "1f1ee-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-is",
            "iceland flag"
        ],
        u: "1f1ee-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "it",
            "flag-it",
            "italy flag"
        ],
        u: "1f1ee-1f1f9",
        a: "0.6"
    },
    {
        n: [
            "flag-je",
            "jersey flag"
        ],
        u: "1f1ef-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-jm",
            "jamaica flag"
        ],
        u: "1f1ef-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-jo",
            "jordan flag"
        ],
        u: "1f1ef-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "jp",
            "flag-jp",
            "japan flag"
        ],
        u: "1f1ef-1f1f5",
        a: "0.6"
    },
    {
        n: [
            "flag-ke",
            "kenya flag"
        ],
        u: "1f1f0-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-kg",
            "kyrgyzstan flag"
        ],
        u: "1f1f0-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-kh",
            "cambodia flag"
        ],
        u: "1f1f0-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-ki",
            "kiribati flag"
        ],
        u: "1f1f0-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-km",
            "comoros flag"
        ],
        u: "1f1f0-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-kn",
            "st. kitts & nevis flag"
        ],
        u: "1f1f0-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-kp",
            "north korea flag"
        ],
        u: "1f1f0-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "kr",
            "flag-kr",
            "south korea flag"
        ],
        u: "1f1f0-1f1f7",
        a: "0.6"
    },
    {
        n: [
            "flag-kw",
            "kuwait flag"
        ],
        u: "1f1f0-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-ky",
            "cayman islands flag"
        ],
        u: "1f1f0-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-kz",
            "kazakhstan flag"
        ],
        u: "1f1f0-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-la",
            "laos flag"
        ],
        u: "1f1f1-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-lb",
            "lebanon flag"
        ],
        u: "1f1f1-1f1e7",
        a: "2.0"
    },
    {
        n: [
            "flag-lc",
            "st. lucia flag"
        ],
        u: "1f1f1-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-li",
            "liechtenstein flag"
        ],
        u: "1f1f1-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-lk",
            "sri lanka flag"
        ],
        u: "1f1f1-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-lr",
            "liberia flag"
        ],
        u: "1f1f1-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ls",
            "lesotho flag"
        ],
        u: "1f1f1-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-lt",
            "lithuania flag"
        ],
        u: "1f1f1-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-lu",
            "luxembourg flag"
        ],
        u: "1f1f1-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-lv",
            "latvia flag"
        ],
        u: "1f1f1-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-ly",
            "libya flag"
        ],
        u: "1f1f1-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-ma",
            "morocco flag"
        ],
        u: "1f1f2-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-mc",
            "monaco flag"
        ],
        u: "1f1f2-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-md",
            "moldova flag"
        ],
        u: "1f1f2-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-me",
            "montenegro flag"
        ],
        u: "1f1f2-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-mf",
            "st. martin flag"
        ],
        u: "1f1f2-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-mg",
            "madagascar flag"
        ],
        u: "1f1f2-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-mh",
            "marshall islands flag"
        ],
        u: "1f1f2-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-mk",
            "north macedonia flag"
        ],
        u: "1f1f2-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-ml",
            "mali flag"
        ],
        u: "1f1f2-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-mm",
            "myanmar (burma) flag"
        ],
        u: "1f1f2-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-mn",
            "mongolia flag"
        ],
        u: "1f1f2-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-mo",
            "macao sar china flag"
        ],
        u: "1f1f2-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-mp",
            "northern mariana islands flag"
        ],
        u: "1f1f2-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-mq",
            "martinique flag"
        ],
        u: "1f1f2-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-mr",
            "mauritania flag"
        ],
        u: "1f1f2-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ms",
            "montserrat flag"
        ],
        u: "1f1f2-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-mt",
            "malta flag"
        ],
        u: "1f1f2-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-mu",
            "mauritius flag"
        ],
        u: "1f1f2-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-mv",
            "maldives flag"
        ],
        u: "1f1f2-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-mw",
            "malawi flag"
        ],
        u: "1f1f2-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-mx",
            "mexico flag"
        ],
        u: "1f1f2-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-my",
            "malaysia flag"
        ],
        u: "1f1f2-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-mz",
            "mozambique flag"
        ],
        u: "1f1f2-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-na",
            "namibia flag"
        ],
        u: "1f1f3-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-nc",
            "new caledonia flag"
        ],
        u: "1f1f3-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ne",
            "niger flag"
        ],
        u: "1f1f3-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-nf",
            "norfolk island flag"
        ],
        u: "1f1f3-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-ng",
            "nigeria flag"
        ],
        u: "1f1f3-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ni",
            "nicaragua flag"
        ],
        u: "1f1f3-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-nl",
            "netherlands flag"
        ],
        u: "1f1f3-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-no",
            "norway flag"
        ],
        u: "1f1f3-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-np",
            "nepal flag"
        ],
        u: "1f1f3-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-nr",
            "nauru flag"
        ],
        u: "1f1f3-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-nu",
            "niue flag"
        ],
        u: "1f1f3-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-nz",
            "new zealand flag"
        ],
        u: "1f1f3-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-om",
            "oman flag"
        ],
        u: "1f1f4-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-pa",
            "panama flag"
        ],
        u: "1f1f5-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-pe",
            "peru flag"
        ],
        u: "1f1f5-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-pf",
            "french polynesia flag"
        ],
        u: "1f1f5-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-pg",
            "papua new guinea flag"
        ],
        u: "1f1f5-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ph",
            "philippines flag"
        ],
        u: "1f1f5-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-pk",
            "pakistan flag"
        ],
        u: "1f1f5-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-pl",
            "poland flag"
        ],
        u: "1f1f5-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-pm",
            "st. pierre & miquelon flag"
        ],
        u: "1f1f5-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-pn",
            "pitcairn islands flag"
        ],
        u: "1f1f5-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-pr",
            "puerto rico flag"
        ],
        u: "1f1f5-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ps",
            "palestinian territories flag"
        ],
        u: "1f1f5-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-pt",
            "portugal flag"
        ],
        u: "1f1f5-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-pw",
            "palau flag"
        ],
        u: "1f1f5-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-py",
            "paraguay flag"
        ],
        u: "1f1f5-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-qa",
            "qatar flag"
        ],
        u: "1f1f6-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-re",
            "r\xe9union flag"
        ],
        u: "1f1f7-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-ro",
            "romania flag"
        ],
        u: "1f1f7-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-rs",
            "serbia flag"
        ],
        u: "1f1f7-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "ru",
            "flag-ru",
            "russia flag"
        ],
        u: "1f1f7-1f1fa",
        a: "0.6"
    },
    {
        n: [
            "flag-rw",
            "rwanda flag"
        ],
        u: "1f1f7-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-sa",
            "saudi arabia flag"
        ],
        u: "1f1f8-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-sb",
            "solomon islands flag"
        ],
        u: "1f1f8-1f1e7",
        a: "2.0"
    },
    {
        n: [
            "flag-sc",
            "seychelles flag"
        ],
        u: "1f1f8-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-sd",
            "sudan flag"
        ],
        u: "1f1f8-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-se",
            "sweden flag"
        ],
        u: "1f1f8-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-sg",
            "singapore flag"
        ],
        u: "1f1f8-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-sh",
            "st. helena flag"
        ],
        u: "1f1f8-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-si",
            "slovenia flag"
        ],
        u: "1f1f8-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-sj",
            "svalbard & jan mayen flag"
        ],
        u: "1f1f8-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-sk",
            "slovakia flag"
        ],
        u: "1f1f8-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-sl",
            "sierra leone flag"
        ],
        u: "1f1f8-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-sm",
            "san marino flag"
        ],
        u: "1f1f8-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-sn",
            "senegal flag"
        ],
        u: "1f1f8-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-so",
            "somalia flag"
        ],
        u: "1f1f8-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-sr",
            "suriname flag"
        ],
        u: "1f1f8-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ss",
            "south sudan flag"
        ],
        u: "1f1f8-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-st",
            "s\xe3o tom\xe9 & pr\xedncipe flag"
        ],
        u: "1f1f8-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-sv",
            "el salvador flag"
        ],
        u: "1f1f8-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-sx",
            "sint maarten flag"
        ],
        u: "1f1f8-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-sy",
            "syria flag"
        ],
        u: "1f1f8-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-sz",
            "eswatini flag"
        ],
        u: "1f1f8-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ta",
            "tristan da cunha flag"
        ],
        u: "1f1f9-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-tc",
            "turks & caicos islands flag"
        ],
        u: "1f1f9-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-td",
            "chad flag"
        ],
        u: "1f1f9-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-tf",
            "french southern territories flag"
        ],
        u: "1f1f9-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-tg",
            "togo flag"
        ],
        u: "1f1f9-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-th",
            "thailand flag"
        ],
        u: "1f1f9-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-tj",
            "tajikistan flag"
        ],
        u: "1f1f9-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-tk",
            "tokelau flag"
        ],
        u: "1f1f9-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-tl",
            "timor-leste flag"
        ],
        u: "1f1f9-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-tm",
            "turkmenistan flag"
        ],
        u: "1f1f9-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-tn",
            "tunisia flag"
        ],
        u: "1f1f9-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-to",
            "tonga flag"
        ],
        u: "1f1f9-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-tr",
            "turkey flag"
        ],
        u: "1f1f9-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-tt",
            "trinidad & tobago flag"
        ],
        u: "1f1f9-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-tv",
            "tuvalu flag"
        ],
        u: "1f1f9-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-tw",
            "taiwan flag"
        ],
        u: "1f1f9-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-tz",
            "tanzania flag"
        ],
        u: "1f1f9-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ua",
            "ukraine flag"
        ],
        u: "1f1fa-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-ug",
            "uganda flag"
        ],
        u: "1f1fa-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-um",
            "u.s. outlying islands flag"
        ],
        u: "1f1fa-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-un",
            "united nations flag"
        ],
        u: "1f1fa-1f1f3",
        a: "4.0"
    },
    {
        n: [
            "us",
            "flag-us",
            "united states flag"
        ],
        u: "1f1fa-1f1f8",
        a: "0.6"
    },
    {
        n: [
            "flag-uy",
            "uruguay flag"
        ],
        u: "1f1fa-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-uz",
            "uzbekistan flag"
        ],
        u: "1f1fa-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-va",
            "vatican city flag"
        ],
        u: "1f1fb-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-vc",
            "st. vincent & grenadines flag"
        ],
        u: "1f1fb-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ve",
            "venezuela flag"
        ],
        u: "1f1fb-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-vg",
            "british virgin islands flag"
        ],
        u: "1f1fb-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-vi",
            "u.s. virgin islands flag"
        ],
        u: "1f1fb-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-vn",
            "vietnam flag"
        ],
        u: "1f1fb-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-vu",
            "vanuatu flag"
        ],
        u: "1f1fb-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-wf",
            "wallis & futuna flag"
        ],
        u: "1f1fc-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-ws",
            "samoa flag"
        ],
        u: "1f1fc-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-xk",
            "kosovo flag"
        ],
        u: "1f1fd-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-ye",
            "yemen flag"
        ],
        u: "1f1fe-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-yt",
            "mayotte flag"
        ],
        u: "1f1fe-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-za",
            "south africa flag"
        ],
        u: "1f1ff-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-zm",
            "zambia flag"
        ],
        u: "1f1ff-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-zw",
            "zimbabwe flag"
        ],
        u: "1f1ff-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "england flag",
            "flag-england"
        ],
        u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
        a: "5.0"
    },
    {
        n: [
            "scotland flag",
            "flag-scotland"
        ],
        u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
        a: "5.0"
    },
    {
        n: [
            "wales flag",
            "flag-wales"
        ],
        u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
        a: "5.0"
    }
];
var emojis = {
    custom: custom,
    smileys_people: smileys_people,
    animals_nature: animals_nature,
    food_drink: food_drink,
    travel_places: travel_places,
    activities: activities,
    objects: objects,
    symbols: symbols,
    flags: flags
};
var skinToneVariations = [
    SkinTones.NEUTRAL,
    SkinTones.LIGHT,
    SkinTones.MEDIUM_LIGHT,
    SkinTones.MEDIUM,
    SkinTones.MEDIUM_DARK,
    SkinTones.DARK
];
var skinTonesNamed = /*#__PURE__*/ Object.entries(SkinTones).reduce(function(acc, _ref) {
    var key = _ref[0], value = _ref[1];
    acc[value] = key;
    return acc;
}, {});
var skinTonesMapped = /*#__PURE__*/ skinToneVariations.reduce(function(mapped, skinTone) {
    var _Object$assign;
    return Object.assign(mapped, (_Object$assign = {}, _Object$assign[skinTone] = skinTone, _Object$assign));
}, {});
var EmojiProperties;
(function(EmojiProperties) {
    EmojiProperties["name"] = "n";
    EmojiProperties["unified"] = "u";
    EmojiProperties["variations"] = "v";
    EmojiProperties["added_in"] = "a";
    EmojiProperties["imgUrl"] = "imgUrl";
})(EmojiProperties || (EmojiProperties = {}));
var alphaNumericEmojiIndex = {};
setTimeout(function() {
    allEmojis.reduce(function(searchIndex, emoji) {
        indexEmoji(emoji);
        return searchIndex;
    }, alphaNumericEmojiIndex);
});
function indexEmoji(emoji) {
    var joinedNameString = emojiNames(emoji).flat().join("").toLowerCase().replace(/[^a-zA-Z\d]/g, "").split("");
    joinedNameString.forEach(function(_char) {
        var _alphaNumericEmojiInd;
        alphaNumericEmojiIndex[_char] = (_alphaNumericEmojiInd = alphaNumericEmojiIndex[_char]) != null ? _alphaNumericEmojiInd : {};
        alphaNumericEmojiIndex[_char][emojiUnified(emoji)] = emoji;
    });
}
function emojiNames(emoji) {
    var _emoji$EmojiPropertie;
    return (_emoji$EmojiPropertie = emoji[EmojiProperties.name]) != null ? _emoji$EmojiPropertie : [];
}
function addedIn(emoji) {
    return parseFloat(emoji[EmojiProperties.added_in]);
}
function emojiName(emoji) {
    if (!emoji) return "";
    return emojiNames(emoji)[0];
}
function unifiedWithoutSkinTone(unified) {
    var splat = unified.split("-");
    var _splat$splice = splat.splice(1, 1), skinTone = _splat$splice[0];
    if (skinTonesMapped[skinTone]) return splat.join("-");
    return unified;
}
function emojiUnified(emoji, skinTone) {
    var _emojiVariationUnifie;
    var unified = emoji[EmojiProperties.unified];
    if (!skinTone || !emojiHasVariations(emoji)) return unified;
    return (_emojiVariationUnifie = emojiVariationUnified(emoji, skinTone)) != null ? _emojiVariationUnifie : unified;
}
function emojisByCategory(category) {
    var _emojis$category;
    // @ts-ignore
    return (_emojis$category = emojis == null ? void 0 : emojis[category]) != null ? _emojis$category : [];
}
// WARNING: DO NOT USE DIRECTLY
function emojiUrlByUnified(unified, emojiStyle) {
    return "" + cdnUrl(emojiStyle) + unified + ".png";
}
function emojiVariations(emoji) {
    var _emoji$EmojiPropertie2;
    return (_emoji$EmojiPropertie2 = emoji[EmojiProperties.variations]) != null ? _emoji$EmojiPropertie2 : [];
}
function emojiHasVariations(emoji) {
    return emojiVariations(emoji).length > 0;
}
function emojiVariationUnified(emoji, skinTone) {
    return skinTone ? emojiVariations(emoji).find(function(variation) {
        return variation.includes(skinTone);
    }) : emojiUnified(emoji);
}
function emojiByUnified(unified) {
    if (!unified) return;
    if (allEmojisByUnified[unified]) return allEmojisByUnified[unified];
    var withoutSkinTone = unifiedWithoutSkinTone(unified);
    return allEmojisByUnified[withoutSkinTone];
}
var allEmojis = /*#__PURE__*/ Object.values(emojis).flat();
function setCustomEmojis(customEmojis) {
    emojis[Categories.CUSTOM].length = 0;
    customEmojis.forEach(function(emoji) {
        var emojiData = customToRegularEmoji(emoji);
        emojis[Categories.CUSTOM].push(emojiData);
        if (allEmojisByUnified[emojiData[EmojiProperties.unified]]) return;
        allEmojis.push(emojiData);
        allEmojisByUnified[emojiData[EmojiProperties.unified]] = emojiData;
        indexEmoji(emojiData);
    });
}
function customToRegularEmoji(emoji) {
    var _ref;
    return _ref = {}, _ref[EmojiProperties.name] = emoji.names.map(function(name) {
        return name.toLowerCase();
    }), _ref[EmojiProperties.unified] = emoji.id.toLowerCase(), _ref[EmojiProperties.added_in] = "0", _ref[EmojiProperties.imgUrl] = emoji.imgUrl, _ref;
}
var allEmojisByUnified = {};
setTimeout(function() {
    allEmojis.reduce(function(allEmojis, Emoji) {
        allEmojis[emojiUnified(Emoji)] = Emoji;
        if (emojiHasVariations(Emoji)) emojiVariations(Emoji).forEach(function(variation) {
            allEmojis[variation] = Emoji;
        });
        return allEmojis;
    }, allEmojisByUnified);
});
function activeVariationFromUnified(unified) {
    var _unified$split = unified.split("-"), suspectedSkinTone = _unified$split[1];
    return skinToneVariations.includes(suspectedSkinTone) ? suspectedSkinTone : null;
}
var KNOWN_FAILING_EMOJIS = [
    "2640-fe0f",
    "2642-fe0f",
    "2695-fe0f"
];
var DEFAULT_SEARCH_PLACEHOLDER = "Search";
var SEARCH_RESULTS_NO_RESULTS_FOUND = "No results found";
var SEARCH_RESULTS_SUFFIX = " found. Use up and down arrow keys to navigate.";
var SEARCH_RESULTS_ONE_RESULT_FOUND = "1 result" + SEARCH_RESULTS_SUFFIX;
var SEARCH_RESULTS_MULTIPLE_RESULTS_FOUND = "%n results" + SEARCH_RESULTS_SUFFIX;
function mergeConfig(userConfig) {
    var _userConfig$previewCo, _config$customEmojis;
    if (userConfig === void 0) userConfig = {};
    var base = basePickerConfig();
    var previewConfig = Object.assign(base.previewConfig, (_userConfig$previewCo = userConfig.previewConfig) != null ? _userConfig$previewCo : {});
    var config = Object.assign(base, userConfig);
    var categories = mergeCategoriesConfig(userConfig.categories, {
        suggestionMode: config.suggestedEmojisMode
    });
    setCustomEmojis((_config$customEmojis = config.customEmojis) != null ? _config$customEmojis : []);
    var skinTonePickerLocation = config.searchDisabled ? SkinTonePickerLocation.PREVIEW : config.skinTonePickerLocation;
    return _extends({}, config, {
        categories: categories,
        previewConfig: previewConfig,
        skinTonePickerLocation: skinTonePickerLocation
    });
}
function basePickerConfig() {
    return {
        autoFocusSearch: true,
        categories: baseCategoriesConfig(),
        className: "",
        customEmojis: [],
        defaultSkinTone: SkinTones.NEUTRAL,
        emojiStyle: EmojiStyle.APPLE,
        emojiVersion: null,
        getEmojiUrl: emojiUrlByUnified,
        height: 450,
        lazyLoadEmojis: false,
        previewConfig: _extends({}, basePreviewConfig),
        searchDisabled: false,
        searchPlaceHolder: DEFAULT_SEARCH_PLACEHOLDER,
        searchPlaceholder: DEFAULT_SEARCH_PLACEHOLDER,
        skinTonePickerLocation: SkinTonePickerLocation.SEARCH,
        skinTonesDisabled: false,
        style: {},
        suggestedEmojisMode: SuggestionMode.FREQUENT,
        theme: Theme.LIGHT,
        unicodeToHide: new Set(KNOWN_FAILING_EMOJIS),
        width: 350,
        reactionsDefaultOpen: false,
        reactions: DEFAULT_REACTIONS,
        open: true
    };
}
var basePreviewConfig = {
    defaultEmoji: "1f60a",
    defaultCaption: "What's your mood?",
    showPreview: true
};
var _excluded = [
    "children"
];
var ConfigContext = /*#__PURE__*/ (0, _react.createContext)(/*#__PURE__*/ basePickerConfig());
function PickerConfigProvider(_ref) {
    var children = _ref.children, config = _objectWithoutPropertiesLoose(_ref, _excluded);
    var mergedConfig = useSetConfig(config);
    return (0, _react.createElement)(ConfigContext.Provider, {
        value: mergedConfig
    }, children);
}
function useSetConfig(config) {
    var _config$customEmojis;
    var _React$useState = (0, _react.useState)(function() {
        return mergeConfig(config);
    }), mergedConfig = _React$useState[0], setMergedConfig = _React$useState[1];
    (0, _react.useEffect)(function() {
        if (avoidRefresh(config, mergedConfig)) return;
        setMergedConfig(mergeConfig(config));
    // not gonna...
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (_config$customEmojis = config.customEmojis) == null ? void 0 : _config$customEmojis.length,
        config.open
    ]);
    return mergedConfig;
}
function usePickerConfig() {
    return (0, _react.useContext)(ConfigContext);
}
function avoidRefresh(prev, next) {
    var _prev$customEmojis, _next$customEmojis;
    return ((_prev$customEmojis = prev.customEmojis) == null ? void 0 : _prev$customEmojis.length) === ((_next$customEmojis = next.customEmojis) == null ? void 0 : _next$customEmojis.length) && prev.open === next.open;
}
var MutableConfigContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});
function useMutableConfig() {
    var mutableConfig = (0, _reactDefault.default).useContext(MutableConfigContext);
    return mutableConfig;
}
function useDefineMutableConfig(config) {
    var MutableConfigRef = (0, _reactDefault.default).useRef({
        onEmojiClick: config.onEmojiClick || emptyFunc,
        onReactionClick: config.onReactionClick || config.onEmojiClick
    });
    (0, _reactDefault.default).useEffect(function() {
        MutableConfigRef.current.onEmojiClick = config.onEmojiClick || emptyFunc;
        MutableConfigRef.current.onReactionClick = config.onReactionClick || config.onEmojiClick;
    }, [
        config.onEmojiClick,
        config.onReactionClick
    ]);
    return MutableConfigRef;
}
function emptyFunc() {}
var MOUSE_EVENT_SOURCE;
(function(MOUSE_EVENT_SOURCE) {
    MOUSE_EVENT_SOURCE["REACTIONS"] = "reactions";
    MOUSE_EVENT_SOURCE["PICKER"] = "picker";
})(MOUSE_EVENT_SOURCE || (MOUSE_EVENT_SOURCE = {}));
function useSearchPlaceHolderConfig() {
    var _find;
    var _usePickerConfig = usePickerConfig(), searchPlaceHolder = _usePickerConfig.searchPlaceHolder, searchPlaceholder = _usePickerConfig.searchPlaceholder;
    return (_find = [
        searchPlaceHolder,
        searchPlaceholder
    ].find(function(p) {
        return p !== DEFAULT_SEARCH_PLACEHOLDER;
    })) != null ? _find : DEFAULT_SEARCH_PLACEHOLDER;
}
function useDefaultSkinToneConfig() {
    var _usePickerConfig2 = usePickerConfig(), defaultSkinTone = _usePickerConfig2.defaultSkinTone;
    return defaultSkinTone;
}
function useSkinTonesDisabledConfig() {
    var _usePickerConfig3 = usePickerConfig(), skinTonesDisabled = _usePickerConfig3.skinTonesDisabled;
    return skinTonesDisabled;
}
function useEmojiStyleConfig() {
    var _usePickerConfig4 = usePickerConfig(), emojiStyle = _usePickerConfig4.emojiStyle;
    return emojiStyle;
}
function useAutoFocusSearchConfig() {
    var _usePickerConfig5 = usePickerConfig(), autoFocusSearch = _usePickerConfig5.autoFocusSearch;
    return autoFocusSearch;
}
function useCategoriesConfig() {
    var _usePickerConfig6 = usePickerConfig(), categories = _usePickerConfig6.categories;
    return categories;
}
function useCustomEmojisConfig() {
    var _usePickerConfig7 = usePickerConfig(), customEmojis = _usePickerConfig7.customEmojis;
    return customEmojis;
}
function useOpenConfig() {
    var _usePickerConfig8 = usePickerConfig(), open = _usePickerConfig8.open;
    return open;
}
function useOnEmojiClickConfig(mouseEventSource) {
    var _ref;
    var _useMutableConfig = useMutableConfig(), current = _useMutableConfig.current;
    var handler = (_ref = mouseEventSource === MOUSE_EVENT_SOURCE.REACTIONS ? current.onReactionClick : current.onEmojiClick) != null ? _ref : current.onEmojiClick;
    return handler || function() {};
}
function usePreviewConfig() {
    var _usePickerConfig9 = usePickerConfig(), previewConfig = _usePickerConfig9.previewConfig;
    return previewConfig;
}
function useThemeConfig() {
    var _usePickerConfig10 = usePickerConfig(), theme = _usePickerConfig10.theme;
    return theme;
}
function useSuggestedEmojisModeConfig() {
    var _usePickerConfig11 = usePickerConfig(), suggestedEmojisMode = _usePickerConfig11.suggestedEmojisMode;
    return suggestedEmojisMode;
}
function useLazyLoadEmojisConfig() {
    var _usePickerConfig12 = usePickerConfig(), lazyLoadEmojis = _usePickerConfig12.lazyLoadEmojis;
    return lazyLoadEmojis;
}
function useClassNameConfig() {
    var _usePickerConfig13 = usePickerConfig(), className = _usePickerConfig13.className;
    return className;
}
function useStyleConfig() {
    var _usePickerConfig14 = usePickerConfig(), height = _usePickerConfig14.height, width = _usePickerConfig14.width, style = _usePickerConfig14.style;
    return _extends({
        height: getDimension(height),
        width: getDimension(width)
    }, style);
}
function useReactionsOpenConfig() {
    var _usePickerConfig15 = usePickerConfig(), reactionsDefaultOpen = _usePickerConfig15.reactionsDefaultOpen;
    return reactionsDefaultOpen;
}
function useEmojiVersionConfig() {
    var _usePickerConfig16 = usePickerConfig(), emojiVersion = _usePickerConfig16.emojiVersion;
    return emojiVersion;
}
function useSearchDisabledConfig() {
    var _usePickerConfig17 = usePickerConfig(), searchDisabled = _usePickerConfig17.searchDisabled;
    return searchDisabled;
}
function useSkinTonePickerLocationConfig() {
    var _usePickerConfig18 = usePickerConfig(), skinTonePickerLocation = _usePickerConfig18.skinTonePickerLocation;
    return skinTonePickerLocation;
}
function useUnicodeToHide() {
    var _usePickerConfig19 = usePickerConfig(), unicodeToHide = _usePickerConfig19.unicodeToHide;
    return unicodeToHide;
}
function useReactionsConfig() {
    var _usePickerConfig20 = usePickerConfig(), reactions = _usePickerConfig20.reactions;
    return reactions;
}
function useGetEmojiUrlConfig() {
    var _usePickerConfig21 = usePickerConfig(), getEmojiUrl = _usePickerConfig21.getEmojiUrl;
    return getEmojiUrl;
}
function getDimension(dimensionConfig) {
    return typeof dimensionConfig === "number" ? dimensionConfig + "px" : dimensionConfig;
}
function useSearchResultsConfig(searchResultsCount) {
    var hasResults = searchResultsCount > 0;
    var isPlural = searchResultsCount > 1;
    if (hasResults) return isPlural ? SEARCH_RESULTS_MULTIPLE_RESULTS_FOUND.replace("%n", searchResultsCount.toString()) : SEARCH_RESULTS_ONE_RESULT_FOUND;
    return SEARCH_RESULTS_NO_RESULTS_FOUND;
}
function elementCountInRow(parent, element) {
    if (!parent || !element) return 0;
    var parentWidth = parent.getBoundingClientRect().width;
    var elementWidth = element.getBoundingClientRect().width;
    return Math.floor(parentWidth / elementWidth);
}
function elementIndexInRow(parent, element) {
    if (!parent || !element) return 0;
    var elementWidth = element.getBoundingClientRect().width;
    var elementLeft = element.getBoundingClientRect().left;
    var parentLeft = parent.getBoundingClientRect().left;
    return Math.floor((elementLeft - parentLeft) / elementWidth);
}
function rowNumber(parent, element) {
    if (!parent || !element) return 0;
    var elementHeight = element.getBoundingClientRect().height;
    var elementTop = element.getBoundingClientRect().top;
    var parentTop = parent.getBoundingClientRect().top;
    return Math.round((elementTop - parentTop) / elementHeight);
}
function hasNextRow(parent, element) {
    if (!parent || !element) return false;
    var elementHeight = element.getBoundingClientRect().height;
    var elementTop = element.getBoundingClientRect().top;
    var parentTop = parent.getBoundingClientRect().top;
    var parentHeight = parent.getBoundingClientRect().height;
    return Math.round(elementTop - parentTop + elementHeight) < parentHeight;
}
function getRowElements(elements, row, elementsInRow) {
    if (row === -1) {
        var lastRow = Math.floor((elements.length - 1) / elementsInRow);
        var firstElementIndex = lastRow * elementsInRow;
        var lastElementIndex = elements.length - 1;
        return elements.slice(firstElementIndex, lastElementIndex + 1);
    }
    return elements.slice(row * elementsInRow, (row + 1) * elementsInRow);
}
function getNextRowElements(allElements, currentRow, elementsInRow) {
    var nextRow = currentRow + 1;
    if (nextRow * elementsInRow > allElements.length) return [];
    return getRowElements(allElements, nextRow, elementsInRow);
}
function getElementInRow(elements, row, elementsInRow, indexInRow) {
    var rowElements = getRowElements(elements, row, elementsInRow);
    // get element, default to last
    return rowElements[indexInRow] || rowElements[rowElements.length - 1] || null;
}
function getElementInNextRow(allElements, currentRow, elementsInRow, index) {
    var nextRowElements = getNextRowElements(allElements, currentRow, elementsInRow);
    // return item in index, or last item in row
    return nextRowElements[index] || nextRowElements[nextRowElements.length - 1] || null;
}
function getElementInPrevRow(allElements, currentRow, elementsInRow, index) {
    var prevRowElements = getRowElements(allElements, currentRow - 1, elementsInRow);
    // default to last
    return prevRowElements[index] || prevRowElements[prevRowElements.length - 1] || null;
}
function firstVisibleElementInContainer(parent, elements) {
    if (!parent || !elements.length) return null;
    var parentTop = parent.getBoundingClientRect().top;
    var parentBottom = parent.getBoundingClientRect().bottom;
    var visibleElements = elements.find(function(element) {
        var elementTop = element.getBoundingClientRect().top;
        var elementBottom = element.getBoundingClientRect().bottom;
        return elementTop >= parentTop && elementTop <= parentBottom || elementBottom >= parentTop && elementBottom <= parentBottom;
    });
    return visibleElements || null;
}
function hasNextElementSibling(element) {
    return !!element.nextElementSibling;
}
var EmojiButtonSelector = "button" + /*#__PURE__*/ asSelectors(ClassNames.emoji);
var VisibleEmojiSelector = /*#__PURE__*/ [
    EmojiButtonSelector,
    asSelectors(ClassNames.visible),
    ":not(" + asSelectors(ClassNames.hidden) + ")"
].join("");
function buttonFromTarget(emojiElement) {
    var _emojiElement$closest;
    return (_emojiElement$closest = emojiElement == null ? void 0 : emojiElement.closest(EmojiButtonSelector)) != null ? _emojiElement$closest : null;
}
function emojiFromElement(element) {
    var originalUnified = originalUnifiedFromEmojiElement(element);
    var unified = unifiedFromEmojiElement(element);
    if (!originalUnified) return [];
    var emoji = emojiByUnified(unified != null ? unified : originalUnified);
    if (!emoji) return [];
    return [
        emoji,
        unified
    ];
}
function isEmojiElement(element) {
    var _element$parentElemen;
    return Boolean((element == null ? void 0 : element.matches(EmojiButtonSelector)) || (element == null ? void 0 : (_element$parentElemen = element.parentElement) == null ? void 0 : _element$parentElemen.matches(EmojiButtonSelector)));
}
function elementHeight(element) {
    var _element$clientHeight;
    return (_element$clientHeight = element == null ? void 0 : element.clientHeight) != null ? _element$clientHeight : 0;
}
function emojiTrueOffsetTop(element) {
    if (!element) return 0;
    var button = buttonFromTarget(element);
    var category = closestCategory(button);
    // compensate for the label height
    var labelHeight = categoryLabelHeight(category);
    return elementOffsetTop(button) + elementOffsetTop(category) + labelHeight;
}
function categoryLabelHeight(category) {
    var _category$clientHeigh, _categoryWithoutLabel;
    if (!category) return 0;
    var categoryWithoutLabel = category.querySelector(asSelectors(ClassNames.categoryContent));
    return ((_category$clientHeigh = category == null ? void 0 : category.clientHeight) != null ? _category$clientHeigh : 0) - ((_categoryWithoutLabel = categoryWithoutLabel == null ? void 0 : categoryWithoutLabel.clientHeight) != null ? _categoryWithoutLabel : 0);
}
function isEmojiBehindLabel(emoji) {
    if (!emoji) return false;
    return emojiDistanceFromScrollTop(emoji) < categoryLabelHeight(closestCategory(emoji));
}
function queryScrollBody(root) {
    if (!root) return null;
    return root.matches(asSelectors(ClassNames.scrollBody)) ? root : root.querySelector(asSelectors(ClassNames.scrollBody));
}
function emojiDistanceFromScrollTop(emoji) {
    var _closestScrollBody$sc, _closestScrollBody;
    if (!emoji) return 0;
    return emojiTrueOffsetTop(emoji) - ((_closestScrollBody$sc = (_closestScrollBody = closestScrollBody(emoji)) == null ? void 0 : _closestScrollBody.scrollTop) != null ? _closestScrollBody$sc : 0);
}
function closestScrollBody(element) {
    var _element$closest;
    if (!element) return null;
    return (_element$closest = element.closest(asSelectors(ClassNames.scrollBody))) != null ? _element$closest : null;
}
function emojiTruOffsetLeft(element) {
    var button = buttonFromTarget(element);
    var category = closestCategory(button);
    return elementOffsetLeft(button) + elementOffsetLeft(category);
}
function elementOffsetTop(element) {
    var _element$offsetTop;
    return (_element$offsetTop = element == null ? void 0 : element.offsetTop) != null ? _element$offsetTop : 0;
}
function elementOffsetLeft(element) {
    var _element$offsetLeft;
    return (_element$offsetLeft = element == null ? void 0 : element.offsetLeft) != null ? _element$offsetLeft : 0;
}
function unifiedFromEmojiElement(emoji) {
    var _elementDataSetKey;
    return (_elementDataSetKey = elementDataSetKey(buttonFromTarget(emoji), "unified")) != null ? _elementDataSetKey : null;
}
function originalUnifiedFromEmojiElement(emoji) {
    var unified = unifiedFromEmojiElement(emoji);
    if (unified) return unifiedWithoutSkinTone(unified);
    return null;
}
function elementDataSetKey(element, key) {
    var _elementDataSet$key;
    return (_elementDataSet$key = elementDataSet(element)[key]) != null ? _elementDataSet$key : null;
}
function elementDataSet(element) {
    var _element$dataset;
    return (_element$dataset = element == null ? void 0 : element.dataset) != null ? _element$dataset : {};
}
function isVisibleEmoji(element) {
    return element.classList.contains(ClassNames.visible);
}
function isHidden(element) {
    if (!element) return true;
    return element.classList.contains(ClassNames.hidden);
}
function allVisibleEmojis(parent) {
    if (!parent) return [];
    return Array.from(parent.querySelectorAll(VisibleEmojiSelector));
}
function lastVisibleEmoji(element) {
    if (!element) return null;
    var allEmojis = allVisibleEmojis(element);
    var _allEmojis$slice = allEmojis.slice(-1), last = _allEmojis$slice[0];
    if (!last) return null;
    if (!isVisibleEmoji(last)) return prevVisibleEmoji(last);
    return last;
}
function nextVisibleEmoji(element) {
    var next = element.nextElementSibling;
    if (!next) return firstVisibleEmoji(nextCategory(element));
    if (!isVisibleEmoji(next)) return nextVisibleEmoji(next);
    return next;
}
function prevVisibleEmoji(element) {
    var prev = element.previousElementSibling;
    if (!prev) return lastVisibleEmoji(prevCategory(element));
    if (!isVisibleEmoji(prev)) return prevVisibleEmoji(prev);
    return prev;
}
function firstVisibleEmoji(parent) {
    if (!parent) return null;
    var allEmojis = allVisibleEmojis(parent);
    return firstVisibleElementInContainer(parent, allEmojis);
}
function prevCategory(element) {
    var category = closestCategory(element);
    if (!category) return null;
    var prev = category.previousElementSibling;
    if (!prev) return null;
    if (isHidden(prev)) return prevCategory(prev);
    return prev;
}
function nextCategory(element) {
    var category = closestCategory(element);
    if (!category) return null;
    var next = category.nextElementSibling;
    if (!next) return null;
    if (isHidden(next)) return nextCategory(next);
    return next;
}
function closestCategory(element) {
    if (!element) return null;
    return element.closest(asSelectors(ClassNames.category));
}
function closestCategoryContent(element) {
    if (!element) return null;
    return element.closest(asSelectors(ClassNames.categoryContent));
}
function useDebouncedState(initialValue, delay) {
    if (delay === void 0) delay = 0;
    var _useState = (0, _react.useState)(initialValue), state = _useState[0], setState = _useState[1];
    var timer = (0, _react.useRef)(null);
    function debouncedSetState(value) {
        return new Promise(function(resolve) {
            var _window;
            if (timer.current) clearTimeout(timer.current);
            timer.current = (_window = window) == null ? void 0 : _window.setTimeout(function() {
                setState(value);
                resolve(value);
            }, delay);
        });
    }
    return [
        state,
        debouncedSetState
    ];
}
function useIsUnicodeHidden() {
    var unicodeToHide = useUnicodeToHide();
    return function(emojiUnified) {
        return unicodeToHide.has(emojiUnified);
    };
}
function useDisallowedEmojis() {
    var DisallowedEmojisRef = (0, _react.useRef)({});
    var emojiVersionConfig = useEmojiVersionConfig();
    return (0, _react.useMemo)(function() {
        var emojiVersion = parseFloat("" + emojiVersionConfig);
        if (!emojiVersionConfig || Number.isNaN(emojiVersion)) return DisallowedEmojisRef.current;
        return allEmojis.reduce(function(disallowedEmojis, emoji) {
            if (addedInNewerVersion(emoji, emojiVersion)) disallowedEmojis[emojiUnified(emoji)] = true;
            return disallowedEmojis;
        }, DisallowedEmojisRef.current);
    }, [
        emojiVersionConfig
    ]);
}
function useIsEmojiDisallowed() {
    var disallowedEmojis = useDisallowedEmojis();
    var isUnicodeHidden = useIsUnicodeHidden();
    return function isEmojiDisallowed(emoji) {
        var unified = unifiedWithoutSkinTone(emojiUnified(emoji));
        return Boolean(disallowedEmojis[unified] || isUnicodeHidden(unified));
    };
}
function addedInNewerVersion(emoji, supportedLevel) {
    return addedIn(emoji) > supportedLevel;
}
function useMarkInitialLoad(dispatch) {
    (0, _react.useEffect)(function() {
        dispatch(true);
    }, [
        dispatch
    ]);
}
function PickerContextProvider(_ref) {
    var children = _ref.children;
    var disallowedEmojis = useDisallowedEmojis();
    var defaultSkinTone = useDefaultSkinToneConfig();
    var reactionsDefaultOpen = useReactionsOpenConfig();
    // Initialize the filter with the inititial dictionary
    var filterRef = (0, _react.useRef)(alphaNumericEmojiIndex);
    var disallowClickRef = (0, _react.useRef)(false);
    var disallowMouseRef = (0, _react.useRef)(false);
    var disallowedEmojisRef = (0, _react.useRef)(disallowedEmojis);
    var suggestedUpdateState = useDebouncedState(Date.now(), 200);
    var searchTerm = useDebouncedState("", 100);
    var skinToneFanOpenState = (0, _react.useState)(false);
    var activeSkinTone = (0, _react.useState)(defaultSkinTone);
    var activeCategoryState = (0, _react.useState)(null);
    var emojisThatFailedToLoadState = (0, _react.useState)(new Set());
    var emojiVariationPickerState = (0, _react.useState)(null);
    var reactionsModeState = (0, _react.useState)(reactionsDefaultOpen);
    var _useState = (0, _react.useState)(false), isPastInitialLoad = _useState[0], setIsPastInitialLoad = _useState[1];
    useMarkInitialLoad(setIsPastInitialLoad);
    return (0, _react.createElement)(PickerContext.Provider, {
        value: {
            activeCategoryState: activeCategoryState,
            activeSkinTone: activeSkinTone,
            disallowClickRef: disallowClickRef,
            disallowMouseRef: disallowMouseRef,
            disallowedEmojisRef: disallowedEmojisRef,
            emojiVariationPickerState: emojiVariationPickerState,
            emojisThatFailedToLoadState: emojisThatFailedToLoadState,
            filterRef: filterRef,
            isPastInitialLoad: isPastInitialLoad,
            searchTerm: searchTerm,
            skinToneFanOpenState: skinToneFanOpenState,
            suggestedUpdateState: suggestedUpdateState,
            reactionsModeState: reactionsModeState
        }
    }, children);
}
var PickerContext = /*#__PURE__*/ (0, _react.createContext)({
    activeCategoryState: [
        null,
        function() {}
    ],
    activeSkinTone: [
        SkinTones.NEUTRAL,
        function() {}
    ],
    disallowClickRef: {
        current: false
    },
    disallowMouseRef: {
        current: false
    },
    disallowedEmojisRef: {
        current: {}
    },
    emojiVariationPickerState: [
        null,
        function() {}
    ],
    emojisThatFailedToLoadState: [
        /*#__PURE__*/ new Set(),
        function() {}
    ],
    filterRef: {
        current: {}
    },
    isPastInitialLoad: true,
    searchTerm: [
        "",
        function() {
            return new Promise(function() {
                return undefined;
            });
        }
    ],
    skinToneFanOpenState: [
        false,
        function() {}
    ],
    suggestedUpdateState: [
        /*#__PURE__*/ Date.now(),
        function() {}
    ],
    reactionsModeState: [
        false,
        function() {}
    ]
});
function useFilterRef() {
    var _React$useContext = (0, _react.useContext)(PickerContext), filterRef = _React$useContext.filterRef;
    return filterRef;
}
function useDisallowClickRef() {
    var _React$useContext2 = (0, _react.useContext)(PickerContext), disallowClickRef = _React$useContext2.disallowClickRef;
    return disallowClickRef;
}
function useDisallowMouseRef() {
    var _React$useContext3 = (0, _react.useContext)(PickerContext), disallowMouseRef = _React$useContext3.disallowMouseRef;
    return disallowMouseRef;
}
function useReactionsModeState() {
    var _React$useContext4 = (0, _react.useContext)(PickerContext), reactionsModeState = _React$useContext4.reactionsModeState;
    return reactionsModeState;
}
function useSearchTermState() {
    var _React$useContext5 = (0, _react.useContext)(PickerContext), searchTerm = _React$useContext5.searchTerm;
    return searchTerm;
}
function useActiveSkinToneState() {
    var _React$useContext6 = (0, _react.useContext)(PickerContext), activeSkinTone = _React$useContext6.activeSkinTone;
    return activeSkinTone;
}
function useEmojisThatFailedToLoadState() {
    var _React$useContext7 = (0, _react.useContext)(PickerContext), emojisThatFailedToLoadState = _React$useContext7.emojisThatFailedToLoadState;
    return emojisThatFailedToLoadState;
}
function useIsPastInitialLoad() {
    var _React$useContext8 = (0, _react.useContext)(PickerContext), isPastInitialLoad = _React$useContext8.isPastInitialLoad;
    return isPastInitialLoad;
}
function useEmojiVariationPickerState() {
    var _React$useContext9 = (0, _react.useContext)(PickerContext), emojiVariationPickerState = _React$useContext9.emojiVariationPickerState;
    return emojiVariationPickerState;
}
function useSkinToneFanOpenState() {
    var _React$useContext10 = (0, _react.useContext)(PickerContext), skinToneFanOpenState = _React$useContext10.skinToneFanOpenState;
    return skinToneFanOpenState;
}
function useUpdateSuggested() {
    var _React$useContext12 = (0, _react.useContext)(PickerContext), suggestedUpdateState = _React$useContext12.suggestedUpdateState;
    var suggestedUpdated = suggestedUpdateState[0], setsuggestedUpdate = suggestedUpdateState[1];
    return [
        suggestedUpdated,
        function updateSuggested() {
            setsuggestedUpdate(Date.now());
        }
    ];
}
function parseNativeEmoji(unified) {
    return unified.split("-").map(function(hex) {
        return String.fromCodePoint(parseInt(hex, 16));
    }).join("");
}
var SUGGESTED_LS_KEY = "epr_suggested";
function getSuggested(mode) {
    try {
        var _window, _window$localStorage$, _window2;
        if (!((_window = window) != null && _window.localStorage)) return [];
        var recent = JSON.parse((_window$localStorage$ = (_window2 = window) == null ? void 0 : _window2.localStorage.getItem(SUGGESTED_LS_KEY)) != null ? _window$localStorage$ : "[]");
        if (mode === SuggestionMode.FREQUENT) return recent.sort(function(a, b) {
            return b.count - a.count;
        });
        return recent;
    } catch (_unused) {
        return [];
    }
}
function setSuggested(emoji, skinTone) {
    var recent = getSuggested();
    var unified = emojiUnified(emoji, skinTone);
    var originalUnified = emojiUnified(emoji);
    var existing = recent.find(function(_ref) {
        var u = _ref.unified;
        return u === unified;
    });
    var nextList;
    if (existing) nextList = [
        existing
    ].concat(recent.filter(function(i) {
        return i !== existing;
    }));
    else {
        existing = {
            unified: unified,
            original: originalUnified,
            count: 0
        };
        nextList = [
            existing
        ].concat(recent);
    }
    existing.count++;
    nextList.length = Math.min(nextList.length, 14);
    try {
        var _window3;
        (_window3 = window) == null || _window3.localStorage.setItem(SUGGESTED_LS_KEY, JSON.stringify(nextList));
    // Prevents the change from being seen immediately.
    } catch (_unused2) {
    // ignore
    }
}
function isCustomCategory(category) {
    return category.category === Categories.CUSTOM;
}
function isCustomEmoji(emoji) {
    return emoji.imgUrl !== undefined;
}
function useCloseAllOpenToggles() {
    var _useEmojiVariationPic = useEmojiVariationPickerState(), variationPicker = _useEmojiVariationPic[0], setVariationPicker = _useEmojiVariationPic[1];
    var _useSkinToneFanOpenSt = useSkinToneFanOpenState(), skinToneFanOpen = _useSkinToneFanOpenSt[0], setSkinToneFanOpen = _useSkinToneFanOpenSt[1];
    var closeAllOpenToggles = (0, _react.useCallback)(function() {
        if (variationPicker) setVariationPicker(null);
        if (skinToneFanOpen) setSkinToneFanOpen(false);
    }, [
        variationPicker,
        skinToneFanOpen,
        setVariationPicker,
        setSkinToneFanOpen
    ]);
    return closeAllOpenToggles;
}
function useHasOpenToggles() {
    var _useEmojiVariationPic2 = useEmojiVariationPickerState(), variationPicker = _useEmojiVariationPic2[0];
    var _useSkinToneFanOpenSt2 = useSkinToneFanOpenState(), skinToneFanOpen = _useSkinToneFanOpenSt2[0];
    return function hasOpenToggles() {
        return !!variationPicker || skinToneFanOpen;
    };
}
function focusElement(element) {
    if (!element) return;
    requestAnimationFrame(function() {
        element.focus();
    });
}
function focusPrevElementSibling(element) {
    if (!element) return;
    var prev = element.previousElementSibling;
    focusElement(prev);
}
function focusNextElementSibling(element) {
    if (!element) return;
    var next = element.nextElementSibling;
    focusElement(next);
}
function focusFirstElementChild(element) {
    if (!element) return;
    var first = element.firstElementChild;
    focusElement(first);
}
function ElementRefContextProvider(_ref) {
    var children = _ref.children;
    var PickerMainRef = (0, _react.useRef)(null);
    var AnchoredEmojiRef = (0, _react.useRef)(null);
    var BodyRef = (0, _react.useRef)(null);
    var SearchInputRef = (0, _react.useRef)(null);
    var SkinTonePickerRef = (0, _react.useRef)(null);
    var CategoryNavigationRef = (0, _react.useRef)(null);
    var VariationPickerRef = (0, _react.useRef)(null);
    var ReactionsRef = (0, _react.useRef)(null);
    return (0, _react.createElement)(ElementRefContext.Provider, {
        value: {
            AnchoredEmojiRef: AnchoredEmojiRef,
            BodyRef: BodyRef,
            CategoryNavigationRef: CategoryNavigationRef,
            PickerMainRef: PickerMainRef,
            SearchInputRef: SearchInputRef,
            SkinTonePickerRef: SkinTonePickerRef,
            VariationPickerRef: VariationPickerRef,
            ReactionsRef: ReactionsRef
        }
    }, children);
}
var ElementRefContext = /*#__PURE__*/ (0, _react.createContext)({
    AnchoredEmojiRef: /*#__PURE__*/ (0, _react.createRef)(),
    BodyRef: /*#__PURE__*/ (0, _react.createRef)(),
    CategoryNavigationRef: /*#__PURE__*/ (0, _react.createRef)(),
    PickerMainRef: /*#__PURE__*/ (0, _react.createRef)(),
    SearchInputRef: /*#__PURE__*/ (0, _react.createRef)(),
    SkinTonePickerRef: /*#__PURE__*/ (0, _react.createRef)(),
    VariationPickerRef: /*#__PURE__*/ (0, _react.createRef)(),
    ReactionsRef: /*#__PURE__*/ (0, _react.createRef)()
});
function useElementRef() {
    return (0, _react.useContext)(ElementRefContext);
}
function usePickerMainRef() {
    return useElementRef()["PickerMainRef"];
}
function useAnchoredEmojiRef() {
    return useElementRef()["AnchoredEmojiRef"];
}
function useSetAnchoredEmojiRef() {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    return function(target) {
        if (target === null && AnchoredEmojiRef.current !== null) focusElement(AnchoredEmojiRef.current);
        AnchoredEmojiRef.current = target;
    };
}
function useBodyRef() {
    return useElementRef()["BodyRef"];
}
function useReactionsRef() {
    return useElementRef()["ReactionsRef"];
}
function useSearchInputRef() {
    return useElementRef()["SearchInputRef"];
}
function useSkinTonePickerRef() {
    return useElementRef()["SkinTonePickerRef"];
}
function useCategoryNavigationRef() {
    return useElementRef()["CategoryNavigationRef"];
}
function useVariationPickerRef() {
    return useElementRef()["VariationPickerRef"];
}
function useSetVariationPicker() {
    var setAnchoredEmojiRef = useSetAnchoredEmojiRef();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), setEmojiVariationPicker = _useEmojiVariationPic[1];
    return function setVariationPicker(element) {
        var _emojiFromElement = emojiFromElement(element), emoji = _emojiFromElement[0];
        if (emoji) {
            setAnchoredEmojiRef(element);
            setEmojiVariationPicker(emoji);
        }
    };
}
function useMouseDownHandlers(ContainerRef, mouseEventSource) {
    var mouseDownTimerRef = (0, _react.useRef)();
    var setVariationPicker = useSetVariationPicker();
    var disallowClickRef = useDisallowClickRef();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), setEmojiVariationPicker = _useEmojiVariationPic[1];
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var _useActiveSkinToneSta = useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0];
    var onEmojiClick = useOnEmojiClickConfig(mouseEventSource);
    var _useUpdateSuggested = useUpdateSuggested(), updateSuggested = _useUpdateSuggested[1];
    var getEmojiUrl = useGetEmojiUrlConfig();
    var activeEmojiStyle = useEmojiStyleConfig();
    var onClick = (0, _react.useCallback)(function onClick(event) {
        if (disallowClickRef.current) return;
        closeAllOpenToggles();
        var _emojiFromEvent = emojiFromEvent(event), emoji = _emojiFromEvent[0], unified = _emojiFromEvent[1];
        if (!emoji || !unified) return;
        var skinToneToUse = activeVariationFromUnified(unified) || activeSkinTone;
        updateSuggested();
        setSuggested(emoji, skinToneToUse);
        onEmojiClick(emojiClickOutput(emoji, skinToneToUse, activeEmojiStyle, getEmojiUrl), event);
    }, [
        activeSkinTone,
        closeAllOpenToggles,
        disallowClickRef,
        onEmojiClick,
        updateSuggested,
        getEmojiUrl,
        activeEmojiStyle
    ]);
    var onMouseDown = (0, _react.useCallback)(function onMouseDown(event) {
        var _window;
        if (mouseDownTimerRef.current) clearTimeout(mouseDownTimerRef.current);
        var _emojiFromEvent2 = emojiFromEvent(event), emoji = _emojiFromEvent2[0];
        if (!emoji || !emojiHasVariations(emoji)) return;
        mouseDownTimerRef.current = (_window = window) == null ? void 0 : _window.setTimeout(function() {
            disallowClickRef.current = true;
            mouseDownTimerRef.current = undefined;
            closeAllOpenToggles();
            setVariationPicker(event.target);
            setEmojiVariationPicker(emoji);
        }, 500);
    }, [
        disallowClickRef,
        closeAllOpenToggles,
        setVariationPicker,
        setEmojiVariationPicker
    ]);
    var onMouseUp = (0, _react.useCallback)(function onMouseUp() {
        if (mouseDownTimerRef.current) {
            clearTimeout(mouseDownTimerRef.current);
            mouseDownTimerRef.current = undefined;
        } else if (disallowClickRef.current) // The problem we're trying to overcome here
        // is that the emoji has both mouseup and click events
        // and when releasing a mouseup event
        // the click gets triggered too
        // So we're disallowing the click event for a short time
        requestAnimationFrame(function() {
            disallowClickRef.current = false;
        });
    }, [
        disallowClickRef
    ]);
    (0, _react.useEffect)(function() {
        if (!ContainerRef.current) return;
        var confainerRef = ContainerRef.current;
        confainerRef.addEventListener("click", onClick, {
            passive: true
        });
        confainerRef.addEventListener("mousedown", onMouseDown, {
            passive: true
        });
        confainerRef.addEventListener("mouseup", onMouseUp, {
            passive: true
        });
        return function() {
            confainerRef == null || confainerRef.removeEventListener("click", onClick);
            confainerRef == null || confainerRef.removeEventListener("mousedown", onMouseDown);
            confainerRef == null || confainerRef.removeEventListener("mouseup", onMouseUp);
        };
    }, [
        ContainerRef,
        onClick,
        onMouseDown,
        onMouseUp
    ]);
}
function emojiFromEvent(event) {
    var target = event == null ? void 0 : event.target;
    if (!isEmojiElement(target)) return [];
    return emojiFromElement(target);
}
function emojiClickOutput(emoji, activeSkinTone, activeEmojiStyle, getEmojiUrl) {
    var names = emojiNames(emoji);
    if (isCustomEmoji(emoji)) {
        var _unified = emojiUnified(emoji);
        return {
            activeSkinTone: activeSkinTone,
            emoji: _unified,
            getImageUrl: function getImageUrl() {
                return emoji.imgUrl;
            },
            imageUrl: emoji.imgUrl,
            isCustom: true,
            names: names,
            unified: _unified,
            unifiedWithoutSkinTone: _unified
        };
    }
    var unified = emojiUnified(emoji, activeSkinTone);
    return {
        activeSkinTone: activeSkinTone,
        emoji: parseNativeEmoji(unified),
        getImageUrl: function getImageUrl(emojiStyle) {
            if (emojiStyle === void 0) emojiStyle = activeEmojiStyle != null ? activeEmojiStyle : EmojiStyle.APPLE;
            return getEmojiUrl(unified, emojiStyle);
        },
        imageUrl: getEmojiUrl(unified, activeEmojiStyle != null ? activeEmojiStyle : EmojiStyle.APPLE),
        isCustom: false,
        names: names,
        unified: unified,
        unifiedWithoutSkinTone: emojiUnified(emoji)
    };
}
function Button(props) {
    return (0, _react.createElement)("button", Object.assign({
        type: "button"
    }, props, {
        className: (0, _flairup.cx)(styles.button, props.className)
    }), props.children);
}
var styles = /*#__PURE__*/ stylesheet.create({
    button: {
        ".": "epr-btn",
        cursor: "pointer",
        border: "0",
        background: "none",
        outline: "none"
    }
});
function ClickableEmojiButton(_ref) {
    var _cx;
    var emojiNames = _ref.emojiNames, unified = _ref.unified, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch, _ref$showVariations = _ref.showVariations, showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations, hasVariations = _ref.hasVariations, children = _ref.children, className = _ref.className, _ref$noBackground = _ref.noBackground, noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground;
    return (0, _react.createElement)(Button, {
        className: (0, _flairup.cx)(styles$1.emoji, hidden && commonStyles.hidden, hiddenOnSearch && commonInteractionStyles.hiddenOnSearch, (_cx = {}, _cx[ClassNames.visible] = !hidden && !hiddenOnSearch, _cx), !!(hasVariations && showVariations) && styles$1.hasVariations, noBackground && styles$1.noBackground, className),
        "data-unified": unified,
        "aria-label": emojiNames[0],
        "data-full-name": emojiNames
    }, children);
}
var styles$1 = /*#__PURE__*/ stylesheet.create({
    emoji: {
        ".": ClassNames.emoji,
        position: "relative",
        width: "var(--epr-emoji-fullsize)",
        height: "var(--epr-emoji-fullsize)",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "var(--epr-emoji-fullsize)",
        maxHeight: "var(--epr-emoji-fullsize)",
        borderRadius: "8px",
        overflow: "hidden",
        transition: "background-color 0.2s",
        ":hover": {
            backgroundColor: "var(--epr-emoji-hover-color)"
        },
        ":focus": {
            backgroundColor: "var(--epr-focus-bg-color)"
        }
    },
    noBackground: {
        background: "none",
        ":hover": {
            backgroundColor: "transparent",
            background: "none"
        },
        ":focus": {
            backgroundColor: "transparent",
            background: "none"
        }
    },
    hasVariations: {
        ".": ClassNames.emojiHasVariations,
        ":after": {
            content: "",
            display: "block",
            width: "0",
            height: "0",
            right: "0px",
            bottom: "1px",
            position: "absolute",
            borderLeft: "4px solid transparent",
            borderRight: "4px solid transparent",
            transform: "rotate(135deg)",
            borderBottom: "4px solid var(--epr-emoji-variation-indicator-color)",
            zIndex: "var(--epr-emoji-variations-indictator-z-index)"
        },
        ":hover:after": {
            borderBottom: "4px solid var(--epr-emoji-variation-indicator-color-hover)"
        }
    }
});
var emojiStyles = /*#__PURE__*/ stylesheet.create({
    external: {
        ".": ClassNames.external,
        fontSize: "0"
    },
    common: {
        alignSelf: "center",
        justifySelf: "center",
        display: "block"
    }
});
function EmojiImg(_ref) {
    var emojiName = _ref.emojiName, style = _ref.style, _ref$lazyLoad = _ref.lazyLoad, lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad, imgUrl = _ref.imgUrl, onError = _ref.onError, className = _ref.className;
    return (0, _react.createElement)("img", {
        src: imgUrl,
        alt: emojiName,
        className: (0, _flairup.cx)(styles$2.emojiImag, emojiStyles.external, emojiStyles.common, className),
        loading: lazyLoad ? "lazy" : "eager",
        onError: onError,
        style: style
    });
}
var styles$2 = /*#__PURE__*/ stylesheet.create({
    emojiImag: {
        ".": "epr-emoji-img",
        maxWidth: "var(--epr-emoji-fullsize)",
        maxHeight: "var(--epr-emoji-fullsize)",
        minWidth: "var(--epr-emoji-fullsize)",
        minHeight: "var(--epr-emoji-fullsize)",
        padding: "var(--epr-emoji-padding)"
    }
});
function NativeEmoji(_ref) {
    var unified = _ref.unified, style = _ref.style, className = _ref.className;
    return (0, _react.createElement)("span", {
        className: (0, _flairup.cx)(styles$3.nativeEmoji, emojiStyles.common, emojiStyles.external, className),
        "data-unified": unified,
        style: style
    }, parseNativeEmoji(unified));
}
var styles$3 = /*#__PURE__*/ stylesheet.create({
    nativeEmoji: {
        ".": "epr-emoji-native",
        fontFamily: '"Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji"!important',
        position: "relative",
        lineHeight: "100%",
        fontSize: "var(--epr-emoji-size)",
        textAlign: "center",
        alignSelf: "center",
        justifySelf: "center",
        letterSpacing: "0",
        padding: "var(--epr-emoji-padding)"
    }
});
function ViewOnlyEmoji(_ref) {
    var emoji = _ref.emoji, unified = _ref.unified, emojiStyle = _ref.emojiStyle, size = _ref.size, lazyLoad = _ref.lazyLoad, _ref$getEmojiUrl = _ref.getEmojiUrl, getEmojiUrl = _ref$getEmojiUrl === void 0 ? emojiUrlByUnified : _ref$getEmojiUrl, className = _ref.className;
    var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(), setEmojisThatFailedToLoad = _useEmojisThatFailedT[1];
    var style = {};
    if (size) style.width = style.height = style.fontSize = size + "px";
    var emojiToRender = emoji ? emoji : emojiByUnified(unified);
    if (!emojiToRender) return null;
    if (isCustomEmoji(emojiToRender)) return (0, _react.createElement)(EmojiImg, {
        style: style,
        emojiName: unified,
        emojiStyle: EmojiStyle.NATIVE,
        lazyLoad: lazyLoad,
        imgUrl: emojiToRender.imgUrl,
        onError: onError,
        className: className
    });
    return (0, _react.createElement)((0, _react.Fragment), null, emojiStyle === EmojiStyle.NATIVE ? (0, _react.createElement)(NativeEmoji, {
        unified: unified,
        style: style,
        className: className
    }) : (0, _react.createElement)(EmojiImg, {
        style: style,
        emojiName: emojiName(emojiToRender),
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        imgUrl: getEmojiUrl(unified, emojiStyle),
        onError: onError,
        className: className
    }));
    function onError() {
        setEmojisThatFailedToLoad(function(prev) {
            return new Set(prev).add(unified);
        });
    }
}
function ClickableEmoji(_ref) {
    var emoji = _ref.emoji, unified = _ref.unified, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch, emojiStyle = _ref.emojiStyle, _ref$showVariations = _ref.showVariations, showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations, size = _ref.size, lazyLoad = _ref.lazyLoad, getEmojiUrl = _ref.getEmojiUrl, className = _ref.className, _ref$noBackground = _ref.noBackground, noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground;
    var hasVariations = emojiHasVariations(emoji);
    return (0, _react.createElement)(ClickableEmojiButton, {
        hasVariations: hasVariations,
        showVariations: showVariations,
        hidden: hidden,
        hiddenOnSearch: hiddenOnSearch,
        emojiNames: emojiNames(emoji),
        unified: unified,
        noBackground: noBackground
    }, (0, _react.createElement)(ViewOnlyEmoji, {
        unified: unified,
        emoji: emoji,
        size: size,
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        getEmojiUrl: getEmojiUrl,
        className: className
    }));
}
var Plus = "data:image/svg+xml;base64,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";
function BtnPlus() {
    var _useReactionsModeStat = useReactionsModeState(), setReactionsMode = _useReactionsModeStat[1];
    return (0, _react.createElement)(Button, {
        "aria-label": "Show all Emojis",
        title: "Show all Emojis",
        tabIndex: 0,
        className: (0, _flairup.cx)(styles$4.plusSign),
        onClick: function onClick() {
            return setReactionsMode(false);
        }
    });
}
var styles$4 = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    plusSign: {
        fontSize: "20px",
        padding: "17px",
        color: "var(--epr-text-color)",
        borderRadius: "50%",
        textAlign: "center",
        lineHeight: "100%",
        width: "20px",
        height: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "background-color 0.2s ease-in-out",
        ":after": {
            content: "",
            minWidth: "20px",
            minHeight: "20px",
            backgroundImage: "url(" + Plus + ")",
            backgroundColor: "transparent",
            backgroundRepeat: "no-repeat",
            backgroundSize: "20px",
            backgroundPositionY: "0"
        },
        ":hover": {
            color: "var(--epr-highlight-color)",
            backgroundColor: "var(--epr-hover-bg-color-reduced-opacity)",
            // @ts-ignore
            ":after": {
                backgroundPositionY: "-20px"
            }
        },
        ":focus": {
            color: "var(--epr-highlight-color)",
            backgroundColor: "var(--epr-hover-bg-color-reduced-opacity)",
            // @ts-ignore
            ":after": {
                backgroundPositionY: "-40px"
            }
        }
    }
}, /*#__PURE__*/ darkMode("plusSign", {
    ":after": {
        backgroundPositionY: "-40px"
    },
    ":hover:after": {
        backgroundPositionY: "-60px"
    }
})));
function Reactions() {
    var _useReactionsModeStat = useReactionsModeState(), reactionsOpen = _useReactionsModeStat[0];
    var ReactionsRef = useReactionsRef();
    var reactions = useReactionsConfig();
    useMouseDownHandlers(ReactionsRef, MOUSE_EVENT_SOURCE.REACTIONS);
    var emojiStyle = useEmojiStyleConfig();
    if (!reactionsOpen) return null;
    return (0, _react.createElement)("ul", {
        className: (0, _flairup.cx)(styles$5.list, !reactionsOpen && commonStyles.hidden),
        ref: ReactionsRef
    }, reactions.map(function(reaction) {
        return (0, _react.createElement)("li", {
            key: reaction
        }, (0, _react.createElement)(ClickableEmoji, {
            emoji: emojiByUnified(reaction),
            emojiStyle: emojiStyle,
            unified: reaction,
            showVariations: false,
            className: (0, _flairup.cx)(styles$5.emojiButton),
            noBackground: true
        }));
    }), (0, _react.createElement)("li", null, (0, _react.createElement)(BtnPlus, null)));
}
var styles$5 = /*#__PURE__*/ stylesheet.create({
    list: {
        listStyle: "none",
        margin: "0",
        padding: "0 5px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "100%"
    },
    emojiButton: {
        ":hover": {
            transform: "scale(1.2)"
        },
        ":focus": {
            transform: "scale(1.2)"
        },
        ":active": {
            transform: "scale(1.1)"
        },
        transition: "transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.5)"
    }
});
function useDisallowMouseMove() {
    var DisallowMouseRef = useDisallowMouseRef();
    return function disallowMouseMove() {
        DisallowMouseRef.current = true;
    };
}
function useAllowMouseMove() {
    var DisallowMouseRef = useDisallowMouseRef();
    return function allowMouseMove() {
        DisallowMouseRef.current = false;
    };
}
function useIsMouseDisallowed() {
    var DisallowMouseRef = useDisallowMouseRef();
    return function isMouseDisallowed() {
        return DisallowMouseRef.current;
    };
}
function useOnMouseMove() {
    var BodyRef = useBodyRef();
    var allowMouseMove = useAllowMouseMove();
    var isMouseDisallowed = useIsMouseDisallowed();
    (0, _react.useEffect)(function() {
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener("mousemove", onMouseMove, {
            passive: true
        });
        function onMouseMove() {
            if (isMouseDisallowed()) allowMouseMove();
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener("mousemove", onMouseMove);
        };
    }, [
        BodyRef,
        allowMouseMove,
        isMouseDisallowed
    ]);
}
function useOnScroll(BodyRef) {
    var closeAllOpenToggles = useCloseAllOpenToggles();
    (0, _react.useEffect)(function() {
        var bodyRef = BodyRef.current;
        if (!bodyRef) return;
        bodyRef.addEventListener("scroll", onScroll, {
            passive: true
        });
        function onScroll() {
            closeAllOpenToggles();
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener("scroll", onScroll);
        };
    }, [
        BodyRef,
        closeAllOpenToggles
    ]);
}
function scrollTo(root, top) {
    if (top === void 0) top = 0;
    var $eprBody = queryScrollBody(root);
    if (!$eprBody) return;
    requestAnimationFrame(function() {
        $eprBody.scrollTop = top + 1;
    });
}
function scrollBy(root, by) {
    var $eprBody = queryScrollBody(root);
    if (!$eprBody) return;
    requestAnimationFrame(function() {
        $eprBody.scrollTop = $eprBody.scrollTop + by;
    });
}
function useScrollTo() {
    var BodyRef = useBodyRef();
    return (0, _react.useCallback)(function(top) {
        requestAnimationFrame(function() {
            if (BodyRef.current) BodyRef.current.scrollTop = top;
        });
    }, [
        BodyRef
    ]);
}
function scrollEmojiAboveLabel(emoji) {
    if (!emoji || !isEmojiBehindLabel(emoji)) return;
    if (emoji.closest(asSelectors(ClassNames.variationPicker))) return;
    var scrollBody = closestScrollBody(emoji);
    var by = emojiDistanceFromScrollTop(emoji);
    scrollBy(scrollBody, -(categoryLabelHeight(closestCategory(emoji)) - by));
}
function useFocusSearchInput() {
    var SearchInputRef = useSearchInputRef();
    return (0, _react.useCallback)(function() {
        focusElement(SearchInputRef.current);
    }, [
        SearchInputRef
    ]);
}
function useFocusSkinTonePicker() {
    var SkinTonePickerRef = useSkinTonePickerRef();
    return (0, _react.useCallback)(function() {
        if (!SkinTonePickerRef.current) return;
        focusFirstElementChild(SkinTonePickerRef.current);
    }, [
        SkinTonePickerRef
    ]);
}
function useFocusCategoryNavigation() {
    var CategoryNavigationRef = useCategoryNavigationRef();
    return (0, _react.useCallback)(function() {
        if (!CategoryNavigationRef.current) return;
        focusFirstElementChild(CategoryNavigationRef.current);
    }, [
        CategoryNavigationRef
    ]);
}
function useSetFilterRef() {
    var filterRef = useFilterRef();
    return function setFilter(setter) {
        if (typeof setter === "function") return setFilter(setter(filterRef.current));
        filterRef.current = setter;
    };
}
function useClearSearch() {
    var applySearch = useApplySearch();
    var SearchInputRef = useSearchInputRef();
    var focusSearchInput = useFocusSearchInput();
    return function clearSearch() {
        if (SearchInputRef.current) SearchInputRef.current.value = "";
        applySearch("");
        focusSearchInput();
    };
}
function useAppendSearch() {
    var SearchInputRef = useSearchInputRef();
    var applySearch = useApplySearch();
    return function appendSearch(str) {
        if (SearchInputRef.current) {
            SearchInputRef.current.value = "" + SearchInputRef.current.value + str;
            applySearch(getNormalizedSearchTerm(SearchInputRef.current.value));
        } else applySearch(getNormalizedSearchTerm(str));
    };
}
function useFilter() {
    var SearchInputRef = useSearchInputRef();
    var filterRef = useFilterRef();
    var setFilterRef = useSetFilterRef();
    var applySearch = useApplySearch();
    var _useSearchTermState = useSearchTermState(), searchTerm = _useSearchTermState[0];
    var statusSearchResults = getStatusSearchResults(filterRef.current, searchTerm);
    return {
        onChange: onChange,
        searchTerm: searchTerm,
        SearchInputRef: SearchInputRef,
        statusSearchResults: statusSearchResults
    };
    function onChange(inputValue) {
        var filter = filterRef.current;
        var nextValue = inputValue.toLowerCase();
        if (filter != null && filter[nextValue] || nextValue.length <= 1) return applySearch(nextValue);
        var longestMatch = findLongestMatch(nextValue, filter);
        if (!longestMatch) // Can we even get here?
        // If so, we need to search among all emojis
        return applySearch(nextValue);
        setFilterRef(function(current) {
            var _Object$assign;
            return Object.assign(current, (_Object$assign = {}, _Object$assign[nextValue] = filterEmojiObjectByKeyword(longestMatch, nextValue), _Object$assign));
        });
        applySearch(nextValue);
    }
}
function useApplySearch() {
    var _useSearchTermState2 = useSearchTermState(), setSearchTerm = _useSearchTermState2[1];
    var PickerMainRef = usePickerMainRef();
    return function applySearch(searchTerm) {
        requestAnimationFrame(function() {
            setSearchTerm(searchTerm ? searchTerm == null ? void 0 : searchTerm.toLowerCase() : searchTerm).then(function() {
                scrollTo(PickerMainRef.current, 0);
            });
        });
    };
}
function filterEmojiObjectByKeyword(emojis, keyword) {
    var filtered = {};
    for(var unified in emojis){
        var emoji = emojis[unified];
        if (hasMatch(emoji, keyword)) filtered[unified] = emoji;
    }
    return filtered;
}
function hasMatch(emoji, keyword) {
    return emojiNames(emoji).some(function(name) {
        return name.includes(keyword);
    });
}
function useIsEmojiFiltered() {
    var _useFilterRef = useFilterRef(), filter = _useFilterRef.current;
    var _useSearchTermState3 = useSearchTermState(), searchTerm = _useSearchTermState3[0];
    return function(unified) {
        return isEmojiFilteredBySearchTerm(unified, filter, searchTerm);
    };
}
function isEmojiFilteredBySearchTerm(unified, filter, searchTerm) {
    var _filter$searchTerm;
    if (!filter || !searchTerm) return false;
    return !((_filter$searchTerm = filter[searchTerm]) != null && _filter$searchTerm[unified]);
}
function findLongestMatch(keyword, dict) {
    if (!dict) return null;
    if (dict[keyword]) return dict[keyword];
    var longestMatchingKey = Object.keys(dict).sort(function(a, b) {
        return b.length - a.length;
    }).find(function(key) {
        return keyword.includes(key);
    });
    if (longestMatchingKey) return dict[longestMatchingKey];
    return null;
}
function getNormalizedSearchTerm(str) {
    if (!str || typeof str !== "string") return "";
    return str.trim().toLowerCase();
}
function getStatusSearchResults(filterState, searchTerm) {
    var _Object$entries;
    if (!(filterState != null && filterState[searchTerm])) return "";
    var searchResultsCount = ((_Object$entries = Object.entries(filterState == null ? void 0 : filterState[searchTerm])) == null ? void 0 : _Object$entries.length) || 0;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useSearchResultsConfig(searchResultsCount);
}
function useIsEmojiHidden() {
    var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(), emojisThatFailedToLoad = _useEmojisThatFailedT[0];
    var isEmojiFiltered = useIsEmojiFiltered();
    return function(emoji) {
        var unified = emojiUnified(emoji);
        var failedToLoad = emojisThatFailedToLoad.has(unified);
        var filteredOut = isEmojiFiltered(unified);
        return {
            failedToLoad: failedToLoad,
            filteredOut: filteredOut,
            hidden: failedToLoad || filteredOut
        };
    };
}
function EmojiCategory(_ref) {
    var categoryConfig = _ref.categoryConfig, children = _ref.children, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch;
    var category = categoryFromCategoryConfig(categoryConfig);
    var categoryName = categoryNameFromCategoryConfig(categoryConfig);
    return (0, _react.createElement)("li", {
        className: (0, _flairup.cx)(styles$6.category, hidden && commonStyles.hidden, hiddenOnSearch && commonInteractionStyles.hiddenOnSearch),
        "data-name": category,
        "aria-label": categoryName
    }, (0, _react.createElement)("h2", {
        className: (0, _flairup.cx)(styles$6.label)
    }, categoryName), (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$6.categoryContent)
    }, children));
}
var styles$6 = /*#__PURE__*/ stylesheet.create({
    category: {
        ".": ClassNames.category,
        ":not(:has(.epr-visible))": {
            display: "none"
        }
    },
    categoryContent: {
        ".": ClassNames.categoryContent,
        display: "grid",
        gridGap: "0",
        gridTemplateColumns: "repeat(auto-fill, var(--epr-emoji-fullsize))",
        justifyContent: "space-between",
        margin: "var(--epr-category-padding)",
        position: "relative"
    },
    label: {
        ".": ClassNames.label,
        alignItems: "center",
        // @ts-expect-error - backdropFilter is a valid CSS property
        backdropFilter: "blur(3px)",
        backgroundColor: "var(--epr-category-label-bg-color)",
        color: "var(--epr-category-label-text-color)",
        display: "flex",
        fontSize: "16px",
        fontWeight: "bold",
        height: "var(--epr-category-label-height)",
        margin: "0",
        padding: "var(--epr-category-label-padding)",
        position: "sticky",
        textTransform: "capitalize",
        top: "0",
        width: "100%",
        zIndex: "var(--epr-category-label-z-index)"
    }
});
var isEverMounted = false;
function useIsEverMounted() {
    var _React$useState = (0, _react.useState)(isEverMounted), isMounted = _React$useState[0], setIsMounted = _React$useState[1];
    (0, _react.useEffect)(function() {
        setIsMounted(true);
        isEverMounted = true;
    }, []);
    return isMounted || isEverMounted;
}
function Suggested(_ref) {
    var categoryConfig = _ref.categoryConfig;
    var _useUpdateSuggested = useUpdateSuggested(), suggestedUpdated = _useUpdateSuggested[0];
    var isMounted = useIsEverMounted();
    var suggestedEmojisModeConfig = useSuggestedEmojisModeConfig();
    var getEmojiUrl = useGetEmojiUrlConfig();
    var suggested = (0, _react.useMemo)(function() {
        var _getSuggested;
        return (_getSuggested = getSuggested(suggestedEmojisModeConfig)) != null ? _getSuggested : [];
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        suggestedUpdated,
        suggestedEmojisModeConfig
    ]);
    var emojiStyle = useEmojiStyleConfig();
    if (!isMounted) return null;
    return (0, _react.createElement)(EmojiCategory, {
        categoryConfig: categoryConfig,
        hiddenOnSearch: true,
        hidden: suggested.length === 0
    }, suggested.map(function(suggestedItem) {
        var emoji = emojiByUnified(suggestedItem.original);
        if (!emoji) return null;
        return (0, _react.createElement)(ClickableEmoji, {
            showVariations: false,
            unified: suggestedItem.unified,
            emojiStyle: emojiStyle,
            emoji: emoji,
            key: suggestedItem.unified,
            getEmojiUrl: getEmojiUrl
        });
    }));
}
function EmojiList() {
    var categories = useCategoriesConfig();
    var renderdCategoriesCountRef = (0, _react.useRef)(0);
    return (0, _react.createElement)("ul", {
        className: (0, _flairup.cx)(styles$7.emojiList)
    }, categories.map(function(categoryConfig) {
        var category = categoryFromCategoryConfig(categoryConfig);
        if (category === Categories.SUGGESTED) return (0, _react.createElement)(Suggested, {
            key: category,
            categoryConfig: categoryConfig
        });
        return (0, _react.createElement)(RenderCategory, {
            key: category,
            category: category,
            categoryConfig: categoryConfig,
            renderdCategoriesCountRef: renderdCategoriesCountRef
        });
    }));
}
function RenderCategory(_ref) {
    var category = _ref.category, categoryConfig = _ref.categoryConfig, renderdCategoriesCountRef = _ref.renderdCategoriesCountRef;
    var isEmojiHidden = useIsEmojiHidden();
    var lazyLoadEmojis = useLazyLoadEmojisConfig();
    var emojiStyle = useEmojiStyleConfig();
    var isPastInitialLoad = useIsPastInitialLoad();
    var _useActiveSkinToneSta = useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0];
    var isEmojiDisallowed = useIsEmojiDisallowed();
    var getEmojiUrl = useGetEmojiUrlConfig();
    var showVariations = !useSkinTonesDisabledConfig();
    // Small trick to defer the rendering of all emoji categories until the first category is visible
    // This way the user gets to actually see something and not wait for the whole picker to render.
    var emojisToPush = !isPastInitialLoad && renderdCategoriesCountRef.current > 0 ? [] : emojisByCategory(category);
    if (emojisToPush.length > 0) renderdCategoriesCountRef.current++;
    var hiddenCounter = 0;
    var emojis = emojisToPush.map(function(emoji) {
        var unified = emojiUnified(emoji, activeSkinTone);
        var _isEmojiHidden = isEmojiHidden(emoji), failedToLoad = _isEmojiHidden.failedToLoad, filteredOut = _isEmojiHidden.filteredOut, hidden = _isEmojiHidden.hidden;
        var isDisallowed = isEmojiDisallowed(emoji);
        if (hidden || isDisallowed) hiddenCounter++;
        if (isDisallowed) return null;
        return (0, _react.createElement)(ClickableEmoji, {
            showVariations: showVariations,
            key: unified,
            emoji: emoji,
            unified: unified,
            hidden: failedToLoad,
            hiddenOnSearch: filteredOut,
            emojiStyle: emojiStyle,
            lazyLoad: lazyLoadEmojis,
            getEmojiUrl: getEmojiUrl
        });
    });
    return (0, _react.createElement)(EmojiCategory, {
        categoryConfig: categoryConfig,
        // Indicates that there are no visible emojis
        // Hence, the category should be hidden
        hidden: hiddenCounter === emojis.length
    }, emojis);
}
var styles$7 = /*#__PURE__*/ stylesheet.create({
    emojiList: {
        ".": ClassNames.emojiList,
        listStyle: "none",
        margin: "0",
        padding: "0"
    }
});
function focusFirstVisibleEmoji(parent) {
    var emoji = firstVisibleEmoji(parent);
    focusElement(emoji);
    scrollEmojiAboveLabel(emoji);
}
function focusAndClickFirstVisibleEmoji(parent) {
    var firstEmoji = firstVisibleEmoji(parent);
    focusElement(firstEmoji);
    firstEmoji == null || firstEmoji.click();
}
function focusLastVisibleEmoji(parent) {
    focusElement(lastVisibleEmoji(parent));
}
function focusNextVisibleEmoji(element) {
    if (!element) return;
    var next = nextVisibleEmoji(element);
    if (!next) return focusFirstVisibleEmoji(nextCategory(element));
    focusElement(next);
    scrollEmojiAboveLabel(next);
}
function focusPrevVisibleEmoji(element) {
    if (!element) return;
    var prev = prevVisibleEmoji(element);
    if (!prev) return focusLastVisibleEmoji(prevCategory(element));
    focusElement(prev);
    scrollEmojiAboveLabel(prev);
}
function focusVisibleEmojiOneRowUp(element, exitUp) {
    if (!element) return;
    var prev = visibleEmojiOneRowUp(element);
    if (!prev) return exitUp();
    focusElement(prev);
    scrollEmojiAboveLabel(prev);
}
function focusVisibleEmojiOneRowDown(element) {
    if (!element) return;
    var next = visibleEmojiOneRowDown(element);
    return focusElement(next);
}
function visibleEmojiOneRowUp(element) {
    if (!element) return null;
    var categoryContent = closestCategoryContent(element);
    var category = closestCategory(categoryContent);
    var indexInRow = elementIndexInRow(categoryContent, element);
    var row = rowNumber(categoryContent, element);
    var countInRow = elementCountInRow(categoryContent, element);
    if (row === 0) {
        var prevVisibleCategory = prevCategory(category);
        if (!prevVisibleCategory) return null;
        return getElementInRow(allVisibleEmojis(prevVisibleCategory), -1, // last row
        countInRow, indexInRow);
    }
    return getElementInPrevRow(allVisibleEmojis(categoryContent), row, countInRow, indexInRow);
}
function visibleEmojiOneRowDown(element) {
    if (!element) return null;
    var categoryContent = closestCategoryContent(element);
    var category = closestCategory(categoryContent);
    var indexInRow = elementIndexInRow(categoryContent, element);
    var row = rowNumber(categoryContent, element);
    var countInRow = elementCountInRow(categoryContent, element);
    if (!hasNextRow(categoryContent, element)) {
        var nextVisibleCategory = nextCategory(category);
        if (!nextVisibleCategory) return null;
        return getElementInRow(allVisibleEmojis(nextVisibleCategory), 0, countInRow, indexInRow);
    }
    var itemInNextRow = getElementInNextRow(allVisibleEmojis(categoryContent), row, countInRow, indexInRow);
    return itemInNextRow;
}
var SVGTriangle = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI1MHB4IgoJIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDUwIDE1IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCAxNSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJMYXllcl8xIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMiI+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiNFOEU3RTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KCTxwYXRoIGZpbGw9IiMwMTAyMDIiIHN0cm9rZT0iIzE1MTYxNyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMjYuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KPC9nPgo8L3N2Zz4=";
var Direction;
(function(Direction) {
    Direction[Direction["Up"] = 0] = "Up";
    Direction[Direction["Down"] = 1] = "Down";
})(Direction || (Direction = {}));
// eslint-disable-next-line complexity
function EmojiVariationPicker() {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    var VariationPickerRef = useVariationPickerRef();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), emoji = _useEmojiVariationPic[0];
    var emojiStyle = useEmojiStyleConfig();
    var _useVariationPickerTo = useVariationPickerTop(VariationPickerRef), getTop = _useVariationPickerTo.getTop, getMenuDirection = _useVariationPickerTo.getMenuDirection;
    var setAnchoredEmojiRef = useSetAnchoredEmojiRef();
    var getPointerStyle = usePointerStyle(VariationPickerRef);
    var getEmojiUrl = useGetEmojiUrlConfig();
    var button = buttonFromTarget(AnchoredEmojiRef.current);
    var visible = Boolean(emoji && button && emojiHasVariations(emoji) && button.classList.contains(ClassNames.emojiHasVariations));
    (0, _react.useEffect)(function() {
        if (!visible) return;
        focusFirstVisibleEmoji(VariationPickerRef.current);
    }, [
        VariationPickerRef,
        visible,
        AnchoredEmojiRef
    ]);
    var top, pointerStyle;
    if (!visible && AnchoredEmojiRef.current) setAnchoredEmojiRef(null);
    else {
        top = getTop();
        pointerStyle = getPointerStyle();
    }
    return (0, _react.createElement)("div", {
        ref: VariationPickerRef,
        className: (0, _flairup.cx)(styles$8.variationPicker, getMenuDirection() === Direction.Down && styles$8.pointingUp, visible && styles$8.visible),
        style: {
            top: top
        }
    }, visible && emoji ? [
        emojiUnified(emoji)
    ].concat(emojiVariations(emoji)).slice(0, 6).map(function(unified) {
        return (0, _react.createElement)(ClickableEmoji, {
            key: unified,
            emoji: emoji,
            unified: unified,
            emojiStyle: emojiStyle,
            showVariations: false,
            getEmojiUrl: getEmojiUrl
        });
    }) : null, (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$8.pointer),
        style: pointerStyle
    }));
}
function usePointerStyle(VariationPickerRef) {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    return function getPointerStyle() {
        var style = {};
        if (!VariationPickerRef.current) return style;
        if (AnchoredEmojiRef.current) {
            var button = buttonFromTarget(AnchoredEmojiRef.current);
            var offsetLeft = emojiTruOffsetLeft(button);
            if (!button) return style;
            // half of the button
            style.left = offsetLeft + (button == null ? void 0 : button.clientWidth) / 2;
        }
        return style;
    };
}
function useVariationPickerTop(VariationPickerRef) {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    var BodyRef = useBodyRef();
    var direction = Direction.Up;
    return {
        getMenuDirection: getMenuDirection,
        getTop: getTop
    };
    function getMenuDirection() {
        return direction;
    }
    function getTop() {
        direction = Direction.Up;
        var emojiOffsetTop = 0;
        if (!VariationPickerRef.current) return 0;
        var height = elementHeight(VariationPickerRef.current);
        if (AnchoredEmojiRef.current) {
            var _bodyRef$scrollTop;
            var bodyRef = BodyRef.current;
            var button = buttonFromTarget(AnchoredEmojiRef.current);
            var buttonHeight = elementHeight(button);
            emojiOffsetTop = emojiTrueOffsetTop(button);
            var scrollTop = (_bodyRef$scrollTop = bodyRef == null ? void 0 : bodyRef.scrollTop) != null ? _bodyRef$scrollTop : 0;
            if (scrollTop > emojiOffsetTop - height) {
                direction = Direction.Down;
                emojiOffsetTop += buttonHeight + height;
            }
        }
        return emojiOffsetTop - height;
    }
}
var styles$8 = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    variationPicker: {
        ".": ClassNames.variationPicker,
        position: "absolute",
        right: "15px",
        left: "15px",
        padding: "5px",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
        borderRadius: "3px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        opacity: "0",
        visibility: "hidden",
        pointerEvents: "none",
        top: "-100%",
        border: "1px solid var(--epr-picker-border-color)",
        height: "var(--epr-emoji-variation-picker-height)",
        zIndex: "var(--epr-skin-variation-picker-z-index)",
        background: "var(--epr-emoji-variation-picker-bg-color)",
        transform: "scale(0.9)",
        transition: "transform 0.1s ease-out, opacity 0.2s ease-out"
    },
    visible: {
        opacity: "1",
        visibility: "visible",
        pointerEvents: "all",
        transform: "scale(1)"
    },
    pointingUp: {
        ".": "pointing-up",
        transformOrigin: "center 0%",
        transform: "scale(0.9)"
    },
    ".pointing-up": {
        pointer: {
            top: "0",
            transform: "rotate(180deg) translateY(100%) translateX(18px)"
        }
    },
    pointer: {
        ".": "epr-emoji-pointer",
        content: "",
        position: "absolute",
        width: "25px",
        height: "15px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0 0",
        backgroundSize: "50px 15px",
        top: "100%",
        transform: "translateX(-18px)",
        backgroundImage: "url(" + SVGTriangle + ")"
    }
}, /*#__PURE__*/ darkMode("pointer", {
    backgroundPosition: "-25px 0"
})));
function Body() {
    var BodyRef = useBodyRef();
    useOnScroll(BodyRef);
    useMouseDownHandlers(BodyRef, MOUSE_EVENT_SOURCE.PICKER);
    useOnMouseMove();
    return (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$9.body, commonInteractionStyles.hiddenOnReactions),
        ref: BodyRef
    }, (0, _react.createElement)(EmojiVariationPicker, null), (0, _react.createElement)(EmojiList, null));
}
var styles$9 = /*#__PURE__*/ stylesheet.create({
    body: {
        ".": ClassNames.scrollBody,
        flex: "1",
        overflowY: "scroll",
        overflowX: "hidden",
        position: "relative"
    }
});
function useEmojiPreviewEvents(allow, setPreviewEmoji) {
    var BodyRef = useBodyRef();
    var isMouseDisallowed = useIsMouseDisallowed();
    var allowMouseMove = useAllowMouseMove();
    (0, _react.useEffect)(function() {
        if (!allow) return;
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener("keydown", onEscape, {
            passive: true
        });
        bodyRef == null || bodyRef.addEventListener("mouseover", onMouseOver, true);
        bodyRef == null || bodyRef.addEventListener("focus", onEnter, true);
        bodyRef == null || bodyRef.addEventListener("mouseout", onLeave, {
            passive: true
        });
        bodyRef == null || bodyRef.addEventListener("blur", onLeave, true);
        function onEnter(e) {
            var button = buttonFromTarget(e.target);
            if (!button) return onLeave();
            var unified = unifiedFromEmojiElement(button);
            var originalUnified = originalUnifiedFromEmojiElement(button);
            if (!unified || !originalUnified) return onLeave();
            setPreviewEmoji({
                unified: unified,
                originalUnified: originalUnified
            });
        }
        function onLeave(e) {
            if (e) {
                var relatedTarget = e.relatedTarget;
                if (!buttonFromTarget(relatedTarget)) return setPreviewEmoji(null);
            }
            setPreviewEmoji(null);
        }
        function onEscape(e) {
            if (e.key === "Escape") setPreviewEmoji(null);
        }
        function onMouseOver(e) {
            if (isMouseDisallowed()) return;
            var button = buttonFromTarget(e.target);
            if (button) focusElement(button);
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener("mouseover", onMouseOver);
            bodyRef == null || bodyRef.removeEventListener("mouseout", onLeave);
            bodyRef == null || bodyRef.removeEventListener("focus", onEnter, true);
            bodyRef == null || bodyRef.removeEventListener("blur", onLeave, true);
            bodyRef == null || bodyRef.removeEventListener("keydown", onEscape);
        };
    }, [
        BodyRef,
        allow,
        setPreviewEmoji,
        isMouseDisallowed,
        allowMouseMove
    ]);
}
function useIsSkinToneInSearch() {
    var skinTonePickerLocationConfig = useSkinTonePickerLocationConfig();
    return skinTonePickerLocationConfig === SkinTonePickerLocation.SEARCH;
}
function useIsSkinToneInPreview() {
    var skinTonePickerLocationConfig = useSkinTonePickerLocationConfig();
    return skinTonePickerLocationConfig === SkinTonePickerLocation.PREVIEW;
}
var _stylesheet$create;
var FlexDirection;
(function(FlexDirection) {
    FlexDirection["ROW"] = "FlexRow";
    FlexDirection["COLUMN"] = "FlexColumn";
})(FlexDirection || (FlexDirection = {}));
function Flex(_ref) {
    var children = _ref.children, className = _ref.className, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? FlexDirection.ROW : _ref$direction;
    return (0, _react.createElement)("div", {
        style: _extends({}, style),
        className: (0, _flairup.cx)(styles$a.flex, className, styles$a[direction])
    }, children);
}
var styles$a = /*#__PURE__*/ stylesheet.create((_stylesheet$create = {
    flex: {
        display: "flex"
    }
}, _stylesheet$create[FlexDirection.ROW] = {
    flexDirection: "row"
}, _stylesheet$create[FlexDirection.COLUMN] = {
    flexDirection: "column"
}, _stylesheet$create));
function Space(_ref) {
    var className = _ref.className, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    return (0, _react.createElement)("div", {
        style: _extends({
            flex: 1
        }, style),
        className: (0, _flairup.cx)(className)
    });
}
function Absolute(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style;
    return (0, _react.createElement)("div", {
        style: _extends({}, style, {
            position: "absolute"
        }),
        className: className
    }, children);
}
function Relative(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style;
    return (0, _react.createElement)("div", {
        style: _extends({}, style, {
            position: "relative"
        }),
        className: className
    }, children);
}
// eslint-disable-next-line complexity
function BtnSkinToneVariation(_ref) {
    var isOpen = _ref.isOpen, onClick = _ref.onClick, isActive = _ref.isActive, skinToneVariation = _ref.skinToneVariation, style = _ref.style;
    return (0, _react.createElement)(Button, {
        style: style,
        onClick: onClick,
        className: (0, _flairup.cx)("epr-tone-" + skinToneVariation, styles$b.tone, !isOpen && styles$b.closedTone, isActive && styles$b.active),
        tabIndex: isOpen ? 0 : -1,
        "aria-pressed": isActive,
        "aria-label": "Skin tone " + skinTonesNamed[skinToneVariation]
    });
}
var styles$b = /*#__PURE__*/ stylesheet.create({
    closedTone: {
        opacity: "0",
        zIndex: "0"
    },
    active: {
        ".": "epr-active",
        zIndex: "1",
        opacity: "1"
    },
    tone: {
        ".": "epr-tone",
        ":hover": {
            boxShadow: "0 0 0 3px var(--epr-active-skin-hover-color)"
        },
        ":focus": {
            boxShadow: "0 0 0 3px var(--epr-focus-bg-color)"
        },
        // @ts-ignore
        "&.epr-tone-neutral": {
            backgroundColor: "#ffd225"
        },
        "&.epr-tone-1f3fb": {
            backgroundColor: "#ffdfbd"
        },
        "&.epr-tone-1f3fc": {
            backgroundColor: "#e9c197"
        },
        "&.epr-tone-1f3fd": {
            backgroundColor: "#c88e62"
        },
        "&.epr-tone-1f3fe": {
            backgroundColor: "#a86637"
        },
        "&.epr-tone-1f3ff": {
            backgroundColor: "#60463a"
        }
    }
});
/* eslint-disable complexity */ var ITEM_SIZE = 28;
function SkinTonePickerMenu() {
    return (0, _react.createElement)(Relative, {
        style: {
            height: ITEM_SIZE
        }
    }, (0, _react.createElement)(Absolute, {
        style: {
            bottom: 0,
            right: 0
        }
    }, (0, _react.createElement)(SkinTonePicker, {
        direction: SkinTonePickerDirection.VERTICAL
    })));
}
function SkinTonePicker(_ref) {
    var _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? SkinTonePickerDirection.HORIZONTAL : _ref$direction;
    var SkinTonePickerRef = useSkinTonePickerRef();
    var isDisabled = useSkinTonesDisabledConfig();
    var _useSkinToneFanOpenSt = useSkinToneFanOpenState(), isOpen = _useSkinToneFanOpenSt[0], setIsOpen = _useSkinToneFanOpenSt[1];
    var _useActiveSkinToneSta = useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0], setActiveSkinTone = _useActiveSkinToneSta[1];
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var focusSearchInput = useFocusSearchInput();
    if (isDisabled) return null;
    var fullWidth = ITEM_SIZE * skinToneVariations.length + "px";
    var expandedSize = isOpen ? fullWidth : ITEM_SIZE + "px";
    var vertical = direction === SkinTonePickerDirection.VERTICAL;
    return (0, _react.createElement)(Relative, {
        className: (0, _flairup.cx)(styles$c.skinTones, vertical && styles$c.vertical, isOpen && styles$c.open, vertical && isOpen && styles$c.verticalShadow),
        style: vertical ? {
            flexBasis: expandedSize,
            height: expandedSize
        } : {
            flexBasis: expandedSize
        }
    }, (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$c.select),
        ref: SkinTonePickerRef
    }, skinToneVariations.map(function(skinToneVariation, i) {
        var active = skinToneVariation === activeSkinTone;
        return (0, _react.createElement)(BtnSkinToneVariation, {
            key: skinToneVariation,
            skinToneVariation: skinToneVariation,
            isOpen: isOpen,
            style: {
                transform: (0, _flairup.cx)(vertical ? "translateY(-" + i * (isOpen ? ITEM_SIZE : 0) + "px)" : "translateX(-" + i * (isOpen ? ITEM_SIZE : 0) + "px)", isOpen && active && "scale(1.3)")
            },
            isActive: active,
            onClick: function onClick() {
                if (isOpen) {
                    setActiveSkinTone(skinToneVariation);
                    focusSearchInput();
                } else setIsOpen(true);
                closeAllOpenToggles();
            }
        });
    })));
}
var SkinTonePickerDirection;
(function(SkinTonePickerDirection) {
    SkinTonePickerDirection["VERTICAL"] = "epr-vertical";
    SkinTonePickerDirection["HORIZONTAL"] = "epr-horizontal";
})(SkinTonePickerDirection || (SkinTonePickerDirection = {}));
var styles$c = /*#__PURE__*/ stylesheet.create({
    skinTones: {
        ".": "epr-skin-tones",
        "--": {
            "--epr-skin-tone-size": "15px"
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        transition: "all 0.3s ease-in-out",
        padding: "10px 0"
    },
    vertical: {
        padding: "9px",
        alignItems: "flex-end",
        flexDirection: "column",
        borderRadius: "6px",
        border: "1px solid var(--epr-bg-color)"
    },
    verticalShadow: {
        boxShadow: "0px 0 7px var(--epr-picker-border-color)"
    },
    open: {
        // @ts-ignore
        backdropFilter: "blur(5px)",
        background: "var(--epr-skin-tone-picker-menu-color)",
        // @ts-ignore
        ".epr-active:after": {
            content: "",
            position: "absolute",
            top: "-2px",
            left: "-2px",
            right: "-2px",
            bottom: "-2px",
            borderRadius: "5px",
            border: "1px solid var(--epr-active-skin-tone-indicator-border-color)"
        }
    },
    select: {
        ".": "epr-skin-tone-select",
        position: "relative",
        width: "var(--epr-skin-tone-size)",
        height: "var(--epr-skin-tone-size)",
        // @ts-ignore
        "> button": {
            width: "var(--epr-skin-tone-size)",
            display: "block",
            cursor: "pointer",
            borderRadius: "4px",
            height: "var(--epr-skin-tone-size)",
            position: "absolute",
            right: "0",
            transition: "transform 0.3s ease-in-out, opacity 0.35s ease-in-out",
            zIndex: "0",
            boxShadow: "0 0 0 0px var(--epr-active-skin-hover-color)"
        }
    }
});
function Preview() {
    var previewConfig = usePreviewConfig();
    var isSkinToneInPreview = useIsSkinToneInPreview();
    if (!previewConfig.showPreview) return null;
    return (0, _react.createElement)(Flex, {
        className: (0, _flairup.cx)(styles$d.preview, commonInteractionStyles.hiddenOnReactions)
    }, (0, _react.createElement)(PreviewBody, null), (0, _react.createElement)(Space, null), isSkinToneInPreview ? (0, _react.createElement)(SkinTonePickerMenu, null) : null);
}
function PreviewBody() {
    var _previewEmoji$unified;
    var previewConfig = usePreviewConfig();
    var _useState = (0, _react.useState)(null), previewEmoji = _useState[0], setPreviewEmoji = _useState[1];
    var emojiStyle = useEmojiStyleConfig();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), variationPickerEmoji = _useEmojiVariationPic[0];
    var getEmojiUrl = useGetEmojiUrlConfig();
    useEmojiPreviewEvents(previewConfig.showPreview, setPreviewEmoji);
    var emoji = emojiByUnified((_previewEmoji$unified = previewEmoji == null ? void 0 : previewEmoji.unified) != null ? _previewEmoji$unified : previewEmoji == null ? void 0 : previewEmoji.originalUnified);
    var show = emoji != null && previewEmoji != null;
    return (0, _react.createElement)(PreviewContent, null);
    function PreviewContent() {
        var defaultEmoji = variationPickerEmoji != null ? variationPickerEmoji : emojiByUnified(previewConfig.defaultEmoji);
        if (!defaultEmoji) return null;
        var defaultText = variationPickerEmoji ? emojiName(variationPickerEmoji) : previewConfig.defaultCaption;
        return (0, _react.createElement)((0, _react.Fragment), null, (0, _react.createElement)("div", null, show ? (0, _react.createElement)(ViewOnlyEmoji, {
            unified: previewEmoji == null ? void 0 : previewEmoji.unified,
            emoji: emoji,
            emojiStyle: emojiStyle,
            size: 45,
            getEmojiUrl: getEmojiUrl,
            className: (0, _flairup.cx)(styles$d.emoji)
        }) : defaultEmoji ? (0, _react.createElement)(ViewOnlyEmoji, {
            unified: emojiUnified(defaultEmoji),
            emoji: defaultEmoji,
            emojiStyle: emojiStyle,
            size: 45,
            getEmojiUrl: getEmojiUrl,
            className: (0, _flairup.cx)(styles$d.emoji)
        }) : null), (0, _react.createElement)("div", {
            className: (0, _flairup.cx)(styles$d.label)
        }, show ? emojiName(emoji) : defaultText));
    }
}
var styles$d = /*#__PURE__*/ stylesheet.create({
    preview: {
        alignItems: "center",
        borderTop: "1px solid var(--epr-preview-border-color)",
        height: "var(--epr-preview-height)",
        padding: "0 var(--epr-horizontal-padding)",
        position: "relative",
        zIndex: "var(--epr-preview-z-index)"
    },
    label: {
        color: "var(--epr-preview-text-color)",
        fontSize: "var(--epr-preview-text-size)",
        padding: "var(--epr-preview-text-padding)",
        textTransform: "capitalize"
    },
    emoji: {
        padding: "0"
    }
});
function categoryNameFromDom($category) {
    var _$category$getAttribu;
    return (_$category$getAttribu = $category == null ? void 0 : $category.getAttribute("data-name")) != null ? _$category$getAttribu : null;
}
function useActiveCategoryScrollDetection(setActiveCategory) {
    var BodyRef = useBodyRef();
    (0, _react.useEffect)(function() {
        var visibleCategories = new Map();
        var bodyRef = BodyRef.current;
        var observer = new IntersectionObserver(function(entries) {
            if (!bodyRef) return;
            for(var _iterator = _createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;){
                var entry = _step.value;
                var _id = categoryNameFromDom(entry.target);
                visibleCategories.set(_id, entry.intersectionRatio);
            }
            var ratios = Array.from(visibleCategories);
            var lastCategory = ratios[ratios.length - 1];
            if (lastCategory[1] == 1) return setActiveCategory(lastCategory[0]);
            for(var _i = 0, _ratios = ratios; _i < _ratios.length; _i++){
                var _ratios$_i = _ratios[_i], id = _ratios$_i[0], ratio = _ratios$_i[1];
                if (ratio) {
                    setActiveCategory(id);
                    break;
                }
            }
        }, {
            threshold: [
                0,
                1
            ]
        });
        bodyRef == null || bodyRef.querySelectorAll(asSelectors(ClassNames.category)).forEach(function(el) {
            observer.observe(el);
        });
    }, [
        BodyRef,
        setActiveCategory
    ]);
}
function useIsSearchMode() {
    var _useSearchTermState = useSearchTermState(), searchTerm = _useSearchTermState[0];
    return !!searchTerm;
}
function useScrollCategoryIntoView() {
    var BodyRef = useBodyRef();
    var PickerMainRef = usePickerMainRef();
    return function scrollCategoryIntoView(category) {
        var _BodyRef$current;
        if (!BodyRef.current) return;
        var $category = (_BodyRef$current = BodyRef.current) == null ? void 0 : _BodyRef$current.querySelector('[data-name="' + category + '"]');
        if (!$category) return;
        var offsetTop = $category.offsetTop || 0;
        scrollTo(PickerMainRef.current, offsetTop);
    };
}
function useShouldHideCustomEmojis() {
    var customCategoryConfig = useCustomEmojisConfig();
    if (!customCategoryConfig) return false;
    return customCategoryConfig.length === 0;
}
var SVGNavigation = "data:image/svg+xml;base64,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";
function CategoryButton(_ref) {
    var _cx;
    var isActiveCategory = _ref.isActiveCategory, category = _ref.category, allowNavigation = _ref.allowNavigation, categoryConfig = _ref.categoryConfig, onClick = _ref.onClick;
    return (0, _react.createElement)(Button, {
        tabIndex: allowNavigation ? 0 : -1,
        className: (0, _flairup.cx)(styles$e.catBtn, commonInteractionStyles.categoryBtn, "epr-icn-" + category, (_cx = {}, _cx[ClassNames.active] = isActiveCategory, _cx)),
        onClick: onClick,
        "aria-label": categoryNameFromCategoryConfig(categoryConfig),
        "aria-selected": isActiveCategory,
        role: "tab",
        "aria-controls": "epr-category-nav-id"
    });
}
var DarkActivePositionY = {
    backgroundPositionY: "calc(var(--epr-category-navigation-button-size) * 3)"
};
var DarkPositionY = {
    backgroundPositionY: "calc(var(--epr-category-navigation-button-size) * 2)"
};
var DarkInactivePosition = {
    ":not(.epr-search-active)": {
        catBtn: {
            ":hover": DarkActivePositionY,
            "&.epr-active": DarkActivePositionY
        }
    }
};
var styles$e = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    catBtn: {
        ".": "epr-cat-btn",
        display: "inline-block",
        transition: "opacity 0.2s ease-in-out",
        position: "relative",
        height: "var(--epr-category-navigation-button-size)",
        width: "var(--epr-category-navigation-button-size)",
        backgroundSize: "calc(var(--epr-category-navigation-button-size) * 10)",
        outline: "none",
        backgroundPosition: "0 0",
        backgroundImage: "url(" + SVGNavigation + ")",
        ":focus:before": {
            content: "",
            position: "absolute",
            top: "-2px",
            left: "-2px",
            right: "-2px",
            bottom: "-2px",
            border: "2px solid var(--epr-category-icon-active-color)",
            borderRadius: "50%"
        },
        // @ts-ignore
        "&.epr-icn-suggested": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -8)"
        },
        "&.epr-icn-custom": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -9)"
        },
        "&.epr-icn-activities": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -4)"
        },
        "&.epr-icn-animals_nature": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -1)"
        },
        "&.epr-icn-flags": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -7)"
        },
        "&.epr-icn-food_drink": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -2)"
        },
        "&.epr-icn-objects": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -5)"
        },
        "&.epr-icn-smileys_people": {
            backgroundPositionX: "0px"
        },
        "&.epr-icn-symbols": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -6)"
        },
        "&.epr-icn-travel_places": {
            backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -3)"
        }
    }
}, /*#__PURE__*/ darkMode("catBtn", DarkPositionY), {
    ".epr-dark-theme": /*#__PURE__*/ _extends({}, DarkInactivePosition),
    ".epr-auto-theme": /*#__PURE__*/ _extends({}, DarkInactivePosition)
}));
function CategoryNavigation() {
    var _useState = (0, _react.useState)(null), activeCategory = _useState[0], setActiveCategory = _useState[1];
    var scrollCategoryIntoView = useScrollCategoryIntoView();
    useActiveCategoryScrollDetection(setActiveCategory);
    var isSearchMode = useIsSearchMode();
    var categoriesConfig = useCategoriesConfig();
    var CategoryNavigationRef = useCategoryNavigationRef();
    var hideCustomCategory = useShouldHideCustomEmojis();
    return (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$f.nav),
        role: "tablist",
        "aria-label": "Category navigation",
        id: "epr-category-nav-id",
        ref: CategoryNavigationRef
    }, categoriesConfig.map(function(categoryConfig) {
        var category = categoryFromCategoryConfig(categoryConfig);
        var isActiveCategory = category === activeCategory;
        if (isCustomCategory(categoryConfig) && hideCustomCategory) return null;
        var allowNavigation = !isSearchMode && !isActiveCategory;
        return (0, _react.createElement)(CategoryButton, {
            key: category,
            category: category,
            isActiveCategory: isActiveCategory,
            allowNavigation: allowNavigation,
            categoryConfig: categoryConfig,
            onClick: function onClick() {
                setActiveCategory(category);
                scrollCategoryIntoView(category);
            }
        });
    }));
}
var styles$f = /*#__PURE__*/ stylesheet.create({
    nav: {
        ".": "epr-category-nav",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        padding: "var(--epr-header-padding)"
    },
    ".epr-search-active": {
        nav: {
            opacity: "0.3",
            cursor: "default",
            pointerEvents: "none"
        }
    },
    ".epr-main:has(input:not(:placeholder-shown))": {
        nav: {
            opacity: "0.3",
            cursor: "default",
            pointerEvents: "none"
        }
    }
});
var SVGTimes = "data:image/svg+xml;base64,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";
function BtnClearSearch() {
    var clearSearch = useClearSearch();
    return (0, _react.createElement)(Button, {
        className: (0, _flairup.cx)(styles$g.btnClearSearch, commonInteractionStyles.visibleOnSearchOnly),
        onClick: clearSearch,
        "aria-label": "Clear",
        title: "Clear"
    }, (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$g.icnClearnSearch)
    }));
}
var HoverDark = {
    ":hover": {
        "> .epr-icn-clear-search": {
            backgroundPositionY: "-60px"
        }
    }
};
var styles$g = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    btnClearSearch: {
        ".": "epr-btn-clear-search",
        position: "absolute",
        right: "var(--epr-search-bar-inner-padding)",
        height: "30px",
        width: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        top: "50%",
        transform: "translateY(-50%)",
        padding: "0",
        borderRadius: "50%",
        ":hover": {
            background: "var(--epr-hover-bg-color)"
        },
        ":focus": {
            background: "var(--epr-hover-bg-color)"
        }
    },
    icnClearnSearch: {
        ".": "epr-icn-clear-search",
        backgroundColor: "transparent",
        backgroundRepeat: "no-repeat",
        backgroundSize: "20px",
        height: "20px",
        width: "20px",
        backgroundImage: "url(" + SVGTimes + ")",
        ":hover": {
            backgroundPositionY: "-20px"
        },
        ":focus": {
            backgroundPositionY: "-20px"
        }
    }
}, /*#__PURE__*/ darkMode("icnClearnSearch", {
    backgroundPositionY: "-40px"
}), /*#__PURE__*/ darkMode("btnClearSearch", HoverDark)));
var SCOPE = /*#__PURE__*/ asSelectors(ClassNames.emojiPicker) + " " + /*#__PURE__*/ asSelectors(ClassNames.emojiList);
var EMOJI_BUTTON = /*#__PURE__*/ [
    "button",
    asSelectors(ClassNames.emoji)
].join("");
var CATEGORY = /*#__PURE__*/ asSelectors(ClassNames.category);
function CssSearch(_ref) {
    var value = _ref.value;
    if (!value) return null;
    var q = genQuery(value);
    return (0, _react.createElement)("style", null, "\n    " + SCOPE + " " + EMOJI_BUTTON + " {\n      display: none;\n    }\n\n\n    " + SCOPE + " " + q + " {\n      display: flex;\n    }\n\n    " + SCOPE + " " + CATEGORY + ":not(:has(" + q + ")) {\n      display: none;\n    }\n  ");
}
function genQuery(value) {
    return [
        EMOJI_BUTTON,
        '[data-full-name*="',
        getNormalizedSearchTerm(value),
        '"]'
    ].join("");
}
var SVGMagnifier = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyMHB4IiBoZWlnaHQ9IjQwcHgiIHZpZXdCb3g9IjAgMCAyMCA0MCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzg2ODY4NiIgZD0iTTEyLDguODFjMCwyLjA4LTEuNjgsMy43Ni0zLjc2LDMuNzZjLTIuMDgsMC0zLjc2LTEuNjgtMy43Ni0zLjc2CgljMC0yLjA4LDEuNjgtMy43NiwzLjc2LTMuNzZDMTAuMzIsNS4wNSwxMiw2LjczLDEyLDguODF6IE0xMS4yMywxMi43MmMtMC44MywwLjY0LTEuODcsMS4wMS0yLjk5LDEuMDFjLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTIKCWMwLTIuNzIsMi4yLTQuOTIsNC45Mi00LjkyYzIuNzIsMCw0LjkyLDIuMiw0LjkyLDQuOTJjMCwxLjEzLTAuMzgsMi4xNi0xLjAxLDIuOTlsMy45NCwzLjkzYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyCgljLTAuMjUsMC4yNS0wLjY2LDAuMjUtMC45MiwwTDExLjIzLDEyLjcyeiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0MwQzBCRiIgZD0iTTEyLDI4LjgxYzAsMi4wOC0xLjY4LDMuNzYtMy43NiwzLjc2Yy0yLjA4LDAtMy43Ni0xLjY4LTMuNzYtMy43NgoJYzAtMi4wOCwxLjY4LTMuNzYsMy43Ni0zLjc2QzEwLjMyLDI1LjA1LDEyLDI2LjczLDEyLDI4LjgxeiBNMTEuMjMsMzIuNzJjLTAuODMsMC42NC0xLjg3LDEuMDEtMi45OSwxLjAxCgljLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTJjMC0yLjcyLDIuMi00LjkyLDQuOTItNC45MmMyLjcyLDAsNC45MiwyLjIsNC45Miw0LjkyYzAsMS4xMy0wLjM4LDIuMTYtMS4wMSwyLjk5bDMuOTQsMy45MwoJYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyYy0wLjI1LDAuMjUtMC42NiwwLjI1LTAuOTIsMEwxMS4yMywzMi43MnoiLz4KPC9zdmc+";
function IcnSearch() {
    return (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$h.icnSearch)
    });
}
var styles$h = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    icnSearch: {
        ".": "epr-icn-search",
        content: "",
        position: "absolute",
        top: "50%",
        left: "var(--epr-search-bar-inner-padding)",
        transform: "translateY(-50%)",
        width: "20px",
        height: "20px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0 0",
        backgroundSize: "20px",
        backgroundImage: "url(" + SVGMagnifier + ")"
    }
}, /*#__PURE__*/ darkMode("icnSearch", {
    backgroundPositionY: "-20px"
})));
function SearchContainer() {
    var searchDisabled = useSearchDisabledConfig();
    var isSkinToneInSearch = useIsSkinToneInSearch();
    if (searchDisabled) return null;
    return (0, _react.createElement)(Flex, {
        className: (0, _flairup.cx)(styles$i.overlay)
    }, (0, _react.createElement)(Search, null), isSkinToneInSearch ? (0, _react.createElement)(SkinTonePicker, null) : null);
}
function Search() {
    var _useState = (0, _react.useState)(0), inc = _useState[0], setInc = _useState[1];
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var SearchInputRef = useSearchInputRef();
    var placeholder = useSearchPlaceHolderConfig();
    var autoFocus = useAutoFocusSearchConfig();
    var _useFilter = useFilter(), statusSearchResults = _useFilter.statusSearchResults, searchTerm = _useFilter.searchTerm, _onChange = _useFilter.onChange;
    var input = SearchInputRef == null ? void 0 : SearchInputRef.current;
    var value = input == null ? void 0 : input.value;
    return (0, _react.createElement)(Relative, {
        className: (0, _flairup.cx)(styles$i.searchContainer)
    }, (0, _react.createElement)(CssSearch, {
        value: value
    }), (0, _react.createElement)("input", {
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: autoFocus,
        "aria-label": "Type to search for an emoji",
        onFocus: closeAllOpenToggles,
        className: (0, _flairup.cx)(styles$i.search),
        type: "text",
        "aria-controls": "epr-search-id",
        placeholder: placeholder,
        onChange: function onChange(event) {
            setInc(inc + 1);
            setTimeout(function() {
                var _event$target$value, _event$target;
                _onChange((_event$target$value = event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value) != null ? _event$target$value : value);
            });
        },
        ref: SearchInputRef
    }), searchTerm ? (0, _react.createElement)("div", {
        role: "status",
        className: (0, _flairup.cx)("epr-status-search-results", styles$i.visuallyHidden),
        "aria-live": "polite",
        id: "epr-search-id",
        "aria-atomic": "true"
    }, statusSearchResults) : null, (0, _react.createElement)(IcnSearch, null), (0, _react.createElement)(BtnClearSearch, null));
}
var styles$i = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    overlay: {
        padding: "var(--epr-header-padding)",
        zIndex: "var(--epr-header-overlay-z-index)"
    },
    searchContainer: {
        ".": "epr-search-container",
        flex: "1",
        display: "block",
        minWidth: "0"
    },
    visuallyHidden: {
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: "1px",
        overflow: "hidden",
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px"
    },
    search: {
        outline: "none",
        transition: "all 0.2s ease-in-out",
        color: "var(--epr-search-input-text-color)",
        borderRadius: "var(--epr-search-input-border-radius)",
        padding: "var(--epr-search-input-padding)",
        height: "var(--epr-search-input-height)",
        backgroundColor: "var(--epr-search-input-bg-color)",
        border: "1px solid var(--epr-search-input-bg-color)",
        width: "100%",
        ":focus": {
            backgroundColor: "var(--epr-search-input-bg-color-active)",
            border: "1px solid var(--epr-search-border-color)"
        },
        "::placeholder": {
            color: "var(--epr-search-input-placeholder-color)"
        }
    },
    btnClearSearch: {
        ".": "epr-btn-clear-search",
        position: "absolute",
        right: "var(--epr-search-bar-inner-padding)",
        height: "30px",
        width: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        top: "50%",
        transform: "translateY(-50%)",
        padding: "0",
        borderRadius: "50%",
        ":hover": {
            background: "var(--epr-hover-bg-color)"
        },
        ":focus": {
            background: "var(--epr-hover-bg-color)"
        }
    },
    icnClearnSearch: {
        ".": "epr-icn-clear-search",
        backgroundColor: "transparent",
        backgroundRepeat: "no-repeat",
        backgroundSize: "20px",
        height: "20px",
        width: "20px",
        backgroundImage: "url(" + SVGTimes + ")",
        ":hover": {
            backgroundPositionY: "-20px"
        },
        ":focus": {
            backgroundPositionY: "-20px"
        }
    }
}, /*#__PURE__*/ darkMode("icnClearnSearch", {
    backgroundPositionY: "-40px"
}), /*#__PURE__*/ darkMode("btnClearSearch", {
    ":hover > .epr-icn-clear-search": {
        backgroundPositionY: "-60px"
    }
})));
function Header() {
    return (0, _react.createElement)(Relative, {
        className: (0, _flairup.cx)("epr-header", commonInteractionStyles.hiddenOnReactions)
    }, (0, _react.createElement)(SearchContainer, null), (0, _react.createElement)(CategoryNavigation, null));
}
function getActiveElement() {
    return document.activeElement;
}
var KeyboardEvents;
(function(KeyboardEvents) {
    KeyboardEvents["ArrowDown"] = "ArrowDown";
    KeyboardEvents["ArrowUp"] = "ArrowUp";
    KeyboardEvents["ArrowLeft"] = "ArrowLeft";
    KeyboardEvents["ArrowRight"] = "ArrowRight";
    KeyboardEvents["Escape"] = "Escape";
    KeyboardEvents["Enter"] = "Enter";
    KeyboardEvents["Space"] = " ";
})(KeyboardEvents || (KeyboardEvents = {}));
function useKeyboardNavigation() {
    usePickerMainKeyboardEvents();
    useSearchInputKeyboardEvents();
    useSkinTonePickerKeyboardEvents();
    useCategoryNavigationKeyboardEvents();
    useBodyKeyboardEvents();
}
function usePickerMainKeyboardEvents() {
    var PickerMainRef = usePickerMainRef();
    var clearSearch = useClearSearch();
    var scrollTo = useScrollTo();
    var SearchInputRef = useSearchInputRef();
    var focusSearchInput = useFocusSearchInput();
    var hasOpenToggles = useHasOpenToggles();
    var disallowMouseMove = useDisallowMouseMove();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var onKeyDown = (0, _react.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            disallowMouseMove();
            switch(key){
                // eslint-disable-next-line no-fallthrough
                case KeyboardEvents.Escape:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        return;
                    }
                    clearSearch();
                    scrollTo(0);
                    focusSearchInput();
                    break;
            }
        };
    }, [
        scrollTo,
        clearSearch,
        closeAllOpenToggles,
        focusSearchInput,
        hasOpenToggles,
        disallowMouseMove
    ]);
    (0, _react.useEffect)(function() {
        var current = PickerMainRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        PickerMainRef,
        SearchInputRef,
        scrollTo,
        onKeyDown
    ]);
}
function useSearchInputKeyboardEvents() {
    var focusSkinTonePicker = useFocusSkinTonePicker();
    var PickerMainRef = usePickerMainRef();
    var BodyRef = useBodyRef();
    var SearchInputRef = useSearchInputRef();
    var _useSkinToneFanOpenSt = useSkinToneFanOpenState(), setSkinToneFanOpenState = _useSkinToneFanOpenSt[1];
    var goDownFromSearchInput = useGoDownFromSearchInput();
    var isSkinToneInSearch = useIsSkinToneInSearch();
    var onKeyDown = (0, _react.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            switch(key){
                case KeyboardEvents.ArrowRight:
                    if (!isSkinToneInSearch) return;
                    event.preventDefault();
                    setSkinToneFanOpenState(true);
                    focusSkinTonePicker();
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    goDownFromSearchInput();
                    break;
                case KeyboardEvents.Enter:
                    event.preventDefault();
                    focusAndClickFirstVisibleEmoji(BodyRef.current);
                    break;
            }
        };
    }, [
        focusSkinTonePicker,
        goDownFromSearchInput,
        setSkinToneFanOpenState,
        BodyRef,
        isSkinToneInSearch
    ]);
    (0, _react.useEffect)(function() {
        var current = SearchInputRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        PickerMainRef,
        SearchInputRef,
        onKeyDown
    ]);
}
function useSkinTonePickerKeyboardEvents() {
    var SkinTonePickerRef = useSkinTonePickerRef();
    var focusSearchInput = useFocusSearchInput();
    var SearchInputRef = useSearchInputRef();
    var goDownFromSearchInput = useGoDownFromSearchInput();
    var _useSkinToneFanOpenSt2 = useSkinToneFanOpenState(), isOpen = _useSkinToneFanOpenSt2[0], setIsOpen = _useSkinToneFanOpenSt2[1];
    var isSkinToneInPreview = useIsSkinToneInPreview();
    var isSkinToneInSearch = useIsSkinToneInSearch();
    var onType = useOnType();
    var onKeyDown = (0, _react.useMemo)(function() {
        return(// eslint-disable-next-line complexity
        function onKeyDown(event) {
            var key = event.key;
            if (isSkinToneInSearch) switch(key){
                case KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusNextSkinTone(focusSearchInput);
                    break;
                case KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusPrevSkinTone();
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (isOpen) setIsOpen(false);
                    goDownFromSearchInput();
                    break;
                default:
                    onType(event);
                    break;
            }
            if (isSkinToneInPreview) switch(key){
                case KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusNextSkinTone(focusSearchInput);
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusPrevSkinTone();
                    break;
                default:
                    onType(event);
                    break;
            }
        });
    }, [
        isOpen,
        focusSearchInput,
        setIsOpen,
        goDownFromSearchInput,
        onType,
        isSkinToneInPreview,
        isSkinToneInSearch
    ]);
    (0, _react.useEffect)(function() {
        var current = SkinTonePickerRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        SkinTonePickerRef,
        SearchInputRef,
        isOpen,
        onKeyDown
    ]);
}
function useCategoryNavigationKeyboardEvents() {
    var focusSearchInput = useFocusSearchInput();
    var CategoryNavigationRef = useCategoryNavigationRef();
    var BodyRef = useBodyRef();
    var onType = useOnType();
    var onKeyDown = (0, _react.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            switch(key){
                case KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    focusSearchInput();
                    break;
                case KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    focusNextElementSibling(getActiveElement());
                    break;
                case KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    focusPrevElementSibling(getActiveElement());
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    focusFirstVisibleEmoji(BodyRef.current);
                    break;
                default:
                    onType(event);
                    break;
            }
        };
    }, [
        BodyRef,
        focusSearchInput,
        onType
    ]);
    (0, _react.useEffect)(function() {
        var current = CategoryNavigationRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        CategoryNavigationRef,
        BodyRef,
        onKeyDown
    ]);
}
function useBodyKeyboardEvents() {
    var BodyRef = useBodyRef();
    var goUpFromBody = useGoUpFromBody();
    var setVariationPicker = useSetVariationPicker();
    var hasOpenToggles = useHasOpenToggles();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var onType = useOnType();
    var onKeyDown = (0, _react.useMemo)(function() {
        return(// eslint-disable-next-line complexity
        function onKeyDown(event) {
            var key = event.key;
            var activeElement = buttonFromTarget(getActiveElement());
            switch(key){
                case KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    focusNextVisibleEmoji(activeElement);
                    break;
                case KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    focusPrevVisibleEmoji(activeElement);
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        break;
                    }
                    focusVisibleEmojiOneRowDown(activeElement);
                    break;
                case KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        break;
                    }
                    focusVisibleEmojiOneRowUp(activeElement, goUpFromBody);
                    break;
                case KeyboardEvents.Space:
                    event.preventDefault();
                    setVariationPicker(event.target);
                    break;
                default:
                    onType(event);
                    break;
            }
        });
    }, [
        goUpFromBody,
        onType,
        setVariationPicker,
        hasOpenToggles,
        closeAllOpenToggles
    ]);
    (0, _react.useEffect)(function() {
        var current = BodyRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        BodyRef,
        onKeyDown
    ]);
}
function useGoDownFromSearchInput() {
    var focusCategoryNavigation = useFocusCategoryNavigation();
    var isSearchMode = useIsSearchMode();
    var BodyRef = useBodyRef();
    return (0, _react.useCallback)(function goDownFromSearchInput() {
        if (isSearchMode) return focusFirstVisibleEmoji(BodyRef.current);
        return focusCategoryNavigation();
    }, [
        BodyRef,
        focusCategoryNavigation,
        isSearchMode
    ]);
}
function useGoUpFromBody() {
    var focusSearchInput = useFocusSearchInput();
    var focusCategoryNavigation = useFocusCategoryNavigation();
    var isSearchMode = useIsSearchMode();
    return (0, _react.useCallback)(function goUpFromEmoji() {
        if (isSearchMode) return focusSearchInput();
        return focusCategoryNavigation();
    }, [
        focusSearchInput,
        isSearchMode,
        focusCategoryNavigation
    ]);
}
function focusNextSkinTone(exitLeft) {
    var currentSkinTone = getActiveElement();
    if (!currentSkinTone) return;
    if (!hasNextElementSibling(currentSkinTone)) exitLeft();
    focusNextElementSibling(currentSkinTone);
}
function focusPrevSkinTone() {
    var currentSkinTone = getActiveElement();
    if (!currentSkinTone) return;
    focusPrevElementSibling(currentSkinTone);
}
function useOnType() {
    var appendSearch = useAppendSearch();
    var focusSearchInput = useFocusSearchInput();
    var searchDisabled = useSearchDisabledConfig();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    return function onType(event) {
        var key = event.key;
        if (hasModifier(event) || searchDisabled) return;
        if (key.match(/(^[a-zA-Z0-9]$){1}/)) {
            event.preventDefault();
            closeAllOpenToggles();
            focusSearchInput();
            appendSearch(key);
        }
    };
}
function hasModifier(event) {
    var metaKey = event.metaKey, ctrlKey = event.ctrlKey, altKey = event.altKey;
    return metaKey || ctrlKey || altKey;
}
function preloadEmoji(getEmojiUrl, emoji, emojiStyle) {
    if (!emoji) return;
    if (emojiStyle === EmojiStyle.NATIVE) return;
    var unified = emojiUnified(emoji);
    if (preloadedEmojs.has(unified)) return;
    emojiVariations(emoji).forEach(function(variation) {
        var emojiUrl = getEmojiUrl(variation, emojiStyle);
        preloadImage(emojiUrl);
    });
    preloadedEmojs.add(unified);
}
var preloadedEmojs = /*#__PURE__*/ new Set();
function preloadImage(url) {
    var image = new Image();
    image.src = url;
}
function useOnFocus() {
    var BodyRef = useBodyRef();
    var emojiStyle = useEmojiStyleConfig();
    var getEmojiUrl = useGetEmojiUrlConfig();
    (0, _react.useEffect)(function() {
        if (emojiStyle === EmojiStyle.NATIVE) return;
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener("focusin", onFocus);
        return function() {
            bodyRef == null || bodyRef.removeEventListener("focusin", onFocus);
        };
        function onFocus(event) {
            var button = buttonFromTarget(event.target);
            if (!button) return;
            var _emojiFromElement = emojiFromElement(button), emoji = _emojiFromElement[0];
            if (!emoji) return;
            if (emojiHasVariations(emoji)) preloadEmoji(getEmojiUrl, emoji, emojiStyle);
        }
    }, [
        BodyRef,
        emojiStyle,
        getEmojiUrl
    ]);
}
var _excluded$1 = [
    "width",
    "height"
];
function PickerMain(_ref) {
    var children = _ref.children;
    return (0, _react.createElement)(PickerContextProvider, null, (0, _react.createElement)(PickerRootElement, null, children));
}
function PickerRootElement(_ref2) {
    var _cx;
    var children = _ref2.children;
    var _useReactionsModeStat = useReactionsModeState(), reactionsMode = _useReactionsModeStat[0];
    var theme = useThemeConfig();
    var searchModeActive = useIsSearchMode();
    var PickerMainRef = usePickerMainRef();
    var className = useClassNameConfig();
    var style = useStyleConfig();
    useKeyboardNavigation();
    useOnFocus();
    var _ref3 = style || {}, width = _ref3.width, height = _ref3.height, styleProps = _objectWithoutPropertiesLoose(_ref3, _excluded$1);
    return (0, _react.createElement)("aside", {
        className: (0, _flairup.cx)(styles$j.main, styles$j.baseVariables, theme === Theme.DARK && styles$j.darkTheme, theme === Theme.AUTO && styles$j.autoThemeDark, (_cx = {}, _cx[ClassNames.searchActive] = searchModeActive, _cx), reactionsMode && styles$j.reactionsMenu, className),
        ref: PickerMainRef,
        style: _extends({}, styleProps, !reactionsMode && {
            height: height,
            width: width
        })
    }, children);
}
var DarkTheme = {
    "--epr-emoji-variation-picker-bg-color": "var(--epr-dark-emoji-variation-picker-bg-color)",
    "--epr-hover-bg-color-reduced-opacity": "var(--epr-dark-hover-bg-color-reduced-opacity)",
    "--epr-highlight-color": "var(--epr-dark-highlight-color)",
    "--epr-text-color": "var(--epr-dark-text-color)",
    "--epr-hover-bg-color": "var(--epr-dark-hover-bg-color)",
    "--epr-focus-bg-color": "var(--epr-dark-focus-bg-color)",
    "--epr-search-input-bg-color": "var(--epr-dark-search-input-bg-color)",
    "--epr-category-label-bg-color": "var(--epr-dark-category-label-bg-color)",
    "--epr-picker-border-color": "var(--epr-dark-picker-border-color)",
    "--epr-bg-color": "var(--epr-dark-bg-color)",
    "--epr-reactions-bg-color": "var(--epr-dark-reactions-bg-color)",
    "--epr-search-input-bg-color-active": "var(--epr-dark-search-input-bg-color-active)",
    "--epr-emoji-variation-indicator-color": "var(--epr-dark-emoji-variation-indicator-color)",
    "--epr-category-icon-active-color": "var(--epr-dark-category-icon-active-color)",
    "--epr-skin-tone-picker-menu-color": "var(--epr-dark-skin-tone-picker-menu-color)"
};
var styles$j = /*#__PURE__*/ stylesheet.create({
    main: {
        ".": [
            "epr-main",
            ClassNames.emojiPicker
        ],
        position: "relative",
        display: "flex",
        flexDirection: "column",
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "var(--epr-picker-border-radius)",
        borderColor: "var(--epr-picker-border-color)",
        backgroundColor: "var(--epr-bg-color)",
        overflow: "hidden",
        transition: "all 0.3s ease-in-out, background-color 0.1s ease-in-out",
        // @ts-expect-error - need to work on this
        "*": {
            boxSizing: "border-box",
            fontFamily: "sans-serif"
        }
    },
    baseVariables: {
        "--": {
            "--epr-highlight-color": "#007aeb",
            "--epr-hover-bg-color": "#f1f8ff",
            "--epr-hover-bg-color-reduced-opacity": "#f1f8ff80",
            "--epr-focus-bg-color": "#e0f0ff",
            "--epr-text-color": "#858585",
            "--epr-search-input-bg-color": "#f6f6f6",
            "--epr-picker-border-color": "#e7e7e7",
            "--epr-bg-color": "#fff",
            "--epr-reactions-bg-color": "#ffffff90",
            "--epr-category-icon-active-color": "#6aa8de",
            "--epr-skin-tone-picker-menu-color": "#ffffff95",
            "--epr-horizontal-padding": "10px",
            "--epr-picker-border-radius": "8px",
            /* Header */ "--epr-search-border-color": "var(--epr-highlight-color)",
            "--epr-header-padding": "15px var(--epr-horizontal-padding)",
            /* Skin Tone Picker */ "--epr-active-skin-tone-indicator-border-color": "var(--epr-highlight-color)",
            "--epr-active-skin-hover-color": "var(--epr-hover-bg-color)",
            /* Search */ "--epr-search-input-bg-color-active": "var(--epr-search-input-bg-color)",
            "--epr-search-input-padding": "0 30px",
            "--epr-search-input-border-radius": "8px",
            "--epr-search-input-height": "40px",
            "--epr-search-input-text-color": "var(--epr-text-color)",
            "--epr-search-input-placeholder-color": "var(--epr-text-color)",
            "--epr-search-bar-inner-padding": "var(--epr-horizontal-padding)",
            /*  Category Navigation */ "--epr-category-navigation-button-size": "30px",
            /* Variation Picker */ "--epr-emoji-variation-picker-height": "45px",
            "--epr-emoji-variation-picker-bg-color": "var(--epr-bg-color)",
            /*  Preview */ "--epr-preview-height": "70px",
            "--epr-preview-text-size": "14px",
            "--epr-preview-text-padding": "0 var(--epr-horizontal-padding)",
            "--epr-preview-border-color": "var(--epr-picker-border-color)",
            "--epr-preview-text-color": "var(--epr-text-color)",
            /* Category */ "--epr-category-padding": "0 var(--epr-horizontal-padding)",
            /*  Category Label */ "--epr-category-label-bg-color": "#ffffffe6",
            "--epr-category-label-text-color": "var(--epr-text-color)",
            "--epr-category-label-padding": "0 var(--epr-horizontal-padding)",
            "--epr-category-label-height": "40px",
            /*  Emoji */ "--epr-emoji-size": "30px",
            "--epr-emoji-padding": "5px",
            "--epr-emoji-fullsize": "calc(var(--epr-emoji-size) + var(--epr-emoji-padding) * 2)",
            "--epr-emoji-hover-color": "var(--epr-hover-bg-color)",
            "--epr-emoji-variation-indicator-color": "var(--epr-picker-border-color)",
            "--epr-emoji-variation-indicator-color-hover": "var(--epr-text-color)",
            /* Z-Index */ "--epr-header-overlay-z-index": "3",
            "--epr-emoji-variations-indictator-z-index": "1",
            "--epr-category-label-z-index": "2",
            "--epr-skin-variation-picker-z-index": "5",
            "--epr-preview-z-index": "6",
            /* Dark Theme Variables */ "--epr-dark": "#000",
            "--epr-dark-emoji-variation-picker-bg-color": "var(--epr-dark)",
            "--epr-dark-highlight-color": "#c0c0c0",
            "--epr-dark-text-color": "var(--epr-highlight-color)",
            "--epr-dark-hover-bg-color": "#363636f6",
            "--epr-dark-hover-bg-color-reduced-opacity": "#36363680",
            "--epr-dark-focus-bg-color": "#474747",
            "--epr-dark-search-input-bg-color": "#333333",
            "--epr-dark-category-label-bg-color": "#222222e6",
            "--epr-dark-picker-border-color": "#151617",
            "--epr-dark-bg-color": "#222222",
            "--epr-dark-reactions-bg-color": "#22222290",
            "--epr-dark-search-input-bg-color-active": "var(--epr-dark)",
            "--epr-dark-emoji-variation-indicator-color": "#444",
            "--epr-dark-category-icon-active-color": "#3271b7",
            "--epr-dark-skin-tone-picker-menu-color": "#22222295"
        }
    },
    autoThemeDark: {
        ".": ClassNames.autoTheme,
        "@media (prefers-color-scheme: dark)": {
            "--": DarkTheme
        }
    },
    darkTheme: {
        ".": ClassNames.darkTheme,
        "--": DarkTheme
    },
    reactionsMenu: {
        ".": "epr-reactions",
        height: "50px",
        display: "inline-flex",
        backgroundColor: "var(--epr-reactions-bg-color)",
        // @ts-expect-error - need to work on this
        backdropFilter: "blur(8px)",
        "--": {
            "--epr-picker-border-radius": "50px"
        }
    }
});
function EmojiPicker(props) {
    return (0, _react.createElement)(ElementRefContextProvider, null, (0, _react.createElement)(PickerStyleTag, null), (0, _react.createElement)(PickerConfigProvider, Object.assign({}, props), (0, _react.createElement)(ContentControl, null)));
}
function ContentControl() {
    var _useReactionsModeStat = useReactionsModeState(), reactionsDefaultOpen = _useReactionsModeStat[0];
    var _React$useState = (0, _react.useState)(!reactionsDefaultOpen), renderAll = _React$useState[0], setRenderAll = _React$useState[1];
    var isOpen = useOpenConfig();
    (0, _react.useEffect)(function() {
        if (!renderAll) setRenderAll(true);
    }, [
        renderAll
    ]);
    if (!isOpen) return null;
    return (0, _react.createElement)(PickerMain, null, (0, _react.createElement)(Reactions, null), renderAll ? (0, _react.createElement)((0, _react.Fragment), null, (0, _react.createElement)(Header, null), (0, _react.createElement)(Body, null), (0, _react.createElement)(Preview, null)) : null);
}
// eslint-disable-next-line complexity
var EmojiPickerReact = /*#__PURE__*/ (0, _react.memo)(EmojiPicker, function(prev, next) {
    var _prev$customEmojis, _next$customEmojis;
    var prevCustomEmojis = (_prev$customEmojis = prev.customEmojis) != null ? _prev$customEmojis : [];
    var nextCustomEmojis = (_next$customEmojis = next.customEmojis) != null ? _next$customEmojis : [];
    return prev.open === next.open && prev.emojiVersion === next.emojiVersion && prev.reactionsDefaultOpen === next.reactionsDefaultOpen && prev.searchPlaceHolder === next.searchPlaceHolder && prev.searchPlaceholder === next.searchPlaceholder && prev.defaultSkinTone === next.defaultSkinTone && prev.skinTonesDisabled === next.skinTonesDisabled && prev.autoFocusSearch === next.autoFocusSearch && prev.emojiStyle === next.emojiStyle && prev.theme === next.theme && prev.suggestedEmojisMode === next.suggestedEmojisMode && prev.lazyLoadEmojis === next.lazyLoadEmojis && prev.className === next.className && prev.height === next.height && prev.width === next.width && prev.style === next.style && prev.searchDisabled === next.searchDisabled && prev.skinTonePickerLocation === next.skinTonePickerLocation && prevCustomEmojis.length === nextCustomEmojis.length;
});
var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);
    function ErrorBoundary(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            hasError: false
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error("Emoji Picker React failed to render:", error, errorInfo);
    };
    _proto.render = function render() {
        if (this.state.hasError) return null;
        return this.props.children;
    };
    return ErrorBoundary;
}((0, _react.Component));
function ExportedEmoji(_ref) {
    var unified = _ref.unified, _ref$size = _ref.size, size = _ref$size === void 0 ? 32 : _ref$size, _ref$emojiStyle = _ref.emojiStyle, emojiStyle = _ref$emojiStyle === void 0 ? EmojiStyle.APPLE : _ref$emojiStyle, _ref$lazyLoad = _ref.lazyLoad, lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad, getEmojiUrl = _ref.getEmojiUrl, emojiUrl = _ref.emojiUrl;
    if (!unified && !emojiUrl && !getEmojiUrl) return null;
    return (0, _react.createElement)(ViewOnlyEmoji, {
        unified: unified,
        size: size,
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        getEmojiUrl: emojiUrl ? function() {
            return emojiUrl;
        } : getEmojiUrl
    });
}
function EmojiPicker$1(props) {
    var MutableConfigRef = useDefineMutableConfig({
        onEmojiClick: props.onEmojiClick,
        onReactionClick: props.onReactionClick
    });
    return (0, _react.createElement)(ErrorBoundary, null, (0, _react.createElement)(MutableConfigContext.Provider, {
        value: MutableConfigRef
    }, (0, _react.createElement)(EmojiPickerReact, Object.assign({}, props))));
}
exports.default = EmojiPicker$1;

},{"react":"6uln9","flairup":"gxuBZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gxuBZ":[function(require,module,exports) {
"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
    else return left instanceof right;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    createSheet: function() {
        return createSheet;
    },
    cx: function() {
        return cx;
    }
});
module.exports = __toCommonJS(src_exports);
// src/utils/asArray.ts
function asArray(v) {
    return [].concat(v);
}
// src/utils/is.ts
function isPsuedoSelector(selector) {
    return selector.startsWith(":");
}
function isStyleCondition(selector) {
    return isString(selector) && (selector === "*" || selector.length > 1 && ":>~.+*".includes(selector.slice(0, 1)) || isImmediatePostcondition(selector));
}
function isValidProperty(property, value) {
    return (isString(value) || typeof value === "number") && !isCssVariables(property) && !isPsuedoSelector(property) && !isMediaQuery(property);
}
function isMediaQuery(selector) {
    return selector.startsWith("@media");
}
function isDirectClass(selector) {
    return selector === ".";
}
function isCssVariables(selector) {
    return selector === "--";
}
function isString(value) {
    return value + "" === value;
}
function isImmediatePostcondition(value) {
    return isString(value) && (value.startsWith("&") || isPsuedoSelector(value));
}
// src/utils/joinTruthy.ts
function joinTruthy(arr) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return arr.filter(Boolean).join(delimiter);
}
// src/utils/stableHash.ts
function stableHash(prefix, seed) {
    var hash = 0;
    if (seed.length === 0) return hash.toString();
    for(var i = 0; i < seed.length; i++){
        var char = seed.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    return "".concat(prefix !== null && prefix !== void 0 ? prefix : "cl", "_").concat(hash.toString(36));
}
// src/utils/stringManipulators.ts
function handlePropertyValue(property, value) {
    if (property === "content") return '"'.concat(value, '"');
    return value;
}
function camelCaseToDash(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function joinedProperty(property, value) {
    return "".concat(property, ":").concat(value);
}
function toClass(str) {
    return str ? ".".concat(str) : "";
}
function appendString(base, line) {
    return base ? "".concat(base, "\n").concat(line) : line;
}
// src/Rule.ts
var Rule = /*#__PURE__*/ function() {
    function _Rule(sheet, property, value, selector) {
        _class_call_check(this, _Rule);
        this.sheet = sheet;
        this.property = property;
        this.value = value;
        this.selector = selector;
        this.property = property;
        this.value = value;
        this.joined = joinedProperty(property, value);
        var joinedConditions = this.selector.preconditions.concat(this.selector.postconditions);
        this.hash = this.selector.hasConditions ? this.selector.scopeClassName : stableHash(this.sheet.name, this.joined);
        this.key = joinTruthy([
            this.joined,
            joinedConditions,
            this.hash
        ]);
    }
    _create_class(_Rule, [
        {
            key: "toString",
            value: function toString() {
                var selectors = mergeSelectors(this.selector.preconditions, {
                    right: this.hash
                });
                selectors = mergeSelectors(this.selector.postconditions, {
                    left: selectors
                });
                return "".concat(selectors, " {").concat(_Rule.genRule(this.property, this.value), "}");
            }
        }
    ], [
        {
            key: "genRule",
            value: function genRule(property, value) {
                var transformedProperty = camelCaseToDash(property);
                return joinedProperty(transformedProperty, handlePropertyValue(property, value)) + ";";
            }
        }
    ]);
    return _Rule;
}();
function mergeSelectors(selectors) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_left = _ref.left, left = _ref_left === void 0 ? "" : _ref_left, _ref_right = _ref.right, right = _ref_right === void 0 ? "" : _ref_right;
    var output = selectors.reduce(function(selectors2, current) {
        if (isPsuedoSelector(current)) return selectors2 + current;
        if (isImmediatePostcondition(current)) return selectors2 + current.slice(1);
        return joinTruthy([
            selectors2,
            current
        ], " ");
    }, left);
    return joinTruthy([
        output,
        toClass(right)
    ], " ");
}
var Selector = /*#__PURE__*/ function() {
    function _Selector(sheet) {
        var scopeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, preconditions = _ref.preconditions, postconditions = _ref.postconditions;
        _class_call_check(this, _Selector);
        this.sheet = sheet;
        this.preconditions = [];
        this.scopeClassName = null;
        this.scopeName = null;
        this.postconditions = [];
        this.preconditions = preconditions ? asArray(preconditions) : [];
        this.postconditions = postconditions ? asArray(postconditions) : [];
        this.setScope(scopeName);
    }
    _create_class(_Selector, [
        {
            key: "setScope",
            value: function setScope(scopeName) {
                if (!scopeName) return this;
                if (!this.scopeClassName) {
                    this.scopeName = scopeName;
                    this.scopeClassName = stableHash(this.sheet.name, scopeName + this.sheet.count);
                }
                return this;
            }
        },
        {
            key: "hasConditions",
            get: function get() {
                return this.preconditions.length > 0 || this.postconditions.length > 0;
            }
        },
        {
            key: "addScope",
            value: function addScope(scopeName) {
                return new _Selector(this.sheet, scopeName, {
                    preconditions: this.preconditions,
                    postconditions: this.postconditions
                });
            }
        },
        {
            key: "addPrecondition",
            value: function addPrecondition(precondition) {
                return new _Selector(this.sheet, this.scopeClassName, {
                    postconditions: this.postconditions,
                    preconditions: this.preconditions.concat(precondition)
                });
            }
        },
        {
            key: "addPostcondition",
            value: function addPostcondition(postcondition) {
                return new _Selector(this.sheet, this.scopeClassName, {
                    preconditions: this.preconditions,
                    postconditions: this.postconditions.concat(postcondition)
                });
            }
        },
        {
            key: "createRule",
            value: function createRule(property, value) {
                return new Rule(this.sheet, property, value, this);
            }
        }
    ]);
    return _Selector;
}();
// src/Sheet.ts
var Sheet = /*#__PURE__*/ function() {
    function Sheet(name, rootNode) {
        _class_call_check(this, Sheet);
        this.name = name;
        this.rootNode = rootNode;
        // Hash->css
        this.storedStyles = {};
        // styles->hash
        this.storedClasses = {};
        this.style = "";
        this.count = 0;
        this.id = "flairup-".concat(name);
        this.styleTag = this.createStyleTag();
    }
    _create_class(Sheet, [
        {
            key: "getStyle",
            value: function getStyle() {
                return this.style;
            }
        },
        {
            key: "append",
            value: function append(css) {
                this.style = appendString(this.style, css);
            }
        },
        {
            key: "apply",
            value: function apply() {
                this.count++;
                if (!this.styleTag) return;
                this.styleTag.innerHTML = this.style;
            }
        },
        {
            key: "isApplied",
            value: function isApplied() {
                return !!this.styleTag;
            }
        },
        {
            key: "createStyleTag",
            value: function createStyleTag() {
                if (typeof document === "undefined" || this.isApplied() || // Explicitly disallow mounting to the DOM
                this.rootNode === null) return this.styleTag;
                var styleTag = document.createElement("style");
                styleTag.type = "text/css";
                styleTag.id = this.id;
                var _this_rootNode;
                ((_this_rootNode = this.rootNode) !== null && _this_rootNode !== void 0 ? _this_rootNode : document.head).appendChild(styleTag);
                return styleTag;
            }
        },
        {
            key: "addRule",
            value: function addRule(rule) {
                var storedClass = this.storedClasses[rule.key];
                if (isString(storedClass)) return storedClass;
                this.storedClasses[rule.key] = rule.hash;
                this.storedStyles[rule.hash] = [
                    rule.property,
                    rule.value
                ];
                this.append(rule.toString());
                return rule.hash;
            }
        }
    ]);
    return Sheet;
}();
// src/utils/forIn.ts
function forIn(obj, fn) {
    for(var key in obj)fn(key.trim(), obj[key]);
}
// src/cx.ts
function cx() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var classes = args.reduce(function(classes2, arg) {
        if (_instanceof(arg, Set)) {
            var _classes2;
            (_classes2 = classes2).push.apply(_classes2, _to_consumable_array(arg));
        } else if (typeof arg === "string") classes2.push(arg);
        else if (Array.isArray(arg)) classes2.push(cx.apply(void 0, _to_consumable_array(arg)));
        else if (typeof arg === "object") Object.entries(arg).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            if (value) classes2.push(key);
        });
        return classes2;
    }, []);
    return joinTruthy(classes, " ").trim();
}
// src/index.ts
function createSheet(name, rootNode) {
    var sheet = new Sheet(name, rootNode);
    return {
        create: create,
        getStyle: sheet.getStyle.bind(sheet),
        isApplied: sheet.isApplied.bind(sheet)
    };
    function create(styles) {
        var scopedStyles = {};
        iteratePreconditions(sheet, styles, new Selector(sheet)).forEach(function(param) {
            var _param = _sliced_to_array(param, 3), scopeName = _param[0], styles2 = _param[1], selector = _param[2];
            iterateStyles(sheet, styles2, selector).forEach(function(className) {
                addScopedStyle(scopeName, className);
            });
        });
        sheet.apply();
        return scopedStyles;
        function addScopedStyle(name2, className) {
            var _scopedStyles_name2;
            scopedStyles[name2] = (_scopedStyles_name2 = scopedStyles[name2]) !== null && _scopedStyles_name2 !== void 0 ? _scopedStyles_name2 : /* @__PURE__ */ new Set();
            scopedStyles[name2].add(className);
        }
    }
}
function iteratePreconditions(sheet, styles, selector) {
    var output = [];
    forIn(styles, function(key, value) {
        if (isStyleCondition(key)) return iteratePreconditions(sheet, value, selector.addPrecondition(key)).forEach(function(item) {
            return output.push(item);
        });
        output.push([
            key,
            styles[key],
            selector.addScope(key)
        ]);
    });
    return output;
}
function iterateStyles(sheet, styles, selector) {
    var output = /* @__PURE__ */ new Set();
    forIn(styles, function(property, value) {
        var res = [];
        if (isStyleCondition(property)) res = iterateStyles(sheet, value, selector.addPostcondition(property));
        else if (isDirectClass(property)) res = asArray(value);
        else if (isMediaQuery(property)) res = handleMediaQuery(sheet, value, property, selector);
        else if (isCssVariables(property)) res = cssVariablesBlock(sheet, value, selector);
        else if (isValidProperty(property, value)) {
            var rule = selector.createRule(property, value);
            sheet.addRule(rule);
            output.add(rule.hash);
        }
        return addEachClass(res, output);
    });
    return output;
}
function addEachClass(list, to) {
    list.forEach(function(className) {
        return to.add(className);
    });
    return to;
}
function cssVariablesBlock(sheet, styles, selector) {
    var classes = /* @__PURE__ */ new Set();
    var chunkRows = [];
    forIn(styles, function(property, value) {
        if (isValidProperty(property, value)) {
            chunkRows.push(Rule.genRule(property, value));
            return;
        }
        var res = iterateStyles(sheet, value !== null && value !== void 0 ? value : {}, selector);
        addEachClass(res, classes);
    });
    if (!selector.scopeClassName) return classes;
    if (chunkRows.length) {
        var output = chunkRows.join(" ");
        sheet.append("".concat(mergeSelectors(selector.preconditions, {
            right: selector.scopeClassName
        }), " {").concat(output, "}"));
    }
    classes.add(selector.scopeClassName);
    return classes;
}
function handleMediaQuery(sheet, styles, mediaQuery, selector) {
    sheet.append(mediaQuery + " {");
    var output = iterateStyles(sheet, styles, selector);
    sheet.append("}");
    return output;
}

},{}],"daBzQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReorderCollections);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _reactEasySort = require("react-easy-sort");
var _reactEasySortDefault = parcelHelpers.interopDefault(_reactEasySort);
var _arrayMove = require("array-move");
var _collections = require("../layout/Collections");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
const REORDER_COLLECTIONS = (0, _client.gql)`
	mutation ReorderCollections($positions:[ID]!) {
		reorderCollections(positions:$positions)
	}
`;
function ReorderCollections({}) {
    const { loading, error, data } = (0, _client.useQuery)((0, _collections.GET_COLLECTIONS));
    const [reorderCollections, { loading: loadingReorder, error: reorderError }] = (0, _client.useMutation)(REORDER_COLLECTIONS, {
        refetchQueries: [
            {
                query: (0, _collections.GET_COLLECTIONS)
            }
        ]
    });
    const collections = data?.collections ?? [];
    function handleSortEnd(oldIndex, newIndex) {
        const newOrder = (0, _arrayMove.arrayMoveImmutable)(collections, oldIndex, newIndex);
        const positions = newOrder.map(({ collectionId })=>collectionId);
        reorderCollections({
            variables: {
                positions
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Reorder collections"
            }),
            (!!error || !!reorderError) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error || reorderError
            }),
            Array.isArray(collections) && collections.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySortDefault.default), {
                className: "MultiFieldSortableList",
                draggedItemClassName: "dragged",
                onSortEnd: handleSortEnd,
                children: collections.map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySort.SortableItem), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "SortableItem",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySort.SortableKnob), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        "\u2195\uFE0F ",
                                        c.icon,
                                        " ",
                                        c.name
                                    ]
                                })
                            })
                        })
                    }, c.collectionId))
            }),
            loading || loadingReorder && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","react-easy-sort":"iVlh1","array-move":"iaig5","../layout/Collections":"fogPQ","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iVlh1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortableItem", ()=>SortableItem);
parcelHelpers.export(exports, "SortableKnob", ()=>SortableKnob);
var _tslib = require("tslib");
var _arrayMove = require("array-move");
var _arrayMoveDefault = parcelHelpers.interopDefault(_arrayMove);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/**
 * This function check if a given point is inside of the items rect.
 * If it's not inside any rect, it will return the index of the closest rect
 */ var findItemIndexAtPosition = function findItemIndexAtPosition(_a, itemsRect, _b) {
    var x = _a.x, y = _a.y;
    var _c = (_b === void 0 ? {} : _b).fallbackToClosest, fallbackToClosest = _c === void 0 ? false : _c;
    var smallestDistance = 10000;
    var smallestDistanceIndex = -1;
    for(var index = 0; index < itemsRect.length; index += 1){
        var rect = itemsRect[index]; // if it's inside the rect, we return the current index directly
        if (x >= rect.left && x < rect.right && y >= rect.top && y < rect.bottom) return index;
        if (fallbackToClosest) {
            // otherwise we compute the distance and update the smallest distance index if needed
            var itemCenterX = (rect.left + rect.right) / 2;
            var itemCenterY = (rect.top + rect.bottom) / 2;
            var distance = Math.sqrt(Math.pow(x - itemCenterX, 2) + Math.pow(y - itemCenterY, 2)); // ** 2 operator is not supported on IE11
            if (distance < smallestDistance) {
                smallestDistance = distance;
                smallestDistanceIndex = index;
            }
        }
    }
    return smallestDistanceIndex;
};
var getMousePoint = function getMousePoint(e) {
    return {
        x: Number(e.clientX),
        y: Number(e.clientY)
    };
};
var getTouchPoint = function getTouchPoint(touch) {
    return {
        x: Number(touch.clientX),
        y: Number(touch.clientY)
    };
};
var getPointInContainer = function getPointInContainer(point, containerTopLeft) {
    return {
        x: point.x - containerTopLeft.x,
        y: point.y - containerTopLeft.y
    };
};
var preventDefault = function preventDefault(event) {
    event.preventDefault();
};
var disableContextMenu = function disableContextMenu() {
    window.addEventListener("contextmenu", preventDefault, {
        capture: true,
        passive: false
    });
};
var enableContextMenu = function enableContextMenu() {
    window.removeEventListener("contextmenu", preventDefault);
};
var useDrag = function useDrag(_a) {
    var onStart = _a.onStart, onMove = _a.onMove, onEnd = _a.onEnd, _b = _a.allowDrag, allowDrag = _b === void 0 ? true : _b, containerRef = _a.containerRef, knobs = _a.knobs; // contains the top-left coordinates of the container in the window. Set on drag start and used in drag move
    var containerPositionRef = (0, _reactDefault.default).useRef({
        x: 0,
        y: 0
    }); // on touch devices, we only start the drag gesture after pressing the item 200ms.
    // this ref contains the timer id to be able to cancel it
    var handleTouchStartTimerRef = (0, _reactDefault.default).useRef(undefined); // on non-touch device, we don't call onStart on mouse down but on the first mouse move
    // we do this to let the user clicks on clickable element inside the container
    // this means that the drag gesture actually starts on the fist move
    var isFirstMoveRef = (0, _reactDefault.default).useRef(false); // see https://twitter.com/ValentinHervieu/status/1324407814970920968
    // we do this so that the parent doesn't have to use `useCallback()` for these callbacks
    var callbacksRef = (0, _reactDefault.default).useRef({
        onStart: onStart,
        onMove: onMove,
        onEnd: onEnd
    }); // instead of relying on hacks to know if the device is a touch device or not,
    // we track this using an onTouchStart listener on the document. (see https://codeburst.io/the-only-way-to-detect-touch-with-javascript-7791a3346685)
    var _c = (0, _reactDefault.default).useState(false), isTouchDevice = _c[0], setTouchDevice = _c[1];
    (0, _reactDefault.default).useEffect(function() {
        callbacksRef.current = {
            onStart: onStart,
            onMove: onMove,
            onEnd: onEnd
        };
    }, [
        onStart,
        onMove,
        onEnd
    ]);
    var cancelTouchStart = function cancelTouchStart() {
        if (handleTouchStartTimerRef.current) window.clearTimeout(handleTouchStartTimerRef.current);
    };
    var saveContainerPosition = (0, _reactDefault.default).useCallback(function() {
        if (containerRef.current) {
            var bounds = containerRef.current.getBoundingClientRect();
            containerPositionRef.current = {
                x: bounds.left,
                y: bounds.top
            };
        }
    }, [
        containerRef
    ]);
    var onDrag = (0, _reactDefault.default).useCallback(function(pointInWindow) {
        var point = getPointInContainer(pointInWindow, containerPositionRef.current);
        if (callbacksRef.current.onMove) callbacksRef.current.onMove({
            pointInWindow: pointInWindow,
            point: point
        });
    }, []);
    var onMouseMove = (0, _reactDefault.default).useCallback(function(e) {
        // if this is the first move, we trigger the onStart logic
        if (isFirstMoveRef.current) {
            isFirstMoveRef.current = false;
            var pointInWindow = getMousePoint(e);
            var point = getPointInContainer(pointInWindow, containerPositionRef.current);
            if (callbacksRef.current.onStart) callbacksRef.current.onStart({
                point: point,
                pointInWindow: pointInWindow
            });
        } else onDrag(getMousePoint(e));
    }, [
        onDrag
    ]);
    var onTouchMove = (0, _reactDefault.default).useCallback(function(e) {
        if (e.cancelable) {
            // Prevent the whole page from scrolling
            e.preventDefault();
            onDrag(getTouchPoint(e.touches[0]));
        } else {
            // if the event is not cancelable, it means the browser is currently scrolling
            // which cannot be interrupted. Thus we cancel the drag gesture.
            document.removeEventListener("touchmove", onTouchMove);
            if (callbacksRef.current.onEnd) callbacksRef.current.onEnd();
        }
    }, [
        onDrag
    ]);
    var onMouseUp = (0, _reactDefault.default).useCallback(function() {
        isFirstMoveRef.current = false;
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
        if (callbacksRef.current.onEnd) callbacksRef.current.onEnd();
    }, [
        onMouseMove
    ]);
    var onTouchEnd = (0, _reactDefault.default).useCallback(function() {
        document.removeEventListener("touchmove", onTouchMove);
        document.removeEventListener("touchend", onTouchEnd);
        enableContextMenu();
        if (callbacksRef.current.onEnd) callbacksRef.current.onEnd();
    }, [
        onTouchMove
    ]);
    var onMouseDown = (0, _reactDefault.default).useCallback(function(e) {
        if (e.button !== 0) // we don't want to handle clicks other than left ones
        return;
        if ((knobs === null || knobs === void 0 ? void 0 : knobs.length) && !knobs.find(function(knob) {
            return knob.contains(e.target);
        })) return;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        saveContainerPosition(); // mark the next move as being the first one
        isFirstMoveRef.current = true;
    }, [
        onMouseMove,
        onMouseUp,
        saveContainerPosition,
        knobs
    ]);
    var handleTouchStart = (0, _reactDefault.default).useCallback(function(point, pointInWindow) {
        document.addEventListener("touchmove", onTouchMove, {
            capture: false,
            passive: false
        });
        document.addEventListener("touchend", onTouchEnd);
        disableContextMenu();
        if (callbacksRef.current.onStart) callbacksRef.current.onStart({
            point: point,
            pointInWindow: pointInWindow
        });
    }, [
        onTouchEnd,
        onTouchMove
    ]);
    var onTouchStart = (0, _reactDefault.default).useCallback(function(e) {
        if ((knobs === null || knobs === void 0 ? void 0 : knobs.length) && !knobs.find(function(knob) {
            return knob.contains(e.target);
        })) return;
        saveContainerPosition();
        var pointInWindow = getTouchPoint(e.touches[0]);
        var point = getPointInContainer(pointInWindow, containerPositionRef.current); // we wait 120ms to start the gesture to be sure that the user
        // is not trying to scroll the page
        handleTouchStartTimerRef.current = window.setTimeout(function() {
            return handleTouchStart(point, pointInWindow);
        }, 120);
    }, [
        handleTouchStart,
        saveContainerPosition,
        knobs
    ]);
    var detectTouchDevice = (0, _reactDefault.default).useCallback(function() {
        setTouchDevice(true);
        document.removeEventListener("touchstart", detectTouchDevice);
    }, []); // if the user is scrolling on mobile, we cancel the drag gesture
    var touchScrollListener = (0, _reactDefault.default).useCallback(function() {
        cancelTouchStart();
    }, []);
    (0, _reactDefault.default).useLayoutEffect(function() {
        if (isTouchDevice) {
            var container_1 = containerRef.current;
            if (allowDrag) {
                container_1 === null || container_1 === void 0 || container_1.addEventListener("touchstart", onTouchStart, {
                    capture: true,
                    passive: false
                }); // we are adding this touchmove listener to cancel drag if user is scrolling
                // however, it's also important to have a touchmove listener always set
                // with non-capture and non-passive option to prevent an issue on Safari
                // with e.preventDefault (https://github.com/atlassian/react-beautiful-dnd/issues/1374)
                document.addEventListener("touchmove", touchScrollListener, {
                    capture: false,
                    passive: false
                });
                document.addEventListener("touchend", touchScrollListener, {
                    capture: false,
                    passive: false
                });
            }
            return function() {
                container_1 === null || container_1 === void 0 || container_1.removeEventListener("touchstart", onTouchStart, {
                    capture: true
                });
                document.removeEventListener("touchmove", touchScrollListener, {
                    capture: false
                });
                document.removeEventListener("touchend", touchScrollListener, {
                    capture: false
                });
                document.removeEventListener("touchmove", onTouchMove);
                document.removeEventListener("touchend", onTouchEnd);
                enableContextMenu();
                cancelTouchStart();
            };
        } // if non-touch device
        document.addEventListener("touchstart", detectTouchDevice);
        return function() {
            document.removeEventListener("touchstart", detectTouchDevice);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
        };
    }, [
        isTouchDevice,
        allowDrag,
        detectTouchDevice,
        onMouseMove,
        onTouchMove,
        touchScrollListener,
        onTouchEnd,
        onMouseUp,
        containerRef,
        onTouchStart
    ]); // on touch devices, we cannot attach the onTouchStart directly via React:
    // Touch handlers must be added with {passive: false} to be cancelable.
    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
    return isTouchDevice ? {} : {
        onMouseDown: onMouseDown
    };
};
var useDropTarget = function useDropTarget(content) {
    var dropTargetRef = (0, _reactDefault.default).useRef(null);
    if (!content) return {};
    var show = function show(sourceRect) {
        if (dropTargetRef.current) {
            dropTargetRef.current.style.width = sourceRect.width + "px";
            dropTargetRef.current.style.height = sourceRect.height + "px";
            dropTargetRef.current.style.opacity = "1";
            dropTargetRef.current.style.visibility = "visible";
        }
    };
    var hide = function hide() {
        if (dropTargetRef.current) {
            dropTargetRef.current.style.opacity = "0";
            dropTargetRef.current.style.visibility = "hidden";
        }
    };
    var setPosition = function setPosition(index, itemsRect, lockAxis) {
        if (dropTargetRef.current) {
            var sourceRect = itemsRect[index];
            var newX = lockAxis === "y" ? sourceRect.left : itemsRect[index].left;
            var newY = lockAxis === "x" ? sourceRect.top : itemsRect[index].top;
            dropTargetRef.current.style.transform = "translate3d(" + newX + "px, " + newY + "px, 0px)";
        }
    };
    var DropTargetWrapper = function DropTargetWrapper() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: dropTargetRef,
            "aria-hidden": true,
            style: {
                opacity: 0,
                visibility: "hidden",
                position: "fixed",
                top: 0,
                left: 0,
                pointerEvents: "none"
            }
        }, content);
    };
    return {
        show: show,
        hide: hide,
        setPosition: setPosition,
        render: DropTargetWrapper
    };
};
var DEFAULT_CONTAINER_TAG = "div";
var SortableListContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
var SortableList = function SortableList(_a) {
    var _b;
    var children = _a.children, _c = _a.allowDrag, allowDrag = _c === void 0 ? true : _c, onSortEnd = _a.onSortEnd, draggedItemClassName = _a.draggedItemClassName, as = _a.as, lockAxis = _a.lockAxis, customHolderRef = _a.customHolderRef, dropTarget = _a.dropTarget, rest = (0, _tslib.__rest)(_a, [
        "children",
        "allowDrag",
        "onSortEnd",
        "draggedItemClassName",
        "as",
        "lockAxis",
        "customHolderRef",
        "dropTarget"
    ]); // this array contains the elements than can be sorted (wrapped inside SortableItem)
    var itemsRef = (0, _reactDefault.default).useRef([]); // this array contains the coordinates of each sortable element (only computed on dragStart and used in dragMove for perf reason)
    var itemsRect = (0, _reactDefault.default).useRef([]); // Hold all registered knobs
    var knobs = (0, _reactDefault.default).useRef([]); // contains the container element
    var containerRef = (0, _reactDefault.default).useRef(null); // contains the target element (copy of the source element)
    var targetRef = (0, _reactDefault.default).useRef(null); // contains the index in the itemsRef array of the element being dragged
    var sourceIndexRef = (0, _reactDefault.default).useRef(undefined); // contains the index in the itemsRef of the element to be exchanged with the source item
    var lastTargetIndexRef = (0, _reactDefault.default).useRef(undefined); // contains the offset point where the initial drag occurred to be used when dragging the item
    var offsetPointRef = (0, _reactDefault.default).useRef({
        x: 0,
        y: 0
    }); // contains the dropTarget logic
    var dropTargetLogic = useDropTarget(dropTarget);
    (0, _reactDefault.default).useEffect(function() {
        var holder = (customHolderRef === null || customHolderRef === void 0 ? void 0 : customHolderRef.current) || document.body;
        return function() {
            // cleanup the target element from the DOM when SortableList in unmounted
            if (targetRef.current) holder.removeChild(targetRef.current);
        };
    }, [
        customHolderRef
    ]);
    var updateTargetPosition = function updateTargetPosition(position) {
        if (targetRef.current && sourceIndexRef.current !== undefined) {
            var offset = offsetPointRef.current;
            var sourceRect = itemsRect.current[sourceIndexRef.current];
            var newX = lockAxis === "y" ? sourceRect.left : position.x - offset.x;
            var newY = lockAxis === "x" ? sourceRect.top : position.y - offset.y; // we use `translate3d` to force using the GPU if available
            targetRef.current.style.transform = "translate3d(" + newX + "px, " + newY + "px, 0px)";
        }
    };
    var copyItem = (0, _reactDefault.default).useCallback(function(sourceIndex) {
        if (!containerRef.current) return;
        var source = itemsRef.current[sourceIndex];
        var sourceRect = itemsRect.current[sourceIndex];
        var copy = source.cloneNode(true); // added the "dragged" class name
        if (draggedItemClassName) draggedItemClassName.split(" ").forEach(function(c) {
            return copy.classList.add(c);
        });
         // we ensure the copy has the same size than the source element
        copy.style.width = sourceRect.width + "px";
        copy.style.height = sourceRect.height + "px"; // we place the target starting position to the top left of the window
        // it will then be moved relatively using `transform: translate3d()`
        copy.style.position = "fixed";
        copy.style.margin = "0";
        copy.style.top = "0";
        copy.style.left = "0";
        var sourceCanvases = source.querySelectorAll("canvas");
        copy.querySelectorAll("canvas").forEach(function(canvas, index) {
            var _a;
            (_a = canvas.getContext("2d")) === null || _a === void 0 || _a.drawImage(sourceCanvases[index], 0, 0);
        });
        var holder = (customHolderRef === null || customHolderRef === void 0 ? void 0 : customHolderRef.current) || document.body;
        holder.appendChild(copy);
        targetRef.current = copy;
    }, [
        customHolderRef,
        draggedItemClassName
    ]);
    var listeners = useDrag({
        allowDrag: allowDrag,
        containerRef: containerRef,
        knobs: knobs.current,
        onStart: function onStart(_a) {
            var _b;
            var pointInWindow = _a.pointInWindow;
            if (!containerRef.current) return;
            itemsRect.current = itemsRef.current.map(function(item) {
                return item.getBoundingClientRect();
            });
            var sourceIndex = findItemIndexAtPosition(pointInWindow, itemsRect.current); // if we are not starting the drag gesture on a SortableItem, we exit early
            if (sourceIndex === -1) return;
             // saving the index of the item being dragged
            sourceIndexRef.current = sourceIndex; // the item being dragged is copied to the document body and will be used as the target
            copyItem(sourceIndex); // hide source during the drag gesture
            var source = itemsRef.current[sourceIndex];
            source.style.opacity = "0";
            source.style.visibility = "hidden"; // get the offset between the source item's window position relative to the point in window
            var sourceRect = source.getBoundingClientRect();
            offsetPointRef.current = {
                x: pointInWindow.x - sourceRect.left,
                y: pointInWindow.y - sourceRect.top
            };
            updateTargetPosition(pointInWindow);
            (_b = dropTargetLogic.show) === null || _b === void 0 || _b.call(dropTargetLogic, sourceRect); // Adds a nice little physical feedback
            if (window.navigator.vibrate) window.navigator.vibrate(100);
        },
        onMove: function onMove(_a) {
            var _b;
            var pointInWindow = _a.pointInWindow;
            updateTargetPosition(pointInWindow);
            var sourceIndex = sourceIndexRef.current; // if there is no source, we exit early (happened when drag gesture was started outside a SortableItem)
            if (sourceIndex === undefined || sourceIndexRef.current === undefined) return;
            var sourceRect = itemsRect.current[sourceIndexRef.current];
            var targetPoint = {
                x: lockAxis === "y" ? sourceRect.left : pointInWindow.x,
                y: lockAxis === "x" ? sourceRect.top : pointInWindow.y
            };
            var targetIndex = findItemIndexAtPosition(targetPoint, itemsRect.current, {
                fallbackToClosest: true
            }); // if not target detected, we don't need to update other items' position
            if (targetIndex === -1) return;
             // we keep track of the last target index (to be passed to the onSortEnd callback)
            lastTargetIndexRef.current = targetIndex;
            var isMovingRight = sourceIndex < targetIndex; // in this loop, we go over each sortable item and see if we need to update their position
            for(var index = 0; index < itemsRef.current.length; index += 1){
                var currentItem = itemsRef.current[index];
                var currentItemRect = itemsRect.current[index]; // if current index is between sourceIndex and targetIndex, we need to translate them
                if (isMovingRight && index >= sourceIndex && index <= targetIndex || !isMovingRight && index >= targetIndex && index <= sourceIndex) {
                    // we need to move the item to the previous or next item position
                    var nextItemRects = itemsRect.current[isMovingRight ? index - 1 : index + 1];
                    if (nextItemRects) {
                        var translateX = nextItemRects.left - currentItemRect.left;
                        var translateY = nextItemRects.top - currentItemRect.top; // we use `translate3d` to force using the GPU if available
                        currentItem.style.transform = "translate3d(" + translateX + "px, " + translateY + "px, 0px)";
                    }
                } else currentItem.style.transform = "translate3d(0,0,0)";
                 // we want the translation to be animated
                currentItem.style.transitionDuration = "300ms";
            }
            (_b = dropTargetLogic.setPosition) === null || _b === void 0 || _b.call(dropTargetLogic, lastTargetIndexRef.current, itemsRect.current, lockAxis);
        },
        onEnd: function onEnd() {
            var _a; // we reset all items translations (the parent is expected to sort the items in the onSortEnd callback)
            for(var index = 0; index < itemsRef.current.length; index += 1){
                var currentItem = itemsRef.current[index];
                currentItem.style.transform = "";
                currentItem.style.transitionDuration = "";
            }
            var sourceIndex = sourceIndexRef.current;
            if (sourceIndex !== undefined) {
                // show the source item again
                var source = itemsRef.current[sourceIndex];
                if (source) {
                    source.style.opacity = "1";
                    source.style.visibility = "";
                }
                var targetIndex = lastTargetIndexRef.current;
                if (targetIndex !== undefined) {
                    if (sourceIndex !== targetIndex) {
                        // sort our internal items array
                        itemsRef.current = (0, _arrayMoveDefault.default)(itemsRef.current, sourceIndex, targetIndex); // let the parent know
                        onSortEnd(sourceIndex, targetIndex);
                    }
                }
            }
            sourceIndexRef.current = undefined;
            lastTargetIndexRef.current = undefined;
            (_a = dropTargetLogic.hide) === null || _a === void 0 || _a.call(dropTargetLogic); // cleanup the target element from the DOM
            if (targetRef.current) {
                var holder = (customHolderRef === null || customHolderRef === void 0 ? void 0 : customHolderRef.current) || document.body;
                holder.removeChild(targetRef.current);
                targetRef.current = null;
            }
        }
    });
    var registerItem = (0, _reactDefault.default).useCallback(function(item) {
        itemsRef.current.push(item);
    }, []);
    var removeItem = (0, _reactDefault.default).useCallback(function(item) {
        var index = itemsRef.current.indexOf(item);
        if (index !== -1) itemsRef.current.splice(index, 1);
    }, []);
    var registerKnob = (0, _reactDefault.default).useCallback(function(item) {
        knobs.current.push(item);
    }, []);
    var removeKnob = (0, _reactDefault.default).useCallback(function(item) {
        var index = knobs.current.indexOf(item);
        if (index !== -1) knobs.current.splice(index, 1);
    }, []); // we need to memoize the context to avoid re-rendering every children of the context provider
    // when not needed
    var context = (0, _reactDefault.default).useMemo(function() {
        return {
            registerItem: registerItem,
            removeItem: removeItem,
            registerKnob: registerKnob,
            removeKnob: removeKnob
        };
    }, [
        registerItem,
        removeItem,
        registerKnob,
        removeKnob
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(as || DEFAULT_CONTAINER_TAG, (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, allowDrag ? listeners : {}), rest), {
        ref: containerRef
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(SortableListContext.Provider, {
        value: context
    }, children, (_b = dropTargetLogic.render) === null || _b === void 0 ? void 0 : _b.call(dropTargetLogic)));
};
/**
 * SortableItem only adds a ref to its children so that we can register it to the main Sortable
 */ var SortableItem = function SortableItem(_a) {
    var children = _a.children;
    var context = (0, _reactDefault.default).useContext(SortableListContext);
    if (!context) throw new Error("SortableItem must be a child of SortableList");
    var registerItem = context.registerItem, removeItem = context.removeItem;
    var elementRef = (0, _reactDefault.default).useRef(null);
    (0, _reactDefault.default).useEffect(function() {
        var currentItem = elementRef.current;
        if (currentItem) registerItem(currentItem);
        return function() {
            if (currentItem) removeItem(currentItem);
        }; // if the children changes, we want to re-register the DOM node
    }, [
        registerItem,
        removeItem,
        children
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
        ref: elementRef
    });
};
var SortableKnob = function SortableKnob(_a) {
    var children = _a.children;
    var context = (0, _reactDefault.default).useContext(SortableListContext);
    if (!context) throw new Error("SortableKnob must be a child of SortableList");
    var registerKnob = context.registerKnob, removeKnob = context.removeKnob;
    var elementRef = (0, _reactDefault.default).useRef(null);
    (0, _reactDefault.default).useEffect(function() {
        var currentItem = elementRef.current;
        if (currentItem) registerKnob(currentItem);
        return function() {
            if (currentItem) removeKnob(currentItem);
        }; // if the children changes, we want to re-register the DOM node
    }, [
        registerKnob,
        removeKnob,
        children
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
        ref: elementRef
    });
};
exports.default = SortableList;

},{"tslib":"byQkh","array-move":"bTLKW","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"byQkh":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bTLKW":[function(require,module,exports) {
"use strict";
const arrayMoveMutate = (array, from, to)=>{
    const startIndex = from < 0 ? array.length + from : from;
    if (startIndex >= 0 && startIndex < array.length) {
        const endIndex = to < 0 ? array.length + to : to;
        const [item] = array.splice(from, 1);
        array.splice(endIndex, 0, item);
    }
};
const arrayMove = (array, from, to)=>{
    array = [
        ...array
    ];
    arrayMoveMutate(array, from, to);
    return array;
};
module.exports = arrayMove;
module.exports.mutate = arrayMoveMutate;

},{}],"iaig5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayMoveMutable", ()=>arrayMoveMutable);
parcelHelpers.export(exports, "arrayMoveImmutable", ()=>arrayMoveImmutable);
function arrayMoveMutable(array, fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < array.length) {
        const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;
        const [item] = array.splice(fromIndex, 1);
        array.splice(endIndex, 0, item);
    }
}
function arrayMoveImmutable(array, fromIndex, toIndex) {
    array = [
        ...array
    ];
    arrayMoveMutable(array, fromIndex, toIndex);
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fAN69":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CollectionPageWrap);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _collectionProvider = require("./CollectionProvider");
var _collectionProviderDefault = parcelHelpers.interopDefault(_collectionProvider);
var _entriesPage = require("../entries/EntriesPage");
var _entriesPageDefault = parcelHelpers.interopDefault(_entriesPage);
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _fieldsPage = require("./FieldsPage");
var _fieldsPageDefault = parcelHelpers.interopDefault(_fieldsPage);
var _sourcePage = require("./SourcePage");
var _sourcePageDefault = parcelHelpers.interopDefault(_sourcePage);
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _settingsPage = require("./SettingsPage");
var _settingsPageDefault = parcelHelpers.interopDefault(_settingsPage);
var _entryPage = require("../entries/EntryPage");
var _entryPageDefault = parcelHelpers.interopDefault(_entryPage);
var _exportPage = require("./ExportPage");
var _exportPageDefault = parcelHelpers.interopDefault(_exportPage);
var _bulkEdit = require("./BulkEdit");
var _bulkEditDefault = parcelHelpers.interopDefault(_bulkEdit);
function CollectionPageWrap() {
    const { collectionId } = (0, _reactRouterDom.useParams)();
    // const loc = useLocation()
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectionProviderDefault.default), {
        collectionId: collectionId,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollectionPage, {})
    });
}
function CollectionPage({}) {
    const { collection } = (0, _useCollectionDefault.default)();
    const title = `${collection?.icon || "\uD83D\uDCC1"} ${collection?.name || "..."}`;
    const { pathname } = (0, _reactRouterDom.useLocation)();
    const isEntryPage = pathname.startsWith(`/collection/${collection?.collectionId}/id/`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                        children: [
                            [
                                "",
                                "Entries"
                            ],
                            [
                                "/fields",
                                "Fields"
                            ],
                            [
                                "/source",
                                "Source"
                            ],
                            [
                                "/export",
                                "Export"
                            ],
                            [
                                "/settings",
                                "Settings"
                            ]
                        ].map(([url, label])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                to: `/collection/${collection?.collectionId || "_"}${url}`,
                                end: true,
                                className: url === "" && !!isEntryPage ? "active" : "",
                                children: label
                            }, label))
                    })
                ]
            }),
            !!collection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Routes), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        index: true,
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entriesPageDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/id/:entryId",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entryPageDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/fields",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldsPageDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/source",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sourcePageDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/export",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exportPageDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/settings",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsPageDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                        path: "/bulk",
                        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bulkEditDefault.default), {})
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","./CollectionProvider":"3TmKU","../entries/EntriesPage":"bpu4i","./useCollection":"hFA2a","./FieldsPage":"8AI5I","./SourcePage":"7O1g2","../utils/Title":"IV4kx","./SettingsPage":"458fb","../entries/EntryPage":"kM9DE","./ExportPage":"bPisx","./BulkEdit":"7Zu5a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3TmKU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_COLLECTION", ()=>GET_COLLECTION);
parcelHelpers.export(exports, "CollectionContext", ()=>CollectionContext);
parcelHelpers.export(exports, "default", ()=>CollectionProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
const GET_COLLECTION = (0, _client.gql)`
	query GetCollection($collectionId: ID!) {
		collection(collectionId: $collectionId) {
			collectionId
			name
			icon
			fields
			columns
			snippet
			title
		}
	}
`;
const CollectionContext = /*#__PURE__*/ (0, _react.createContext)({});
function CollectionProvider({ collectionId, children }) {
    const { error, data } = (0, _client.useQuery)(GET_COLLECTION, {
        variables: {
            collectionId
        },
        fetchPolicy: "cache-and-network"
    });
    const collection = data?.collection || null;
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
        error: error
    });
    if (!collection) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollectionContext.Provider, {
        value: collection,
        children: children
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bpu4i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EntriesPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _reactRouterDom = require("react-router-dom");
var _entries = require("./Entries");
var _entriesDefault = parcelHelpers.interopDefault(_entries);
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
const CREATE_ENTRY = (0, _client.gql)`
	mutation CreateEntry($collectionId: ID!) {
		createEntry(collectionId: $collectionId)
	}`;
const REMOVE_ENTRIES = (0, _client.gql)`
	mutation RemoveEntries($collectionId: ID!, $entryIds: [ID!]!) {
		removeEntries(collectionId: $collectionId, entryIds: $entryIds)
	}`;
function EntriesPage() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { collection: { collectionId } } = (0, _useCollectionDefault.default)();
    const [selected, setSelected] = (0, _react.useState)([]);
    const [selectedAction, setSelectedAction] = (0, _react.useState)("");
    const [createEntry, { loading: loadingCreate, error: createError }] = (0, _client.useMutation)(CREATE_ENTRY);
    const [removeEntries, { loading: loadingRemove, error: removeError }] = (0, _client.useMutation)(REMOVE_ENTRIES, {
        refetchQueries: [
            {
                query: (0, _entries.GET_ENTRIES),
                variables: {
                    collectionId
                }
            }
        ]
    });
    async function handleCreate() {
        const response = await createEntry({
            variables: {
                collectionId
            }
        });
        navigate(`/collection/${collectionId}/id/${response.data?.createEntry || ""}`);
    }
    async function handleSelectedAction() {
        if (selectedAction === "delete") {
            await removeEntries({
                variables: {
                    collectionId,
                    entryIds: selected
                }
            });
            setSelected([]);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
                className: "Menu",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleCreate(),
                        className: "primary",
                        children: "+ Add entry"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: "bulk",
                        children: "Bulk edit"
                    }),
                    !!selected.length && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            "Selected ",
                            selected.length,
                            ":",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                value: selectedAction,
                                onChange: (e)=>setSelectedAction(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: ""
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "delete",
                                        children: "delete"
                                    })
                                ]
                            }),
                            !!selectedAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>handleSelectedAction(),
                                children: "\u2192"
                            })
                        ]
                    })
                ]
            }),
            createError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: createError
            }),
            removeError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: removeError
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entriesDefault.default), {
                selected: selected,
                onSelected: setSelected
            }),
            loadingRemove && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            loadingCreate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","react-router-dom":"l6ORY","./Entries":"cERqi","../collections/useCollection":"hFA2a","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cERqi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_ENTRIES", ()=>GET_ENTRIES);
parcelHelpers.export(exports, "default", ()=>Entries);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _immer = require("immer");
var _entrySnippet = require("../collections/EntrySnippet");
var _entrySnippetDefault = parcelHelpers.interopDefault(_entrySnippet);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
const GET_ENTRIES = (0, _client.gql)`
	query GetEntries($collectionId:ID!, $offset:Int, $limit:Int, $search:String) {	
		entries(collectionId:$collectionId, offset:$offset, limit:$limit, search:$search) {
			collectionId
			entryId
			values
			tags 
		}
	}
`;
const GET_COLLECTION_STATS = (0, _client.gql)`
	query GetEntries($collectionId:ID!) {	
		collectionStats(collectionId:$collectionId)
	}
`;
function Entries({ selected = [], onSelected = ()=>{}, selectMode = false, forcedCollection }) {
    const { collection: contextCollection } = (0, _useCollectionDefault.default)();
    const collection = forcedCollection || contextCollection;
    const [offset, setOffset] = (0, _react.useState)(0);
    const limit = 250;
    const [search, setSearch] = (0, _react.useState)("");
    const { data: statsData } = (0, _client.useQuery)(GET_COLLECTION_STATS, {
        variables: {
            collectionId: collection.collectionId
        }
    });
    const { loading, error, data, fetchMore } = (0, _client.useQuery)(GET_ENTRIES, {
        variables: {
            collectionId: collection.collectionId,
            offset,
            limit,
            search
        },
        fetchPolicy: "cache-and-network"
    });
    const entries = data?.entries || [];
    const collectionStats = statsData?.collectionStats || {};
    const totalEntries = collectionStats.totalEntries || 0;
    const entriesCount = entries.length;
    const snippetHeaders = (0, _react.useMemo)(()=>{
        const headers = collection.snippet.map((field)=>field?.config?.name || "");
        if (headers.length === 0) headers.push("ID");
        return headers;
    }, [
        collection.snippet
    ]);
    function handleChange(event) {
        handleToggle(event.target.name);
    }
    function handleToggle(entryId) {
        onSelected((0, _immer.produce)(selected, (draft)=>{
            const idx = draft.indexOf(entryId);
            if (idx === -1) draft.push(entryId);
            else draft.splice(idx, 1);
        }));
    }
    function handleToggleAll(event) {
        onSelected(event.target.checked ? entries.map((entry)=>entry.entryId) : []);
    }
    function handleSearch(event) {
        event.preventDefault();
        setOffset(0);
        fetchMore({
            variables: {
                search
            }
        });
    }
    (0, _react.useEffect)(()=>{
        fetchMore({
            variables: {
                offset
            }
        });
    }, [
        offset
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Menu EntriesMenu",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                        onSubmit: handleSearch,
                        className: "EntriesSearch",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "search",
                                placeholder: "Search",
                                value: search,
                                onChange: (e)=>setSearch(e.target.value)
                            }),
                            !!search && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    entriesCount === 0 ? "No" : entriesCount,
                                    entriesCount === limit ? "+" : "",
                                    " ",
                                    entriesCount === 1 ? "entry" : "entries",
                                    " found"
                                ]
                            })
                        ]
                    }),
                    !search && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationDefault.default), {
                        offset: offset,
                        setOffset: setOffset,
                        limit: limit,
                        totalEntries: totalEntries,
                        loading: loading
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            entries.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Entries",
                style: {
                    gridTemplateColumns: `min-content [snippet-start] repeat(${snippetHeaders.length}, auto) [snippet-end]`
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "EntriesHeaders",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    checked: selected.length === entries.length,
                                    onChange: handleToggleAll
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "EntriesSnippetHeaders",
                                children: snippetHeaders.map((fieldName, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: fieldName
                                    }, `${fieldName}-${idx}`))
                            })
                        ]
                    }),
                    entries.map((entry)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "EntriesEntry",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "checkbox",
                                        name: entry.entryId,
                                        checked: selected.includes(entry.entryId),
                                        onChange: handleChange
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entrySnippetDefault.default), {
                                    snippet: collection.snippet,
                                    entry: entry,
                                    onSelect: selectMode && handleToggle
                                })
                            ]
                        }, entry.entryId))
                ]
            }),
            !search && totalEntries > limit && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationDefault.default), {
                setOffset: setOffset,
                offset: offset,
                limit: limit,
                totalEntries: totalEntries,
                loading: loading
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","immer":"eUR2H","../collections/EntrySnippet":"kQo4P","../utils/Alert":"5W3pt","../collections/useCollection":"hFA2a","./Pagination":"8E2ET","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQo4P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EntrySnippet);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _recoil = require("recoil");
var _timestamp = require("../utils/Timestamp");
var _timestampDefault = parcelHelpers.interopDefault(_timestamp);
var _atoms = require("../layout/atoms");
function EntrySnippet({ entry, snippet, onSelect, hideMeta = false }) {
    const buildDate = (0, _recoil.useRecoilValue)((0, _atoms.buildDateAtom));
    const infoTag = (0, _react.useMemo)(()=>{
        if (hideMeta || !buildDate || !entry.modified) return null;
        const modified = new Date(entry.modified);
        if (modified > buildDate) return "M";
        return null;
    }, [
        buildDate,
        entry.modified,
        hideMeta
    ]);
    const handleClick = (0, _react.useCallback)((e)=>{
        if (!onSelect) return true;
        e.preventDefault();
        onSelect(entry.entryId);
    }, [
        onSelect,
        entry.entryId
    ]);
    // if (snippet.length === 0) snippet.push({ fieldId: 'id' })
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: `/collection/${entry.collectionId}/id/${entry.entryId}`,
        className: "EntrySnippet",
        onClick: handleClick,
        children: snippet.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SnippetValue, {
                field: field,
                value: entry.values[field.fieldId]
            }, field.fieldId))
    });
}
// function Tags({ tags }) {
// 	return tags.map((tag, idx) => 
// 		<span key={tag+idx}>{tag.split(' ')[0]}</span>)
// }
function SnippetValue({ field, value }) {
    if (value === null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
        className: "null",
        children: "null"
    });
    if (field.type === "URI") return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
                children: [
                    "/",
                    field?.config?.prefix || ""
                ]
            }),
            value
        ]
    });
    if (field.type === "MODIFIED") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timestampDefault.default), {
            live: true,
            iso: value
        })
    });
    if (field.type === "ID") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
            children: value
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: value
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","recoil":"2QijJ","../utils/Timestamp":"aW5w6","../layout/atoms":"jppgz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hFA2a":[function(require,module,exports) {
// import { gql, useMutation } from '@apollo/client'
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCollection);
var _react = require("react");
var _collectionProvider = require("./CollectionProvider");
function useCollection() {
    const collection = (0, _react.useContext)((0, _collectionProvider.CollectionContext));
    // const collectionId = collection.collectionId
    // const [editCollectionFields] = useMutation(EDIT_COLLECTION_FIELDS, {
    // 	refetchQueries: [{ query: GET_COLLECTION, variables: { collectionId } }]
    // })
    // function updateField(fieldId, field) {
    // 	return editCollectionFields({ 
    // 		variables: {
    // 			action: 'UPDATE',
    // 			collectionId, 
    // 			field,
    // 			prevFieldId: fieldId
    // 		}
    // 	})
    // }
    // function deleteField(fieldId) {
    // 	return editCollectionFields({ 
    // 		variables: {
    // 			action: 'REMOVE',
    // 			collectionId, 
    // 			field: { id: fieldId },
    // 		}
    // 	})
    // }
    return {
        collectionId: collection.collectionId,
        collection
    };
}

},{"react":"6uln9","./CollectionProvider":"3TmKU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8E2ET":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Pagination);
var _jsxRuntime = require("react/jsx-runtime");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
function Pagination({ setOffset, offset, limit, totalEntries, loading }) {
    // if (totalEntries === 0) return null
    // if (totalEntries <= limit) 
    // 	return <div className='Pagination'>{totalEntries} {totalEntries === 1 ? "entry" : "entries"}</div>
    const isLastPage = offset + limit >= totalEntries;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "Pagination",
        children: [
            totalEntries <= limit && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    totalEntries,
                    " ",
                    totalEntries === 1 ? "entry" : "entries"
                ]
            }),
            totalEntries > limit && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setOffset((o)=>o - limit),
                        disabled: offset === 0,
                        children: "\u2190"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setOffset((o)=>o + limit),
                        disabled: isLastPage,
                        className: "last",
                        children: "\u2192"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        children: [
                            offset + 1,
                            " - ",
                            isLastPage ? totalEntries : offset + limit,
                            " / ",
                            totalEntries,
                            " entries"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                show: loading
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","../utils/Spinner":"lspMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8AI5I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CollectionFieldsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _arrayMove = require("array-move");
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _unclaimedColumns = require("./UnclaimedColumns");
var _unclaimedColumnsDefault = parcelHelpers.interopDefault(_unclaimedColumns);
var _collectionProvider = require("./CollectionProvider");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _fieldsEditor = require("../fields/FieldsEditor");
var _fieldsEditorDefault = parcelHelpers.interopDefault(_fieldsEditor);
const REORDER_FIELDS = (0, _client.gql)`
	mutation ReorderFields($collectionId: ID!, $positions: [ID]!) {
		reorderFields(collectionId: $collectionId, positions: $positions)
	}
`;
const ADD_FIELD = (0, _client.gql)`
	mutation AddField($collectionId:ID, $values:JSON!) {	
		addField(collectionId:$collectionId, values:$values)
	}
`;
function CollectionFieldsPage() {
    const { collection } = (0, _useCollectionDefault.default)();
    const [reorderFields, { loading: loadingReorder, error: reorderError }] = (0, _client.useMutation)(REORDER_FIELDS, {
        refetchQueries: [
            {
                query: (0, _collectionProvider.GET_COLLECTION),
                variables: {
                    collectionId: collection.collectionId
                }
            }
        ]
    });
    const [addField, { loading: loadingAdd, error: addError }] = (0, _client.useMutation)(ADD_FIELD, {
        refetchQueries: [
            {
                query: (0, _collectionProvider.GET_COLLECTION),
                variables: {
                    collectionId: collection.collectionId
                }
            }
        ]
    });
    function handleSortEnd(oldIndex, newIndex) {
        const newOrder = (0, _arrayMove.arrayMoveImmutable)(collection.fields, oldIndex, newIndex);
        const positions = newOrder.map(({ fieldId })=>fieldId);
        reorderFields({
            variables: {
                collectionId: collection.collectionId,
                positions
            }
        });
    }
    async function handleAddField(values) {
        await addField({
            variables: {
                collectionId: collection.collectionId,
                values
            }
        });
        return true;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !!reorderError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: reorderError
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldsEditorDefault.default), {
                fields: collection.fields,
                handleAddField: handleAddField,
                handleSortEnd: handleSortEnd
            }),
            loadingReorder && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            loadingAdd && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            !!addError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: addError
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unclaimedColumnsDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","array-move":"iaig5","./useCollection":"hFA2a","./UnclaimedColumns":"aVvhe","./CollectionProvider":"3TmKU","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","../fields/FieldsEditor":"Wwc4C","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aVvhe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UnclaimedColumns);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _collectionProvider = require("./CollectionProvider");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
const DROP_COLUMN = (0, _client.gql)`
	mutation DropColumn($collectionId:ID!, $columnName:String!) {
		dropColumn(collectionId:$collectionId, columnName:$columnName)
	}`;
function UnclaimedColumns() {
    const { collection } = (0, _useCollectionDefault.default)();
    const [dropColumn, { loading: loadingDropColumn, error: dropColumnError }] = (0, _client.useMutation)(DROP_COLUMN, {
        refetchQueries: [
            {
                query: (0, _collectionProvider.GET_COLLECTION),
                variables: {
                    collectionId: collection.collectionId
                }
            }
        ]
    });
    const unclaimedColumns = (0, _react.useMemo)(()=>{
        const claimedColumns = collection.fields.map((field)=>field.fieldId);
        return collection.columns.filter((column)=>!claimedColumns.includes(column.name));
    }, [
        collection
    ]);
    function handleDropColumn(columnName) {
        if (!window.confirm(`Are you sure you want to drop column ${columnName}? All data in it will be lost.`)) return;
        console.log("dropping column", columnName);
        dropColumn({
            variables: {
                collectionId: collection.collectionId,
                columnName
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            loadingDropColumn && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            !!dropColumnError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: dropColumnError
            }),
            unclaimedColumns.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Unclaimed columns"
                    }),
                    unclaimedColumns.map((column)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "box",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>handleDropColumn(column.name),
                                    className: "small delete float-right",
                                    children: "Drop column"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                                    children: JSON.stringify(column, null, 2)
                                })
                            ]
                        }, column.name))
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","./useCollection":"hFA2a","./CollectionProvider":"3TmKU","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Wwc4C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FieldsEditor);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactEasySort = require("react-easy-sort");
var _reactEasySortDefault = parcelHelpers.interopDefault(_reactEasySort);
var _arrayMove = require("array-move");
var _fieldItem = require("../fields/FieldItem");
var _fieldItemDefault = parcelHelpers.interopDefault(_fieldItem);
var _fieldEditor = require("../fields/FieldEditor");
var _fieldEditorDefault = parcelHelpers.interopDefault(_fieldEditor);
function FieldsEditor({ fields = [], handleAddField, handleSortEnd }) {
    // const { collection } = useCollection()
    const [newField, setNewField] = (0, _react.useState)(null);
    // const [reorderFields, { loading: loadingReorder, error: reorderError }] = useMutation(REORDER_FIELDS, {
    // 	refetchQueries: [{ query: GET_COLLECTION, variables: { collectionId: collection.collectionId } }],
    // })
    // const [addField, { loading: loadingAdd, error: addError }] = useMutation(ADD_FIELD, {
    // 	refetchQueries: [{ query: GET_COLLECTION, variables: { collectionId: collection.collectionId } }],
    // })
    // function handleSortEnd(oldIndex, newIndex) {
    // 	const newOrder = arrayMoveImmutable(fields, oldIndex, newIndex)
    // 	const positions = newOrder.map(({fieldId}) => fieldId)
    // 	// reorderFields({ variables: { collectionId: collection.collectionId, positions } })
    // }
    async function handleSaveAddField(values) {
        if (await handleAddField(values)) setNewField(null);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySortDefault.default), {
                className: "GridTable FieldsList",
                draggedItemClassName: "dragged",
                onSortEnd: handleSortEnd,
                children: Array.isArray(fields) && fields.map((f)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySort.SortableItem), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "Item",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySort.SortableKnob), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: " \u2195\uFE0F "
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldItemDefault.default), {
                                    field: f
                                })
                            ]
                        })
                    }, f.fieldId))
            }),
            !newField && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>setNewField((pf)=>!!pf ? null : {}),
                children: "Add field"
            }),
            !!newField && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldEditorDefault.default), {
                field: newField,
                handleSave: handleSaveAddField,
                onCancel: ()=>setNewField(null)
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-easy-sort":"iVlh1","array-move":"iaig5","../fields/FieldItem":"6QoJK","../fields/FieldEditor":"aCIpB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6QoJK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FieldItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _fieldEditor = require("./FieldEditor");
var _fieldEditorDefault = parcelHelpers.interopDefault(_fieldEditor);
// import FieldInput from './Field'
// import InputLabel from './InputLabel'
// import Spinner from '../utils/Spinner'
// import Alert from '../utils/Alert'
var _collectionProvider = require("../collections/CollectionProvider");
const UPDATE_FIELD = (0, _client.gql)`
	mutation UpdateField($collectionId:ID, $fieldId:ID!, $values:JSON!) {	
		updateField(collectionId:$collectionId, fieldId:$fieldId, values:$values)
	}`;
function FieldItem({ field }) {
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [value, setValue] = (0, _react.useState)();
    const [updateField, { loading: loadingUpdate, error: updateError }] = (0, _client.useMutation)(UPDATE_FIELD, {
        refetchQueries: [
            {
                query: (0, _collectionProvider.GET_COLLECTION),
                variables: {
                    collectionId: field.collectionId
                }
            }
        ]
    });
    async function handleUpdate(values) {
        console.log(field, values);
        await updateField({
            variables: {
                collectionId: field.collectionId,
                fieldId: field.fieldId,
                values
            }
        });
        setIsEditing(false);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "FieldItem",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>setIsEditing(true),
                            children: "Edit"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: field.config?.name || " "
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                        children: field.type
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                            children: field.fieldId
                        })
                    })
                ]
            }),
            isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "FieldItemEditor",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldEditorDefault.default), {
                    field: field,
                    handleSave: handleUpdate,
                    onDelete: ()=>setIsEditing(false),
                    onCancel: ()=>setIsEditing(false)
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","./FieldEditor":"aCIpB","../collections/CollectionProvider":"3TmKU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aCIpB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FieldEditor);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _useImmer = require("use-immer");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _fieldsPage = require("./FieldsPage");
var _collectionProvider = require("../collections/CollectionProvider");
var _shallowMerge = require("../utils/shallowMerge");
var _shallowMergeDefault = parcelHelpers.interopDefault(_shallowMerge);
var _field = require("../../common/fields/Field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _fields = require("../../common/fields/fields");
var _idOptionsJsx = require("./IdOptions.jsx");
var _idOptionsJsxDefault = parcelHelpers.interopDefault(_idOptionsJsx);
var _uriOptionsJsx = require("./UriOptions.jsx");
var _uriOptionsJsxDefault = parcelHelpers.interopDefault(_uriOptionsJsx);
var _textOptionsJsx = require("./TextOptions.jsx");
var _textOptionsJsxDefault = parcelHelpers.interopDefault(_textOptionsJsx);
var _htmlOptionsJsx = require("./HtmlOptions.jsx");
var _htmlOptionsJsxDefault = parcelHelpers.interopDefault(_htmlOptionsJsx);
var _fileOptionsJsx = require("./FileOptions.jsx");
var _fileOptionsJsxDefault = parcelHelpers.interopDefault(_fileOptionsJsx);
var _structOptionsJsx = require("./StructOptions.jsx");
var _structOptionsJsxDefault = parcelHelpers.interopDefault(_structOptionsJsx);
var _jsonOptionsJsx = require("./JsonOptions.jsx");
var _jsonOptionsJsxDefault = parcelHelpers.interopDefault(_jsonOptionsJsx);
var _numericOptionsJsx = require("./NumericOptions.jsx");
var _numericOptionsJsxDefault = parcelHelpers.interopDefault(_numericOptionsJsx);
var _booleanOptionsJsx = require("./BooleanOptions.jsx");
var _booleanOptionsJsxDefault = parcelHelpers.interopDefault(_booleanOptionsJsx);
var _modifiedOptionsJsx = require("./ModifiedOptions.jsx");
var _modifiedOptionsJsxDefault = parcelHelpers.interopDefault(_modifiedOptionsJsx);
var _datetimeOptionsJsx = require("./DatetimeOptions.jsx");
var _datetimeOptionsJsxDefault = parcelHelpers.interopDefault(_datetimeOptionsJsx);
var _referenceOptionsJsx = require("./ReferenceOptions.jsx");
var _referenceOptionsJsxDefault = parcelHelpers.interopDefault(_referenceOptionsJsx);
const FIELD_TYPES_OPTIONS = {
    ID: (0, _idOptionsJsxDefault.default),
    URI: (0, _uriOptionsJsxDefault.default),
    TEXT: (0, _textOptionsJsxDefault.default),
    JSON: (0, _jsonOptionsJsxDefault.default),
    HTML: (0, _htmlOptionsJsxDefault.default),
    FILE: (0, _fileOptionsJsxDefault.default),
    STRUCT: (0, _structOptionsJsxDefault.default),
    NUMERIC: (0, _numericOptionsJsxDefault.default),
    BOOLEAN: (0, _booleanOptionsJsxDefault.default),
    MODIFIED: (0, _modifiedOptionsJsxDefault.default),
    DATETIME: (0, _datetimeOptionsJsxDefault.default),
    REFERENCE: (0, _referenceOptionsJsxDefault.default)
};
const DELETE_FIELD = (0, _client.gql)`
	mutation DeleteField($collectionId:ID, $fieldId:ID!) {	
		deleteField(collectionId:$collectionId, fieldId:$fieldId)
	}`;
const emptyField = new (0, _fieldDefault.default)();
const DEFAULT_FIELD = emptyField.json;
function FieldEditor({ field, handleSave = ()=>{}, onDelete = ()=>{}, onCancel = ()=>{} }) {
    const [draft, setDraft] = (0, _useImmer.useImmer)(()=>(0, _shallowMergeDefault.default)(DEFAULT_FIELD, field));
    // const [saveField,	{ loading: isSaving, error: saveError }] = useMutation(SAVE_FIELD)
    const [deleteField, { loading: isDeleting, error: deleteError }] = (0, _client.useMutation)(DELETE_FIELD);
    // async function handleSave() {
    // 	const variables = { 
    // 		collectionId: field.collectionId, 
    // 		fieldId: field.fieldId || draft.fieldId
    // 	}
    // 	const options = {
    // 		variables: { ...variables, values: draft },
    // 		refetchQueries: [
    // 			{ query: GET_COLLECTION, variables },
    // 			{ query: GET_FIELDS, variables },
    // 		]
    // 	}
    // 	await saveField(options)
    // 	onSave()
    // }
    async function handleDelete() {
        const variables = {
            collectionId: field.collectionId,
            fieldId: field.fieldId
        };
        await deleteField({
            variables,
            refetchQueries: [
                {
                    query: (0, _collectionProvider.GET_COLLECTION),
                    variables
                },
                {
                    query: (0, _fieldsPage.GET_FIELDS),
                    variables
                }
            ]
        });
        onDelete();
    }
    function updateConfig(producer) {
        return setDraft((d)=>{
            producer(d.config);
        });
    }
    function handleCancel() {
        onCancel();
    }
    const OptionsComponent = FIELD_TYPES_OPTIONS[draft.type];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "Form FieldEditor",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Field type:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                        value: draft.type || "",
                        onChange: (e)=>setDraft((d)=>{
                                d.type = e.target.value;
                            }),
                        className: "w-fit",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: ""
                            }),
                            (0, _fields.FIELD_TYPES).map((type)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: type,
                                    children: type
                                }, type))
                        ]
                    })
                ]
            }),
            !!draft.type && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Name:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                value: draft.config.name || "",
                                onChange: (e)=>setDraft((d)=>{
                                        d.config.name = e.target.value;
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "ID:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                value: draft.fieldId || "",
                                onChange: (e)=>setDraft((d)=>{
                                        d.fieldId = e.target.value;
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Description:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                value: draft.config.description || "",
                                onChange: (e)=>setDraft((d)=>{
                                        d.config.description = e.target.value;
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("fieldset", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    checked: !!draft.config?.multi,
                                    onChange: (e)=>setDraft((d)=>{
                                            d.config.multi = e.target.checked;
                                        })
                                }),
                                " allow multiple values"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("fieldset", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    checked: !!draft.required,
                                    onChange: (e)=>setDraft((d)=>{
                                            d.config.required = e.target.checked;
                                        })
                                }),
                                " required"
                            ]
                        })
                    }),
                    !!OptionsComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OptionsComponent, {
                        config: draft.config,
                        update: updateConfig
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Submit",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleDelete(),
                        disabled: isDeleting,
                        className: "delete",
                        children: "Delete"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleCancel(),
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleSave(draft),
                        disabled: !draft.type || !draft.fieldId,
                        className: "primary",
                        children: "Save"
                    }),
                    isDeleting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
                ]
            }),
            deleteError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: deleteError
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","use-immer":"cnEe2","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","./FieldsPage":"7807s","../collections/CollectionProvider":"3TmKU","../utils/shallowMerge":"k4n68","../../common/fields/Field":"kXEtx","../../common/fields/fields":"eJZRF","./IdOptions.jsx":"eRvEC","./UriOptions.jsx":"boo3K","./TextOptions.jsx":"4c0Co","./HtmlOptions.jsx":"4dlxL","./FileOptions.jsx":"cDN1M","./StructOptions.jsx":"6Kvab","./JsonOptions.jsx":"cDTXI","./NumericOptions.jsx":"eutOa","./BooleanOptions.jsx":"3L63N","./ModifiedOptions.jsx":"3qCOc","./DatetimeOptions.jsx":"efMNX","./ReferenceOptions.jsx":"jeUZc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7807s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_FIELDS", ()=>GET_FIELDS);
parcelHelpers.export(exports, "default", ()=>FieldsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
// import { NavLink, Link } from 'react-router-dom'
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _fieldItem = require("./FieldItem");
var _fieldItemDefault = parcelHelpers.interopDefault(_fieldItem);
const GET_FIELDS = (0, _client.gql)`
	query GetFields {
		fields
	}`;
function FieldsPage() {
    const { loading, error, data } = (0, _client.useQuery)(GET_FIELDS);
    const fields = data?.fields || [];
    const [isAdding, setIsAdding] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Fields"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Heading",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "Fields"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: ()=>setIsAdding(true),
                    children: "New field"
                })
            }),
            !!error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            fields.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldItemDefault.default), {
                    field: field
                }, `${field.fieldId}+${field.collectionId}`)),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","../utils/Title":"IV4kx","./FieldItem":"6QoJK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k4n68":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowMerge);
function shallowMerge(obj1, obj2) {
    let merged = {
        ...obj1
    };
    for(let key in obj2)if (obj2.hasOwnProperty(key)) {
        // If both objects have the same key and their values are objects, merge them
        if (typeof obj2[key] === "object" && obj2[key] !== null && typeof merged[key] === "object" && merged[key] !== null) merged[key] = {
            ...merged[key],
            ...obj2[key]
        };
        else // Otherwise, simply set/overwrite the value in the merged object
        merged[key] = obj2[key];
    }
    return merged;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kXEtx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _shallowMergeJs = require("../utils/shallowMerge.js");
var _shallowMergeJsDefault = parcelHelpers.interopDefault(_shallowMergeJs);
var _jsonJs = require("../utils/json.js");
class Field {
    prevId = null;
    type = null;
    fieldId = null;
    collectionId = null;
    isCommon = false;
    config = {
        name: "",
        description: "",
        multi: false,
        required: false
    };
    // options = {}
    _columnType = "TEXT";
    columnOptions = "";
    _gqlType = "JSON";
    constructor(initVals){
        this.modify(initVals);
    }
    get columnType() {
        return this.config.multi ? `JSON` : this._columnType;
    }
    get gqlType() {
        return this._gqlType;
    }
    get columnDefinition() {
        return `${this.fieldId} ${this.columnType} ${this.columnOptions || ""}`.trim();
    }
    get json() {
        return {
            type: this.type,
            fieldId: this.fieldId,
            collectionId: this.collectionId,
            isCommon: this.isCommon,
            config: this.config
        };
    }
    modify(values = {}) {
        this.type = values.type ?? this.type;
        if (this.type === "ID") this.fieldId = "id";
        if (!!values.fieldId && this.prevId === null) this.prevId = this.fieldId;
        this.fieldId = values.fieldId ?? this.fieldId;
        this.collectionId = values.collectionId ?? this.collectionId;
        this.config = (0, _shallowMergeJsDefault.default)(this.config, values.config);
        if (!this.config.name) this.config.name = this.fieldId;
    // this.options = shallowMerge(this.options, values.options)
    }
    _parseValue(value) {
        return value;
    }
    parseValue(value) {
        return this.config.multi ? (0, _jsonJs.parseJsonValue)(value) : this._parseValue(value);
    }
    _serializeValue(value) {
        return value;
    }
    serializeValue(value) {
        return this.config.multi ? (0, _jsonJs.serializeJsonValue)(value) : this._serializeValue(value);
    }
    _exportValue(value) {
        return value;
    }
    exportValue(value) {
        return this._exportValue(value);
    }
}
exports.default = Field;

},{"../utils/shallowMerge.js":"3HHEO","../utils/json.js":"69IoX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3HHEO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowMerge);
function shallowMerge(obj1 = {}, initObj2, depth = 1) {
    let merged = {
        ...obj1
    };
    let obj2 = initObj2;
    if (typeof obj2 === "string" && obj2.length > 0) try {
        obj2 = JSON.parse(obj2);
    } catch (_) {
        obj2 = null;
    }
    if (typeof obj2 !== "object" || obj2 === null) return merged;
    for(let key in obj2)if (obj2.hasOwnProperty(key)) {
        // If both objects have the same key and their values are objects, merge them
        if (depth > 0 && typeof obj2[key] === "object" && obj2[key] !== null && typeof merged[key] === "object" && merged[key] !== null) merged[key] = {
            ...merged[key],
            ...obj2[key]
        };
        else // Otherwise, simply set/overwrite the value in the merged object
        merged[key] = obj2[key];
    }
    return merged;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"69IoX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseJsonValue", ()=>parseJsonValue);
parcelHelpers.export(exports, "serializeJsonValue", ()=>serializeJsonValue);
parcelHelpers.export(exports, "deserializeJsonValue", ()=>deserializeJsonValue);
function parseJsonValue(value) {
    let parsedValue = value;
    if (typeof value === "string") try {
        parsedValue = JSON.parse(value);
    } catch (_) {}
    if (typeof parsedValue === "undefined") return null;
    return parsedValue;
}
function serializeJsonValue(value) {
    return JSON.stringify(value);
}
function deserializeJsonValue(value) {
    return JSON.parse(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eJZRF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FIELD_TYPES", ()=>FIELD_TYPES);
var _idFieldJs = require("./IdField.js");
var _idFieldJsDefault = parcelHelpers.interopDefault(_idFieldJs);
var _uriFieldJs = require("./UriField.js");
var _uriFieldJsDefault = parcelHelpers.interopDefault(_uriFieldJs);
var _textFieldJs = require("./TextField.js");
var _textFieldJsDefault = parcelHelpers.interopDefault(_textFieldJs);
var _htmlFieldJs = require("./HtmlField.js");
var _htmlFieldJsDefault = parcelHelpers.interopDefault(_htmlFieldJs);
var _jsonFieldJs = require("./JsonField.js");
var _jsonFieldJsDefault = parcelHelpers.interopDefault(_jsonFieldJs);
var _fileFieldJs = require("./FileField.js");
var _fileFieldJsDefault = parcelHelpers.interopDefault(_fileFieldJs);
var _structFieldJs = require("./StructField.js");
var _structFieldJsDefault = parcelHelpers.interopDefault(_structFieldJs);
var _numericFieldJs = require("./NumericField.js");
var _numericFieldJsDefault = parcelHelpers.interopDefault(_numericFieldJs);
var _booleanFieldJs = require("./BooleanField.js");
var _booleanFieldJsDefault = parcelHelpers.interopDefault(_booleanFieldJs);
var _modifiedFieldJs = require("./ModifiedField.js");
var _modifiedFieldJsDefault = parcelHelpers.interopDefault(_modifiedFieldJs);
var _datetimeFieldJs = require("./DatetimeField.js");
var _datetimeFieldJsDefault = parcelHelpers.interopDefault(_datetimeFieldJs);
var _referenceFieldJs = require("./ReferenceField.js");
var _referenceFieldJsDefault = parcelHelpers.interopDefault(_referenceFieldJs);
const FIELDS = {
    ID: (0, _idFieldJsDefault.default),
    URI: (0, _uriFieldJsDefault.default),
    TEXT: (0, _textFieldJsDefault.default),
    HTML: (0, _htmlFieldJsDefault.default),
    JSON: (0, _jsonFieldJsDefault.default),
    FILE: (0, _fileFieldJsDefault.default),
    STRUCT: (0, _structFieldJsDefault.default),
    NUMERIC: (0, _numericFieldJsDefault.default),
    BOOLEAN: (0, _booleanFieldJsDefault.default),
    MODIFIED: (0, _modifiedFieldJsDefault.default),
    DATETIME: (0, _datetimeFieldJsDefault.default),
    REFERENCE: (0, _referenceFieldJsDefault.default)
};
exports.default = FIELDS;
const FIELD_TYPES = Object.keys(FIELDS);

},{"./IdField.js":"sZRtQ","./UriField.js":"e6lyN","./TextField.js":"e85L2","./HtmlField.js":"4FJHr","./JsonField.js":"ekfEo","./FileField.js":"hSmOQ","./StructField.js":"iPL8x","./NumericField.js":"1jqXD","./BooleanField.js":"29uuc","./ModifiedField.js":"bCuzl","./DatetimeField.js":"bKz6e","./ReferenceField.js":"2Bslm","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"sZRtQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
var _textFieldJs = require("./TextField.js");
var _textFieldJsDefault = parcelHelpers.interopDefault(_textFieldJs);
var _generateIdJs = require("../utils/generateId.js");
var _generateIdJsDefault = parcelHelpers.interopDefault(_generateIdJs);
class IdField extends (0, _fieldJsDefault.default) {
    type = "ID";
    _columnType = "TEXT";
    columnOptions = "PRIMARY KEY";
    _gqlType = "ID";
    fieldId = "id";
    static parseValue(value) {
        return (0, _textFieldJsDefault.default).parseValue(value);
    }
    static getDefault(seed = "CMSIDFIELD") {
        return (0, _generateIdJsDefault.default)(seed);
    }
    constructor(initVals){
        super(initVals);
    }
    _parseValue(value) {
        return IdField.parseValue(value);
    }
    // _serializeValue(value) {
    // 	return !!this.config?.prefix ? `${this.config.prefix}${value}` : value
    // }
    _exportValue(value) {
        return `${this.collectionId}_${value}`;
    }
}
exports.default = IdField;

},{"./Field.js":"kXEtx","./TextField.js":"e85L2","../utils/generateId.js":"lAWqB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e85L2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
class TextField extends (0, _fieldJsDefault.default) {
    type = "TEXT";
    _columnType = "TEXT";
    _gqlType = "String";
    options = {
        rows: 5
    };
    constructor(initVals){
        super(initVals);
    }
    static parseValue(value) {
        let parsedValue = value;
        switch(typeof value){
            case "undefined":
                return null;
            case "object":
                if (value === null) return null;
                try {
                    parsedValue = JSON.stringify(value);
                } catch (_) {}
                parsedValue = `${parsedValue}`;
                break;
            case "boolean":
                parsedValue = value ? "true" : "false";
                break;
            default:
                parsedValue = `${parsedValue}`;
                break;
        }
        return parsedValue ?? null;
    }
    _parseValue(value) {
        return TextField.parseValue(value);
    }
}
exports.default = TextField;

},{"./Field.js":"kXEtx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lAWqB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>generateId);
var _uuid = require("uuid");
function generateId(namespace, value, length = 8) {
    let id = !namespace && !value ? (0, _uuid.v4)() : !value ? (0, _uuid.v5)(namespace, (0, _uuid.v4)()) : (0, _uuid.v5)(namespace, value);
    return id.slice(0, length);
}

},{"uuid":"klst7","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"klst7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v1ToV6", ()=>(0, _v1ToV6JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "v6", ()=>(0, _v6JsDefault.default));
parcelHelpers.export(exports, "v6ToV1", ()=>(0, _v6ToV1JsDefault.default));
parcelHelpers.export(exports, "v7", ()=>(0, _v7JsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v1ToV6Js = require("./v1ToV6.js");
var _v1ToV6JsDefault = parcelHelpers.interopDefault(_v1ToV6Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _v6Js = require("./v6.js");
var _v6JsDefault = parcelHelpers.interopDefault(_v6Js);
var _v6ToV1Js = require("./v6ToV1.js");
var _v6ToV1JsDefault = parcelHelpers.interopDefault(_v6ToV1Js);
var _v7Js = require("./v7.js");
var _v7JsDefault = parcelHelpers.interopDefault(_v7Js);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);

},{"./max.js":false,"./nil.js":false,"./parse.js":false,"./stringify.js":false,"./v1.js":false,"./v1ToV6.js":false,"./v3.js":false,"./v4.js":"fpA4M","./v5.js":"c3Ua0","./v6.js":false,"./v6ToV1.js":false,"./v7.js":false,"./validate.js":false,"./version.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8aDS1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function parse(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Invalid UUID");
    var v;
    var arr = new Uint8Array(16);
    // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff;
    // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff;
    // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff;
    // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff;
    // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
exports.default = parse;

},{"./validate.js":"d35r5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d35r5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"agidw","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"agidw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fHrI1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", ()=>unsafeStringify);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
    var uuid = unsafeStringify(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"d35r5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fpA4M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"2mj2P","./rng.js":"lpvWd","./stringify.js":"fHrI1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2mj2P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpvWd":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c3Ua0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
var _sha1Js = require("./sha1.js");
var _sha1JsDefault = parcelHelpers.interopDefault(_sha1Js);
var v5 = (0, _v35JsDefault.default)("v5", 0x50, (0, _sha1JsDefault.default));
exports.default = v5;

},{"./v35.js":"iutsq","./sha1.js":"cLjRe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iutsq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DNS", ()=>DNS);
parcelHelpers.export(exports, "URL", ()=>URL);
parcelHelpers.export(exports, "default", ()=>v35);
var _stringifyJs = require("./stringify.js");
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
function stringToBytes(str) {
    str = unescape(encodeURIComponent(str)); // UTF8 escape
    var bytes = [];
    for(var i = 0; i < str.length; ++i)bytes.push(str.charCodeAt(i));
    return bytes;
}
var DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
var URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function v35(name, version, hashfunc) {
    function generateUUID(value, namespace, buf, offset) {
        var _namespace;
        if (typeof value === "string") value = stringToBytes(value);
        if (typeof namespace === "string") namespace = (0, _parseJsDefault.default)(namespace);
        if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
        // Compute hash of namespace and value, Per 4.3
        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
        // hashfunc([...namespace, ... value])`
        var bytes = new Uint8Array(16 + value.length);
        bytes.set(namespace);
        bytes.set(value, namespace.length);
        bytes = hashfunc(bytes);
        bytes[6] = bytes[6] & 0x0f | version;
        bytes[8] = bytes[8] & 0x3f | 0x80;
        if (buf) {
            offset = offset || 0;
            for(var i = 0; i < 16; ++i)buf[offset + i] = bytes[i];
            return buf;
        }
        return (0, _stringifyJs.unsafeStringify)(bytes);
    }
    // Function#name is not settable on some platforms (#270)
    try {
        generateUUID.name = name;
    } catch (err) {}
    // For CommonJS default export support
    generateUUID.DNS = DNS;
    generateUUID.URL = URL;
    return generateUUID;
}

},{"./stringify.js":"fHrI1","./parse.js":"8aDS1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cLjRe":[function(require,module,exports) {
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function f(s, x, y, z) {
    switch(s){
        case 0:
            return x & y ^ ~x & z;
        case 1:
            return x ^ y ^ z;
        case 2:
            return x & y ^ x & z ^ y & z;
        case 3:
            return x ^ y ^ z;
    }
}
function ROTL(x, n) {
    return x << n | x >>> 32 - n;
}
function sha1(bytes) {
    var K = [
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xca62c1d6
    ];
    var H = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    if (typeof bytes === "string") {
        var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = [];
        for(var i = 0; i < msg.length; ++i)bytes.push(msg.charCodeAt(i));
    } else if (!Array.isArray(bytes)) // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
    bytes.push(0x80);
    var l = bytes.length / 4 + 2;
    var N = Math.ceil(l / 16);
    var M = new Array(N);
    for(var _i = 0; _i < N; ++_i){
        var arr = new Uint32Array(16);
        for(var j = 0; j < 16; ++j)arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
        M[_i] = arr;
    }
    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
    M[N - 1][14] = Math.floor(M[N - 1][14]);
    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
    for(var _i2 = 0; _i2 < N; ++_i2){
        var W = new Uint32Array(80);
        for(var t = 0; t < 16; ++t)W[t] = M[_i2][t];
        for(var _t = 16; _t < 80; ++_t)W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
        var a = H[0];
        var b = H[1];
        var c = H[2];
        var d = H[3];
        var e = H[4];
        for(var _t2 = 0; _t2 < 80; ++_t2){
            var s = Math.floor(_t2 / 20);
            var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
            e = d;
            d = c;
            c = ROTL(b, 30) >>> 0;
            b = a;
            a = T;
        }
        H[0] = H[0] + a >>> 0;
        H[1] = H[1] + b >>> 0;
        H[2] = H[2] + c >>> 0;
        H[3] = H[3] + d >>> 0;
        H[4] = H[4] + e >>> 0;
    }
    return [
        H[0] >> 24 & 0xff,
        H[0] >> 16 & 0xff,
        H[0] >> 8 & 0xff,
        H[0] & 0xff,
        H[1] >> 24 & 0xff,
        H[1] >> 16 & 0xff,
        H[1] >> 8 & 0xff,
        H[1] & 0xff,
        H[2] >> 24 & 0xff,
        H[2] >> 16 & 0xff,
        H[2] >> 8 & 0xff,
        H[2] & 0xff,
        H[3] >> 24 & 0xff,
        H[3] >> 16 & 0xff,
        H[3] >> 8 & 0xff,
        H[3] & 0xff,
        H[4] >> 24 & 0xff,
        H[4] >> 16 & 0xff,
        H[4] >> 8 & 0xff,
        H[4] & 0xff
    ];
}
exports.default = sha1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e6lyN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
var _idFieldJs = require("./IdField.js");
var _idFieldJsDefault = parcelHelpers.interopDefault(_idFieldJs);
class UriField extends (0, _fieldJsDefault.default) {
    type = "URI";
    _columnType = "TEXT";
    _gqlType = "URI";
    fieldId = "uri";
    constructor(initVals){
        super(initVals);
    }
    _parseValue(value) {
        return (0, _idFieldJsDefault.default).parseValue(value, this.collectionId ?? this.fieldId);
    }
    _exportValue(value) {
        const url = `${this.config?.prefix || ""}${value || ""}`;
        return {
            uri: value,
            prefix: this.config?.prefix || null,
            slug: url.split("/").pop(),
            url: `/${url}/`
        };
    }
}
exports.default = UriField;

},{"./Field.js":"kXEtx","./IdField.js":"sZRtQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4FJHr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
var _textFieldJs = require("./TextField.js");
var _textFieldJsDefault = parcelHelpers.interopDefault(_textFieldJs);
class HtmlField extends (0, _fieldJsDefault.default) {
    type = "HTML";
    _columnType = "TEXT";
    _gqlType = "HTML";
    constructor(initVals){
        super(initVals);
    }
    _parseValue(value) {
        return (0, _textFieldJsDefault.default).parseValue(value);
    }
}
exports.default = HtmlField;

},{"./Field.js":"kXEtx","./TextField.js":"e85L2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ekfEo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
var _jsonJs = require("../utils/json.js");
class JsonField extends (0, _fieldJsDefault.default) {
    type = "JSON";
    _columnType = "JSON";
    _gqlType = "JSON";
    options = {};
    constructor(initVals){
        super(initVals);
    }
    static parseValue(value) {
        return (0, _jsonJs.parseJsonValue)(value);
    }
    static serializeValue(value) {
        return (0, _jsonJs.serializeJsonValue)(value);
    }
    _parseValue(value) {
        return JsonField.parseValue(value);
    }
    _serializeValue(value) {
        return JsonField.serializeValue(value);
    }
}
exports.default = JsonField;

},{"./Field.js":"kXEtx","../utils/json.js":"69IoX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hSmOQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
var _textFieldJs = require("./TextField.js");
var _textFieldJsDefault = parcelHelpers.interopDefault(_textFieldJs);
class FileField extends (0, _fieldJsDefault.default) {
    type = "FILE";
    _columnType = "TEXT";
    _gqlType = "DaisyFile";
    // isReferenceType = true
    constructor(initVals){
        super(initVals);
    }
    _parseValue(value) {
        return (0, _textFieldJsDefault.default).parseValue(value);
    }
}
exports.default = FileField;

},{"./Field.js":"kXEtx","./TextField.js":"e85L2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iPL8x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
var _jsonJs = require("../utils/json.js");
class StructField extends (0, _fieldJsDefault.default) {
    type = "STRUCT";
    _columnType = "JSON";
    _gqlType = "JSON";
    // options = {}
    constructor(initVals){
        super(initVals);
    }
    get gqlType() {
        return `${this.collectionId}_${this.fieldId}`;
    // return this.config.multi ? `[${typeName}]` : typeName
    }
    static parseValue(value) {
        return (0, _jsonJs.parseJsonValue)(value);
    }
    static serializeValue(value) {
        return (0, _jsonJs.serializeJsonValue)(value);
    }
    _parseValue(value) {
        return JsonField.parseValue(value);
    }
    _serializeValue(value) {
        return JsonField.serializeValue(value);
    }
}
exports.default = StructField;

},{"./Field.js":"kXEtx","../utils/json.js":"69IoX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1jqXD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
class NumericField extends (0, _fieldJsDefault.default) {
    type = "NUMERIC";
    _columnType = "NUMERIC";
    _gqlType = "Float";
    constructor(initVals){
        super(initVals);
    }
    _parseValue(value) {
        let parsedValue = Number(value);
        if (isNaN(parsedValue)) parsedValue = null;
        return parsedValue;
    }
}
exports.default = NumericField;

},{"./Field.js":"kXEtx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"29uuc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
class BooleanField extends (0, _fieldJsDefault.default) {
    type = "BOOLEAN";
    _columnType = "BOOLEAN";
    _gqlType = "Boolean";
    constructor(initVals){
        super(initVals);
    }
    _parseValue(value) {
        return !!value;
    }
    _serializeValue(value) {
        return value ? 1 : 0;
    }
}
exports.default = BooleanField;

},{"./Field.js":"kXEtx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bCuzl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datetimeFieldJs = require("./DatetimeField.js");
var _datetimeFieldJsDefault = parcelHelpers.interopDefault(_datetimeFieldJs);
class ModifiedField extends (0, _datetimeFieldJsDefault.default) {
    type = "MODIFIED";
    _columnType = "DATETIME";
    _gqlType = "Date";
    constructor(initVals){
        super(initVals);
    }
}
exports.default = ModifiedField;

},{"./DatetimeField.js":"bKz6e","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bKz6e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
var _textFieldJs = require("./TextField.js");
var _textFieldJsDefault = parcelHelpers.interopDefault(_textFieldJs);
class DatetimeField extends (0, _fieldJsDefault.default) {
    type = "DATETIME";
    _columnType = "DATETIME";
    _gqlType = "Date";
    static isValidDate(dateObj) {
        return dateObj instanceof Date && !isNaN(dateObj.getTime());
    }
    static parseValue(value) {
        // TODO: if value is a string, parse it as a date, if it's a number, parse it as a timestamp
        const textValue = (0, _textFieldJsDefault.default).parseValue(value);
        if (!textValue) return null;
        // console.log('textValue', textValue)
        const date = new Date(textValue);
        return !DatetimeField.isValidDate(date) ? null : date.toISOString();
    }
    constructor(initVals){
        super(initVals);
    }
    _parseValue(value) {
        return DatetimeField.parseValue(value);
    }
}
exports.default = DatetimeField;

},{"./Field.js":"kXEtx","./TextField.js":"e85L2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2Bslm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldJs = require("./Field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
var _textFieldJs = require("./TextField.js");
var _textFieldJsDefault = parcelHelpers.interopDefault(_textFieldJs);
class ReferenceField extends (0, _fieldJsDefault.default) {
    type = "REFERENCE";
    _columnType = "TEXT";
    _gqlType = "ID";
    constructor(initVals){
        super(initVals);
    }
    get gqlType() {
        return this.config?.collectionId || this._gqlType;
    }
    _parseValue(value) {
        return (0, _textFieldJsDefault.default).parseValue(value);
    }
}
exports.default = ReferenceField;

},{"./Field.js":"kXEtx","./TextField.js":"e85L2","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eRvEC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IdOptions);
var _jsxRuntime = require("react/jsx-runtime");
function IdOptions({ config, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "FieldOptions FieldOptionsCustom"
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"boo3K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IdOptions);
var _jsxRuntime = require("react/jsx-runtime");
function IdOptions({ config, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "FieldOptions FieldOptionsCustom",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                    children: "Prefix:"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    value: config.prefix || "",
                    onChange: (e)=>update((d)=>{
                            d.prefix = e.target.value;
                        })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4c0Co":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextOptions);
var _jsxRuntime = require("react/jsx-runtime");
function TextOptions({ config, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "FieldOptions FieldOptionsCustom",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                    children: "Rows:"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "number",
                    value: config.rows || "",
                    onChange: (e)=>update((d)=>{
                            d.rows = Number(e.target.value);
                        })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4dlxL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HtmlOptions);
var _jsxRuntime = require("react/jsx-runtime");
function HtmlOptions({ field, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "FieldOptions FieldOptionsCustom"
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cDN1M":[function(require,module,exports) {
// const FILETYPES = [
// 	'jpg', 'png', 'webp', 'mp3', 'psd',
// ]
// const FileALLOWED = [
// 	'minValue',
// 	'maxValue',
// 	'step',
// 	'prefix',
// 	'unit',	
// ]
// export { FileALLOWED }
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileOptions);
var _jsxRuntime = require("react/jsx-runtime");
function FileOptions({ field, update }) {
    // function onChangeFiletype({ target: { value, checked }}) {
    // 	update(draft => {
    // 		if (!Array.isArray(draft.allowedFiletypes)) draft.allowedFiletypes = []
    // 		const idx = draft.allowedFiletypes.findIndex(ext => ext === value)
    // 		if (checked && idx === -1) {
    // 			draft.allowedFiletypes.push(value)
    // 		} else if (!checked && idx > -1) {
    // 			draft.allowedFiletypes.splice(idx, 1)
    // 		}
    // 	})
    // }
    // 	function handleChange({ target: { name, value, type } }) {
    // 		if (value === '') return update(draft => { delete draft[name] })
    // 		if (type === 'number') value = Number(value)
    // 		if (name === 'suggested') value = value.split(`
    // `).map(v => v.trim())
    // 		update(draft => { draft[name] = value })
    // 	}
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Kvab":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StructOptions);
var _jsxRuntime = require("react/jsx-runtime");
var _fieldsEditor = require("./FieldsEditor");
var _fieldsEditorDefault = parcelHelpers.interopDefault(_fieldsEditor);
function StructOptions({ config, update }) {
    // const handleUpdateFields = useCallback((action, fieldVals) => {
    // 	update(draft => { 
    // 		if (!Array.isArray(draft.fields)) draft.fields = []
    // 		switch (action) {
    // 			case 'ADD':
    // 				draft.fields.push(fieldVals)
    // 				break
    // 		}
    // 	})
    // }, [])
    function handleAddField(fieldVals) {
        update((draft)=>{
            if (!Array.isArray(draft.fields)) draft.fields = [];
            draft.fields.push(fieldVals);
        });
        return true;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
        className: "STRUCToptions",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                children: "Fields"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "STRUCTfieldsEditor",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldsEditorDefault.default), {
                    fields: config.fields || [],
                    handleAddField: handleAddField
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","./FieldsEditor":"Wwc4C","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cDTXI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>JsonOptions);
var _jsxRuntime = require("react/jsx-runtime");
function JsonOptions({ config, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "FieldOptions FieldOptionsCustom",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                    children: "Rows:"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "number",
                    value: config.rows || "",
                    onChange: (e)=>update((d)=>{
                            d.rows = Number(e.target.value);
                        })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eutOa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NumberOptions);
var _jsxRuntime = require("react/jsx-runtime");
function NumberOptions({ field, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "FieldOptions FieldOptionsCustom"
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3L63N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BooleanOptions);
var _jsxRuntime = require("react/jsx-runtime");
function BooleanOptions({ config, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "FieldOptions FieldOptionsCustom",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Input type:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "RadioInput",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "radio",
                                        checked: config.inputType === "checkbox" || !config.inputType,
                                        onChange: (e)=>update((draft)=>{
                                                draft.inputType = e.target.checked ? "checkbox" : "radio";
                                            })
                                    }),
                                    " checkbox"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "radio",
                                        checked: config.inputType === "radio",
                                        onChange: (e)=>update((draft)=>{
                                                draft.inputType = e.target.checked ? "radio" : "checkbox";
                                            })
                                    }),
                                    " radio buttons"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: config.inputType === "checkbox" ? "Label:" : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                    children: "true"
                                }),
                                " label:"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: config.trueLabel || "",
                        onChange: (e)=>update((draft)=>{
                                draft.trueLabel = e.target.value;
                            }),
                        className: "TextInput"
                    })
                ]
            }),
            config.inputType === "radio" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("legend", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                children: "false"
                            }),
                            " label:"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: config.falseLabel || "",
                        onChange: (e)=>update((draft)=>{
                                draft.falseLabel = e.target.value;
                            }),
                        className: "TextInput"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3qCOc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datetimeOptionsJsx = require("./DatetimeOptions.jsx");
var _datetimeOptionsJsxDefault = parcelHelpers.interopDefault(_datetimeOptionsJsx);
exports.default = (0, _datetimeOptionsJsxDefault.default);

},{"./DatetimeOptions.jsx":"efMNX","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"efMNX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DatetimeOptions);
var _jsxRuntime = require("react/jsx-runtime");
function DatetimeOptions({ config, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jeUZc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReferenceOptions);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _collections = require("../layout/Collections");
var _queryStatus = require("../utils/QueryStatus");
var _queryStatusDefault = parcelHelpers.interopDefault(_queryStatus);
function ReferenceOptions({ config, update }) {
    const { loading, error, data } = (0, _client.useQuery)((0, _collections.GET_COLLECTIONS));
    const collections = data?.collections || [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "FieldOptions FieldOptionsCustom",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Collection:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                        value: config.collectionId || "",
                        onChange: (e)=>update((d)=>{
                                d.collectionId = e.target.value;
                            }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: ""
                            }),
                            collections.map(({ collectionId, name, icon })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                                    value: collectionId,
                                    children: [
                                        icon,
                                        " ",
                                        name
                                    ]
                                }, collectionId))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _queryStatusDefault.default), {
                loading: loading,
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","../layout/Collections":"fogPQ","../utils/QueryStatus":"dSO6d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7O1g2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_SOURCE", ()=>GET_SOURCE);
parcelHelpers.export(exports, "default", ()=>SourcePage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _client = require("@apollo/client");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
const GET_SOURCE = (0, _client.gql)`
	query GetSource($collectionId:ID!) {
		source(collectionId:$collectionId)
	}
`;
function SourcePage({}) {
    const { collection, updateField, deleteField } = (0, _useCollectionDefault.default)();
    const [showEditField, setShowEditField] = (0, _react.useState)(null);
    const { loading, error, data, refetch } = (0, _client.useQuery)(GET_SOURCE, {
        variables: {
            collectionId: collection.collectionId
        }
    });
    const columns = data?.source?.columns || [];
    const rows = data?.source?.rows || [];
    // async function handleEdit(fieldId, field) {
    // 	try {
    // 		await updateField(fieldId, field)
    // 		setShowEditField(null)
    // 		refetch()
    // 	} catch (error) { console.error(error) }
    // }
    // async function handleDelete(fieldId) {
    // 	try {
    // 		await deleteField(fieldId, null)
    // 		setShowEditField(null)
    // 		refetch()
    // 	} catch (error) { console.error(error) }
    // }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            !!showEditField && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Modal"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                className: "CollectionSource",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                            children: columns.map((column)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ColumnInfo, {
                                    column: column,
                                    field: collection.fields.find((f)=>f.id === column.name),
                                    handleSelect: (fieldId)=>setShowEditField(fieldId)
                                }, column.name))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: rows.map((row, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                children: row.map((value, idx)=>{
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: `val ${value === null ? "null" : ""}`,
                                        children: value === null ? "null" : value
                                    }, idx);
                                })
                            }, idx))
                    })
                ]
            })
        ]
    });
}
function ColumnInfo({ column: { name, type, notnull, dflt_value, pk, stats: { total, nullCount, minVal, minLen, maxVal, maxLen, distinctCount } }, field, handleSelect }) {
    let textType = ![
        "NUMERIC",
        "INTEGER"
    ].includes(type);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                    children: name
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "ColumnType",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                        children: type
                    }),
                    !!notnull && /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                        children: "NOTNULL"
                    }),
                    !!dflt_value && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
                        children: [
                            "DEFAULT VALUE ",
                            dflt_value
                        ]
                    }),
                    !!pk && /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                        children: "PRIMARY KEY"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dl", {
                className: "ColumnStats",
                children: [
                    !textType && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: "Value range:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    minVal,
                                    " - ",
                                    maxVal
                                ]
                            })
                        ]
                    }),
                    textType && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                children: "Length range:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                                children: [
                                    minLen,
                                    " - ",
                                    maxLen
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: "Distinct values:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                        children: [
                            distinctCount,
                            "/",
                            total,
                            " ",
                            distinctCount < 2 && "\u26A0\uFE0F"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                        children: "nulls:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dd", {
                        children: [
                            nullCount,
                            nullCount > total - 2 && "\u26A0\uFE0F"
                        ]
                    })
                ]
            }),
            !!field && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "ColumnField",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: field.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    field.kind,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleSelect(field.id),
                        className: "small",
                        children: "Edit"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./useCollection":"hFA2a","@apollo/client":"bWmmR","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"458fb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CollectionSettingsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _editSnippet = require("./EditSnippet");
var _editSnippetDefault = parcelHelpers.interopDefault(_editSnippet);
var _deleteCollection = require("./DeleteCollection");
var _deleteCollectionDefault = parcelHelpers.interopDefault(_deleteCollection);
var _emptyCollection = require("./EmptyCollection");
var _emptyCollectionDefault = parcelHelpers.interopDefault(_emptyCollection);
var _editCollection = require("./EditCollection");
var _editCollectionDefault = parcelHelpers.interopDefault(_editCollection);
var _configEntryTitle = require("./ConfigEntryTitle");
var _configEntryTitleDefault = parcelHelpers.interopDefault(_configEntryTitle);
var _jason = require("../utils/jason");
var _jasonDefault = parcelHelpers.interopDefault(_jason);
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
function CollectionSettingsPage() {
    const { collection } = (0, _useCollectionDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editCollectionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSnippetDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _configEntryTitleDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                className: "dangerZone"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "Danger zone"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteCollectionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyCollectionDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            (0, _jasonDefault.default)(collection, "collection")
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","./EditSnippet":"ar1Iw","./DeleteCollection":"k5gWc","./EmptyCollection":"jts7L","./EditCollection":"2r6kl","./ConfigEntryTitle":"54y6n","../utils/jason":"dL3Qe","./useCollection":"hFA2a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ar1Iw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditSnippet);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _immer = require("immer");
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _collectionProvider = require("./CollectionProvider");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _editCollection = require("./EditCollection");
function EditSnippet() {
    const { collection } = (0, _useCollectionDefault.default)();
    const { collectionId } = collection;
    const [editCollection, { error, loading }] = (0, _client.useMutation)((0, _editCollection.EDIT_COLLECTION), {
        refetchQueries: [
            {
                query: (0, _collectionProvider.GET_COLLECTION),
                variables: {
                    collectionId
                }
            }
        ]
    });
    const snippetFields = collection.snippet?.map((f)=>f.fieldId) ?? [];
    async function handleChange(fieldId, checked) {
        const snippet = (0, _immer.produce)(snippetFields, (draft)=>{
            if (!Array.isArray(draft)) draft = [];
            const idx = draft.findIndex((fId)=>fId === fieldId);
            if (checked && idx === -1) draft.push(fieldId);
            else if (!checked && idx > -1) draft.splice(idx, 1);
        });
        await editCollection({
            variables: {
                collectionId,
                values: {
                    snippet
                }
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "Entry snippet"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "EntrySnippetEdit",
                children: collection.fields.map(({ fieldId, config: { name } })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "checkbox",
                                checked: snippetFields.includes(fieldId),
                                onChange: (e)=>handleChange(fieldId, e.target.checked)
                            }),
                            " ",
                            name
                        ]
                    }, fieldId))
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","immer":"eUR2H","./useCollection":"hFA2a","./CollectionProvider":"3TmKU","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","./EditCollection":"2r6kl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2r6kl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EDIT_COLLECTION", ()=>EDIT_COLLECTION);
parcelHelpers.export(exports, "default", ()=>EditCollection);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _collectionProvider = require("./CollectionProvider");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _collectionEditor = require("./CollectionEditor");
var _collectionEditorDefault = parcelHelpers.interopDefault(_collectionEditor);
var _collections = require("../layout/Collections");
const EDIT_COLLECTION = (0, _client.gql)`
	mutation EditCollection($collectionId:ID!, $values:JSON!) {
		editCollection(collectionId:$collectionId, values:$values)
	}
`;
function EditCollection() {
    const { collection } = (0, _useCollectionDefault.default)();
    const { collectionId } = collection;
    const [editCollection, { error, loading }] = (0, _client.useMutation)(EDIT_COLLECTION, {
        refetchQueries: [
            {
                query: (0, _collectionProvider.GET_COLLECTION),
                variables: {
                    collectionId
                }
            },
            {
                query: (0, _collections.GET_COLLECTIONS)
            }
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "Edit Collection"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _collectionEditorDefault.default), {
                collection: collection,
                handleSave: (values)=>editCollection({
                        variables: {
                            collectionId,
                            values
                        }
                    })
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","./useCollection":"hFA2a","./CollectionProvider":"3TmKU","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","./CollectionEditor":"5cxiT","../layout/Collections":"fogPQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k5gWc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteCollection);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _client = require("@apollo/client");
var _collections = require("../layout/Collections");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
const DELETE_COLLECTION = (0, _client.gql)`
	mutation DeleteCollection($collectionId:ID!) {
		deleteCollection(collectionId:$collectionId)
	}
`;
function DeleteCollection() {
    const { collection: { collectionId } } = (0, _useCollectionDefault.default)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [deleteCollection, { loading, error }] = (0, _client.useMutation)(DELETE_COLLECTION, {
        refetchQueries: [
            {
                query: (0, _collections.GET_COLLECTIONS)
            }
        ]
    });
    async function handleDelete() {
        if (!confirm(`Are you sure? All data will be lost.`)) return false;
        await deleteCollection({
            variables: {
                collectionId
            }
        });
        navigate("/");
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>handleDelete(),
                className: "delete small",
                disabled: loading,
                children: "Delete collection"
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","@apollo/client":"bWmmR","../layout/Collections":"fogPQ","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","./useCollection":"hFA2a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jts7L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EmptyCollection);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _client = require("@apollo/client");
var _collections = require("../layout/Collections");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
const EMPTY_COLLECTION = (0, _client.gql)`
	mutation EmptyCollection($collectionId:ID!) {
		emptyCollection(collectionId:$collectionId)
	}
`;
function EmptyCollection() {
    const { collection: { collectionId } } = (0, _useCollectionDefault.default)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [emptyCollection, { loading, error }] = (0, _client.useMutation)(EMPTY_COLLECTION, {
        refetchQueries: [
            {
                query: (0, _collections.GET_COLLECTIONS)
            }
        ]
    });
    async function handleDelete() {
        if (!confirm(`Are you sure? All data will be lost. The collection schema will be preserved.`)) return false;
        await emptyCollection({
            variables: {
                collectionId
            }
        });
        navigate(`/collection/${collectionId}`);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>handleDelete(),
                className: "delete small",
                disabled: loading,
                children: "Empty collection"
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","@apollo/client":"bWmmR","../layout/Collections":"fogPQ","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","./useCollection":"hFA2a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"54y6n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ConfigEntryTitle);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _immer = require("immer");
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _collectionProvider = require("./CollectionProvider");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _editCollection = require("./EditCollection");
function ConfigEntryTitle() {
    const { collection } = (0, _useCollectionDefault.default)();
    const { collectionId } = collection;
    const [editCollection, { error, loading }] = (0, _client.useMutation)((0, _editCollection.EDIT_COLLECTION), {
        refetchQueries: [
            {
                query: (0, _collectionProvider.GET_COLLECTION),
                variables: {
                    collectionId
                }
            }
        ]
    });
    const fields = collection?.title?.map(({ fieldId })=>fieldId) ?? [];
    async function handleChange(fieldId, checked) {
        const title = (0, _immer.produce)(fields, (draft)=>{
            if (!Array.isArray(draft)) draft = [];
            const idx = draft.findIndex((fId)=>fId === fieldId);
            if (checked && idx === -1) draft.push(fieldId);
            else if (!checked && idx > -1) draft.splice(idx, 1);
        });
        await editCollection({
            variables: {
                collectionId,
                values: {
                    title
                }
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "Entry title"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "EntrySnippetEdit",
                children: collection.fields.map(({ fieldId, config: { name } })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "checkbox",
                                checked: fields.includes(fieldId),
                                onChange: (e)=>handleChange(fieldId, e.target.checked)
                            }),
                            " ",
                            name
                        ]
                    }, fieldId))
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","immer":"eUR2H","./useCollection":"hFA2a","./CollectionProvider":"3TmKU","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","./EditCollection":"2r6kl","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dL3Qe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>jason);
var _jsxRuntime = require("react/jsx-runtime");
function jason(value, title) {
    let summary = title;
    if (!summary && typeof value === "object") {
        const keys = Object.keys(value);
        summary = keys.length > 0 ? keys.length === 1 ? keys[0] : `${keys[0]}...` : "json";
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                children: summary
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                children: JSON.stringify(value, null, 2)
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kM9DE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UPDATE_ENTRY", ()=>UPDATE_ENTRY);
parcelHelpers.export(exports, "default", ()=>EntryPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _reactRouterDom = require("react-router-dom");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _entryChanges = require("./EntryChanges");
var _entryChangesDefault = parcelHelpers.interopDefault(_entryChanges);
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _entries = require("./Entries");
var _entryContext = require("./EntryContext");
var _entryContextDefault = parcelHelpers.interopDefault(_entryContext);
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _entryTasks = require("./EntryTasks");
var _entryTasksDefault = parcelHelpers.interopDefault(_entryTasks);
var _getValuesDiff = require("../../common/utils/getValuesDiff");
var _getValuesDiffDefault = parcelHelpers.interopDefault(_getValuesDiff);
var _detailsButton = require("../utils/DetailsButton");
var _detailsButtonDefault = parcelHelpers.interopDefault(_detailsButton);
var _field = require("../fields/Field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _jason = require("../utils/jason");
var _jasonDefault = parcelHelpers.interopDefault(_jason);
const UPDATE_ENTRY = (0, _client.gql)`
	mutation UpdateEntry($collectionId:ID!, $entryId:ID!, $values:JSON!, $changes:JSON) {
		updateEntry(collectionId:$collectionId, entryId:$entryId, values:$values, changes:$changes)
	}`;
const REMOVE_ENTRY = (0, _client.gql)`
mutation RemoveEntry($collectionId: ID!, $entryId: ID!) {
		removeEntry(collectionId: $collectionId, entryId: $entryId)
	}`;
function EntryPage() {
    const { collectionId, entryId } = (0, _reactRouterDom.useParams)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entryContext.EntryProvider), {
        collectionId: collectionId,
        entryId: entryId,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EntryPageContent, {})
    });
}
function EntryPageContent() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { collection } = (0, _useCollectionDefault.default)();
    const { collectionId, entryId, entry, draft, setDraft, title } = (0, _react.useContext)((0, _entryContextDefault.default));
    const [isSaved, setIsSaved] = (0, _react.useState)(false);
    const [showChanges, setShowChanges] = (0, _react.useState)(false);
    const [showTasks, setShowTasks] = (0, _react.useState)(false);
    const changes = (0, _react.useMemo)(()=>{
        if (!entry?.values) return null;
        const changes = (0, _getValuesDiffDefault.default)(entry.values, draft);
        return !changes.length ? null : changes;
    }, [
        entry,
        draft
    ]);
    const [updateEntry, { loading: loadingSave, error: saveError }] = (0, _client.useMutation)(UPDATE_ENTRY, {
        refetchQueries: [
            {
                query: (0, _entryContext.GET_ENTRY)
            }
        ]
    });
    async function handleSave() {
        const saveResponse = await updateEntry({
            variables: {
                collectionId,
                entryId,
                values: draft,
                changes
            }
        });
        if (saveResponse?.data?.updateEntry) setIsSaved(true);
    }
    const [removeEntry, { loading: loadingRemove, error: removeError }] = (0, _client.useMutation)(REMOVE_ENTRY, {
        variables: {
            collectionId,
            entryId
        },
        refetchQueries: [
            {
                query: (0, _entries.GET_ENTRIES),
                variables: {
                    collectionId
                }
            }
        ]
    });
    async function handleRemove() {
        if (!window.confirm(`Delete entry ${entryId}?`)) return false;
        await removeEntry();
        navigate(`/collection/${collectionId}`);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "EntryTitle",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _classnamesDefault.default)("EntryMenu", {
                    sticky: !!changes
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailsButtonDefault.default), {
                        isOpen: showTasks,
                        toggle: ()=>setShowTasks((v)=>!v),
                        children: "Tasks"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _detailsButtonDefault.default), {
                        isOpen: showChanges,
                        toggle: ()=>setShowChanges((v)=>!v),
                        children: "Changes"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleSave,
                        disabled: !changes || loadingSave,
                        className: !!changes ? "primary" : "",
                        children: "Save"
                    }),
                    loadingSave ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}) : isSaved ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "Changes saved."
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "Changes",
                        children: !!changes ? `${changes.length} change${changes.length > 1 ? "s" : ""}` : ""
                    })
                ]
            }),
            saveError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: saveError
            }),
            showChanges && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entryChangesDefault.default), {}),
            showTasks && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entryTasksDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "EntryFields",
                children: collection.fields.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldDefault.default), {
                        field: field,
                        value: draft[field.fieldId],
                        update: (value)=>setDraft((d)=>{
                                d[field.fieldId] = value;
                            })
                    }, field.fieldId))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                className: "dangerZone"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: handleRemove,
                className: "delete small",
                children: "Delete entry"
            }),
            removeError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: removeError
            }),
            loadingRemove && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            (0, _jasonDefault.default)(entry, "entry"),
            (0, _jasonDefault.default)(draft, "draft")
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","react-router-dom":"l6ORY","classnames":"hVGzI","./EntryChanges":"gwfnY","../collections/useCollection":"hFA2a","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","./Entries":"cERqi","./EntryContext":"7OvfG","../utils/Title":"IV4kx","./EntryTasks":"f6GeO","../../common/utils/getValuesDiff":"9Yfls","../utils/DetailsButton":"bXPDL","../fields/Field":"k7tVB","../utils/jason":"dL3Qe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVGzI":[function(require,module,exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"gwfnY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EntryChanges);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _timestamp = require("../utils/Timestamp");
var _timestampDefault = parcelHelpers.interopDefault(_timestamp);
var _avatar = require("../users/Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
// import jason from '../utils/jason'
var _entryChange = require("./EntryChange");
var _entryChangeDefault = parcelHelpers.interopDefault(_entryChange);
var _entryContext = require("./EntryContext");
var _entryContextDefault = parcelHelpers.interopDefault(_entryContext);
const GET_ENTRY_CHANGES = (0, _client.gql)`
	query EntryChanges($collectionId: ID!, $entryId: ID!) {
		entryChanges(collectionId: $collectionId, entryId: $entryId) {
			created
			changes
			user {
				userId
				name
				emailHash
			}
		}
	}`;
function EntryChanges({ fields = [] }) {
    const { collectionId, entryId } = (0, _react.useContext)((0, _entryContextDefault.default));
    const { loading, error, data, refetch } = (0, _client.useQuery)(GET_ENTRY_CHANGES, {
        variables: {
            collectionId,
            entryId
        }
    });
    const fieldsMap = (0, _react.useMemo)(()=>{
        const map = {};
        fields.forEach((field)=>map[field.id] = field.name);
        return map;
    }, [
        fields
    ]);
    const changes = data?.entryChanges || [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "EntryChanges",
        children: [
            !!error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "ItemsList",
                children: changes.map((snap)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ChangesSnap, {
                        snap: snap,
                        fieldsMap: fieldsMap
                    }, snap.created))
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}
function ChangesSnap({ snap, fieldsMap }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "EntryChangesSnap",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "userTimestamp",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                        emailHash: snap.user.emailHash
                    }),
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        className: "username",
                        children: snap.user.name
                    }),
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timestampDefault.default), {
                        iso: snap.created
                    })
                ]
            }),
            snap.changes.map((change)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entryChangeDefault.default), {
                    change: change,
                    fieldsMap: fieldsMap
                }, change.key))
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","../utils/Timestamp":"aW5w6","../users/Avatar":"8GHf3","./EntryChange":"atBDa","./EntryContext":"7OvfG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"atBDa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Change);
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
const Diff = require("14b86825f2e33b4a");
function Change({ change, fieldsMap, onRevert }) {
    // const added = change.old === null && change.new !== null
    // const removed = change.old !== null && change.new === null
    // const modified = change.old !== null && change.new !== null	&& change.old !== change.new
    // console.log(change)
    const diff = Diff.diffWords(`${change.old || ""}`, `${change.new || ""}`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "EntryChange",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                children: change.key
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "deltas",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChangeValue, {
                        diff: diff,
                        hide: "added",
                        isNull: change.old === null
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "action",
                        children: "\u2192"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChangeValue, {
                        diff: diff,
                        hide: "removed",
                        isNull: change.new === null
                    })
                ]
            })
        ]
    });
}
function ChangeValue({ isNull, diff, hide }) {
    if (isNull) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "value",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
            className: "null",
            children: "null"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "value",
        children: diff.map((part, idx)=>part[hide] ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _classnamesDefault.default)({
                    added: part.added,
                    removed: part.removed
                }),
                children: part.value
            }, idx))
    });
}

},{"react/jsx-runtime":"gaGEj","14b86825f2e33b4a":"7DSAB","classnames":"hVGzI","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7DSAB":[function(require,module,exports) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    function Diff() {}
    Diff.prototype = {
        diff: function diff(oldString, newString) {
            var _options$timeout;
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var callback = options.callback;
            if (typeof options === "function") {
                callback = options;
                options = {};
            }
            this.options = options;
            var self = this;
            function done(value) {
                if (callback) {
                    setTimeout(function() {
                        callback(undefined, value);
                    }, 0);
                    return true;
                } else return value;
            } // Allow subclasses to massage the input prior to running
            oldString = this.castInput(oldString);
            newString = this.castInput(newString);
            oldString = this.removeEmpty(this.tokenize(oldString));
            newString = this.removeEmpty(this.tokenize(newString));
            var newLen = newString.length, oldLen = oldString.length;
            var editLength = 1;
            var maxEditLength = newLen + oldLen;
            if (options.maxEditLength) maxEditLength = Math.min(maxEditLength, options.maxEditLength);
            var maxExecutionTime = (_options$timeout = options.timeout) !== null && _options$timeout !== void 0 ? _options$timeout : Infinity;
            var abortAfterTimestamp = Date.now() + maxExecutionTime;
            var bestPath = [
                {
                    oldPos: -1,
                    lastComponent: undefined
                }
            ]; // Seed editLength = 0, i.e. the content starts with the same values
            var newPos = this.extractCommon(bestPath[0], newString, oldString, 0);
            if (bestPath[0].oldPos + 1 >= oldLen && newPos + 1 >= newLen) // Identity per the equality and tokenizer
            return done([
                {
                    value: this.join(newString),
                    count: newString.length
                }
            ]);
             // Once we hit the right edge of the edit graph on some diagonal k, we can
            // definitely reach the end of the edit graph in no more than k edits, so
            // there's no point in considering any moves to diagonal k+1 any more (from
            // which we're guaranteed to need at least k+1 more edits).
            // Similarly, once we've reached the bottom of the edit graph, there's no
            // point considering moves to lower diagonals.
            // We record this fact by setting minDiagonalToConsider and
            // maxDiagonalToConsider to some finite value once we've hit the edge of
            // the edit graph.
            // This optimization is not faithful to the original algorithm presented in
            // Myers's paper, which instead pointlessly extends D-paths off the end of
            // the edit graph - see page 7 of Myers's paper which notes this point
            // explicitly and illustrates it with a diagram. This has major performance
            // implications for some common scenarios. For instance, to compute a diff
            // where the new text simply appends d characters on the end of the
            // original text of length n, the true Myers algorithm will take O(n+d^2)
            // time while this optimization needs only O(n+d) time.
            var minDiagonalToConsider = -Infinity, maxDiagonalToConsider = Infinity; // Main worker method. checks all permutations of a given edit length for acceptance.
            function execEditLength() {
                for(var diagonalPath = Math.max(minDiagonalToConsider, -editLength); diagonalPath <= Math.min(maxDiagonalToConsider, editLength); diagonalPath += 2){
                    var basePath = void 0;
                    var removePath = bestPath[diagonalPath - 1], addPath = bestPath[diagonalPath + 1];
                    if (removePath) // No one else is going to attempt to use this value, clear it
                    bestPath[diagonalPath - 1] = undefined;
                    var canAdd = false;
                    if (addPath) {
                        // what newPos will be after we do an insertion:
                        var addPathNewPos = addPath.oldPos - diagonalPath;
                        canAdd = addPath && 0 <= addPathNewPos && addPathNewPos < newLen;
                    }
                    var canRemove = removePath && removePath.oldPos + 1 < oldLen;
                    if (!canAdd && !canRemove) {
                        // If this path is a terminal then prune
                        bestPath[diagonalPath] = undefined;
                        continue;
                    } // Select the diagonal that we want to branch from. We select the prior
                    // path whose position in the old string is the farthest from the origin
                    // and does not pass the bounds of the diff graph
                    // TODO: Remove the `+ 1` here to make behavior match Myers algorithm
                    //       and prefer to order removals before insertions.
                    if (!canRemove || canAdd && removePath.oldPos + 1 < addPath.oldPos) basePath = self.addToPath(addPath, true, undefined, 0);
                    else basePath = self.addToPath(removePath, undefined, true, 1);
                    newPos = self.extractCommon(basePath, newString, oldString, diagonalPath);
                    if (basePath.oldPos + 1 >= oldLen && newPos + 1 >= newLen) // If we have hit the end of both strings, then we are done
                    return done(buildValues(self, basePath.lastComponent, newString, oldString, self.useLongestToken));
                    else {
                        bestPath[diagonalPath] = basePath;
                        if (basePath.oldPos + 1 >= oldLen) maxDiagonalToConsider = Math.min(maxDiagonalToConsider, diagonalPath - 1);
                        if (newPos + 1 >= newLen) minDiagonalToConsider = Math.max(minDiagonalToConsider, diagonalPath + 1);
                    }
                }
                editLength++;
            } // Performs the length of edit iteration. Is a bit fugly as this has to support the
            // sync and async mode which is never fun. Loops over execEditLength until a value
            // is produced, or until the edit length exceeds options.maxEditLength (if given),
            // in which case it will return undefined.
            if (callback) (function exec() {
                setTimeout(function() {
                    if (editLength > maxEditLength || Date.now() > abortAfterTimestamp) return callback();
                    if (!execEditLength()) exec();
                }, 0);
            })();
            else while(editLength <= maxEditLength && Date.now() <= abortAfterTimestamp){
                var ret = execEditLength();
                if (ret) return ret;
            }
        },
        addToPath: function addToPath(path, added, removed, oldPosInc) {
            var last = path.lastComponent;
            if (last && last.added === added && last.removed === removed) return {
                oldPos: path.oldPos + oldPosInc,
                lastComponent: {
                    count: last.count + 1,
                    added: added,
                    removed: removed,
                    previousComponent: last.previousComponent
                }
            };
            else return {
                oldPos: path.oldPos + oldPosInc,
                lastComponent: {
                    count: 1,
                    added: added,
                    removed: removed,
                    previousComponent: last
                }
            };
        },
        extractCommon: function extractCommon(basePath, newString, oldString, diagonalPath) {
            var newLen = newString.length, oldLen = oldString.length, oldPos = basePath.oldPos, newPos = oldPos - diagonalPath, commonCount = 0;
            while(newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newString[newPos + 1], oldString[oldPos + 1])){
                newPos++;
                oldPos++;
                commonCount++;
            }
            if (commonCount) basePath.lastComponent = {
                count: commonCount,
                previousComponent: basePath.lastComponent
            };
            basePath.oldPos = oldPos;
            return newPos;
        },
        equals: function equals(left, right) {
            if (this.options.comparator) return this.options.comparator(left, right);
            else return left === right || this.options.ignoreCase && left.toLowerCase() === right.toLowerCase();
        },
        removeEmpty: function removeEmpty(array) {
            var ret = [];
            for(var i = 0; i < array.length; i++)if (array[i]) ret.push(array[i]);
            return ret;
        },
        castInput: function castInput(value) {
            return value;
        },
        tokenize: function tokenize(value) {
            return value.split("");
        },
        join: function join(chars) {
            return chars.join("");
        }
    };
    function buildValues(diff, lastComponent, newString, oldString, useLongestToken) {
        // First we convert our linked list of components in reverse order to an
        // array in the right order:
        var components = [];
        var nextComponent;
        while(lastComponent){
            components.push(lastComponent);
            nextComponent = lastComponent.previousComponent;
            delete lastComponent.previousComponent;
            lastComponent = nextComponent;
        }
        components.reverse();
        var componentPos = 0, componentLen = components.length, newPos = 0, oldPos = 0;
        for(; componentPos < componentLen; componentPos++){
            var component = components[componentPos];
            if (!component.removed) {
                if (!component.added && useLongestToken) {
                    var value = newString.slice(newPos, newPos + component.count);
                    value = value.map(function(value, i) {
                        var oldValue = oldString[oldPos + i];
                        return oldValue.length > value.length ? oldValue : value;
                    });
                    component.value = diff.join(value);
                } else component.value = diff.join(newString.slice(newPos, newPos + component.count));
                newPos += component.count; // Common case
                if (!component.added) oldPos += component.count;
            } else {
                component.value = diff.join(oldString.slice(oldPos, oldPos + component.count));
                oldPos += component.count; // Reverse add and remove so removes are output first to match common convention
                // The diffing algorithm is tied to add then remove output and this is the simplest
                // route to get the desired output with minimal overhead.
                if (componentPos && components[componentPos - 1].added) {
                    var tmp = components[componentPos - 1];
                    components[componentPos - 1] = components[componentPos];
                    components[componentPos] = tmp;
                }
            }
        } // Special case handle for when one terminal is ignored (i.e. whitespace).
        // For this case we merge the terminal into the prior string and drop the change.
        // This is only available for string mode.
        var finalComponent = components[componentLen - 1];
        if (componentLen > 1 && typeof finalComponent.value === "string" && (finalComponent.added || finalComponent.removed) && diff.equals("", finalComponent.value)) {
            components[componentLen - 2].value += finalComponent.value;
            components.pop();
        }
        return components;
    }
    var characterDiff = new Diff();
    function diffChars(oldStr, newStr, options) {
        return characterDiff.diff(oldStr, newStr, options);
    }
    function generateOptions(options, defaults) {
        if (typeof options === "function") defaults.callback = options;
        else if (options) {
            for(var name in options)/* istanbul ignore else */ if (options.hasOwnProperty(name)) defaults[name] = options[name];
        }
        return defaults;
    }
    //
    // Ranges and exceptions:
    // Latin-1 Supplement, 0080–00FF
    //  - U+00D7  × Multiplication sign
    //  - U+00F7  ÷ Division sign
    // Latin Extended-A, 0100–017F
    // Latin Extended-B, 0180–024F
    // IPA Extensions, 0250–02AF
    // Spacing Modifier Letters, 02B0–02FF
    //  - U+02C7  ˇ &#711;  Caron
    //  - U+02D8  ˘ &#728;  Breve
    //  - U+02D9  ˙ &#729;  Dot Above
    //  - U+02DA  ˚ &#730;  Ring Above
    //  - U+02DB  ˛ &#731;  Ogonek
    //  - U+02DC  ˜ &#732;  Small Tilde
    //  - U+02DD  ˝ &#733;  Double Acute Accent
    // Latin Extended Additional, 1E00–1EFF
    var extendedWordChars = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/;
    var reWhitespace = /\S/;
    var wordDiff = new Diff();
    wordDiff.equals = function(left, right) {
        if (this.options.ignoreCase) {
            left = left.toLowerCase();
            right = right.toLowerCase();
        }
        return left === right || this.options.ignoreWhitespace && !reWhitespace.test(left) && !reWhitespace.test(right);
    };
    wordDiff.tokenize = function(value) {
        // All whitespace symbols except newline group into one token, each newline - in separate token
        var tokens = value.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/); // Join the boundary splits that we do not consider to be boundaries. This is primarily the extended Latin character set.
        for(var i = 0; i < tokens.length - 1; i++)// If we have an empty string in the next field and we have only word chars before and after, merge
        if (!tokens[i + 1] && tokens[i + 2] && extendedWordChars.test(tokens[i]) && extendedWordChars.test(tokens[i + 2])) {
            tokens[i] += tokens[i + 2];
            tokens.splice(i + 1, 2);
            i--;
        }
        return tokens;
    };
    function diffWords(oldStr, newStr, options) {
        options = generateOptions(options, {
            ignoreWhitespace: true
        });
        return wordDiff.diff(oldStr, newStr, options);
    }
    function diffWordsWithSpace(oldStr, newStr, options) {
        return wordDiff.diff(oldStr, newStr, options);
    }
    var lineDiff = new Diff();
    lineDiff.tokenize = function(value) {
        if (this.options.stripTrailingCr) // remove one \r before \n to match GNU diff's --strip-trailing-cr behavior
        value = value.replace(/\r\n/g, "\n");
        var retLines = [], linesAndNewlines = value.split(/(\n|\r\n)/); // Ignore the final empty token that occurs if the string ends with a new line
        if (!linesAndNewlines[linesAndNewlines.length - 1]) linesAndNewlines.pop();
         // Merge the content and line separators into single tokens
        for(var i = 0; i < linesAndNewlines.length; i++){
            var line = linesAndNewlines[i];
            if (i % 2 && !this.options.newlineIsToken) retLines[retLines.length - 1] += line;
            else {
                if (this.options.ignoreWhitespace) line = line.trim();
                retLines.push(line);
            }
        }
        return retLines;
    };
    function diffLines(oldStr, newStr, callback) {
        return lineDiff.diff(oldStr, newStr, callback);
    }
    function diffTrimmedLines(oldStr, newStr, callback) {
        var options = generateOptions(callback, {
            ignoreWhitespace: true
        });
        return lineDiff.diff(oldStr, newStr, options);
    }
    var sentenceDiff = new Diff();
    sentenceDiff.tokenize = function(value) {
        return value.split(/(\S.+?[.!?])(?=\s+|$)/);
    };
    function diffSentences(oldStr, newStr, callback) {
        return sentenceDiff.diff(oldStr, newStr, callback);
    }
    var cssDiff = new Diff();
    cssDiff.tokenize = function(value) {
        return value.split(/([{}:;,]|\s+)/);
    };
    function diffCss(oldStr, newStr, callback) {
        return cssDiff.diff(oldStr, newStr, callback);
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var objectPrototypeToString = Object.prototype.toString;
    var jsonDiff = new Diff(); // Discriminate between two lines of pretty-printed, serialized JSON where one of them has a
    // dangling comma and the other doesn't. Turns out including the dangling comma yields the nicest output:
    jsonDiff.useLongestToken = true;
    jsonDiff.tokenize = lineDiff.tokenize;
    jsonDiff.castInput = function(value) {
        var _this$options = this.options, undefinedReplacement = _this$options.undefinedReplacement, _this$options$stringi = _this$options.stringifyReplacer, stringifyReplacer = _this$options$stringi === void 0 ? function(k, v) {
            return typeof v === "undefined" ? undefinedReplacement : v;
        } : _this$options$stringi;
        return typeof value === "string" ? value : JSON.stringify(canonicalize(value, null, null, stringifyReplacer), stringifyReplacer, "  ");
    };
    jsonDiff.equals = function(left, right) {
        return Diff.prototype.equals.call(jsonDiff, left.replace(/,([\r\n])/g, "$1"), right.replace(/,([\r\n])/g, "$1"));
    };
    function diffJson(oldObj, newObj, options) {
        return jsonDiff.diff(oldObj, newObj, options);
    } // This function handles the presence of circular references by bailing out when encountering an
    // object that is already on the "stack" of items being processed. Accepts an optional replacer
    function canonicalize(obj, stack, replacementStack, replacer, key) {
        stack = stack || [];
        replacementStack = replacementStack || [];
        if (replacer) obj = replacer(key, obj);
        var i;
        for(i = 0; i < stack.length; i += 1){
            if (stack[i] === obj) return replacementStack[i];
        }
        var canonicalizedObj;
        if ("[object Array]" === objectPrototypeToString.call(obj)) {
            stack.push(obj);
            canonicalizedObj = new Array(obj.length);
            replacementStack.push(canonicalizedObj);
            for(i = 0; i < obj.length; i += 1)canonicalizedObj[i] = canonicalize(obj[i], stack, replacementStack, replacer, key);
            stack.pop();
            replacementStack.pop();
            return canonicalizedObj;
        }
        if (obj && obj.toJSON) obj = obj.toJSON();
        if (_typeof(obj) === "object" && obj !== null) {
            stack.push(obj);
            canonicalizedObj = {};
            replacementStack.push(canonicalizedObj);
            var sortedKeys = [], _key;
            for(_key in obj)/* istanbul ignore else */ if (obj.hasOwnProperty(_key)) sortedKeys.push(_key);
            sortedKeys.sort();
            for(i = 0; i < sortedKeys.length; i += 1){
                _key = sortedKeys[i];
                canonicalizedObj[_key] = canonicalize(obj[_key], stack, replacementStack, replacer, _key);
            }
            stack.pop();
            replacementStack.pop();
        } else canonicalizedObj = obj;
        return canonicalizedObj;
    }
    var arrayDiff = new Diff();
    arrayDiff.tokenize = function(value) {
        return value.slice();
    };
    arrayDiff.join = arrayDiff.removeEmpty = function(value) {
        return value;
    };
    function diffArrays(oldArr, newArr, callback) {
        return arrayDiff.diff(oldArr, newArr, callback);
    }
    function parsePatch(uniDiff) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var diffstr = uniDiff.split(/\r\n|[\n\v\f\r\x85]/), delimiters = uniDiff.match(/\r\n|[\n\v\f\r\x85]/g) || [], list = [], i = 0;
        function parseIndex() {
            var index = {};
            list.push(index); // Parse diff metadata
            while(i < diffstr.length){
                var line = diffstr[i]; // File header found, end parsing diff metadata
                if (/^(\-\-\-|\+\+\+|@@)\s/.test(line)) break;
                 // Diff index
                var header = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(line);
                if (header) index.index = header[1];
                i++;
            } // Parse file headers if they are defined. Unified diff requires them, but
            // there's no technical issues to have an isolated hunk without file header
            parseFileHeader(index);
            parseFileHeader(index); // Parse hunks
            index.hunks = [];
            while(i < diffstr.length){
                var _line = diffstr[i];
                if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(_line)) break;
                else if (/^@@/.test(_line)) index.hunks.push(parseHunk());
                else if (_line && options.strict) // Ignore unexpected content unless in strict mode
                throw new Error("Unknown line " + (i + 1) + " " + JSON.stringify(_line));
                else i++;
            }
        } // Parses the --- and +++ headers, if none are found, no lines
        // are consumed.
        function parseFileHeader(index) {
            var fileHeader = /^(---|\+\+\+)\s+(.*)$/.exec(diffstr[i]);
            if (fileHeader) {
                var keyPrefix = fileHeader[1] === "---" ? "old" : "new";
                var data = fileHeader[2].split("	", 2);
                var fileName = data[0].replace(/\\\\/g, "\\");
                if (/^".*"$/.test(fileName)) fileName = fileName.substr(1, fileName.length - 2);
                index[keyPrefix + "FileName"] = fileName;
                index[keyPrefix + "Header"] = (data[1] || "").trim();
                i++;
            }
        } // Parses a hunk
        // This assumes that we are at the start of a hunk.
        function parseHunk() {
            var chunkHeaderIndex = i, chunkHeaderLine = diffstr[i++], chunkHeader = chunkHeaderLine.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/);
            var hunk = {
                oldStart: +chunkHeader[1],
                oldLines: typeof chunkHeader[2] === "undefined" ? 1 : +chunkHeader[2],
                newStart: +chunkHeader[3],
                newLines: typeof chunkHeader[4] === "undefined" ? 1 : +chunkHeader[4],
                lines: [],
                linedelimiters: []
            }; // Unified Diff Format quirk: If the chunk size is 0,
            // the first number is one lower than one would expect.
            // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
            if (hunk.oldLines === 0) hunk.oldStart += 1;
            if (hunk.newLines === 0) hunk.newStart += 1;
            var addCount = 0, removeCount = 0;
            for(; i < diffstr.length; i++){
                // Lines starting with '---' could be mistaken for the "remove line" operation
                // But they could be the header for the next file. Therefore prune such cases out.
                if (diffstr[i].indexOf("--- ") === 0 && i + 2 < diffstr.length && diffstr[i + 1].indexOf("+++ ") === 0 && diffstr[i + 2].indexOf("@@") === 0) break;
                var operation = diffstr[i].length == 0 && i != diffstr.length - 1 ? " " : diffstr[i][0];
                if (operation === "+" || operation === "-" || operation === " " || operation === "\\") {
                    hunk.lines.push(diffstr[i]);
                    hunk.linedelimiters.push(delimiters[i] || "\n");
                    if (operation === "+") addCount++;
                    else if (operation === "-") removeCount++;
                    else if (operation === " ") {
                        addCount++;
                        removeCount++;
                    }
                } else break;
            } // Handle the empty block count case
            if (!addCount && hunk.newLines === 1) hunk.newLines = 0;
            if (!removeCount && hunk.oldLines === 1) hunk.oldLines = 0;
             // Perform optional sanity checking
            if (options.strict) {
                if (addCount !== hunk.newLines) throw new Error("Added line count did not match for hunk at line " + (chunkHeaderIndex + 1));
                if (removeCount !== hunk.oldLines) throw new Error("Removed line count did not match for hunk at line " + (chunkHeaderIndex + 1));
            }
            return hunk;
        }
        while(i < diffstr.length)parseIndex();
        return list;
    }
    // Iterator that traverses in the range of [min, max], stepping
    // by distance from a given start position. I.e. for [0, 4], with
    // start of 2, this will iterate 2, 3, 1, 4, 0.
    function distanceIterator(start, minLine, maxLine) {
        var wantForward = true, backwardExhausted = false, forwardExhausted = false, localOffset = 1;
        return function iterator() {
            if (wantForward && !forwardExhausted) {
                if (backwardExhausted) localOffset++;
                else wantForward = false;
                 // Check if trying to fit beyond text length, and if not, check it fits
                // after offset location (or desired location on first iteration)
                if (start + localOffset <= maxLine) return localOffset;
                forwardExhausted = true;
            }
            if (!backwardExhausted) {
                if (!forwardExhausted) wantForward = true;
                 // Check if trying to fit before text beginning, and if not, check it fits
                // before offset location
                if (minLine <= start - localOffset) return -localOffset++;
                backwardExhausted = true;
                return iterator();
            } // We tried to fit hunk before text beginning and beyond text length, then
        // hunk can't fit on the text. Return undefined
        };
    }
    function applyPatch(source, uniDiff) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (typeof uniDiff === "string") uniDiff = parsePatch(uniDiff);
        if (Array.isArray(uniDiff)) {
            if (uniDiff.length > 1) throw new Error("applyPatch only works with a single input.");
            uniDiff = uniDiff[0];
        } // Apply the diff to the input
        var lines = source.split(/\r\n|[\n\v\f\r\x85]/), delimiters = source.match(/\r\n|[\n\v\f\r\x85]/g) || [], hunks = uniDiff.hunks, compareLine = options.compareLine || function(lineNumber, line, operation, patchContent) {
            return line === patchContent;
        }, errorCount = 0, fuzzFactor = options.fuzzFactor || 0, minLine = 0, offset = 0, removeEOFNL, addEOFNL;
        /**
     * Checks if the hunk exactly fits on the provided location
     */ function hunkFits(hunk, toPos) {
            for(var j = 0; j < hunk.lines.length; j++){
                var line = hunk.lines[j], operation = line.length > 0 ? line[0] : " ", content = line.length > 0 ? line.substr(1) : line;
                if (operation === " " || operation === "-") {
                    // Context sanity check
                    if (!compareLine(toPos + 1, lines[toPos], operation, content)) {
                        errorCount++;
                        if (errorCount > fuzzFactor) return false;
                    }
                    toPos++;
                }
            }
            return true;
        } // Search best fit offsets for each hunk based on the previous ones
        for(var i = 0; i < hunks.length; i++){
            var hunk = hunks[i], maxLine = lines.length - hunk.oldLines, localOffset = 0, toPos = offset + hunk.oldStart - 1;
            var iterator = distanceIterator(toPos, minLine, maxLine);
            for(; localOffset !== undefined; localOffset = iterator())if (hunkFits(hunk, toPos + localOffset)) {
                hunk.offset = offset += localOffset;
                break;
            }
            if (localOffset === undefined) return false;
             // Set lower text limit to end of the current hunk, so next ones don't try
            // to fit over already patched text
            minLine = hunk.offset + hunk.oldStart + hunk.oldLines;
        } // Apply patch hunks
        var diffOffset = 0;
        for(var _i = 0; _i < hunks.length; _i++){
            var _hunk = hunks[_i], _toPos = _hunk.oldStart + _hunk.offset + diffOffset - 1;
            diffOffset += _hunk.newLines - _hunk.oldLines;
            for(var j = 0; j < _hunk.lines.length; j++){
                var line = _hunk.lines[j], operation = line.length > 0 ? line[0] : " ", content = line.length > 0 ? line.substr(1) : line, delimiter = _hunk.linedelimiters && _hunk.linedelimiters[j] || "\n";
                if (operation === " ") _toPos++;
                else if (operation === "-") {
                    lines.splice(_toPos, 1);
                    delimiters.splice(_toPos, 1);
                /* istanbul ignore else */ } else if (operation === "+") {
                    lines.splice(_toPos, 0, content);
                    delimiters.splice(_toPos, 0, delimiter);
                    _toPos++;
                } else if (operation === "\\") {
                    var previousOperation = _hunk.lines[j - 1] ? _hunk.lines[j - 1][0] : null;
                    if (previousOperation === "+") removeEOFNL = true;
                    else if (previousOperation === "-") addEOFNL = true;
                }
            }
        } // Handle EOFNL insertion/removal
        if (removeEOFNL) while(!lines[lines.length - 1]){
            lines.pop();
            delimiters.pop();
        }
        else if (addEOFNL) {
            lines.push("");
            delimiters.push("\n");
        }
        for(var _k = 0; _k < lines.length - 1; _k++)lines[_k] = lines[_k] + delimiters[_k];
        return lines.join("");
    } // Wrapper that supports multiple file patches via callbacks.
    function applyPatches(uniDiff, options) {
        if (typeof uniDiff === "string") uniDiff = parsePatch(uniDiff);
        var currentIndex = 0;
        function processIndex() {
            var index = uniDiff[currentIndex++];
            if (!index) return options.complete();
            options.loadFile(index, function(err, data) {
                if (err) return options.complete(err);
                var updatedContent = applyPatch(data, index, options);
                options.patched(index, updatedContent, function(err) {
                    if (err) return options.complete(err);
                    processIndex();
                });
            });
        }
        processIndex();
    }
    function structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
        if (!options) options = {};
        if (typeof options.context === "undefined") options.context = 4;
        var diff = diffLines(oldStr, newStr, options);
        if (!diff) return;
        diff.push({
            value: "",
            lines: []
        }); // Append an empty value to make cleanup easier
        function contextLines(lines) {
            return lines.map(function(entry) {
                return " " + entry;
            });
        }
        var hunks = [];
        var oldRangeStart = 0, newRangeStart = 0, curRange = [], oldLine = 1, newLine = 1;
        var _loop = function _loop(i) {
            var current = diff[i], lines = current.lines || current.value.replace(/\n$/, "").split("\n");
            current.lines = lines;
            if (current.added || current.removed) {
                var _curRange;
                // If we have previous context, start with that
                if (!oldRangeStart) {
                    var prev = diff[i - 1];
                    oldRangeStart = oldLine;
                    newRangeStart = newLine;
                    if (prev) {
                        curRange = options.context > 0 ? contextLines(prev.lines.slice(-options.context)) : [];
                        oldRangeStart -= curRange.length;
                        newRangeStart -= curRange.length;
                    }
                } // Output our changes
                (_curRange = curRange).push.apply(_curRange, _toConsumableArray(lines.map(function(entry) {
                    return (current.added ? "+" : "-") + entry;
                }))); // Track the updated file position
                if (current.added) newLine += lines.length;
                else oldLine += lines.length;
            } else {
                // Identical context lines. Track line changes
                if (oldRangeStart) {
                    // Close out any changes that have been output (or join overlapping)
                    if (lines.length <= options.context * 2 && i < diff.length - 2) {
                        var _curRange2;
                        // Overlapping
                        (_curRange2 = curRange).push.apply(_curRange2, _toConsumableArray(contextLines(lines)));
                    } else {
                        var _curRange3;
                        // end the range and output
                        var contextSize = Math.min(lines.length, options.context);
                        (_curRange3 = curRange).push.apply(_curRange3, _toConsumableArray(contextLines(lines.slice(0, contextSize))));
                        var hunk = {
                            oldStart: oldRangeStart,
                            oldLines: oldLine - oldRangeStart + contextSize,
                            newStart: newRangeStart,
                            newLines: newLine - newRangeStart + contextSize,
                            lines: curRange
                        };
                        if (i >= diff.length - 2 && lines.length <= options.context) {
                            // EOF is inside this hunk
                            var oldEOFNewline = /\n$/.test(oldStr);
                            var newEOFNewline = /\n$/.test(newStr);
                            var noNlBeforeAdds = lines.length == 0 && curRange.length > hunk.oldLines;
                            if (!oldEOFNewline && noNlBeforeAdds && oldStr.length > 0) // special case: old has no eol and no trailing context; no-nl can end up before adds
                            // however, if the old file is empty, do not output the no-nl line
                            curRange.splice(hunk.oldLines, 0, "\\ No newline at end of file");
                            if (!oldEOFNewline && !noNlBeforeAdds || !newEOFNewline) curRange.push("\\ No newline at end of file");
                        }
                        hunks.push(hunk);
                        oldRangeStart = 0;
                        newRangeStart = 0;
                        curRange = [];
                    }
                }
                oldLine += lines.length;
                newLine += lines.length;
            }
        };
        for(var i = 0; i < diff.length; i++)_loop(i);
        return {
            oldFileName: oldFileName,
            newFileName: newFileName,
            oldHeader: oldHeader,
            newHeader: newHeader,
            hunks: hunks
        };
    }
    function formatPatch(diff) {
        if (Array.isArray(diff)) return diff.map(formatPatch).join("\n");
        var ret = [];
        if (diff.oldFileName == diff.newFileName) ret.push("Index: " + diff.oldFileName);
        ret.push("===================================================================");
        ret.push("--- " + diff.oldFileName + (typeof diff.oldHeader === "undefined" ? "" : "	" + diff.oldHeader));
        ret.push("+++ " + diff.newFileName + (typeof diff.newHeader === "undefined" ? "" : "	" + diff.newHeader));
        for(var i = 0; i < diff.hunks.length; i++){
            var hunk = diff.hunks[i]; // Unified Diff Format quirk: If the chunk size is 0,
            // the first number is one lower than one would expect.
            // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
            if (hunk.oldLines === 0) hunk.oldStart -= 1;
            if (hunk.newLines === 0) hunk.newStart -= 1;
            ret.push("@@ -" + hunk.oldStart + "," + hunk.oldLines + " +" + hunk.newStart + "," + hunk.newLines + " @@");
            ret.push.apply(ret, hunk.lines);
        }
        return ret.join("\n") + "\n";
    }
    function createTwoFilesPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
        return formatPatch(structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options));
    }
    function createPatch(fileName, oldStr, newStr, oldHeader, newHeader, options) {
        return createTwoFilesPatch(fileName, fileName, oldStr, newStr, oldHeader, newHeader, options);
    }
    function arrayEqual(a, b) {
        if (a.length !== b.length) return false;
        return arrayStartsWith(a, b);
    }
    function arrayStartsWith(array, start) {
        if (start.length > array.length) return false;
        for(var i = 0; i < start.length; i++){
            if (start[i] !== array[i]) return false;
        }
        return true;
    }
    function calcLineCount(hunk) {
        var _calcOldNewLineCount = calcOldNewLineCount(hunk.lines), oldLines = _calcOldNewLineCount.oldLines, newLines = _calcOldNewLineCount.newLines;
        if (oldLines !== undefined) hunk.oldLines = oldLines;
        else delete hunk.oldLines;
        if (newLines !== undefined) hunk.newLines = newLines;
        else delete hunk.newLines;
    }
    function merge(mine, theirs, base) {
        mine = loadPatch(mine, base);
        theirs = loadPatch(theirs, base);
        var ret = {}; // For index we just let it pass through as it doesn't have any necessary meaning.
        // Leaving sanity checks on this to the API consumer that may know more about the
        // meaning in their own context.
        if (mine.index || theirs.index) ret.index = mine.index || theirs.index;
        if (mine.newFileName || theirs.newFileName) {
            if (!fileNameChanged(mine)) {
                // No header or no change in ours, use theirs (and ours if theirs does not exist)
                ret.oldFileName = theirs.oldFileName || mine.oldFileName;
                ret.newFileName = theirs.newFileName || mine.newFileName;
                ret.oldHeader = theirs.oldHeader || mine.oldHeader;
                ret.newHeader = theirs.newHeader || mine.newHeader;
            } else if (!fileNameChanged(theirs)) {
                // No header or no change in theirs, use ours
                ret.oldFileName = mine.oldFileName;
                ret.newFileName = mine.newFileName;
                ret.oldHeader = mine.oldHeader;
                ret.newHeader = mine.newHeader;
            } else {
                // Both changed... figure it out
                ret.oldFileName = selectField(ret, mine.oldFileName, theirs.oldFileName);
                ret.newFileName = selectField(ret, mine.newFileName, theirs.newFileName);
                ret.oldHeader = selectField(ret, mine.oldHeader, theirs.oldHeader);
                ret.newHeader = selectField(ret, mine.newHeader, theirs.newHeader);
            }
        }
        ret.hunks = [];
        var mineIndex = 0, theirsIndex = 0, mineOffset = 0, theirsOffset = 0;
        while(mineIndex < mine.hunks.length || theirsIndex < theirs.hunks.length){
            var mineCurrent = mine.hunks[mineIndex] || {
                oldStart: Infinity
            }, theirsCurrent = theirs.hunks[theirsIndex] || {
                oldStart: Infinity
            };
            if (hunkBefore(mineCurrent, theirsCurrent)) {
                // This patch does not overlap with any of the others, yay.
                ret.hunks.push(cloneHunk(mineCurrent, mineOffset));
                mineIndex++;
                theirsOffset += mineCurrent.newLines - mineCurrent.oldLines;
            } else if (hunkBefore(theirsCurrent, mineCurrent)) {
                // This patch does not overlap with any of the others, yay.
                ret.hunks.push(cloneHunk(theirsCurrent, theirsOffset));
                theirsIndex++;
                mineOffset += theirsCurrent.newLines - theirsCurrent.oldLines;
            } else {
                // Overlap, merge as best we can
                var mergedHunk = {
                    oldStart: Math.min(mineCurrent.oldStart, theirsCurrent.oldStart),
                    oldLines: 0,
                    newStart: Math.min(mineCurrent.newStart + mineOffset, theirsCurrent.oldStart + theirsOffset),
                    newLines: 0,
                    lines: []
                };
                mergeLines(mergedHunk, mineCurrent.oldStart, mineCurrent.lines, theirsCurrent.oldStart, theirsCurrent.lines);
                theirsIndex++;
                mineIndex++;
                ret.hunks.push(mergedHunk);
            }
        }
        return ret;
    }
    function loadPatch(param, base) {
        if (typeof param === "string") {
            if (/^@@/m.test(param) || /^Index:/m.test(param)) return parsePatch(param)[0];
            if (!base) throw new Error("Must provide a base reference or pass in a patch");
            return structuredPatch(undefined, undefined, base, param);
        }
        return param;
    }
    function fileNameChanged(patch) {
        return patch.newFileName && patch.newFileName !== patch.oldFileName;
    }
    function selectField(index, mine, theirs) {
        if (mine === theirs) return mine;
        else {
            index.conflict = true;
            return {
                mine: mine,
                theirs: theirs
            };
        }
    }
    function hunkBefore(test, check) {
        return test.oldStart < check.oldStart && test.oldStart + test.oldLines < check.oldStart;
    }
    function cloneHunk(hunk, offset) {
        return {
            oldStart: hunk.oldStart,
            oldLines: hunk.oldLines,
            newStart: hunk.newStart + offset,
            newLines: hunk.newLines,
            lines: hunk.lines
        };
    }
    function mergeLines(hunk, mineOffset, mineLines, theirOffset, theirLines) {
        // This will generally result in a conflicted hunk, but there are cases where the context
        // is the only overlap where we can successfully merge the content here.
        var mine = {
            offset: mineOffset,
            lines: mineLines,
            index: 0
        }, their = {
            offset: theirOffset,
            lines: theirLines,
            index: 0
        }; // Handle any leading content
        insertLeading(hunk, mine, their);
        insertLeading(hunk, their, mine); // Now in the overlap content. Scan through and select the best changes from each.
        while(mine.index < mine.lines.length && their.index < their.lines.length){
            var mineCurrent = mine.lines[mine.index], theirCurrent = their.lines[their.index];
            if ((mineCurrent[0] === "-" || mineCurrent[0] === "+") && (theirCurrent[0] === "-" || theirCurrent[0] === "+")) // Both modified ...
            mutualChange(hunk, mine, their);
            else if (mineCurrent[0] === "+" && theirCurrent[0] === " ") {
                var _hunk$lines;
                // Mine inserted
                (_hunk$lines = hunk.lines).push.apply(_hunk$lines, _toConsumableArray(collectChange(mine)));
            } else if (theirCurrent[0] === "+" && mineCurrent[0] === " ") {
                var _hunk$lines2;
                // Theirs inserted
                (_hunk$lines2 = hunk.lines).push.apply(_hunk$lines2, _toConsumableArray(collectChange(their)));
            } else if (mineCurrent[0] === "-" && theirCurrent[0] === " ") // Mine removed or edited
            removal(hunk, mine, their);
            else if (theirCurrent[0] === "-" && mineCurrent[0] === " ") // Their removed or edited
            removal(hunk, their, mine, true);
            else if (mineCurrent === theirCurrent) {
                // Context identity
                hunk.lines.push(mineCurrent);
                mine.index++;
                their.index++;
            } else // Context mismatch
            conflict(hunk, collectChange(mine), collectChange(their));
        } // Now push anything that may be remaining
        insertTrailing(hunk, mine);
        insertTrailing(hunk, their);
        calcLineCount(hunk);
    }
    function mutualChange(hunk, mine, their) {
        var myChanges = collectChange(mine), theirChanges = collectChange(their);
        if (allRemoves(myChanges) && allRemoves(theirChanges)) {
            // Special case for remove changes that are supersets of one another
            if (arrayStartsWith(myChanges, theirChanges) && skipRemoveSuperset(their, myChanges, myChanges.length - theirChanges.length)) {
                var _hunk$lines3;
                (_hunk$lines3 = hunk.lines).push.apply(_hunk$lines3, _toConsumableArray(myChanges));
                return;
            } else if (arrayStartsWith(theirChanges, myChanges) && skipRemoveSuperset(mine, theirChanges, theirChanges.length - myChanges.length)) {
                var _hunk$lines4;
                (_hunk$lines4 = hunk.lines).push.apply(_hunk$lines4, _toConsumableArray(theirChanges));
                return;
            }
        } else if (arrayEqual(myChanges, theirChanges)) {
            var _hunk$lines5;
            (_hunk$lines5 = hunk.lines).push.apply(_hunk$lines5, _toConsumableArray(myChanges));
            return;
        }
        conflict(hunk, myChanges, theirChanges);
    }
    function removal(hunk, mine, their, swap) {
        var myChanges = collectChange(mine), theirChanges = collectContext(their, myChanges);
        if (theirChanges.merged) {
            var _hunk$lines6;
            (_hunk$lines6 = hunk.lines).push.apply(_hunk$lines6, _toConsumableArray(theirChanges.merged));
        } else conflict(hunk, swap ? theirChanges : myChanges, swap ? myChanges : theirChanges);
    }
    function conflict(hunk, mine, their) {
        hunk.conflict = true;
        hunk.lines.push({
            conflict: true,
            mine: mine,
            theirs: their
        });
    }
    function insertLeading(hunk, insert, their) {
        while(insert.offset < their.offset && insert.index < insert.lines.length){
            var line = insert.lines[insert.index++];
            hunk.lines.push(line);
            insert.offset++;
        }
    }
    function insertTrailing(hunk, insert) {
        while(insert.index < insert.lines.length){
            var line = insert.lines[insert.index++];
            hunk.lines.push(line);
        }
    }
    function collectChange(state) {
        var ret = [], operation = state.lines[state.index][0];
        while(state.index < state.lines.length){
            var line = state.lines[state.index]; // Group additions that are immediately after subtractions and treat them as one "atomic" modify change.
            if (operation === "-" && line[0] === "+") operation = "+";
            if (operation === line[0]) {
                ret.push(line);
                state.index++;
            } else break;
        }
        return ret;
    }
    function collectContext(state, matchChanges) {
        var changes = [], merged = [], matchIndex = 0, contextChanges = false, conflicted = false;
        while(matchIndex < matchChanges.length && state.index < state.lines.length){
            var change = state.lines[state.index], match = matchChanges[matchIndex]; // Once we've hit our add, then we are done
            if (match[0] === "+") break;
            contextChanges = contextChanges || change[0] !== " ";
            merged.push(match);
            matchIndex++; // Consume any additions in the other block as a conflict to attempt
            // to pull in the remaining context after this
            if (change[0] === "+") {
                conflicted = true;
                while(change[0] === "+"){
                    changes.push(change);
                    change = state.lines[++state.index];
                }
            }
            if (match.substr(1) === change.substr(1)) {
                changes.push(change);
                state.index++;
            } else conflicted = true;
        }
        if ((matchChanges[matchIndex] || "")[0] === "+" && contextChanges) conflicted = true;
        if (conflicted) return changes;
        while(matchIndex < matchChanges.length)merged.push(matchChanges[matchIndex++]);
        return {
            merged: merged,
            changes: changes
        };
    }
    function allRemoves(changes) {
        return changes.reduce(function(prev, change) {
            return prev && change[0] === "-";
        }, true);
    }
    function skipRemoveSuperset(state, removeChanges, delta) {
        for(var i = 0; i < delta; i++){
            var changeContent = removeChanges[removeChanges.length - delta + i].substr(1);
            if (state.lines[state.index + i] !== " " + changeContent) return false;
        }
        state.index += delta;
        return true;
    }
    function calcOldNewLineCount(lines) {
        var oldLines = 0;
        var newLines = 0;
        lines.forEach(function(line) {
            if (typeof line !== "string") {
                var myCount = calcOldNewLineCount(line.mine);
                var theirCount = calcOldNewLineCount(line.theirs);
                if (oldLines !== undefined) {
                    if (myCount.oldLines === theirCount.oldLines) oldLines += myCount.oldLines;
                    else oldLines = undefined;
                }
                if (newLines !== undefined) {
                    if (myCount.newLines === theirCount.newLines) newLines += myCount.newLines;
                    else newLines = undefined;
                }
            } else {
                if (newLines !== undefined && (line[0] === "+" || line[0] === " ")) newLines++;
                if (oldLines !== undefined && (line[0] === "-" || line[0] === " ")) oldLines++;
            }
        });
        return {
            oldLines: oldLines,
            newLines: newLines
        };
    }
    function reversePatch(structuredPatch) {
        if (Array.isArray(structuredPatch)) return structuredPatch.map(reversePatch).reverse();
        return _objectSpread2(_objectSpread2({}, structuredPatch), {}, {
            oldFileName: structuredPatch.newFileName,
            oldHeader: structuredPatch.newHeader,
            newFileName: structuredPatch.oldFileName,
            newHeader: structuredPatch.oldHeader,
            hunks: structuredPatch.hunks.map(function(hunk) {
                return {
                    oldLines: hunk.newLines,
                    oldStart: hunk.newStart,
                    newLines: hunk.oldLines,
                    newStart: hunk.oldStart,
                    linedelimiters: hunk.linedelimiters,
                    lines: hunk.lines.map(function(l) {
                        if (l.startsWith("-")) return "+".concat(l.slice(1));
                        if (l.startsWith("+")) return "-".concat(l.slice(1));
                        return l;
                    })
                };
            })
        });
    }
    // See: http://code.google.com/p/google-diff-match-patch/wiki/API
    function convertChangesToDMP(changes) {
        var ret = [], change, operation;
        for(var i = 0; i < changes.length; i++){
            change = changes[i];
            if (change.added) operation = 1;
            else if (change.removed) operation = -1;
            else operation = 0;
            ret.push([
                operation,
                change.value
            ]);
        }
        return ret;
    }
    function convertChangesToXML(changes) {
        var ret = [];
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            if (change.added) ret.push("<ins>");
            else if (change.removed) ret.push("<del>");
            ret.push(escapeHTML(change.value));
            if (change.added) ret.push("</ins>");
            else if (change.removed) ret.push("</del>");
        }
        return ret.join("");
    }
    function escapeHTML(s) {
        var n = s;
        n = n.replace(/&/g, "&amp;");
        n = n.replace(/</g, "&lt;");
        n = n.replace(/>/g, "&gt;");
        n = n.replace(/"/g, "&quot;");
        return n;
    }
    exports1.Diff = Diff;
    exports1.applyPatch = applyPatch;
    exports1.applyPatches = applyPatches;
    exports1.canonicalize = canonicalize;
    exports1.convertChangesToDMP = convertChangesToDMP;
    exports1.convertChangesToXML = convertChangesToXML;
    exports1.createPatch = createPatch;
    exports1.createTwoFilesPatch = createTwoFilesPatch;
    exports1.diffArrays = diffArrays;
    exports1.diffChars = diffChars;
    exports1.diffCss = diffCss;
    exports1.diffJson = diffJson;
    exports1.diffLines = diffLines;
    exports1.diffSentences = diffSentences;
    exports1.diffTrimmedLines = diffTrimmedLines;
    exports1.diffWords = diffWords;
    exports1.diffWordsWithSpace = diffWordsWithSpace;
    exports1.formatPatch = formatPatch;
    exports1.merge = merge;
    exports1.parsePatch = parsePatch;
    exports1.reversePatch = reversePatch;
    exports1.structuredPatch = structuredPatch;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

},{}],"7OvfG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_ENTRY", ()=>GET_ENTRY);
parcelHelpers.export(exports, "EntryProvider", ()=>EntryProvider) // export function useEntry() {
 // 	const { collectionId, entryId, entry, tags, draft, setDraft } = useContext(EntryContext)
 // 	// const [editCollectionFields] = useMutation(EDIT_COLLECTION_FIELDS, {
 // 	// 	refetchQueries: [{ query: GET_COLLECTION, variables: { collectionId } }]
 // 	// })
 // 	// function updateField(fieldId, field) {
 // 	// 	return editCollectionFields({ 
 // 	// 		variables: {
 // 	// 			action: 'UPDATE',
 // 	// 			collectionId, 
 // 	// 			field,
 // 	// 			prevFieldId: fieldId
 // 	// 		}
 // 	// 	})
 // 	// }
 // 	// function deleteField(fieldId) {
 // 	// 	return editCollectionFields({ 
 // 	// 		variables: {
 // 	// 			action: 'REMOVE',
 // 	// 			collectionId, 
 // 	// 			field: { id: fieldId },
 // 	// 		}
 // 	// 	})
 // 	// }
 // 	return {
 // 		collectionId,
 // 		entryId,
 // 		entry,
 // 		tags,
 // 		draft,
 // 		setDraft,
 // 	}
 // }
;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _useImmer = require("use-immer");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
const GET_ENTRY = (0, _client.gql)`
	query GetEntry($collectionId:ID!, $entryId:ID!) {
		entry(collectionId:$collectionId, entryId:$entryId) {
			collectionId
			entryId
			values
		}
		tags(collectionId:$collectionId, entryId:$entryId) {
			id
			target
			value
			data
			created
			author {
				userId
				name
				emailHash
			}
		}				
	}
`;
const MAX_TITLE_LENTH = 128;
const EntryContext = /*#__PURE__*/ (0, _react.createContext)({});
exports.default = EntryContext;
function EntryProvider({ collectionId, entryId, children }) {
    const { loading, error, data } = (0, _client.useQuery)(GET_ENTRY, {
        variables: {
            collectionId,
            entryId
        }
    });
    const entry = data?.entry || null;
    const tags = data?.tags || [];
    const { collection } = (0, _useCollectionDefault.default)(collectionId);
    const [draft, setDraft] = (0, _useImmer.useImmer)(entry?.values || {});
    const title = (0, _react.useMemo)(()=>{
        let title = [];
        if (!!entry?.values) {
            if (!!collection.title) {
                for (let { fieldId } of collection.title)if (!!entry.values[fieldId]) title.push(`${entry.values[fieldId]}`.trim());
            }
            if (!title.length) {
                for (let fieldId of [
                    "title",
                    "name",
                    "label",
                    "uri",
                    "id"
                ])if (!!entry.values[fieldId]) {
                    title.push(`${entry.values[fieldId]}`.trim());
                    break;
                }
            }
        }
        title = title.join(" \xb7 ");
        if (title.length > MAX_TITLE_LENTH) title = title.slice(0, MAX_TITLE_LENTH).trim() + "\u2026";
        return !title.length ? entryId ?? "Entry" : title;
    }, [
        entryId,
        collection.title,
        entry?.values
    ]);
    const context = {
        collectionId,
        entryId,
        entry,
        tags,
        draft,
        setDraft,
        title
    };
    (0, _react.useEffect)(()=>{
        // console.log(entry?.values)
        if (!loading && !!entry?.values) setDraft(entry.values);
    }, [
        loading,
        entry
    ]);
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
        error: error
    });
    if (!entry) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(EntryContext.Provider, {
        value: context,
        children: children
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","use-immer":"cnEe2","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","../collections/useCollection":"hFA2a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f6GeO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EntryTasks);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _taskList = require("../tasks/TaskList");
var _taskListDefault = parcelHelpers.interopDefault(_taskList);
var _taskRun = require("../tasks/TaskRun");
var _taskRunDefault = parcelHelpers.interopDefault(_taskRun);
// import Task from '../tasks/Task'
var _entryContext = require("./EntryContext");
var _entryContextDefault = parcelHelpers.interopDefault(_entryContext);
function EntryTasks() {
    const [task, setTask] = (0, _react.useState)(null);
    const { entryId, setDraft } = (0, _react.useContext)((0, _entryContextDefault.default));
    function handleUpdate(values) {
        console.log(values);
        setDraft((draft)=>{
            for (const [fieldId, value] of Object.entries(values))draft[fieldId] = value;
        // console.log(fieldId, value)
        // draft.provider = 'dupa'
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                    children: "Note: Tasks are performed on saved values only. Save changes first to run tasks on them."
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _taskListDefault.default), {
                onSelect: (t)=>setTask(t),
                selected: task
            }),
            !!task && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _taskRunDefault.default), {
                    task: task,
                    entryId: entryId,
                    handleUpdate: handleUpdate
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../tasks/TaskList":"9mbab","../tasks/TaskRun":"kgt6R","./EntryContext":"7OvfG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9mbab":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LIST_TASKS", ()=>LIST_TASKS);
parcelHelpers.export(exports, "default", ()=>TaskList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _task = require("./Task");
var _taskDefault = parcelHelpers.interopDefault(_task);
var _taskEditor = require("./TaskEditor");
var _taskEditorDefault = parcelHelpers.interopDefault(_taskEditor);
const LIST_TASKS = (0, _client.gql)`
	query Tasks {
		tasks {
			taskId
			name
			type
			config
			modified
		}
	}`;
const CREATE_TASK = (0, _client.gql)`
	mutation CreateAITask($name: String!, $type: String!, $config: JSON!) {
		createTask(name: $name, type: $type, config: $config)
	}`;
function TaskList({ onSelect, selected }) {
    const [showCreate, setShowCreate] = (0, _react.useState)(false);
    const { loading, error, data } = (0, _client.useQuery)(LIST_TASKS);
    const [createTask, { loading: loadingCreate, error: createError }] = (0, _client.useMutation)(CREATE_TASK, {
        refetchQueries: [
            LIST_TASKS
        ]
    });
    const tasks = (0, _react.useMemo)(()=>{
        const tasks = data?.tasks || [];
        return !!selected ? tasks.filter((t)=>t.taskId === selected.taskId) : tasks;
    }, [
        data,
        selected
    ]);
    async function handleCreate(task) {
        await createTask({
            variables: task
        });
        setShowCreate(false);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "GridTable TaskList",
                children: tasks.map((task)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _taskDefault.default), {
                        task: task,
                        onSelect: onSelect,
                        isSelected: task.taskId === selected?.taskId
                    }, task.taskId))
            }),
            !showCreate && !selected && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>setShowCreate(true),
                children: "New Task"
            }),
            showCreate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _taskEditorDefault.default), {
                handleSave: handleCreate,
                onDiscard: ()=>setShowCreate(false)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: createError
            }),
            loadingCreate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","./Task":"2cXTS","./TaskEditor":"3BK1G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2cXTS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Task);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _jason = require("../utils/jason");
var _jasonDefault = parcelHelpers.interopDefault(_jason);
var _taskList = require("./TaskList");
var _taskRun = require("./TaskRun");
var _taskRunDefault = parcelHelpers.interopDefault(_taskRun);
var _taskEditor = require("./TaskEditor");
var _taskEditorDefault = parcelHelpers.interopDefault(_taskEditor);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
function Task({ task, onSelect, isSelected }) {
    const [showEdit, setShowEdit] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Task Item",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: isSelected ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>onSelect(null),
                            children: "Back"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>onSelect(task),
                            children: "Select"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                        children: task.type
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: task.name
                    }),
                    (0, _jasonDefault.default)(task.config, "config"),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>setShowEdit((p)=>!p),
                            children: "Edit"
                        })
                    })
                ]
            }),
            showEdit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "SubItem",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _taskEditorDefault.default), {
                    task: task,
                    onDiscard: ()=>setShowEdit(false),
                    onSave: ()=>setShowEdit(false)
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","../utils/jason":"dL3Qe","./TaskList":"9mbab","./TaskRun":"kgt6R","./TaskEditor":"3BK1G","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kgt6R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RUN_TASK", ()=>RUN_TASK);
parcelHelpers.export(exports, "default", ()=>TaskRun);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _client = require("@apollo/client");
var _useImmer = require("use-immer");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
// import jason from '../utils/jason'
var _entryChange = require("../entries/EntryChange");
var _entryChangeDefault = parcelHelpers.interopDefault(_entryChange);
const RUN_TASK = (0, _client.gql)`
	mutation RunTask($taskId:ID!, $collectionId:ID!, $entryId:ID!) {
		runTask(taskId:$taskId, collectionId:$collectionId, entryId:$entryId)
	}`;
function TaskRun({ task, entryId, onFinish = ()=>{}, handleUpdate = ()=>{}, bulkEntryStatus, noButton = false, isSaved }) {
    const { collection: { collectionId } } = (0, _useCollectionDefault.default)();
    const [runTask, { loading, error, data }] = (0, _client.useMutation)(RUN_TASK);
    // const payload = data?.runTask
    // const changes = payload?.changes || null
    function handleRun() {
        console.log("run task", task);
        runTask({
            variables: {
                taskId: task.taskId,
                collectionId,
                entryId
            }
        });
    }
    function handleSave() {
        if (!data?.runTask?.changes) return;
        handleUpdate(Object.fromEntries(Object.entries(data.runTask.changes).map(([key, change])=>[
                key,
                change[0]
            ])));
    }
    (0, _react.useEffect)(()=>{
        if (!!error) {
            onFinish({
                error
            });
            return;
        }
        if (!!data?.runTask) onFinish(data.runTask);
    }, [
        data,
        error
    ]);
    (0, _react.useEffect)(()=>{
        if (bulkEntryStatus === "LOADING" && !loading && !data) handleRun();
        else if (bulkEntryStatus === "SAVING" && !!data?.runTask?.changes) handleSave();
    }, [
        bulkEntryStatus,
        loading,
        data
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !noButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: handleRun,
                    disabled: loading,
                    className: "primary",
                    children: "Run task"
                })
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            !!data?.runTask && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TaskChanges, {
                changes: data.runTask.changes,
                isSaved: isSaved,
                handleSave: handleSave
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            })
        ]
    });
}
function TaskChanges({ changes, handleSave, isSaved = false }) {
    // const [usedKeys, setUsedKeys] = useImmer([])
    // function handleUse(key, change) {
    // 	handleUpdate({ [key]: change[ usedKeys.includes(key) ? 1 : 0 ] })
    // 	setUsedKeys(draft => {
    // 		if (draft.includes(key)) draft.splice(draft.indexOf(key), 1)
    // 			else draft.push(key)
    // 	})
    // }
    // function handleSave() {
    // 	handleUpdate(Object.fromEntries(Object.entries(changes).map(([key, change]) => [key, change[0]])))
    // }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "TaskChanges",
        children: [
            !changes && /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                children: "No changes."
            }),
            !!changes && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "TaskChangesList",
                        children: Object.entries(changes).map(([key, change])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entryChangeDefault.default), {
                                change: {
                                    key,
                                    old: change[1],
                                    new: change[0]
                                }
                            }, key))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleSave(),
                        children: isSaved ? "\u2705" : "Save"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../collections/useCollection":"hFA2a","@apollo/client":"bWmmR","use-immer":"cnEe2","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","../entries/EntryChange":"atBDa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3BK1G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_VALUES", ()=>DEFAULT_VALUES);
parcelHelpers.export(exports, "default", ()=>TaskEditor);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useImmer = require("use-immer");
var _client = require("@apollo/client");
var _tasksJs = require("./tasks.js");
var _tasksJsDefault = parcelHelpers.interopDefault(_tasksJs);
var _taskList = require("./TaskList");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
const TASK_TYPES = Object.keys((0, _tasksJsDefault.default));
const DEFAULT_VALUES = {
    id: null,
    type: TASK_TYPES[0],
    name: "Task",
    config: {}
};
const MODIFY_TASK = (0, _client.gql)`
	mutation ModifyTask($taskId:ID!, $name:String!, $type:String!, $config:JSON!) {
		modifyTask(taskId:$taskId, name:$name, type:$type, config:$config)
	}`;
const REMOVE_TASK = (0, _client.gql)`
	mutation RemoveTask($taskId:ID!) {
		removeTask(taskId:$taskId)
	}`;
function TaskEditor({ task = DEFAULT_VALUES, handleSave, onSave = ()=>{}, onDiscard = ()=>{} }) {
    const [name, setName] = (0, _react.useState)(task?.name || "Task");
    const [type, setType] = (0, _react.useState)(task?.type || TASK_TYPES[0]);
    const [config, setConfig] = (0, _useImmer.useImmer)(task?.config || {});
    const [modifyTask, { loading: loadingModify, error: modifyError }] = (0, _client.useMutation)(MODIFY_TASK, {
        refetchQueries: [
            (0, _taskList.LIST_TASKS)
        ]
    });
    // async function handleModify(draft) {
    // 	await modifyTask({ variables: { taskId: task.taskId, ...draft } })
    // 	setShowEdit(false)
    // }
    const [removeTask, { loading: loadingRemove, error: removeError }] = (0, _client.useMutation)(REMOVE_TASK, {
        refetchQueries: [
            (0, _taskList.LIST_TASKS)
        ]
    });
    function handleRemove() {
        if (!confirm("Are you sure you want to delete this task?")) return;
        removeTask({
            variables: {
                taskId: task.taskId
            }
        });
    }
    async function handleSubmit() {
        if (!!handleSave) return handleSave({
            name,
            type,
            config
        });
        await modifyTask({
            variables: {
                taskId: task.taskId,
                name,
                type,
                config
            }
        });
        onSave();
    }
    const TypeConfig = (0, _tasksJsDefault.default)[type];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "Form TaskEditor",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Name:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: name,
                        onChange: (e)=>setName(e.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Type:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        value: type,
                        onChange: (e)=>setType(e.target.value),
                        className: "w-fit",
                        children: TASK_TYPES.map((type)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: type,
                                children: type
                            }, type))
                    })
                ]
            }),
            !!TypeConfig && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TypeConfig, {
                config: config,
                setConfig: setConfig
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Submit",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "small delete",
                        onClick: handleRemove,
                        children: "Remove"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>onDiscard(),
                        children: "Discard"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "primary",
                        onClick: handleSubmit,
                        children: "Save"
                    }),
                    loadingModify && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
                    modifyError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                        error: modifyError
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","use-immer":"cnEe2","@apollo/client":"bWmmR","./tasks.js":"hQU9U","./TaskList":"9mbab","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hQU9U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extractFiles = require("./ExtractFiles");
var _extractFilesDefault = parcelHelpers.interopDefault(_extractFiles);
var _chatGPT = require("./ChatGPT");
var _chatGPTDefault = parcelHelpers.interopDefault(_chatGPT);
var _regexReplace = require("./RegexReplace");
var _regexReplaceDefault = parcelHelpers.interopDefault(_regexReplace);
var _moveValues = require("./MoveValues");
var _moveValuesDefault = parcelHelpers.interopDefault(_moveValues);
var _stripHTML = require("./StripHTML");
var _stripHTMLDefault = parcelHelpers.interopDefault(_stripHTML);
exports.default = {
    ExtractFiles: (0, _extractFilesDefault.default),
    ChatGPT: (0, _chatGPTDefault.default),
    RegexReplace: (0, _regexReplaceDefault.default),
    MoveValues: (0, _moveValuesDefault.default),
    StripHTML: (0, _stripHTMLDefault.default)
};

},{"./ExtractFiles":"sT1lU","./ChatGPT":"cBAK2","./RegexReplace":"eS7Ww","./MoveValues":"8adRv","./StripHTML":"c8iCY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"sT1lU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ExtractFiles);
var _jsxRuntime = require("react/jsx-runtime");
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
function ExtractFiles({ config, setConfig }) {
    const { collection: { fields } } = (0, _useCollectionDefault.default)();
    function toggleField(fieldId) {
        setConfig((config)=>{
            if (!config.fields) config.fields = [];
            if (config.fields.includes(fieldId)) config.fields.splice(config.fields.indexOf(fieldId), 1);
            else config.fields.push(fieldId);
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "This will search for urls to external files, download them to ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                        children: "Files"
                    }),
                    ", and replace the url with the new ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                        children: "Files"
                    }),
                    " path."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Target fields:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        children: fields.map(({ fieldId, config: { name } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "checkbox",
                                            checked: !!config.fields?.includes(fieldId),
                                            onChange: ()=>toggleField(fieldId)
                                        }),
                                        " ",
                                        name
                                    ]
                                })
                            }, fieldId))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Overwrite destination folder:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: config.destFolder,
                        onChange: (e)=>setConfig((c)=>{
                                c.destFolder = e.target.value;
                            }),
                        placeholder: "e.g. /article-images/"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","../collections/useCollection":"hFA2a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cBAK2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ChatGPT);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _entryContext = require("../entries/EntryContext");
var _entryContextDefault = parcelHelpers.interopDefault(_entryContext);
var _generateGPTPrompt = require("../../common/utils/generateGPTPrompt");
var _generateGPTPromptDefault = parcelHelpers.interopDefault(_generateGPTPrompt);
const GPT_MODELS = [
    "gpt-4-turbo-preview",
    "gpt-4",
    "gpt-4-1106-preview",
    "gpt-3.5-turbo-1106"
];
function ChatGPT({ config, setConfig }) {
    const { collection: { fields } } = (0, _useCollectionDefault.default)();
    const { draft } = (0, _react.useContext)((0, _entryContextDefault.default));
    const ioPrompt = (0, _generateGPTPromptDefault.default)(config, fields, draft);
    function toggleFields(which, id) {
        setConfig((d)=>{
            if (!d[which]) d[which] = [];
            if (d[which].includes(id)) d[which].splice(d[which].indexOf(id), 1);
            else d[which].push(id);
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Model:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                        value: config.model,
                        onChange: (e)=>setConfig((d)=>{
                                d.model = e.target.value;
                            }),
                        className: "w-fit",
                        children: GPT_MODELS.map((model)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: model,
                                children: model
                            }, model))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Instructions:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        value: config.instructions,
                        onChange: (e)=>setConfig((d)=>{
                                d.instructions = e.target.value;
                            }),
                        placeholder: "You are a helpful assistant..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Prompt:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        value: config.prompt,
                        onChange: (e)=>setConfig((d)=>{
                                d.prompt = e.target.value;
                            }),
                        rows: 10,
                        className: "w-100"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                className: "InOutFields",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Input fields:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                children: fields.map(({ fieldId, config: { name } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: !!config.input?.includes(fieldId),
                                                    onChange: ()=>toggleFields("input", fieldId)
                                                }),
                                                " ",
                                                name
                                            ]
                                        })
                                    }, fieldId))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Output fields:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                children: fields.map(({ fieldId, config: { name } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: !!config.output?.includes(fieldId),
                                                    onChange: ()=>toggleFields("output", fieldId)
                                                }),
                                                " ",
                                                name
                                            ]
                                        })
                                    }, fieldId))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("fieldset", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                            children: "Input/Output prompt"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                            className: "wrap",
                            children: ioPrompt.trim()
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../collections/useCollection":"hFA2a","../entries/EntryContext":"7OvfG","../../common/utils/generateGPTPrompt":"iQsyk","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iQsyk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>generateGPTPrompt);
function generateGPTPrompt(config, fields, values) {
    let prompt = `${config.prompt}`;
    if (config.input?.length > 0 && !!values && typeof values === "object") {
        prompt += `\n\nUse the information below to generate the answer:\n\n`;
        const inputValues = config.input.map((id)=>{
            const field = fields.find((f)=>f.fieldId === id);
            if (!field || !values[field.fieldId]) return "";
            return `${field.config?.name || field.fieldId}${!!field.config?.desc ? ` (${field.config?.desc})` : ""}:\n${values[field.fieldId]}\n`;
        });
        prompt += inputValues.join("\n");
    }
    if (config.output?.length > 0) {
        prompt += `\n\nReply in JSON object format with `;
        const outputFields = config.output.map((fieldId)=>{
            const field = fields.find((f)=>f.fieldId === fieldId);
            return !field ? "" : `"${field.config?.name || field.fieldId}" under the key "${field.fieldId}"`;
        });
        prompt += outputFields.join(", ") + ".";
    }
    return prompt;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eS7Ww":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RegexReplace);
var _jsxRuntime = require("react/jsx-runtime");
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
function RegexReplace({ config, setConfig }) {
    const { collection: { fields } } = (0, _useCollectionDefault.default)();
    function toggleField(fieldId) {
        setConfig((config)=>{
            if (!config.fields) config.fields = [];
            if (config.fields.includes(fieldId)) config.fields.splice(config.fields.indexOf(fieldId), 1);
            else config.fields.push(fieldId);
        });
    }
    function toggleFlag(flag) {
        setConfig((config)=>{
            if (!config.flags) config.flags = "";
            if (config.flags.includes(flag)) config.flags = config.flags.replace(flag, "");
            else config.flags += flag;
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Search and replace a string using regular expressions on a text type field."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Find and replace:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: "Regular expression:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                value: config.regex || "",
                                onChange: (e)=>setConfig((c)=>{
                                        c.regex = e.target.value;
                                    })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "checkbox",
                                        checked: !!config.flags?.includes("i"),
                                        onChange: ()=>toggleFlag("i")
                                    }),
                                    "i"
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "checkbox",
                                        checked: !!config.flags?.includes("g"),
                                        onChange: (e)=>toggleFlag("g")
                                    }),
                                    "g"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: "Replace:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                value: config.replace || "",
                                onChange: (e)=>setConfig((c)=>{
                                        c.replace = e.target.value;
                                    })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Target fields:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        children: fields.map(({ fieldId, config: { name } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "checkbox",
                                            checked: !!config.fields?.includes(fieldId),
                                            onChange: ()=>toggleField(fieldId)
                                        }),
                                        " ",
                                        name
                                    ]
                                })
                            }, fieldId))
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","../collections/useCollection":"hFA2a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8adRv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MoveValues);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
function MoveValues({ config, setConfig }) {
    // const { collection: { fields } } = useCollection()
    // const 
    // function toggleField(fieldId) {
    // 	setConfig(config => {
    // 		if (!config.fields) config.fields = []
    // 		if (config.fields.includes(fieldId)) {
    // 			config.fields.splice(config.fields.indexOf(fieldId), 1)
    // 		} else {
    // 			config.fields.push(fieldId)
    // 		}
    // 	})
    // }
    // function toggleFlag(flag) {
    // 	setConfig(config => {
    // 		if (!config.flags) config.flags = ''
    // 		if (config.flags.includes(flag)) config.flags = config.flags.replace(flag, '')
    // 			else config.flags += flag
    // 	})
    // }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Copy, move, and remove fields' values."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Actions:"
                    }),
                    Array.isArray(config.actions) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        children: config.actions.map((a, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>setConfig((d)=>{
                                                d.actions.splice(idx, 1);
                                            }),
                                        children: "x"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Action, {
                                        action: a,
                                        handleUpdate: (action)=>setConfig((d)=>{
                                                d.actions[idx] = action;
                                            })
                                    })
                                ]
                            }, `${a.command}-${a.fromFieldId}-${a.toFieldId}-${idx}`))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setConfig((d)=>{
                                if (!Array.isArray(d.actions)) d.actions = [];
                                d.actions.push({});
                            }),
                        children: "Add action"
                    })
                ]
            })
        ]
    });
}
const COMMANDS = [
    "copy",
    "move",
    "remove"
];
function Action({ action = {}, handleUpdate }) {
    const { collection: { fields } } = (0, _useCollectionDefault.default)();
    // const [command, setCommand] = useState(action.command || COMMANDS[0])
    // const [fromFieldId, setFromFieldId] = useState(action.fromFieldId || '')
    // const [toFieldId, setToFieldId] = useState(action.toFieldId || '')
    function setValue(key, value) {
        handleUpdate({
            ...action,
            [key]: value
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                value: action.command || "",
                onChange: (e)=>setValue("command", e.target.value),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                        value: ""
                    }),
                    COMMANDS.map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                            value: c,
                            children: c
                        }, c))
                ]
            }),
            "from",
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                value: action.fromFieldId || "",
                onChange: (e)=>setValue("fromFieldId", e.target.value),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                        value: ""
                    }),
                    fields.map(({ fieldId, type, config: { name } })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                            value: fieldId,
                            children: [
                                name,
                                " [",
                                type,
                                "]"
                            ]
                        }, fieldId))
                ]
            }),
            action.command !== "remove" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "to",
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                        value: action.toFieldId,
                        onChange: (e)=>setValue("toFieldId", e.target.value),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: ""
                            }),
                            fields.map(({ fieldId, type, config: { name } })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                                    value: fieldId,
                                    children: [
                                        name,
                                        " [",
                                        type,
                                        "]"
                                    ]
                                }, fieldId))
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../collections/useCollection":"hFA2a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c8iCY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditHTML);
var _jsxRuntime = require("react/jsx-runtime");
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
function EditHTML({ config, setConfig }) {
    const { collection: { fields } } = (0, _useCollectionDefault.default)();
    function toggleField(fieldId) {
        setConfig((config)=>{
            if (!config.fields) config.fields = [];
            if (config.fields.includes(fieldId)) config.fields.splice(config.fields.indexOf(fieldId), 1);
            else config.fields.push(fieldId);
        });
    }
    // function toggleFlag(flag) {
    // 	setConfig(config => {
    // 		if (!config.flags) config.flags = ''
    // 		if (config.flags.includes(flag)) config.flags = config.flags.replace(flag, '')
    // 			else config.flags += flag
    // 	})
    // }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Modify HTML code."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Target fields:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        children: fields.map(({ fieldId, config: { name } })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "checkbox",
                                            checked: !!config.fields?.includes(fieldId),
                                            onChange: ()=>toggleField(fieldId)
                                        }),
                                        " ",
                                        name
                                    ]
                                })
                            }, fieldId))
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","../collections/useCollection":"hFA2a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9Yfls":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getValuesDiff);
function getValuesDiff(prevObj, nextObj) {
    const changedValues = [];
    const allKeys = new Set([
        ...Object.keys(prevObj),
        ...Object.keys(nextObj)
    ]);
    for (const key of allKeys){
        const oldVal = prevObj[key] ?? null;
        const newVal = nextObj[key] ?? null;
        if (oldVal !== newVal) changedValues.push({
            key,
            old: oldVal,
            new: newVal
        });
    }
    return changedValues;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bXPDL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DetailsButton);
var _jsxRuntime = require("react/jsx-runtime");
function DetailsButton({ isOpen, toggle, children }) {
    function onClick(e) {
        e.preventDefault();
        toggle();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("details", {
        open: isOpen,
        onClick: onClick,
        className: "DetailsButton",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
            children: children
        })
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k7tVB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Field);
var _jsxRuntime = require("react/jsx-runtime");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _fieldLabel = require("./FieldLabel");
var _fieldLabelDefault = parcelHelpers.interopDefault(_fieldLabel);
var _idInputJsx = require("./IdInput.jsx");
var _idInputJsxDefault = parcelHelpers.interopDefault(_idInputJsx);
var _uriInputJsx = require("./UriInput.jsx");
var _uriInputJsxDefault = parcelHelpers.interopDefault(_uriInputJsx);
var _textInputJsx = require("./TextInput.jsx");
var _textInputJsxDefault = parcelHelpers.interopDefault(_textInputJsx);
var _htmlInputJsx = require("./HtmlInput.jsx");
var _htmlInputJsxDefault = parcelHelpers.interopDefault(_htmlInputJsx);
var _fileInputJsx = require("./FileInput.jsx");
var _fileInputJsxDefault = parcelHelpers.interopDefault(_fileInputJsx);
var _structInputJsx = require("./StructInput.jsx");
var _structInputJsxDefault = parcelHelpers.interopDefault(_structInputJsx);
var _jsonInputJsx = require("./JsonInput.jsx");
var _jsonInputJsxDefault = parcelHelpers.interopDefault(_jsonInputJsx);
var _numericInputJsx = require("./NumericInput.jsx");
var _numericInputJsxDefault = parcelHelpers.interopDefault(_numericInputJsx);
var _booleanInputJsx = require("./BooleanInput.jsx");
var _booleanInputJsxDefault = parcelHelpers.interopDefault(_booleanInputJsx);
var _modifiedInputJsx = require("./ModifiedInput.jsx");
var _modifiedInputJsxDefault = parcelHelpers.interopDefault(_modifiedInputJsx);
var _datetimeInputJsx = require("./DatetimeInput.jsx");
var _datetimeInputJsxDefault = parcelHelpers.interopDefault(_datetimeInputJsx);
var _referenceInputJsx = require("./ReferenceInput.jsx");
var _referenceInputJsxDefault = parcelHelpers.interopDefault(_referenceInputJsx);
const FIELD_TYPES_INPUTS = {
    ID: (0, _idInputJsxDefault.default),
    URI: (0, _uriInputJsxDefault.default),
    TEXT: (0, _textInputJsxDefault.default),
    JSON: (0, _jsonInputJsxDefault.default),
    HTML: (0, _htmlInputJsxDefault.default),
    FILE: (0, _fileInputJsxDefault.default),
    STRUCT: (0, _structInputJsxDefault.default),
    NUMERIC: (0, _numericInputJsxDefault.default),
    BOOLEAN: (0, _booleanInputJsxDefault.default),
    MODIFIED: (0, _modifiedInputJsxDefault.default),
    DATETIME: (0, _datetimeInputJsxDefault.default),
    REFERENCE: (0, _referenceInputJsxDefault.default)
};
function Field({ field, value, update }) {
    const InputComponent = FIELD_TYPES_INPUTS[field.type];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "Field",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldLabelDefault.default), {
                field: field,
                empty: !value
            }),
            !InputComponent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: `No input component for field type: ${field.type}`
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputComponent, {
                field: field,
                value: value,
                update: update
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","../utils/Alert":"5W3pt","./FieldLabel":"8cj5V","./IdInput.jsx":"k0IVg","./UriInput.jsx":"7Y6W5","./TextInput.jsx":"2H9YQ","./HtmlInput.jsx":"9MYzy","./FileInput.jsx":"kXYRz","./StructInput.jsx":"hWQoS","./JsonInput.jsx":"ktLRQ","./NumericInput.jsx":"ih3bY","./BooleanInput.jsx":"fmfrP","./ModifiedInput.jsx":"ak6Mz","./DatetimeInput.jsx":"4kKlY","./ReferenceInput.jsx":"8VoYn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8cj5V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FieldLabel);
var _jsxRuntime = require("react/jsx-runtime");
function FieldLabel({ field, empty = false }) {
    const { fieldId, config: { name, required, description } } = field;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "FieldLabel",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h4", {
                "data-title": `[${field.type}] ${fieldId}`,
                className: "tooltip",
                children: [
                    !name ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                        children: fieldId
                    }) : name,
                    ":"
                ]
            }),
            required && empty && /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                className: "required",
                children: "required"
            }),
            !!description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: description
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k0IVg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IdInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function IdInput({ field, value, update }) {
    const { config } = field;
    const [draft, setDraft] = (0, _react.useState)(value || "");
    const [badRegexp, setBadRegexp] = (0, _react.useState)(false);
    const placeholder = config.placeholder || config.regExp || "";
    const onChange = (0, _react.useCallback)((event)=>{
        let value = event.target.value;
        if (config.maxLength > 0) value = value.slice(0, config.maxLength);
        if (config.noNewline) value = value.replace(/\n\r?/g, "");
        if (config.regExp) {
            if (value === "") setBadRegexp(false);
            else {
                const re = new RegExp(config.regExp);
                setBadRegexp(!re.test(value));
            }
        }
        setDraft(value);
    }, [
        config,
        badRegexp
    ]);
    const onBlur = (0, _react.useCallback)(()=>{
        if (!!update) update(draft === "" ? null : draft);
    // if (config.regExp) {
    // 	const re = new RegExp(config.regExp)
    // 	setBadRegexp(!re.test(draft))
    // }
    }, [
        draft
    ]);
    (0, _react.useEffect)(()=>{
        if (value === draft) return;
        setDraft(value || "");
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "FieldInput IDinput",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "text",
                value: draft,
                onChange: onChange,
                onBlur: onBlur,
                maxLength: config.maxLength || null,
                placeholder: placeholder,
                style: {
                    maxWidth: !!config.maxLength ? `${config.maxLength + 1}em` : "auto"
                }
            }),
            badRegexp && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "InputInfo",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "warning",
                    children: [
                        "Must match: ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                            children: config.regExp
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Y6W5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UriInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function UriInput({ field, value, update }) {
    const [draft, setDraft] = (0, _react.useState)(value);
    // const [redirect, setRedirect] = useImmer({ fromUrl: null, toUrl: null, code: 301 })
    const prefix = field.config.prefix || "";
    // const { data, loading: loadingRedirects, error: redirectsError } = useQuery(LIST_REDIRECTS, {
    // 	variables: { toUrl: `${prefix}${value}` }
    // })
    // const [addRedirect, { loading: loadingAddRedirect, error: addRedirectError }] = useMutation(ADD_REDIRECT, {
    // 	refetchQueries: [{ query: LIST_REDIRECTS, variables: { toUrl: `${prefix}${value}` } }]
    // })
    function handleBlur() {
        // if (!!value && draft !== value)
        // 	setRedirect({ fromUrl:`${prefix}${value}`, toUrl: `${prefix}${draft}`, code: 301 })
        update(draft);
    }
    // async function handleAddRedirect() {
    // 	await addRedirect({ variables: { fromUrl: redirect.fromUrl, toUrl: redirect.toUrl, code: redirect.code } })
    // 	setRedirect({ fromUrl: null, toUrl: null, code: 301 })
    // }
    (0, _react.useEffect)(()=>{
        setDraft(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "FieldInput URIinput",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "input fixWrap",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "prefix",
                        children: [
                            "/",
                            field?.config?.prefix || ""
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: draft ?? "",
                        onChange: (e)=>setDraft(e.target.value),
                        onBlur: handleBlur
                    })
                ]
            })
        })
    });
} // function RedirectsList({ toUrl }) {
 // 	const { data, loading, error } = useQuery(LIST_REDIRECTS, {
 // 		variables: { toUrl }
 // 	})
 // 	if (!!error) return <Alert error={error} />
 // 	if (!data?.redirects?.length) return null
 // 	return <details>
 // 		<summary><Icon i='redirect' /> Redirects ({data.redirects.length})</summary>
 // 		<div className='GridTable RedirectsList'>
 // 			{ data.redirects.map(r => 
 // 				<Redirect key={r.redirectId} redirect={r} noDest />
 // 			) }
 // 		</div>
 // 	</details>
 // }

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2H9YQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _multiField = require("./MultiField");
var _multiFieldDefault = parcelHelpers.interopDefault(_multiField);
function TextInputSingle({ field, value, update }) {
    const { config } = field;
    const [draft, setDraft] = (0, _react.useState)(value || "");
    // const [badRegexp, setBadRegexp] = useState(false)
    // const placeholder = config.placeholder || config.regExp || ''
    const onChange = (0, _react.useCallback)((event)=>{
        let value = event.target.value;
        // if (config.maxLength > 0) value = value.slice(0, config.maxLength)
        // if (config.noNewline) value = value.replace(/\n\r?/g, '')
        // if (config.regExp) {
        // 	if (value === '') {
        // 		setBadRegexp(false)
        // 	} else {
        // 		const re = new RegExp(config.regExp)
        // 		setBadRegexp(!re.test(value))
        // 	}
        // }
        setDraft(value);
    }, [
        config
    ]);
    const onBlur = (0, _react.useCallback)(()=>{
        if (!!update) update(draft === "" ? null : draft);
    // if (config.regExp) {
    // 	const re = new RegExp(config.regExp)
    // 	setBadRegexp(!re.test(draft))
    // }
    }, [
        draft
    ]);
    (0, _react.useEffect)(()=>{
        if (value === draft) return;
        setDraft(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "FieldInput TEXTinput",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
            value: draft || "",
            onChange: onChange,
            onBlur: onBlur,
            className: "input"
        })
    });
}
function TextInput({ field, value, update }) {
    return !field.config?.multi ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextInputSingle, {
        field: field,
        value: value,
        update: update
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiFieldDefault.default), {
        field: field,
        value: value,
        update: update,
        InputComponent: TextInputSingle
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./MultiField":"f37Be","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f37Be":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultiField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _immer = require("immer");
var _reactEasySort = require("react-easy-sort");
var _reactEasySortDefault = parcelHelpers.interopDefault(_reactEasySort);
var _arrayMove = require("array-move");
function MultiField({ field, value, update, InputComponent }) {
    function handleAdd() {
        update((0, _immer.produce)(value, (draft)=>{
            if (!Array.isArray(draft)) return [
                null
            ];
            draft.push(null);
        }));
    }
    function handleRemove(idx) {
        update((0, _immer.produce)(value, (draft)=>{
            draft.splice(idx, 1);
        }));
    }
    // const items = useMemo(() => {
    // 	if (!Array.isArray(value)) return []
    // 	const keyFreshness = Date.now()
    // 	return value.map((val, idx) => (
    // 		<div key={`${idx}-${keyFreshness}`}>
    // 			{ cloneElement(children, { 
    // 					field, 
    // 					value: val,
    // 					update: val => update(produce(value, draft => { draft.splice(idx, 1, val) }))
    // 				})
    // 			}
    // 			<button onClick={() => handleRemove(idx)}>x</button>
    // 		</div>
    // 	))
    // }, [field, value, children])
    function handleSortEnd(oldIndex, newIndex) {
        const newOrder = (0, _arrayMove.arrayMoveImmutable)(value, oldIndex, newIndex);
        update(newOrder);
    }
    // const handleSelect = useCallback((entryId, add = true) => {
    // 	const value = produce(selected, draft => {
    // 		const idx = draft.indexOf(entryId)
    // 		if (add && idx === -1) {
    // 			draft.push(entryId)
    // 		} else if (idx > -1) draft.splice(idx, 1)
    // 	})
    // 	if (value.length === 0) return update(null)
    // 	if (!field.multi) {
    // 		update(value[0])
    // 		setShowPicker(false)
    // 		return
    // 	}
    // 	update(value)
    // }, [selected])
    // const handleReorder = useCallback(entryIds => {
    // 	update(entryIds)
    // }, [])
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            Array.isArray(value) && value.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySortDefault.default), {
                className: "MultiFieldSortableList",
                draggedItemClassName: "dragged",
                onSortEnd: handleSortEnd,
                children: value.map((val, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySort.SortableItem), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "SortableItem",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySort.SortableKnob), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        children: "\u2195\uFE0F"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputComponent, {
                                    field: field,
                                    value: val,
                                    update: (newValue)=>update((0, _immer.produce)(value, (draft)=>{
                                            draft.splice(idx, 1, newValue);
                                        }))
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>handleRemove(idx),
                                    children: "x"
                                })
                            ]
                        })
                    }, `${idx}-${Date.now()}`))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: handleAdd,
                children: "Add item"
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","immer":"eUR2H","react-easy-sort":"iVlh1","array-move":"iaig5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9MYzy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HtmlInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _htmlReactParser = require("html-react-parser");
var _htmlReactParserDefault = parcelHelpers.interopDefault(_htmlReactParser);
var _multiInput = require("./MultiInput");
var _multiInputDefault = parcelHelpers.interopDefault(_multiInput);
var _icon = require("../utils/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function HtmlInputSingle({ field, value, update }) {
    const [draft, setDraft] = (0, _react.useState)(value);
    const [showOutput, setShowOutput] = (0, _react.useState)(false);
    // const [showFullscreen, setShowFullscreen] = useState(false)
    const onChange = (0, _react.useCallback)((event)=>{
        let value = event.target.value;
        setDraft(value);
    }, [
        field
    ]);
    const onBlur = (0, _react.useCallback)(()=>{
        update(draft === "" ? null : draft);
    }, [
        draft
    ]);
    (0, _react.useEffect)(()=>{
        if (value !== draft) setDraft(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "FieldInput HTMLinput",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "input",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        value: draft || "",
                        onChange: onChange,
                        onBlur: onBlur,
                        rows: 12
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("details", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                        children: "HTML tags guide"
                                    })
                                })
                            }),
                            "Example image tag:",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: '<img src="/path/to/image.jpg" alt="Image description" class="left small" />'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            "The  ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "class"
                            }),
                            " attribute can have ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "left"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "right"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "center"
                            }),
                            ", and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "stretch"
                            }),
                            " for positioning, and ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "small"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "medium"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                                children: "large"
                            }),
                            ", for size.",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                        ]
                    })
                ]
            }),
            showOutput && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "HTMLinputOutput",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(HtmlRenderer, {
                    htmlString: draft
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "HTMLinputButtons",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: ()=>setShowOutput((v)=>!v),
                    className: (0, _classnamesDefault.default)({
                        primary: showOutput
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        i: "html"
                    })
                })
            })
        ]
    });
}
function HtmlInput({ field, value, update }) {
    return !field.multi ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(HtmlInputSingle, {
        field: field,
        value: value,
        update: update
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiInputDefault.default), {
        field: field,
        value: value,
        update: update,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(HtmlInputSingle, {})
    });
}
function HtmlRenderer({ htmlString }) {
    const parserOptions = {
        replace: (node)=>{
            if (node.name === "img") {
                const attrs = {
                    ...(0, _htmlReactParser.attributesToProps)(node.attribs),
                    src: `${"http://cms.pp.content.catering"}/files${node.attribs.src}`
                };
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    ...attrs
                });
            }
        }
    };
    return (0, _htmlReactParserDefault.default)(htmlString, parserOptions);
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","classnames":"hVGzI","html-react-parser":"gFznZ","./MultiInput":"4aMA6","../utils/Icon":"fAdkP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gFznZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Comment", ()=>(0, _indexJs.Comment));
parcelHelpers.export(exports, "Element", ()=>(0, _indexJs.Element));
parcelHelpers.export(exports, "ProcessingInstruction", ()=>(0, _indexJs.ProcessingInstruction));
parcelHelpers.export(exports, "Text", ()=>(0, _indexJs.Text));
parcelHelpers.export(exports, "attributesToProps", ()=>(0, _indexJs.attributesToProps));
parcelHelpers.export(exports, "domToReact", ()=>(0, _indexJs.domToReact));
parcelHelpers.export(exports, "htmlToDOM", ()=>(0, _indexJs.htmlToDOM));
var _indexJs = require("../lib/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).default || (0, _indexJsDefault.default);

},{"../lib/index.js":"3TwtF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3TwtF":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.htmlToDOM = exports.domToReact = exports.attributesToProps = exports.Text = exports.ProcessingInstruction = exports.Element = exports.Comment = void 0;
var html_dom_parser_1 = __importDefault(require("c58c1da32ddd0ed2"));
exports.htmlToDOM = html_dom_parser_1.default;
var attributes_to_props_1 = __importDefault(require("e947334d858ca0c8"));
exports.attributesToProps = attributes_to_props_1.default;
var dom_to_react_1 = __importDefault(require("7b5511921c5335a3"));
exports.domToReact = dom_to_react_1.default;
var domhandler_1 = require("f45776fba4237e44");
Object.defineProperty(exports, "Comment", {
    enumerable: true,
    get: function() {
        return domhandler_1.Comment;
    }
});
Object.defineProperty(exports, "Element", {
    enumerable: true,
    get: function() {
        return domhandler_1.Element;
    }
});
Object.defineProperty(exports, "ProcessingInstruction", {
    enumerable: true,
    get: function() {
        return domhandler_1.ProcessingInstruction;
    }
});
Object.defineProperty(exports, "Text", {
    enumerable: true,
    get: function() {
        return domhandler_1.Text;
    }
});
var domParserOptions = {
    lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param html - HTML string.
 * @param options - Parser options.
 * @returns - React element(s), empty array, or string.
 */ function HTMLReactParser(html, options) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (!html) return [];
    return (0, dom_to_react_1.default)((0, html_dom_parser_1.default)(html, (options === null || options === void 0 ? void 0 : options.htmlparser2) || domParserOptions), options);
}
exports.default = HTMLReactParser;

},{"c58c1da32ddd0ed2":"5Biuo","e947334d858ca0c8":"9FB39","7b5511921c5335a3":"jjpLC","f45776fba4237e44":"jJGos"}],"5Biuo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _htmlToDomJs = require("../../lib/client/html-to-dom.js");
var _htmlToDomJsDefault = parcelHelpers.interopDefault(_htmlToDomJs);
exports.default = (0, _htmlToDomJsDefault.default).default || (0, _htmlToDomJsDefault.default);

},{"../../lib/client/html-to-dom.js":"9hAKe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9hAKe":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var domparser_1 = __importDefault(require("2ab0d8e23d23421a"));
var utilities_1 = require("28c5533ea5609ec5");
var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param html - HTML markup.
 * @returns - DOM elements.
 */ function HTMLDOMParser(html) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (!html) return [];
    // match directive
    var match = html.match(DIRECTIVE_REGEX);
    var directive = match ? match[1] : undefined;
    return (0, utilities_1.formatDOM)((0, domparser_1.default)(html), null, directive);
}
exports.default = HTMLDOMParser;

},{"2ab0d8e23d23421a":"4Pb1p","28c5533ea5609ec5":"cKwkx"}],"4Pb1p":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// constants
var HTML = "html";
var HEAD = "head";
var BODY = "body";
var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// match-all-characters in case of newlines (DOTALL)
var HEAD_TAG_REGEX = /<head[^]*>/i;
var BODY_TAG_REGEX = /<body[^]*>/i;
// falls back to `parseFromString` if `createHTMLDocument` cannot be used
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var parseFromDocument = function(html, tagName) {
    /* istanbul ignore next */ throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var parseFromString = function(html, tagName) {
    /* istanbul ignore next */ throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
};
var DOMParser = typeof window === "object" && window.DOMParser;
/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */ if (typeof DOMParser === "function") {
    var domParser_1 = new DOMParser();
    var mimeType_1 = "text/html";
    /**
     * Creates an HTML document using `DOMParser.parseFromString`.
     *
     * @param html - The HTML string.
     * @param tagName - The element to render the HTML (with 'body' as fallback).
     * @returns - Document.
     */ parseFromString = function(html, tagName) {
        if (tagName) /* istanbul ignore next */ html = "<".concat(tagName, ">").concat(html, "</").concat(tagName, ">");
        return domParser_1.parseFromString(html, mimeType_1);
    };
    parseFromDocument = parseFromString;
}
/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */ if (typeof document === "object" && document.implementation) {
    var htmlDocument_1 = document.implementation.createHTMLDocument();
    /**
     * Use HTML document created by `document.implementation.createHTMLDocument`.
     *
     * @param html - The HTML string.
     * @param tagName - The element to render the HTML (with 'body' as fallback).
     * @returns - Document
     */ parseFromDocument = function(html, tagName) {
        if (tagName) {
            var element = htmlDocument_1.documentElement.querySelector(tagName);
            if (element) element.innerHTML = html;
            return htmlDocument_1;
        }
        htmlDocument_1.documentElement.innerHTML = html;
        return htmlDocument_1;
    };
}
/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */ var template = typeof document === "object" && document.createElement("template");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var parseFromTemplate;
if (template && template.content) /**
     * Uses a template element (content fragment) to parse HTML.
     *
     * @param html - HTML string.
     * @returns - Nodes.
     */ parseFromTemplate = function(html) {
    template.innerHTML = html;
    return template.content.childNodes;
};
/**
 * Parses HTML string to DOM nodes.
 *
 * @param html - HTML markup.
 * @returns - DOM nodes.
 */ function domparser(html) {
    var _a, _b;
    var match = html.match(FIRST_TAG_REGEX);
    var firstTagName = match && match[1] ? match[1].toLowerCase() : "";
    switch(firstTagName){
        case HTML:
            var doc = parseFromString(html);
            // the created document may come with filler head/body elements,
            // so make sure to remove them if they don't actually exist
            if (!HEAD_TAG_REGEX.test(html)) {
                var element = doc.querySelector(HEAD);
                (_a = element === null || element === void 0 ? void 0 : element.parentNode) === null || _a === void 0 || _a.removeChild(element);
            }
            if (!BODY_TAG_REGEX.test(html)) {
                var element = doc.querySelector(BODY);
                (_b = element === null || element === void 0 ? void 0 : element.parentNode) === null || _b === void 0 || _b.removeChild(element);
            }
            return doc.querySelectorAll(HTML);
        case HEAD:
        case BODY:
            var elements = parseFromDocument(html).querySelectorAll(firstTagName);
            // if there's a sibling element, then return both elements
            if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) return elements[0].parentNode.childNodes;
            return elements;
        // low-level tag or text
        default:
            if (parseFromTemplate) return parseFromTemplate(html);
            var element = parseFromDocument(html, BODY).querySelector(BODY);
            return element.childNodes;
    }
}
exports.default = domparser;

},{}],"cKwkx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatDOM = exports.formatAttributes = void 0;
var domhandler_1 = require("9fa8a6b30c516006");
var constants_1 = require("6be3bf5fd67cd884");
/**
 * Gets case-sensitive tag name.
 *
 * @param tagName - Tag name in lowercase.
 * @returns - Case-sensitive tag name.
 */ function getCaseSensitiveTagName(tagName) {
    return constants_1.CASE_SENSITIVE_TAG_NAMES_MAP[tagName];
}
/**
 * Formats DOM attributes to a hash map.
 *
 * @param attributes - List of attributes.
 * @returns - Map of attribute name to value.
 */ function formatAttributes(attributes) {
    var map = {};
    var index = 0;
    var attributesLength = attributes.length;
    // `NamedNodeMap` is array-like
    for(; index < attributesLength; index++){
        var attribute = attributes[index];
        map[attribute.name] = attribute.value;
    }
    return map;
}
exports.formatAttributes = formatAttributes;
/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param tagName - Lowercase tag name.
 * @returns - Formatted tag name.
 */ function formatTagName(tagName) {
    tagName = tagName.toLowerCase();
    var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
    if (caseSensitiveTagName) return caseSensitiveTagName;
    return tagName;
}
/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param nodes - DOM nodes.
 * @param parent - Parent node.
 * @param directive - Directive.
 * @returns - Nodes.
 */ function formatDOM(nodes, parent, directive) {
    if (parent === void 0) parent = null;
    var domNodes = [];
    var current;
    var index = 0;
    var nodesLength = nodes.length;
    for(; index < nodesLength; index++){
        var node = nodes[index];
        // set the node data given the type
        switch(node.nodeType){
            case 1:
                var tagName = formatTagName(node.nodeName);
                // script, style, or tag
                current = new domhandler_1.Element(tagName, formatAttributes(node.attributes));
                current.children = formatDOM(// template children are on content
                tagName === "template" ? node.content.childNodes : node.childNodes, current);
                break;
            case 3:
                current = new domhandler_1.Text(node.nodeValue);
                break;
            case 8:
                current = new domhandler_1.Comment(node.nodeValue);
                break;
            default:
                continue;
        }
        // set previous node next
        var prev = domNodes[index - 1] || null;
        if (prev) prev.next = current;
        // set properties for current node
        current.parent = parent;
        current.prev = prev;
        current.next = null;
        domNodes.push(current);
    }
    if (directive) {
        current = new domhandler_1.ProcessingInstruction(directive.substring(0, directive.indexOf(" ")).toLowerCase(), directive);
        current.next = domNodes[0] || null;
        current.parent = parent;
        domNodes.unshift(current);
        if (domNodes[1]) domNodes[1].prev = domNodes[0];
    }
    return domNodes;
}
exports.formatDOM = formatDOM;

},{"9fa8a6b30c516006":"jJGos","6be3bf5fd67cd884":"gYJLB"}],"jJGos":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DomHandler", ()=>DomHandler);
var _domelementtype = require("domelementtype");
var _nodeJs = require("./node.js");
parcelHelpers.exportAll(_nodeJs, exports);
// Default options
const defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class DomHandler {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, _nodeJs.Document)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, _nodeJs.Document)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, _domelementtype.ElementType).Tag : undefined;
        const element = new (0, _nodeJs.Element)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode } = this;
        if (lastNode && lastNode.type === (0, _domelementtype.ElementType).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, _nodeJs.Text)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, _domelementtype.ElementType).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, _nodeJs.Comment)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, _nodeJs.Text)("");
        const node = new (0, _nodeJs.CDATA)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, _nodeJs.ProcessingInstruction)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
exports.default = DomHandler;

},{"domelementtype":"ezor8","./node.js":"49kuc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ezor8":[function(require,module,exports) {
/** Types of elements found in htmlparser2's DOM */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ElementType", ()=>ElementType);
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */ parcelHelpers.export(exports, "isTag", ()=>isTag);
parcelHelpers.export(exports, "Root", ()=>Root);
parcelHelpers.export(exports, "Text", ()=>Text);
parcelHelpers.export(exports, "Directive", ()=>Directive);
parcelHelpers.export(exports, "Comment", ()=>Comment);
parcelHelpers.export(exports, "Script", ()=>Script);
parcelHelpers.export(exports, "Style", ()=>Style);
parcelHelpers.export(exports, "Tag", ()=>Tag);
parcelHelpers.export(exports, "CDATA", ()=>CDATA);
parcelHelpers.export(exports, "Doctype", ()=>Doctype);
var ElementType;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})(ElementType || (ElementType = {}));
function isTag(elem) {
    return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
}
const Root = ElementType.Root;
const Text = ElementType.Text;
const Directive = ElementType.Directive;
const Comment = ElementType.Comment;
const Script = ElementType.Script;
const Style = ElementType.Style;
const Tag = ElementType.Tag;
const CDATA = ElementType.CDATA;
const Doctype = ElementType.Doctype;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"49kuc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */ parcelHelpers.export(exports, "Node", ()=>Node);
/**
 * A node that contains some data.
 */ parcelHelpers.export(exports, "DataNode", ()=>DataNode);
/**
 * Text within the document.
 */ parcelHelpers.export(exports, "Text", ()=>Text);
/**
 * Comments within the document.
 */ parcelHelpers.export(exports, "Comment", ()=>Comment);
/**
 * Processing instructions, including doc types.
 */ parcelHelpers.export(exports, "ProcessingInstruction", ()=>ProcessingInstruction);
/**
 * A `Node` that can have children.
 */ parcelHelpers.export(exports, "NodeWithChildren", ()=>NodeWithChildren);
parcelHelpers.export(exports, "CDATA", ()=>CDATA);
/**
 * The root node of the document.
 */ parcelHelpers.export(exports, "Document", ()=>Document);
/**
 * An element within the DOM.
 */ parcelHelpers.export(exports, "Element", ()=>Element);
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */ parcelHelpers.export(exports, "isTag", ()=>isTag);
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */ parcelHelpers.export(exports, "isCDATA", ()=>isCDATA);
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */ parcelHelpers.export(exports, "isText", ()=>isText);
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */ parcelHelpers.export(exports, "isComment", ()=>isComment);
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ parcelHelpers.export(exports, "isDirective", ()=>isDirective);
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ parcelHelpers.export(exports, "isDocument", ()=>isDocument);
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */ parcelHelpers.export(exports, "hasChildren", ()=>hasChildren);
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */ parcelHelpers.export(exports, "cloneNode", ()=>cloneNode);
var _domelementtype = require("domelementtype");
class Node {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return cloneNode(this, recursive);
    }
}
class DataNode extends Node {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class Text extends DataNode {
    constructor(){
        super(...arguments);
        this.type = (0, _domelementtype.ElementType).Text;
    }
    get nodeType() {
        return 3;
    }
}
class Comment extends DataNode {
    constructor(){
        super(...arguments);
        this.type = (0, _domelementtype.ElementType).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class ProcessingInstruction extends DataNode {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, _domelementtype.ElementType).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class NodeWithChildren extends Node {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class CDATA extends NodeWithChildren {
    constructor(){
        super(...arguments);
        this.type = (0, _domelementtype.ElementType).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class Document extends NodeWithChildren {
    constructor(){
        super(...arguments);
        this.type = (0, _domelementtype.ElementType).Root;
    }
    get nodeType() {
        return 9;
    }
}
class Element extends NodeWithChildren {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, _domelementtype.ElementType).Script : name === "style" ? (0, _domelementtype.ElementType).Style : (0, _domelementtype.ElementType).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function isTag(node) {
    return (0, _domelementtype.isTag)(node);
}
function isCDATA(node) {
    return node.type === (0, _domelementtype.ElementType).CDATA;
}
function isText(node) {
    return node.type === (0, _domelementtype.ElementType).Text;
}
function isComment(node) {
    return node.type === (0, _domelementtype.ElementType).Comment;
}
function isDirective(node) {
    return node.type === (0, _domelementtype.ElementType).Directive;
}
function isDocument(node) {
    return node.type === (0, _domelementtype.ElementType).Root;
}
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function cloneNode(node, recursive = false) {
    let result;
    if (isText(node)) result = new Text(node.data);
    else if (isComment(node)) result = new Comment(node.data);
    else if (isTag(node)) {
        const children = recursive ? cloneChildren(node.children) : [];
        const clone = new Element(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if (isCDATA(node)) {
        const children = recursive ? cloneChildren(node.children) : [];
        const clone = new CDATA(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if (isDocument(node)) {
        const children = recursive ? cloneChildren(node.children) : [];
        const clone = new Document(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if (isDirective(node)) {
        const instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function cloneChildren(childs) {
    const children = childs.map((child)=>cloneNode(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

},{"domelementtype":"ezor8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gYJLB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CASE_SENSITIVE_TAG_NAMES_MAP = exports.CASE_SENSITIVE_TAG_NAMES = void 0;
/**
 * SVG elements are case-sensitive.
 *
 * @see https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z
 */ exports.CASE_SENSITIVE_TAG_NAMES = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
];
exports.CASE_SENSITIVE_TAG_NAMES_MAP = exports.CASE_SENSITIVE_TAG_NAMES.reduce(function(accumulator, tagName) {
    accumulator[tagName.toLowerCase()] = tagName;
    return accumulator;
}, {});

},{}],"9FB39":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var react_property_1 = require("f48322aabde4e7b1");
var utilities_1 = require("9f0d281674b3b603");
// https://react.dev/learn/sharing-state-between-components#controlled-and-uncontrolled-components
// https://developer.mozilla.org/docs/Web/HTML/Attributes
var UNCONTROLLED_COMPONENT_ATTRIBUTES = [
    "checked",
    "value"
];
var UNCONTROLLED_COMPONENT_NAMES = [
    "input",
    "select",
    "textarea"
];
var valueOnlyInputs = {
    reset: true,
    submit: true
};
/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param attributes - HTML/SVG DOM attributes.
 * @param nodeName - DOM node name.
 * @returns - React props.
 */ function attributesToProps(attributes, nodeName) {
    if (attributes === void 0) attributes = {};
    var props = {};
    var isInputValueOnly = Boolean(attributes.type && valueOnlyInputs[attributes.type]);
    for(var attributeName in attributes){
        var attributeValue = attributes[attributeName];
        // ARIA (aria-*) or custom data (data-*) attribute
        if ((0, react_property_1.isCustomAttribute)(attributeName)) {
            props[attributeName] = attributeValue;
            continue;
        }
        // convert HTML/SVG attribute to React prop
        var attributeNameLowerCased = attributeName.toLowerCase();
        var propName = getPropName(attributeNameLowerCased);
        if (propName) {
            var propertyInfo = (0, react_property_1.getPropertyInfo)(propName);
            // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
            if (UNCONTROLLED_COMPONENT_ATTRIBUTES.includes(propName) && UNCONTROLLED_COMPONENT_NAMES.includes(nodeName) && !isInputValueOnly) propName = getPropName("default" + attributeNameLowerCased);
            props[propName] = attributeValue;
            switch(propertyInfo && propertyInfo.type){
                case react_property_1.BOOLEAN:
                    props[propName] = true;
                    break;
                case react_property_1.OVERLOADED_BOOLEAN:
                    if (attributeValue === "") props[propName] = true;
                    break;
            }
            continue;
        }
        // preserve custom attribute if React >=16
        if (utilities_1.PRESERVE_CUSTOM_ATTRIBUTES) props[attributeName] = attributeValue;
    }
    // transform inline style to object
    (0, utilities_1.setStyleProp)(attributes.style, props);
    return props;
}
exports.default = attributesToProps;
/**
 * Gets prop name from lowercased attribute name.
 *
 * @param attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */ function getPropName(attributeName) {
    return react_property_1.possibleStandardNames[attributeName];
}

},{"f48322aabde4e7b1":"cUQ7D","9f0d281674b3b603":"hsuSw"}],"cUQ7D":[function(require,module,exports) {
"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
const RESERVED = 0;
// A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.
const STRING = 1;
// A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.
const BOOLEANISH_STRING = 2;
// A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
const BOOLEAN = 3;
// An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.
const OVERLOADED_BOOLEAN = 4;
// An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.
const NUMERIC = 5;
// An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.
const POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
    return properties.hasOwnProperty(name) ? properties[name] : null;
}
function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
    this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
    this.attributeName = attributeName;
    this.attributeNamespace = attributeNamespace;
    this.mustUseProperty = mustUseProperty;
    this.propertyName = name;
    this.type = type;
    this.sanitizeURL = sanitizeURL;
    this.removeEmptyString = removeEmptyString;
}
// When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.
const properties = {};
// These props are reserved by React. They shouldn't be written to the DOM.
const reservedProps = [
    "children",
    "dangerouslySetInnerHTML",
    // TODO: This prevents the assignment of defaultValue to regular
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    "defaultValue",
    "defaultChecked",
    "innerHTML",
    "suppressContentEditableWarning",
    "suppressHydrationWarning",
    "style"
];
reservedProps.forEach((name)=>{
    properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
});
// A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(([name, attributeName])=>{
    properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
});
// These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach((name)=>{
    properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
});
// These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach((name)=>{
    properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
});
// These are HTML boolean attributes.
[
    "allowFullScreen",
    "async",
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus",
    "autoPlay",
    "controls",
    "default",
    "defer",
    "disabled",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "formNoValidate",
    "hidden",
    "loop",
    "noModule",
    "noValidate",
    "open",
    "playsInline",
    "readOnly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    // Microdata
    "itemScope"
].forEach((name)=>{
    properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
});
// These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.
[
    "checked",
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple",
    "muted",
    "selected"
].forEach((name)=>{
    properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
});
// These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.
[
    "capture",
    "download"
].forEach((name)=>{
    properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
});
// These are HTML attributes that must be positive numbers.
[
    "cols",
    "rows",
    "size",
    "span"
].forEach((name)=>{
    properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
});
// These are HTML attributes that must be numbers.
[
    "rowSpan",
    "start"
].forEach((name)=>{
    properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
});
const CAMELIZE = /[\-\:]([a-z])/g;
const capitalize = (token)=>token[1].toUpperCase();
// This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.
[
    "accent-height",
    "alignment-baseline",
    "arabic-form",
    "baseline-shift",
    "cap-height",
    "clip-path",
    "clip-rule",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "dominant-baseline",
    "enable-background",
    "fill-opacity",
    "fill-rule",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-name",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "horiz-adv-x",
    "horiz-origin-x",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "overline-position",
    "overline-thickness",
    "paint-order",
    "panose-1",
    "pointer-events",
    "rendering-intent",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "strikethrough-position",
    "strikethrough-thickness",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "underline-position",
    "underline-thickness",
    "unicode-bidi",
    "unicode-range",
    "units-per-em",
    "v-alphabetic",
    "v-hanging",
    "v-ideographic",
    "v-mathematical",
    "vector-effect",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "word-spacing",
    "writing-mode",
    "xmlns:xlink",
    "x-height"
].forEach((attributeName)=>{
    const name = attributeName.replace(CAMELIZE, capitalize);
    properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
});
// String SVG attributes with the xlink namespace.
[
    "xlink:actuate",
    "xlink:arcrole",
    "xlink:role",
    "xlink:show",
    "xlink:title",
    "xlink:type"
].forEach((attributeName)=>{
    const name = attributeName.replace(CAMELIZE, capitalize);
    properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
});
// String SVG attributes with the xml namespace.
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach((attributeName)=>{
    const name = attributeName.replace(CAMELIZE, capitalize);
    properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
});
// These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.
[
    "tabIndex",
    "crossOrigin"
].forEach((attributeName)=>{
    properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
});
// These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.
const xlinkHref = "xlinkHref";
properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach((attributeName)=>{
    properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
});
// 
const { CAMELCASE, SAME, possibleStandardNames: possibleStandardNamesOptimized } = require("9ac9344711c5e413");
const ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
const ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
 *
 * @type {(attribute: string) => boolean}
 */ const isCustomAttribute = RegExp.prototype.test.bind(// eslint-disable-next-line no-misleading-character-class
new RegExp("^(data|aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$"));
/**
 * @type {Record<string, string>}
 */ const possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce((accumulator, standardName)=>{
    const propName = possibleStandardNamesOptimized[standardName];
    if (propName === SAME) accumulator[standardName] = standardName;
    else if (propName === CAMELCASE) accumulator[standardName.toLowerCase()] = standardName;
    else accumulator[standardName] = propName;
    return accumulator;
}, {});
exports.BOOLEAN = BOOLEAN;
exports.BOOLEANISH_STRING = BOOLEANISH_STRING;
exports.NUMERIC = NUMERIC;
exports.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
exports.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
exports.RESERVED = RESERVED;
exports.STRING = STRING;
exports.getPropertyInfo = getPropertyInfo;
exports.isCustomAttribute = isCustomAttribute;
exports.possibleStandardNames = possibleStandardNames;

},{"9ac9344711c5e413":"iof6B"}],"iof6B":[function(require,module,exports) {
// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var SAME = 0;
exports.SAME = SAME;
// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var CAMELCASE = 1;
exports.CAMELCASE = CAMELCASE;
exports.possibleStandardNames = {
    accept: 0,
    acceptCharset: 1,
    "accept-charset": "acceptCharset",
    accessKey: 1,
    action: 0,
    allowFullScreen: 1,
    alt: 0,
    as: 0,
    async: 0,
    autoCapitalize: 1,
    autoComplete: 1,
    autoCorrect: 1,
    autoFocus: 1,
    autoPlay: 1,
    autoSave: 1,
    capture: 0,
    cellPadding: 1,
    cellSpacing: 1,
    challenge: 0,
    charSet: 1,
    checked: 0,
    children: 0,
    cite: 0,
    class: "className",
    classID: 1,
    className: 1,
    cols: 0,
    colSpan: 1,
    content: 0,
    contentEditable: 1,
    contextMenu: 1,
    controls: 0,
    controlsList: 1,
    coords: 0,
    crossOrigin: 1,
    dangerouslySetInnerHTML: 1,
    data: 0,
    dateTime: 1,
    default: 0,
    defaultChecked: 1,
    defaultValue: 1,
    defer: 0,
    dir: 0,
    disabled: 0,
    disablePictureInPicture: 1,
    disableRemotePlayback: 1,
    download: 0,
    draggable: 0,
    encType: 1,
    enterKeyHint: 1,
    for: "htmlFor",
    form: 0,
    formMethod: 1,
    formAction: 1,
    formEncType: 1,
    formNoValidate: 1,
    formTarget: 1,
    frameBorder: 1,
    headers: 0,
    height: 0,
    hidden: 0,
    high: 0,
    href: 0,
    hrefLang: 1,
    htmlFor: 1,
    httpEquiv: 1,
    "http-equiv": "httpEquiv",
    icon: 0,
    id: 0,
    innerHTML: 1,
    inputMode: 1,
    integrity: 0,
    is: 0,
    itemID: 1,
    itemProp: 1,
    itemRef: 1,
    itemScope: 1,
    itemType: 1,
    keyParams: 1,
    keyType: 1,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 0,
    low: 0,
    manifest: 0,
    marginWidth: 1,
    marginHeight: 1,
    max: 0,
    maxLength: 1,
    media: 0,
    mediaGroup: 1,
    method: 0,
    min: 0,
    minLength: 1,
    multiple: 0,
    muted: 0,
    name: 0,
    noModule: 1,
    nonce: 0,
    noValidate: 1,
    open: 0,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 1,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 1,
    readOnly: 1,
    referrerPolicy: 1,
    rel: 0,
    required: 0,
    reversed: 0,
    role: 0,
    rows: 0,
    rowSpan: 1,
    sandbox: 0,
    scope: 0,
    scoped: 0,
    scrolling: 0,
    seamless: 0,
    selected: 0,
    shape: 0,
    size: 0,
    sizes: 0,
    span: 0,
    spellCheck: 1,
    src: 0,
    srcDoc: 1,
    srcLang: 1,
    srcSet: 1,
    start: 0,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 1,
    target: 0,
    title: 0,
    type: 0,
    useMap: 1,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    accentHeight: 1,
    "accent-height": "accentHeight",
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 1,
    "alignment-baseline": "alignmentBaseline",
    allowReorder: 1,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 1,
    "arabic-form": "arabicForm",
    ascent: 0,
    attributeName: 1,
    attributeType: 1,
    autoReverse: 1,
    azimuth: 0,
    baseFrequency: 1,
    baselineShift: 1,
    "baseline-shift": "baselineShift",
    baseProfile: 1,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 1,
    capHeight: 1,
    "cap-height": "capHeight",
    clip: 0,
    clipPath: 1,
    "clip-path": "clipPath",
    clipPathUnits: 1,
    clipRule: 1,
    "clip-rule": "clipRule",
    color: 0,
    colorInterpolation: 1,
    "color-interpolation": "colorInterpolation",
    colorInterpolationFilters: 1,
    "color-interpolation-filters": "colorInterpolationFilters",
    colorProfile: 1,
    "color-profile": "colorProfile",
    colorRendering: 1,
    "color-rendering": "colorRendering",
    contentScriptType: 1,
    contentStyleType: 1,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    datatype: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 1,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 1,
    "dominant-baseline": "dominantBaseline",
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 1,
    elevation: 0,
    enableBackground: 1,
    "enable-background": "enableBackground",
    end: 0,
    exponent: 0,
    externalResourcesRequired: 1,
    fill: 0,
    fillOpacity: 1,
    "fill-opacity": "fillOpacity",
    fillRule: 1,
    "fill-rule": "fillRule",
    filter: 0,
    filterRes: 1,
    filterUnits: 1,
    floodOpacity: 1,
    "flood-opacity": "floodOpacity",
    floodColor: 1,
    "flood-color": "floodColor",
    focusable: 0,
    fontFamily: 1,
    "font-family": "fontFamily",
    fontSize: 1,
    "font-size": "fontSize",
    fontSizeAdjust: 1,
    "font-size-adjust": "fontSizeAdjust",
    fontStretch: 1,
    "font-stretch": "fontStretch",
    fontStyle: 1,
    "font-style": "fontStyle",
    fontVariant: 1,
    "font-variant": "fontVariant",
    fontWeight: 1,
    "font-weight": "fontWeight",
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 1,
    "glyph-name": "glyphName",
    glyphOrientationHorizontal: 1,
    "glyph-orientation-horizontal": "glyphOrientationHorizontal",
    glyphOrientationVertical: 1,
    "glyph-orientation-vertical": "glyphOrientationVertical",
    glyphRef: 1,
    gradientTransform: 1,
    gradientUnits: 1,
    hanging: 0,
    horizAdvX: 1,
    "horiz-adv-x": "horizAdvX",
    horizOriginX: 1,
    "horiz-origin-x": "horizOriginX",
    ideographic: 0,
    imageRendering: 1,
    "image-rendering": "imageRendering",
    in2: 0,
    in: 0,
    inlist: 0,
    intercept: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    k: 0,
    kernelMatrix: 1,
    kernelUnitLength: 1,
    kerning: 0,
    keyPoints: 1,
    keySplines: 1,
    keyTimes: 1,
    lengthAdjust: 1,
    letterSpacing: 1,
    "letter-spacing": "letterSpacing",
    lightingColor: 1,
    "lighting-color": "lightingColor",
    limitingConeAngle: 1,
    local: 0,
    markerEnd: 1,
    "marker-end": "markerEnd",
    markerHeight: 1,
    markerMid: 1,
    "marker-mid": "markerMid",
    markerStart: 1,
    "marker-start": "markerStart",
    markerUnits: 1,
    markerWidth: 1,
    mask: 0,
    maskContentUnits: 1,
    maskUnits: 1,
    mathematical: 0,
    mode: 0,
    numOctaves: 1,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 1,
    "overline-position": "overlinePosition",
    overlineThickness: 1,
    "overline-thickness": "overlineThickness",
    paintOrder: 1,
    "paint-order": "paintOrder",
    panose1: 0,
    "panose-1": "panose1",
    pathLength: 1,
    patternContentUnits: 1,
    patternTransform: 1,
    patternUnits: 1,
    pointerEvents: 1,
    "pointer-events": "pointerEvents",
    points: 0,
    pointsAtX: 1,
    pointsAtY: 1,
    pointsAtZ: 1,
    prefix: 0,
    preserveAlpha: 1,
    preserveAspectRatio: 1,
    primitiveUnits: 1,
    property: 0,
    r: 0,
    radius: 0,
    refX: 1,
    refY: 1,
    renderingIntent: 1,
    "rendering-intent": "renderingIntent",
    repeatCount: 1,
    repeatDur: 1,
    requiredExtensions: 1,
    requiredFeatures: 1,
    resource: 0,
    restart: 0,
    result: 0,
    results: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    security: 0,
    seed: 0,
    shapeRendering: 1,
    "shape-rendering": "shapeRendering",
    slope: 0,
    spacing: 0,
    specularConstant: 1,
    specularExponent: 1,
    speed: 0,
    spreadMethod: 1,
    startOffset: 1,
    stdDeviation: 1,
    stemh: 0,
    stemv: 0,
    stitchTiles: 1,
    stopColor: 1,
    "stop-color": "stopColor",
    stopOpacity: 1,
    "stop-opacity": "stopOpacity",
    strikethroughPosition: 1,
    "strikethrough-position": "strikethroughPosition",
    strikethroughThickness: 1,
    "strikethrough-thickness": "strikethroughThickness",
    string: 0,
    stroke: 0,
    strokeDasharray: 1,
    "stroke-dasharray": "strokeDasharray",
    strokeDashoffset: 1,
    "stroke-dashoffset": "strokeDashoffset",
    strokeLinecap: 1,
    "stroke-linecap": "strokeLinecap",
    strokeLinejoin: 1,
    "stroke-linejoin": "strokeLinejoin",
    strokeMiterlimit: 1,
    "stroke-miterlimit": "strokeMiterlimit",
    strokeWidth: 1,
    "stroke-width": "strokeWidth",
    strokeOpacity: 1,
    "stroke-opacity": "strokeOpacity",
    suppressContentEditableWarning: 1,
    suppressHydrationWarning: 1,
    surfaceScale: 1,
    systemLanguage: 1,
    tableValues: 1,
    targetX: 1,
    targetY: 1,
    textAnchor: 1,
    "text-anchor": "textAnchor",
    textDecoration: 1,
    "text-decoration": "textDecoration",
    textLength: 1,
    textRendering: 1,
    "text-rendering": "textRendering",
    to: 0,
    transform: 0,
    typeof: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 1,
    "underline-position": "underlinePosition",
    underlineThickness: 1,
    "underline-thickness": "underlineThickness",
    unicode: 0,
    unicodeBidi: 1,
    "unicode-bidi": "unicodeBidi",
    unicodeRange: 1,
    "unicode-range": "unicodeRange",
    unitsPerEm: 1,
    "units-per-em": "unitsPerEm",
    unselectable: 0,
    vAlphabetic: 1,
    "v-alphabetic": "vAlphabetic",
    values: 0,
    vectorEffect: 1,
    "vector-effect": "vectorEffect",
    version: 0,
    vertAdvY: 1,
    "vert-adv-y": "vertAdvY",
    vertOriginX: 1,
    "vert-origin-x": "vertOriginX",
    vertOriginY: 1,
    "vert-origin-y": "vertOriginY",
    vHanging: 1,
    "v-hanging": "vHanging",
    vIdeographic: 1,
    "v-ideographic": "vIdeographic",
    viewBox: 1,
    viewTarget: 1,
    visibility: 0,
    vMathematical: 1,
    "v-mathematical": "vMathematical",
    vocab: 0,
    widths: 0,
    wordSpacing: 1,
    "word-spacing": "wordSpacing",
    writingMode: 1,
    "writing-mode": "writingMode",
    x1: 0,
    x2: 0,
    x: 0,
    xChannelSelector: 1,
    xHeight: 1,
    "x-height": "xHeight",
    xlinkActuate: 1,
    "xlink:actuate": "xlinkActuate",
    xlinkArcrole: 1,
    "xlink:arcrole": "xlinkArcrole",
    xlinkHref: 1,
    "xlink:href": "xlinkHref",
    xlinkRole: 1,
    "xlink:role": "xlinkRole",
    xlinkShow: 1,
    "xlink:show": "xlinkShow",
    xlinkTitle: 1,
    "xlink:title": "xlinkTitle",
    xlinkType: 1,
    "xlink:type": "xlinkType",
    xmlBase: 1,
    "xml:base": "xmlBase",
    xmlLang: 1,
    "xml:lang": "xmlLang",
    xmlns: 0,
    "xml:space": "xmlSpace",
    xmlnsXlink: 1,
    "xmlns:xlink": "xmlnsXlink",
    xmlSpace: 1,
    y1: 0,
    y2: 0,
    y: 0,
    yChannelSelector: 1,
    z: 0,
    zoomAndPan: 1
};

},{}],"hsuSw":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.returnFirstArg = exports.canTextBeChildOfNode = exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = exports.PRESERVE_CUSTOM_ATTRIBUTES = exports.setStyleProp = exports.isCustomComponent = void 0;
var react_1 = require("b1cb1b3034b1c960");
var style_to_js_1 = __importDefault(require("bdaa71267fd00108"));
var RESERVED_SVG_MATHML_ELEMENTS = new Set([
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-src",
    "font-face-uri",
    "font-face-format",
    "font-face-name",
    "missing-glyph"
]);
/**
 * Check if a tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param tagName - Tag name.
 * @param props - Props passed to the element.
 * @returns - Whether the tag is custom component.
 */ function isCustomComponent(tagName, props) {
    if (!tagName.includes("-")) return Boolean(props && typeof props.is === "string");
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    if (RESERVED_SVG_MATHML_ELEMENTS.has(tagName)) return false;
    return true;
}
exports.isCustomComponent = isCustomComponent;
var styleOptions = {
    reactCompat: true
};
/**
 * Sets style prop.
 *
 * @param style - Inline style.
 * @param props - Props object.
 */ function setStyleProp(style, props) {
    if (typeof style !== "string") return;
    if (!style.trim()) {
        props.style = {};
        return;
    }
    try {
        props.style = (0, style_to_js_1.default)(style, styleOptions);
    } catch (error) {
        props.style = {};
    }
}
exports.setStyleProp = setStyleProp;
/**
 * @see https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html
 */ exports.PRESERVE_CUSTOM_ATTRIBUTES = Number(react_1.version.split(".")[0]) >= 16;
/**
 * @see https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
 */ exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
]);
/**
 * Checks if the given node can contain text nodes
 *
 * @param node - Element node.
 * @returns - Whether the node can contain text nodes.
 */ var canTextBeChildOfNode = function(node) {
    return !exports.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(node.name);
};
exports.canTextBeChildOfNode = canTextBeChildOfNode;
/**
 * Returns the first argument as is.
 *
 * @param arg - The argument to be returned.
 * @returns - The input argument `arg`.
 */ var returnFirstArg = function(arg) {
    return arg;
};
exports.returnFirstArg = returnFirstArg;

},{"b1cb1b3034b1c960":"6uln9","bdaa71267fd00108":"5wC8v"}],"5wC8v":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var style_to_object_1 = __importDefault(require("addfc2082a8581f8"));
var utilities_1 = require("c247c029b724bbe9");
/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== "string") return output;
    (0, style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, utilities_1.camelCase)(property, options)] = value;
    });
    return output;
}
StyleToJS.default = StyleToJS;
module.exports = StyleToJS;

},{"addfc2082a8581f8":"hlvq3","c247c029b724bbe9":"844r1"}],"hlvq3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../cjs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// ensure compatibility with rollup umd build
exports.default = (0, _indexJsDefault.default).default || (0, _indexJsDefault.default);

},{"../cjs/index.js":"dfb9k","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dfb9k":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var inline_style_parser_1 = __importDefault(require("2ba9386652217ec0"));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function StyleToObject(style, iterator) {
    var styleObject = null;
    if (!style || typeof style !== "string") return styleObject;
    var declarations = (0, inline_style_parser_1.default)(style);
    var hasIterator = typeof iterator === "function";
    declarations.forEach(function(declaration) {
        if (declaration.type !== "declaration") return;
        var property = declaration.property, value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}
exports.default = StyleToObject;

},{"2ba9386652217ec0":"dlLJS"}],"dlLJS":[function(require,module,exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;
// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;
// strings
var NEWLINE = "\n";
var FORWARD_SLASH = "/";
var ASTERISK = "*";
var EMPTY_STRING = "";
// types
var TYPE_COMMENT = "comment";
var TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match(NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf(NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match(WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
        var i = 2;
        while(EMPTY_STRING != style.charAt(i) && (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if (EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match(PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match(COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match(VALUE_REGEX);
        var ret = pos({
            type: TYPE_DECLARATION,
            property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
            value: val ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
        });
        // ;
        match(SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function trim(str) {
    return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

},{}],"844r1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var skipCamelCase = function(property) {
    return !property || NO_HYPHEN_REGEX.test(property) || CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var capitalize = function(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var camelCase = function(property, options) {
    if (options === void 0) options = {};
    if (skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    return property.replace(HYPHEN_REGEX, capitalize);
};
exports.camelCase = camelCase;

},{}],"jjpLC":[function(require,module,exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var react_1 = require("731ac75943b91dde");
var attributes_to_props_1 = __importDefault(require("3094f08771d33e7b"));
var utilities_1 = require("dde6c4a3b7b6adbf");
var React = {
    cloneElement: react_1.cloneElement,
    createElement: react_1.createElement,
    isValidElement: react_1.isValidElement
};
/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param nodes - DOM nodes.
 * @param options - Options.
 * @returns - String or JSX element(s).
 */ function domToReact(nodes, options) {
    if (options === void 0) options = {};
    var reactElements = [];
    var hasReplace = typeof options.replace === "function";
    var transform = options.transform || utilities_1.returnFirstArg;
    var _a = options.library || React, cloneElement = _a.cloneElement, createElement = _a.createElement, isValidElement = _a.isValidElement;
    var nodesLength = nodes.length;
    for(var index = 0; index < nodesLength; index++){
        var node = nodes[index];
        // replace with custom React element (if present)
        if (hasReplace) {
            var replaceElement = options.replace(node, index);
            if (isValidElement(replaceElement)) {
                // set "key" prop for sibling elements
                // https://react.dev/learn/rendering-lists#rules-of-keys
                if (nodesLength > 1) replaceElement = cloneElement(replaceElement, {
                    key: replaceElement.key || index
                });
                reactElements.push(transform(replaceElement, node, index));
                continue;
            }
        }
        if (node.type === "text") {
            var isWhitespace = !node.data.trim().length;
            // We have a whitespace node that can't be nested in its parent
            // so skip it
            if (isWhitespace && node.parent && !(0, utilities_1.canTextBeChildOfNode)(node.parent)) continue;
            // Trim is enabled and we have a whitespace node
            // so skip it
            if (options.trim && isWhitespace) continue;
            // We have a text node that's not whitespace and it can be nested
            // in its parent so add it to the results
            reactElements.push(transform(node.data, node, index));
            continue;
        }
        var element = node;
        var props = {};
        if (skipAttributesToProps(element)) {
            (0, utilities_1.setStyleProp)(element.attribs.style, element.attribs);
            props = element.attribs;
        } else if (element.attribs) props = (0, attributes_to_props_1.default)(element.attribs, element.name);
        var children = void 0;
        switch(node.type){
            case "script":
            case "style":
                // prevent text in <script> or <style> from being escaped
                // https://react.dev/reference/react-dom/components/common#dangerously-setting-the-inner-html
                if (node.children[0]) props.dangerouslySetInnerHTML = {
                    __html: node.children[0].data
                };
                break;
            case "tag":
                // setting textarea value in children is an antipattern in React
                // https://react.dev/reference/react-dom/components/textarea#caveats
                if (node.name === "textarea" && node.children[0]) props.defaultValue = node.children[0].data;
                else if (node.children && node.children.length) // continue recursion of creating React elements (if applicable)
                children = domToReact(node.children, options);
                break;
            // skip all other cases (e.g., comment)
            default:
                continue;
        }
        // set "key" prop for sibling elements
        // https://react.dev/learn/rendering-lists#rules-of-keys
        if (nodesLength > 1) props.key = index;
        reactElements.push(transform(createElement(node.name, props, children), node, index));
    }
    return reactElements.length === 1 ? reactElements[0] : reactElements;
}
exports.default = domToReact;
/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param node - Element node.
 * @returns - Whether the node attributes should be converted to props.
 */ function skipAttributesToProps(node) {
    return utilities_1.PRESERVE_CUSTOM_ATTRIBUTES && node.type === "tag" && (0, utilities_1.isCustomComponent)(node.name, node.attribs);
}

},{"731ac75943b91dde":"6uln9","3094f08771d33e7b":"9FB39","dde6c4a3b7b6adbf":"hsuSw"}],"4aMA6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultiInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _immer = require("immer");
var _reactEasySort = require("react-easy-sort");
var _reactEasySortDefault = parcelHelpers.interopDefault(_reactEasySort);
var _arrayMove = require("array-move");
function MultiInput({ field, value, update, children }) {
    function handleAdd() {
        update((0, _immer.produce)(value, (draft)=>{
            if (!Array.isArray(draft)) return [
                {}
            ];
            draft.push({});
        }));
    }
    function handleRemove(idx) {
        update((0, _immer.produce)(value, (draft)=>{
            draft.splice(idx, 1);
        }));
    }
    function handleSortEnd(oldIndex, newIndex) {
    // update(produce(value, draft => arrayMoveImmutable(draft, oldIndex, newIndex)))
    }
    const items = (0, _react.useMemo)(()=>{
        if (!Array.isArray(value)) return [];
        const keyFreshness = Date.now();
        return value.map((val, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySort.SortableItem), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "Item",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySort.SortableKnob), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: " \u2195\uFE0F "
                            })
                        }),
                        /*#__PURE__*/ (0, _react.cloneElement)(children, {
                            field,
                            value: val,
                            update: (val)=>update((0, _immer.produce)(value, (draft)=>{
                                    draft.splice(idx, 1, val);
                                }))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>handleRemove(idx),
                                children: "x"
                            })
                        })
                    ]
                })
            }, `${idx}-${keyFreshness}`));
    }, [
        field,
        value,
        children
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySortDefault.default), {
                className: "GridTable MultiInputList",
                draggedItemClassName: "dragged",
                onSortEnd: handleSortEnd,
                children: items
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: handleAdd,
                children: "Add item"
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","immer":"eUR2H","react-easy-sort":"iVlh1","array-move":"iaig5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fAdkP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _jsxRuntime = require("react/jsx-runtime");
const RedirectIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: "Icon",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.2929 3.29286C16.6834 2.90234 17.3166 2.90234 17.7071 3.29286L22.7071 8.29286C23.0976 8.68339 23.0976 9.31655 22.7071 9.70708L17.7071 14.7071C17.3166 15.0976 16.6834 15.0976 16.2929 14.7071C15.9024 14.3166 15.9024 13.6834 16.2929 13.2929L19.5858 9.99997H8.76619L13.8575 18.4855C14.0429 18.7944 14.0477 19.1792 13.8702 19.4927C13.6927 19.8062 13.3603 20 13 20H2C1.44772 20 1 19.5523 1 19C1 18.4477 1.44772 18 2 18H11.2338L6.14251 9.51447C5.95715 9.20553 5.95229 8.82078 6.1298 8.50727C6.30731 8.19376 6.63973 7.99997 7 7.99997H19.5858L16.2929 4.70708C15.9024 4.31655 15.9024 3.68339 16.2929 3.29286Z"
        })
    });
const OutIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        className: "Icon",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M20.2929 9.70708C20.5789 9.99307 21.009 10.0786 21.3827 9.92385C21.7564 9.76907 22 9.40443 22 8.99997V2.99997C22 2.44768 21.5523 1.99997 21 1.99997H15C14.5955 1.99997 14.2309 2.24361 14.0761 2.61729C13.9213 2.99096 14.0069 3.42108 14.2929 3.70708L16.2322 5.64641L9.58574 12.2929C9.19522 12.6834 9.19522 13.3166 9.58574 13.7071L10.2928 14.4142C10.6834 14.8048 11.3165 14.8048 11.7071 14.4142L18.3536 7.76774L20.2929 9.70708Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M4.5 8.00006C4.5 7.72392 4.72386 7.50006 5 7.50006H10.0625C10.6148 7.50006 11.0625 7.05234 11.0625 6.50006V5.50006C11.0625 4.94777 10.6148 4.50006 10.0625 4.50006H5C3.067 4.50006 1.5 6.06706 1.5 8.00006V19.0001C1.5 20.9331 3.067 22.5001 5 22.5001H16C17.933 22.5001 19.5 20.9331 19.5 19.0001V13.9376C19.5 13.3853 19.0523 12.9376 18.5 12.9376H17.5C16.9477 12.9376 16.5 13.3853 16.5 13.9376V19.0001C16.5 19.2762 16.2761 19.5001 16 19.5001H5C4.72386 19.5001 4.5 19.2762 4.5 19.0001V8.00006Z"
            })
        ]
    });
const HtmlIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: "Icon",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M4 16v-2H2v2H1v-5h1v2h2v-2h1v5H4zM7 16v-4H5.6v-1h3.7v1H8v4H7zM10 16v-5h1l1.4 3.4h.1L14 11h1v5h-1v-3.1h-.1l-1.1 2.5h-.6l-1.1-2.5H11V16h-1zM19 16h-3v-5h1v4h2v1zM9.4 4.2L7.1 6.5l2.3 2.3-.6 1.2-3.5-3.5L8.8 3l.6 1.2zm1.2 4.6l2.3-2.3-2.3-2.3.6-1.2 3.5 3.5-3.5 3.5-.6-1.2z"
        })
    });
const FullscreenIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        fill: "currentColor",
        className: "Icon",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M14 3.414L9.414 8 14 12.586v-2.583h2V16h-6v-1.996h2.59L8 9.414l-4.59 4.59H6V16H0v-5.997h2v2.583L6.586 8 2 3.414v2.588H0V0h16v6.002h-2V3.414zm-1.415-1.413H10V0H6v2H3.415L8 6.586 12.585 2z",
            fillRule: "evenodd"
        })
    });
function Icon({ i }) {
    switch(i){
        case "out":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutIcon, {});
        case "redirect":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RedirectIcon, {});
        case "html":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(HtmlIcon, {});
        case "fullscreen":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FullscreenIcon, {});
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: "Icon not found"
            });
    }
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kXYRz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _immer = require("immer");
var _files = require("../files/Files");
var _filesDefault = parcelHelpers.interopDefault(_files);
var _getThumbUrl = require("../utils/getThumbUrl");
var _getThumbUrlDefault = parcelHelpers.interopDefault(_getThumbUrl);
function FileItem({ path, handleRemove, handleShow }) {
    const thumbUrl = (0, _getThumbUrlDefault.default)(path);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "FileFieldItem",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: thumbUrl,
                width: "128px",
                onClick: handleShow
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                        children: path
                    }),
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: handleRemove,
                        children: "x"
                    })
                ]
            })
        ]
    });
}
function FileInput({ field, value, update }) {
    const [showFiles, setShowFiles] = (0, _react.useState)(false);
    const handleSelected = (0, _react.useCallback)((paths)=>{
        if (field.multi) update(paths);
        else {
            update(paths[0]);
            setShowFiles(false);
        }
    }, [
        field.multi
    ]);
    const handleRemove = (0, _react.useCallback)((idx)=>{
        update((0, _immer.produce)(value, (draft)=>{
            draft.splice(idx, 1);
        }));
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            Array.isArray(value) && value.map((path, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(FileItem, {
                    path: path,
                    handleRemove: ()=>handleRemove(idx),
                    handleShow: ()=>setShowFiles(path)
                }, path)),
            typeof value === "string" && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FileItem, {
                path: value,
                handleRemove: ()=>update(null),
                handleShow: ()=>setShowFiles(value)
            }),
            !showFiles && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                onClick: ()=>setShowFiles(true),
                className: "Button",
                children: [
                    "Pick ",
                    field.multi ? "files" : "file"
                ]
            }),
            showFiles && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setShowFiles(null),
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filesDefault.default), {
                        isEmbed: true,
                        onSelected: handleSelected,
                        initialPath: "/"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","immer":"eUR2H","../files/Files":"9m1Pe","../utils/getThumbUrl":"gGbYT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9m1Pe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilesContext", ()=>FilesContext);
parcelHelpers.export(exports, "default", ()=>Files);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _useImmer = require("use-immer");
var _immer = require("immer");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _filesPath = require("./FilesPath");
var _filesPathDefault = parcelHelpers.interopDefault(_filesPath);
var _fileModal = require("./FileModal");
var _fileModalDefault = parcelHelpers.interopDefault(_fileModal);
var _fileUpload = require("./FileUpload");
var _fileUploadDefault = parcelHelpers.interopDefault(_fileUpload);
var _folder = require("./Folder");
var _folderDefault = parcelHelpers.interopDefault(_folder);
var _selectedFiles = require("./SelectedFiles");
var _selectedFilesDefault = parcelHelpers.interopDefault(_selectedFiles);
var _newFolder = require("./NewFolder");
var _newFolderDefault = parcelHelpers.interopDefault(_newFolder);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
const GET_FILES_PATH = (0, _client.gql)`
	query getFilesPath($path: String!) {
		filesPath(path: $path) {
			path
			folders {
				path
				name
			}
			files {
				path
				name
			}
			file {
				path
	 			name
	 			mimeType
	 			size
	 			created
	 			modified
			}
		}
	}`;
const FilesContext = /*#__PURE__*/ (0, _react.createContext)({});
function Files({ isEmbed = false, isModal = false, initialPath = "/", forcePath, onSelected }) {
    const [path, setPath] = (0, _react.useState)(forcePath || initialPath);
    const { loading, error, data, refetch } = (0, _client.useQuery)(GET_FILES_PATH, {
        variables: {
            path
        }
    });
    const [selected, setSelected] = (0, _useImmer.useImmer)([]);
    const folder = (0, _react.useMemo)(()=>{
        if (!data?.filesPath) return null;
        if (selected.length === 0 || data.filesPath.files.length === 0) return data.filesPath;
        return (0, _immer.produce)(data.filesPath, (draft)=>{
            draft.files.forEach((file, idx)=>{
                if (selected.includes(file.path)) draft.files[idx].selected = true;
            });
        });
    }, [
        data,
        selected
    ]);
    const closeModal = (0, _react.useCallback)(()=>{
        const splitPath = path.split("/");
        splitPath.pop();
        setPath(splitPath.join("/"));
    }, [
        path
    ]);
    const filesCtx = (0, _react.useMemo)(()=>({
            isEmbed,
            path,
            setPath,
            setSelected,
            selected,
            refetch
        }), [
        selected,
        path
    ]);
    (0, _react.useEffect)(()=>{
        if (!!onSelected && selected.length > 0) onSelected(selected);
    }, [
        selected
    ]);
    (0, _react.useEffect)(()=>{
        if (!!forcePath && path !== forcePath) setPath(forcePath);
    // refetch({ path })
    }, [
        forcePath
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FilesContext.Provider, {
        value: filesCtx,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _classnamesDefault.default)("FilesWrap", {
                    isModal
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "Files",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "FilesPath",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filesPathDefault.default), {
                                path: path
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "FilesOptions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newFolderDefault.default), {
                                    path: path
                                }),
                                !!folder && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectedFilesDefault.default), {
                                    folder: folder
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileUploadDefault.default), {
                                    path: path
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "FilesFolder",
                            children: !!folder && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _folderDefault.default), {
                                folder: folder
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                            error: error
                        })
                    ]
                })
            }),
            !!folder?.file && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileModalDefault.default), {
                file: folder.file,
                handleClose: ()=>closeModal()
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","use-immer":"cnEe2","immer":"eUR2H","classnames":"hVGzI","./FilesPath":"brYqs","./FileModal":"bmSHy","./FileUpload":"9I2Sh","./Folder":"dKiBa","./SelectedFiles":"5msDw","./NewFolder":"Z6C0u","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"brYqs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FilesPath);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _filesLink = require("./FilesLink");
var _filesLinkDefault = parcelHelpers.interopDefault(_filesLink);
function FilesPath({ path }) {
    const folderMap = (0, _react.useMemo)(()=>path === "/" ? [] : path.split("/").slice(1), [
        path
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filesLinkDefault.default), {
                path: "",
                children: "\uD83C\uDFE0"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "/"
            }),
            folderMap.map((folder, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        idx === folderMap.length - 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: folder
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filesLinkDefault.default), {
                            path: `/${folderMap.slice(0, idx + 1).join("/")}`,
                            children: folder
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "/"
                        })
                    ]
                }, `${idx}-${folder}`))
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./FilesLink":"2h45D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2h45D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FilesLink);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _files = require("./Files");
function FilesLink({ path, className, children }) {
    const { setPath, isEmbed } = (0, _react.useContext)((0, _files.FilesContext));
    const handleClick = (0, _react.useCallback)((event)=>{
        if (!isEmbed) return true;
        event.preventDefault();
        setPath(path);
    }, [
        path
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        to: `/files${path}`,
        onClick: handleClick,
        className: className,
        children: children
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","react":"6uln9","./Files":"9m1Pe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmSHy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileModal);
var _jsxRuntime = require("react/jsx-runtime");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _formatFileSize = require("../utils/formatFileSize");
var _formatFileSizeDefault = parcelHelpers.interopDefault(_formatFileSize);
function FileModal({ file, handleClose }) {
    // const { navigate, isEmbed } = useContext(FilesContext)
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "FileModal",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Image",
                children: file.mimeType?.startsWith("image/") && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: `${"http://cms.pp.content.catering"}/files${file.path}`,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Info",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "Close",
                        onClick: handleClose,
                        children: "Close"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: file.path
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: file.mimeType
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: (0, _formatFileSizeDefault.default)(file.size)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            "Created ",
                            (0, _dayjsDefault.default)(file.created).format(`DD/MM/YYYY HH:mm`)
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","dayjs":"8F3kd","../utils/formatFileSize":"3ALCd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3ALCd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatFileSize);
function formatFileSize(bytes) {
    if (bytes < 1024) return bytes.toFixed(1) + " B";
    else if (bytes < 1048576) return bytes < 10240 ? (bytes / 1024).toFixed(1) + " kB" : Math.round(bytes / 1024) + " kB";
    else return (bytes / 1048576).toFixed(1) + " MB";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9I2Sh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileUpload);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useImmer = require("use-immer");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _uploadProgress = require("./UploadProgress");
var _uploadProgressDefault = parcelHelpers.interopDefault(_uploadProgress);
var _files = require("./Files");
const UPLOAD_SERVER = `${"http://cms.pp.content.catering"}/upload`;
function FileUpload({ path }) {
    const [progress, setProgress] = (0, _useImmer.useImmer)(null);
    const inputRef = (0, _react.useRef)(null);
    const { refetch } = (0, _react.useContext)((0, _files.FilesContext));
    async function onSelectFiles(event) {
        try {
            const progress = {
                fileCount: 0,
                loaded: 0,
                total: 0,
                done: false,
                error: null
            };
            const formData = new FormData();
            formData.append("parentPath", path);
            for (let file of event.target.files){
                progress.fileCount++;
                progress.total += file.size;
                formData.append("files", file);
            }
            setProgress(progress);
            const token = localStorage.getItem("token");
            const response = await (0, _axiosDefault.default).postForm(UPLOAD_SERVER, formData, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : ""
                },
                onUploadProgress: (progress)=>setProgress((draft)=>{
                        draft.loaded = progress.loaded;
                        draft.total = progress.total;
                    })
            });
            if (response.status === 200) setProgress((draft)=>{
                draft.done = true;
            });
            else throw new Error("Files did not finish uploading successfuly.");
        } catch (error) {
            setProgress({
                error: error.toString()
            });
        }
    }
    function handleDiscard() {
        inputRef.current.value = "";
        setProgress(null);
    }
    // refetch() when all files are uploaded
    (0, _react.useEffect)(()=>{
        if (progress?.done) refetch();
    }, [
        progress
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "FilesUpload",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "file",
                name: "files",
                onChange: onSelectFiles,
                multiple: true,
                disabled: !!progress && !progress.done,
                ref: inputRef
            }),
            !!progress && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadProgressDefault.default), {
                progress: progress,
                onDiscard: handleDiscard
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("pre", {
                children: JSON.stringify(progress, null, 2)
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","use-immer":"cnEe2","axios":"gqqlV","./UploadProgress":"8Fm7k","./Files":"9m1Pe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gqqlV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"bpQHr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bpQHr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"j4U5Z","./helpers/bind.js":"lsHw8","./core/Axios.js":"gSzLM","./core/mergeConfig.js":"hBFgb","./defaults/index.js":"5ajHU","./helpers/formDataToJSON.js":"lvQ77","./cancel/CanceledError.js":"2SXaM","./cancel/CancelToken.js":"d4MXP","./cancel/isCancel.js":"kQA2M","./env/data.js":"dV7xS","./helpers/toFormData.js":"SFWXV","./core/AxiosError.js":"e7UnU","./helpers/spread.js":"jQT5B","./helpers/isAxiosError.js":"2EXuU","./core/AxiosHeaders.js":"kmeTN","./adapters/adapters.js":"lFvV1","./helpers/HttpStatusCode.js":"8j5L4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j4U5Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== "object") return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
    DIGIT,
    ALPHA,
    ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    ALPHABET,
    generateString,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable
};

},{"./helpers/bind.js":"lsHw8","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lsHw8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
"use strict";
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSzLM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"j4U5Z","../helpers/buildURL.js":"hOGC1","./InterceptorManager.js":"g8bpG","./dispatchRequest.js":"98TLw","./mergeConfig.js":"hBFgb","./buildFullPath.js":"6MlRA","../helpers/validator.js":"ky4Bn","./AxiosHeaders.js":"kmeTN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hOGC1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

},{"../utils.js":"j4U5Z","../helpers/AxiosURLSearchParams.js":"9zMgc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9zMgc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"SFWXV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"SFWXV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, _utilsJsDefault.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, "[]")) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"l5Twm","../utils.js":"j4U5Z","../core/AxiosError.js":"e7UnU","../platform/node/classes/FormData.js":"jlmg9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l5Twm":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"6Pb1S","aceacb6a4531a9d2":"6ifNR"}],"6Pb1S":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"6ifNR":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"e7UnU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlmg9":[function(require,module,exports) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g8bpG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
class InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"98TLw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"74rSt","../cancel/isCancel.js":"kQA2M","../defaults/index.js":"5ajHU","../cancel/CanceledError.js":"2SXaM","../core/AxiosHeaders.js":"kmeTN","../adapters/adapters.js":"lFvV1","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"74rSt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"j4U5Z","../defaults/index.js":"5ajHU","../core/AxiosHeaders.js":"kmeTN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5ajHU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"j4U5Z","../core/AxiosError.js":"e7UnU","./transitional.js":"1sSt7","../helpers/toFormData.js":"SFWXV","../helpers/toURLEncodedForm.js":"f1oER","../platform/index.js":"Y0LSh","../helpers/formDataToJSON.js":"lvQ77","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1sSt7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f1oER":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

},{"../utils.js":"j4U5Z","./toFormData.js":"SFWXV","../platform/index.js":"Y0LSh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Y0LSh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"haxDI","./common/utils.js":"9bQaq","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"haxDI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

},{"./classes/URLSearchParams.js":"8vuBk","./classes/FormData.js":"bzfcl","./classes/Blob.js":"kfCzj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8vuBk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
"use strict";
exports.default = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"9zMgc","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bzfcl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof FormData !== "undefined" ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kfCzj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
exports.default = typeof Blob !== "undefined" ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9bQaq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = ((product)=>{
    return hasBrowserEnv && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lvQ77":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kmeTN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
"use strict";
const $internals = Symbol("internals");
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"j4U5Z","../helpers/parseHeaders.js":"g7ZuC","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g7ZuC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

},{"./../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQA2M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
"use strict";
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2SXaM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? "canceled" : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"e7UnU","../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lFvV1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default)
};
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value
        });
    }
});
const renderReason = (reason)=>`- ${reason}`;
const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
exports.default = {
    getAdapter: (adapters)=>{
        adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: knownAdapters
};

},{"../utils.js":"j4U5Z","./http.js":"jlmg9","./xhr.js":"hVrwR","../core/AxiosError.js":"e7UnU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hVrwR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _cookiesJs = require("./../helpers/cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildURLJs = require("./../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _isURLSameOriginJs = require("./../helpers/isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _speedometerJs = require("../helpers/speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
"use strict";
function progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(config.headers).normalize();
        let { responseType, withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, _utilsJsDefault.default).isFormData(requestData)) {
            if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)("Request aborted", (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, _axiosErrorJsDefault.default)("Network Error", (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, _transitionalJsDefault.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, _cookiesJsDefault.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(fullPath);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)("Unsupported protocol " + protocol + ":", (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"j4U5Z","./../core/settle.js":"jaZcJ","./../helpers/cookies.js":"eD59s","./../helpers/buildURL.js":"hOGC1","../core/buildFullPath.js":"6MlRA","./../helpers/isURLSameOrigin.js":"3QStk","../defaults/transitional.js":"1sSt7","../core/AxiosError.js":"e7UnU","../cancel/CanceledError.js":"2SXaM","../helpers/parseProtocol.js":"lrlmI","../platform/index.js":"Y0LSh","../core/AxiosHeaders.js":"kmeTN","../helpers/speedometer.js":"jDdfD","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jaZcJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)("Request failed with status code " + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"e7UnU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eD59s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, _utilsJsDefault.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, _utilsJsDefault.default).isString(path) && cookie.push("path=" + path);
        (0, _utilsJsDefault.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"j4U5Z","../platform/index.js":"Y0LSh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6MlRA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
"use strict";
function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !(0, _isAbsoluteURLJsDefault.default)(requestedURL)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"02G4G","../helpers/combineURLs.js":"6BOaY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"02G4G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
"use strict";
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6BOaY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
"use strict";
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3QStk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
"use strict";
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, _utilsJsDefault.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"./../utils.js":"j4U5Z","../platform/index.js":"Y0LSh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lrlmI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
"use strict";
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jDdfD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hBFgb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
"use strict";
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? thing.toJSON() : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties(headersToObject(a), headersToObject(b), true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"j4U5Z","./AxiosHeaders.js":"kmeTN","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ky4Bn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
"use strict";
const validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, _dataJs.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, _axiosErrorJsDefault.default)("options must be an object", (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)("option " + opt + " must be " + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)("Unknown option " + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"dV7xS","../core/AxiosError.js":"e7UnU","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dV7xS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.6.7";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d4MXP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"2SXaM","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jQT5B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
"use strict";
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2EXuU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
"use strict";
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"j4U5Z","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8j5L4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Fm7k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UploadProgress);
var _jsxRuntime = require("react/jsx-runtime");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _formatFileSize = require("../utils/formatFileSize");
var _formatFileSizeDefault = parcelHelpers.interopDefault(_formatFileSize);
function UploadProgress({ progress, onDiscard }) {
    if (progress?.error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
        error: progress.error
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            progress.done && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "Done uploading ",
                    progress.fileCount,
                    " files.",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    (0, _formatFileSizeDefault.default)(progress.total),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                ]
            }),
            !progress.done && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    "Uploading ",
                    progress.fileCount,
                    " files...",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    Math.round(progress.loaded * 100 / progress.total),
                    "% of ",
                    (0, _formatFileSizeDefault.default)(progress.total),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: onDiscard,
                children: "x"
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","../utils/Alert":"5W3pt","../utils/formatFileSize":"3ALCd","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dKiBa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FilesFolder);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fileItem = require("./FileItem");
var _fileItemDefault = parcelHelpers.interopDefault(_fileItem);
var _folderItem = require("./FolderItem");
var _folderItemDefault = parcelHelpers.interopDefault(_folderItem);
function FilesFolder({ folder }) {
    const parentItem = (0, _react.useMemo)(()=>{
        if (folder.path === "/") return null;
        return {
            path: folder.path.split("/").slice(0, -1).join("/"),
            name: ".."
        };
    }, [
        folder
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Folders",
                children: [
                    !!parentItem && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _folderItemDefault.default), {
                        item: parentItem
                    }),
                    folder.folders.length > 0 && folder.folders.map((f)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _folderItemDefault.default), {
                            item: f
                        }, f.path))
                ]
            }),
            folder.files.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Files",
                children: folder.files.map((f)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileItemDefault.default), {
                        item: f
                    }, f.path))
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./FileItem":"5teEj","./FolderItem":"92j6Y","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5teEj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FileItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _mime = require("mime");
var _mimeDefault = parcelHelpers.interopDefault(_mime);
var _filesLink = require("./FilesLink");
var _filesLinkDefault = parcelHelpers.interopDefault(_filesLink);
var _files = require("./Files");
var _getThumbUrl = require("../utils/getThumbUrl");
var _getThumbUrlDefault = parcelHelpers.interopDefault(_getThumbUrl);
function FileItem({ item }) {
    const { setSelected } = (0, _react.useContext)((0, _files.FilesContext));
    const thumbUrl = (0, _getThumbUrlDefault.default)(item.path);
    function onChange(event) {
        setSelected((draft)=>{
            if (event.target.checked) draft.push(item.path);
            else {
                const idx = draft.indexOf(item.path);
                if (idx > -1) draft.splice(idx, 1);
            }
        });
    }
    // const path = useMemo(() => {
    // 	const regex = /\/(?!.*\/)/
    // 	return item.path.replace(regex, '#')
    // }, [item.path])
    const isImage = (0, _mimeDefault.default).getType(item.path)?.startsWith("image/");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "ImageFile",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filesLinkDefault.default), {
                path: item.path,
                type: "file",
                children: isImage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: thumbUrl,
                    alt: thumbUrl
                }) : "\uD83D\uDCC4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        onChange: onChange,
                        checked: !!item.selected
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: item.name
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","mime":"dUIIq","./FilesLink":"2h45D","./Files":"9m1Pe","../utils/getThumbUrl":"gGbYT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dUIIq":[function(require,module,exports) {
"use strict";
let Mime = require("56d3d30c93373f00");
module.exports = new Mime(require("61bde799ae1459e8"), require("21266f6bee3e48b7"));

},{"56d3d30c93373f00":"4KfQF","61bde799ae1459e8":"8JtBI","21266f6bee3e48b7":"kkBBC"}],"4KfQF":[function(require,module,exports) {
"use strict";
/**
 * @param typeMap [Object] Map of MIME type -> Array[extensions]
 * @param ...
 */ function Mime() {
    this._types = Object.create(null);
    this._extensions = Object.create(null);
    for(let i = 0; i < arguments.length; i++)this.define(arguments[i]);
    this.define = this.define.bind(this);
    this.getType = this.getType.bind(this);
    this.getExtension = this.getExtension.bind(this);
}
/**
 * Define mimetype -> extension mappings.  Each key is a mime-type that maps
 * to an array of extensions associated with the type.  The first extension is
 * used as the default extension for the type.
 *
 * e.g. mime.define({'audio/ogg', ['oga', 'ogg', 'spx']});
 *
 * If a type declares an extension that has already been defined, an error will
 * be thrown.  To suppress this error and force the extension to be associated
 * with the new type, pass `force`=true.  Alternatively, you may prefix the
 * extension with "*" to map the type to extension, without mapping the
 * extension to the type.
 *
 * e.g. mime.define({'audio/wav', ['wav']}, {'audio/x-wav', ['*wav']});
 *
 *
 * @param map (Object) type definitions
 * @param force (Boolean) if true, force overriding of existing definitions
 */ Mime.prototype.define = function(typeMap, force) {
    for(let type in typeMap){
        let extensions = typeMap[type].map(function(t) {
            return t.toLowerCase();
        });
        type = type.toLowerCase();
        for(let i = 0; i < extensions.length; i++){
            const ext = extensions[i];
            // '*' prefix = not the preferred type for this extension.  So fixup the
            // extension, and skip it.
            if (ext[0] === "*") continue;
            if (!force && ext in this._types) throw new Error('Attempt to change mapping for "' + ext + '" extension from "' + this._types[ext] + '" to "' + type + '". Pass `force=true` to allow this, otherwise remove "' + ext + '" from the list of extensions for "' + type + '".');
            this._types[ext] = type;
        }
        // Use first extension as default
        if (force || !this._extensions[type]) {
            const ext = extensions[0];
            this._extensions[type] = ext[0] !== "*" ? ext : ext.substr(1);
        }
    }
};
/**
 * Lookup a mime type based on extension
 */ Mime.prototype.getType = function(path) {
    path = String(path);
    let last = path.replace(/^.*[/\\]/, "").toLowerCase();
    let ext = last.replace(/^.*\./, "").toLowerCase();
    let hasPath = last.length < path.length;
    let hasDot = ext.length < last.length - 1;
    return (hasDot || !hasPath) && this._types[ext] || null;
};
/**
 * Return file extension associated with a mime type
 */ Mime.prototype.getExtension = function(type) {
    type = /^\s*([^;\s]*)/.test(type) && RegExp.$1;
    return type && this._extensions[type.toLowerCase()] || null;
};
module.exports = Mime;

},{}],"8JtBI":[function(require,module,exports) {
module.exports = {
    "application/andrew-inset": [
        "ez"
    ],
    "application/applixware": [
        "aw"
    ],
    "application/atom+xml": [
        "atom"
    ],
    "application/atomcat+xml": [
        "atomcat"
    ],
    "application/atomdeleted+xml": [
        "atomdeleted"
    ],
    "application/atomsvc+xml": [
        "atomsvc"
    ],
    "application/atsc-dwd+xml": [
        "dwd"
    ],
    "application/atsc-held+xml": [
        "held"
    ],
    "application/atsc-rsat+xml": [
        "rsat"
    ],
    "application/bdoc": [
        "bdoc"
    ],
    "application/calendar+xml": [
        "xcs"
    ],
    "application/ccxml+xml": [
        "ccxml"
    ],
    "application/cdfx+xml": [
        "cdfx"
    ],
    "application/cdmi-capability": [
        "cdmia"
    ],
    "application/cdmi-container": [
        "cdmic"
    ],
    "application/cdmi-domain": [
        "cdmid"
    ],
    "application/cdmi-object": [
        "cdmio"
    ],
    "application/cdmi-queue": [
        "cdmiq"
    ],
    "application/cu-seeme": [
        "cu"
    ],
    "application/dash+xml": [
        "mpd"
    ],
    "application/davmount+xml": [
        "davmount"
    ],
    "application/docbook+xml": [
        "dbk"
    ],
    "application/dssc+der": [
        "dssc"
    ],
    "application/dssc+xml": [
        "xdssc"
    ],
    "application/ecmascript": [
        "es",
        "ecma"
    ],
    "application/emma+xml": [
        "emma"
    ],
    "application/emotionml+xml": [
        "emotionml"
    ],
    "application/epub+zip": [
        "epub"
    ],
    "application/exi": [
        "exi"
    ],
    "application/express": [
        "exp"
    ],
    "application/fdt+xml": [
        "fdt"
    ],
    "application/font-tdpfr": [
        "pfr"
    ],
    "application/geo+json": [
        "geojson"
    ],
    "application/gml+xml": [
        "gml"
    ],
    "application/gpx+xml": [
        "gpx"
    ],
    "application/gxf": [
        "gxf"
    ],
    "application/gzip": [
        "gz"
    ],
    "application/hjson": [
        "hjson"
    ],
    "application/hyperstudio": [
        "stk"
    ],
    "application/inkml+xml": [
        "ink",
        "inkml"
    ],
    "application/ipfix": [
        "ipfix"
    ],
    "application/its+xml": [
        "its"
    ],
    "application/java-archive": [
        "jar",
        "war",
        "ear"
    ],
    "application/java-serialized-object": [
        "ser"
    ],
    "application/java-vm": [
        "class"
    ],
    "application/javascript": [
        "js",
        "mjs"
    ],
    "application/json": [
        "json",
        "map"
    ],
    "application/json5": [
        "json5"
    ],
    "application/jsonml+json": [
        "jsonml"
    ],
    "application/ld+json": [
        "jsonld"
    ],
    "application/lgr+xml": [
        "lgr"
    ],
    "application/lost+xml": [
        "lostxml"
    ],
    "application/mac-binhex40": [
        "hqx"
    ],
    "application/mac-compactpro": [
        "cpt"
    ],
    "application/mads+xml": [
        "mads"
    ],
    "application/manifest+json": [
        "webmanifest"
    ],
    "application/marc": [
        "mrc"
    ],
    "application/marcxml+xml": [
        "mrcx"
    ],
    "application/mathematica": [
        "ma",
        "nb",
        "mb"
    ],
    "application/mathml+xml": [
        "mathml"
    ],
    "application/mbox": [
        "mbox"
    ],
    "application/mediaservercontrol+xml": [
        "mscml"
    ],
    "application/metalink+xml": [
        "metalink"
    ],
    "application/metalink4+xml": [
        "meta4"
    ],
    "application/mets+xml": [
        "mets"
    ],
    "application/mmt-aei+xml": [
        "maei"
    ],
    "application/mmt-usd+xml": [
        "musd"
    ],
    "application/mods+xml": [
        "mods"
    ],
    "application/mp21": [
        "m21",
        "mp21"
    ],
    "application/mp4": [
        "mp4s",
        "m4p"
    ],
    "application/msword": [
        "doc",
        "dot"
    ],
    "application/mxf": [
        "mxf"
    ],
    "application/n-quads": [
        "nq"
    ],
    "application/n-triples": [
        "nt"
    ],
    "application/node": [
        "cjs"
    ],
    "application/octet-stream": [
        "bin",
        "dms",
        "lrf",
        "mar",
        "so",
        "dist",
        "distz",
        "pkg",
        "bpk",
        "dump",
        "elc",
        "deploy",
        "exe",
        "dll",
        "deb",
        "dmg",
        "iso",
        "img",
        "msi",
        "msp",
        "msm",
        "buffer"
    ],
    "application/oda": [
        "oda"
    ],
    "application/oebps-package+xml": [
        "opf"
    ],
    "application/ogg": [
        "ogx"
    ],
    "application/omdoc+xml": [
        "omdoc"
    ],
    "application/onenote": [
        "onetoc",
        "onetoc2",
        "onetmp",
        "onepkg"
    ],
    "application/oxps": [
        "oxps"
    ],
    "application/p2p-overlay+xml": [
        "relo"
    ],
    "application/patch-ops-error+xml": [
        "xer"
    ],
    "application/pdf": [
        "pdf"
    ],
    "application/pgp-encrypted": [
        "pgp"
    ],
    "application/pgp-signature": [
        "asc",
        "sig"
    ],
    "application/pics-rules": [
        "prf"
    ],
    "application/pkcs10": [
        "p10"
    ],
    "application/pkcs7-mime": [
        "p7m",
        "p7c"
    ],
    "application/pkcs7-signature": [
        "p7s"
    ],
    "application/pkcs8": [
        "p8"
    ],
    "application/pkix-attr-cert": [
        "ac"
    ],
    "application/pkix-cert": [
        "cer"
    ],
    "application/pkix-crl": [
        "crl"
    ],
    "application/pkix-pkipath": [
        "pkipath"
    ],
    "application/pkixcmp": [
        "pki"
    ],
    "application/pls+xml": [
        "pls"
    ],
    "application/postscript": [
        "ai",
        "eps",
        "ps"
    ],
    "application/provenance+xml": [
        "provx"
    ],
    "application/pskc+xml": [
        "pskcxml"
    ],
    "application/raml+yaml": [
        "raml"
    ],
    "application/rdf+xml": [
        "rdf",
        "owl"
    ],
    "application/reginfo+xml": [
        "rif"
    ],
    "application/relax-ng-compact-syntax": [
        "rnc"
    ],
    "application/resource-lists+xml": [
        "rl"
    ],
    "application/resource-lists-diff+xml": [
        "rld"
    ],
    "application/rls-services+xml": [
        "rs"
    ],
    "application/route-apd+xml": [
        "rapd"
    ],
    "application/route-s-tsid+xml": [
        "sls"
    ],
    "application/route-usd+xml": [
        "rusd"
    ],
    "application/rpki-ghostbusters": [
        "gbr"
    ],
    "application/rpki-manifest": [
        "mft"
    ],
    "application/rpki-roa": [
        "roa"
    ],
    "application/rsd+xml": [
        "rsd"
    ],
    "application/rss+xml": [
        "rss"
    ],
    "application/rtf": [
        "rtf"
    ],
    "application/sbml+xml": [
        "sbml"
    ],
    "application/scvp-cv-request": [
        "scq"
    ],
    "application/scvp-cv-response": [
        "scs"
    ],
    "application/scvp-vp-request": [
        "spq"
    ],
    "application/scvp-vp-response": [
        "spp"
    ],
    "application/sdp": [
        "sdp"
    ],
    "application/senml+xml": [
        "senmlx"
    ],
    "application/sensml+xml": [
        "sensmlx"
    ],
    "application/set-payment-initiation": [
        "setpay"
    ],
    "application/set-registration-initiation": [
        "setreg"
    ],
    "application/shf+xml": [
        "shf"
    ],
    "application/sieve": [
        "siv",
        "sieve"
    ],
    "application/smil+xml": [
        "smi",
        "smil"
    ],
    "application/sparql-query": [
        "rq"
    ],
    "application/sparql-results+xml": [
        "srx"
    ],
    "application/srgs": [
        "gram"
    ],
    "application/srgs+xml": [
        "grxml"
    ],
    "application/sru+xml": [
        "sru"
    ],
    "application/ssdl+xml": [
        "ssdl"
    ],
    "application/ssml+xml": [
        "ssml"
    ],
    "application/swid+xml": [
        "swidtag"
    ],
    "application/tei+xml": [
        "tei",
        "teicorpus"
    ],
    "application/thraud+xml": [
        "tfi"
    ],
    "application/timestamped-data": [
        "tsd"
    ],
    "application/toml": [
        "toml"
    ],
    "application/trig": [
        "trig"
    ],
    "application/ttml+xml": [
        "ttml"
    ],
    "application/ubjson": [
        "ubj"
    ],
    "application/urc-ressheet+xml": [
        "rsheet"
    ],
    "application/urc-targetdesc+xml": [
        "td"
    ],
    "application/voicexml+xml": [
        "vxml"
    ],
    "application/wasm": [
        "wasm"
    ],
    "application/widget": [
        "wgt"
    ],
    "application/winhlp": [
        "hlp"
    ],
    "application/wsdl+xml": [
        "wsdl"
    ],
    "application/wspolicy+xml": [
        "wspolicy"
    ],
    "application/xaml+xml": [
        "xaml"
    ],
    "application/xcap-att+xml": [
        "xav"
    ],
    "application/xcap-caps+xml": [
        "xca"
    ],
    "application/xcap-diff+xml": [
        "xdf"
    ],
    "application/xcap-el+xml": [
        "xel"
    ],
    "application/xcap-ns+xml": [
        "xns"
    ],
    "application/xenc+xml": [
        "xenc"
    ],
    "application/xhtml+xml": [
        "xhtml",
        "xht"
    ],
    "application/xliff+xml": [
        "xlf"
    ],
    "application/xml": [
        "xml",
        "xsl",
        "xsd",
        "rng"
    ],
    "application/xml-dtd": [
        "dtd"
    ],
    "application/xop+xml": [
        "xop"
    ],
    "application/xproc+xml": [
        "xpl"
    ],
    "application/xslt+xml": [
        "*xsl",
        "xslt"
    ],
    "application/xspf+xml": [
        "xspf"
    ],
    "application/xv+xml": [
        "mxml",
        "xhvml",
        "xvml",
        "xvm"
    ],
    "application/yang": [
        "yang"
    ],
    "application/yin+xml": [
        "yin"
    ],
    "application/zip": [
        "zip"
    ],
    "audio/3gpp": [
        "*3gpp"
    ],
    "audio/adpcm": [
        "adp"
    ],
    "audio/amr": [
        "amr"
    ],
    "audio/basic": [
        "au",
        "snd"
    ],
    "audio/midi": [
        "mid",
        "midi",
        "kar",
        "rmi"
    ],
    "audio/mobile-xmf": [
        "mxmf"
    ],
    "audio/mp3": [
        "*mp3"
    ],
    "audio/mp4": [
        "m4a",
        "mp4a"
    ],
    "audio/mpeg": [
        "mpga",
        "mp2",
        "mp2a",
        "mp3",
        "m2a",
        "m3a"
    ],
    "audio/ogg": [
        "oga",
        "ogg",
        "spx",
        "opus"
    ],
    "audio/s3m": [
        "s3m"
    ],
    "audio/silk": [
        "sil"
    ],
    "audio/wav": [
        "wav"
    ],
    "audio/wave": [
        "*wav"
    ],
    "audio/webm": [
        "weba"
    ],
    "audio/xm": [
        "xm"
    ],
    "font/collection": [
        "ttc"
    ],
    "font/otf": [
        "otf"
    ],
    "font/ttf": [
        "ttf"
    ],
    "font/woff": [
        "woff"
    ],
    "font/woff2": [
        "woff2"
    ],
    "image/aces": [
        "exr"
    ],
    "image/apng": [
        "apng"
    ],
    "image/avif": [
        "avif"
    ],
    "image/bmp": [
        "bmp"
    ],
    "image/cgm": [
        "cgm"
    ],
    "image/dicom-rle": [
        "drle"
    ],
    "image/emf": [
        "emf"
    ],
    "image/fits": [
        "fits"
    ],
    "image/g3fax": [
        "g3"
    ],
    "image/gif": [
        "gif"
    ],
    "image/heic": [
        "heic"
    ],
    "image/heic-sequence": [
        "heics"
    ],
    "image/heif": [
        "heif"
    ],
    "image/heif-sequence": [
        "heifs"
    ],
    "image/hej2k": [
        "hej2"
    ],
    "image/hsj2": [
        "hsj2"
    ],
    "image/ief": [
        "ief"
    ],
    "image/jls": [
        "jls"
    ],
    "image/jp2": [
        "jp2",
        "jpg2"
    ],
    "image/jpeg": [
        "jpeg",
        "jpg",
        "jpe"
    ],
    "image/jph": [
        "jph"
    ],
    "image/jphc": [
        "jhc"
    ],
    "image/jpm": [
        "jpm"
    ],
    "image/jpx": [
        "jpx",
        "jpf"
    ],
    "image/jxr": [
        "jxr"
    ],
    "image/jxra": [
        "jxra"
    ],
    "image/jxrs": [
        "jxrs"
    ],
    "image/jxs": [
        "jxs"
    ],
    "image/jxsc": [
        "jxsc"
    ],
    "image/jxsi": [
        "jxsi"
    ],
    "image/jxss": [
        "jxss"
    ],
    "image/ktx": [
        "ktx"
    ],
    "image/ktx2": [
        "ktx2"
    ],
    "image/png": [
        "png"
    ],
    "image/sgi": [
        "sgi"
    ],
    "image/svg+xml": [
        "svg",
        "svgz"
    ],
    "image/t38": [
        "t38"
    ],
    "image/tiff": [
        "tif",
        "tiff"
    ],
    "image/tiff-fx": [
        "tfx"
    ],
    "image/webp": [
        "webp"
    ],
    "image/wmf": [
        "wmf"
    ],
    "message/disposition-notification": [
        "disposition-notification"
    ],
    "message/global": [
        "u8msg"
    ],
    "message/global-delivery-status": [
        "u8dsn"
    ],
    "message/global-disposition-notification": [
        "u8mdn"
    ],
    "message/global-headers": [
        "u8hdr"
    ],
    "message/rfc822": [
        "eml",
        "mime"
    ],
    "model/3mf": [
        "3mf"
    ],
    "model/gltf+json": [
        "gltf"
    ],
    "model/gltf-binary": [
        "glb"
    ],
    "model/iges": [
        "igs",
        "iges"
    ],
    "model/mesh": [
        "msh",
        "mesh",
        "silo"
    ],
    "model/mtl": [
        "mtl"
    ],
    "model/obj": [
        "obj"
    ],
    "model/step+xml": [
        "stpx"
    ],
    "model/step+zip": [
        "stpz"
    ],
    "model/step-xml+zip": [
        "stpxz"
    ],
    "model/stl": [
        "stl"
    ],
    "model/vrml": [
        "wrl",
        "vrml"
    ],
    "model/x3d+binary": [
        "*x3db",
        "x3dbz"
    ],
    "model/x3d+fastinfoset": [
        "x3db"
    ],
    "model/x3d+vrml": [
        "*x3dv",
        "x3dvz"
    ],
    "model/x3d+xml": [
        "x3d",
        "x3dz"
    ],
    "model/x3d-vrml": [
        "x3dv"
    ],
    "text/cache-manifest": [
        "appcache",
        "manifest"
    ],
    "text/calendar": [
        "ics",
        "ifb"
    ],
    "text/coffeescript": [
        "coffee",
        "litcoffee"
    ],
    "text/css": [
        "css"
    ],
    "text/csv": [
        "csv"
    ],
    "text/html": [
        "html",
        "htm",
        "shtml"
    ],
    "text/jade": [
        "jade"
    ],
    "text/jsx": [
        "jsx"
    ],
    "text/less": [
        "less"
    ],
    "text/markdown": [
        "markdown",
        "md"
    ],
    "text/mathml": [
        "mml"
    ],
    "text/mdx": [
        "mdx"
    ],
    "text/n3": [
        "n3"
    ],
    "text/plain": [
        "txt",
        "text",
        "conf",
        "def",
        "list",
        "log",
        "in",
        "ini"
    ],
    "text/richtext": [
        "rtx"
    ],
    "text/rtf": [
        "*rtf"
    ],
    "text/sgml": [
        "sgml",
        "sgm"
    ],
    "text/shex": [
        "shex"
    ],
    "text/slim": [
        "slim",
        "slm"
    ],
    "text/spdx": [
        "spdx"
    ],
    "text/stylus": [
        "stylus",
        "styl"
    ],
    "text/tab-separated-values": [
        "tsv"
    ],
    "text/troff": [
        "t",
        "tr",
        "roff",
        "man",
        "me",
        "ms"
    ],
    "text/turtle": [
        "ttl"
    ],
    "text/uri-list": [
        "uri",
        "uris",
        "urls"
    ],
    "text/vcard": [
        "vcard"
    ],
    "text/vtt": [
        "vtt"
    ],
    "text/xml": [
        "*xml"
    ],
    "text/yaml": [
        "yaml",
        "yml"
    ],
    "video/3gpp": [
        "3gp",
        "3gpp"
    ],
    "video/3gpp2": [
        "3g2"
    ],
    "video/h261": [
        "h261"
    ],
    "video/h263": [
        "h263"
    ],
    "video/h264": [
        "h264"
    ],
    "video/iso.segment": [
        "m4s"
    ],
    "video/jpeg": [
        "jpgv"
    ],
    "video/jpm": [
        "*jpm",
        "jpgm"
    ],
    "video/mj2": [
        "mj2",
        "mjp2"
    ],
    "video/mp2t": [
        "ts"
    ],
    "video/mp4": [
        "mp4",
        "mp4v",
        "mpg4"
    ],
    "video/mpeg": [
        "mpeg",
        "mpg",
        "mpe",
        "m1v",
        "m2v"
    ],
    "video/ogg": [
        "ogv"
    ],
    "video/quicktime": [
        "qt",
        "mov"
    ],
    "video/webm": [
        "webm"
    ]
};

},{}],"kkBBC":[function(require,module,exports) {
module.exports = {
    "application/prs.cww": [
        "cww"
    ],
    "application/vnd.1000minds.decision-model+xml": [
        "1km"
    ],
    "application/vnd.3gpp.pic-bw-large": [
        "plb"
    ],
    "application/vnd.3gpp.pic-bw-small": [
        "psb"
    ],
    "application/vnd.3gpp.pic-bw-var": [
        "pvb"
    ],
    "application/vnd.3gpp2.tcap": [
        "tcap"
    ],
    "application/vnd.3m.post-it-notes": [
        "pwn"
    ],
    "application/vnd.accpac.simply.aso": [
        "aso"
    ],
    "application/vnd.accpac.simply.imp": [
        "imp"
    ],
    "application/vnd.acucobol": [
        "acu"
    ],
    "application/vnd.acucorp": [
        "atc",
        "acutc"
    ],
    "application/vnd.adobe.air-application-installer-package+zip": [
        "air"
    ],
    "application/vnd.adobe.formscentral.fcdt": [
        "fcdt"
    ],
    "application/vnd.adobe.fxp": [
        "fxp",
        "fxpl"
    ],
    "application/vnd.adobe.xdp+xml": [
        "xdp"
    ],
    "application/vnd.adobe.xfdf": [
        "xfdf"
    ],
    "application/vnd.ahead.space": [
        "ahead"
    ],
    "application/vnd.airzip.filesecure.azf": [
        "azf"
    ],
    "application/vnd.airzip.filesecure.azs": [
        "azs"
    ],
    "application/vnd.amazon.ebook": [
        "azw"
    ],
    "application/vnd.americandynamics.acc": [
        "acc"
    ],
    "application/vnd.amiga.ami": [
        "ami"
    ],
    "application/vnd.android.package-archive": [
        "apk"
    ],
    "application/vnd.anser-web-certificate-issue-initiation": [
        "cii"
    ],
    "application/vnd.anser-web-funds-transfer-initiation": [
        "fti"
    ],
    "application/vnd.antix.game-component": [
        "atx"
    ],
    "application/vnd.apple.installer+xml": [
        "mpkg"
    ],
    "application/vnd.apple.keynote": [
        "key"
    ],
    "application/vnd.apple.mpegurl": [
        "m3u8"
    ],
    "application/vnd.apple.numbers": [
        "numbers"
    ],
    "application/vnd.apple.pages": [
        "pages"
    ],
    "application/vnd.apple.pkpass": [
        "pkpass"
    ],
    "application/vnd.aristanetworks.swi": [
        "swi"
    ],
    "application/vnd.astraea-software.iota": [
        "iota"
    ],
    "application/vnd.audiograph": [
        "aep"
    ],
    "application/vnd.balsamiq.bmml+xml": [
        "bmml"
    ],
    "application/vnd.blueice.multipass": [
        "mpm"
    ],
    "application/vnd.bmi": [
        "bmi"
    ],
    "application/vnd.businessobjects": [
        "rep"
    ],
    "application/vnd.chemdraw+xml": [
        "cdxml"
    ],
    "application/vnd.chipnuts.karaoke-mmd": [
        "mmd"
    ],
    "application/vnd.cinderella": [
        "cdy"
    ],
    "application/vnd.citationstyles.style+xml": [
        "csl"
    ],
    "application/vnd.claymore": [
        "cla"
    ],
    "application/vnd.cloanto.rp9": [
        "rp9"
    ],
    "application/vnd.clonk.c4group": [
        "c4g",
        "c4d",
        "c4f",
        "c4p",
        "c4u"
    ],
    "application/vnd.cluetrust.cartomobile-config": [
        "c11amc"
    ],
    "application/vnd.cluetrust.cartomobile-config-pkg": [
        "c11amz"
    ],
    "application/vnd.commonspace": [
        "csp"
    ],
    "application/vnd.contact.cmsg": [
        "cdbcmsg"
    ],
    "application/vnd.cosmocaller": [
        "cmc"
    ],
    "application/vnd.crick.clicker": [
        "clkx"
    ],
    "application/vnd.crick.clicker.keyboard": [
        "clkk"
    ],
    "application/vnd.crick.clicker.palette": [
        "clkp"
    ],
    "application/vnd.crick.clicker.template": [
        "clkt"
    ],
    "application/vnd.crick.clicker.wordbank": [
        "clkw"
    ],
    "application/vnd.criticaltools.wbs+xml": [
        "wbs"
    ],
    "application/vnd.ctc-posml": [
        "pml"
    ],
    "application/vnd.cups-ppd": [
        "ppd"
    ],
    "application/vnd.curl.car": [
        "car"
    ],
    "application/vnd.curl.pcurl": [
        "pcurl"
    ],
    "application/vnd.dart": [
        "dart"
    ],
    "application/vnd.data-vision.rdz": [
        "rdz"
    ],
    "application/vnd.dbf": [
        "dbf"
    ],
    "application/vnd.dece.data": [
        "uvf",
        "uvvf",
        "uvd",
        "uvvd"
    ],
    "application/vnd.dece.ttml+xml": [
        "uvt",
        "uvvt"
    ],
    "application/vnd.dece.unspecified": [
        "uvx",
        "uvvx"
    ],
    "application/vnd.dece.zip": [
        "uvz",
        "uvvz"
    ],
    "application/vnd.denovo.fcselayout-link": [
        "fe_launch"
    ],
    "application/vnd.dna": [
        "dna"
    ],
    "application/vnd.dolby.mlp": [
        "mlp"
    ],
    "application/vnd.dpgraph": [
        "dpg"
    ],
    "application/vnd.dreamfactory": [
        "dfac"
    ],
    "application/vnd.ds-keypoint": [
        "kpxx"
    ],
    "application/vnd.dvb.ait": [
        "ait"
    ],
    "application/vnd.dvb.service": [
        "svc"
    ],
    "application/vnd.dynageo": [
        "geo"
    ],
    "application/vnd.ecowin.chart": [
        "mag"
    ],
    "application/vnd.enliven": [
        "nml"
    ],
    "application/vnd.epson.esf": [
        "esf"
    ],
    "application/vnd.epson.msf": [
        "msf"
    ],
    "application/vnd.epson.quickanime": [
        "qam"
    ],
    "application/vnd.epson.salt": [
        "slt"
    ],
    "application/vnd.epson.ssf": [
        "ssf"
    ],
    "application/vnd.eszigno3+xml": [
        "es3",
        "et3"
    ],
    "application/vnd.ezpix-album": [
        "ez2"
    ],
    "application/vnd.ezpix-package": [
        "ez3"
    ],
    "application/vnd.fdf": [
        "fdf"
    ],
    "application/vnd.fdsn.mseed": [
        "mseed"
    ],
    "application/vnd.fdsn.seed": [
        "seed",
        "dataless"
    ],
    "application/vnd.flographit": [
        "gph"
    ],
    "application/vnd.fluxtime.clip": [
        "ftc"
    ],
    "application/vnd.framemaker": [
        "fm",
        "frame",
        "maker",
        "book"
    ],
    "application/vnd.frogans.fnc": [
        "fnc"
    ],
    "application/vnd.frogans.ltf": [
        "ltf"
    ],
    "application/vnd.fsc.weblaunch": [
        "fsc"
    ],
    "application/vnd.fujitsu.oasys": [
        "oas"
    ],
    "application/vnd.fujitsu.oasys2": [
        "oa2"
    ],
    "application/vnd.fujitsu.oasys3": [
        "oa3"
    ],
    "application/vnd.fujitsu.oasysgp": [
        "fg5"
    ],
    "application/vnd.fujitsu.oasysprs": [
        "bh2"
    ],
    "application/vnd.fujixerox.ddd": [
        "ddd"
    ],
    "application/vnd.fujixerox.docuworks": [
        "xdw"
    ],
    "application/vnd.fujixerox.docuworks.binder": [
        "xbd"
    ],
    "application/vnd.fuzzysheet": [
        "fzs"
    ],
    "application/vnd.genomatix.tuxedo": [
        "txd"
    ],
    "application/vnd.geogebra.file": [
        "ggb"
    ],
    "application/vnd.geogebra.tool": [
        "ggt"
    ],
    "application/vnd.geometry-explorer": [
        "gex",
        "gre"
    ],
    "application/vnd.geonext": [
        "gxt"
    ],
    "application/vnd.geoplan": [
        "g2w"
    ],
    "application/vnd.geospace": [
        "g3w"
    ],
    "application/vnd.gmx": [
        "gmx"
    ],
    "application/vnd.google-apps.document": [
        "gdoc"
    ],
    "application/vnd.google-apps.presentation": [
        "gslides"
    ],
    "application/vnd.google-apps.spreadsheet": [
        "gsheet"
    ],
    "application/vnd.google-earth.kml+xml": [
        "kml"
    ],
    "application/vnd.google-earth.kmz": [
        "kmz"
    ],
    "application/vnd.grafeq": [
        "gqf",
        "gqs"
    ],
    "application/vnd.groove-account": [
        "gac"
    ],
    "application/vnd.groove-help": [
        "ghf"
    ],
    "application/vnd.groove-identity-message": [
        "gim"
    ],
    "application/vnd.groove-injector": [
        "grv"
    ],
    "application/vnd.groove-tool-message": [
        "gtm"
    ],
    "application/vnd.groove-tool-template": [
        "tpl"
    ],
    "application/vnd.groove-vcard": [
        "vcg"
    ],
    "application/vnd.hal+xml": [
        "hal"
    ],
    "application/vnd.handheld-entertainment+xml": [
        "zmm"
    ],
    "application/vnd.hbci": [
        "hbci"
    ],
    "application/vnd.hhe.lesson-player": [
        "les"
    ],
    "application/vnd.hp-hpgl": [
        "hpgl"
    ],
    "application/vnd.hp-hpid": [
        "hpid"
    ],
    "application/vnd.hp-hps": [
        "hps"
    ],
    "application/vnd.hp-jlyt": [
        "jlt"
    ],
    "application/vnd.hp-pcl": [
        "pcl"
    ],
    "application/vnd.hp-pclxl": [
        "pclxl"
    ],
    "application/vnd.hydrostatix.sof-data": [
        "sfd-hdstx"
    ],
    "application/vnd.ibm.minipay": [
        "mpy"
    ],
    "application/vnd.ibm.modcap": [
        "afp",
        "listafp",
        "list3820"
    ],
    "application/vnd.ibm.rights-management": [
        "irm"
    ],
    "application/vnd.ibm.secure-container": [
        "sc"
    ],
    "application/vnd.iccprofile": [
        "icc",
        "icm"
    ],
    "application/vnd.igloader": [
        "igl"
    ],
    "application/vnd.immervision-ivp": [
        "ivp"
    ],
    "application/vnd.immervision-ivu": [
        "ivu"
    ],
    "application/vnd.insors.igm": [
        "igm"
    ],
    "application/vnd.intercon.formnet": [
        "xpw",
        "xpx"
    ],
    "application/vnd.intergeo": [
        "i2g"
    ],
    "application/vnd.intu.qbo": [
        "qbo"
    ],
    "application/vnd.intu.qfx": [
        "qfx"
    ],
    "application/vnd.ipunplugged.rcprofile": [
        "rcprofile"
    ],
    "application/vnd.irepository.package+xml": [
        "irp"
    ],
    "application/vnd.is-xpr": [
        "xpr"
    ],
    "application/vnd.isac.fcs": [
        "fcs"
    ],
    "application/vnd.jam": [
        "jam"
    ],
    "application/vnd.jcp.javame.midlet-rms": [
        "rms"
    ],
    "application/vnd.jisp": [
        "jisp"
    ],
    "application/vnd.joost.joda-archive": [
        "joda"
    ],
    "application/vnd.kahootz": [
        "ktz",
        "ktr"
    ],
    "application/vnd.kde.karbon": [
        "karbon"
    ],
    "application/vnd.kde.kchart": [
        "chrt"
    ],
    "application/vnd.kde.kformula": [
        "kfo"
    ],
    "application/vnd.kde.kivio": [
        "flw"
    ],
    "application/vnd.kde.kontour": [
        "kon"
    ],
    "application/vnd.kde.kpresenter": [
        "kpr",
        "kpt"
    ],
    "application/vnd.kde.kspread": [
        "ksp"
    ],
    "application/vnd.kde.kword": [
        "kwd",
        "kwt"
    ],
    "application/vnd.kenameaapp": [
        "htke"
    ],
    "application/vnd.kidspiration": [
        "kia"
    ],
    "application/vnd.kinar": [
        "kne",
        "knp"
    ],
    "application/vnd.koan": [
        "skp",
        "skd",
        "skt",
        "skm"
    ],
    "application/vnd.kodak-descriptor": [
        "sse"
    ],
    "application/vnd.las.las+xml": [
        "lasxml"
    ],
    "application/vnd.llamagraphics.life-balance.desktop": [
        "lbd"
    ],
    "application/vnd.llamagraphics.life-balance.exchange+xml": [
        "lbe"
    ],
    "application/vnd.lotus-1-2-3": [
        "123"
    ],
    "application/vnd.lotus-approach": [
        "apr"
    ],
    "application/vnd.lotus-freelance": [
        "pre"
    ],
    "application/vnd.lotus-notes": [
        "nsf"
    ],
    "application/vnd.lotus-organizer": [
        "org"
    ],
    "application/vnd.lotus-screencam": [
        "scm"
    ],
    "application/vnd.lotus-wordpro": [
        "lwp"
    ],
    "application/vnd.macports.portpkg": [
        "portpkg"
    ],
    "application/vnd.mapbox-vector-tile": [
        "mvt"
    ],
    "application/vnd.mcd": [
        "mcd"
    ],
    "application/vnd.medcalcdata": [
        "mc1"
    ],
    "application/vnd.mediastation.cdkey": [
        "cdkey"
    ],
    "application/vnd.mfer": [
        "mwf"
    ],
    "application/vnd.mfmp": [
        "mfm"
    ],
    "application/vnd.micrografx.flo": [
        "flo"
    ],
    "application/vnd.micrografx.igx": [
        "igx"
    ],
    "application/vnd.mif": [
        "mif"
    ],
    "application/vnd.mobius.daf": [
        "daf"
    ],
    "application/vnd.mobius.dis": [
        "dis"
    ],
    "application/vnd.mobius.mbk": [
        "mbk"
    ],
    "application/vnd.mobius.mqy": [
        "mqy"
    ],
    "application/vnd.mobius.msl": [
        "msl"
    ],
    "application/vnd.mobius.plc": [
        "plc"
    ],
    "application/vnd.mobius.txf": [
        "txf"
    ],
    "application/vnd.mophun.application": [
        "mpn"
    ],
    "application/vnd.mophun.certificate": [
        "mpc"
    ],
    "application/vnd.mozilla.xul+xml": [
        "xul"
    ],
    "application/vnd.ms-artgalry": [
        "cil"
    ],
    "application/vnd.ms-cab-compressed": [
        "cab"
    ],
    "application/vnd.ms-excel": [
        "xls",
        "xlm",
        "xla",
        "xlc",
        "xlt",
        "xlw"
    ],
    "application/vnd.ms-excel.addin.macroenabled.12": [
        "xlam"
    ],
    "application/vnd.ms-excel.sheet.binary.macroenabled.12": [
        "xlsb"
    ],
    "application/vnd.ms-excel.sheet.macroenabled.12": [
        "xlsm"
    ],
    "application/vnd.ms-excel.template.macroenabled.12": [
        "xltm"
    ],
    "application/vnd.ms-fontobject": [
        "eot"
    ],
    "application/vnd.ms-htmlhelp": [
        "chm"
    ],
    "application/vnd.ms-ims": [
        "ims"
    ],
    "application/vnd.ms-lrm": [
        "lrm"
    ],
    "application/vnd.ms-officetheme": [
        "thmx"
    ],
    "application/vnd.ms-outlook": [
        "msg"
    ],
    "application/vnd.ms-pki.seccat": [
        "cat"
    ],
    "application/vnd.ms-pki.stl": [
        "*stl"
    ],
    "application/vnd.ms-powerpoint": [
        "ppt",
        "pps",
        "pot"
    ],
    "application/vnd.ms-powerpoint.addin.macroenabled.12": [
        "ppam"
    ],
    "application/vnd.ms-powerpoint.presentation.macroenabled.12": [
        "pptm"
    ],
    "application/vnd.ms-powerpoint.slide.macroenabled.12": [
        "sldm"
    ],
    "application/vnd.ms-powerpoint.slideshow.macroenabled.12": [
        "ppsm"
    ],
    "application/vnd.ms-powerpoint.template.macroenabled.12": [
        "potm"
    ],
    "application/vnd.ms-project": [
        "mpp",
        "mpt"
    ],
    "application/vnd.ms-word.document.macroenabled.12": [
        "docm"
    ],
    "application/vnd.ms-word.template.macroenabled.12": [
        "dotm"
    ],
    "application/vnd.ms-works": [
        "wps",
        "wks",
        "wcm",
        "wdb"
    ],
    "application/vnd.ms-wpl": [
        "wpl"
    ],
    "application/vnd.ms-xpsdocument": [
        "xps"
    ],
    "application/vnd.mseq": [
        "mseq"
    ],
    "application/vnd.musician": [
        "mus"
    ],
    "application/vnd.muvee.style": [
        "msty"
    ],
    "application/vnd.mynfc": [
        "taglet"
    ],
    "application/vnd.neurolanguage.nlu": [
        "nlu"
    ],
    "application/vnd.nitf": [
        "ntf",
        "nitf"
    ],
    "application/vnd.noblenet-directory": [
        "nnd"
    ],
    "application/vnd.noblenet-sealer": [
        "nns"
    ],
    "application/vnd.noblenet-web": [
        "nnw"
    ],
    "application/vnd.nokia.n-gage.ac+xml": [
        "*ac"
    ],
    "application/vnd.nokia.n-gage.data": [
        "ngdat"
    ],
    "application/vnd.nokia.n-gage.symbian.install": [
        "n-gage"
    ],
    "application/vnd.nokia.radio-preset": [
        "rpst"
    ],
    "application/vnd.nokia.radio-presets": [
        "rpss"
    ],
    "application/vnd.novadigm.edm": [
        "edm"
    ],
    "application/vnd.novadigm.edx": [
        "edx"
    ],
    "application/vnd.novadigm.ext": [
        "ext"
    ],
    "application/vnd.oasis.opendocument.chart": [
        "odc"
    ],
    "application/vnd.oasis.opendocument.chart-template": [
        "otc"
    ],
    "application/vnd.oasis.opendocument.database": [
        "odb"
    ],
    "application/vnd.oasis.opendocument.formula": [
        "odf"
    ],
    "application/vnd.oasis.opendocument.formula-template": [
        "odft"
    ],
    "application/vnd.oasis.opendocument.graphics": [
        "odg"
    ],
    "application/vnd.oasis.opendocument.graphics-template": [
        "otg"
    ],
    "application/vnd.oasis.opendocument.image": [
        "odi"
    ],
    "application/vnd.oasis.opendocument.image-template": [
        "oti"
    ],
    "application/vnd.oasis.opendocument.presentation": [
        "odp"
    ],
    "application/vnd.oasis.opendocument.presentation-template": [
        "otp"
    ],
    "application/vnd.oasis.opendocument.spreadsheet": [
        "ods"
    ],
    "application/vnd.oasis.opendocument.spreadsheet-template": [
        "ots"
    ],
    "application/vnd.oasis.opendocument.text": [
        "odt"
    ],
    "application/vnd.oasis.opendocument.text-master": [
        "odm"
    ],
    "application/vnd.oasis.opendocument.text-template": [
        "ott"
    ],
    "application/vnd.oasis.opendocument.text-web": [
        "oth"
    ],
    "application/vnd.olpc-sugar": [
        "xo"
    ],
    "application/vnd.oma.dd2+xml": [
        "dd2"
    ],
    "application/vnd.openblox.game+xml": [
        "obgx"
    ],
    "application/vnd.openofficeorg.extension": [
        "oxt"
    ],
    "application/vnd.openstreetmap.data+xml": [
        "osm"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
        "pptx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slide": [
        "sldx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
        "ppsx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.template": [
        "potx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        "xlsx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
        "xltx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
        "docx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
        "dotx"
    ],
    "application/vnd.osgeo.mapguide.package": [
        "mgp"
    ],
    "application/vnd.osgi.dp": [
        "dp"
    ],
    "application/vnd.osgi.subsystem": [
        "esa"
    ],
    "application/vnd.palm": [
        "pdb",
        "pqa",
        "oprc"
    ],
    "application/vnd.pawaafile": [
        "paw"
    ],
    "application/vnd.pg.format": [
        "str"
    ],
    "application/vnd.pg.osasli": [
        "ei6"
    ],
    "application/vnd.picsel": [
        "efif"
    ],
    "application/vnd.pmi.widget": [
        "wg"
    ],
    "application/vnd.pocketlearn": [
        "plf"
    ],
    "application/vnd.powerbuilder6": [
        "pbd"
    ],
    "application/vnd.previewsystems.box": [
        "box"
    ],
    "application/vnd.proteus.magazine": [
        "mgz"
    ],
    "application/vnd.publishare-delta-tree": [
        "qps"
    ],
    "application/vnd.pvi.ptid1": [
        "ptid"
    ],
    "application/vnd.quark.quarkxpress": [
        "qxd",
        "qxt",
        "qwd",
        "qwt",
        "qxl",
        "qxb"
    ],
    "application/vnd.rar": [
        "rar"
    ],
    "application/vnd.realvnc.bed": [
        "bed"
    ],
    "application/vnd.recordare.musicxml": [
        "mxl"
    ],
    "application/vnd.recordare.musicxml+xml": [
        "musicxml"
    ],
    "application/vnd.rig.cryptonote": [
        "cryptonote"
    ],
    "application/vnd.rim.cod": [
        "cod"
    ],
    "application/vnd.rn-realmedia": [
        "rm"
    ],
    "application/vnd.rn-realmedia-vbr": [
        "rmvb"
    ],
    "application/vnd.route66.link66+xml": [
        "link66"
    ],
    "application/vnd.sailingtracker.track": [
        "st"
    ],
    "application/vnd.seemail": [
        "see"
    ],
    "application/vnd.sema": [
        "sema"
    ],
    "application/vnd.semd": [
        "semd"
    ],
    "application/vnd.semf": [
        "semf"
    ],
    "application/vnd.shana.informed.formdata": [
        "ifm"
    ],
    "application/vnd.shana.informed.formtemplate": [
        "itp"
    ],
    "application/vnd.shana.informed.interchange": [
        "iif"
    ],
    "application/vnd.shana.informed.package": [
        "ipk"
    ],
    "application/vnd.simtech-mindmapper": [
        "twd",
        "twds"
    ],
    "application/vnd.smaf": [
        "mmf"
    ],
    "application/vnd.smart.teacher": [
        "teacher"
    ],
    "application/vnd.software602.filler.form+xml": [
        "fo"
    ],
    "application/vnd.solent.sdkm+xml": [
        "sdkm",
        "sdkd"
    ],
    "application/vnd.spotfire.dxp": [
        "dxp"
    ],
    "application/vnd.spotfire.sfs": [
        "sfs"
    ],
    "application/vnd.stardivision.calc": [
        "sdc"
    ],
    "application/vnd.stardivision.draw": [
        "sda"
    ],
    "application/vnd.stardivision.impress": [
        "sdd"
    ],
    "application/vnd.stardivision.math": [
        "smf"
    ],
    "application/vnd.stardivision.writer": [
        "sdw",
        "vor"
    ],
    "application/vnd.stardivision.writer-global": [
        "sgl"
    ],
    "application/vnd.stepmania.package": [
        "smzip"
    ],
    "application/vnd.stepmania.stepchart": [
        "sm"
    ],
    "application/vnd.sun.wadl+xml": [
        "wadl"
    ],
    "application/vnd.sun.xml.calc": [
        "sxc"
    ],
    "application/vnd.sun.xml.calc.template": [
        "stc"
    ],
    "application/vnd.sun.xml.draw": [
        "sxd"
    ],
    "application/vnd.sun.xml.draw.template": [
        "std"
    ],
    "application/vnd.sun.xml.impress": [
        "sxi"
    ],
    "application/vnd.sun.xml.impress.template": [
        "sti"
    ],
    "application/vnd.sun.xml.math": [
        "sxm"
    ],
    "application/vnd.sun.xml.writer": [
        "sxw"
    ],
    "application/vnd.sun.xml.writer.global": [
        "sxg"
    ],
    "application/vnd.sun.xml.writer.template": [
        "stw"
    ],
    "application/vnd.sus-calendar": [
        "sus",
        "susp"
    ],
    "application/vnd.svd": [
        "svd"
    ],
    "application/vnd.symbian.install": [
        "sis",
        "sisx"
    ],
    "application/vnd.syncml+xml": [
        "xsm"
    ],
    "application/vnd.syncml.dm+wbxml": [
        "bdm"
    ],
    "application/vnd.syncml.dm+xml": [
        "xdm"
    ],
    "application/vnd.syncml.dmddf+xml": [
        "ddf"
    ],
    "application/vnd.tao.intent-module-archive": [
        "tao"
    ],
    "application/vnd.tcpdump.pcap": [
        "pcap",
        "cap",
        "dmp"
    ],
    "application/vnd.tmobile-livetv": [
        "tmo"
    ],
    "application/vnd.trid.tpt": [
        "tpt"
    ],
    "application/vnd.triscape.mxs": [
        "mxs"
    ],
    "application/vnd.trueapp": [
        "tra"
    ],
    "application/vnd.ufdl": [
        "ufd",
        "ufdl"
    ],
    "application/vnd.uiq.theme": [
        "utz"
    ],
    "application/vnd.umajin": [
        "umj"
    ],
    "application/vnd.unity": [
        "unityweb"
    ],
    "application/vnd.uoml+xml": [
        "uoml"
    ],
    "application/vnd.vcx": [
        "vcx"
    ],
    "application/vnd.visio": [
        "vsd",
        "vst",
        "vss",
        "vsw"
    ],
    "application/vnd.visionary": [
        "vis"
    ],
    "application/vnd.vsf": [
        "vsf"
    ],
    "application/vnd.wap.wbxml": [
        "wbxml"
    ],
    "application/vnd.wap.wmlc": [
        "wmlc"
    ],
    "application/vnd.wap.wmlscriptc": [
        "wmlsc"
    ],
    "application/vnd.webturbo": [
        "wtb"
    ],
    "application/vnd.wolfram.player": [
        "nbp"
    ],
    "application/vnd.wordperfect": [
        "wpd"
    ],
    "application/vnd.wqd": [
        "wqd"
    ],
    "application/vnd.wt.stf": [
        "stf"
    ],
    "application/vnd.xara": [
        "xar"
    ],
    "application/vnd.xfdl": [
        "xfdl"
    ],
    "application/vnd.yamaha.hv-dic": [
        "hvd"
    ],
    "application/vnd.yamaha.hv-script": [
        "hvs"
    ],
    "application/vnd.yamaha.hv-voice": [
        "hvp"
    ],
    "application/vnd.yamaha.openscoreformat": [
        "osf"
    ],
    "application/vnd.yamaha.openscoreformat.osfpvg+xml": [
        "osfpvg"
    ],
    "application/vnd.yamaha.smaf-audio": [
        "saf"
    ],
    "application/vnd.yamaha.smaf-phrase": [
        "spf"
    ],
    "application/vnd.yellowriver-custom-menu": [
        "cmp"
    ],
    "application/vnd.zul": [
        "zir",
        "zirz"
    ],
    "application/vnd.zzazz.deck+xml": [
        "zaz"
    ],
    "application/x-7z-compressed": [
        "7z"
    ],
    "application/x-abiword": [
        "abw"
    ],
    "application/x-ace-compressed": [
        "ace"
    ],
    "application/x-apple-diskimage": [
        "*dmg"
    ],
    "application/x-arj": [
        "arj"
    ],
    "application/x-authorware-bin": [
        "aab",
        "x32",
        "u32",
        "vox"
    ],
    "application/x-authorware-map": [
        "aam"
    ],
    "application/x-authorware-seg": [
        "aas"
    ],
    "application/x-bcpio": [
        "bcpio"
    ],
    "application/x-bdoc": [
        "*bdoc"
    ],
    "application/x-bittorrent": [
        "torrent"
    ],
    "application/x-blorb": [
        "blb",
        "blorb"
    ],
    "application/x-bzip": [
        "bz"
    ],
    "application/x-bzip2": [
        "bz2",
        "boz"
    ],
    "application/x-cbr": [
        "cbr",
        "cba",
        "cbt",
        "cbz",
        "cb7"
    ],
    "application/x-cdlink": [
        "vcd"
    ],
    "application/x-cfs-compressed": [
        "cfs"
    ],
    "application/x-chat": [
        "chat"
    ],
    "application/x-chess-pgn": [
        "pgn"
    ],
    "application/x-chrome-extension": [
        "crx"
    ],
    "application/x-cocoa": [
        "cco"
    ],
    "application/x-conference": [
        "nsc"
    ],
    "application/x-cpio": [
        "cpio"
    ],
    "application/x-csh": [
        "csh"
    ],
    "application/x-debian-package": [
        "*deb",
        "udeb"
    ],
    "application/x-dgc-compressed": [
        "dgc"
    ],
    "application/x-director": [
        "dir",
        "dcr",
        "dxr",
        "cst",
        "cct",
        "cxt",
        "w3d",
        "fgd",
        "swa"
    ],
    "application/x-doom": [
        "wad"
    ],
    "application/x-dtbncx+xml": [
        "ncx"
    ],
    "application/x-dtbook+xml": [
        "dtb"
    ],
    "application/x-dtbresource+xml": [
        "res"
    ],
    "application/x-dvi": [
        "dvi"
    ],
    "application/x-envoy": [
        "evy"
    ],
    "application/x-eva": [
        "eva"
    ],
    "application/x-font-bdf": [
        "bdf"
    ],
    "application/x-font-ghostscript": [
        "gsf"
    ],
    "application/x-font-linux-psf": [
        "psf"
    ],
    "application/x-font-pcf": [
        "pcf"
    ],
    "application/x-font-snf": [
        "snf"
    ],
    "application/x-font-type1": [
        "pfa",
        "pfb",
        "pfm",
        "afm"
    ],
    "application/x-freearc": [
        "arc"
    ],
    "application/x-futuresplash": [
        "spl"
    ],
    "application/x-gca-compressed": [
        "gca"
    ],
    "application/x-glulx": [
        "ulx"
    ],
    "application/x-gnumeric": [
        "gnumeric"
    ],
    "application/x-gramps-xml": [
        "gramps"
    ],
    "application/x-gtar": [
        "gtar"
    ],
    "application/x-hdf": [
        "hdf"
    ],
    "application/x-httpd-php": [
        "php"
    ],
    "application/x-install-instructions": [
        "install"
    ],
    "application/x-iso9660-image": [
        "*iso"
    ],
    "application/x-iwork-keynote-sffkey": [
        "*key"
    ],
    "application/x-iwork-numbers-sffnumbers": [
        "*numbers"
    ],
    "application/x-iwork-pages-sffpages": [
        "*pages"
    ],
    "application/x-java-archive-diff": [
        "jardiff"
    ],
    "application/x-java-jnlp-file": [
        "jnlp"
    ],
    "application/x-keepass2": [
        "kdbx"
    ],
    "application/x-latex": [
        "latex"
    ],
    "application/x-lua-bytecode": [
        "luac"
    ],
    "application/x-lzh-compressed": [
        "lzh",
        "lha"
    ],
    "application/x-makeself": [
        "run"
    ],
    "application/x-mie": [
        "mie"
    ],
    "application/x-mobipocket-ebook": [
        "prc",
        "mobi"
    ],
    "application/x-ms-application": [
        "application"
    ],
    "application/x-ms-shortcut": [
        "lnk"
    ],
    "application/x-ms-wmd": [
        "wmd"
    ],
    "application/x-ms-wmz": [
        "wmz"
    ],
    "application/x-ms-xbap": [
        "xbap"
    ],
    "application/x-msaccess": [
        "mdb"
    ],
    "application/x-msbinder": [
        "obd"
    ],
    "application/x-mscardfile": [
        "crd"
    ],
    "application/x-msclip": [
        "clp"
    ],
    "application/x-msdos-program": [
        "*exe"
    ],
    "application/x-msdownload": [
        "*exe",
        "*dll",
        "com",
        "bat",
        "*msi"
    ],
    "application/x-msmediaview": [
        "mvb",
        "m13",
        "m14"
    ],
    "application/x-msmetafile": [
        "*wmf",
        "*wmz",
        "*emf",
        "emz"
    ],
    "application/x-msmoney": [
        "mny"
    ],
    "application/x-mspublisher": [
        "pub"
    ],
    "application/x-msschedule": [
        "scd"
    ],
    "application/x-msterminal": [
        "trm"
    ],
    "application/x-mswrite": [
        "wri"
    ],
    "application/x-netcdf": [
        "nc",
        "cdf"
    ],
    "application/x-ns-proxy-autoconfig": [
        "pac"
    ],
    "application/x-nzb": [
        "nzb"
    ],
    "application/x-perl": [
        "pl",
        "pm"
    ],
    "application/x-pilot": [
        "*prc",
        "*pdb"
    ],
    "application/x-pkcs12": [
        "p12",
        "pfx"
    ],
    "application/x-pkcs7-certificates": [
        "p7b",
        "spc"
    ],
    "application/x-pkcs7-certreqresp": [
        "p7r"
    ],
    "application/x-rar-compressed": [
        "*rar"
    ],
    "application/x-redhat-package-manager": [
        "rpm"
    ],
    "application/x-research-info-systems": [
        "ris"
    ],
    "application/x-sea": [
        "sea"
    ],
    "application/x-sh": [
        "sh"
    ],
    "application/x-shar": [
        "shar"
    ],
    "application/x-shockwave-flash": [
        "swf"
    ],
    "application/x-silverlight-app": [
        "xap"
    ],
    "application/x-sql": [
        "sql"
    ],
    "application/x-stuffit": [
        "sit"
    ],
    "application/x-stuffitx": [
        "sitx"
    ],
    "application/x-subrip": [
        "srt"
    ],
    "application/x-sv4cpio": [
        "sv4cpio"
    ],
    "application/x-sv4crc": [
        "sv4crc"
    ],
    "application/x-t3vm-image": [
        "t3"
    ],
    "application/x-tads": [
        "gam"
    ],
    "application/x-tar": [
        "tar"
    ],
    "application/x-tcl": [
        "tcl",
        "tk"
    ],
    "application/x-tex": [
        "tex"
    ],
    "application/x-tex-tfm": [
        "tfm"
    ],
    "application/x-texinfo": [
        "texinfo",
        "texi"
    ],
    "application/x-tgif": [
        "*obj"
    ],
    "application/x-ustar": [
        "ustar"
    ],
    "application/x-virtualbox-hdd": [
        "hdd"
    ],
    "application/x-virtualbox-ova": [
        "ova"
    ],
    "application/x-virtualbox-ovf": [
        "ovf"
    ],
    "application/x-virtualbox-vbox": [
        "vbox"
    ],
    "application/x-virtualbox-vbox-extpack": [
        "vbox-extpack"
    ],
    "application/x-virtualbox-vdi": [
        "vdi"
    ],
    "application/x-virtualbox-vhd": [
        "vhd"
    ],
    "application/x-virtualbox-vmdk": [
        "vmdk"
    ],
    "application/x-wais-source": [
        "src"
    ],
    "application/x-web-app-manifest+json": [
        "webapp"
    ],
    "application/x-x509-ca-cert": [
        "der",
        "crt",
        "pem"
    ],
    "application/x-xfig": [
        "fig"
    ],
    "application/x-xliff+xml": [
        "*xlf"
    ],
    "application/x-xpinstall": [
        "xpi"
    ],
    "application/x-xz": [
        "xz"
    ],
    "application/x-zmachine": [
        "z1",
        "z2",
        "z3",
        "z4",
        "z5",
        "z6",
        "z7",
        "z8"
    ],
    "audio/vnd.dece.audio": [
        "uva",
        "uvva"
    ],
    "audio/vnd.digital-winds": [
        "eol"
    ],
    "audio/vnd.dra": [
        "dra"
    ],
    "audio/vnd.dts": [
        "dts"
    ],
    "audio/vnd.dts.hd": [
        "dtshd"
    ],
    "audio/vnd.lucent.voice": [
        "lvp"
    ],
    "audio/vnd.ms-playready.media.pya": [
        "pya"
    ],
    "audio/vnd.nuera.ecelp4800": [
        "ecelp4800"
    ],
    "audio/vnd.nuera.ecelp7470": [
        "ecelp7470"
    ],
    "audio/vnd.nuera.ecelp9600": [
        "ecelp9600"
    ],
    "audio/vnd.rip": [
        "rip"
    ],
    "audio/x-aac": [
        "aac"
    ],
    "audio/x-aiff": [
        "aif",
        "aiff",
        "aifc"
    ],
    "audio/x-caf": [
        "caf"
    ],
    "audio/x-flac": [
        "flac"
    ],
    "audio/x-m4a": [
        "*m4a"
    ],
    "audio/x-matroska": [
        "mka"
    ],
    "audio/x-mpegurl": [
        "m3u"
    ],
    "audio/x-ms-wax": [
        "wax"
    ],
    "audio/x-ms-wma": [
        "wma"
    ],
    "audio/x-pn-realaudio": [
        "ram",
        "ra"
    ],
    "audio/x-pn-realaudio-plugin": [
        "rmp"
    ],
    "audio/x-realaudio": [
        "*ra"
    ],
    "audio/x-wav": [
        "*wav"
    ],
    "chemical/x-cdx": [
        "cdx"
    ],
    "chemical/x-cif": [
        "cif"
    ],
    "chemical/x-cmdf": [
        "cmdf"
    ],
    "chemical/x-cml": [
        "cml"
    ],
    "chemical/x-csml": [
        "csml"
    ],
    "chemical/x-xyz": [
        "xyz"
    ],
    "image/prs.btif": [
        "btif"
    ],
    "image/prs.pti": [
        "pti"
    ],
    "image/vnd.adobe.photoshop": [
        "psd"
    ],
    "image/vnd.airzip.accelerator.azv": [
        "azv"
    ],
    "image/vnd.dece.graphic": [
        "uvi",
        "uvvi",
        "uvg",
        "uvvg"
    ],
    "image/vnd.djvu": [
        "djvu",
        "djv"
    ],
    "image/vnd.dvb.subtitle": [
        "*sub"
    ],
    "image/vnd.dwg": [
        "dwg"
    ],
    "image/vnd.dxf": [
        "dxf"
    ],
    "image/vnd.fastbidsheet": [
        "fbs"
    ],
    "image/vnd.fpx": [
        "fpx"
    ],
    "image/vnd.fst": [
        "fst"
    ],
    "image/vnd.fujixerox.edmics-mmr": [
        "mmr"
    ],
    "image/vnd.fujixerox.edmics-rlc": [
        "rlc"
    ],
    "image/vnd.microsoft.icon": [
        "ico"
    ],
    "image/vnd.ms-dds": [
        "dds"
    ],
    "image/vnd.ms-modi": [
        "mdi"
    ],
    "image/vnd.ms-photo": [
        "wdp"
    ],
    "image/vnd.net-fpx": [
        "npx"
    ],
    "image/vnd.pco.b16": [
        "b16"
    ],
    "image/vnd.tencent.tap": [
        "tap"
    ],
    "image/vnd.valve.source.texture": [
        "vtf"
    ],
    "image/vnd.wap.wbmp": [
        "wbmp"
    ],
    "image/vnd.xiff": [
        "xif"
    ],
    "image/vnd.zbrush.pcx": [
        "pcx"
    ],
    "image/x-3ds": [
        "3ds"
    ],
    "image/x-cmu-raster": [
        "ras"
    ],
    "image/x-cmx": [
        "cmx"
    ],
    "image/x-freehand": [
        "fh",
        "fhc",
        "fh4",
        "fh5",
        "fh7"
    ],
    "image/x-icon": [
        "*ico"
    ],
    "image/x-jng": [
        "jng"
    ],
    "image/x-mrsid-image": [
        "sid"
    ],
    "image/x-ms-bmp": [
        "*bmp"
    ],
    "image/x-pcx": [
        "*pcx"
    ],
    "image/x-pict": [
        "pic",
        "pct"
    ],
    "image/x-portable-anymap": [
        "pnm"
    ],
    "image/x-portable-bitmap": [
        "pbm"
    ],
    "image/x-portable-graymap": [
        "pgm"
    ],
    "image/x-portable-pixmap": [
        "ppm"
    ],
    "image/x-rgb": [
        "rgb"
    ],
    "image/x-tga": [
        "tga"
    ],
    "image/x-xbitmap": [
        "xbm"
    ],
    "image/x-xpixmap": [
        "xpm"
    ],
    "image/x-xwindowdump": [
        "xwd"
    ],
    "message/vnd.wfa.wsc": [
        "wsc"
    ],
    "model/vnd.collada+xml": [
        "dae"
    ],
    "model/vnd.dwf": [
        "dwf"
    ],
    "model/vnd.gdl": [
        "gdl"
    ],
    "model/vnd.gtw": [
        "gtw"
    ],
    "model/vnd.mts": [
        "mts"
    ],
    "model/vnd.opengex": [
        "ogex"
    ],
    "model/vnd.parasolid.transmit.binary": [
        "x_b"
    ],
    "model/vnd.parasolid.transmit.text": [
        "x_t"
    ],
    "model/vnd.sap.vds": [
        "vds"
    ],
    "model/vnd.usdz+zip": [
        "usdz"
    ],
    "model/vnd.valve.source.compiled-map": [
        "bsp"
    ],
    "model/vnd.vtu": [
        "vtu"
    ],
    "text/prs.lines.tag": [
        "dsc"
    ],
    "text/vnd.curl": [
        "curl"
    ],
    "text/vnd.curl.dcurl": [
        "dcurl"
    ],
    "text/vnd.curl.mcurl": [
        "mcurl"
    ],
    "text/vnd.curl.scurl": [
        "scurl"
    ],
    "text/vnd.dvb.subtitle": [
        "sub"
    ],
    "text/vnd.fly": [
        "fly"
    ],
    "text/vnd.fmi.flexstor": [
        "flx"
    ],
    "text/vnd.graphviz": [
        "gv"
    ],
    "text/vnd.in3d.3dml": [
        "3dml"
    ],
    "text/vnd.in3d.spot": [
        "spot"
    ],
    "text/vnd.sun.j2me.app-descriptor": [
        "jad"
    ],
    "text/vnd.wap.wml": [
        "wml"
    ],
    "text/vnd.wap.wmlscript": [
        "wmls"
    ],
    "text/x-asm": [
        "s",
        "asm"
    ],
    "text/x-c": [
        "c",
        "cc",
        "cxx",
        "cpp",
        "h",
        "hh",
        "dic"
    ],
    "text/x-component": [
        "htc"
    ],
    "text/x-fortran": [
        "f",
        "for",
        "f77",
        "f90"
    ],
    "text/x-handlebars-template": [
        "hbs"
    ],
    "text/x-java-source": [
        "java"
    ],
    "text/x-lua": [
        "lua"
    ],
    "text/x-markdown": [
        "mkd"
    ],
    "text/x-nfo": [
        "nfo"
    ],
    "text/x-opml": [
        "opml"
    ],
    "text/x-org": [
        "*org"
    ],
    "text/x-pascal": [
        "p",
        "pas"
    ],
    "text/x-processing": [
        "pde"
    ],
    "text/x-sass": [
        "sass"
    ],
    "text/x-scss": [
        "scss"
    ],
    "text/x-setext": [
        "etx"
    ],
    "text/x-sfv": [
        "sfv"
    ],
    "text/x-suse-ymp": [
        "ymp"
    ],
    "text/x-uuencode": [
        "uu"
    ],
    "text/x-vcalendar": [
        "vcs"
    ],
    "text/x-vcard": [
        "vcf"
    ],
    "video/vnd.dece.hd": [
        "uvh",
        "uvvh"
    ],
    "video/vnd.dece.mobile": [
        "uvm",
        "uvvm"
    ],
    "video/vnd.dece.pd": [
        "uvp",
        "uvvp"
    ],
    "video/vnd.dece.sd": [
        "uvs",
        "uvvs"
    ],
    "video/vnd.dece.video": [
        "uvv",
        "uvvv"
    ],
    "video/vnd.dvb.file": [
        "dvb"
    ],
    "video/vnd.fvt": [
        "fvt"
    ],
    "video/vnd.mpegurl": [
        "mxu",
        "m4u"
    ],
    "video/vnd.ms-playready.media.pyv": [
        "pyv"
    ],
    "video/vnd.uvvu.mp4": [
        "uvu",
        "uvvu"
    ],
    "video/vnd.vivo": [
        "viv"
    ],
    "video/x-f4v": [
        "f4v"
    ],
    "video/x-fli": [
        "fli"
    ],
    "video/x-flv": [
        "flv"
    ],
    "video/x-m4v": [
        "m4v"
    ],
    "video/x-matroska": [
        "mkv",
        "mk3d",
        "mks"
    ],
    "video/x-mng": [
        "mng"
    ],
    "video/x-ms-asf": [
        "asf",
        "asx"
    ],
    "video/x-ms-vob": [
        "vob"
    ],
    "video/x-ms-wm": [
        "wm"
    ],
    "video/x-ms-wmv": [
        "wmv"
    ],
    "video/x-ms-wmx": [
        "wmx"
    ],
    "video/x-ms-wvx": [
        "wvx"
    ],
    "video/x-msvideo": [
        "avi"
    ],
    "video/x-sgi-movie": [
        "movie"
    ],
    "video/x-smv": [
        "smv"
    ],
    "x-conference/x-cooltalk": [
        "ice"
    ]
};

},{}],"gGbYT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getThumbUrl);
function getThumbUrl(path) {
    return `${"http://cms.pp.content.catering"}/thumbs${path}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"92j6Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FolderItem);
var _jsxRuntime = require("react/jsx-runtime");
var _filesLink = require("./FilesLink");
var _filesLinkDefault = parcelHelpers.interopDefault(_filesLink);
function FolderItem({ item }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _filesLinkDefault.default), {
        path: item.path,
        className: "FolderLink",
        children: [
            "\uD83D\uDCC1 ",
            item.name
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","./FilesLink":"2h45D","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5msDw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectedFiles);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _files = require("./Files");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
const DELETE_FILES = (0, _client.gql)`
	mutation deleteFiles($paths: [String!]!) {
		deleteFiles(paths: $paths) 
	}
`;
function SelectedFiles({ folder }) {
    const { selected, setSelected, refetch } = (0, _react.useContext)((0, _files.FilesContext));
    const [action, setAction] = (0, _react.useState)("");
    const [deleteFiles, { loading: loadingDelete, error: deleteError }] = (0, _client.useMutation)(DELETE_FILES, {
    });
    const onSelectAll = (0, _react.useCallback)((event)=>{
        setSelected((draft)=>{
            for (const file of folder.files){
                const idx = draft.indexOf(file.path);
                if (idx === -1 && event.target.checked) draft.push(file.path);
                else if (idx > -1 && !event.target.checked) draft.splice(idx, 1);
            }
        });
    }, [
        folder.files
    ]);
    const handleChangeAction = (0, _react.useCallback)(({ target })=>{
        setAction(target.value);
    }, []);
    async function handleRunAction() {
        if (action === "delete") {
            await deleteFiles({
                variables: {
                    paths: selected
                }
            });
            refetch();
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                className: "block",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        onChange: onSelectAll,
                        disabled: !folder.files || folder.files.length === 0
                    }),
                    " Select all"
                ]
            }),
            selected.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        children: [
                            "Selected ",
                            selected.length,
                            " ",
                            selected.length === 1 ? "file" : "files",
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                        value: action,
                        onChange: handleChangeAction,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: ""
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: "delete",
                                children: "delete"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        disabled: action === "",
                        onClick: handleRunAction,
                        children: "\u2192"
                    })
                ]
            }),
            loadingDelete && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            deleteError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                children: deleteError.toString()
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","./Files":"9m1Pe","../utils/Spinner":"lspMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"Z6C0u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NewFolder);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _files = require("./Files");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
const NEW_FOLDER = (0, _client.gql)`
	mutation NewFolder($folderPath: String!) {
		newFolder(folderPath: $folderPath)
	}
`;
function NewFolder() {
    const { path, refetch } = (0, _react.useContext)((0, _files.FilesContext));
    const [newFolder, { error, loading }] = (0, _client.useMutation)(NEW_FOLDER, {
    });
    const onMkdir = (0, _react.useCallback)(async ()=>{
        let name = prompt("Folder name:", "New folder");
        if (!name) return false;
        name = `${name}`.trim();
        if (name === "") name = "New folder";
        newFolder({
            variables: {
                folderPath: `${path}/${name}`
            }
        });
        refetch();
    }, [
        path
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: onMkdir,
                children: "New folder"
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","./Files":"9m1Pe","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hWQoS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StructInput);
var _jsxRuntime = require("react/jsx-runtime");
var _immer = require("immer");
var _multiInput = require("./MultiInput");
var _multiInputDefault = parcelHelpers.interopDefault(_multiInput);
var _field = require("./Field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _jason = require("../utils/jason");
var _jasonDefault = parcelHelpers.interopDefault(_jason);
function StructInputSingle({ field, value, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "STRUCTfields",
        children: Array.isArray(field?.config?.fields) && field.config.fields.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldDefault.default), {
                // fieldId={field.id}
                field: field,
                value: !!value && value[field.fieldId],
                update: (v)=>{
                    // console.log(value, v)
                    update((0, _immer.produce)(value, (draft)=>{
                        if (!draft) return {
                            [field.fieldId]: v
                        };
                        draft[field.fieldId] = v;
                    }));
                }
            }, field.fieldId))
    });
}
function StructInput({ field, value, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "FieldInput STRUCTinput",
        children: !field?.config.multi ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StructInputSingle, {
            field: field,
            value: value,
            update: update
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiInputDefault.default), {
            field: field,
            value: value,
            update: update,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StructInputSingle, {})
        })
    });
}

},{"react/jsx-runtime":"gaGEj","immer":"eUR2H","./MultiInput":"4aMA6","./Field":"k7tVB","../utils/jason":"dL3Qe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ktLRQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>JsonInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function JsonInput({ field, value, update }) {
    const { config } = field;
    const [draft, setDraft] = (0, _react.useState)(JSON.stringify(value, null, 2));
    function onBlur() {
        if (!!update) update(draft === "" ? null : draft);
    }
    (0, _react.useEffect)(()=>{
        if (value !== draft) setDraft(JSON.stringify(value, null, 2));
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "FieldInput JSONinput",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
            value: draft,
            onChange: (e)=>setDraft(e.target.value),
            onBlur: onBlur,
            rows: config.rows || 5,
            className: "monospace input"
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ih3bY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NumberInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _multiInput = require("./MultiInput");
var _multiInputDefault = parcelHelpers.interopDefault(_multiInput);
function NumberInputSingle({ field, value, update }) {
    const [draft, setDraft] = (0, _react.useState)(value);
    // const props = {}
    // if (typeof field.minValue === 'number') props.min = field.minValue
    // if (typeof field.maxValue === 'number') props.max = field.maxValue
    // if (!!field.step) props.step = field.step
    // const fieldId = `field-${field.id}`
    // if (Array.isArray(field.suggested)) props.list = fieldId
    function onChange(event) {
        setDraft(event.target.value);
    }
    function onBlur() {
        update(draft === "" ? null : Number(draft));
    }
    (0, _react.useEffect)(()=>{
        setDraft(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
            type: "number",
            value: draft ?? "",
            onChange: onChange,
            onBlur: onBlur
        })
    });
}
function NumberInput({ field, value, update }) {
    return !field.multi ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(NumberInputSingle, {
        field: field,
        value: value,
        update: update
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiInputDefault.default), {
        field: field,
        value: value,
        update: update,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NumberInputSingle, {})
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./MultiInput":"4aMA6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fmfrP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BooleanInput);
var _jsxRuntime = require("react/jsx-runtime");
var _multiInput = require("./MultiInput");
var _multiInputDefault = parcelHelpers.interopDefault(_multiInput);
function BooleanInputSingle({ field, value, update }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "BooleanInput",
        children: [
            field.inputType === "radio" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "radio",
                                checked: !!value,
                                onChange: (e)=>update(!!e.target.checked)
                            }),
                            " ",
                            field.trueLabel ?? "yes"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "radio",
                                checked: value !== null && !value,
                                onChange: (e)=>update(!e.target.checked)
                            }),
                            " ",
                            field.falseLabel ?? "no"
                        ]
                    })
                ]
            }),
            (!field.inputType || field.inputType === "checkbox") && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        checked: !!value,
                        onChange: (e)=>update(e.target.checked ? true : null)
                    }),
                    " ",
                    !!field.trueLabel && field.trueLabel
                ]
            })
        ]
    });
}
function BooleanInput({ field, value, update }) {
    return !field.multi ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BooleanInputSingle, {
        field: field,
        value: value,
        update: update
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiInputDefault.default), {
        field: field,
        value: value,
        update: update,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BooleanInputSingle, {})
    });
}

},{"react/jsx-runtime":"gaGEj","./MultiInput":"4aMA6","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ak6Mz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datetimeInputJsx = require("./DatetimeInput.jsx");
var _datetimeInputJsxDefault = parcelHelpers.interopDefault(_datetimeInputJsx);
exports.default = (0, _datetimeInputJsxDefault.default);

},{"./DatetimeInput.jsx":"4kKlY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4kKlY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DatetimeInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function DatetimeInput({ field, value, update }) {
    const [inputValue, setInputValue] = (0, _react.useState)("");
    function handleChange(event) {
        const date = new Date(event.target.value);
        update(isNaN(date) ? null : date.toISOString());
    }
    (0, _react.useEffect)(()=>{
        if (!value) {
            setInputValue("");
            return;
        }
        try {
            const date = new Date(value);
            date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
            setInputValue(date.toISOString().slice(0, 16));
        } catch (e) {
            setInputValue("");
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "FieldInput",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "datetime-local",
                value: inputValue,
                onChange: handleChange
            }),
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>update(null),
                children: "x"
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8VoYn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReferenceInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _reactEasySort = require("react-easy-sort");
var _reactEasySortDefault = parcelHelpers.interopDefault(_reactEasySort);
var _arrayMove = require("array-move");
var _immer = require("immer");
// import useCollection from '../collections/useCollection'
var _entrySnippet = require("../collections/EntrySnippet");
var _entrySnippetDefault = parcelHelpers.interopDefault(_entrySnippet);
var _entries = require("../entries/Entries");
var _entriesDefault = parcelHelpers.interopDefault(_entries);
// import CollectionProvider from '../collections/CollectionProvider'
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
// import { GET_COLLECTION } from '../collections/CollectionProvider'
const GET_ENTRY_SNIPPETS = (0, _client.gql)`
	query GetReferenceFieldEntrySnippets($collectionId:ID!, $entryIds:[ID]) {
		entrySnippets(collectionId:$collectionId, entryIds:$entryIds) {
			collectionId
			entryId
			values
		}
	}
`;
const GET_COLLECTION = (0, _client.gql)`
	query GetCollectionStuff($collectionId: ID!) {
		collection(collectionId: $collectionId) {
			collectionId
			name
			icon
			fields
			snippet
			title
		}
	}
`;
function ReferenceInput({ field, value, update }) {
    const { loading, error, data } = (0, _client.useQuery)(GET_COLLECTION, {
        variables: {
            collectionId: field.config?.collectionId || ""
        }
    });
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {});
    if (error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
        error: error
    });
    if (!data?.collection) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
        children: "No collection"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReferenceInputPicker, {
        field: field,
        value: value,
        update: update,
        collection: data.collection
    });
}
function ReferenceInputPicker({ field, value, update, collection }) {
    // const { collection } = useCollection()
    const [showPicker, setShowPicker] = (0, _react.useState)(false);
    const selected = (0, _react.useMemo)(()=>Array.isArray(value) ? value : typeof value === "string" ? [
            value
        ] : [], [
        value
    ]);
    const [loadEntries, { loading, error, data }] = (0, _client.useLazyQuery)(GET_ENTRY_SNIPPETS);
    const entries = (0, _react.useMemo)(()=>selected.map((entryId)=>data?.entrySnippets.find((e)=>e.entryId === entryId) ?? {
                entryId
            }), [
        selected,
        data
    ]);
    (0, _react.useEffect)(()=>{
        // if (!selected.length || !collection) return;
        // console.log('loadEntries', selected)
        loadEntries({
            variables: {
                collectionId: collection.collectionId,
                entryIds: selected
            }
        });
    }, [
        selected,
        collection
    ]);
    function handleChange(entryIds, hidePicker = true) {
        if (!Array.isArray(entryIds)) entryIds = [];
        update(!!field.config?.multi ? entryIds : entryIds[0] || null);
        if (!field.config?.multi && hidePicker) setShowPicker(false);
    }
    // const handleSelect = useCallback((entryId, add = true) => {
    // 	const value = produce(selected, draft => {
    // 		const idx = draft.indexOf(entryId)
    // 		if (add && idx === -1) {
    // 			draft.push(entryId)
    // 		} else if (idx > -1) draft.splice(idx, 1)
    // 	})
    // 	// console.log('handleSelect', value)
    // 	if (value.length === 0) return update(null)
    // 	if (!field.config?.multi) {
    // 		update(value[0])
    // 		setShowPicker(false)
    // 		return
    // 	}
    // 	update(value)
    // }, [selected])
    function handleRemove(entryIdx) {
        handleChange((0, _immer.produce)(selected, (draft)=>{
            draft.splice(entryIdx, 1);
        }), false);
    }
    function handleReorder(entryIds) {
        update(entryIds);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "FieldInput REFERENCEinput",
                children: !!selected.length && !!collection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(EntriesSortableList, {
                            multi: field.config.multi,
                            collection: collection,
                            entries: entries,
                            handleRemove: handleRemove,
                            onReorder: handleReorder,
                            hideMeta: true
                        }),
                        loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "FieldExtras REFERENCEextras",
                children: [
                    !!error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                        error: error
                    }),
                    showPicker ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setShowPicker(false),
                        children: "Done"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        onClick: ()=>setShowPicker(true),
                        children: [
                            "Pick from ",
                            collection?.icon,
                            " ",
                            collection?.name
                        ]
                    }),
                    showPicker && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "ReferenceInputEntries",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entriesDefault.default), {
                            forcedCollection: collection,
                            selected: selected,
                            selectMode: true,
                            onSelected: handleChange
                        })
                    })
                ]
            })
        ]
    });
}
function EntriesSortableList({ collection, entries, handleRemove, onReorder, multi }) {
    function onSortEnd(oldIndex, newIndex) {
        const newOrder = (0, _arrayMove.arrayMoveImmutable)(entries.map((e)=>e.entryId), oldIndex, newIndex);
        onReorder(newOrder);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySortDefault.default), {
        className: "GridTable REFERENCEgrid",
        draggedItemClassName: "dragged",
        onSortEnd: onSortEnd,
        allowDrag: !!multi,
        style: {
            "--columns": collection.snippet.length + (!!multi ? 2 : 1)
        },
        children: entries.map((entry, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySort.SortableItem), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "Item",
                    children: [
                        !!multi && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactEasySort.SortableKnob), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: "\u2195\uFE0F"
                            })
                        }),
                        !entry.values ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alertDefault.default), {
                            children: [
                                "Missing entry ",
                                entry.entryId
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entrySnippetDefault.default), {
                            snippet: collection.snippet,
                            entry: entry,
                            hideMeta: true
                        }, entry.entryId),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>handleRemove(idx),
                                children: "x"
                            })
                        })
                    ]
                })
            }, entry.entryId))
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","react-easy-sort":"iVlh1","array-move":"iaig5","immer":"eUR2H","../collections/EntrySnippet":"kQo4P","../entries/Entries":"cERqi","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bPisx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ExportsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _useImmer = require("use-immer");
var _collections = require("../layout/Collections");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
const EXPORT_COLLECTION = (0, _client.gql)`
	query Export($collectionId:ID!, $format:String!, $fields:[String]!) {
		export(collectionId:$collectionId, format:$format, fields:$fields)
	}`;
function ExportsPage() {
    const { collection } = (0, _useCollectionDefault.default)();
    const [format, setFormat] = (0, _react.useState)("csv");
    const [fields, setFields] = (0, _useImmer.useImmer)(collection.fields.map((field)=>field.fieldId));
    const [exportCollection, { loading: exportLoading, error: exportError }] = (0, _client.useLazyQuery)(EXPORT_COLLECTION);
    function handleCheckField(event) {
        const fieldId = event.target.value;
        setFields((draft)=>{
            if (draft.includes(fieldId)) draft.splice(draft.indexOf(fieldId), 1);
            else draft.push(fieldId);
        });
    }
    async function handleExport() {
        const response = await exportCollection({
            variables: {
                collectionId: collection.collectionId,
                format,
                fields
            }
        });
        const csv = response?.data?.export;
        if (!!csv) downloadCSV(csv, `${collection.collectionId}.csv`);
        console.log("response", response);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Export"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Format"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "checkbox",
                                    onChange: (event)=>setFormat("csv"),
                                    checked: format === "csv"
                                }),
                                "CSV"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Fields"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: collection.fields.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "checkbox",
                                        value: field.fieldId,
                                        onChange: handleCheckField,
                                        checked: fields.includes(field.fieldId)
                                    }),
                                    field.fieldId
                                ]
                            }, field.fieldId))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>handleExport(),
                disabled: exportLoading,
                children: "Export"
            }),
            exportLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            !!exportError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: exportError
            })
        ]
    });
}
function downloadCSV(csvString, filename) {
    var blob = new Blob([
        csvString
    ], {
        type: "text/csv;charset=utf-8;"
    });
    var url = URL.createObjectURL(blob);
    var downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","../utils/Title":"IV4kx","use-immer":"cnEe2","../layout/Collections":"fogPQ","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","./useCollection":"hFA2a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Zu5a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BulkEditContext", ()=>BulkEditContext);
parcelHelpers.export(exports, "default", ()=>BulkEditPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useImmer = require("use-immer");
var _taskList = require("../tasks/TaskList");
var _taskListDefault = parcelHelpers.interopDefault(_taskList);
var _bulkTaskRun = require("../tasks/BulkTaskRun");
var _bulkTaskRunDefault = parcelHelpers.interopDefault(_bulkTaskRun);
const BulkEditContext = /*#__PURE__*/ (0, _react.createContext)({
    entryIds: [],
    task: null,
    setTask: null
});
function BulkEditPage() {
    const [task, setTask] = (0, _useImmer.useImmer)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Bulk edit"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _taskListDefault.default), {
                onSelect: (task)=>setTask(task),
                selected: task
            }),
            !!task && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bulkTaskRunDefault.default), {
                task: task
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","use-immer":"cnEe2","../tasks/TaskList":"9mbab","../tasks/BulkTaskRun":"4BgsJ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4BgsJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_ENTRY_SNIPPETS", ()=>GET_ENTRY_SNIPPETS);
parcelHelpers.export(exports, "default", ()=>BulkTaskRun);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useCollection = require("../collections/useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _client = require("@apollo/client");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _useImmer = require("use-immer");
var _bulkEntry = require("../collections/BulkEntry");
var _bulkEntryDefault = parcelHelpers.interopDefault(_bulkEntry);
var _jason = require("../utils/jason");
var _jasonDefault = parcelHelpers.interopDefault(_jason);
const GET_ENTRY_SNIPPETS = (0, _client.gql)`
	query GetBulkRunEntriesIds($collectionId:ID!) {
		entrySnippets(collectionId:$collectionId) {
			entryId
			collectionId
			values
		}
	}`;
function BulkTaskRun({ task }) {
    const { collection } = (0, _useCollectionDefault.default)();
    const [isRunning, setIsRunning] = (0, _react.useState)(false);
    const [concurrent, setConcurrent] = (0, _react.useState)(1);
    const { data: entriesData, loading: loadingEntries, error: entriesError } = (0, _client.useQuery)(GET_ENTRY_SNIPPETS, {
        variables: {
            collectionId: collection.collectionId
        }
    });
    const [entries, setEntries] = (0, _useImmer.useImmer)({});
    const stats = (0, _react.useMemo)(()=>Object.entries(entries).reduce((acc, [entryId, { status }])=>{
            acc[status]++;
            acc.total++;
            return acc;
        }, {
            total: 0,
            LOADING: 0,
            DONE: 0,
            SAVING: 0,
            SAVED: 0
        }), [
        entries
    ]);
    function handleSaveAll() {
        setEntries((draft)=>{
            for (const [entryId, entry] of Object.entries(draft))if (entry.status === "DONE") draft[entryId].status = "SAVING";
        // draft.forEach(entry => {
        // 	if (entry.status === 'DONE' && !!entry.draft)
        // 		entry.status = 'SAVING'
        // })
        // for (const entry of draft) {
        // 	if (entry.status === 'DONE' && !!entry.draft)
        // 		draft.set(entryId, { ...entry, status: 'SAVING' })
        // }
        });
    }
    // function setEntry(entryId, vals) {
    // 	setEntries(draft => {
    // 		const entryIdx = draft.findIndex(e => e.entry.entryId === entryId)
    // 		if (entryIdx > -1) draft[entryIdx] = { ...draft[entryIdx], ...vals }
    // 	})
    // }
    (0, _react.useEffect)(()=>{
        if (!entriesData?.entrySnippets?.length) return;
        setEntries(Object.fromEntries(entriesData.entrySnippets.map((entry)=>[
                entry.entryId,
                {
                    status: null,
                    entry
                }
            ])));
    }, [
        entriesData
    ]);
    (0, _react.useEffect)(()=>{
        if (!isRunning || stats.total === 0) return;
        let loading = 0;
        // const updates = []
        for (const [entryId, entry] of Object.entries(entries)){
            if (entry.status === "DONE") continue;
            else if (entry.status === "LOADING") {
                loading++;
                continue;
            } else if (!entry.status && loading < concurrent) {
                // updates.push({ entryId, status: 'LOADING' })
                console.log("start", entryId);
                setEntries((draft)=>{
                    draft[entryId].status = "LOADING";
                });
                break;
            }
        }
    // if (updates.length) {
    // 	setEntries(draft => {
    // 		for (const { entryId, status } of updates) 
    // 			draft[entryId].status = status
    // 	})
    // }
    }, [
        isRunning,
        entries
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            entriesError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: entriesError
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Menu",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>setIsRunning((pv)=>!pv),
                        className: "primary",
                        children: isRunning ? "Stop" : "Run all"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            "Concurrent:",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                                onChange: (e)=>setConcurrent(e.target.value),
                                value: concurrent,
                                children: [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ].map((n)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: n,
                                        children: n
                                    }, n))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                        children: [
                            stats.total,
                            " entries \xb7 ",
                            stats.LOADING,
                            " loading \xb7 ",
                            stats.DONE,
                            " done \xb7 ",
                            stats.SAVING,
                            " saving \xb7 ",
                            stats.SAVED,
                            " saved"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: ()=>handleSaveAll(),
                        children: "Save all"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "GridTable BulkEntries",
                style: {
                    "--columns": collection.snippet.length
                },
                children: Object.entries(entries).map(([entryId, entry])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bulkEntryDefault.default), {
                        task: task,
                        entry: entry,
                        setEntries: setEntries
                    }, entryId))
            }),
            loadingEntries && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                children: "Loading entries..."
            }),
            (0, _jasonDefault.default)(entries, "entries")
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","../collections/useCollection":"hFA2a","@apollo/client":"bWmmR","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","use-immer":"cnEe2","../collections/BulkEntry":"bpIyh","../utils/jason":"dL3Qe","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bpIyh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BulkEntry);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _taskRun = require("../tasks/TaskRun");
var _taskRunDefault = parcelHelpers.interopDefault(_taskRun);
var _entryPage = require("../entries/EntryPage");
var _useCollection = require("./useCollection");
var _useCollectionDefault = parcelHelpers.interopDefault(_useCollection);
var _entrySnippet = require("./EntrySnippet");
var _entrySnippetDefault = parcelHelpers.interopDefault(_entrySnippet);
function BulkEntry({ task, entry, // setEntry,
setEntries }) {
    const entryId = entry.entry.entryId;
    const { collection } = (0, _useCollectionDefault.default)();
    const [updateEntry, { loading: loadingUpdate, error: updateError }] = (0, _client.useMutation)((0, _entryPage.UPDATE_ENTRY), {
    });
    // function setEntry(vals) {
    // 	setEntries(draft => {
    // 		const entryIdx = draft.findIndex(e => e.entry.entryId === entryId)
    // 		if (entryIdx > -1) draft[entryIdx] = { ...draft[entryIdx], ...vals }
    // 	})
    // }
    function handleFinish(payload) {
        setEntries((draft)=>{
            if (!!payload?.errors) {
                draft[entryId].status = "ERROR";
                draft[entryId].error = payload.errors.message || "ERROR";
            } else draft[entryId].status = "DONE";
        // draft[entryId].draft = !payload.changes ? null 
        // 	:	Object.entries(payload.changes).reduce((acc, [fieldId, [value]]) => {
        // 			acc[fieldId] = value
        // 			return acc
        // 		}, {})
        // }
        });
    }
    async function handleUpdate(values) {
        const response = await updateEntry({
            variables: {
                collectionId: collection.collectionId,
                entryId,
                values
            }
        });
        setEntries((draft)=>{
            if (!!response.errors) {
                draft[entryId].status = "ERROR";
                draft[entryId].error = response.errors;
            } else draft[entryId].status = "SAVED";
        });
    }
    // useEffect(() => {
    // 	if (entry.status === 'SAVING' && !loadingUpdate && !!entry.draft) handleUpdate(entry.draft)
    // }, [entry.status, loadingUpdate])
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "BulkEntry Item",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: entry.status || " "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _entrySnippetDefault.default), {
                        snippet: collection.snippet,
                        entry: entry.entry
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "SubItem",
                children: [
                    !!entry.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Alert, {
                        error: entry.error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _taskRunDefault.default), {
                        task: task,
                        entryId: entryId,
                        bulkEntryStatus: entry.status,
                        noButton: true,
                        isSaved: entry.status === "SAVED",
                        onFinish: handleFinish,
                        handleUpdate: handleUpdate
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","../tasks/TaskRun":"kgt6R","../entries/EntryPage":"kM9DE","./useCollection":"hFA2a","./EntrySnippet":"kQo4P","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9w220":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FilesPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _files = require("./Files");
var _filesDefault = parcelHelpers.interopDefault(_files);
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
function FilesPage() {
    const { "*": uri } = (0, _reactRouterDom.useParams)();
    const path = decodeURIComponent(`/${uri}`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Files"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filesDefault.default), {
                forcePath: path || "/"
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","./Files":"9m1Pe","../utils/Title":"IV4kx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3WtLX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>URLsRouter);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _urlsPage = require("./UrlsPage");
var _urlsPageDefault = parcelHelpers.interopDefault(_urlsPage);
function URLsRouter() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "URLs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Routes), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    index: true,
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _urlsPageDefault.default), {})
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","./UrlsPage":"bVC91","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bVC91":[function(require,module,exports) {
// import { useState } from 'react'
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>URLsPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _client = require("@apollo/client");
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _icon = require("../utils/Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
// import Redirect from './Redirect'
const GET_URL_LIST = (0, _client.gql)`
	query UrlList {
		urlList
	}
`;
function URLsPage() {
    const { data, loading, error } = (0, _client.useQuery)(GET_URL_LIST);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "URLs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            !!data?.urlList && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: data.urlList.length === 0 ? "No URLs." : `Total: ${data.urlList.length}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "GridTable UrlsList",
                        children: data.urlList.map((url, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(UrlLink, {
                                url: url
                            }, `${url[0] || ""}/${url[1]}/${idx}`))
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}
function UrlLink({ url: [prefix, uri, entryId, collectionId, collectionName, redirects] }) {
    const urlPath = `${prefix || ""}${uri}`;
    // const [showRedirects, setShowRedirects] = useState(false)
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "UrlsListItem Item",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    href: `${"https://pozyczkaportal.pl"}/${urlPath}`,
                    target: "_blank",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        i: "out"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: collectionName
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: `/collection/${collectionId}/id/${entryId}`,
                    children: `/${prefix || ""}${uri}/`
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","@apollo/client":"bWmmR","../utils/Title":"IV4kx","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","../utils/Icon":"fAdkP","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8CXMj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UsersPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _usersList = require("./UsersList");
var _usersListDefault = parcelHelpers.interopDefault(_usersList);
var _addUser = require("./AddUser");
var _addUserDefault = parcelHelpers.interopDefault(_addUser);
var _userPage = require("./UserPage");
var _userPageDefault = parcelHelpers.interopDefault(_userPage);
function UsersPage() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Routes), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    index: true,
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _usersListDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/add",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addUserDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "/:userId",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userPageDefault.default), {})
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","./UsersList":"b97vK","./AddUser":"gesDG","./UserPage":"kj4aH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"b97vK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_USERS", ()=>GET_USERS);
parcelHelpers.export(exports, "default", ()=>UsersList);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _reactRouterDom = require("react-router-dom");
var _userSnippet = require("./UserSnippet");
var _userSnippetDefault = parcelHelpers.interopDefault(_userSnippet);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
const GET_USERS = (0, _client.gql)`
	query GetUsers {
		users {
			userId
			name
			email
			emailHash
			role
		}
	}`;
function UsersList() {
    const { loading, error, data } = (0, _client.useQuery)(GET_USERS);
    const users = data?.users || [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Users"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Heading",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: "Users"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                            to: "/users/add",
                            children: "Add user"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "UsersList",
                className: "ItemsList",
                children: users.map((user)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: `/users/${user.userId}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userSnippetDefault.default), {
                            user: user
                        })
                    }, user.userId))
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","react-router-dom":"l6ORY","./UserSnippet":"ae0Dz","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","../utils/Title":"IV4kx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ae0Dz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UserSnippet);
var _jsxRuntime = require("react/jsx-runtime");
var _avatar = require("./Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
function UserSnippet({ user }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "UserSnippet",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                emailHash: user.emailHash,
                size: 256
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: user.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: user.email
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                            children: user.role
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","./Avatar":"8GHf3","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gesDG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddUserPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _client = require("@apollo/client");
var _roles = require("./roles");
var _usersList = require("./UsersList");
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
const ADD_USER = (0, _client.gql)`
	mutation AddUser($name: String!, $email: String!, $password: String!, $role: String!) {
		addUser(name: $name, email: $email, password: $password, role: $role) {
			userId
		}
	}`;
function AddUserPage() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [addUser, { data, loading, error }] = (0, _client.useMutation)(ADD_USER, {
        refetchQueries: [
            {
                query: (0, _usersList.GET_USERS)
            }
        ]
    });
    const handleSubmit = (0, _react.useCallback)(async (event)=>{
        event.preventDefault();
        const form = new FormData(event.target);
        try {
            const res = await addUser({
                variables: {
                    name: form.get("name"),
                    email: form.get("email"),
                    password: form.get("password"),
                    role: form.get("role")
                }
            });
            navigate(`/users/${res.data.addUser.userId}`);
        } catch (error) {
            console.error(error);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Add user"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Heading",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: "Add user"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                            to: "/users",
                            end: true,
                            children: "\u2190 Users list"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "Form width-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Name:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                required: true,
                                type: "text",
                                name: "name",
                                defaultValue: "",
                                className: "Input"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Email:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                required: true,
                                type: "email",
                                name: "email",
                                className: "Input",
                                defaultValue: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Password:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                required: true,
                                type: "text",
                                name: "password",
                                className: "Input",
                                defaultValue: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Role:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "RadioInput",
                                children: (0, _roles.USER_ROLES).map((role)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "radio",
                                                name: "role",
                                                value: role
                                            }),
                                            " ",
                                            role
                                        ]
                                    }, role))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "Submit",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                className: "primary",
                                children: "Add user"
                            }),
                            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","react-router-dom":"l6ORY","@apollo/client":"bWmmR","./roles":"6rCQb","./UsersList":"b97vK","../utils/Title":"IV4kx","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6rCQb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_ROLES", ()=>USER_ROLES);
parcelHelpers.export(exports, "ENTRIES_SCOPES", ()=>ENTRIES_SCOPES);
const USER_ROLES = [
    "ADMIN",
    "EDITOR",
    "GUEST"
];
const ENTRIES_SCOPES = [
    "ADD",
    "EDIT",
    "REMOVE"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kj4aH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_USER", ()=>GET_USER);
parcelHelpers.export(exports, "default", ()=>UserPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _client = require("@apollo/client");
var _editUser = require("./EditUser");
var _editUserDefault = parcelHelpers.interopDefault(_editUser);
var _deleteUser = require("./DeleteUser");
var _deleteUserDefault = parcelHelpers.interopDefault(_deleteUser);
var _resetPassword = require("./ResetPassword");
var _resetPasswordDefault = parcelHelpers.interopDefault(_resetPassword);
var _permissions = require("./Permissions");
var _permissionsDefault = parcelHelpers.interopDefault(_permissions);
var _userSnippet = require("./UserSnippet");
var _userSnippetDefault = parcelHelpers.interopDefault(_userSnippet);
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
const GET_USER = (0, _client.gql)`
	query GetUser($userId: ID!, $token: String) {
		user(userId: $userId, token: $token) {
			userId
			name
			email
			emailHash
			role
			permissions
		}
	}`;
function UserPage() {
    const { userId } = (0, _reactRouterDom.useParams)();
    const { data, loading: loadingUser, error: userError } = (0, _client.useQuery)(GET_USER, {
        variables: {
            userId
        }
    });
    const user = data?.user || null;
    const title = user?.name || "User";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Heading SubHeading",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: "/users/",
                            children: "Users"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: userError
            }),
            !!user && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userSnippetDefault.default), {
                        user: user
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editUserDefault.default), {
                        user: user
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
                    user.role === "EDITOR" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permissionsDefault.default), {
                                user: user
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Danger zone"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetPasswordDefault.default), {
                        userId: userId
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteUserDefault.default), {
                        userId: userId
                    })
                ]
            }),
            loadingUser && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","@apollo/client":"bWmmR","./EditUser":"aO7jg","./DeleteUser":"dIzt3","./ResetPassword":"3IIyQ","./Permissions":"jlIKC","./UserSnippet":"ae0Dz","../utils/Title":"IV4kx","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aO7jg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditUser);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _roles = require("./roles");
var _userPage = require("./UserPage");
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
const EDIT_USER = (0, _client.gql)`
	mutation EditUser($userId: ID!, $name: String!, $email: String!, $role: String!) {
		editUser(userId: $userId, name: $name, email: $email, role: $role)
	}`;
function EditUser({ user }) {
    const [editUser, { loading, error }] = (0, _client.useMutation)(EDIT_USER, {
        refetchQueries: [
            {
                query: (0, _userPage.GET_USER),
                variables: {
                    userId: user.userId
                }
            }
        ]
    });
    const handleSubmit = (0, _react.useCallback)(async (event)=>{
        event.preventDefault();
        const form = new FormData(event.target);
        try {
            await editUser({
                variables: {
                    userId: user.userId,
                    name: form.get("name"),
                    email: form.get("email"),
                    role: form.get("role")
                }
            });
        } catch (error) {
            console.error(error);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "Form width-sm",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Edit account"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Name:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                required: true,
                                name: "name",
                                defaultValue: user.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Email:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "email",
                                required: true,
                                name: "email",
                                defaultValue: user.email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Role:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "RadioInput",
                                children: (0, _roles.USER_ROLES).map((role)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "radio",
                                                name: "role",
                                                value: role,
                                                defaultChecked: user.role === role
                                            }),
                                            " ",
                                            role
                                        ]
                                    }, role))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "submit",
                                disabled: loading,
                                className: "Button",
                                children: "Edit account"
                            }),
                            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","./roles":"6rCQb","./UserPage":"kj4aH","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dIzt3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteUser);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _usersList = require("./UsersList");
const DELETE_USER = (0, _client.gql)`
	mutation DeleteUser($userId: ID!) {
		deleteUser(userId: $userId)
	}`;
function DeleteUser({ userId }) {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [deleteUser, { loading, error }] = (0, _client.useMutation)(DELETE_USER, {
        refetchQueries: [
            {
                query: (0, _usersList.GET_USERS)
            }
        ]
    });
    const handleDelete = (0, _react.useCallback)(async ()=>{
        if (!confirm("Are you sure you want to delete this user account?")) return null;
        try {
            await deleteUser({
                variables: {
                    userId
                }
            });
            alert("User deleted.");
            navigate("/users");
        } catch (error) {
            console.error(error);
        }
    }, [
        userId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "my-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: handleDelete,
                className: "delete small",
                children: "Delete user"
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","react":"6uln9","react-router-dom":"l6ORY","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","./UsersList":"b97vK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3IIyQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResetPassword);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _reactRouterDom = require("react-router-dom");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
const RESET_PASSWORD = (0, _client.gql)`
	mutation ResetPassword($userId: ID!, $password: String!) {
		resetPassword(userId: $userId, password: $password)
	}`;
function ResetPassword() {
    const { userId } = (0, _reactRouterDom.useParams)();
    const [resetPassword, { loading, error }] = (0, _client.useMutation)(RESET_PASSWORD, {
        variables: {
            userId
        }
    });
    const handleResetPassword = (0, _react.useCallback)(async ()=>{
        const password = prompt("New password:");
        if (!password) return null;
        if (password.length < 3) return alert("Too short.");
        try {
            await resetPassword({
                variables: {
                    password
                }
            });
            alert("Password reset.");
        } catch (error) {
            console.error(error);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "my-4",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: handleResetPassword,
                className: "Button Danger text-sm",
                children: "Reset password"
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","react-router-dom":"l6ORY","../utils/Alert":"5W3pt","../utils/Spinner":"lspMb","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jlIKC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Permissions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _roles = require("./roles");
var _userPage = require("./UserPage");
var _collections = require("../layout/Collections");
const EDIT_PERMISSIONS = (0, _client.gql)`
	mutation EditPermissions($userId: ID!, $target: String!, $scope: String!, $action: String!) {
		editPermissions(userId: $userId, target: $target, scope: $scope, action: $action)
	}`;
function Permissions({ user }) {
    const [editPermissions, { loading, error }] = (0, _client.useMutation)(EDIT_PERMISSIONS, {
        variables: {
            userId: user.userId
        },
        refetchQueries: [
            {
                query: (0, _userPage.GET_USER),
                variables: {
                    userId: user.userId
                }
            }
        ]
    });
    const { data: collectionsData } = (0, _client.useQuery)((0, _collections.GET_COLLECTIONS));
    const collections = collectionsData?.collections || [];
    const handleChange = (0, _react.useCallback)((target, scope)=>(event)=>{
            editPermissions({
                variables: {
                    target,
                    scope,
                    action: event.target.checked ? "allow" : "deny"
                }
            });
        }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Permissions"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: "Entries"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    children: "All"
                                }),
                                [
                                    "ADD",
                                    "EDIT",
                                    "REMOVE"
                                ].map((scope)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "checkbox",
                                                    onChange: handleChange("COLLECTIONS", scope),
                                                    checked: user.permissions.includes(`COLLECTIONS:${scope}`)
                                                }),
                                                " ",
                                                scope
                                            ]
                                        })
                                    }, scope))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: collections.map(({ collectionId, name, icon })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                        children: [
                                            icon,
                                            " ",
                                            name
                                        ]
                                    }),
                                    (0, _roles.ENTRIES_SCOPES).map((scope)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "checkbox",
                                                        onChange: handleChange(`COLLECTION/${collectionId}`, scope),
                                                        checked: user.permissions.includes(`COLLECTION/${collectionId}:${scope}`),
                                                        disabled: user.permissions.includes(`COLLECTIONS:${scope}`)
                                                    }),
                                                    " ",
                                                    scope
                                                ]
                                            })
                                        }, scope))
                                ]
                            }, collectionId))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","../utils/Alert":"5W3pt","./roles":"6rCQb","./UserPage":"kj4aH","../layout/Collections":"fogPQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c8WTJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AccountPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _recoil = require("recoil");
var _changePassword = require("./ChangePassword");
var _changePasswordDefault = parcelHelpers.interopDefault(_changePassword);
var _userSnippet = require("./UserSnippet");
var _userSnippetDefault = parcelHelpers.interopDefault(_userSnippet);
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _atoms = require("../layout/atoms");
function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 04:20:00 UTC; path=/;`;
}
const SIGN_OUT = (0, _client.gql)`
	mutation SignOut {
		signOut
	}
`;
function AccountPage() {
    const [user, setUser] = (0, _recoil.useRecoilState)((0, _atoms.userAtom));
    const [signOut] = (0, _client.useMutation)(SIGN_OUT);
    const handleSignOut = (0, _react.useCallback)(async ()=>{
        try {
            await signOut();
        } catch (error) {
            console.error(error);
        } finally{
            setUser(null);
            localStorage.removeItem("token");
            deleteCookie("token");
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Your account"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Heading",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: "Your account"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: handleSignOut,
                            children: "Sign out \u2192"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userSnippetDefault.default), {
                user: user
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _changePasswordDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","recoil":"2QijJ","./ChangePassword":"iATo4","./UserSnippet":"ae0Dz","../utils/Title":"IV4kx","../layout/atoms":"jppgz","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iATo4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ChangePassword);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _queryStatus = require("../utils/QueryStatus");
var _queryStatusDefault = parcelHelpers.interopDefault(_queryStatus);
const CHANGE_PASSWORD = (0, _client.gql)`
	mutation ChangePassword($oldpass: String!, $newpass: String!) {
		changePassword(oldpass: $oldpass, newpass: $newpass)
	}
`;
function ChangePassword({}) {
    const [changePassword, { loading, error }] = (0, _client.useMutation)(CHANGE_PASSWORD);
    const handleSubmit = (0, _react.useCallback)(async (event)=>{
        event.preventDefault();
        const form = new FormData(event.target);
        if (form.get("newpass") !== form.get("confirmpass")) return alert("New passwords don't match.");
        try {
            await changePassword({
                variables: {
                    oldpass: form.get("oldpass"),
                    newpass: form.get("newpass")
                }
            });
            alert("Password changed. Sign out and in again.");
        } catch (error) {
            console.error(error);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleSubmit,
        className: "Form width-sm",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Change password"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Current password"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "password",
                        required: true,
                        name: "oldpass",
                        defaultValue: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "New password"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "password",
                        required: true,
                        name: "newpass",
                        defaultValue: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                        children: "Confirm"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "password",
                        required: true,
                        name: "confirmpass",
                        defaultValue: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Submit",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "submit",
                    children: "Change password"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _queryStatusDefault.default), {
                loading: loading,
                error: error
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","../utils/QueryStatus":"dSO6d","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"f9n0G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_LOGS", ()=>GET_LOGS);
parcelHelpers.export(exports, "default", ()=>LogPage);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _client = require("@apollo/client");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _relativeTime = require("dayjs/plugin/relativeTime");
var _relativeTimeDefault = parcelHelpers.interopDefault(_relativeTime);
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _avatar = require("../users/Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _deleteLogs = require("./DeleteLogs");
var _deleteLogsDefault = parcelHelpers.interopDefault(_deleteLogs);
var _logTypes = require("./logTypes");
var _logTypesDefault = parcelHelpers.interopDefault(_logTypes);
(0, _dayjsDefault.default).extend((0, _relativeTimeDefault.default));
const GET_LOGS = (0, _client.gql)`
	query Logs {
		logs {
			logId
			userId
			created
			type
			vals
			name
			email
			emailHash
		}
	}`;
function LogPage() {
    const { data, loading, error } = (0, _client.useQuery)(GET_LOGS);
    const logs = data?.logs || [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Logs"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Heading",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "Logs"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteLogsDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Logs",
                children: logs.map((log)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Log, {
                        log: log
                    }, log.logId))
            })
        ]
    });
}
function Log({ log }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "LogLine",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "LogDate",
                children: (0, _dayjsDefault.default)(log.created).format("HH:mm ddd DD/MM ")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "LogUser",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                    emailHash: log.emailHash,
                    className: "LogAvatar",
                    size: 64
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "LogDesc",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: log.name
                    }),
                    " \xa0",
                    !!(0, _logTypesDefault.default)[log.type] ? (0, _logTypesDefault.default)[log.type](log) : log.type
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","@apollo/client":"bWmmR","dayjs":"8F3kd","dayjs/plugin/relativeTime":"hgDes","../utils/Title":"IV4kx","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","../users/Avatar":"8GHf3","./DeleteLogs":"4b9eI","./logTypes":"7JaWh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4b9eI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteLogs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _relativeTime = require("dayjs/plugin/relativeTime");
var _relativeTimeDefault = parcelHelpers.interopDefault(_relativeTime);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _logsPage = require("./LogsPage");
(0, _dayjsDefault.default).extend((0, _relativeTimeDefault.default));
const DELETE_LOGS = (0, _client.gql)`
	mutation DeleteLogs($beforeDate: DateTime!) {
		deleteLogs(beforeDate: $beforeDate)
	}
`;
function DeleteLogs() {
    const [date, setDate] = (0, _react.useState)((0, _dayjsDefault.default)().subtract(1, "month").format("YYYY-MM-DD"));
    const [deleteLogs, { loading, error, data }] = (0, _client.useMutation)(DELETE_LOGS, {
        refetchQueries: [
            {
                query: (0, _logsPage.GET_LOGS)
            }
        ]
    });
    const handleSubmit = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        deleteLogs({
            variables: {
                beforeDate: date
            }
        });
    }, [
        date
    ]);
    console.log(data);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            "Remove logs before date:",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "date",
                value: date,
                onChange: (e)=>setDate(e.target.value)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "submit",
                children: "Remove"
            }),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error.message
            }),
            data && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Removed: ",
                    data.deleteLogs,
                    " logs"
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","dayjs":"8F3kd","dayjs/plugin/relativeTime":"hgDes","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","./LogsPage":"f9n0G","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7JaWh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
const LOGTYPES = {
    "BUILD_STARTED": ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: "started a build"
        }),
    "BUILD_ABORTED": ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: "aborted a build"
        }),
    "TOKEN_CREATED": (log)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "created a ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/build/tokens",
                    children: "developer token"
                }),
                ': "',
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                    children: log.vals.label
                }),
                '" ',
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                    children: log.vals.tokenId
                })
            ]
        }),
    "TOKEN_DELETED": (log)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "deleted a ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: "/build/tokens",
                    children: "developer token"
                }),
                ": ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                    children: log.vals.tokenId
                })
            ]
        }),
    "USER_CREATED": (log)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "created a new user ",
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                    to: `/users/${log.vals.userId}`,
                    children: [
                        log.vals.name,
                        " (",
                        log.vals.email,
                        ") [",
                        log.vals.role,
                        "]"
                    ]
                })
            ]
        }),
    "USER_EDITED": (log)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "edited user profile ",
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                    to: `/users/${log.vals.userId}`,
                    children: [
                        log.vals.name,
                        " (",
                        log.vals.email,
                        ") [",
                        log.vals.role,
                        "]"
                    ]
                })
            ]
        }),
    "PERMISSIONS_EDITED": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "edited ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: `/users/${vals.userId}`,
                    children: "user permissions"
                }),
                ": ",
                vals.action,
                " ",
                vals.scope,
                "/",
                vals.target
            ]
        }),
    "USER_DELETED": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "deleted user ",
                vals.userId
            ]
        }),
    "PASSWORD_RESET": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "reset password for user ",
                vals.userId
            ]
        }),
    "COLLECTION_CREATED": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "created collection ",
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                    to: `/collection/${vals.collectionId}`,
                    children: [
                        vals.icon,
                        " ",
                        vals.name
                    ]
                })
            ]
        }),
    "COLLECTION_FIELDS_EDITED": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "edited ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: `/collection/${vals.collectionId}`,
                    children: "collection"
                }),
                ' field "',
                vals.field.id,
                '" [',
                vals.action,
                "]"
            ]
        }),
    "COLLECTION_SNIPPET_EDITED": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "edited ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: `/collection/${vals.collectionId}`,
                    children: "collection snippet"
                })
            ]
        }),
    "COLLECTION_URI_CONFIG_EDITED": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "edited ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: `/collection/${vals.collectionId}`,
                    children: "collection URI config"
                }),
                ": ",
                vals.uriPrefix
            ]
        }),
    "COLLECTION_DELETED": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "deleted collection ",
                vals.collectionId
            ]
        }),
    "ENTRY_CREATED": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "created ",
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                    to: `/collection/${vals.collectionId}/${vals.entryId}`,
                    children: [
                        "a new entry in ",
                        vals.collectionId
                    ]
                })
            ]
        }),
    "ENTRY_SAVED": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "saved changes in ",
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                    to: `/collection/${vals.collectionId}/${vals.entryId}`,
                    children: [
                        vals.collectionId,
                        " entry"
                    ]
                })
            ]
        }),
    "ENTRY_URI_EDITED": ({ vals })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                "changed URI of ",
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                    to: `/collection/${vals.collectionId}/${vals.entryId}`,
                    children: [
                        vals.collectionId,
                        " entry"
                    ]
                }),
                " to ",
                vals.uri
            ]
        })
};
exports.default = LOGTYPES;

},{"react/jsx-runtime":"gaGEj","react-router-dom":"l6ORY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4nNML":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_IMPORT_STUFF", ()=>GET_IMPORT_STUFF);
parcelHelpers.export(exports, "default", ()=>ImportPage);
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("@apollo/client");
var _title = require("../utils/Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
// import ImportUpload from './ImportUpload'
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _importMap = require("./ImportMap");
var _importMapDefault = parcelHelpers.interopDefault(_importMap);
const GET_IMPORT_STUFF = (0, _client.gql)`
	query GetImportMaps {
		# importFiles {
		# 	filename
		# 	mimeType
		# 	size
		# 	created
		# }
		importMaps {
			importMapId
			config
			modified
		}
	}`;
const CREATE_IMPORT_MAP = (0, _client.gql)`
	mutation CreateImportMap($config:JSON!) {
		createImportMap(config:$config)
	}`;
function ImportPage() {
    const { data, loading, error, refetch } = (0, _client.useQuery)(GET_IMPORT_STUFF);
    const [createImportMap, { loading: loadingCreate, error: createError }] = (0, _client.useMutation)(CREATE_IMPORT_MAP);
    // const [deleteImportFile, { loading: loadingDelete, error: deleteError }] = useMutation(DELETE_IMPORT_FILE)
    const importFiles = data?.importFiles || [];
    const importMaps = data?.importMaps || [];
    async function handleCreate() {
        const name = prompt("Name for new Import Map:") || "An Import Map";
        await createImportMap({
            variables: {
                config: {
                    name
                }
            },
            refetchQueries: [
                {
                    query: GET_IMPORT_STUFF
                }
            ]
        });
    }
    // async function deleteFile(filename) {
    // 	if (confirm(`Delete source file ${filename}?`)) await deleteImportFile({
    // 		variables: { filename },
    // 		refetchQueries: [{ query: GET_IMPORT_STUFF }]
    // 	})
    // }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _titleDefault.default), {
                children: "Import"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "Import"
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                onClick: ()=>handleCreate(),
                disabled: loadingCreate,
                children: "Add import map"
            }),
            createError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                error: createError
            }),
            loadingCreate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
            importMaps.map((map)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importMapDefault.default), {
                    importMap: map,
                    files: importFiles
                }, map.importMapId)),
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@apollo/client":"bWmmR","../utils/Title":"IV4kx","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","./ImportMap":"kQWxG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kQWxG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ImportMap);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("@apollo/client");
var _useImmer = require("use-immer");
var _reactRouterDom = require("react-router-dom");
var _files = require("../files/Files");
var _filesDefault = parcelHelpers.interopDefault(_files);
var _spinner = require("../utils/Spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _alert = require("../utils/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _jason = require("../utils/jason");
var _jasonDefault = parcelHelpers.interopDefault(_jason);
var _shallowMerge = require("../../common/utils/shallowMerge");
var _shallowMergeDefault = parcelHelpers.interopDefault(_shallowMerge);
var _importMapNew = require("./ImportMapNew");
var _importMapNewDefault = parcelHelpers.interopDefault(_importMapNew);
var _importMapExisting = require("./ImportMapExisting");
var _importMapExistingDefault = parcelHelpers.interopDefault(_importMapExisting);
var _importPage = require("./ImportPage");
const GET_COLLECTIONS = (0, _client.gql)`
	query GetCollectionsWithFields {
		collections {
			collectionId
			name
			icon
			fields
		}
	}
`;
const GET_FILE_PROFILE = (0, _client.gql)`
	query GetFileProfile($config:JSON!) {
		fileProfile(config:$config)
	}`;
const UPDATE_IMPORT_MAP = (0, _client.gql)`
	mutation UpdateImportMap($importMapId:ID!, $config:JSON!) {
		updateImportMap(importMapId:$importMapId, config:$config)
	}`;
const DELETE_IMPORT_MAP = (0, _client.gql)`
	mutation DeleteImportMap($importMapId:ID!) {
		deleteImportMap(importMapId:$importMapId)
	}`;
const START_IMPORT = (0, _client.gql)`
	mutation StartImport($config:JSON!) {
		startImport(config:$config)
	}`;
const DEFAULT_IMPORT_MAP_CONFIG = {
    name: "Import Map",
    filename: "",
    destination: "",
    insertStrategy: "insert",
    linkBy: "id",
    uniqueErrorStrategy: "error",
    // parser: '',
    fieldsMap: {}
};
// const PARSERS = ['JSON', 'CSV', 'WordPressXML']
const INSERT_STRATEGIES = [
    "insert",
    "merge"
];
const UNIQUE_ERROR_STRATEGIES = {
    "error": "Throw an error. Abort the import.",
    "skip": "Ignore the error. Skip the entry.",
    "create": "Create a new entry. Replace duplicate ID with a random ID.",
    // 'update':	"Update the existing entry with the new data. Keep unchanged data.",
    "replace": "Replace the existing entry with the new data."
};
function ImportMap({ importMap, files = [] }) {
    const [editingName, setEditingName] = (0, _react.useState)(false);
    const [config, setConfig] = (0, _useImmer.useImmer)((0, _shallowMergeDefault.default)(DEFAULT_IMPORT_MAP_CONFIG, importMap.config));
    // const [fieldsMap, setFieldsMap] = useImmer(config.fieldsMap)
    const hasChanged = (0, _react.useMemo)(()=>{
        return JSON.stringify(importMap.config) !== JSON.stringify(config);
    }, [
        importMap.config,
        config
    ]);
    const [showFiles, setShowFiles] = (0, _react.useState)(false);
    const { loading: loadingCollections, error: collectionsError, data: collectionsData } = (0, _client.useQuery)(GET_COLLECTIONS);
    const collections = collectionsData?.collections || [];
    const collection = collections.find((c)=>c.collectionId === config.destination);
    const [getFileProfile, { data, loading, error }] = (0, _client.useLazyQuery)(GET_FILE_PROFILE);
    const profile = data?.fileProfile || {};
    const [deleteImportMap, { loading: loadingDelete, error: deleteError }] = (0, _client.useMutation)(DELETE_IMPORT_MAP, {
        variables: {
            importMapId: importMap.importMapId
        },
        refetchQueries: [
            (0, _importPage.GET_IMPORT_STUFF)
        ]
    });
    const [updateImportMap, { loading: loadingUpdate, error: updateError }] = (0, _client.useMutation)(UPDATE_IMPORT_MAP, {
        refetchQueries: [
            (0, _importPage.GET_IMPORT_STUFF)
        ]
    });
    const [startImport, { loading: loadingImport, error: importError, data: importData }] = (0, _client.useMutation)(START_IMPORT, {
        refetchQueries: [
            GET_COLLECTIONS
        ]
    });
    async function handleDelete() {
        if (confirm("Delete Import Map?")) await deleteImportMap();
    }
    async function handleUpdate() {
        await updateImportMap({
            variables: {
                importMapId: importMap.importMapId,
                config
            }
        });
    }
    async function handleImport() {
        if (!config.destination) return alert("Please select a destination collection name");
        await startImport({
            variables: {
                config
            }
        });
    }
    function setFieldsMap(nextFieldsMap) {
        setConfig((d)=>{
            d.fieldsMap = nextFieldsMap;
        });
    }
    function handleSelectFile(filenames) {
        // console.log('handleSelectFile', filename)
        if (Array.isArray(filenames)) setConfig((d)=>{
            d.filename = filenames[0];
        });
        setShowFiles(false);
    }
    // const hasIdField = useMemo(() => {
    // 	return !!config.fieldsMap && !!Object.values(config.fieldsMap).find(f => f.fieldId === 'id' && f.type === 'ID')
    // }, [config.fieldsMap])
    // useEffect(() => {
    // 	if (!!config?.filename) getFileProfile({ variables: { filename: config.filename } })
    // }, [config])
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "ImportMap",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "IMHeader",
                children: !editingName ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                    children: [
                        config?.name || "An Import Map",
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>setEditingName(true),
                            children: "edit"
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "text",
                    value: config?.name || "",
                    onChange: (e)=>setConfig((d)=>{
                            d.name = e.target.value;
                        }),
                    onBlur: ()=>setEditingName(false)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Source"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Source file:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                        children: config?.filename
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>setShowFiles((p)=>!p),
                                        children: "Select file"
                                    })
                                ]
                            }),
                            showFiles && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filesDefault.default), {
                                    isEmbed: true,
                                    isModal: true,
                                    onSelected: handleSelectFile,
                                    initialPath: "/",
                                    initialSelected: config?.filename
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            !!config?.filename && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    config?.filename?.substr(-4) === ".json" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            "Address: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "text",
                                                value: config?.address || "",
                                                onChange: (e)=>setConfig((d)=>{
                                                        d.address = e.target.value;
                                                    })
                                            })
                                        ]
                                    }),
                                    config?.filename?.substr(-4) === ".csv" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            "Delimiter: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "text",
                                                value: config?.delimiter || "",
                                                placeholder: ",",
                                                onChange: (e)=>setConfig((d)=>{
                                                        d.delimiter = e.target.value;
                                                    })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>getFileProfile({
                                        variables: {
                                            config
                                        }
                                    }),
                                children: "Load"
                            }),
                            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
                            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                                error: error
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Destination"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("legend", {
                                children: "Destination:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                value: config.destination,
                                onChange: (e)=>setConfig((d)=>{
                                        d.destination = e.target.value;
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                        value: "",
                                        children: "New collection"
                                    }),
                                    collections.map(({ collectionId, name, icon })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                                            value: collectionId,
                                            children: [
                                                icon,
                                                " ",
                                                name
                                            ]
                                        }, collectionId))
                                ]
                            }),
                            !collection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Collection name:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        value: config.destination || "",
                                        onChange: (e)=>setConfig((d)=>{
                                                d.destination = e.target.value;
                                            })
                                    })
                                ]
                            }),
                            !!collection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    "Insert strategy:",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                                        value: config.insertStrategy,
                                        onChange: (e)=>setConfig((d)=>{
                                                d.insertStrategy = e.target.value;
                                            }),
                                        children: INSERT_STRATEGIES.map((s)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                value: s,
                                                children: s
                                            }, s))
                                    }),
                                    config.insertStrategy === "insert" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            "Unique constraint fail handling strategy:",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                                                value: config.uniqueErrorStrategy,
                                                onChange: (e)=>setConfig((d)=>{
                                                        d.uniqueErrorStrategy = e.target.value;
                                                    }),
                                                children: Object.keys(UNIQUE_ERROR_STRATEGIES).map((s)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                        value: s,
                                                        children: s
                                                    }, s))
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                                children: UNIQUE_ERROR_STRATEGIES[config.uniqueErrorStrategy]
                                            })
                                        ]
                                    }),
                                    config.insertStrategy === "merge" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        children: [
                                            "Link by field:",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "text",
                                                value: config.linkBy || "",
                                                onChange: (e)=>setConfig((d)=>{
                                                        d.linkBy = e.target.value;
                                                    })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!collection ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importMapExistingDefault.default), {
                sourceFields: profile?.stats,
                collection: collection,
                fieldsMap: config?.fieldsMap,
                setFieldsMap: setFieldsMap
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importMapNewDefault.default), {
                sourceFields: profile?.stats,
                fieldsMap: config?.fieldsMap,
                setFieldsMap: setFieldsMap
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "IMFooter",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>handleDelete(),
                                className: "delete",
                                children: "Delete"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>handleUpdate(),
                                disabled: !hasChanged,
                                className: hasChanged ? "primary" : "",
                                children: "Save"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>handleImport(),
                                disabled: !config?.filename || loadingImport,
                                className: "primary",
                                children: "Import"
                            })
                        ]
                    }),
                    loadingUpdate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
                    loadingDelete && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
                    loadingImport && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {
                        children: "Importing..."
                    }),
                    importError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                        error: importError
                    }),
                    updateError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                        error: importError
                    }),
                    deleteError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                        error: deleteError
                    }),
                    !!importData?.startImport && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "success",
                        children: [
                            "Imported ",
                            importData.startImport?.entryCount,
                            " entries to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `/collection/${importData.startImport?.collectionId}`,
                                children: importData.startImport?.collectionId
                            }),
                            "."
                        ]
                    }),
                    (0, _jasonDefault.default)(importMap, "importMap"),
                    (0, _jasonDefault.default)(config, "config"),
                    (0, _jasonDefault.default)(profile, "profile")
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","@apollo/client":"bWmmR","use-immer":"cnEe2","react-router-dom":"l6ORY","../files/Files":"9m1Pe","../utils/Spinner":"lspMb","../utils/Alert":"5W3pt","../utils/jason":"dL3Qe","../../common/utils/shallowMerge":"3HHEO","./ImportMapNew":"3o082","./ImportMapExisting":"fKlEq","./ImportPage":"4nNML","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3o082":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ImportMapNew);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _immer = require("immer");
var _columnStats = require("../utils/ColumnStats");
var _columnStatsDefault = parcelHelpers.interopDefault(_columnStats);
var _notifications = require("../utils/Notifications");
var _fields = require("../../common/fields/fields");
function suggestFieldType(source) {
    let type = Object.entries(source.types).sort((a, b)=>b[1] - a[1])[0][0];
    switch(type){
        case "number":
            return "NUMERIC";
        case "boolean":
            return "BOOLEAN";
        case "string":
            return "TEXT";
        default:
        case "object":
            return "JSON";
    }
}
function ImportMapNew({ fieldsMap, setFieldsMap, sourceFields, collection }) {
    const rows = (0, _react.useMemo)(()=>{
        const rows = [];
        if (!!sourceFields) for (const sourceKey of Object.keys(sourceFields)){
            const row = rows.find(([sKey])=>sKey === sourceKey);
            if (!row) rows.push([
                sourceKey,
                null
            ]);
        }
        if (!!fieldsMap) for (let [sourceKey, field] of Object.entries(fieldsMap)){
            const rowWithSource = rows.find(([sKey])=>sourceKey === sKey);
            if (!!rowWithSource) rowWithSource[1] = field;
        }
        return rows.map(([sourceKey, field])=>{
            return [
                !!sourceKey && !!sourceFields?.[sourceKey] ? {
                    key: sourceKey,
                    stats: sourceFields[sourceKey]
                } : sourceKey,
                field
            ];
        });
    }, [
        collection,
        fieldsMap,
        sourceFields
    ]);
    // const rows = useMemo(() => {
    // 	const rows = []
    // 	if (!!profile?.stats) {
    // 		for (let sourceKey of Object.keys(profile.stats)) {
    // 			rows.push([sourceKey, null])
    // 		}
    // 	}
    // 	if (!!config.fieldsMap) {
    // 		for (let [sourceKey, field] of Object.entries(config.fieldsMap)) {
    // 			const row = rows.find(([sKey]) => sKey === sourceKey)
    // 			if (!row) rows.push([sourceKey, field])
    // 				else row[1] = field
    // 		}
    // 	}
    // 	if (!!collection?.fields) {
    // 		for (let field of collection.fields) {
    // 			const row = rows.find(([sKey, f]) => field.fieldId === f?.fieldId && field.type === f?.type)
    // 			if (!row) rows.push([null, field])
    // 				else row[1] = field
    // 		}
    // 	}
    // 	return rows.map(([sKey, dest]) => {
    // 		return [
    // 			!!sKey ? { key: sKey, stats: profile?.stats?.[sKey] } : null, 
    // 			dest
    // 		]
    // 	})
    // }, [config.fieldsMap, profile.stats, collection])
    function toggleSource(sourceKey) {
        setFieldsMap((0, _immer.produce)(fieldsMap, (draft)=>{
            if (draft[sourceKey]) delete draft[sourceKey];
            else draft[sourceKey] = {
                fieldId: sourceKey,
                type: suggestFieldType(sourceFields[sourceKey])
            };
        }));
    }
    function updateField(sourceKey, values) {
        setFieldsMap((0, _immer.produce)(fieldsMap, (draft)=>{
            draft[sourceKey] = {
                ...draft[sourceKey],
                ...values
            };
        }));
    }
    // function toggleSelectAll(event) {
    // 	if (!profile.stats) return
    // 	if (event.target.checked) {
    // 		setConfig(d => {
    // 			for (let sourceKey of Object.keys(profile.stats)) {
    // 				if (!d.fieldsMap[sourceKey]) d.fieldsMap[sourceKey] = { fieldId: sourceKey, type: 'TEXT' }
    // 			}
    // 		})
    // 	} else setConfig(d => { d.fieldsMap = {} })
    // }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: rows.map(([source, field])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "IMLink",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "IMSource",
                        children: !!source?.stats ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
                                    className: "float-right",
                                    children: [
                                        !!source.stats?.types && Object.entries(source.stats.types).map(([type, count])=>`${type}(${count})`).join(","),
                                        " ",
                                        source.stats.count - source.stats.nulls,
                                        "/",
                                        source.stats.count - source.stats.empty,
                                        "/",
                                        source.stats.count - source.stats.duplicates
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: source.key
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnStatsDefault.default), {
                                    stats: source.stats
                                })
                            ]
                        }) : !!source?.key ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                            children: source.key
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                            children: "-"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "IMDestination",
                        children: [
                            !collection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "checkbox",
                                        checked: !!field,
                                        disabled: !source?.stats,
                                        onChange: ()=>toggleSource(source.key)
                                    }),
                                    !!field && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "text",
                                                defaultValue: field?.fieldId,
                                                onBlur: (e)=>updateField(source.key, {
                                                        fieldId: e.target.value
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("select", {
                                                value: field?.type,
                                                onChange: (e)=>updateField(source.key, {
                                                        type: e.target.value
                                                    }),
                                                children: (0, _fields.FIELD_TYPES).map((type)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                                        value: type,
                                                        children: type
                                                    }, type))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !!collection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                                    value: field?.fieldId || "",
                                    onChange: (e)=>handleUpdate(source.key, e.target.value),
                                    disabled: !source?.key,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                            value: ""
                                        }),
                                        collection?.fields?.map((f)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                                                value: f.fieldId,
                                                children: [
                                                    f.fieldId,
                                                    " [",
                                                    f.type,
                                                    "]"
                                                ]
                                            }, f.fieldId))
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }, `${source?.key || `${source}`}-${field?.fieldId || "_field"}`))
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","immer":"eUR2H","../utils/ColumnStats":"hhys5","../utils/Notifications":"hTdby","../../common/fields/fields":"eJZRF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hhys5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ColumnStats);
var _jsxRuntime = require("react/jsx-runtime");
function ColumnStats({ stats }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "ColumnStats",
        children: [
            "count:",
            stats.count,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "duplicates:",
            stats.duplicates,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "empty:",
            stats.empty,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "nulls:",
            stats.nulls,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "min length: ",
            stats.lengths.min,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "max length: ",
            stats.lengths.max,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "avg length: ",
            stats.lengths.avg,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            "Types:",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                children: Object.entries(stats.types).map(([type, count])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                        children: [
                            type,
                            ":",
                            count
                        ]
                    }, type))
            }),
            "Sample:",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                children: stats.distinct.map((value, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: value
                    }, idx))
            })
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hTdby":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Note", ()=>Note);
var _jsxRuntime = require("react/jsx-runtime");
function Note({ small = false, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
        className: small ? "small" : "",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                children: "Note:"
            }),
            " ",
            children
        ]
    });
}

},{"react/jsx-runtime":"gaGEj","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fKlEq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ImportMapExisting);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _immer = require("immer");
var _columnStats = require("../utils/ColumnStats");
var _columnStatsDefault = parcelHelpers.interopDefault(_columnStats);
var _notifications = require("../utils/Notifications");
var _fields = require("../../common/fields/fields");
function ImportMapExisting({ collection, fieldsMap, setFieldsMap, sourceFields }) {
    // const sourceFields = useMemo(() => {
    // 	if (!stats) return []
    // 	return Object.keys(stats)
    // }, [stats])
    const rows = (0, _react.useMemo)(()=>{
        const rows = [];
        if (!!sourceFields) for (const sourceKey of Object.keys(sourceFields)){
            const row = rows.find(([sKey])=>sKey === sourceKey);
            if (!row) rows.push([
                sourceKey,
                null
            ]);
        }
        if (!!fieldsMap) for (let [sourceKey, field] of Object.entries(fieldsMap)){
            const rowWithSource = rows.find(([sKey])=>sourceKey === sKey);
            if (!!rowWithSource) rowWithSource[1] = field;
        }
        if (!!collection?.fields) for (let field of collection.fields){
            const row = rows.find(([sKey, f])=>field.fieldId === f?.fieldId);
            if (!row) rows.push([
                null,
                field
            ]);
        }
        // else row[1] = field
        // 		const rowWithField = rows.find(([_, f]) => field?.fieldId === f?.fieldId)
        // if (!rowWithField && !rowWithSource) {
        // 			rows.push([{ key: sourceKey }, field])
        // 		} else if (!!rowWithSource) {
        // 			rowWithSource[1] = !!rowWithField ? rowWithField[1] : field
        // 		}
        // 		// if (!!rowWithField) {
        // 		// 	rowWithField[0] = sourceKey
        // 		// }
        // 		//  else if (!rowWithSource) {
        // 	// 		rows.push([sourceKey, field])
        // 	// 	}
        // }
        // }
        // if (!!collection?.fields) {
        // 	for (let field of collection.fields) {
        // 		const row = rows.find(([sKey, f]) => field.fieldId === f?.fieldId)
        // 		if (!row) rows.push([null, field])
        // 			else row[1] = field
        // 	}
        // }
        return rows.map(([sourceKey, field])=>{
            return [
                !!sourceKey && !!sourceFields?.[sourceKey] ? {
                    key: sourceKey,
                    stats: sourceFields[sourceKey]
                } : sourceKey,
                field
            ];
        });
    }, [
        collection,
        fieldsMap,
        sourceFields
    ]);
    // console.log(rows)
    function handleUpdate(sourceKey, fieldId) {
        // console.log(sourceKey, fieldId)
        setFieldsMap((0, _immer.produce)(fieldsMap, (draft)=>{
            if (!fieldId) delete draft[sourceKey];
            else draft[sourceKey] = {
                fieldId
            };
        }));
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: rows.map(([source, field])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "IMLink",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "IMSource",
                        children: !!source?.stats ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("code", {
                                    className: "float-right",
                                    children: [
                                        source.stats?.count,
                                        "/",
                                        source.stats?.duplicates,
                                        "/",
                                        source.stats?.empty
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: source.key
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _columnStatsDefault.default), {
                                    stats: source.stats
                                })
                            ]
                        }) : !!source?.key ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                            children: source.key
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                            children: "-"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "IMDestination",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                            value: field?.fieldId || "",
                            onChange: (e)=>handleUpdate(source.key, e.target.value),
                            disabled: !source?.key,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: ""
                                }),
                                collection?.fields?.map((f)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("option", {
                                        value: f.fieldId,
                                        children: [
                                            f.fieldId,
                                            " [",
                                            f.type,
                                            "]"
                                        ]
                                    }, f.fieldId))
                            ]
                        })
                    })
                ]
            }, `${source?.key || `${source}`}-${field?.fieldId || "_field"}`))
    });
}

},{"react/jsx-runtime":"gaGEj","react":"6uln9","immer":"eUR2H","../utils/ColumnStats":"hhys5","../utils/Notifications":"hTdby","../../common/fields/fields":"eJZRF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gTAYQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
class ErrorBoundary extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error(error);
        console.log(errorInfo);
    }
    render() {
        return !!this.state.error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
            error: this.state.error
        }) : this.props.children;
    }
}
exports.default = ErrorBoundary;

},{"react/jsx-runtime":"gaGEj","react":"6uln9","./Alert":"5W3pt","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["jKDqp"], "jKDqp", "parcelRequire452c")

//# sourceMappingURL=index.7ccfcf4a.js.map
